angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods that can be use to retrieve position of DOM elements.
 * It is meant to be used where we need to absolute-position DOM elements in
 * relation to other, existing elements (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
  .factory('$position', ['$document', '$window', function ($document, $window) {

    function getStyle(el, cssprop) {
      if (el.currentStyle) { //IE
        return el.currentStyle[cssprop];
      } else if ($window.getComputedStyle) {
        return $window.getComputedStyle(el)[cssprop];
      }
      // finally try and get inline style
      return el.style[cssprop];
    }

    /**
     * Checks if a given element is statically positioned
     * @param element - raw DOM element
     */
    function isStaticPositioned(element) {
      return (getStyle(element, 'position') || 'static' ) === 'static';
    }

    /**
     * returns the closest, non-statically positioned parentOffset of a given element
     * @param element
     */
    var parentOffsetEl = function (element) {
      var docDomEl = $document[0];
      var offsetParent = element.offsetParent || docDomEl;
      while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent) ) {
        offsetParent = offsetParent.offsetParent;
      }
      return offsetParent || docDomEl;
    };

    return {
      /**
       * Provides read-only equivalent of jQuery's position function:
       * http://api.jquery.com/position/
       */
      position: function (element) {
        var elBCR = this.offset(element);
        var offsetParentBCR = { top: 0, left: 0 };
        var offsetParentEl = parentOffsetEl(element[0]);
        if (offsetParentEl != $document[0]) {
          offsetParentBCR = this.offset(angular.element(offsetParentEl));
          offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
          offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
        }

        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width: boundingClientRect.width || element.prop('offsetWidth'),
          height: boundingClientRect.height || element.prop('offsetHeight'),
          top: elBCR.top - offsetParentBCR.top,
          left: elBCR.left - offsetParentBCR.left
        };
      },

      /**
       * Provides read-only equivalent of jQuery's offset function:
       * http://api.jquery.com/offset/
       */
      offset: function (element) {
        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width: boundingClientRect.width || element.prop('offsetWidth'),
          height: boundingClientRect.height || element.prop('offsetHeight'),
          top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
          left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
        };
      },

      /**
       * Provides coordinates for the targetEl in relation to hostEl
       */
      positionElements: function (hostEl, targetEl, positionStr, appendToBody) {

        var positionStrParts = positionStr.split('-');
        var pos0 = positionStrParts[0], pos1 = positionStrParts[1] || 'center';

        var hostElPos,
          targetElWidth,
          targetElHeight,
          targetElPos;

        hostElPos = appendToBody ? this.offset(hostEl) : this.position(hostEl);

        targetElWidth = targetEl.prop('offsetWidth');
        targetElHeight = targetEl.prop('offsetHeight');

        var shiftWidth = {
          center: function () {
            return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
          },
          left: function () {
            return hostElPos.left;
          },
          right: function () {
            return hostElPos.left + hostElPos.width;
          }
        };

        var shiftHeight = {
          center: function () {
            return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
          },
          top: function () {
            return hostElPos.top;
          },
          bottom: function () {
            return hostElPos.top + hostElPos.height;
          }
        };

        switch (pos0) {
          case 'right':
            targetElPos = {
              top: shiftHeight[pos1](),
              left: shiftWidth[pos0]()
            };
            break;
          case 'left':
            targetElPos = {
              top: shiftHeight[pos1](),
              left: hostElPos.left - targetElWidth
            };
            break;
          case 'bottom':
            targetElPos = {
              top: shiftHeight[pos0](),
              left: shiftWidth[pos1]()
            };
            break;
          default:
            targetElPos = {
              top: hostElPos.top - targetElHeight,
              left: shiftWidth[pos1]()
            };
            break;
        }

        return targetElPos;
      }
    };
  }]);
;
/*
 * angular-elastic v2.5.1
 * (c) 2014 Monospaced http://monospaced.com
 * License: MIT
 */

if (typeof module !== 'undefined' &&
    typeof exports !== 'undefined' &&
    module.exports === exports){
  module.exports = 'monospaced.elastic';
}

angular.module('monospaced.elastic', [])

  .constant('msdElasticConfig', {
    append: ''
  })

  .directive('msdElastic', [
    '$timeout', '$window', 'msdElasticConfig',
    function($timeout, $window, config) {
      'use strict';

      return {
        require: 'ngModel',
        restrict: 'A, C',
        link: function(scope, element, attrs, ngModel) {

          // cache a reference to the DOM element
          var ta = element[0],
              $ta = element;

          // ensure the element is a textarea, and browser is capable
          if (ta.nodeName !== 'TEXTAREA' || !$window.getComputedStyle) {
            return;
          }

          // set these properties before measuring dimensions
          $ta.css({
            'overflow': 'hidden',
            'overflow-y': 'hidden',
            'word-wrap': 'break-word'
          });

          // force text reflow
          var text = ta.value;
          ta.value = '';
          ta.value = text;

          var append = attrs.msdElastic ? attrs.msdElastic.replace(/\\n/g, '\n') : config.append,
              $win = angular.element($window),
              mirrorInitStyle = 'position: absolute; top: -999px; right: auto; bottom: auto;' +
                                'left: 0; overflow: hidden; -webkit-box-sizing: content-box;' +
                                '-moz-box-sizing: content-box; box-sizing: content-box;' +
                                'min-height: 0 !important; height: 0 !important; padding: 0;' +
                                'word-wrap: break-word; border: 0;',
              $mirror = angular.element('<textarea aria-hidden="true" tabindex="-1" ' +
                                        'style="' + mirrorInitStyle + '"/>').data('elastic', true),
              mirror = $mirror[0],
              taStyle = getComputedStyle(ta),
              resize = taStyle.getPropertyValue('resize'),
              borderBox = taStyle.getPropertyValue('box-sizing') === 'border-box' ||
                          taStyle.getPropertyValue('-moz-box-sizing') === 'border-box' ||
                          taStyle.getPropertyValue('-webkit-box-sizing') === 'border-box',
              boxOuter = !borderBox ? {width: 0, height: 0} : {
                            width:  parseInt(taStyle.getPropertyValue('border-right-width'), 10) +
                                    parseInt(taStyle.getPropertyValue('padding-right'), 10) +
                                    parseInt(taStyle.getPropertyValue('padding-left'), 10) +
                                    parseInt(taStyle.getPropertyValue('border-left-width'), 10),
                            height: parseInt(taStyle.getPropertyValue('border-top-width'), 10) +
                                    parseInt(taStyle.getPropertyValue('padding-top'), 10) +
                                    parseInt(taStyle.getPropertyValue('padding-bottom'), 10) +
                                    parseInt(taStyle.getPropertyValue('border-bottom-width'), 10)
                          },
              minHeightValue = parseInt(taStyle.getPropertyValue('min-height'), 10),
              heightValue = parseInt(taStyle.getPropertyValue('height'), 10),
              minHeight = Math.max(minHeightValue, heightValue) - boxOuter.height,
              maxHeight = parseInt(taStyle.getPropertyValue('max-height'), 10),
              mirrored,
              active,
              copyStyle = ['font-family',
                           'font-size',
                           'font-weight',
                           'font-style',
                           'letter-spacing',
                           'line-height',
                           'text-transform',
                           'word-spacing',
                           'text-indent'];

          // exit if elastic already applied (or is the mirror element)
          if ($ta.data('elastic')) {
            return;
          }

          // Opera returns max-height of -1 if not set
          maxHeight = maxHeight && maxHeight > 0 ? maxHeight : 9e4;

          // append mirror to the DOM
          if (mirror.parentNode !== document.body) {
            angular.element(document.body).append(mirror);
          }

          // set resize and apply elastic
          $ta.css({
            'resize': (resize === 'none' || resize === 'vertical') ? 'none' : 'horizontal'
          }).data('elastic', true);

          /*
           * methods
           */

          function initMirror() {
            var mirrorStyle = mirrorInitStyle;

            mirrored = ta;
            // copy the essential styles from the textarea to the mirror
            taStyle = getComputedStyle(ta);
            angular.forEach(copyStyle, function(val) {
              mirrorStyle += val + ':' + taStyle.getPropertyValue(val) + ';';
            });
            mirror.setAttribute('style', mirrorStyle);
          }

          function adjust() {
            var taHeight,
                taComputedStyleWidth,
                mirrorHeight,
                width,
                overflow;

            if (mirrored !== ta) {
              initMirror();
            }

            // active flag prevents actions in function from calling adjust again
            if (!active) {
              active = true;

              mirror.value = ta.value + append; // optional whitespace to improve animation
              mirror.style.overflowY = ta.style.overflowY;

              taHeight = ta.style.height === '' ? 'auto' : parseInt(ta.style.height, 10);

              taComputedStyleWidth = getComputedStyle(ta).getPropertyValue('width');

              // ensure getComputedStyle has returned a readable 'used value' pixel width
              if (taComputedStyleWidth.substr(taComputedStyleWidth.length - 2, 2) === 'px') {
                // update mirror width in case the textarea width has changed
                width = parseInt(taComputedStyleWidth, 10) - boxOuter.width;
                mirror.style.width = width + 'px';
              }

              mirrorHeight = mirror.scrollHeight;

              if (mirrorHeight > maxHeight) {
                mirrorHeight = maxHeight;
                overflow = 'scroll';
              } else if (mirrorHeight < minHeight) {
                mirrorHeight = minHeight;
              }
              mirrorHeight += boxOuter.height;
              ta.style.overflowY = overflow || 'hidden';

              if (taHeight !== mirrorHeight) {
                scope.$emit('elastic:resize', $ta, taHeight, mirrorHeight);
                ta.style.height = mirrorHeight + 'px';
              }

              // small delay to prevent an infinite loop
              $timeout(function() {
                active = false;
              }, 1, false);

            }
          }

          function forceAdjust() {
            active = false;
            adjust();
          }

          /*
           * initialise
           */

          // listen
          if ('onpropertychange' in ta && 'oninput' in ta) {
            // IE9
            ta['oninput'] = ta.onkeyup = adjust;
          } else {
            ta['oninput'] = adjust;
          }

          $win.bind('resize', forceAdjust);

          scope.$watch(function() {
            return ngModel.$modelValue;
          }, function(newValue) {
            forceAdjust();
          });

          scope.$on('elastic:adjust', function() {
            initMirror();
            forceAdjust();
          });

          $timeout(adjust, 0, false);

          /*
           * destroy
           */

          scope.$on('$destroy', function() {
            $mirror.remove();
            $win.unbind('resize', forceAdjust);
          });
        }
      };
    }
  ]);
;
angular.module('ui.bootstrap.bindHtml', [])

  .directive('bindHtmlUnsafe', function () {
    return function (scope, element, attr) {
      element.addClass('ng-binding').data('$binding', attr.bindHtmlUnsafe);
      scope.$watch(attr.bindHtmlUnsafe, function bindHtmlUnsafeWatchAction(value) {
        element.html(value || '');
      });
    };
  });;
!function(e){"undefined"!=typeof exports?e(exports):(window.hljs=e({}),"function"==typeof define&&define.amd&&define([],function(){return window.hljs}))}(function(e){function t(e){return e.replace(/&/gm,"&amp;").replace(/</gm,"&lt;").replace(/>/gm,"&gt;")}function r(e){return e.nodeName.toLowerCase()}function a(e,t){var r=e&&e.exec(t);return r&&0==r.index}function i(e){var t=(e.className+" "+(e.parentNode?e.parentNode.className:"")).split(/\s+/);return t=t.map(function(e){return e.replace(/^lang(uage)?-/,"")}),t.filter(function(e){return _(e)||/no(-?)highlight|plain|text/.test(e)})[0]}function n(e,t){var r,a={};for(r in e)a[r]=e[r];if(t)for(r in t)a[r]=t[r];return a}function o(e){var t=[];return function a(e,i){for(var n=e.firstChild;n;n=n.nextSibling)3==n.nodeType?i+=n.nodeValue.length:1==n.nodeType&&(t.push({event:"start",offset:i,node:n}),i=a(n,i),r(n).match(/br|hr|img|input/)||t.push({event:"stop",offset:i,node:n}));return i}(e,0),t}function s(e,a,i){function n(){return e.length&&a.length?e[0].offset!=a[0].offset?e[0].offset<a[0].offset?e:a:"start"==a[0].event?e:a:e.length?e:a}function o(e){function a(e){return" "+e.nodeName+'="'+t(e.value)+'"'}d+="<"+r(e)+Array.prototype.map.call(e.attributes,a).join("")+">"}function s(e){d+="</"+r(e)+">"}function l(e){("start"==e.event?o:s)(e.node)}for(var c=0,d="",p=[];e.length||a.length;){var u=n();if(d+=t(i.substr(c,u[0].offset-c)),c=u[0].offset,u==e){p.reverse().forEach(s);do l(u.splice(0,1)[0]),u=n();while(u==e&&u.length&&u[0].offset==c);p.reverse().forEach(o)}else"start"==u[0].event?p.push(u[0].node):p.pop(),l(u.splice(0,1)[0])}return d+t(i.substr(c))}function l(e){function t(e){return e&&e.source||e}function r(r,a){return new RegExp(t(r),"m"+(e.cI?"i":"")+(a?"g":""))}function a(i,o){if(!i.compiled){if(i.compiled=!0,i.k=i.k||i.bK,i.k){var s={},l=function(t,r){e.cI&&(r=r.toLowerCase()),r.split(" ").forEach(function(e){var r=e.split("|");s[r[0]]=[t,r[1]?Number(r[1]):1]})};"string"==typeof i.k?l("keyword",i.k):Object.keys(i.k).forEach(function(e){l(e,i.k[e])}),i.k=s}i.lR=r(i.l||/\b\w+\b/,!0),o&&(i.bK&&(i.b="\\b("+i.bK.split(" ").join("|")+")\\b"),i.b||(i.b=/\B|\b/),i.bR=r(i.b),i.e||i.eW||(i.e=/\B|\b/),i.e&&(i.eR=r(i.e)),i.tE=t(i.e)||"",i.eW&&o.tE&&(i.tE+=(i.e?"|":"")+o.tE)),i.i&&(i.iR=r(i.i)),void 0===i.r&&(i.r=1),i.c||(i.c=[]);var c=[];i.c.forEach(function(e){e.v?e.v.forEach(function(t){c.push(n(e,t))}):c.push("self"==e?i:e)}),i.c=c,i.c.forEach(function(e){a(e,i)}),i.starts&&a(i.starts,o);var d=i.c.map(function(e){return e.bK?"\\.?("+e.b+")\\.?":e.b}).concat([i.tE,i.i]).map(t).filter(Boolean);i.t=d.length?r(d.join("|"),!0):{exec:function(){return null}}}}a(e)}function c(e,r,i,n){function o(e,t){for(var r=0;r<t.c.length;r++)if(a(t.c[r].bR,e))return t.c[r]}function s(e,t){if(a(e.eR,t)){for(;e.endsParent&&e.parent;)e=e.parent;return e}return e.eW?s(e.parent,t):void 0}function p(e,t){return!i&&a(t.iR,e)}function u(e,t){var r=C.cI?t[0].toLowerCase():t[0];return e.k.hasOwnProperty(r)&&e.k[r]}function m(e,t,r,a){var i=a?"":y.classPrefix,n='<span class="'+i,o=r?"":"</span>";return n+=e+'">',n+t+o}function b(){if(!w.k)return t(D);var e="",r=0;w.lR.lastIndex=0;for(var a=w.lR.exec(D);a;){e+=t(D.substr(r,a.index-r));var i=u(w,a);i?(M+=i[1],e+=m(i[0],t(a[0]))):e+=t(a[0]),r=w.lR.lastIndex,a=w.lR.exec(D)}return e+t(D.substr(r))}function g(){if(w.sL&&!x[w.sL])return t(D);var e=w.sL?c(w.sL,D,!0,N[w.sL]):d(D);return w.r>0&&(M+=e.r),"continuous"==w.subLanguageMode&&(N[w.sL]=e.top),m(e.language,e.value,!1,!0)}function f(){return void 0!==w.sL?g():b()}function h(e,r){var a=e.cN?m(e.cN,"",!0):"";e.rB?(k+=a,D=""):e.eB?(k+=t(r)+a,D=""):(k+=a,D=r),w=Object.create(e,{parent:{value:w}})}function v(e,r){if(D+=e,void 0===r)return k+=f(),0;var a=o(r,w);if(a)return k+=f(),h(a,r),a.rB?0:r.length;var i=s(w,r);if(i){var n=w;n.rE||n.eE||(D+=r),k+=f();do w.cN&&(k+="</span>"),M+=w.r,w=w.parent;while(w!=i.parent);return n.eE&&(k+=t(r)),D="",i.starts&&h(i.starts,""),n.rE?0:r.length}if(p(r,w))throw new Error('Illegal lexeme "'+r+'" for mode "'+(w.cN||"<unnamed>")+'"');return D+=r,r.length||1}var C=_(e);if(!C)throw new Error('Unknown language: "'+e+'"');l(C);var S,w=n||C,N={},k="";for(S=w;S!=C;S=S.parent)S.cN&&(k=m(S.cN,"",!0)+k);var D="",M=0;try{for(var T,E,A=0;;){if(w.t.lastIndex=A,T=w.t.exec(r),!T)break;E=v(r.substr(A,T.index-A),T[0]),A=T.index+E}for(v(r.substr(A)),S=w;S.parent;S=S.parent)S.cN&&(k+="</span>");return{r:M,value:k,language:e,top:w}}catch(L){if(-1!=L.message.indexOf("Illegal"))return{r:0,value:t(r)};throw L}}function d(e,r){r=r||y.languages||Object.keys(x);var a={r:0,value:t(e)},i=a;return r.forEach(function(t){if(_(t)){var r=c(t,e,!1);r.language=t,r.r>i.r&&(i=r),r.r>a.r&&(i=a,a=r)}}),i.language&&(a.second_best=i),a}function p(e){return y.tabReplace&&(e=e.replace(/^((<[^>]+>|\t)+)/gm,function(e,t){return t.replace(/\t/g,y.tabReplace)})),y.useBR&&(e=e.replace(/\n/g,"<br>")),e}function u(e,t,r){var a=t?C[t]:r,i=[e.trim()];return e.match(/\bhljs\b/)||i.push("hljs"),-1===e.indexOf(a)&&i.push(a),i.join(" ").trim()}function m(e){var t=i(e);if(!/no(-?)highlight|plain|text/.test(t)){var r;y.useBR?(r=document.createElementNS("http://www.w3.org/1999/xhtml","div"),r.innerHTML=e.innerHTML.replace(/\n/g,"").replace(/<br[ \/]*>/g,"\n")):r=e;var a=r.textContent,n=t?c(t,a,!0):d(a),l=o(r);if(l.length){var m=document.createElementNS("http://www.w3.org/1999/xhtml","div");m.innerHTML=n.value,n.value=s(l,o(m),a)}n.value=p(n.value),e.innerHTML=n.value,e.className=u(e.className,t,n.language),e.result={language:n.language,re:n.r},n.second_best&&(e.second_best={language:n.second_best.language,re:n.second_best.r})}}function b(e){y=n(y,e)}function g(){if(!g.called){g.called=!0;var e=document.querySelectorAll("pre code");Array.prototype.forEach.call(e,m)}}function f(){addEventListener("DOMContentLoaded",g,!1),addEventListener("load",g,!1)}function h(t,r){var a=x[t]=r(e);a.aliases&&a.aliases.forEach(function(e){C[e]=t})}function v(){return Object.keys(x)}function _(e){return x[e]||x[C[e]]}var y={classPrefix:"hljs-",tabReplace:null,useBR:!1,languages:void 0},x={},C={};return e.highlight=c,e.highlightAuto=d,e.fixMarkup=p,e.highlightBlock=m,e.configure=b,e.initHighlighting=g,e.initHighlightingOnLoad=f,e.registerLanguage=h,e.listLanguages=v,e.getLanguage=_,e.inherit=n,e.IR="[a-zA-Z]\\w*",e.UIR="[a-zA-Z_]\\w*",e.NR="\\b\\d+(\\.\\d+)?",e.CNR="\\b(0[xX][a-fA-F0-9]+|(\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)",e.BNR="\\b(0b[01]+)",e.RSR="!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~",e.BE={b:"\\\\[\\s\\S]",r:0},e.ASM={cN:"string",b:"'",e:"'",i:"\\n",c:[e.BE]},e.QSM={cN:"string",b:'"',e:'"',i:"\\n",c:[e.BE]},e.PWM={b:/\b(a|an|the|are|I|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such)\b/},e.C=function(t,r,a){var i=e.inherit({cN:"comment",b:t,e:r,c:[]},a||{});return i.c.push(e.PWM),i},e.CLCM=e.C("//","$"),e.CBCM=e.C("/\\*","\\*/"),e.HCM=e.C("#","$"),e.NM={cN:"number",b:e.NR,r:0},e.CNM={cN:"number",b:e.CNR,r:0},e.BNM={cN:"number",b:e.BNR,r:0},e.CSSNM={cN:"number",b:e.NR+"(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",r:0},e.RM={cN:"regexp",b:/\//,e:/\/[gimuy]*/,i:/\n/,c:[e.BE,{b:/\[/,e:/\]/,r:0,c:[e.BE]}]},e.TM={cN:"title",b:e.IR,r:0},e.UTM={cN:"title",b:e.UIR,r:0},e}),hljs.registerLanguage("1c",function(e){var t="[a-zA-Zа-яА-Я][a-zA-Z0-9_а-яА-Я]*",r="возврат дата для если и или иначе иначеесли исключение конецесли конецпопытки конецпроцедуры конецфункции конеццикла константа не перейти перем перечисление по пока попытка прервать продолжить процедура строка тогда фс функция цикл число экспорт",a="ansitooem oemtoansi ввестивидсубконто ввестидату ввестизначение ввестиперечисление ввестипериод ввестиплансчетов ввестистроку ввестичисло вопрос восстановитьзначение врег выбранныйплансчетов вызватьисключение датагод датамесяц датачисло добавитьмесяц завершитьработусистемы заголовоксистемы записьжурналарегистрации запуститьприложение зафиксироватьтранзакцию значениевстроку значениевстрокувнутр значениевфайл значениеизстроки значениеизстрокивнутр значениеизфайла имякомпьютера имяпользователя каталогвременныхфайлов каталогиб каталогпользователя каталогпрограммы кодсимв командасистемы конгода конецпериодаби конецрассчитанногопериодаби конецстандартногоинтервала конквартала конмесяца коннедели лев лог лог10 макс максимальноеколичествосубконто мин монопольныйрежим названиеинтерфейса названиенабораправ назначитьвид назначитьсчет найти найтипомеченныенаудаление найтиссылки началопериодаби началостандартногоинтервала начатьтранзакцию начгода начквартала начмесяца начнедели номерднягода номерднянедели номернеделигода нрег обработкаожидания окр описаниеошибки основнойжурналрасчетов основнойплансчетов основнойязык открытьформу открытьформумодально отменитьтранзакцию очиститьокносообщений периодстр полноеимяпользователя получитьвремята получитьдатута получитьдокументта получитьзначенияотбора получитьпозициюта получитьпустоезначение получитьта прав праводоступа предупреждение префиксавтонумерации пустаястрока пустоезначение рабочаядаттьпустоезначение рабочаядата разделительстраниц разделительстрок разм разобратьпозициюдокумента рассчитатьрегистрына рассчитатьрегистрыпо сигнал симв символтабуляции создатьобъект сокрл сокрлп сокрп сообщить состояние сохранитьзначение сред статусвозврата стрдлина стрзаменить стрколичествострок стрполучитьстроку  стрчисловхождений сформироватьпозициюдокумента счетпокоду текущаядата текущеевремя типзначения типзначениястр удалитьобъекты установитьтана установитьтапо фиксшаблон формат цел шаблон",i={cN:"dquote",b:'""'},n={cN:"string",b:'"',e:'"|$',c:[i]},o={cN:"string",b:"\\|",e:'"|$',c:[i]};return{cI:!0,l:t,k:{keyword:r,built_in:a},c:[e.CLCM,e.NM,n,o,{cN:"function",b:"(процедура|функция)",e:"$",l:t,k:"процедура функция",c:[e.inherit(e.TM,{b:t}),{cN:"tail",eW:!0,c:[{cN:"params",b:"\\(",e:"\\)",l:t,k:"знач",c:[n,o]},{cN:"export",b:"экспорт",eW:!0,l:t,k:"экспорт",c:[e.CLCM]}]},e.CLCM]},{cN:"preprocessor",b:"#",e:"$"},{cN:"date",b:"'\\d{2}\\.\\d{2}\\.(\\d{2}|\\d{4})'"}]}}),hljs.registerLanguage("actionscript",function(e){var t="[a-zA-Z_$][a-zA-Z0-9_$]*",r="([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)",a={cN:"rest_arg",b:"[.]{3}",e:t,r:10};return{aliases:["as"],k:{keyword:"as break case catch class const continue default delete do dynamic each else extends final finally for function get if implements import in include instanceof interface internal is namespace native new override package private protected public return set static super switch this throw try typeof use var void while with",literal:"true false null undefined"},c:[e.ASM,e.QSM,e.CLCM,e.CBCM,e.CNM,{cN:"package",bK:"package",e:"{",c:[e.TM]},{cN:"class",bK:"class interface",e:"{",eE:!0,c:[{bK:"extends implements"},e.TM]},{cN:"preprocessor",bK:"import include",e:";"},{cN:"function",bK:"function",e:"[{;]",eE:!0,i:"\\S",c:[e.TM,{cN:"params",b:"\\(",e:"\\)",c:[e.ASM,e.QSM,e.CLCM,e.CBCM,a]},{cN:"type",b:":",e:r,r:10}]}]}}),hljs.registerLanguage("apache",function(e){var t={cN:"number",b:"[\\$%]\\d+"};return{aliases:["apacheconf"],cI:!0,c:[e.HCM,{cN:"tag",b:"</?",e:">"},{cN:"keyword",b:/\w+/,r:0,k:{common:"order deny allow setenv rewriterule rewriteengine rewritecond documentroot sethandler errordocument loadmodule options header listen serverroot servername"},starts:{e:/$/,r:0,k:{literal:"on off all"},c:[{cN:"sqbracket",b:"\\s\\[",e:"\\]$"},{cN:"cbracket",b:"[\\$%]\\{",e:"\\}",c:["self",t]},t,e.QSM]}}],i:/\S/}}),hljs.registerLanguage("applescript",function(e){var t=e.inherit(e.QSM,{i:""}),r={cN:"params",b:"\\(",e:"\\)",c:["self",e.CNM,t]},a=e.C("--","$"),i=e.C("\\(\\*","\\*\\)",{c:["self",a]}),n=[a,i,e.HCM];return{aliases:["osascript"],k:{keyword:"about above after against and around as at back before beginning behind below beneath beside between but by considering contain contains continue copy div does eighth else end equal equals error every exit fifth first for fourth from front get given global if ignoring in into is it its last local me middle mod my ninth not of on onto or over prop property put ref reference repeat returning script second set seventh since sixth some tell tenth that the|0 then third through thru timeout times to transaction try until where while whose with without",constant:"AppleScript false linefeed return pi quote result space tab true",type:"alias application boolean class constant date file integer list number real record string text",command:"activate beep count delay launch log offset read round run say summarize write",property:"character characters contents day frontmost id item length month name paragraph paragraphs rest reverse running time version weekday word words year"},c:[t,e.CNM,{cN:"type",b:"\\bPOSIX file\\b"},{cN:"command",b:"\\b(clipboard info|the clipboard|info for|list (disks|folder)|mount volume|path to|(close|open for) access|(get|set) eof|current date|do shell script|get volume settings|random number|set volume|system attribute|system info|time to GMT|(load|run|store) script|scripting components|ASCII (character|number)|localized string|choose (application|color|file|file name|folder|from list|remote application|URL)|display (alert|dialog))\\b|^\\s*return\\b"},{cN:"constant",b:"\\b(text item delimiters|current application|missing value)\\b"},{cN:"keyword",b:"\\b(apart from|aside from|instead of|out of|greater than|isn't|(doesn't|does not) (equal|come before|come after|contain)|(greater|less) than( or equal)?|(starts?|ends|begins?) with|contained by|comes (before|after)|a (ref|reference))\\b"},{cN:"property",b:"\\b(POSIX path|(date|time) string|quoted form)\\b"},{cN:"function_start",bK:"on",i:"[${=;\\n]",c:[e.UTM,r]}].concat(n),i:"//|->|=>"}}),hljs.registerLanguage("xml",function(e){var t="[A-Za-z0-9\\._:-]+",r={b:/<\?(php)?(?!\w)/,e:/\?>/,sL:"php",subLanguageMode:"continuous"},a={eW:!0,i:/</,r:0,c:[r,{cN:"attribute",b:t,r:0},{b:"=",r:0,c:[{cN:"value",c:[r],v:[{b:/"/,e:/"/},{b:/'/,e:/'/},{b:/[^\s\/>]+/}]}]}]};return{aliases:["html","xhtml","rss","atom","xsl","plist"],cI:!0,c:[{cN:"doctype",b:"<!DOCTYPE",e:">",r:10,c:[{b:"\\[",e:"\\]"}]},e.C("<!--","-->",{r:10}),{cN:"cdata",b:"<\\!\\[CDATA\\[",e:"\\]\\]>",r:10},{cN:"tag",b:"<style(?=\\s|>|$)",e:">",k:{title:"style"},c:[a],starts:{e:"</style>",rE:!0,sL:"css"}},{cN:"tag",b:"<script(?=\\s|>|$)",e:">",k:{title:"script"},c:[a],starts:{e:"</script>",rE:!0,sL:""}},r,{cN:"pi",b:/<\?\w+/,e:/\?>/,r:10},{cN:"tag",b:"</?",e:"/?>",c:[{cN:"title",b:/[^ \/><\n\t]+/,r:0},a]}]}}),hljs.registerLanguage("asciidoc",function(e){return{aliases:["adoc"],c:[e.C("^/{4,}\\n","\\n/{4,}$",{r:10}),e.C("^//","$",{r:0}),{cN:"title",b:"^\\.\\w.*$"},{b:"^[=\\*]{4,}\\n",e:"\\n^[=\\*]{4,}$",r:10},{cN:"header",b:"^(={1,5}) .+?( \\1)?$",r:10},{cN:"header",b:"^[^\\[\\]\\n]+?\\n[=\\-~\\^\\+]{2,}$",r:10},{cN:"attribute",b:"^:.+?:",e:"\\s",eE:!0,r:10},{cN:"attribute",b:"^\\[.+?\\]$",r:0},{cN:"blockquote",b:"^_{4,}\\n",e:"\\n_{4,}$",r:10},{cN:"code",b:"^[\\-\\.]{4,}\\n",e:"\\n[\\-\\.]{4,}$",r:10},{b:"^\\+{4,}\\n",e:"\\n\\+{4,}$",c:[{b:"<",e:">",sL:"xml",r:0}],r:10},{cN:"bullet",b:"^(\\*+|\\-+|\\.+|[^\\n]+?::)\\s+"},{cN:"label",b:"^(NOTE|TIP|IMPORTANT|WARNING|CAUTION):\\s+",r:10},{cN:"strong",b:"\\B\\*(?![\\*\\s])",e:"(\\n{2}|\\*)",c:[{b:"\\\\*\\w",r:0}]},{cN:"emphasis",b:"\\B'(?!['\\s])",e:"(\\n{2}|')",c:[{b:"\\\\'\\w",r:0}],r:0},{cN:"emphasis",b:"_(?![_\\s])",e:"(\\n{2}|_)",r:0},{cN:"smartquote",v:[{b:"``.+?''"},{b:"`.+?'"}]},{cN:"code",b:"(`.+?`|\\+.+?\\+)",r:0},{cN:"code",b:"^[ \\t]",e:"$",r:0},{cN:"horizontal_rule",b:"^'{3,}[ \\t]*$",r:10},{b:"(link:)?(http|https|ftp|file|irc|image:?):\\S+\\[.*?\\]",rB:!0,c:[{b:"(link|image:?):",r:0},{cN:"link_url",b:"\\w",e:"[^\\[]+",r:0},{cN:"link_label",b:"\\[",e:"\\]",eB:!0,eE:!0,r:0}],r:10}]}}),hljs.registerLanguage("aspectj",function(e){var t="false synchronized int abstract float private char boolean static null if const for true while long throw strictfp finally protected import native final return void enum else extends implements break transient new catch instanceof byte super volatile case assert short package default double public try this switch continue throws privileged aspectOf adviceexecution proceed cflowbelow cflow initialization preinitialization staticinitialization withincode target within execution getWithinTypeName handler thisJoinPoint thisJoinPointStaticPart thisEnclosingJoinPointStaticPart declare parents warning error soft precedence thisAspectInstance",r="get set args call";return{k:t,i:/<\//,c:[{cN:"javadoc",b:"/\\*\\*",e:"\\*/",r:0,c:[{cN:"javadoctag",b:"(^|\\s)@[A-Za-z]+"}]},e.CLCM,e.CBCM,e.ASM,e.QSM,{cN:"aspect",bK:"aspect",e:/[{;=]/,eE:!0,i:/[:;"\[\]]/,c:[{bK:"extends implements pertypewithin perthis pertarget percflowbelow percflow issingleton"},e.UTM,{b:/\([^\)]*/,e:/[)]+/,k:t+" "+r,eE:!1}]},{cN:"class",bK:"class interface",e:/[{;=]/,eE:!0,r:0,k:"class interface",i:/[:"\[\]]/,c:[{bK:"extends implements"},e.UTM]},{bK:"pointcut after before around throwing returning",e:/[)]/,eE:!1,i:/["\[\]]/,c:[{b:e.UIR+"\\s*\\(",rB:!0,c:[e.UTM]}]},{b:/[:]/,rB:!0,e:/[{;]/,r:0,eE:!1,k:t,i:/["\[\]]/,c:[{b:e.UIR+"\\s*\\(",k:t+" "+r},e.QSM]},{bK:"new throw",r:0},{cN:"function",b:/\w+ +\w+(\.)?\w+\s*\([^\)]*\)\s*((throws)[\w\s,]+)?[\{;]/,rB:!0,e:/[{;=]/,k:t,eE:!0,c:[{b:e.UIR+"\\s*\\(",rB:!0,r:0,c:[e.UTM]},{cN:"params",b:/\(/,e:/\)/,r:0,k:t,c:[e.ASM,e.QSM,e.CNM,e.CBCM]},e.CLCM,e.CBCM]},e.CNM,{cN:"annotation",b:"@[A-Za-z]+"}]}}),hljs.registerLanguage("autohotkey",function(e){var t={cN:"escape",b:"`[\\s\\S]"},r=e.C(";","$",{r:0}),a=[{cN:"built_in",b:"A_[a-zA-Z0-9]+"},{cN:"built_in",bK:"ComSpec Clipboard ClipboardAll ErrorLevel"}];return{cI:!0,k:{keyword:"Break Continue Else Gosub If Loop Return While",literal:"A true false NOT AND OR"},c:a.concat([t,e.inherit(e.QSM,{c:[t]}),r,{cN:"number",b:e.NR,r:0},{cN:"var_expand",b:"%",e:"%",i:"\\n",c:[t]},{cN:"label",c:[t],v:[{b:'^[^\\n";]+::(?!=)'},{b:'^[^\\n";]+:(?!=)',r:0}]},{b:",\\s*,",r:10}])}}),hljs.registerLanguage("avrasm",function(e){return{cI:!0,l:"\\.?"+e.IR,k:{keyword:"adc add adiw and andi asr bclr bld brbc brbs brcc brcs break breq brge brhc brhs brid brie brlo brlt brmi brne brpl brsh brtc brts brvc brvs bset bst call cbi cbr clc clh cli cln clr cls clt clv clz com cp cpc cpi cpse dec eicall eijmp elpm eor fmul fmuls fmulsu icall ijmp in inc jmp ld ldd ldi lds lpm lsl lsr mov movw mul muls mulsu neg nop or ori out pop push rcall ret reti rjmp rol ror sbc sbr sbrc sbrs sec seh sbi sbci sbic sbis sbiw sei sen ser ses set sev sez sleep spm st std sts sub subi swap tst wdr",built_in:"r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 r16 r17 r18 r19 r20 r21 r22 r23 r24 r25 r26 r27 r28 r29 r30 r31 x|0 xh xl y|0 yh yl z|0 zh zl ucsr1c udr1 ucsr1a ucsr1b ubrr1l ubrr1h ucsr0c ubrr0h tccr3c tccr3a tccr3b tcnt3h tcnt3l ocr3ah ocr3al ocr3bh ocr3bl ocr3ch ocr3cl icr3h icr3l etimsk etifr tccr1c ocr1ch ocr1cl twcr twdr twar twsr twbr osccal xmcra xmcrb eicra spmcsr spmcr portg ddrg ping portf ddrf sreg sph spl xdiv rampz eicrb eimsk gimsk gicr eifr gifr timsk tifr mcucr mcucsr tccr0 tcnt0 ocr0 assr tccr1a tccr1b tcnt1h tcnt1l ocr1ah ocr1al ocr1bh ocr1bl icr1h icr1l tccr2 tcnt2 ocr2 ocdr wdtcr sfior eearh eearl eedr eecr porta ddra pina portb ddrb pinb portc ddrc pinc portd ddrd pind spdr spsr spcr udr0 ucsr0a ucsr0b ubrr0l acsr admux adcsr adch adcl porte ddre pine pinf",preprocessor:".byte .cseg .db .def .device .dseg .dw .endmacro .equ .eseg .exit .include .list .listmac .macro .nolist .org .set"},c:[e.CBCM,e.C(";","$",{r:0}),e.CNM,e.BNM,{cN:"number",b:"\\b(\\$[a-zA-Z0-9]+|0o[0-7]+)"},e.QSM,{cN:"string",b:"'",e:"[^\\\\]'",i:"[^\\\\][^']"},{cN:"label",b:"^[A-Za-z0-9_.$]+:"},{cN:"preprocessor",b:"#",e:"$"},{cN:"localvars",b:"@[0-9]+"}]}}),hljs.registerLanguage("axapta",function(e){return{k:"false int abstract private char boolean static null if for true while long throw finally protected final return void enum else break new catch byte super case short default double public try this switch continue reverse firstfast firstonly forupdate nofetch sum avg minof maxof count order group by asc desc index hint like dispaly edit client server ttsbegin ttscommit str real date container anytype common div mod",c:[e.CLCM,e.CBCM,e.ASM,e.QSM,e.CNM,{cN:"preprocessor",b:"#",e:"$"},{cN:"class",bK:"class interface",e:"{",eE:!0,i:":",c:[{bK:"extends implements"},e.UTM]}]}}),hljs.registerLanguage("bash",function(e){var t={cN:"variable",v:[{b:/\$[\w\d#@][\w\d_]*/},{b:/\$\{(.*?)}/}]},r={cN:"string",b:/"/,e:/"/,c:[e.BE,t,{cN:"variable",b:/\$\(/,e:/\)/,c:[e.BE]}]},a={cN:"string",b:/'/,e:/'/};return{aliases:["sh","zsh"],l:/-?[a-z\.]+/,k:{keyword:"if then else elif fi for while in do done case esac function",literal:"true false",built_in:"break cd continue eval exec exit export getopts hash pwd readonly return shift test times trap umask unset alias bind builtin caller command declare echo enable help let local logout mapfile printf read readarray source type typeset ulimit unalias set shopt autoload bg bindkey bye cap chdir clone comparguments compcall compctl compdescribe compfiles compgroups compquote comptags comptry compvalues dirs disable disown echotc echoti emulate fc fg float functions getcap getln history integer jobs kill limit log noglob popd print pushd pushln rehash sched setcap setopt stat suspend ttyctl unfunction unhash unlimit unsetopt vared wait whence where which zcompile zformat zftp zle zmodload zparseopts zprof zpty zregexparse zsocket zstyle ztcp",operator:"-ne -eq -lt -gt -f -d -e -s -l -a"},c:[{cN:"shebang",b:/^#![^\n]+sh\s*$/,r:10},{cN:"function",b:/\w[\w\d_]*\s*\(\s*\)\s*\{/,rB:!0,c:[e.inherit(e.TM,{b:/\w[\w\d_]*/})],r:0},e.HCM,e.NM,r,a,t]}}),hljs.registerLanguage("brainfuck",function(e){var t={cN:"literal",b:"[\\+\\-]",r:0};return{aliases:["bf"],c:[e.C("[^\\[\\]\\.,\\+\\-<> \r\n]","[\\[\\]\\.,\\+\\-<> \r\n]",{rE:!0,r:0}),{cN:"title",b:"[\\[\\]]",r:0},{cN:"string",b:"[\\.,]",r:0},{b:/\+\+|\-\-/,rB:!0,c:[t]},t]}}),hljs.registerLanguage("capnproto",function(e){return{aliases:["capnp"],k:{keyword:"struct enum interface union group import using const annotation extends in of on as with from fixed",built_in:"Void Bool Int8 Int16 Int32 Int64 UInt8 UInt16 UInt32 UInt64 Float32 Float64 Text Data AnyPointer AnyStruct Capability List",literal:"true false"},c:[e.QSM,e.NM,e.HCM,{cN:"shebang",b:/@0x[\w\d]{16};/,i:/\n/},{cN:"number",b:/@\d+\b/},{cN:"class",bK:"struct enum",e:/\{/,i:/\n/,c:[e.inherit(e.TM,{starts:{eW:!0,eE:!0}})]},{cN:"class",bK:"interface",e:/\{/,i:/\n/,c:[e.inherit(e.TM,{starts:{eW:!0,eE:!0}})]}]}}),hljs.registerLanguage("clojure",function(e){var t={built_in:"def cond apply if-not if-let if not not= = < > <= >= == + / * - rem quot neg? pos? delay? symbol? keyword? true? false? integer? empty? coll? list? set? ifn? fn? associative? sequential? sorted? counted? reversible? number? decimal? class? distinct? isa? float? rational? reduced? ratio? odd? even? char? seq? vector? string? map? nil? contains? zero? instance? not-every? not-any? libspec? -> ->> .. . inc compare do dotimes mapcat take remove take-while drop letfn drop-last take-last drop-while while intern condp case reduced cycle split-at split-with repeat replicate iterate range merge zipmap declare line-seq sort comparator sort-by dorun doall nthnext nthrest partition eval doseq await await-for let agent atom send send-off release-pending-sends add-watch mapv filterv remove-watch agent-error restart-agent set-error-handler error-handler set-error-mode! error-mode shutdown-agents quote var fn loop recur throw try monitor-enter monitor-exit defmacro defn defn- macroexpand macroexpand-1 for dosync and or when when-not when-let comp juxt partial sequence memoize constantly complement identity assert peek pop doto proxy defstruct first rest cons defprotocol cast coll deftype defrecord last butlast sigs reify second ffirst fnext nfirst nnext defmulti defmethod meta with-meta ns in-ns create-ns import refer keys select-keys vals key val rseq name namespace promise into transient persistent! conj! assoc! dissoc! pop! disj! use class type num float double short byte boolean bigint biginteger bigdec print-method print-dup throw-if printf format load compile get-in update-in pr pr-on newline flush read slurp read-line subvec with-open memfn time re-find re-groups rand-int rand mod locking assert-valid-fdecl alias resolve ref deref refset swap! reset! set-validator! compare-and-set! alter-meta! reset-meta! commute get-validator alter ref-set ref-history-count ref-min-history ref-max-history ensure sync io! new next conj set! to-array future future-call into-array aset gen-class reduce map filter find empty hash-map hash-set sorted-map sorted-map-by sorted-set sorted-set-by vec vector seq flatten reverse assoc dissoc list disj get union difference intersection extend extend-type extend-protocol int nth delay count concat chunk chunk-buffer chunk-append chunk-first chunk-rest max min dec unchecked-inc-int unchecked-inc unchecked-dec-inc unchecked-dec unchecked-negate unchecked-add-int unchecked-add unchecked-subtract-int unchecked-subtract chunk-next chunk-cons chunked-seq? prn vary-meta lazy-seq spread list* str find-keyword keyword symbol gensym force rationalize"},r="a-zA-Z_\\-!.?+*=<>&#'",a="["+r+"]["+r+"0-9/;:]*",i="[-+]?\\d+(\\.\\d+)?",n={b:a,r:0},o={cN:"number",b:i,r:0},s=e.inherit(e.QSM,{i:null}),l=e.C(";","$",{r:0}),c={cN:"literal",b:/\b(true|false|nil)\b/},d={cN:"collection",b:"[\\[\\{]",e:"[\\]\\}]"},p={cN:"comment",b:"\\^"+a},u=e.C("\\^\\{","\\}"),m={cN:"attribute",b:"[:]"+a},b={cN:"list",b:"\\(",e:"\\)"},g={eW:!0,r:0},f={k:t,l:a,cN:"keyword",b:a,starts:g},h=[b,s,p,u,l,m,d,o,c,n];return b.c=[e.C("comment",""),f,g],g.c=h,d.c=h,{aliases:["clj"],i:/\S/,c:[b,s,p,u,l,m,d,o,c]}}),hljs.registerLanguage("clojure-repl",function(e){return{c:[{cN:"prompt",b:/^([\w.-]+|\s*#_)=>/,starts:{e:/$/,sL:"clojure",subLanguageMode:"continuous"}}]}}),hljs.registerLanguage("cmake",function(e){return{aliases:["cmake.in"],cI:!0,k:{keyword:"add_custom_command add_custom_target add_definitions add_dependencies add_executable add_library add_subdirectory add_test aux_source_directory break build_command cmake_minimum_required cmake_policy configure_file create_test_sourcelist define_property else elseif enable_language enable_testing endforeach endfunction endif endmacro endwhile execute_process export find_file find_library find_package find_path find_program fltk_wrap_ui foreach function get_cmake_property get_directory_property get_filename_component get_property get_source_file_property get_target_property get_test_property if include include_directories include_external_msproject include_regular_expression install link_directories load_cache load_command macro mark_as_advanced message option output_required_files project qt_wrap_cpp qt_wrap_ui remove_definitions return separate_arguments set set_directory_properties set_property set_source_files_properties set_target_properties set_tests_properties site_name source_group string target_link_libraries try_compile try_run unset variable_watch while build_name exec_program export_library_dependencies install_files install_programs install_targets link_libraries make_directory remove subdir_depends subdirs use_mangled_mesa utility_source variable_requires write_file qt5_use_modules qt5_use_package qt5_wrap_cpp on off true false and or",operator:"equal less greater strless strgreater strequal matches"},c:[{cN:"envvar",b:"\\${",e:"}"},e.HCM,e.QSM,e.NM]}}),hljs.registerLanguage("coffeescript",function(e){var t={keyword:"in if for while finally new do return else break catch instanceof throw try this switch continue typeof delete debugger super then unless until loop of by when and or is isnt not",literal:"true false null undefined yes no on off",reserved:"case default function var void with const let enum export import native __hasProp __extends __slice __bind __indexOf",built_in:"npm require console print module global window document"},r="[A-Za-z$_][0-9A-Za-z$_]*",a={cN:"subst",b:/#\{/,e:/}/,k:t},i=[e.BNM,e.inherit(e.CNM,{starts:{e:"(\\s*/)?",r:0}}),{cN:"string",v:[{b:/'''/,e:/'''/,c:[e.BE]},{b:/'/,e:/'/,c:[e.BE]},{b:/"""/,e:/"""/,c:[e.BE,a]},{b:/"/,e:/"/,c:[e.BE,a]}]},{cN:"regexp",v:[{b:"///",e:"///",c:[a,e.HCM]},{b:"//[gim]*",r:0},{b:/\/(?![ *])(\\\/|.)*?\/[gim]*(?=\W|$)/}]},{cN:"property",b:"@"+r},{b:"`",e:"`",eB:!0,eE:!0,sL:"javascript"}];a.c=i;var n=e.inherit(e.TM,{b:r}),o="(\\(.*\\))?\\s*\\B[-=]>",s={cN:"params",b:"\\([^\\(]",rB:!0,c:[{b:/\(/,e:/\)/,k:t,c:["self"].concat(i)}]};return{aliases:["coffee","cson","iced"],k:t,i:/\/\*/,c:i.concat([e.C("###","###"),e.HCM,{cN:"function",b:"^\\s*"+r+"\\s*=\\s*"+o,e:"[-=]>",rB:!0,c:[n,s]},{b:/[:\(,=]\s*/,r:0,c:[{cN:"function",b:o,e:"[-=]>",rB:!0,c:[s]}]},{cN:"class",bK:"class",e:"$",i:/[:="\[\]]/,c:[{bK:"extends",eW:!0,i:/[:="\[\]]/,c:[n]},n]},{cN:"attribute",b:r+":",e:":",rB:!0,rE:!0,r:0}])}}),hljs.registerLanguage("cpp",function(e){var t={keyword:"false int float while private char catch export virtual operator sizeof dynamic_cast|10 typedef const_cast|10 const struct for static_cast|10 union namespace unsigned long volatile static protected bool template mutable if public friend do goto auto void enum else break extern using true class asm case typeid short reinterpret_cast|10 default double register explicit signed typename try this switch continue wchar_t inline delete alignof char16_t char32_t constexpr decltype noexcept nullptr static_assert thread_local restrict _Bool complex _Complex _Imaginary intmax_t uintmax_t int8_t uint8_t int16_t uint16_t int32_t uint32_t  int64_t uint64_t int_least8_t uint_least8_t int_least16_t uint_least16_t int_least32_t uint_least32_t int_least64_t uint_least64_t int_fast8_t uint_fast8_t int_fast16_t uint_fast16_t int_fast32_t uint_fast32_t int_fast64_t uint_fast64_t intptr_t uintptr_t atomic_bool atomic_char atomic_schar atomic_uchar atomic_short atomic_ushort atomic_int atomic_uint atomic_long atomic_ulong atomic_llong atomic_ullong atomic_wchar_t atomic_char16_t atomic_char32_t atomic_intmax_t atomic_uintmax_t atomic_intptr_t atomic_uintptr_t atomic_size_t atomic_ptrdiff_t atomic_int_least8_t atomic_int_least16_t atomic_int_least32_t atomic_int_least64_t atomic_uint_least8_t atomic_uint_least16_t atomic_uint_least32_t atomic_uint_least64_t atomic_int_fast8_t atomic_int_fast16_t atomic_int_fast32_t atomic_int_fast64_t atomic_uint_fast8_t atomic_uint_fast16_t atomic_uint_fast32_t atomic_uint_fast64_t",built_in:"std string cin cout cerr clog stringstream istringstream ostringstream auto_ptr deque list queue stack vector map set bitset multiset multimap unordered_set unordered_map unordered_multiset unordered_multimap array shared_ptr abort abs acos asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp fscanf isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper isxdigit tolower toupper labs ldexp log10 log malloc memchr memcmp memcpy memset modf pow printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan vfprintf vprintf vsprintf"};return{aliases:["c","cc","h","c++","h++","hpp"],k:t,i:"</",c:[e.CLCM,e.CBCM,e.QSM,{cN:"string",b:"'\\\\?.",e:"'",i:"."},{cN:"number",b:"\\b(\\d+(\\.\\d*)?|\\.\\d+)(u|U|l|L|ul|UL|f|F)"},e.CNM,{cN:"preprocessor",b:"#",e:"$",k:"if else elif endif define undef warning error line pragma",c:[{b:/\\\n/,r:0},{b:'include\\s*[<"]',e:'[>"]',k:"include",i:"\\n"},e.CLCM]},{b:"\\b(deque|list|queue|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array)\\s*<",e:">",k:t,c:["self"]},{b:e.IR+"::",k:t},{bK:"new throw return else",r:0},{cN:"function",b:"("+e.IR+"\\s+)+"+e.IR+"\\s*\\(",rB:!0,e:/[{;=]/,eE:!0,k:t,c:[{b:e.IR+"\\s*\\(",rB:!0,c:[e.TM],r:0},{cN:"params",b:/\(/,e:/\)/,k:t,r:0,c:[e.CBCM]},e.CLCM,e.CBCM]}]}}),hljs.registerLanguage("cs",function(e){
var t="abstract as base bool break byte case catch char checked const continue decimal dynamic default delegate do double else enum event explicit extern false finally fixed float for foreach goto if implicit in int interface internal is lock long null when object operator out override params private protected public readonly ref sbyte sealed short sizeof stackalloc static string struct switch this true try typeof uint ulong unchecked unsafe ushort using virtual volatile void while async protected public private internal ascending descending from get group into join let orderby partial select set value var where yield",r=e.IR+"(<"+e.IR+">)?";return{aliases:["csharp"],k:t,i:/::/,c:[e.C("///","$",{rB:!0,c:[{cN:"xmlDocTag",v:[{b:"///",r:0},{b:"<!--|-->"},{b:"</?",e:">"}]}]}),e.CLCM,e.CBCM,{cN:"preprocessor",b:"#",e:"$",k:"if else elif endif define undef warning error line region endregion pragma checksum"},{cN:"string",b:'@"',e:'"',c:[{b:'""'}]},e.ASM,e.QSM,e.CNM,{bK:"class namespace interface",e:/[{;=]/,i:/[^\s:]/,c:[e.TM,e.CLCM,e.CBCM]},{bK:"new return throw await",r:0},{cN:"function",b:"("+r+"\\s+)+"+e.IR+"\\s*\\(",rB:!0,e:/[{;=]/,eE:!0,k:t,c:[{b:e.IR+"\\s*\\(",rB:!0,c:[e.TM],r:0},{cN:"params",b:/\(/,e:/\)/,k:t,r:0,c:[e.ASM,e.QSM,e.CNM,e.CBCM]},e.CLCM,e.CBCM]}]}}),hljs.registerLanguage("css",function(e){var t="[a-zA-Z-][a-zA-Z0-9_-]*",r={cN:"function",b:t+"\\(",rB:!0,eE:!0,e:"\\("},a={cN:"rule",b:/[A-Z\_\.\-]+\s*:/,rB:!0,e:";",eW:!0,c:[{cN:"attribute",b:/\S/,e:":",eE:!0,starts:{cN:"value",eW:!0,eE:!0,c:[r,e.CSSNM,e.QSM,e.ASM,e.CBCM,{cN:"hexcolor",b:"#[0-9A-Fa-f]+"},{cN:"important",b:"!important"}]}}]};return{cI:!0,i:/[=\/|']/,c:[e.CBCM,a,{cN:"id",b:/\#[A-Za-z0-9_-]+/},{cN:"class",b:/\.[A-Za-z0-9_-]+/,r:0},{cN:"attr_selector",b:/\[/,e:/\]/,i:"$"},{cN:"pseudo",b:/:(:)?[a-zA-Z0-9\_\-\+\(\)"']+/},{cN:"at_rule",b:"@(font-face|page)",l:"[a-z-]+",k:"font-face page"},{cN:"at_rule",b:"@",e:"[{;]",c:[{cN:"keyword",b:/\S+/},{b:/\s/,eW:!0,eE:!0,r:0,c:[r,e.ASM,e.QSM,e.CSSNM]}]},{cN:"tag",b:t,r:0},{cN:"rules",b:"{",e:"}",i:/\S/,r:0,c:[e.CBCM,a]}]}}),hljs.registerLanguage("d",function(e){var t={keyword:"abstract alias align asm assert auto body break byte case cast catch class const continue debug default delete deprecated do else enum export extern final finally for foreach foreach_reverse|10 goto if immutable import in inout int interface invariant is lazy macro mixin module new nothrow out override package pragma private protected public pure ref return scope shared static struct super switch synchronized template this throw try typedef typeid typeof union unittest version void volatile while with __FILE__ __LINE__ __gshared|10 __thread __traits __DATE__ __EOF__ __TIME__ __TIMESTAMP__ __VENDOR__ __VERSION__",built_in:"bool cdouble cent cfloat char creal dchar delegate double dstring float function idouble ifloat ireal long real short string ubyte ucent uint ulong ushort wchar wstring",literal:"false null true"},r="(0|[1-9][\\d_]*)",a="(0|[1-9][\\d_]*|\\d[\\d_]*|[\\d_]+?\\d)",i="0[bB][01_]+",n="([\\da-fA-F][\\da-fA-F_]*|_[\\da-fA-F][\\da-fA-F_]*)",o="0[xX]"+n,s="([eE][+-]?"+a+")",l="("+a+"(\\.\\d*|"+s+")|\\d+\\."+a+a+"|\\."+r+s+"?)",c="(0[xX]("+n+"\\."+n+"|\\.?"+n+")[pP][+-]?"+a+")",d="("+r+"|"+i+"|"+o+")",p="("+c+"|"+l+")",u="\\\\(['\"\\?\\\\abfnrtv]|u[\\dA-Fa-f]{4}|[0-7]{1,3}|x[\\dA-Fa-f]{2}|U[\\dA-Fa-f]{8})|&[a-zA-Z\\d]{2,};",m={cN:"number",b:"\\b"+d+"(L|u|U|Lu|LU|uL|UL)?",r:0},b={cN:"number",b:"\\b("+p+"([fF]|L|i|[fF]i|Li)?|"+d+"(i|[fF]i|Li))",r:0},g={cN:"string",b:"'("+u+"|.)",e:"'",i:"."},f={b:u,r:0},h={cN:"string",b:'"',c:[f],e:'"[cwd]?'},v={cN:"string",b:'[rq]"',e:'"[cwd]?',r:5},_={cN:"string",b:"`",e:"`[cwd]?"},y={cN:"string",b:'x"[\\da-fA-F\\s\\n\\r]*"[cwd]?',r:10},x={cN:"string",b:'q"\\{',e:'\\}"'},C={cN:"shebang",b:"^#!",e:"$",r:5},S={cN:"preprocessor",b:"#(line)",e:"$",r:5},w={cN:"keyword",b:"@[a-zA-Z_][a-zA-Z_\\d]*"},N=e.C("\\/\\+","\\+\\/",{c:["self"],r:10});return{l:e.UIR,k:t,c:[e.CLCM,e.CBCM,N,y,h,v,_,x,b,m,g,C,S,w]}}),hljs.registerLanguage("markdown",function(e){return{aliases:["md","mkdown","mkd"],c:[{cN:"header",v:[{b:"^#{1,6}",e:"$"},{b:"^.+?\\n[=-]{2,}$"}]},{b:"<",e:">",sL:"xml",r:0},{cN:"bullet",b:"^([*+-]|(\\d+\\.))\\s+"},{cN:"strong",b:"[*_]{2}.+?[*_]{2}"},{cN:"emphasis",v:[{b:"\\*.+?\\*"},{b:"_.+?_",r:0}]},{cN:"blockquote",b:"^>\\s+",e:"$"},{cN:"code",v:[{b:"`.+?`"},{b:"^( {4}|	)",e:"$",r:0}]},{cN:"horizontal_rule",b:"^[-\\*]{3,}",e:"$"},{b:"\\[.+?\\][\\(\\[].*?[\\)\\]]",rB:!0,c:[{cN:"link_label",b:"\\[",e:"\\]",eB:!0,rE:!0,r:0},{cN:"link_url",b:"\\]\\(",e:"\\)",eB:!0,eE:!0},{cN:"link_reference",b:"\\]\\[",e:"\\]",eB:!0,eE:!0}],r:10},{b:"^\\[.+\\]:",rB:!0,c:[{cN:"link_reference",b:"\\[",e:"\\]:",eB:!0,eE:!0,starts:{cN:"link_url",e:"$"}}]}]}}),hljs.registerLanguage("dart",function(e){var t={cN:"subst",b:"\\$\\{",e:"}",k:"true false null this is new super"},r={cN:"string",v:[{b:"r'''",e:"'''"},{b:'r"""',e:'"""'},{b:"r'",e:"'",i:"\\n"},{b:'r"',e:'"',i:"\\n"},{b:"'''",e:"'''",c:[e.BE,t]},{b:'"""',e:'"""',c:[e.BE,t]},{b:"'",e:"'",i:"\\n",c:[e.BE,t]},{b:'"',e:'"',i:"\\n",c:[e.BE,t]}]};t.c=[e.CNM,r];var a={keyword:"assert break case catch class const continue default do else enum extends false final finally for if in is new null rethrow return super switch this throw true try var void while with",literal:"abstract as dynamic export external factory get implements import library operator part set static typedef",built_in:"print Comparable DateTime Duration Function Iterable Iterator List Map Match Null Object Pattern RegExp Set Stopwatch String StringBuffer StringSink Symbol Type Uri bool double int num document window querySelector querySelectorAll Element ElementList"};return{k:a,c:[r,{cN:"dartdoc",b:"/\\*\\*",e:"\\*/",sL:"markdown",subLanguageMode:"continuous"},{cN:"dartdoc",b:"///",e:"$",sL:"markdown",subLanguageMode:"continuous"},e.CLCM,e.CBCM,{cN:"class",bK:"class interface",e:"{",eE:!0,c:[{bK:"extends implements"},e.UTM]},e.CNM,{cN:"annotation",b:"@[A-Za-z]+"},{b:"=>"}]}}),hljs.registerLanguage("delphi",function(e){var t="exports register file shl array record property for mod while set ally label uses raise not stored class safecall var interface or private static exit index inherited to else stdcall override shr asm far resourcestring finalization packed virtual out and protected library do xorwrite goto near function end div overload object unit begin string on inline repeat until destructor write message program with read initialization except default nil if case cdecl in downto threadvar of try pascal const external constructor type public then implementation finally published procedure",r=[e.CLCM,e.C(/\{/,/\}/,{r:0}),e.C(/\(\*/,/\*\)/,{r:10})],a={cN:"string",b:/'/,e:/'/,c:[{b:/''/}]},i={cN:"string",b:/(#\d+)+/},n={b:e.IR+"\\s*=\\s*class\\s*\\(",rB:!0,c:[e.TM]},o={cN:"function",bK:"function constructor destructor procedure",e:/[:;]/,k:"function constructor|10 destructor|10 procedure|10",c:[e.TM,{cN:"params",b:/\(/,e:/\)/,k:t,c:[a,i]}].concat(r)};return{cI:!0,k:t,i:/"|\$[G-Zg-z]|\/\*|<\/|\|/,c:[a,i,e.NM,n,o].concat(r)}}),hljs.registerLanguage("diff",function(e){return{aliases:["patch"],c:[{cN:"chunk",r:10,v:[{b:/^@@ +\-\d+,\d+ +\+\d+,\d+ +@@$/},{b:/^\*\*\* +\d+,\d+ +\*\*\*\*$/},{b:/^\-\-\- +\d+,\d+ +\-\-\-\-$/}]},{cN:"header",v:[{b:/Index: /,e:/$/},{b:/=====/,e:/=====$/},{b:/^\-\-\-/,e:/$/},{b:/^\*{3} /,e:/$/},{b:/^\+\+\+/,e:/$/},{b:/\*{5}/,e:/\*{5}$/}]},{cN:"addition",b:"^\\+",e:"$"},{cN:"deletion",b:"^\\-",e:"$"},{cN:"change",b:"^\\!",e:"$"}]}}),hljs.registerLanguage("django",function(e){var t={cN:"filter",b:/\|[A-Za-z]+:?/,k:"truncatewords removetags linebreaksbr yesno get_digit timesince random striptags filesizeformat escape linebreaks length_is ljust rjust cut urlize fix_ampersands title floatformat capfirst pprint divisibleby add make_list unordered_list urlencode timeuntil urlizetrunc wordcount stringformat linenumbers slice date dictsort dictsortreversed default_if_none pluralize lower join center default truncatewords_html upper length phone2numeric wordwrap time addslashes slugify first escapejs force_escape iriencode last safe safeseq truncatechars localize unlocalize localtime utc timezone",c:[{cN:"argument",b:/"/,e:/"/},{cN:"argument",b:/'/,e:/'/}]};return{aliases:["jinja"],cI:!0,sL:"xml",subLanguageMode:"continuous",c:[e.C(/\{%\s*comment\s*%}/,/\{%\s*endcomment\s*%}/),e.C(/\{#/,/#}/),{cN:"template_tag",b:/\{%/,e:/%}/,k:"comment endcomment load templatetag ifchanged endifchanged if endif firstof for endfor in ifnotequal endifnotequal widthratio extends include spaceless endspaceless regroup by as ifequal endifequal ssi now with cycle url filter endfilter debug block endblock else autoescape endautoescape csrf_token empty elif endwith static trans blocktrans endblocktrans get_static_prefix get_media_prefix plural get_current_language language get_available_languages get_current_language_bidi get_language_info get_language_info_list localize endlocalize localtime endlocaltime timezone endtimezone get_current_timezone verbatim",c:[t]},{cN:"variable",b:/\{\{/,e:/}}/,c:[t]}]}}),hljs.registerLanguage("dockerfile",function(e){return{aliases:["docker"],cI:!0,k:{built_ins:"from maintainer cmd expose add copy entrypoint volume user workdir onbuild run env"},c:[e.HCM,{k:{built_in:"run cmd entrypoint volume add copy workdir onbuild"},b:/^ *(onbuild +)?(run|cmd|entrypoint|volume|add|copy|workdir) +/,starts:{e:/[^\\]\n/,sL:"bash",subLanguageMode:"continuous"}},{k:{built_in:"from maintainer expose env user onbuild"},b:/^ *(onbuild +)?(from|maintainer|expose|env|user|onbuild) +/,e:/[^\\]\n/,c:[e.ASM,e.QSM,e.NM,e.HCM]}]}}),hljs.registerLanguage("dos",function(e){var t=e.C(/@?rem\b/,/$/,{r:10}),r={cN:"label",b:"^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)",r:0};return{aliases:["bat","cmd"],cI:!0,k:{flow:"if else goto for in do call exit not exist errorlevel defined",operator:"equ neq lss leq gtr geq",keyword:"shift cd dir echo setlocal endlocal set pause copy",stream:"prn nul lpt3 lpt2 lpt1 con com4 com3 com2 com1 aux",winutils:"ping net ipconfig taskkill xcopy ren del",built_in:"append assoc at attrib break cacls cd chcp chdir chkdsk chkntfs cls cmd color comp compact convert date dir diskcomp diskcopy doskey erase fs find findstr format ftype graftabl help keyb label md mkdir mode more move path pause print popd pushd promt rd recover rem rename replace restore rmdir shiftsort start subst time title tree type ver verify vol"},c:[{cN:"envvar",b:/%%[^ ]|%[^ ]+?%|![^ ]+?!/},{cN:"function",b:r.b,e:"goto:eof",c:[e.inherit(e.TM,{b:"([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*"}),t]},{cN:"number",b:"\\b\\d+",r:0},t]}}),hljs.registerLanguage("dust",function(e){var t="if eq ne lt lte gt gte select default math sep";return{aliases:["dst"],cI:!0,sL:"xml",subLanguageMode:"continuous",c:[{cN:"expression",b:"{",e:"}",r:0,c:[{cN:"begin-block",b:"#[a-zA-Z- .]+",k:t},{cN:"string",b:'"',e:'"'},{cN:"end-block",b:"\\/[a-zA-Z- .]+",k:t},{cN:"variable",b:"[a-zA-Z-.]+",k:t,r:0}]}]}}),hljs.registerLanguage("elixir",function(e){var t="[a-zA-Z_][a-zA-Z0-9_]*(\\!|\\?)?",r="[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?",a="and false then defined module in return redo retry end for true self when next until do begin unless nil break not case cond alias while ensure or include use alias fn quote",i={cN:"subst",b:"#\\{",e:"}",l:t,k:a},n={cN:"string",c:[e.BE,i],v:[{b:/'/,e:/'/},{b:/"/,e:/"/}]},o={cN:"function",bK:"def defp defmacro",e:/\B\b/,c:[e.inherit(e.TM,{b:t,endsParent:!0})]},s=e.inherit(o,{cN:"class",bK:"defmodule defrecord",e:/\bdo\b|$|;/}),l=[n,e.HCM,s,o,{cN:"constant",b:"(\\b[A-Z_]\\w*(.)?)+",r:0},{cN:"symbol",b:":",c:[n,{b:r}],r:0},{cN:"symbol",b:t+":",r:0},{cN:"number",b:"(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b",r:0},{cN:"variable",b:"(\\$\\W)|((\\$|\\@\\@?)(\\w+))"},{b:"->"},{b:"("+e.RSR+")\\s*",c:[e.HCM,{cN:"regexp",i:"\\n",c:[e.BE,i],v:[{b:"/",e:"/[a-z]*"},{b:"%r\\[",e:"\\][a-z]*"}]}],r:0}];return i.c=l,{l:t,k:a,c:l}}),hljs.registerLanguage("ruby",function(e){var t="[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?",r="and false then defined module in return redo if BEGIN retry end for true self when next until do begin unless END rescue nil else break undef not super class case require yield alias while ensure elsif or include attr_reader attr_writer attr_accessor",a={cN:"yardoctag",b:"@[A-Za-z]+"},i={cN:"value",b:"#<",e:">"},n=[e.C("#","$",{c:[a]}),e.C("^\\=begin","^\\=end",{c:[a],r:10}),e.C("^__END__","\\n$")],o={cN:"subst",b:"#\\{",e:"}",k:r},s={cN:"string",c:[e.BE,o],v:[{b:/'/,e:/'/},{b:/"/,e:/"/},{b:/`/,e:/`/},{b:"%[qQwWx]?\\(",e:"\\)"},{b:"%[qQwWx]?\\[",e:"\\]"},{b:"%[qQwWx]?{",e:"}"},{b:"%[qQwWx]?<",e:">"},{b:"%[qQwWx]?/",e:"/"},{b:"%[qQwWx]?%",e:"%"},{b:"%[qQwWx]?-",e:"-"},{b:"%[qQwWx]?\\|",e:"\\|"},{b:/\B\?(\\\d{1,3}|\\x[A-Fa-f0-9]{1,2}|\\u[A-Fa-f0-9]{4}|\\?\S)\b/}]},l={cN:"params",b:"\\(",e:"\\)",k:r},c=[s,i,{cN:"class",bK:"class module",e:"$|;",i:/=/,c:[e.inherit(e.TM,{b:"[A-Za-z_]\\w*(::\\w+)*(\\?|\\!)?"}),{cN:"inheritance",b:"<\\s*",c:[{cN:"parent",b:"("+e.IR+"::)?"+e.IR}]}].concat(n)},{cN:"function",bK:"def",e:" |$|;",r:0,c:[e.inherit(e.TM,{b:t}),l].concat(n)},{cN:"constant",b:"(::)?(\\b[A-Z]\\w*(::)?)+",r:0},{cN:"symbol",b:e.UIR+"(\\!|\\?)?:",r:0},{cN:"symbol",b:":",c:[s,{b:t}],r:0},{cN:"number",b:"(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b",r:0},{cN:"variable",b:"(\\$\\W)|((\\$|\\@\\@?)(\\w+))"},{b:"("+e.RSR+")\\s*",c:[i,{cN:"regexp",c:[e.BE,o],i:/\n/,v:[{b:"/",e:"/[a-z]*"},{b:"%r{",e:"}[a-z]*"},{b:"%r\\(",e:"\\)[a-z]*"},{b:"%r!",e:"![a-z]*"},{b:"%r\\[",e:"\\][a-z]*"}]}].concat(n),r:0}].concat(n);o.c=c,l.c=c;var d="[>?]>",p="[\\w#]+\\(\\w+\\):\\d+:\\d+>",u="(\\w+-)?\\d+\\.\\d+\\.\\d(p\\d+)?[^>]+>",m=[{b:/^\s*=>/,cN:"status",starts:{e:"$",c:c}},{cN:"prompt",b:"^("+d+"|"+p+"|"+u+")",starts:{e:"$",c:c}}];return{aliases:["rb","gemspec","podspec","thor","irb"],k:r,c:n.concat(m).concat(c)}}),hljs.registerLanguage("erb",function(e){return{sL:"xml",subLanguageMode:"continuous",c:[e.C("<%#","%>"),{b:"<%[%=-]?",e:"[%-]?%>",sL:"ruby",eB:!0,eE:!0}]}}),hljs.registerLanguage("erlang-repl",function(e){return{k:{special_functions:"spawn spawn_link self",reserved:"after and andalso|10 band begin bnot bor bsl bsr bxor case catch cond div end fun if let not of or orelse|10 query receive rem try when xor"},c:[{cN:"prompt",b:"^[0-9]+> ",r:10},e.C("%","$"),{cN:"number",b:"\\b(\\d+#[a-fA-F0-9]+|\\d+(\\.\\d+)?([eE][-+]?\\d+)?)",r:0},e.ASM,e.QSM,{cN:"constant",b:"\\?(::)?([A-Z]\\w*(::)?)+"},{cN:"arrow",b:"->"},{cN:"ok",b:"ok"},{cN:"exclamation_mark",b:"!"},{cN:"function_or_atom",b:"(\\b[a-z'][a-zA-Z0-9_']*:[a-z'][a-zA-Z0-9_']*)|(\\b[a-z'][a-zA-Z0-9_']*)",r:0},{cN:"variable",b:"[A-Z][a-zA-Z0-9_']*",r:0}]}}),hljs.registerLanguage("erlang",function(e){var t="[a-z'][a-zA-Z0-9_']*",r="("+t+":"+t+"|"+t+")",a={keyword:"after and andalso|10 band begin bnot bor bsl bzr bxor case catch cond div end fun if let not of orelse|10 query receive rem try when xor",literal:"false true"},i=e.C("%","$"),n={cN:"number",b:"\\b(\\d+#[a-fA-F0-9]+|\\d+(\\.\\d+)?([eE][-+]?\\d+)?)",r:0},o={b:"fun\\s+"+t+"/\\d+"},s={b:r+"\\(",e:"\\)",rB:!0,r:0,c:[{cN:"function_name",b:r,r:0},{b:"\\(",e:"\\)",eW:!0,rE:!0,r:0}]},l={cN:"tuple",b:"{",e:"}",r:0},c={cN:"variable",b:"\\b_([A-Z][A-Za-z0-9_]*)?",r:0},d={cN:"variable",b:"[A-Z][a-zA-Z0-9_]*",r:0},p={b:"#"+e.UIR,r:0,rB:!0,c:[{cN:"record_name",b:"#"+e.UIR,r:0},{b:"{",e:"}",r:0}]},u={bK:"fun receive if try case",e:"end",k:a};u.c=[i,o,e.inherit(e.ASM,{cN:""}),u,s,e.QSM,n,l,c,d,p];var m=[i,o,u,s,e.QSM,n,l,c,d,p];s.c[1].c=m,l.c=m,p.c[1].c=m;var b={cN:"params",b:"\\(",e:"\\)",c:m};return{aliases:["erl"],k:a,i:"(</|\\*=|\\+=|-=|/\\*|\\*/|\\(\\*|\\*\\))",c:[{cN:"function",b:"^"+t+"\\s*\\(",e:"->",rB:!0,i:"\\(|#|//|/\\*|\\\\|:|;",c:[b,e.inherit(e.TM,{b:t})],starts:{e:";|\\.",k:a,c:m}},i,{cN:"pp",b:"^-",e:"\\.",r:0,eE:!0,rB:!0,l:"-"+e.IR,k:"-module -record -undef -export -ifdef -ifndef -author -copyright -doc -vsn -import -include -include_lib -compile -define -else -endif -file -behaviour -behavior -spec",c:[b]},n,e.QSM,p,c,d,l,{b:/\.$/}]}}),hljs.registerLanguage("fix",function(e){return{c:[{b:/[^\u2401\u0001]+/,e:/[\u2401\u0001]/,eE:!0,rB:!0,rE:!1,c:[{b:/([^\u2401\u0001=]+)/,e:/=([^\u2401\u0001=]+)/,rE:!0,rB:!1,cN:"attribute"},{b:/=/,e:/([\u2401\u0001])/,eE:!0,eB:!0,cN:"string"}]}],cI:!0}}),hljs.registerLanguage("fortran",function(e){var t={cN:"params",b:"\\(",e:"\\)"},r={constant:".False. .True.",type:"integer real character complex logical dimension allocatable|10 parameter external implicit|10 none double precision assign intent optional pointer target in out common equivalence data",keyword:"kind do while private call intrinsic where elsewhere type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. goto save else use module select case access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit continue format pause cycle exit c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg synchronous nopass non_overridable pass protected volatile abstract extends import non_intrinsic value deferred generic final enumerator class associate bind enum c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure",built_in:"alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_ofacosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr num_images parity popcnt poppar shifta shiftl shiftr this_image"};return{cI:!0,aliases:["f90","f95"],k:r,c:[e.inherit(e.ASM,{cN:"string",r:0}),e.inherit(e.QSM,{cN:"string",r:0}),{cN:"function",bK:"subroutine function program",i:"[${=\\n]",c:[e.UTM,t]},e.C("!","$",{r:0}),{cN:"number",b:"(?=\\b|\\+|\\-|\\.)(?=\\.\\d|\\d)(?:\\d+)?(?:\\.?\\d*)(?:[de][+-]?\\d+)?\\b\\.?",r:0}]}}),hljs.registerLanguage("fsharp",function(e){var t={b:"<",e:">",c:[e.inherit(e.TM,{b:/'[a-zA-Z0-9_]+/})]};return{aliases:["fs"],k:"yield! return! let! do!abstract and as assert base begin class default delegate do done downcast downto elif else end exception extern false finally for fun function global if in inherit inline interface internal lazy let match member module mutable namespace new null of open or override private public rec return sig static struct then to true try type upcast use val void when while with yield",c:[{cN:"string",b:'@"',e:'"',c:[{b:'""'}]},{cN:"string",b:'"""',e:'"""'},e.C("\\(\\*","\\*\\)"),{cN:"class",bK:"type",e:"\\(|=|$",eE:!0,c:[e.UTM,t]},{cN:"annotation",b:"\\[<",e:">\\]",r:10},{cN:"attribute",b:"\\B('[A-Za-z])\\b",c:[e.BE]},e.CLCM,e.inherit(e.QSM,{i:null}),e.CNM]}}),hljs.registerLanguage("gcode",function(e){var t="[A-Z_][A-Z0-9_.]*",r="\\%",a={literal:"",built_in:"",keyword:"IF DO WHILE ENDWHILE CALL ENDIF SUB ENDSUB GOTO REPEAT ENDREPEAT EQ LT GT NE GE LE OR XOR"},i={cN:"preprocessor",b:"([O])([0-9]+)"},n=[e.CLCM,e.CBCM,e.C(/\(/,/\)/),e.inherit(e.CNM,{b:"([-+]?([0-9]*\\.?[0-9]+\\.?))|"+e.CNR}),e.inherit(e.ASM,{i:null}),e.inherit(e.QSM,{i:null}),{cN:"keyword",b:"([G])([0-9]+\\.?[0-9]?)"},{cN:"title",b:"([M])([0-9]+\\.?[0-9]?)"},{cN:"title",b:"(VC|VS|#)",e:"(\\d+)"},{cN:"title",b:"(VZOFX|VZOFY|VZOFZ)"},{cN:"built_in",b:"(ATAN|ABS|ACOS|ASIN|SIN|COS|EXP|FIX|FUP|ROUND|LN|TAN)(\\[)",e:"([-+]?([0-9]*\\.?[0-9]+\\.?))(\\])"},{cN:"label",v:[{b:"N",e:"\\d+",i:"\\W"}]}];return{aliases:["nc"],cI:!0,l:t,k:a,c:[{cN:"preprocessor",b:r},i].concat(n)}}),hljs.registerLanguage("gherkin",function(e){return{aliases:["feature"],k:"Feature Background Ability Business Need Scenario Scenarios Scenario Outline Scenario Template Examples Given And Then But When",c:[{cN:"keyword",b:"\\*"},e.C("@[^@\r\n	 ]+","$"),{cN:"string",b:"\\|",e:"\\$"},{cN:"variable",b:"<",e:">"},e.HCM,{cN:"string",b:'"""',e:'"""'},e.QSM]}}),hljs.registerLanguage("glsl",function(e){return{k:{keyword:"atomic_uint attribute bool break bvec2 bvec3 bvec4 case centroid coherent const continue default discard dmat2 dmat2x2 dmat2x3 dmat2x4 dmat3 dmat3x2 dmat3x3 dmat3x4 dmat4 dmat4x2 dmat4x3 dmat4x4 do double dvec2 dvec3 dvec4 else flat float for highp if iimage1D iimage1DArray iimage2D iimage2DArray iimage2DMS iimage2DMSArray iimage2DRect iimage3D iimageBuffer iimageCube iimageCubeArray image1D image1DArray image2D image2DArray image2DMS image2DMSArray image2DRect image3D imageBuffer imageCube imageCubeArray in inout int invariant isampler1D isampler1DArray isampler2D isampler2DArray isampler2DMS isampler2DMSArray isampler2DRect isampler3D isamplerBuffer isamplerCube isamplerCubeArray ivec2 ivec3 ivec4 layout lowp mat2 mat2x2 mat2x3 mat2x4 mat3 mat3x2 mat3x3 mat3x4 mat4 mat4x2 mat4x3 mat4x4 mediump noperspective out patch precision readonly restrict return sample sampler1D sampler1DArray sampler1DArrayShadow sampler1DShadow sampler2D sampler2DArray sampler2DArrayShadow sampler2DMS sampler2DMSArray sampler2DRect sampler2DRectShadow sampler2DShadow sampler3D samplerBuffer samplerCube samplerCubeArray samplerCubeArrayShadow samplerCubeShadow smooth struct subroutine switch uimage1D uimage1DArray uimage2D uimage2DArray uimage2DMS uimage2DMSArray uimage2DRect uimage3D uimageBuffer uimageCube uimageCubeArray uint uniform usampler1D usampler1DArray usampler2D usampler2DArray usampler2DMS usampler2DMSArray usampler2DRect usampler3D usamplerBuffer usamplerCube usamplerCubeArray uvec2 uvec3 uvec4 varying vec2 vec3 vec4 void volatile while writeonly",built_in:"gl_BackColor gl_BackLightModelProduct gl_BackLightProduct gl_BackMaterial gl_BackSecondaryColor gl_ClipDistance gl_ClipPlane gl_ClipVertex gl_Color gl_DepthRange gl_EyePlaneQ gl_EyePlaneR gl_EyePlaneS gl_EyePlaneT gl_Fog gl_FogCoord gl_FogFragCoord gl_FragColor gl_FragCoord gl_FragData gl_FragDepth gl_FrontColor gl_FrontFacing gl_FrontLightModelProduct gl_FrontLightProduct gl_FrontMaterial gl_FrontSecondaryColor gl_InstanceID gl_InvocationID gl_Layer gl_LightModel gl_LightSource gl_MaxAtomicCounterBindings gl_MaxAtomicCounterBufferSize gl_MaxClipDistances gl_MaxClipPlanes gl_MaxCombinedAtomicCounterBuffers gl_MaxCombinedAtomicCounters gl_MaxCombinedImageUniforms gl_MaxCombinedImageUnitsAndFragmentOutputs gl_MaxCombinedTextureImageUnits gl_MaxDrawBuffers gl_MaxFragmentAtomicCounterBuffers gl_MaxFragmentAtomicCounters gl_MaxFragmentImageUniforms gl_MaxFragmentInputComponents gl_MaxFragmentUniformComponents gl_MaxFragmentUniformVectors gl_MaxGeometryAtomicCounterBuffers gl_MaxGeometryAtomicCounters gl_MaxGeometryImageUniforms gl_MaxGeometryInputComponents gl_MaxGeometryOutputComponents gl_MaxGeometryOutputVertices gl_MaxGeometryTextureImageUnits gl_MaxGeometryTotalOutputComponents gl_MaxGeometryUniformComponents gl_MaxGeometryVaryingComponents gl_MaxImageSamples gl_MaxImageUnits gl_MaxLights gl_MaxPatchVertices gl_MaxProgramTexelOffset gl_MaxTessControlAtomicCounterBuffers gl_MaxTessControlAtomicCounters gl_MaxTessControlImageUniforms gl_MaxTessControlInputComponents gl_MaxTessControlOutputComponents gl_MaxTessControlTextureImageUnits gl_MaxTessControlTotalOutputComponents gl_MaxTessControlUniformComponents gl_MaxTessEvaluationAtomicCounterBuffers gl_MaxTessEvaluationAtomicCounters gl_MaxTessEvaluationImageUniforms gl_MaxTessEvaluationInputComponents gl_MaxTessEvaluationOutputComponents gl_MaxTessEvaluationTextureImageUnits gl_MaxTessEvaluationUniformComponents gl_MaxTessGenLevel gl_MaxTessPatchComponents gl_MaxTextureCoords gl_MaxTextureImageUnits gl_MaxTextureUnits gl_MaxVaryingComponents gl_MaxVaryingFloats gl_MaxVaryingVectors gl_MaxVertexAtomicCounterBuffers gl_MaxVertexAtomicCounters gl_MaxVertexAttribs gl_MaxVertexImageUniforms gl_MaxVertexOutputComponents gl_MaxVertexTextureImageUnits gl_MaxVertexUniformComponents gl_MaxVertexUniformVectors gl_MaxViewports gl_MinProgramTexelOffsetgl_ModelViewMatrix gl_ModelViewMatrixInverse gl_ModelViewMatrixInverseTranspose gl_ModelViewMatrixTranspose gl_ModelViewProjectionMatrix gl_ModelViewProjectionMatrixInverse gl_ModelViewProjectionMatrixInverseTranspose gl_ModelViewProjectionMatrixTranspose gl_MultiTexCoord0 gl_MultiTexCoord1 gl_MultiTexCoord2 gl_MultiTexCoord3 gl_MultiTexCoord4 gl_MultiTexCoord5 gl_MultiTexCoord6 gl_MultiTexCoord7 gl_Normal gl_NormalMatrix gl_NormalScale gl_ObjectPlaneQ gl_ObjectPlaneR gl_ObjectPlaneS gl_ObjectPlaneT gl_PatchVerticesIn gl_PerVertex gl_Point gl_PointCoord gl_PointSize gl_Position gl_PrimitiveID gl_PrimitiveIDIn gl_ProjectionMatrix gl_ProjectionMatrixInverse gl_ProjectionMatrixInverseTranspose gl_ProjectionMatrixTranspose gl_SampleID gl_SampleMask gl_SampleMaskIn gl_SamplePosition gl_SecondaryColor gl_TessCoord gl_TessLevelInner gl_TessLevelOuter gl_TexCoord gl_TextureEnvColor gl_TextureMatrixInverseTranspose gl_TextureMatrixTranspose gl_Vertex gl_VertexID gl_ViewportIndex gl_in gl_out EmitStreamVertex EmitVertex EndPrimitive EndStreamPrimitive abs acos acosh all any asin asinh atan atanh atomicCounter atomicCounterDecrement atomicCounterIncrement barrier bitCount bitfieldExtract bitfieldInsert bitfieldReverse ceil clamp cos cosh cross dFdx dFdy degrees determinant distance dot equal exp exp2 faceforward findLSB findMSB floatBitsToInt floatBitsToUint floor fma fract frexp ftransform fwidth greaterThan greaterThanEqual imageAtomicAdd imageAtomicAnd imageAtomicCompSwap imageAtomicExchange imageAtomicMax imageAtomicMin imageAtomicOr imageAtomicXor imageLoad imageStore imulExtended intBitsToFloat interpolateAtCentroid interpolateAtOffset interpolateAtSample inverse inversesqrt isinf isnan ldexp length lessThan lessThanEqual log log2 matrixCompMult max memoryBarrier min mix mod modf noise1 noise2 noise3 noise4 normalize not notEqual outerProduct packDouble2x32 packHalf2x16 packSnorm2x16 packSnorm4x8 packUnorm2x16 packUnorm4x8 pow radians reflect refract round roundEven shadow1D shadow1DLod shadow1DProj shadow1DProjLod shadow2D shadow2DLod shadow2DProj shadow2DProjLod sign sin sinh smoothstep sqrt step tan tanh texelFetch texelFetchOffset texture texture1D texture1DLod texture1DProj texture1DProjLod texture2D texture2DLod texture2DProj texture2DProjLod texture3D texture3DLod texture3DProj texture3DProjLod textureCube textureCubeLod textureGather textureGatherOffset textureGatherOffsets textureGrad textureGradOffset textureLod textureLodOffset textureOffset textureProj textureProjGrad textureProjGradOffset textureProjLod textureProjLodOffset textureProjOffset textureQueryLod textureSize transpose trunc uaddCarry uintBitsToFloat umulExtended unpackDouble2x32 unpackHalf2x16 unpackSnorm2x16 unpackSnorm4x8 unpackUnorm2x16 unpackUnorm4x8 usubBorrow gl_TextureMatrix gl_TextureMatrixInverse",literal:"true false"},i:'"',c:[e.CLCM,e.CBCM,e.CNM,{cN:"preprocessor",b:"#",e:"$"}]}}),hljs.registerLanguage("go",function(e){var t={keyword:"break default func interface select case map struct chan else goto package switch const fallthrough if range type continue for import return var go defer",constant:"true false iota nil",typename:"bool byte complex64 complex128 float32 float64 int8 int16 int32 int64 string uint8 uint16 uint32 uint64 int uint uintptr rune",built_in:"append cap close complex copy imag len make new panic print println real recover delete"};return{aliases:["golang"],k:t,i:"</",c:[e.CLCM,e.CBCM,e.QSM,{cN:"string",b:"'",e:"[^\\\\]'"},{cN:"string",b:"`",e:"`"},{cN:"number",b:e.CNR+"[dflsi]?",r:0},e.CNM]}}),hljs.registerLanguage("gradle",function(e){return{cI:!0,k:{keyword:"task project allprojects subprojects artifacts buildscript configurations dependencies repositories sourceSets description delete from into include exclude source classpath destinationDir includes options sourceCompatibility targetCompatibility group flatDir doLast doFirst flatten todir fromdir ant def abstract break case catch continue default do else extends final finally for if implements instanceof native new private protected public return static switch synchronized throw throws transient try volatile while strictfp package import false null super this true antlrtask checkstyle codenarc copy boolean byte char class double float int interface long short void compile runTime file fileTree abs any append asList asWritable call collect compareTo count div dump each eachByte eachFile eachLine every find findAll flatten getAt getErr getIn getOut getText grep immutable inject inspect intersect invokeMethods isCase join leftShift minus multiply newInputStream newOutputStream newPrintWriter newReader newWriter next plus pop power previous print println push putAt read readBytes readLines reverse reverseEach round size sort splitEachLine step subMap times toInteger toList tokenize upto waitForOrKill withPrintWriter withReader withStream withWriter withWriterAppend write writeLine"},c:[e.CLCM,e.CBCM,e.ASM,e.QSM,e.NM,e.RM]}}),hljs.registerLanguage("groovy",function(e){return{k:{typename:"byte short char int long boolean float double void",literal:"true false null",keyword:"def as in assert trait super this abstract static volatile transient public private protected synchronized final class interface enum if else for while switch case break default continue throw throws try catch finally implements extends new import package return instanceof"},c:[e.CLCM,{cN:"javadoc",b:"/\\*\\*",e:"\\*//*",r:0,c:[{
cN:"javadoctag",b:"(^|\\s)@[A-Za-z]+"}]},e.CBCM,{cN:"string",b:'"""',e:'"""'},{cN:"string",b:"'''",e:"'''"},{cN:"string",b:"\\$/",e:"/\\$",r:10},e.ASM,{cN:"regexp",b:/~?\/[^\/\n]+\//,c:[e.BE]},e.QSM,{cN:"shebang",b:"^#!/usr/bin/env",e:"$",i:"\n"},e.BNM,{cN:"class",bK:"class interface trait enum",e:"{",i:":",c:[{bK:"extends implements"},e.UTM]},e.CNM,{cN:"annotation",b:"@[A-Za-z]+"},{cN:"string",b:/[^\?]{0}[A-Za-z0-9_$]+ *:/},{b:/\?/,e:/\:/},{cN:"label",b:"^\\s*[A-Za-z0-9_$]+:",r:0}]}}),hljs.registerLanguage("haml",function(e){return{cI:!0,c:[{cN:"doctype",b:"^!!!( (5|1\\.1|Strict|Frameset|Basic|Mobile|RDFa|XML\\b.*))?$",r:10},e.C("^\\s*(!=#|=#|-#|/).*$",!1,{r:0}),{b:"^\\s*(-|=|!=)(?!#)",starts:{e:"\\n",sL:"ruby"}},{cN:"tag",b:"^\\s*%",c:[{cN:"title",b:"\\w+"},{cN:"value",b:"[#\\.]\\w+"},{b:"{\\s*",e:"\\s*}",eE:!0,c:[{b:":\\w+\\s*=>",e:",\\s+",rB:!0,eW:!0,c:[{cN:"symbol",b:":\\w+"},{cN:"string",b:'"',e:'"'},{cN:"string",b:"'",e:"'"},{b:"\\w+",r:0}]}]},{b:"\\(\\s*",e:"\\s*\\)",eE:!0,c:[{b:"\\w+\\s*=",e:"\\s+",rB:!0,eW:!0,c:[{cN:"attribute",b:"\\w+",r:0},{cN:"string",b:'"',e:'"'},{cN:"string",b:"'",e:"'"},{b:"\\w+",r:0}]}]}]},{cN:"bullet",b:"^\\s*[=~]\\s*",r:0},{b:"#{",starts:{e:"}",sL:"ruby"}}]}}),hljs.registerLanguage("handlebars",function(e){var t="each in with if else unless bindattr action collection debugger log outlet template unbound view yield";return{aliases:["hbs","html.hbs","html.handlebars"],cI:!0,sL:"xml",subLanguageMode:"continuous",c:[{cN:"expression",b:"{{",e:"}}",c:[{cN:"begin-block",b:"#[a-zA-Z- .]+",k:t},{cN:"string",b:'"',e:'"'},{cN:"end-block",b:"\\/[a-zA-Z- .]+",k:t},{cN:"variable",b:"[a-zA-Z-.]+",k:t}]}]}}),hljs.registerLanguage("haskell",function(e){var t=[e.C("--","$"),e.C("{-","-}",{c:["self"]})],r={cN:"pragma",b:"{-#",e:"#-}"},a={cN:"preprocessor",b:"^#",e:"$"},i={cN:"type",b:"\\b[A-Z][\\w']*",r:0},n={cN:"container",b:"\\(",e:"\\)",i:'"',c:[r,a,{cN:"type",b:"\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?"},e.inherit(e.TM,{b:"[_a-z][\\w']*"})].concat(t)},o={cN:"container",b:"{",e:"}",c:n.c};return{aliases:["hs"],k:"let in if then else case of where do module import hiding qualified type data newtype deriving class instance as default infix infixl infixr foreign export ccall stdcall cplusplus jvm dotnet safe unsafe family forall mdo proc rec",c:[{cN:"module",b:"\\bmodule\\b",e:"where",k:"module where",c:[n].concat(t),i:"\\W\\.|;"},{cN:"import",b:"\\bimport\\b",e:"$",k:"import|0 qualified as hiding",c:[n].concat(t),i:"\\W\\.|;"},{cN:"class",b:"^(\\s*)?(class|instance)\\b",e:"where",k:"class family instance where",c:[i,n].concat(t)},{cN:"typedef",b:"\\b(data|(new)?type)\\b",e:"$",k:"data family type newtype deriving",c:[r,i,n,o].concat(t)},{cN:"default",bK:"default",e:"$",c:[i,n].concat(t)},{cN:"infix",bK:"infix infixl infixr",e:"$",c:[e.CNM].concat(t)},{cN:"foreign",b:"\\bforeign\\b",e:"$",k:"foreign import export ccall stdcall cplusplus jvm dotnet safe unsafe",c:[i,e.QSM].concat(t)},{cN:"shebang",b:"#!\\/usr\\/bin\\/env runhaskell",e:"$"},r,a,e.QSM,e.CNM,i,e.inherit(e.TM,{b:"^[_a-z][\\w']*"}),{b:"->|<-"}].concat(t)}}),hljs.registerLanguage("haxe",function(e){var t="([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)";return{aliases:["hx"],k:{keyword:"break callback case cast catch class continue default do dynamic else enum extends extern for function here if implements import in inline interface never new override package private public return static super switch this throw trace try typedef untyped using var while",literal:"true false null"},c:[e.ASM,e.QSM,e.CLCM,e.CBCM,e.CNM,{cN:"class",bK:"class interface",e:"{",eE:!0,c:[{bK:"extends implements"},e.TM]},{cN:"preprocessor",b:"#",e:"$",k:"if else elseif end error"},{cN:"function",bK:"function",e:"[{;]",eE:!0,i:"\\S",c:[e.TM,{cN:"params",b:"\\(",e:"\\)",c:[e.ASM,e.QSM,e.CLCM,e.CBCM]},{cN:"type",b:":",e:t,r:10}]}]}}),hljs.registerLanguage("http",function(e){return{aliases:["https"],i:"\\S",c:[{cN:"status",b:"^HTTP/[0-9\\.]+",e:"$",c:[{cN:"number",b:"\\b\\d{3}\\b"}]},{cN:"request",b:"^[A-Z]+ (.*?) HTTP/[0-9\\.]+$",rB:!0,e:"$",c:[{cN:"string",b:" ",e:" ",eB:!0,eE:!0}]},{cN:"attribute",b:"^\\w",e:": ",eE:!0,i:"\\n|\\s|=",starts:{cN:"string",e:"$"}},{b:"\\n\\n",starts:{sL:"",eW:!0}}]}}),hljs.registerLanguage("ini",function(e){return{cI:!0,i:/\S/,c:[e.C(";","$"),{cN:"title",b:"^\\[",e:"\\]"},{cN:"setting",b:"^[a-z0-9\\[\\]_-]+[ \\t]*=[ \\t]*",e:"$",c:[{cN:"value",eW:!0,k:"on off true false yes no",c:[e.QSM,e.NM],r:0}]}]}}),hljs.registerLanguage("java",function(e){var t=e.UIR+"(<"+e.UIR+">)?",r="false synchronized int abstract float private char boolean static null if const for true while long strictfp finally protected import native final void enum else break transient catch instanceof byte super volatile case assert short package default double public try this switch continue throws protected public private",a="(\\b(0b[01_]+)|\\b0[xX][a-fA-F0-9_]+|(\\b[\\d_]+(\\.[\\d_]*)?|\\.[\\d_]+)([eE][-+]?\\d+)?)[lLfF]?",i={cN:"number",b:a,r:0};return{aliases:["jsp"],k:r,i:/<\//,c:[{cN:"javadoc",b:"/\\*\\*",e:"\\*/",r:0,c:[{cN:"javadoctag",b:"(^|\\s)@[A-Za-z]+"}]},e.CLCM,e.CBCM,e.ASM,e.QSM,{cN:"class",bK:"class interface",e:/[{;=]/,eE:!0,k:"class interface",i:/[:"\[\]]/,c:[{bK:"extends implements"},e.UTM]},{bK:"new throw return",r:0},{cN:"function",b:"("+t+"\\s+)+"+e.UIR+"\\s*\\(",rB:!0,e:/[{;=]/,eE:!0,k:r,c:[{b:e.UIR+"\\s*\\(",rB:!0,r:0,c:[e.UTM]},{cN:"params",b:/\(/,e:/\)/,k:r,r:0,c:[e.ASM,e.QSM,e.CNM,e.CBCM]},e.CLCM,e.CBCM]},i,{cN:"annotation",b:"@[A-Za-z]+"}]}}),hljs.registerLanguage("javascript",function(e){return{aliases:["js"],k:{keyword:"in of if for while finally var new function do return void else break catch instanceof with throw case default try this switch continue typeof delete let yield const export super debugger as await",literal:"true false null undefined NaN Infinity",built_in:"eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent encodeURI encodeURIComponent escape unescape Object Function Boolean Error EvalError InternalError RangeError ReferenceError StopIteration SyntaxError TypeError URIError Number Math Date String RegExp Array Float32Array Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect Promise"},c:[{cN:"pi",r:10,v:[{b:/^\s*('|")use strict('|")/},{b:/^\s*('|")use asm('|")/}]},e.ASM,e.QSM,{cN:"string",b:"`",e:"`",c:[e.BE,{cN:"subst",b:"\\$\\{",e:"\\}"}]},e.CLCM,e.CBCM,{cN:"number",b:"\\b(0[xXbBoO][a-fA-F0-9]+|(\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)",r:0},{b:"("+e.RSR+"|\\b(case|return|throw)\\b)\\s*",k:"return throw case",c:[e.CLCM,e.CBCM,e.RM,{b:/</,e:/>\s*[);\]]/,r:0,sL:"xml"}],r:0},{cN:"function",bK:"function",e:/\{/,eE:!0,c:[e.inherit(e.TM,{b:/[A-Za-z$_][0-9A-Za-z$_]*/}),{cN:"params",b:/\(/,e:/\)/,c:[e.CLCM,e.CBCM],i:/["'\(]/}],i:/\[|%/},{b:/\$[(.]/},{b:"\\."+e.IR,r:0},{bK:"import",e:"[;$]",k:"import from as",c:[e.ASM,e.QSM]},{cN:"class",bK:"class",e:/[{;=]/,eE:!0,i:/[:"\[\]]/,c:[{bK:"extends"},e.UTM]}]}}),hljs.registerLanguage("json",function(e){var t={literal:"true false null"},r=[e.QSM,e.CNM],a={cN:"value",e:",",eW:!0,eE:!0,c:r,k:t},i={b:"{",e:"}",c:[{cN:"attribute",b:'\\s*"',e:'"\\s*:\\s*',eB:!0,eE:!0,c:[e.BE],i:"\\n",starts:a}],i:"\\S"},n={b:"\\[",e:"\\]",c:[e.inherit(a,{cN:null})],i:"\\S"};return r.splice(r.length,0,i,n),{c:r,k:t,i:"\\S"}}),hljs.registerLanguage("julia",function(e){var t={keyword:"in abstract baremodule begin bitstype break catch ccall const continue do else elseif end export finally for function global if immutable import importall let local macro module quote return try type typealias using while",literal:"true false ANY ARGS CPU_CORES C_NULL DL_LOAD_PATH DevNull ENDIAN_BOM ENV I|0 Inf Inf16 Inf32 InsertionSort JULIA_HOME LOAD_PATH MS_ASYNC MS_INVALIDATE MS_SYNC MergeSort NaN NaN16 NaN32 OS_NAME QuickSort RTLD_DEEPBIND RTLD_FIRST RTLD_GLOBAL RTLD_LAZY RTLD_LOCAL RTLD_NODELETE RTLD_NOLOAD RTLD_NOW RoundDown RoundFromZero RoundNearest RoundToZero RoundUp STDERR STDIN STDOUT VERSION WORD_SIZE catalan cglobal e eu eulergamma golden im nothing pi γ π φ",built_in:"ASCIIString AbstractArray AbstractRNG AbstractSparseArray Any ArgumentError Array Associative Base64Pipe Bidiagonal BigFloat BigInt BitArray BitMatrix BitVector Bool BoundsError Box CFILE Cchar Cdouble Cfloat Char CharString Cint Clong Clonglong ClusterManager Cmd Coff_t Colon Complex Complex128 Complex32 Complex64 Condition Cptrdiff_t Cshort Csize_t Cssize_t Cuchar Cuint Culong Culonglong Cushort Cwchar_t DArray DataType DenseArray Diagonal Dict DimensionMismatch DirectIndexString Display DivideError DomainError EOFError EachLine Enumerate ErrorException Exception Expr Factorization FileMonitor FileOffset Filter Float16 Float32 Float64 FloatRange FloatingPoint Function GetfieldNode GotoNode Hermitian IO IOBuffer IOStream IPv4 IPv6 InexactError Int Int128 Int16 Int32 Int64 Int8 IntSet Integer InterruptException IntrinsicFunction KeyError LabelNode LambdaStaticData LineNumberNode LoadError LocalProcess MIME MathConst MemoryError MersenneTwister Method MethodError MethodTable Module NTuple NewvarNode Nothing Number ObjectIdDict OrdinalRange OverflowError ParseError PollingFileWatcher ProcessExitedException ProcessGroup Ptr QuoteNode Range Range1 Ranges Rational RawFD Real Regex RegexMatch RemoteRef RepString RevString RopeString RoundingMode Set SharedArray Signed SparseMatrixCSC StackOverflowError Stat StatStruct StepRange String SubArray SubString SymTridiagonal Symbol SymbolNode Symmetric SystemError Task TextDisplay Timer TmStruct TopNode Triangular Tridiagonal Type TypeConstructor TypeError TypeName TypeVar UTF16String UTF32String UTF8String UdpSocket Uint Uint128 Uint16 Uint32 Uint64 Uint8 UndefRefError UndefVarError UniformScaling UnionType UnitRange Unsigned Vararg VersionNumber WString WeakKeyDict WeakRef Woodbury Zip"},r="[A-Za-z_\\u00A1-\\uFFFF][A-Za-z_0-9\\u00A1-\\uFFFF]*",a={l:r,k:t},i={cN:"type-annotation",b:/::/},n={cN:"subtype",b:/<:/},o={cN:"number",b:/(\b0x[\d_]*(\.[\d_]*)?|0x\.\d[\d_]*)p[-+]?\d+|\b0[box][a-fA-F0-9][a-fA-F0-9_]*|(\b\d[\d_]*(\.[\d_]*)?|\.\d[\d_]*)([eEfF][-+]?\d+)?/,r:0},s={cN:"char",b:/'(.|\\[xXuU][a-zA-Z0-9]+)'/},l={cN:"subst",b:/\$\(/,e:/\)/,k:t},c={cN:"variable",b:"\\$"+r},d={cN:"string",c:[e.BE,l,c],v:[{b:/\w*"/,e:/"\w*/},{b:/\w*"""/,e:/"""\w*/}]},p={cN:"string",c:[e.BE,l,c],b:"`",e:"`"},u={cN:"macrocall",b:"@"+r},m={cN:"comment",v:[{b:"#=",e:"=#",r:10},{b:"#",e:"$"}]};return a.c=[o,s,i,n,d,p,u,m,e.HCM],l.c=a.c,a}),hljs.registerLanguage("kotlin",function(e){var t="val var get set class trait object public open private protected final enum if else do while for when break continue throw try catch finally import package is as in return fun override default companion reified inline volatile transient native";return{k:{typename:"Byte Short Char Int Long Boolean Float Double Void Unit Nothing",literal:"true false null",keyword:t},c:[e.CLCM,{cN:"javadoc",b:"/\\*\\*",e:"\\*//*",r:0,c:[{cN:"javadoctag",b:"(^|\\s)@[A-Za-z]+"}]},e.CBCM,{cN:"type",b:/</,e:/>/,rB:!0,eE:!1,r:0},{cN:"function",bK:"fun",e:"[(]|$",rB:!0,eE:!0,k:t,i:/fun\s+(<.*>)?[^\s\(]+(\s+[^\s\(]+)\s*=/,r:5,c:[{b:e.UIR+"\\s*\\(",rB:!0,r:0,c:[e.UTM]},{cN:"type",b:/</,e:/>/,k:"reified",r:0},{cN:"params",b:/\(/,e:/\)/,k:t,r:0,i:/\([^\(,\s:]+,/,c:[{cN:"typename",b:/:\s*/,e:/\s*[=\)]/,eB:!0,rE:!0,r:0}]},e.CLCM,e.CBCM]},{cN:"class",bK:"class trait",e:/[:\{(]|$/,eE:!0,i:"extends implements",c:[e.UTM,{cN:"type",b:/</,e:/>/,eB:!0,eE:!0,r:0},{cN:"typename",b:/[,:]\s*/,e:/[<\(,]|$/,eB:!0,rE:!0}]},{cN:"variable",bK:"var val",e:/\s*[=:$]/,eE:!0},e.QSM,{cN:"shebang",b:"^#!/usr/bin/env",e:"$",i:"\n"},e.CNM]}}),hljs.registerLanguage("lasso",function(e){var t="[a-zA-Z_][a-zA-Z0-9_.]*",r="<\\?(lasso(script)?|=)",a="\\]|\\?>",i={literal:"true false none minimal full all void and or not bw nbw ew new cn ncn lt lte gt gte eq neq rx nrx ft",built_in:"array date decimal duration integer map pair string tag xml null boolean bytes keyword list locale queue set stack staticarray local var variable global data self inherited",keyword:"error_code error_msg error_pop error_push error_reset cache database_names database_schemanames database_tablenames define_tag define_type email_batch encode_set html_comment handle handle_error header if inline iterate ljax_target link link_currentaction link_currentgroup link_currentrecord link_detail link_firstgroup link_firstrecord link_lastgroup link_lastrecord link_nextgroup link_nextrecord link_prevgroup link_prevrecord log loop namespace_using output_none portal private protect records referer referrer repeating resultset rows search_args search_arguments select sort_args sort_arguments thread_atomic value_list while abort case else if_empty if_false if_null if_true loop_abort loop_continue loop_count params params_up return return_value run_children soap_definetag soap_lastrequest soap_lastresponse tag_name ascending average by define descending do equals frozen group handle_failure import in into join let match max min on order parent protected provide public require returnhome skip split_thread sum take thread to trait type where with yield yieldhome"},n=e.C("<!--","-->",{r:0}),o={cN:"preprocessor",b:"\\[noprocess\\]",starts:{cN:"markup",e:"\\[/noprocess\\]",rE:!0,c:[n]}},s={cN:"preprocessor",b:"\\[/noprocess|"+r},l={cN:"variable",b:"'"+t+"'"},c=[e.CLCM,{cN:"javadoc",b:"/\\*\\*!",e:"\\*/",c:[e.PWM]},e.CBCM,e.inherit(e.CNM,{b:e.CNR+"|(-?infinity|nan)\\b"}),e.inherit(e.ASM,{i:null}),e.inherit(e.QSM,{i:null}),{cN:"string",b:"`",e:"`"},{cN:"variable",v:[{b:"[#$]"+t},{b:"#",e:"\\d+",i:"\\W"}]},{cN:"tag",b:"::\\s*",e:t,i:"\\W"},{cN:"attribute",v:[{b:"-"+e.UIR,r:0},{b:"(\\.\\.\\.)"}]},{cN:"subst",v:[{b:"->\\s*",c:[l]},{b:":=|/(?!\\w)=?|[-+*%=<>&|!?\\\\]+",r:0}]},{cN:"built_in",b:"\\.\\.?\\s*",r:0,c:[l]},{cN:"class",bK:"define",rE:!0,e:"\\(|=>",c:[e.inherit(e.TM,{b:e.UIR+"(=(?!>))?"})]}];return{aliases:["ls","lassoscript"],cI:!0,l:t+"|&[lg]t;",k:i,c:[{cN:"preprocessor",b:a,r:0,starts:{cN:"markup",e:"\\[|"+r,rE:!0,r:0,c:[n]}},o,s,{cN:"preprocessor",b:"\\[no_square_brackets",starts:{e:"\\[/no_square_brackets\\]",l:t+"|&[lg]t;",k:i,c:[{cN:"preprocessor",b:a,r:0,starts:{cN:"markup",e:"\\[noprocess\\]|"+r,rE:!0,c:[n]}},o,s].concat(c)}},{cN:"preprocessor",b:"\\[",r:0},{cN:"shebang",b:"^#!.+lasso9\\b",r:10}].concat(c)}}),hljs.registerLanguage("less",function(e){var t="[\\w-]+",r="("+t+"|@{"+t+"})",a=[],i=[],n=function(e){return{cN:"string",b:"~?"+e+".*?"+e}},o=function(e,t,r){return{cN:e,b:t,r:r}},s=function(t,r,a){return e.inherit({cN:t,b:r+"\\(",e:"\\(",rB:!0,eE:!0,r:0},a)},l={b:"\\(",e:"\\)",c:i,r:0};i.push(e.CLCM,e.CBCM,n("'"),n('"'),e.CSSNM,o("hexcolor","#[0-9A-Fa-f]+\\b"),s("function","(url|data-uri)",{starts:{cN:"string",e:"[\\)\\n]",eE:!0}}),s("function",t),l,o("variable","@@?"+t,10),o("variable","@{"+t+"}"),o("built_in","~?`[^`]*?`"),{cN:"attribute",b:t+"\\s*:",e:":",rB:!0,eE:!0});var c=i.concat({b:"{",e:"}",c:a}),d={bK:"when",eW:!0,c:[{bK:"and not"}].concat(i)},p={cN:"attribute",b:r,e:":",eE:!0,c:[e.CLCM,e.CBCM],i:/\S/,starts:{e:"[;}]",rE:!0,c:i,i:"[<=$]"}},u={cN:"at_rule",b:"@(import|media|charset|font-face|(-[a-z]+-)?keyframes|supports|document|namespace|page|viewport|host)\\b",starts:{e:"[;{}]",rE:!0,c:i,r:0}},m={cN:"variable",v:[{b:"@"+t+"\\s*:",r:15},{b:"@"+t}],starts:{e:"[;}]",rE:!0,c:c}},b={v:[{b:"[\\.#:&\\[]",e:"[;{}]"},{b:r+"[^;]*{",e:"{"}],rB:!0,rE:!0,i:"[<='$\"]",c:[e.CLCM,e.CBCM,d,o("keyword","all\\b"),o("variable","@{"+t+"}"),o("tag",r+"%?",0),o("id","#"+r),o("class","\\."+r,0),o("keyword","&",0),s("pseudo",":not"),s("keyword",":extend"),o("pseudo","::?"+r),{cN:"attr_selector",b:"\\[",e:"\\]"},{b:"\\(",e:"\\)",c:c},{b:"!important"}]};return a.push(e.CLCM,e.CBCM,u,m,b,p),{cI:!0,i:"[=>'/<($\"]",c:a}}),hljs.registerLanguage("lisp",function(e){var t="[a-zA-Z_\\-\\+\\*\\/\\<\\=\\>\\&\\#][a-zA-Z0-9_\\-\\+\\*\\/\\<\\=\\>\\&\\#!]*",r="\\|[^]*?\\|",a="(\\-|\\+)?\\d+(\\.\\d+|\\/\\d+)?((d|e|f|l|s|D|E|F|L|S)(\\+|\\-)?\\d+)?",i={cN:"shebang",b:"^#!",e:"$"},n={cN:"literal",b:"\\b(t{1}|nil)\\b"},o={cN:"number",v:[{b:a,r:0},{b:"#(b|B)[0-1]+(/[0-1]+)?"},{b:"#(o|O)[0-7]+(/[0-7]+)?"},{b:"#(x|X)[0-9a-fA-F]+(/[0-9a-fA-F]+)?"},{b:"#(c|C)\\("+a+" +"+a,e:"\\)"}]},s=e.inherit(e.QSM,{i:null}),l=e.C(";","$",{r:0}),c={cN:"variable",b:"\\*",e:"\\*"},d={cN:"keyword",b:"[:&]"+t},p={b:t,r:0},u={b:r},m={b:"\\(",e:"\\)",c:["self",n,s,o,p]},b={cN:"quoted",c:[o,s,c,d,m,p],v:[{b:"['`]\\(",e:"\\)"},{b:"\\(quote ",e:"\\)",k:"quote"},{b:"'"+r}]},g={cN:"quoted",v:[{b:"'"+t},{b:"#'"+t+"(::"+t+")*"}]},f={cN:"list",b:"\\(\\s*",e:"\\)"},h={eW:!0,r:0};return f.c=[{cN:"keyword",v:[{b:t},{b:r}]},h],h.c=[b,g,f,n,o,s,l,c,d,u,p],{i:/\S/,c:[o,i,n,s,l,b,g,f,p]}}),hljs.registerLanguage("livecodeserver",function(e){var t={cN:"variable",b:"\\b[gtps][A-Z]+[A-Za-z0-9_\\-]*\\b|\\$_[A-Z]+",r:0},r=[e.CBCM,e.HCM,e.C("--","$"),e.C("[^:]//","$")],a=e.inherit(e.TM,{v:[{b:"\\b_*rig[A-Z]+[A-Za-z0-9_\\-]*"},{b:"\\b_[a-z0-9\\-]+"}]}),i=e.inherit(e.TM,{b:"\\b([A-Za-z0-9_\\-]+)\\b"});return{cI:!1,k:{keyword:"$_COOKIE $_FILES $_GET $_GET_BINARY $_GET_RAW $_POST $_POST_BINARY $_POST_RAW $_SESSION $_SERVER codepoint codepoints segment segments codeunit codeunits sentence sentences trueWord trueWords paragraph after byte bytes english the until http forever descending using line real8 with seventh for stdout finally element word words fourth before black ninth sixth characters chars stderr uInt1 uInt1s uInt2 uInt2s stdin string lines relative rel any fifth items from middle mid at else of catch then third it file milliseconds seconds second secs sec int1 int1s int4 int4s internet int2 int2s normal text item last long detailed effective uInt4 uInt4s repeat end repeat URL in try into switch to words https token binfile each tenth as ticks tick system real4 by dateItems without char character ascending eighth whole dateTime numeric short first ftp integer abbreviated abbr abbrev private case while if",constant:"SIX TEN FORMFEED NINE ZERO NONE SPACE FOUR FALSE COLON CRLF PI COMMA ENDOFFILE EOF EIGHT FIVE QUOTE EMPTY ONE TRUE RETURN CR LINEFEED RIGHT BACKSLASH NULL SEVEN TAB THREE TWO six ten formfeed nine zero none space four false colon crlf pi comma endoffile eof eight five quote empty one true return cr linefeed right backslash null seven tab three two RIVERSION RISTATE FILE_READ_MODE FILE_WRITE_MODE FILE_WRITE_MODE DIR_WRITE_MODE FILE_READ_UMASK FILE_WRITE_UMASK DIR_READ_UMASK DIR_WRITE_UMASK",operator:"div mod wrap and or bitAnd bitNot bitOr bitXor among not in a an within contains ends with begins the keys of keys",built_in:"put abs acos aliasReference annuity arrayDecode arrayEncode asin atan atan2 average avg avgDev base64Decode base64Encode baseConvert binaryDecode binaryEncode byteOffset byteToNum cachedURL cachedURLs charToNum cipherNames codepointOffset codepointProperty codepointToNum codeunitOffset commandNames compound compress constantNames cos date dateFormat decompress directories diskSpace DNSServers exp exp1 exp2 exp10 extents files flushEvents folders format functionNames geometricMean global globals hasMemory harmonicMean hostAddress hostAddressToName hostName hostNameToAddress isNumber ISOToMac itemOffset keys len length libURLErrorData libUrlFormData libURLftpCommand libURLLastHTTPHeaders libURLLastRHHeaders libUrlMultipartFormAddPart libUrlMultipartFormData libURLVersion lineOffset ln ln1 localNames log log2 log10 longFilePath lower macToISO matchChunk matchText matrixMultiply max md5Digest median merge millisec millisecs millisecond milliseconds min monthNames nativeCharToNum normalizeText num number numToByte numToChar numToCodepoint numToNativeChar offset open openfiles openProcesses openProcessIDs openSockets paragraphOffset paramCount param params peerAddress pendingMessages platform popStdDev populationStandardDeviation populationVariance popVariance processID random randomBytes replaceText result revCreateXMLTree revCreateXMLTreeFromFile revCurrentRecord revCurrentRecordIsFirst revCurrentRecordIsLast revDatabaseColumnCount revDatabaseColumnIsNull revDatabaseColumnLengths revDatabaseColumnNames revDatabaseColumnNamed revDatabaseColumnNumbered revDatabaseColumnTypes revDatabaseConnectResult revDatabaseCursors revDatabaseID revDatabaseTableNames revDatabaseType revDataFromQuery revdb_closeCursor revdb_columnbynumber revdb_columncount revdb_columnisnull revdb_columnlengths revdb_columnnames revdb_columntypes revdb_commit revdb_connect revdb_connections revdb_connectionerr revdb_currentrecord revdb_cursorconnection revdb_cursorerr revdb_cursors revdb_dbtype revdb_disconnect revdb_execute revdb_iseof revdb_isbof revdb_movefirst revdb_movelast revdb_movenext revdb_moveprev revdb_query revdb_querylist revdb_recordcount revdb_rollback revdb_tablenames revGetDatabaseDriverPath revNumberOfRecords revOpenDatabase revOpenDatabases revQueryDatabase revQueryDatabaseBlob revQueryResult revQueryIsAtStart revQueryIsAtEnd revUnixFromMacPath revXMLAttribute revXMLAttributes revXMLAttributeValues revXMLChildContents revXMLChildNames revXMLCreateTreeFromFileWithNamespaces revXMLCreateTreeWithNamespaces revXMLDataFromXPathQuery revXMLEvaluateXPath revXMLFirstChild revXMLMatchingNode revXMLNextSibling revXMLNodeContents revXMLNumberOfChildren revXMLParent revXMLPreviousSibling revXMLRootNode revXMLRPC_CreateRequest revXMLRPC_Documents revXMLRPC_Error revXMLRPC_GetHost revXMLRPC_GetMethod revXMLRPC_GetParam revXMLText revXMLRPC_Execute revXMLRPC_GetParamCount revXMLRPC_GetParamNode revXMLRPC_GetParamType revXMLRPC_GetPath revXMLRPC_GetPort revXMLRPC_GetProtocol revXMLRPC_GetRequest revXMLRPC_GetResponse revXMLRPC_GetSocket revXMLTree revXMLTrees revXMLValidateDTD revZipDescribeItem revZipEnumerateItems revZipOpenArchives round sampVariance sec secs seconds sentenceOffset sha1Digest shell shortFilePath sin specialFolderPath sqrt standardDeviation statRound stdDev sum sysError systemVersion tan tempName textDecode textEncode tick ticks time to tokenOffset toLower toUpper transpose truewordOffset trunc uniDecode uniEncode upper URLDecode URLEncode URLStatus uuid value variableNames variance version waitDepth weekdayNames wordOffset xsltApplyStylesheet xsltApplyStylesheetFromFile xsltLoadStylesheet xsltLoadStylesheetFromFile add breakpoint cancel clear local variable file word line folder directory URL close socket process combine constant convert create new alias folder directory decrypt delete variable word line folder directory URL dispatch divide do encrypt filter get include intersect kill libURLDownloadToFile libURLFollowHttpRedirects libURLftpUpload libURLftpUploadFile libURLresetAll libUrlSetAuthCallback libURLSetCustomHTTPHeaders libUrlSetExpect100 libURLSetFTPListCommand libURLSetFTPMode libURLSetFTPStopTime libURLSetStatusCallback load multiply socket prepare process post seek rel relative read from process rename replace require resetAll resolve revAddXMLNode revAppendXML revCloseCursor revCloseDatabase revCommitDatabase revCopyFile revCopyFolder revCopyXMLNode revDeleteFolder revDeleteXMLNode revDeleteAllXMLTrees revDeleteXMLTree revExecuteSQL revGoURL revInsertXMLNode revMoveFolder revMoveToFirstRecord revMoveToLastRecord revMoveToNextRecord revMoveToPreviousRecord revMoveToRecord revMoveXMLNode revPutIntoXMLNode revRollBackDatabase revSetDatabaseDriverPath revSetXMLAttribute revXMLRPC_AddParam revXMLRPC_DeleteAllDocuments revXMLAddDTD revXMLRPC_Free revXMLRPC_FreeAll revXMLRPC_DeleteDocument revXMLRPC_DeleteParam revXMLRPC_SetHost revXMLRPC_SetMethod revXMLRPC_SetPort revXMLRPC_SetProtocol revXMLRPC_SetSocket revZipAddItemWithData revZipAddItemWithFile revZipAddUncompressedItemWithData revZipAddUncompressedItemWithFile revZipCancel revZipCloseArchive revZipDeleteItem revZipExtractItemToFile revZipExtractItemToVariable revZipSetProgressCallback revZipRenameItem revZipReplaceItemWithData revZipReplaceItemWithFile revZipOpenArchive send set sort split start stop subtract union unload wait write"},c:[t,{cN:"keyword",b:"\\bend\\sif\\b"},{cN:"function",bK:"function",e:"$",c:[t,i,e.ASM,e.QSM,e.BNM,e.CNM,a]},{cN:"function",bK:"end",e:"$",c:[i,a]},{cN:"command",bK:"command on",e:"$",c:[t,i,e.ASM,e.QSM,e.BNM,e.CNM,a]},{cN:"command",bK:"end",e:"$",c:[i,a]},{cN:"preprocessor",b:"<\\?rev|<\\?lc|<\\?livecode",r:10},{cN:"preprocessor",b:"<\\?"},{cN:"preprocessor",b:"\\?>"},e.ASM,e.QSM,e.BNM,e.CNM,a].concat(r),i:";$|^\\[|^="}}),hljs.registerLanguage("livescript",function(e){var t={keyword:"in if for while finally new do return else break catch instanceof throw try this switch continue typeof delete debugger case default function var with then unless until loop of by when and or is isnt not it that otherwise from to til fallthrough super case default function var void const let enum export import native __hasProp __extends __slice __bind __indexOf",literal:"true false null undefined yes no on off it that void",built_in:"npm require console print module global window document"},r="[A-Za-z$_](?:-[0-9A-Za-z$_]|[0-9A-Za-z$_])*",a=e.inherit(e.TM,{b:r}),i={cN:"subst",b:/#\{/,e:/}/,k:t},n={cN:"subst",b:/#[A-Za-z$_]/,e:/(?:\-[0-9A-Za-z$_]|[0-9A-Za-z$_])*/,k:t},o=[e.BNM,{cN:"number",b:"(\\b0[xX][a-fA-F0-9_]+)|(\\b\\d(\\d|_\\d)*(\\.(\\d(\\d|_\\d)*)?)?(_*[eE]([-+]\\d(_\\d|\\d)*)?)?[_a-z]*)",r:0,starts:{e:"(\\s*/)?",r:0}},{cN:"string",v:[{b:/'''/,e:/'''/,c:[e.BE]},{b:/'/,e:/'/,c:[e.BE]},{b:/"""/,e:/"""/,c:[e.BE,i,n]},{b:/"/,e:/"/,c:[e.BE,i,n]},{b:/\\/,e:/(\s|$)/,eE:!0}]},{cN:"pi",v:[{b:"//",e:"//[gim]*",c:[i,e.HCM]},{b:/\/(?![ *])(\\\/|.)*?\/[gim]*(?=\W|$)/}]},{cN:"property",b:"@"+r},{b:"``",e:"``",eB:!0,eE:!0,sL:"javascript"}];i.c=o;var s={cN:"params",b:"\\(",rB:!0,c:[{b:/\(/,e:/\)/,k:t,c:["self"].concat(o)}]};return{aliases:["ls"],k:t,i:/\/\*/,c:o.concat([e.C("\\/\\*","\\*\\/"),e.HCM,{cN:"function",c:[a,s],rB:!0,v:[{b:"("+r+"\\s*(?:=|:=)\\s*)?(\\(.*\\))?\\s*\\B\\->\\*?",e:"\\->\\*?"},{b:"("+r+"\\s*(?:=|:=)\\s*)?!?(\\(.*\\))?\\s*\\B[-~]{1,2}>\\*?",e:"[-~]{1,2}>\\*?"},{b:"("+r+"\\s*(?:=|:=)\\s*)?(\\(.*\\))?\\s*\\B!?[-~]{1,2}>\\*?",e:"!?[-~]{1,2}>\\*?"}]},{cN:"class",bK:"class",e:"$",i:/[:="\[\]]/,c:[{bK:"extends",eW:!0,i:/[:="\[\]]/,c:[a]},a]},{cN:"attribute",b:r+":",e:":",rB:!0,rE:!0,r:0}])}}),hljs.registerLanguage("lua",function(e){var t="\\[=*\\[",r="\\]=*\\]",a={b:t,e:r,c:["self"]},i=[e.C("--(?!"+t+")","$"),e.C("--"+t,r,{c:[a],r:10})];return{l:e.UIR,k:{keyword:"and break do else elseif end false for if in local nil not or repeat return then true until while",built_in:"_G _VERSION assert collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstring module next pairs pcall print rawequal rawget rawset require select setfenv setmetatable tonumber tostring type unpack xpcall coroutine debug io math os package string table"},c:i.concat([{cN:"function",bK:"function",e:"\\)",c:[e.inherit(e.TM,{b:"([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*"}),{cN:"params",b:"\\(",eW:!0,c:i}].concat(i)},e.CNM,e.ASM,e.QSM,{cN:"string",b:t,e:r,c:[a],r:5}])}}),hljs.registerLanguage("makefile",function(e){var t={cN:"variable",b:/\$\(/,e:/\)/,c:[e.BE]};return{aliases:["mk","mak"],c:[e.HCM,{b:/^\w+\s*\W*=/,rB:!0,r:0,starts:{cN:"constant",e:/\s*\W*=/,eE:!0,starts:{e:/$/,r:0,c:[t]}}},{cN:"title",b:/^[\w]+:\s*$/},{cN:"phony",b:/^\.PHONY:/,e:/$/,k:".PHONY",l:/[\.\w]+/},{b:/^\t+/,e:/$/,r:0,c:[e.QSM,t]}]}}),hljs.registerLanguage("mathematica",function(e){return{aliases:["mma"],l:"(\\$|\\b)"+e.IR+"\\b",k:"AbelianGroup Abort AbortKernels AbortProtect Above Abs Absolute AbsoluteCorrelation AbsoluteCorrelationFunction AbsoluteCurrentValue AbsoluteDashing AbsoluteFileName AbsoluteOptions AbsolutePointSize AbsoluteThickness AbsoluteTime AbsoluteTiming AccountingForm Accumulate Accuracy AccuracyGoal ActionDelay ActionMenu ActionMenuBox ActionMenuBoxOptions Active ActiveItem ActiveStyle AcyclicGraphQ AddOnHelpPath AddTo AdjacencyGraph AdjacencyList AdjacencyMatrix AdjustmentBox AdjustmentBoxOptions AdjustTimeSeriesForecast AffineTransform After AiryAi AiryAiPrime AiryAiZero AiryBi AiryBiPrime AiryBiZero AlgebraicIntegerQ AlgebraicNumber AlgebraicNumberDenominator AlgebraicNumberNorm AlgebraicNumberPolynomial AlgebraicNumberTrace AlgebraicRules AlgebraicRulesData Algebraics AlgebraicUnitQ Alignment AlignmentMarker AlignmentPoint All AllowedDimensions AllowGroupClose AllowInlineCells AllowKernelInitialization AllowReverseGroupClose AllowScriptLevelChange AlphaChannel AlternatingGroup AlternativeHypothesis Alternatives AmbientLight Analytic AnchoredSearch And AndersonDarlingTest AngerJ AngleBracket AngularGauge Animate AnimationCycleOffset AnimationCycleRepetitions AnimationDirection AnimationDisplayTime AnimationRate AnimationRepetitions AnimationRunning Animator AnimatorBox AnimatorBoxOptions AnimatorElements Annotation Annuity AnnuityDue Antialiasing Antisymmetric Apart ApartSquareFree Appearance AppearanceElements AppellF1 Append AppendTo Apply ArcCos ArcCosh ArcCot ArcCoth ArcCsc ArcCsch ArcSec ArcSech ArcSin ArcSinDistribution ArcSinh ArcTan ArcTanh Arg ArgMax ArgMin ArgumentCountQ ARIMAProcess ArithmeticGeometricMean ARMAProcess ARProcess Array ArrayComponents ArrayDepth ArrayFlatten ArrayPad ArrayPlot ArrayQ ArrayReshape ArrayRules Arrays Arrow Arrow3DBox ArrowBox Arrowheads AspectRatio AspectRatioFixed Assert Assuming Assumptions AstronomicalData Asynchronous AsynchronousTaskObject AsynchronousTasks AtomQ Attributes AugmentedSymmetricPolynomial AutoAction AutoDelete AutoEvaluateEvents AutoGeneratedPackage AutoIndent AutoIndentSpacings AutoItalicWords AutoloadPath AutoMatch Automatic AutomaticImageSize AutoMultiplicationSymbol AutoNumberFormatting AutoOpenNotebooks AutoOpenPalettes AutorunSequencing AutoScaling AutoScroll AutoSpacing AutoStyleOptions AutoStyleWords Axes AxesEdge AxesLabel AxesOrigin AxesStyle Axis BabyMonsterGroupB Back Background BackgroundTasksSettings Backslash Backsubstitution Backward Band BandpassFilter BandstopFilter BarabasiAlbertGraphDistribution BarChart BarChart3D BarLegend BarlowProschanImportance BarnesG BarOrigin BarSpacing BartlettHannWindow BartlettWindow BaseForm Baseline BaselinePosition BaseStyle BatesDistribution BattleLemarieWavelet Because BeckmannDistribution Beep Before Begin BeginDialogPacket BeginFrontEndInteractionPacket BeginPackage BellB BellY Below BenfordDistribution BeniniDistribution BenktanderGibratDistribution BenktanderWeibullDistribution BernoulliB BernoulliDistribution BernoulliGraphDistribution BernoulliProcess BernsteinBasis BesselFilterModel BesselI BesselJ BesselJZero BesselK BesselY BesselYZero Beta BetaBinomialDistribution BetaDistribution BetaNegativeBinomialDistribution BetaPrimeDistribution BetaRegularized BetweennessCentrality BezierCurve BezierCurve3DBox BezierCurve3DBoxOptions BezierCurveBox BezierCurveBoxOptions BezierFunction BilateralFilter Binarize BinaryFormat BinaryImageQ BinaryRead BinaryReadList BinaryWrite BinCounts BinLists Binomial BinomialDistribution BinomialProcess BinormalDistribution BiorthogonalSplineWavelet BipartiteGraphQ BirnbaumImportance BirnbaumSaundersDistribution BitAnd BitClear BitGet BitLength BitNot BitOr BitSet BitShiftLeft BitShiftRight BitXor Black BlackmanHarrisWindow BlackmanNuttallWindow BlackmanWindow Blank BlankForm BlankNullSequence BlankSequence Blend Block BlockRandom BlomqvistBeta BlomqvistBetaTest Blue Blur BodePlot BohmanWindow Bold Bookmarks Boole BooleanConsecutiveFunction BooleanConvert BooleanCountingFunction BooleanFunction BooleanGraph BooleanMaxterms BooleanMinimize BooleanMinterms Booleans BooleanTable BooleanVariables BorderDimensions BorelTannerDistribution Bottom BottomHatTransform BoundaryStyle Bounds Box BoxBaselineShift BoxData BoxDimensions Boxed Boxes BoxForm BoxFormFormatTypes BoxFrame BoxID BoxMargins BoxMatrix BoxRatios BoxRotation BoxRotationPoint BoxStyle BoxWhiskerChart Bra BracketingBar BraKet BrayCurtisDistance BreadthFirstScan Break Brown BrownForsytheTest BrownianBridgeProcess BrowserCategory BSplineBasis BSplineCurve BSplineCurve3DBox BSplineCurveBox BSplineCurveBoxOptions BSplineFunction BSplineSurface BSplineSurface3DBox BubbleChart BubbleChart3D BubbleScale BubbleSizes BulletGauge BusinessDayQ ButterflyGraph ButterworthFilterModel Button ButtonBar ButtonBox ButtonBoxOptions ButtonCell ButtonContents ButtonData ButtonEvaluator ButtonExpandable ButtonFrame ButtonFunction ButtonMargins ButtonMinHeight ButtonNote ButtonNotebook ButtonSource ButtonStyle ButtonStyleMenuListing Byte ByteCount ByteOrdering C CachedValue CacheGraphics CalendarData CalendarType CallPacket CanberraDistance Cancel CancelButton CandlestickChart Cap CapForm CapitalDifferentialD CardinalBSplineBasis CarmichaelLambda Cases Cashflow Casoratian Catalan CatalanNumber Catch CauchyDistribution CauchyWindow CayleyGraph CDF CDFDeploy CDFInformation CDFWavelet Ceiling Cell CellAutoOverwrite CellBaseline CellBoundingBox CellBracketOptions CellChangeTimes CellContents CellContext CellDingbat CellDynamicExpression CellEditDuplicate CellElementsBoundingBox CellElementSpacings CellEpilog CellEvaluationDuplicate CellEvaluationFunction CellEventActions CellFrame CellFrameColor CellFrameLabelMargins CellFrameLabels CellFrameMargins CellGroup CellGroupData CellGrouping CellGroupingRules CellHorizontalScrolling CellID CellLabel CellLabelAutoDelete CellLabelMargins CellLabelPositioning CellMargins CellObject CellOpen CellPrint CellProlog Cells CellSize CellStyle CellTags CellularAutomaton CensoredDistribution Censoring Center CenterDot CentralMoment CentralMomentGeneratingFunction CForm ChampernowneNumber ChanVeseBinarize Character CharacterEncoding CharacterEncodingsPath CharacteristicFunction CharacteristicPolynomial CharacterRange Characters ChartBaseStyle ChartElementData ChartElementDataFunction ChartElementFunction ChartElements ChartLabels ChartLayout ChartLegends ChartStyle Chebyshev1FilterModel Chebyshev2FilterModel ChebyshevDistance ChebyshevT ChebyshevU Check CheckAbort CheckAll Checkbox CheckboxBar CheckboxBox CheckboxBoxOptions ChemicalData ChessboardDistance ChiDistribution ChineseRemainder ChiSquareDistribution ChoiceButtons ChoiceDialog CholeskyDecomposition Chop Circle CircleBox CircleDot CircleMinus CirclePlus CircleTimes CirculantGraph CityData Clear ClearAll ClearAttributes ClearSystemCache ClebschGordan ClickPane Clip ClipboardNotebook ClipFill ClippingStyle ClipPlanes ClipRange Clock ClockGauge ClockwiseContourIntegral Close Closed CloseKernels ClosenessCentrality Closing ClosingAutoSave ClosingEvent ClusteringComponents CMYKColor Coarse Coefficient CoefficientArrays CoefficientDomain CoefficientList CoefficientRules CoifletWavelet Collect Colon ColonForm ColorCombine ColorConvert ColorData ColorDataFunction ColorFunction ColorFunctionScaling Colorize ColorNegate ColorOutput ColorProfileData ColorQuantize ColorReplace ColorRules ColorSelectorSettings ColorSeparate ColorSetter ColorSetterBox ColorSetterBoxOptions ColorSlider ColorSpace Column ColumnAlignments ColumnBackgrounds ColumnForm ColumnLines ColumnsEqual ColumnSpacings ColumnWidths CommonDefaultFormatTypes Commonest CommonestFilter CommonUnits CommunityBoundaryStyle CommunityGraphPlot CommunityLabels CommunityRegionStyle CompatibleUnitQ CompilationOptions CompilationTarget Compile Compiled CompiledFunction Complement CompleteGraph CompleteGraphQ CompleteKaryTree CompletionsListPacket Complex Complexes ComplexExpand ComplexInfinity ComplexityFunction ComponentMeasurements ComponentwiseContextMenu Compose ComposeList ComposeSeries Composition CompoundExpression CompoundPoissonDistribution CompoundPoissonProcess CompoundRenewalProcess Compress CompressedData Condition ConditionalExpression Conditioned Cone ConeBox ConfidenceLevel ConfidenceRange ConfidenceTransform ConfigurationPath Congruent Conjugate ConjugateTranspose Conjunction Connect ConnectedComponents ConnectedGraphQ ConnesWindow ConoverTest ConsoleMessage ConsoleMessagePacket ConsolePrint Constant ConstantArray Constants ConstrainedMax ConstrainedMin ContentPadding ContentsBoundingBox ContentSelectable ContentSize Context ContextMenu Contexts ContextToFilename ContextToFileName Continuation Continue ContinuedFraction ContinuedFractionK ContinuousAction ContinuousMarkovProcess ContinuousTimeModelQ ContinuousWaveletData ContinuousWaveletTransform ContourDetect ContourGraphics ContourIntegral ContourLabels ContourLines ContourPlot ContourPlot3D Contours ContourShading ContourSmoothing ContourStyle ContraharmonicMean Control ControlActive ControlAlignment ControllabilityGramian ControllabilityMatrix ControllableDecomposition ControllableModelQ ControllerDuration ControllerInformation ControllerInformationData ControllerLinking ControllerManipulate ControllerMethod ControllerPath ControllerState ControlPlacement ControlsRendering ControlType Convergents ConversionOptions ConversionRules ConvertToBitmapPacket ConvertToPostScript ConvertToPostScriptPacket Convolve ConwayGroupCo1 ConwayGroupCo2 ConwayGroupCo3 CoordinateChartData CoordinatesToolOptions CoordinateTransform CoordinateTransformData CoprimeQ Coproduct CopulaDistribution Copyable CopyDirectory CopyFile CopyTag CopyToClipboard CornerFilter CornerNeighbors Correlation CorrelationDistance CorrelationFunction CorrelationTest Cos Cosh CoshIntegral CosineDistance CosineWindow CosIntegral Cot Coth Count CounterAssignments CounterBox CounterBoxOptions CounterClockwiseContourIntegral CounterEvaluator CounterFunction CounterIncrements CounterStyle CounterStyleMenuListing CountRoots CountryData Covariance CovarianceEstimatorFunction CovarianceFunction CoxianDistribution CoxIngersollRossProcess CoxModel CoxModelFit CramerVonMisesTest CreateArchive CreateDialog CreateDirectory CreateDocument CreateIntermediateDirectories CreatePalette CreatePalettePacket CreateScheduledTask CreateTemporary CreateWindow CriticalityFailureImportance CriticalitySuccessImportance CriticalSection Cross CrossingDetect CrossMatrix Csc Csch CubeRoot Cubics Cuboid CuboidBox Cumulant CumulantGeneratingFunction Cup CupCap Curl CurlyDoubleQuote CurlyQuote CurrentImage CurrentlySpeakingPacket CurrentValue CurvatureFlowFilter CurveClosed Cyan CycleGraph CycleIndexPolynomial Cycles CyclicGroup Cyclotomic Cylinder CylinderBox CylindricalDecomposition D DagumDistribution DamerauLevenshteinDistance DampingFactor Darker Dashed Dashing DataCompression DataDistribution DataRange DataReversed Date DateDelimiters DateDifference DateFunction DateList DateListLogPlot DateListPlot DatePattern DatePlus DateRange DateString DateTicksFormat DaubechiesWavelet DavisDistribution DawsonF DayCount DayCountConvention DayMatchQ DayName DayPlus DayRange DayRound DeBruijnGraph Debug DebugTag Decimal DeclareKnownSymbols DeclarePackage Decompose Decrement DedekindEta Default DefaultAxesStyle DefaultBaseStyle DefaultBoxStyle DefaultButton DefaultColor DefaultControlPlacement DefaultDuplicateCellStyle DefaultDuration DefaultElement DefaultFaceGridsStyle DefaultFieldHintStyle DefaultFont DefaultFontProperties DefaultFormatType DefaultFormatTypeForStyle DefaultFrameStyle DefaultFrameTicksStyle DefaultGridLinesStyle DefaultInlineFormatType DefaultInputFormatType DefaultLabelStyle DefaultMenuStyle DefaultNaturalLanguage DefaultNewCellStyle DefaultNewInlineCellStyle DefaultNotebook DefaultOptions DefaultOutputFormatType DefaultStyle DefaultStyleDefinitions DefaultTextFormatType DefaultTextInlineFormatType DefaultTicksStyle DefaultTooltipStyle DefaultValues Defer DefineExternal DefineInputStreamMethod DefineOutputStreamMethod Definition Degree DegreeCentrality DegreeGraphDistribution DegreeLexicographic DegreeReverseLexicographic Deinitialization Del Deletable Delete DeleteBorderComponents DeleteCases DeleteContents DeleteDirectory DeleteDuplicates DeleteFile DeleteSmallComponents DeleteWithContents DeletionWarning Delimiter DelimiterFlashTime DelimiterMatching Delimiters Denominator DensityGraphics DensityHistogram DensityPlot DependentVariables Deploy Deployed Depth DepthFirstScan Derivative DerivativeFilter DescriptorStateSpace DesignMatrix Det DGaussianWavelet DiacriticalPositioning Diagonal DiagonalMatrix Dialog DialogIndent DialogInput DialogLevel DialogNotebook DialogProlog DialogReturn DialogSymbols Diamond DiamondMatrix DiceDissimilarity DictionaryLookup DifferenceDelta DifferenceOrder DifferenceRoot DifferenceRootReduce Differences DifferentialD DifferentialRoot DifferentialRootReduce DifferentiatorFilter DigitBlock DigitBlockMinimum DigitCharacter DigitCount DigitQ DihedralGroup Dilation Dimensions DiracComb DiracDelta DirectedEdge DirectedEdges DirectedGraph DirectedGraphQ DirectedInfinity Direction Directive Directory DirectoryName DirectoryQ DirectoryStack DirichletCharacter DirichletConvolve DirichletDistribution DirichletL DirichletTransform DirichletWindow DisableConsolePrintPacket DiscreteChirpZTransform DiscreteConvolve DiscreteDelta DiscreteHadamardTransform DiscreteIndicator DiscreteLQEstimatorGains DiscreteLQRegulatorGains DiscreteLyapunovSolve DiscreteMarkovProcess DiscretePlot DiscretePlot3D DiscreteRatio DiscreteRiccatiSolve DiscreteShift DiscreteTimeModelQ DiscreteUniformDistribution DiscreteVariables DiscreteWaveletData DiscreteWaveletPacketTransform DiscreteWaveletTransform Discriminant Disjunction Disk DiskBox DiskMatrix Dispatch DispersionEstimatorFunction Display DisplayAllSteps DisplayEndPacket DisplayFlushImagePacket DisplayForm DisplayFunction DisplayPacket DisplayRules DisplaySetSizePacket DisplayString DisplayTemporary DisplayWith DisplayWithRef DisplayWithVariable DistanceFunction DistanceTransform Distribute Distributed DistributedContexts DistributeDefinitions DistributionChart DistributionDomain DistributionFitTest DistributionParameterAssumptions DistributionParameterQ Dithering Div Divergence Divide DivideBy Dividers Divisible Divisors DivisorSigma DivisorSum DMSList DMSString Do DockedCells DocumentNotebook DominantColors DOSTextFormat Dot DotDashed DotEqual Dotted DoubleBracketingBar DoubleContourIntegral DoubleDownArrow DoubleLeftArrow DoubleLeftRightArrow DoubleLeftTee DoubleLongLeftArrow DoubleLongLeftRightArrow DoubleLongRightArrow DoubleRightArrow DoubleRightTee DoubleUpArrow DoubleUpDownArrow DoubleVerticalBar DoublyInfinite Down DownArrow DownArrowBar DownArrowUpArrow DownLeftRightVector DownLeftTeeVector DownLeftVector DownLeftVectorBar DownRightTeeVector DownRightVector DownRightVectorBar Downsample DownTee DownTeeArrow DownValues DragAndDrop DrawEdges DrawFrontFaces DrawHighlighted Drop DSolve Dt DualLinearProgramming DualSystemsModel DumpGet DumpSave DuplicateFreeQ Dynamic DynamicBox DynamicBoxOptions DynamicEvaluationTimeout DynamicLocation DynamicModule DynamicModuleBox DynamicModuleBoxOptions DynamicModuleParent DynamicModuleValues DynamicName DynamicNamespace DynamicReference DynamicSetting DynamicUpdating DynamicWrapper DynamicWrapperBox DynamicWrapperBoxOptions E EccentricityCentrality EdgeAdd EdgeBetweennessCentrality EdgeCapacity EdgeCapForm EdgeColor EdgeConnectivity EdgeCost EdgeCount EdgeCoverQ EdgeDashing EdgeDelete EdgeDetect EdgeForm EdgeIndex EdgeJoinForm EdgeLabeling EdgeLabels EdgeLabelStyle EdgeList EdgeOpacity EdgeQ EdgeRenderingFunction EdgeRules EdgeShapeFunction EdgeStyle EdgeThickness EdgeWeight Editable EditButtonSettings EditCellTagsSettings EditDistance EffectiveInterest Eigensystem Eigenvalues EigenvectorCentrality Eigenvectors Element ElementData Eliminate EliminationOrder EllipticE EllipticExp EllipticExpPrime EllipticF EllipticFilterModel EllipticK EllipticLog EllipticNomeQ EllipticPi EllipticReducedHalfPeriods EllipticTheta EllipticThetaPrime EmitSound EmphasizeSyntaxErrors EmpiricalDistribution Empty EmptyGraphQ EnableConsolePrintPacket Enabled Encode End EndAdd EndDialogPacket EndFrontEndInteractionPacket EndOfFile EndOfLine EndOfString EndPackage EngineeringForm Enter EnterExpressionPacket EnterTextPacket Entropy EntropyFilter Environment Epilog Equal EqualColumns EqualRows EqualTilde EquatedTo Equilibrium EquirippleFilterKernel Equivalent Erf Erfc Erfi ErlangB ErlangC ErlangDistribution Erosion ErrorBox ErrorBoxOptions ErrorNorm ErrorPacket ErrorsDialogSettings EstimatedDistribution EstimatedProcess EstimatorGains EstimatorRegulator EuclideanDistance EulerE EulerGamma EulerianGraphQ EulerPhi Evaluatable Evaluate Evaluated EvaluatePacket EvaluationCell EvaluationCompletionAction EvaluationElements EvaluationMode EvaluationMonitor EvaluationNotebook EvaluationObject EvaluationOrder Evaluator EvaluatorNames EvenQ EventData EventEvaluator EventHandler EventHandlerTag EventLabels ExactBlackmanWindow ExactNumberQ ExactRootIsolation ExampleData Except ExcludedForms ExcludePods Exclusions ExclusionsStyle Exists Exit ExitDialog Exp Expand ExpandAll ExpandDenominator ExpandFileName ExpandNumerator Expectation ExpectationE ExpectedValue ExpGammaDistribution ExpIntegralE ExpIntegralEi Exponent ExponentFunction ExponentialDistribution ExponentialFamily ExponentialGeneratingFunction ExponentialMovingAverage ExponentialPowerDistribution ExponentPosition ExponentStep Export ExportAutoReplacements ExportPacket ExportString Expression ExpressionCell ExpressionPacket ExpToTrig ExtendedGCD Extension ExtentElementFunction ExtentMarkers ExtentSize ExternalCall ExternalDataCharacterEncoding Extract ExtractArchive ExtremeValueDistribution FaceForm FaceGrids FaceGridsStyle Factor FactorComplete Factorial Factorial2 FactorialMoment FactorialMomentGeneratingFunction FactorialPower FactorInteger FactorList FactorSquareFree FactorSquareFreeList FactorTerms FactorTermsList Fail FailureDistribution False FARIMAProcess FEDisableConsolePrintPacket FeedbackSector FeedbackSectorStyle FeedbackType FEEnableConsolePrintPacket Fibonacci FieldHint FieldHintStyle FieldMasked FieldSize File FileBaseName FileByteCount FileDate FileExistsQ FileExtension FileFormat FileHash FileInformation FileName FileNameDepth FileNameDialogSettings FileNameDrop FileNameJoin FileNames FileNameSetter FileNameSplit FileNameTake FilePrint FileType FilledCurve FilledCurveBox Filling FillingStyle FillingTransform FilterRules FinancialBond FinancialData FinancialDerivative FinancialIndicator Find FindArgMax FindArgMin FindClique FindClusters FindCurvePath FindDistributionParameters FindDivisions FindEdgeCover FindEdgeCut FindEulerianCycle FindFaces FindFile FindFit FindGeneratingFunction FindGeoLocation FindGeometricTransform FindGraphCommunities FindGraphIsomorphism FindGraphPartition FindHamiltonianCycle FindIndependentEdgeSet FindIndependentVertexSet FindInstance FindIntegerNullVector FindKClan FindKClique FindKClub FindKPlex FindLibrary FindLinearRecurrence FindList FindMaximum FindMaximumFlow FindMaxValue FindMinimum FindMinimumCostFlow FindMinimumCut FindMinValue FindPermutation FindPostmanTour FindProcessParameters FindRoot FindSequenceFunction FindSettings FindShortestPath FindShortestTour FindThreshold FindVertexCover FindVertexCut Fine FinishDynamic FiniteAbelianGroupCount FiniteGroupCount FiniteGroupData First FirstPassageTimeDistribution FischerGroupFi22 FischerGroupFi23 FischerGroupFi24Prime FisherHypergeometricDistribution FisherRatioTest FisherZDistribution Fit FitAll FittedModel FixedPoint FixedPointList FlashSelection Flat Flatten FlattenAt FlatTopWindow FlipView Floor FlushPrintOutputPacket Fold FoldList Font FontColor FontFamily FontForm FontName FontOpacity FontPostScriptName FontProperties FontReencoding FontSize FontSlant FontSubstitutions FontTracking FontVariations FontWeight For ForAll Format FormatRules FormatType FormatTypeAutoConvert FormatValues FormBox FormBoxOptions FortranForm Forward ForwardBackward Fourier FourierCoefficient FourierCosCoefficient FourierCosSeries FourierCosTransform FourierDCT FourierDCTFilter FourierDCTMatrix FourierDST FourierDSTMatrix FourierMatrix FourierParameters FourierSequenceTransform FourierSeries FourierSinCoefficient FourierSinSeries FourierSinTransform FourierTransform FourierTrigSeries FractionalBrownianMotionProcess FractionalPart FractionBox FractionBoxOptions FractionLine Frame FrameBox FrameBoxOptions Framed FrameInset FrameLabel Frameless FrameMargins FrameStyle FrameTicks FrameTicksStyle FRatioDistribution FrechetDistribution FreeQ FrequencySamplingFilterKernel FresnelC FresnelS Friday FrobeniusNumber FrobeniusSolve FromCharacterCode FromCoefficientRules FromContinuedFraction FromDate FromDigits FromDMS Front FrontEndDynamicExpression FrontEndEventActions FrontEndExecute FrontEndObject FrontEndResource FrontEndResourceString FrontEndStackSize FrontEndToken FrontEndTokenExecute FrontEndValueCache FrontEndVersion FrontFaceColor FrontFaceOpacity Full FullAxes FullDefinition FullForm FullGraphics FullOptions FullSimplify Function FunctionExpand FunctionInterpolation FunctionSpace FussellVeselyImportance GaborFilter GaborMatrix GaborWavelet GainMargins GainPhaseMargins Gamma GammaDistribution GammaRegularized GapPenalty Gather GatherBy GaugeFaceElementFunction GaugeFaceStyle GaugeFrameElementFunction GaugeFrameSize GaugeFrameStyle GaugeLabels GaugeMarkers GaugeStyle GaussianFilter GaussianIntegers GaussianMatrix GaussianWindow GCD GegenbauerC General GeneralizedLinearModelFit GenerateConditions GeneratedCell GeneratedParameters GeneratingFunction Generic GenericCylindricalDecomposition GenomeData GenomeLookup GeodesicClosing GeodesicDilation GeodesicErosion GeodesicOpening GeoDestination GeodesyData GeoDirection GeoDistance GeoGridPosition GeometricBrownianMotionProcess GeometricDistribution GeometricMean GeometricMeanFilter GeometricTransformation GeometricTransformation3DBox GeometricTransformation3DBoxOptions GeometricTransformationBox GeometricTransformationBoxOptions GeoPosition GeoPositionENU GeoPositionXYZ GeoProjectionData GestureHandler GestureHandlerTag Get GetBoundingBoxSizePacket GetContext GetEnvironment GetFileName GetFrontEndOptionsDataPacket GetLinebreakInformationPacket GetMenusPacket GetPageBreakInformationPacket Glaisher GlobalClusteringCoefficient GlobalPreferences GlobalSession Glow GoldenRatio GompertzMakehamDistribution GoodmanKruskalGamma GoodmanKruskalGammaTest Goto Grad Gradient GradientFilter GradientOrientationFilter Graph GraphAssortativity GraphCenter GraphComplement GraphData GraphDensity GraphDiameter GraphDifference GraphDisjointUnion GraphDistance GraphDistanceMatrix GraphElementData GraphEmbedding GraphHighlight GraphHighlightStyle GraphHub Graphics Graphics3D Graphics3DBox Graphics3DBoxOptions GraphicsArray GraphicsBaseline GraphicsBox GraphicsBoxOptions GraphicsColor GraphicsColumn GraphicsComplex GraphicsComplex3DBox GraphicsComplex3DBoxOptions GraphicsComplexBox GraphicsComplexBoxOptions GraphicsContents GraphicsData GraphicsGrid GraphicsGridBox GraphicsGroup GraphicsGroup3DBox GraphicsGroup3DBoxOptions GraphicsGroupBox GraphicsGroupBoxOptions GraphicsGrouping GraphicsHighlightColor GraphicsRow GraphicsSpacing GraphicsStyle GraphIntersection GraphLayout GraphLinkEfficiency GraphPeriphery GraphPlot GraphPlot3D GraphPower GraphPropertyDistribution GraphQ GraphRadius GraphReciprocity GraphRoot GraphStyle GraphUnion Gray GrayLevel GreatCircleDistance Greater GreaterEqual GreaterEqualLess GreaterFullEqual GreaterGreater GreaterLess GreaterSlantEqual GreaterTilde Green Grid GridBaseline GridBox GridBoxAlignment GridBoxBackground GridBoxDividers GridBoxFrame GridBoxItemSize GridBoxItemStyle GridBoxOptions GridBoxSpacings GridCreationSettings GridDefaultElement GridElementStyleOptions GridFrame GridFrameMargins GridGraph GridLines GridLinesStyle GroebnerBasis GroupActionBase GroupCentralizer GroupElementFromWord GroupElementPosition GroupElementQ GroupElements GroupElementToWord GroupGenerators GroupMultiplicationTable GroupOrbits GroupOrder GroupPageBreakWithin GroupSetwiseStabilizer GroupStabilizer GroupStabilizerChain Gudermannian GumbelDistribution HaarWavelet HadamardMatrix HalfNormalDistribution HamiltonianGraphQ HammingDistance HammingWindow HankelH1 HankelH2 HankelMatrix HannPoissonWindow HannWindow HaradaNortonGroupHN HararyGraph HarmonicMean HarmonicMeanFilter HarmonicNumber Hash HashTable Haversine HazardFunction Head HeadCompose Heads HeavisideLambda HeavisidePi HeavisideTheta HeldGroupHe HeldPart HelpBrowserLookup HelpBrowserNotebook HelpBrowserSettings HermiteDecomposition HermiteH HermitianMatrixQ HessenbergDecomposition Hessian HexadecimalCharacter Hexahedron HexahedronBox HexahedronBoxOptions HiddenSurface HighlightGraph HighlightImage HighpassFilter HigmanSimsGroupHS HilbertFilter HilbertMatrix Histogram Histogram3D HistogramDistribution HistogramList HistogramTransform HistogramTransformInterpolation HitMissTransform HITSCentrality HodgeDual HoeffdingD HoeffdingDTest Hold HoldAll HoldAllComplete HoldComplete HoldFirst HoldForm HoldPattern HoldRest HolidayCalendar HomeDirectory HomePage Horizontal HorizontalForm HorizontalGauge HorizontalScrollPosition HornerForm HotellingTSquareDistribution HoytDistribution HTMLSave Hue HumpDownHump HumpEqual HurwitzLerchPhi HurwitzZeta HyperbolicDistribution HypercubeGraph HyperexponentialDistribution Hyperfactorial Hypergeometric0F1 Hypergeometric0F1Regularized Hypergeometric1F1 Hypergeometric1F1Regularized Hypergeometric2F1 Hypergeometric2F1Regularized HypergeometricDistribution HypergeometricPFQ HypergeometricPFQRegularized HypergeometricU Hyperlink HyperlinkCreationSettings Hyphenation HyphenationOptions HypoexponentialDistribution HypothesisTestData I Identity IdentityMatrix If IgnoreCase Im Image Image3D Image3DSlices ImageAccumulate ImageAdd ImageAdjust ImageAlign ImageApply ImageAspectRatio ImageAssemble ImageCache ImageCacheValid ImageCapture ImageChannels ImageClip ImageColorSpace ImageCompose ImageConvolve ImageCooccurrence ImageCorners ImageCorrelate ImageCorrespondingPoints ImageCrop ImageData ImageDataPacket ImageDeconvolve ImageDemosaic ImageDifference ImageDimensions ImageDistance ImageEffect ImageFeatureTrack ImageFileApply ImageFileFilter ImageFileScan ImageFilter ImageForestingComponents ImageForwardTransformation ImageHistogram ImageKeypoints ImageLevels ImageLines ImageMargins ImageMarkers ImageMeasurements ImageMultiply ImageOffset ImagePad ImagePadding ImagePartition ImagePeriodogram ImagePerspectiveTransformation ImageQ ImageRangeCache ImageReflect ImageRegion ImageResize ImageResolution ImageRotate ImageRotated ImageScaled ImageScan ImageSize ImageSizeAction ImageSizeCache ImageSizeMultipliers ImageSizeRaw ImageSubtract ImageTake ImageTransformation ImageTrim ImageType ImageValue ImageValuePositions Implies Import ImportAutoReplacements ImportString ImprovementImportance In IncidenceGraph IncidenceList IncidenceMatrix IncludeConstantBasis IncludeFileExtension IncludePods IncludeSingularTerm Increment Indent IndentingNewlineSpacings IndentMaxFraction IndependenceTest IndependentEdgeSetQ IndependentUnit IndependentVertexSetQ Indeterminate IndexCreationOptions Indexed IndexGraph IndexTag Inequality InexactNumberQ InexactNumbers Infinity Infix Information Inherited InheritScope Initialization InitializationCell InitializationCellEvaluation InitializationCellWarning InlineCounterAssignments InlineCounterIncrements InlineRules Inner Inpaint Input InputAliases InputAssumptions InputAutoReplacements InputField InputFieldBox InputFieldBoxOptions InputForm InputGrouping InputNamePacket InputNotebook InputPacket InputSettings InputStream InputString InputStringPacket InputToBoxFormPacket Insert InsertionPointObject InsertResults Inset Inset3DBox Inset3DBoxOptions InsetBox InsetBoxOptions Install InstallService InString Integer IntegerDigits IntegerExponent IntegerLength IntegerPart IntegerPartitions IntegerQ Integers IntegerString Integral Integrate Interactive InteractiveTradingChart Interlaced Interleaving InternallyBalancedDecomposition InterpolatingFunction InterpolatingPolynomial Interpolation InterpolationOrder InterpolationPoints InterpolationPrecision Interpretation InterpretationBox InterpretationBoxOptions InterpretationFunction InterpretTemplate InterquartileRange Interrupt InterruptSettings Intersection Interval IntervalIntersection IntervalMemberQ IntervalUnion Inverse InverseBetaRegularized InverseCDF InverseChiSquareDistribution InverseContinuousWaveletTransform InverseDistanceTransform InverseEllipticNomeQ InverseErf InverseErfc InverseFourier InverseFourierCosTransform InverseFourierSequenceTransform InverseFourierSinTransform InverseFourierTransform InverseFunction InverseFunctions InverseGammaDistribution InverseGammaRegularized InverseGaussianDistribution InverseGudermannian InverseHaversine InverseJacobiCD InverseJacobiCN InverseJacobiCS InverseJacobiDC InverseJacobiDN InverseJacobiDS InverseJacobiNC InverseJacobiND InverseJacobiNS InverseJacobiSC InverseJacobiSD InverseJacobiSN InverseLaplaceTransform InversePermutation InverseRadon InverseSeries InverseSurvivalFunction InverseWaveletTransform InverseWeierstrassP InverseZTransform Invisible InvisibleApplication InvisibleTimes IrreduciblePolynomialQ IsolatingInterval IsomorphicGraphQ IsotopeData Italic Item ItemBox ItemBoxOptions ItemSize ItemStyle ItoProcess JaccardDissimilarity JacobiAmplitude Jacobian JacobiCD JacobiCN JacobiCS JacobiDC JacobiDN JacobiDS JacobiNC JacobiND JacobiNS JacobiP JacobiSC JacobiSD JacobiSN JacobiSymbol JacobiZeta JankoGroupJ1 JankoGroupJ2 JankoGroupJ3 JankoGroupJ4 JarqueBeraALMTest JohnsonDistribution Join Joined JoinedCurve JoinedCurveBox JoinForm JordanDecomposition JordanModelDecomposition K KagiChart KaiserBesselWindow KaiserWindow KalmanEstimator KalmanFilter KarhunenLoeveDecomposition KaryTree KatzCentrality KCoreComponents KDistribution KelvinBei KelvinBer KelvinKei KelvinKer KendallTau KendallTauTest KernelExecute KernelMixtureDistribution KernelObject Kernels Ket Khinchin KirchhoffGraph KirchhoffMatrix KleinInvariantJ KnightTourGraph KnotData KnownUnitQ KolmogorovSmirnovTest KroneckerDelta KroneckerModelDecomposition KroneckerProduct KroneckerSymbol KuiperTest KumaraswamyDistribution Kurtosis KuwaharaFilter Label Labeled LabeledSlider LabelingFunction LabelStyle LaguerreL LambdaComponents LambertW LanczosWindow LandauDistribution Language LanguageCategory LaplaceDistribution LaplaceTransform Laplacian LaplacianFilter LaplacianGaussianFilter Large Larger Last Latitude LatitudeLongitude LatticeData LatticeReduce Launch LaunchKernels LayeredGraphPlot LayerSizeFunction LayoutInformation LCM LeafCount LeapYearQ LeastSquares LeastSquaresFilterKernel Left LeftArrow LeftArrowBar LeftArrowRightArrow LeftDownTeeVector LeftDownVector LeftDownVectorBar LeftRightArrow LeftRightVector LeftTee LeftTeeArrow LeftTeeVector LeftTriangle LeftTriangleBar LeftTriangleEqual LeftUpDownVector LeftUpTeeVector LeftUpVector LeftUpVectorBar LeftVector LeftVectorBar LegendAppearance Legended LegendFunction LegendLabel LegendLayout LegendMargins LegendMarkers LegendMarkerSize LegendreP LegendreQ LegendreType Length LengthWhile LerchPhi Less LessEqual LessEqualGreater LessFullEqual LessGreater LessLess LessSlantEqual LessTilde LetterCharacter LetterQ Level LeveneTest LeviCivitaTensor LevyDistribution Lexicographic LibraryFunction LibraryFunctionError LibraryFunctionInformation LibraryFunctionLoad LibraryFunctionUnload LibraryLoad LibraryUnload LicenseID LiftingFilterData LiftingWaveletTransform LightBlue LightBrown LightCyan Lighter LightGray LightGreen Lighting LightingAngle LightMagenta LightOrange LightPink LightPurple LightRed LightSources LightYellow Likelihood Limit LimitsPositioning LimitsPositioningTokens LindleyDistribution Line Line3DBox LinearFilter LinearFractionalTransform LinearModelFit LinearOffsetFunction LinearProgramming LinearRecurrence LinearSolve LinearSolveFunction LineBox LineBreak LinebreakAdjustments LineBreakChart LineBreakWithin LineColor LineForm LineGraph LineIndent LineIndentMaxFraction LineIntegralConvolutionPlot LineIntegralConvolutionScale LineLegend LineOpacity LineSpacing LineWrapParts LinkActivate LinkClose LinkConnect LinkConnectedQ LinkCreate LinkError LinkFlush LinkFunction LinkHost LinkInterrupt LinkLaunch LinkMode LinkObject LinkOpen LinkOptions LinkPatterns LinkProtocol LinkRead LinkReadHeld LinkReadyQ Links LinkWrite LinkWriteHeld LiouvilleLambda List Listable ListAnimate ListContourPlot ListContourPlot3D ListConvolve ListCorrelate ListCurvePathPlot ListDeconvolve ListDensityPlot Listen ListFourierSequenceTransform ListInterpolation ListLineIntegralConvolutionPlot ListLinePlot ListLogLinearPlot ListLogLogPlot ListLogPlot ListPicker ListPickerBox ListPickerBoxBackground ListPickerBoxOptions ListPlay ListPlot ListPlot3D ListPointPlot3D ListPolarPlot ListQ ListStreamDensityPlot ListStreamPlot ListSurfacePlot3D ListVectorDensityPlot ListVectorPlot ListVectorPlot3D ListZTransform Literal LiteralSearch LocalClusteringCoefficient LocalizeVariables LocationEquivalenceTest LocationTest Locator LocatorAutoCreate LocatorBox LocatorBoxOptions LocatorCentering LocatorPane LocatorPaneBox LocatorPaneBoxOptions LocatorRegion Locked Log Log10 Log2 LogBarnesG LogGamma LogGammaDistribution LogicalExpand LogIntegral LogisticDistribution LogitModelFit LogLikelihood LogLinearPlot LogLogisticDistribution LogLogPlot LogMultinormalDistribution LogNormalDistribution LogPlot LogRankTest LogSeriesDistribution LongEqual Longest LongestAscendingSequence LongestCommonSequence LongestCommonSequencePositions LongestCommonSubsequence LongestCommonSubsequencePositions LongestMatch LongForm Longitude LongLeftArrow LongLeftRightArrow LongRightArrow Loopback LoopFreeGraphQ LowerCaseQ LowerLeftArrow LowerRightArrow LowerTriangularize LowpassFilter LQEstimatorGains LQGRegulator LQOutputRegulatorGains LQRegulatorGains LUBackSubstitution LucasL LuccioSamiComponents LUDecomposition LyapunovSolve LyonsGroupLy MachineID MachineName MachineNumberQ MachinePrecision MacintoshSystemPageSetup Magenta Magnification Magnify MainSolve MaintainDynamicCaches Majority MakeBoxes MakeExpression MakeRules MangoldtLambda ManhattanDistance Manipulate Manipulator MannWhitneyTest MantissaExponent Manual Map MapAll MapAt MapIndexed MAProcess MapThread MarcumQ MardiaCombinedTest MardiaKurtosisTest MardiaSkewnessTest MarginalDistribution MarkovProcessProperties Masking MatchingDissimilarity MatchLocalNameQ MatchLocalNames MatchQ Material MathematicaNotation MathieuC MathieuCharacteristicA MathieuCharacteristicB MathieuCharacteristicExponent MathieuCPrime MathieuGroupM11 MathieuGroupM12 MathieuGroupM22 MathieuGroupM23 MathieuGroupM24 MathieuS MathieuSPrime MathMLForm MathMLText Matrices MatrixExp MatrixForm MatrixFunction MatrixLog MatrixPlot MatrixPower MatrixQ MatrixRank Max MaxBend MaxDetect MaxExtraBandwidths MaxExtraConditions MaxFeatures MaxFilter Maximize MaxIterations MaxMemoryUsed MaxMixtureKernels MaxPlotPoints MaxPoints MaxRecursion MaxStableDistribution MaxStepFraction MaxSteps MaxStepSize MaxValue MaxwellDistribution McLaughlinGroupMcL Mean MeanClusteringCoefficient MeanDegreeConnectivity MeanDeviation MeanFilter MeanGraphDistance MeanNeighborDegree MeanShift MeanShiftFilter Median MedianDeviation MedianFilter Medium MeijerG MeixnerDistribution MemberQ MemoryConstrained MemoryInUse Menu MenuAppearance MenuCommandKey MenuEvaluator MenuItem MenuPacket MenuSortingValue MenuStyle MenuView MergeDifferences Mesh MeshFunctions MeshRange MeshShading MeshStyle Message MessageDialog MessageList MessageName MessageOptions MessagePacket Messages MessagesNotebook MetaCharacters MetaInformation Method MethodOptions MexicanHatWavelet MeyerWavelet Min MinDetect MinFilter MinimalPolynomial MinimalStateSpaceModel Minimize Minors MinRecursion MinSize MinStableDistribution Minus MinusPlus MinValue Missing MissingDataMethod MittagLefflerE MixedRadix MixedRadixQuantity MixtureDistribution Mod Modal Mode Modular ModularLambda Module Modulus MoebiusMu Moment Momentary MomentConvert MomentEvaluate MomentGeneratingFunction Monday Monitor MonomialList MonomialOrder MonsterGroupM MorletWavelet MorphologicalBinarize MorphologicalBranchPoints MorphologicalComponents MorphologicalEulerNumber MorphologicalGraph MorphologicalPerimeter MorphologicalTransform Most MouseAnnotation MouseAppearance MouseAppearanceTag MouseButtons Mouseover MousePointerNote MousePosition MovingAverage MovingMedian MoyalDistribution MultiedgeStyle MultilaunchWarning MultiLetterItalics MultiLetterStyle MultilineFunction Multinomial MultinomialDistribution MultinormalDistribution MultiplicativeOrder Multiplicity Multiselection MultivariateHypergeometricDistribution MultivariatePoissonDistribution MultivariateTDistribution N NakagamiDistribution NameQ Names NamespaceBox Nand NArgMax NArgMin NBernoulliB NCache NDSolve NDSolveValue Nearest NearestFunction NeedCurrentFrontEndPackagePacket NeedCurrentFrontEndSymbolsPacket NeedlemanWunschSimilarity Needs Negative NegativeBinomialDistribution NegativeMultinomialDistribution NeighborhoodGraph Nest NestedGreaterGreater NestedLessLess NestedScriptRules NestList NestWhile NestWhileList NevilleThetaC NevilleThetaD NevilleThetaN NevilleThetaS NewPrimitiveStyle NExpectation Next NextPrime NHoldAll NHoldFirst NHoldRest NicholsGridLines NicholsPlot NIntegrate NMaximize NMaxValue NMinimize NMinValue NominalVariables NonAssociative NoncentralBetaDistribution NoncentralChiSquareDistribution NoncentralFRatioDistribution NoncentralStudentTDistribution NonCommutativeMultiply NonConstants None NonlinearModelFit NonlocalMeansFilter NonNegative NonPositive Nor NorlundB Norm Normal NormalDistribution NormalGrouping Normalize NormalizedSquaredEuclideanDistance NormalsFunction NormFunction Not NotCongruent NotCupCap NotDoubleVerticalBar Notebook NotebookApply NotebookAutoSave NotebookClose NotebookConvertSettings NotebookCreate NotebookCreateReturnObject NotebookDefault NotebookDelete NotebookDirectory NotebookDynamicExpression NotebookEvaluate NotebookEventActions NotebookFileName NotebookFind NotebookFindReturnObject NotebookGet NotebookGetLayoutInformationPacket NotebookGetMisspellingsPacket NotebookInformation NotebookInterfaceObject NotebookLocate NotebookObject NotebookOpen NotebookOpenReturnObject NotebookPath NotebookPrint NotebookPut NotebookPutReturnObject NotebookRead NotebookResetGeneratedCells Notebooks NotebookSave NotebookSaveAs NotebookSelection NotebookSetupLayoutInformationPacket NotebooksMenu NotebookWrite NotElement NotEqualTilde NotExists NotGreater NotGreaterEqual NotGreaterFullEqual NotGreaterGreater NotGreaterLess NotGreaterSlantEqual NotGreaterTilde NotHumpDownHump NotHumpEqual NotLeftTriangle NotLeftTriangleBar NotLeftTriangleEqual NotLess NotLessEqual NotLessFullEqual NotLessGreater NotLessLess NotLessSlantEqual NotLessTilde NotNestedGreaterGreater NotNestedLessLess NotPrecedes NotPrecedesEqual NotPrecedesSlantEqual NotPrecedesTilde NotReverseElement NotRightTriangle NotRightTriangleBar NotRightTriangleEqual NotSquareSubset NotSquareSubsetEqual NotSquareSuperset NotSquareSupersetEqual NotSubset NotSubsetEqual NotSucceeds NotSucceedsEqual NotSucceedsSlantEqual NotSucceedsTilde NotSuperset NotSupersetEqual NotTilde NotTildeEqual NotTildeFullEqual NotTildeTilde NotVerticalBar NProbability NProduct NProductFactors NRoots NSolve NSum NSumTerms Null NullRecords NullSpace NullWords Number NumberFieldClassNumber NumberFieldDiscriminant NumberFieldFundamentalUnits NumberFieldIntegralBasis NumberFieldNormRepresentatives NumberFieldRegulator NumberFieldRootsOfUnity NumberFieldSignature NumberForm NumberFormat NumberMarks NumberMultiplier NumberPadding NumberPoint NumberQ NumberSeparator NumberSigns NumberString Numerator NumericFunction NumericQ NuttallWindow NValues NyquistGridLines NyquistPlot O ObservabilityGramian ObservabilityMatrix ObservableDecomposition ObservableModelQ OddQ Off Offset OLEData On ONanGroupON OneIdentity Opacity Open OpenAppend Opener OpenerBox OpenerBoxOptions OpenerView OpenFunctionInspectorPacket Opening OpenRead OpenSpecialOptions OpenTemporary OpenWrite Operate OperatingSystem OptimumFlowData Optional OptionInspectorSettings OptionQ Options OptionsPacket OptionsPattern OptionValue OptionValueBox OptionValueBoxOptions Or Orange Order OrderDistribution OrderedQ Ordering Orderless OrnsteinUhlenbeckProcess Orthogonalize Out Outer OutputAutoOverwrite OutputControllabilityMatrix OutputControllableModelQ OutputForm OutputFormData OutputGrouping OutputMathEditExpression OutputNamePacket OutputResponse OutputSizeLimit OutputStream Over OverBar OverDot Overflow OverHat Overlaps Overlay OverlayBox OverlayBoxOptions Overscript OverscriptBox OverscriptBoxOptions OverTilde OverVector OwenT OwnValues PackingMethod PaddedForm Padding PadeApproximant PadLeft PadRight PageBreakAbove PageBreakBelow PageBreakWithin PageFooterLines PageFooters PageHeaderLines PageHeaders PageHeight PageRankCentrality PageWidth PairedBarChart PairedHistogram PairedSmoothHistogram PairedTTest PairedZTest PaletteNotebook PalettePath Pane PaneBox PaneBoxOptions Panel PanelBox PanelBoxOptions Paneled PaneSelector PaneSelectorBox PaneSelectorBoxOptions PaperWidth ParabolicCylinderD ParagraphIndent ParagraphSpacing ParallelArray ParallelCombine ParallelDo ParallelEvaluate Parallelization Parallelize ParallelMap ParallelNeeds ParallelProduct ParallelSubmit ParallelSum ParallelTable ParallelTry Parameter ParameterEstimator ParameterMixtureDistribution ParameterVariables ParametricFunction ParametricNDSolve ParametricNDSolveValue ParametricPlot ParametricPlot3D ParentConnect ParentDirectory ParentForm Parenthesize ParentList ParetoDistribution Part PartialCorrelationFunction PartialD ParticleData Partition PartitionsP PartitionsQ ParzenWindow PascalDistribution PassEventsDown PassEventsUp Paste PasteBoxFormInlineCells PasteButton Path PathGraph PathGraphQ Pattern PatternSequence PatternTest PauliMatrix PaulWavelet Pause PausedTime PDF PearsonChiSquareTest PearsonCorrelationTest PearsonDistribution PerformanceGoal PeriodicInterpolation Periodogram PeriodogramArray PermutationCycles PermutationCyclesQ PermutationGroup PermutationLength PermutationList PermutationListQ PermutationMax PermutationMin PermutationOrder PermutationPower PermutationProduct PermutationReplace Permutations PermutationSupport Permute PeronaMalikFilter Perpendicular PERTDistribution PetersenGraph PhaseMargins Pi Pick PIDData PIDDerivativeFilter PIDFeedforward PIDTune Piecewise PiecewiseExpand PieChart PieChart3D PillaiTrace PillaiTraceTest Pink Pivoting PixelConstrained PixelValue PixelValuePositions Placed Placeholder PlaceholderReplace Plain PlanarGraphQ Play PlayRange Plot Plot3D Plot3Matrix PlotDivision PlotJoined PlotLabel PlotLayout PlotLegends PlotMarkers PlotPoints PlotRange PlotRangeClipping PlotRangePadding PlotRegion PlotStyle Plus PlusMinus Pochhammer PodStates PodWidth Point Point3DBox PointBox PointFigureChart PointForm PointLegend PointSize PoissonConsulDistribution PoissonDistribution PoissonProcess PoissonWindow PolarAxes PolarAxesOrigin PolarGridLines PolarPlot PolarTicks PoleZeroMarkers PolyaAeppliDistribution PolyGamma Polygon Polygon3DBox Polygon3DBoxOptions PolygonBox PolygonBoxOptions PolygonHoleScale PolygonIntersections PolygonScale PolyhedronData PolyLog PolynomialExtendedGCD PolynomialForm PolynomialGCD PolynomialLCM PolynomialMod PolynomialQ PolynomialQuotient PolynomialQuotientRemainder PolynomialReduce PolynomialRemainder Polynomials PopupMenu PopupMenuBox PopupMenuBoxOptions PopupView PopupWindow Position Positive PositiveDefiniteMatrixQ PossibleZeroQ Postfix PostScript Power PowerDistribution PowerExpand PowerMod PowerModList PowerSpectralDensity PowersRepresentations PowerSymmetricPolynomial Precedence PrecedenceForm Precedes PrecedesEqual PrecedesSlantEqual PrecedesTilde Precision PrecisionGoal PreDecrement PredictionRoot PreemptProtect PreferencesPath Prefix PreIncrement Prepend PrependTo PreserveImageOptions Previous PriceGraphDistribution PrimaryPlaceholder Prime PrimeNu PrimeOmega PrimePi PrimePowerQ PrimeQ Primes PrimeZetaP PrimitiveRoot PrincipalComponents PrincipalValue Print PrintAction PrintForm PrintingCopies PrintingOptions PrintingPageRange PrintingStartingPageNumber PrintingStyleEnvironment PrintPrecision PrintTemporary Prism PrismBox PrismBoxOptions PrivateCellOptions PrivateEvaluationOptions PrivateFontOptions PrivateFrontEndOptions PrivateNotebookOptions PrivatePaths Probability ProbabilityDistribution ProbabilityPlot ProbabilityPr ProbabilityScalePlot ProbitModelFit ProcessEstimator ProcessParameterAssumptions ProcessParameterQ ProcessStateDomain ProcessTimeDomain Product ProductDistribution ProductLog ProgressIndicator ProgressIndicatorBox ProgressIndicatorBoxOptions Projection Prolog PromptForm Properties Property PropertyList PropertyValue Proportion Proportional Protect Protected ProteinData Pruning PseudoInverse Purple Put PutAppend Pyramid PyramidBox PyramidBoxOptions QBinomial QFactorial QGamma QHypergeometricPFQ QPochhammer QPolyGamma QRDecomposition QuadraticIrrationalQ Quantile QuantilePlot Quantity QuantityForm QuantityMagnitude QuantityQ QuantityUnit Quartics QuartileDeviation Quartiles QuartileSkewness QueueingNetworkProcess QueueingProcess QueueProperties Quiet Quit Quotient QuotientRemainder RadialityCentrality RadicalBox RadicalBoxOptions RadioButton RadioButtonBar RadioButtonBox RadioButtonBoxOptions Radon RamanujanTau RamanujanTauL RamanujanTauTheta RamanujanTauZ Random RandomChoice RandomComplex RandomFunction RandomGraph RandomImage RandomInteger RandomPermutation RandomPrime RandomReal RandomSample RandomSeed RandomVariate RandomWalkProcess Range RangeFilter RangeSpecification RankedMax RankedMin Raster Raster3D Raster3DBox Raster3DBoxOptions RasterArray RasterBox RasterBoxOptions Rasterize RasterSize Rational RationalFunctions Rationalize Rationals Ratios Raw RawArray RawBoxes RawData RawMedium RayleighDistribution Re Read ReadList ReadProtected Real RealBlockDiagonalForm RealDigits RealExponent Reals Reap Record RecordLists RecordSeparators Rectangle RectangleBox RectangleBoxOptions RectangleChart RectangleChart3D RecurrenceFilter RecurrenceTable RecurringDigitsForm Red Reduce RefBox ReferenceLineStyle ReferenceMarkers ReferenceMarkerStyle Refine ReflectionMatrix ReflectionTransform Refresh RefreshRate RegionBinarize RegionFunction RegionPlot RegionPlot3D RegularExpression Regularization Reinstall Release ReleaseHold ReliabilityDistribution ReliefImage ReliefPlot Remove RemoveAlphaChannel RemoveAsynchronousTask Removed RemoveInputStreamMethod RemoveOutputStreamMethod RemoveProperty RemoveScheduledTask RenameDirectory RenameFile RenderAll RenderingOptions RenewalProcess RenkoChart Repeated RepeatedNull RepeatedString Replace ReplaceAll ReplaceHeldPart ReplaceImageValue ReplaceList ReplacePart ReplacePixelValue ReplaceRepeated Resampling Rescale RescalingTransform ResetDirectory ResetMenusPacket ResetScheduledTask Residue Resolve Rest Resultant ResumePacket Return ReturnExpressionPacket ReturnInputFormPacket ReturnPacket ReturnTextPacket Reverse ReverseBiorthogonalSplineWavelet ReverseElement ReverseEquilibrium ReverseGraph ReverseUpEquilibrium RevolutionAxis RevolutionPlot3D RGBColor RiccatiSolve RiceDistribution RidgeFilter RiemannR RiemannSiegelTheta RiemannSiegelZ Riffle Right RightArrow RightArrowBar RightArrowLeftArrow RightCosetRepresentative RightDownTeeVector RightDownVector RightDownVectorBar RightTee RightTeeArrow RightTeeVector RightTriangle RightTriangleBar RightTriangleEqual RightUpDownVector RightUpTeeVector RightUpVector RightUpVectorBar RightVector RightVectorBar RiskAchievementImportance RiskReductionImportance RogersTanimotoDissimilarity Root RootApproximant RootIntervals RootLocusPlot RootMeanSquare RootOfUnityQ RootReduce Roots RootSum Rotate RotateLabel RotateLeft RotateRight RotationAction RotationBox RotationBoxOptions RotationMatrix RotationTransform Round RoundImplies RoundingRadius Row RowAlignments RowBackgrounds RowBox RowHeights RowLines RowMinHeight RowReduce RowsEqual RowSpacings RSolve RudvalisGroupRu Rule RuleCondition RuleDelayed RuleForm RulerUnits Run RunScheduledTask RunThrough RuntimeAttributes RuntimeOptions RussellRaoDissimilarity SameQ SameTest SampleDepth SampledSoundFunction SampledSoundList SampleRate SamplingPeriod SARIMAProcess SARMAProcess SatisfiabilityCount SatisfiabilityInstances SatisfiableQ Saturday Save Saveable SaveAutoDelete SaveDefinitions SawtoothWave Scale Scaled ScaleDivisions ScaledMousePosition ScaleOrigin ScalePadding ScaleRanges ScaleRangeStyle ScalingFunctions ScalingMatrix ScalingTransform Scan ScheduledTaskActiveQ ScheduledTaskData ScheduledTaskObject ScheduledTasks SchurDecomposition ScientificForm ScreenRectangle ScreenStyleEnvironment ScriptBaselineShifts ScriptLevel ScriptMinSize ScriptRules ScriptSizeMultipliers Scrollbars ScrollingOptions ScrollPosition Sec Sech SechDistribution SectionGrouping SectorChart SectorChart3D SectorOrigin SectorSpacing SeedRandom Select Selectable SelectComponents SelectedCells SelectedNotebook Selection SelectionAnimate SelectionCell SelectionCellCreateCell SelectionCellDefaultStyle SelectionCellParentStyle SelectionCreateCell SelectionDebuggerTag SelectionDuplicateCell SelectionEvaluate SelectionEvaluateCreateCell SelectionMove SelectionPlaceholder SelectionSetStyle SelectWithContents SelfLoops SelfLoopStyle SemialgebraicComponentInstances SendMail Sequence SequenceAlignment SequenceForm SequenceHold SequenceLimit Series SeriesCoefficient SeriesData SessionTime Set SetAccuracy SetAlphaChannel SetAttributes Setbacks SetBoxFormNamesPacket SetDelayed SetDirectory SetEnvironment SetEvaluationNotebook SetFileDate SetFileLoadingContext SetNotebookStatusLine SetOptions SetOptionsPacket SetPrecision SetProperty SetSelectedNotebook SetSharedFunction SetSharedVariable SetSpeechParametersPacket SetStreamPosition SetSystemOptions Setter SetterBar SetterBox SetterBoxOptions Setting SetValue Shading Shallow ShannonWavelet ShapiroWilkTest Share Sharpen ShearingMatrix ShearingTransform ShenCastanMatrix Short ShortDownArrow Shortest ShortestMatch ShortestPathFunction ShortLeftArrow ShortRightArrow ShortUpArrow Show ShowAutoStyles ShowCellBracket ShowCellLabel ShowCellTags ShowClosedCellArea ShowContents ShowControls ShowCursorTracker ShowGroupOpenCloseIcon ShowGroupOpener ShowInvisibleCharacters ShowPageBreaks ShowPredictiveInterface ShowSelection ShowShortBoxForm ShowSpecialCharacters ShowStringCharacters ShowSyntaxStyles ShrinkingDelay ShrinkWrapBoundingBox SiegelTheta SiegelTukeyTest Sign Signature SignedRankTest SignificanceLevel SignPadding SignTest SimilarityRules SimpleGraph SimpleGraphQ Simplify Sin Sinc SinghMaddalaDistribution SingleEvaluation SingleLetterItalics SingleLetterStyle SingularValueDecomposition SingularValueList SingularValuePlot SingularValues Sinh SinhIntegral SinIntegral SixJSymbol Skeleton SkeletonTransform SkellamDistribution Skewness SkewNormalDistribution Skip SliceDistribution Slider Slider2D Slider2DBox Slider2DBoxOptions SliderBox SliderBoxOptions SlideView Slot SlotSequence Small SmallCircle Smaller SmithDelayCompensator SmithWatermanSimilarity SmoothDensityHistogram SmoothHistogram SmoothHistogram3D SmoothKernelDistribution SocialMediaData Socket SokalSneathDissimilarity Solve SolveAlways SolveDelayed Sort SortBy Sound SoundAndGraphics SoundNote SoundVolume Sow Space SpaceForm Spacer Spacings Span SpanAdjustments SpanCharacterRounding SpanFromAbove SpanFromBoth SpanFromLeft SpanLineThickness SpanMaxSize SpanMinSize SpanningCharacters SpanSymmetric SparseArray SpatialGraphDistribution Speak SpeakTextPacket SpearmanRankTest SpearmanRho Spectrogram SpectrogramArray Specularity SpellingCorrection SpellingDictionaries SpellingDictionariesPath SpellingOptions SpellingSuggestionsPacket Sphere SphereBox SphericalBesselJ SphericalBesselY SphericalHankelH1 SphericalHankelH2 SphericalHarmonicY SphericalPlot3D SphericalRegion SpheroidalEigenvalue SpheroidalJoiningFactor SpheroidalPS SpheroidalPSPrime SpheroidalQS SpheroidalQSPrime SpheroidalRadialFactor SpheroidalS1 SpheroidalS1Prime SpheroidalS2 SpheroidalS2Prime Splice SplicedDistribution SplineClosed SplineDegree SplineKnots SplineWeights Split SplitBy SpokenString Sqrt SqrtBox SqrtBoxOptions Square SquaredEuclideanDistance SquareFreeQ SquareIntersection SquaresR SquareSubset SquareSubsetEqual SquareSuperset SquareSupersetEqual SquareUnion SquareWave StabilityMargins StabilityMarginsStyle StableDistribution Stack StackBegin StackComplete StackInhibit StandardDeviation StandardDeviationFilter StandardForm Standardize StandbyDistribution Star StarGraph StartAsynchronousTask StartingStepSize StartOfLine StartOfString StartScheduledTask StartupSound StateDimensions StateFeedbackGains StateOutputEstimator StateResponse StateSpaceModel StateSpaceRealization StateSpaceTransform StationaryDistribution StationaryWaveletPacketTransform StationaryWaveletTransform StatusArea StatusCentrality StepMonitor StieltjesGamma StirlingS1 StirlingS2 StopAsynchronousTask StopScheduledTask StrataVariables StratonovichProcess StreamColorFunction StreamColorFunctionScaling StreamDensityPlot StreamPlot StreamPoints StreamPosition Streams StreamScale StreamStyle String StringBreak StringByteCount StringCases StringCount StringDrop StringExpression StringForm StringFormat StringFreeQ StringInsert StringJoin StringLength StringMatchQ StringPosition StringQ StringReplace StringReplaceList StringReplacePart StringReverse StringRotateLeft StringRotateRight StringSkeleton StringSplit StringTake StringToStream StringTrim StripBoxes StripOnInput StripWrapperBoxes StrokeForm StructuralImportance StructuredArray StructuredSelection StruveH StruveL Stub StudentTDistribution Style StyleBox StyleBoxAutoDelete StyleBoxOptions StyleData StyleDefinitions StyleForm StyleKeyMapping StyleMenuListing StyleNameDialogSettings StyleNames StylePrint StyleSheetPath Subfactorial Subgraph SubMinus SubPlus SubresultantPolynomialRemainders SubresultantPolynomials Subresultants Subscript SubscriptBox SubscriptBoxOptions Subscripted Subset SubsetEqual Subsets SubStar Subsuperscript SubsuperscriptBox SubsuperscriptBoxOptions Subtract SubtractFrom SubValues Succeeds SucceedsEqual SucceedsSlantEqual SucceedsTilde SuchThat Sum SumConvergence Sunday SuperDagger SuperMinus SuperPlus Superscript SuperscriptBox SuperscriptBoxOptions Superset SupersetEqual SuperStar Surd SurdForm SurfaceColor SurfaceGraphics SurvivalDistribution SurvivalFunction SurvivalModel SurvivalModelFit SuspendPacket SuzukiDistribution SuzukiGroupSuz SwatchLegend Switch Symbol SymbolName SymletWavelet Symmetric SymmetricGroup SymmetricMatrixQ SymmetricPolynomial SymmetricReduction Symmetrize SymmetrizedArray SymmetrizedArrayRules SymmetrizedDependentComponents SymmetrizedIndependentComponents SymmetrizedReplacePart SynchronousInitialization SynchronousUpdating Syntax SyntaxForm SyntaxInformation SyntaxLength SyntaxPacket SyntaxQ SystemDialogInput SystemException SystemHelpPath SystemInformation SystemInformationData SystemOpen SystemOptions SystemsModelDelay SystemsModelDelayApproximate SystemsModelDelete SystemsModelDimensions SystemsModelExtract SystemsModelFeedbackConnect SystemsModelLabels SystemsModelOrder SystemsModelParallelConnect SystemsModelSeriesConnect SystemsModelStateFeedbackConnect SystemStub Tab TabFilling Table TableAlignments TableDepth TableDirections TableForm TableHeadings TableSpacing TableView TableViewBox TabSpacings TabView TabViewBox TabViewBoxOptions TagBox TagBoxNote TagBoxOptions TaggingRules TagSet TagSetDelayed TagStyle TagUnset Take TakeWhile Tally Tan Tanh TargetFunctions TargetUnits TautologyQ TelegraphProcess TemplateBox TemplateBoxOptions TemplateSlotSequence TemporalData Temporary TemporaryVariable TensorContract TensorDimensions TensorExpand TensorProduct TensorQ TensorRank TensorReduce TensorSymmetry TensorTranspose TensorWedge Tetrahedron TetrahedronBox TetrahedronBoxOptions TeXForm TeXSave Text Text3DBox Text3DBoxOptions TextAlignment TextBand TextBoundingBox TextBox TextCell TextClipboardType TextData TextForm TextJustification TextLine TextPacket TextParagraph TextRecognize TextRendering TextStyle Texture TextureCoordinateFunction TextureCoordinateScaling Therefore ThermometerGauge Thick Thickness Thin Thinning ThisLink ThompsonGroupTh Thread ThreeJSymbol Threshold Through Throw Thumbnail Thursday Ticks TicksStyle Tilde TildeEqual TildeFullEqual TildeTilde TimeConstrained TimeConstraint Times TimesBy TimeSeriesForecast TimeSeriesInvertibility TimeUsed TimeValue TimeZone Timing Tiny TitleGrouping TitsGroupT ToBoxes ToCharacterCode ToColor ToContinuousTimeModel ToDate ToDiscreteTimeModel ToeplitzMatrix ToExpression ToFileName Together Toggle ToggleFalse Toggler TogglerBar TogglerBox TogglerBoxOptions ToHeldExpression ToInvertibleTimeSeries TokenWords Tolerance ToLowerCase ToNumberField TooBig Tooltip TooltipBox TooltipBoxOptions TooltipDelay TooltipStyle Top TopHatTransform TopologicalSort ToRadicals ToRules ToString Total TotalHeight TotalVariationFilter TotalWidth TouchscreenAutoZoom TouchscreenControlPlacement ToUpperCase Tr Trace TraceAbove TraceAction TraceBackward TraceDepth TraceDialog TraceForward TraceInternal TraceLevel TraceOff TraceOn TraceOriginal TracePrint TraceScan TrackedSymbols TradingChart TraditionalForm TraditionalFunctionNotation TraditionalNotation TraditionalOrder TransferFunctionCancel TransferFunctionExpand TransferFunctionFactor TransferFunctionModel TransferFunctionPoles TransferFunctionTransform TransferFunctionZeros TransformationFunction TransformationFunctions TransformationMatrix TransformedDistribution TransformedField Translate TranslationTransform TransparentColor Transpose TreeForm TreeGraph TreeGraphQ TreePlot TrendStyle TriangleWave TriangularDistribution Trig TrigExpand TrigFactor TrigFactorList Trigger TrigReduce TrigToExp TrimmedMean True TrueQ TruncatedDistribution TsallisQExponentialDistribution TsallisQGaussianDistribution TTest Tube TubeBezierCurveBox TubeBezierCurveBoxOptions TubeBox TubeBSplineCurveBox TubeBSplineCurveBoxOptions Tuesday TukeyLambdaDistribution TukeyWindow Tuples TuranGraph TuringMachine Transparent UnateQ Uncompress Undefined UnderBar Underflow Underlined Underoverscript UnderoverscriptBox UnderoverscriptBoxOptions Underscript UnderscriptBox UnderscriptBoxOptions UndirectedEdge UndirectedGraph UndirectedGraphQ UndocumentedTestFEParserPacket UndocumentedTestGetSelectionPacket Unequal Unevaluated UniformDistribution UniformGraphDistribution UniformSumDistribution Uninstall Union UnionPlus Unique UnitBox UnitConvert UnitDimensions Unitize UnitRootTest UnitSimplify UnitStep UnitTriangle UnitVector Unprotect UnsameQ UnsavedVariables Unset UnsetShared UntrackedVariables Up UpArrow UpArrowBar UpArrowDownArrow Update UpdateDynamicObjects UpdateDynamicObjectsSynchronous UpdateInterval UpDownArrow UpEquilibrium UpperCaseQ UpperLeftArrow UpperRightArrow UpperTriangularize Upsample UpSet UpSetDelayed UpTee UpTeeArrow UpValues URL URLFetch URLFetchAsynchronous URLSave URLSaveAsynchronous UseGraphicsRange Using UsingFrontEnd V2Get ValidationLength Value ValueBox ValueBoxOptions ValueForm ValueQ ValuesData Variables Variance VarianceEquivalenceTest VarianceEstimatorFunction VarianceGammaDistribution VarianceTest VectorAngle VectorColorFunction VectorColorFunctionScaling VectorDensityPlot VectorGlyphData VectorPlot VectorPlot3D VectorPoints VectorQ Vectors VectorScale VectorStyle Vee Verbatim Verbose VerboseConvertToPostScriptPacket VerifyConvergence VerifySolutions VerifyTestAssumptions Version VersionNumber VertexAdd VertexCapacity VertexColors VertexComponent VertexConnectivity VertexCoordinateRules VertexCoordinates VertexCorrelationSimilarity VertexCosineSimilarity VertexCount VertexCoverQ VertexDataCoordinates VertexDegree VertexDelete VertexDiceSimilarity VertexEccentricity VertexInComponent VertexInDegree VertexIndex VertexJaccardSimilarity VertexLabeling VertexLabels VertexLabelStyle VertexList VertexNormals VertexOutComponent VertexOutDegree VertexQ VertexRenderingFunction VertexReplace VertexShape VertexShapeFunction VertexSize VertexStyle VertexTextureCoordinates VertexWeight Vertical VerticalBar VerticalForm VerticalGauge VerticalSeparator VerticalSlider VerticalTilde ViewAngle ViewCenter ViewMatrix ViewPoint ViewPointSelectorSettings ViewPort ViewRange ViewVector ViewVertical VirtualGroupData Visible VisibleCell VoigtDistribution VonMisesDistribution WaitAll WaitAsynchronousTask WaitNext WaitUntil WakebyDistribution WalleniusHypergeometricDistribution WaringYuleDistribution WatershedComponents WatsonUSquareTest WattsStrogatzGraphDistribution WaveletBestBasis WaveletFilterCoefficients WaveletImagePlot WaveletListPlot WaveletMapIndexed WaveletMatrixPlot WaveletPhi WaveletPsi WaveletScale WaveletScalogram WaveletThreshold WeaklyConnectedComponents WeaklyConnectedGraphQ WeakStationarity WeatherData WeberE Wedge Wednesday WeibullDistribution WeierstrassHalfPeriods WeierstrassInvariants WeierstrassP WeierstrassPPrime WeierstrassSigma WeierstrassZeta WeightedAdjacencyGraph WeightedAdjacencyMatrix WeightedData WeightedGraphQ Weights WelchWindow WheelGraph WhenEvent Which While White Whitespace WhitespaceCharacter WhittakerM WhittakerW WienerFilter WienerProcess WignerD WignerSemicircleDistribution WilksW WilksWTest WindowClickSelect WindowElements WindowFloating WindowFrame WindowFrameElements WindowMargins WindowMovable WindowOpacity WindowSelected WindowSize WindowStatusArea WindowTitle WindowToolbars WindowWidth With WolframAlpha WolframAlphaDate WolframAlphaQuantity WolframAlphaResult Word WordBoundary WordCharacter WordData WordSearch WordSeparators WorkingPrecision Write WriteString Wronskian XMLElement XMLObject Xnor Xor Yellow YuleDissimilarity ZernikeR ZeroSymmetric ZeroTest ZeroWidthTimes Zeta ZetaZero ZipfDistribution ZTest ZTransform $Aborted $ActivationGroupID $ActivationKey $ActivationUserRegistered $AddOnsDirectory $AssertFunction $Assumptions $AsynchronousTask $BaseDirectory $BatchInput $BatchOutput $BoxForms $ByteOrdering $Canceled $CharacterEncoding $CharacterEncodings $CommandLine $CompilationTarget $ConditionHold $ConfiguredKernels $Context $ContextPath $ControlActiveSetting $CreationDate $CurrentLink $DateStringFormat $DefaultFont $DefaultFrontEnd $DefaultImagingDevice $DefaultPath $Display $DisplayFunction $DistributedContexts $DynamicEvaluation $Echo $Epilog $ExportFormats $Failed $FinancialDataSource $FormatType $FrontEnd $FrontEndSession $GeoLocation $HistoryLength $HomeDirectory $HTTPCookies $IgnoreEOF $ImagingDevices $ImportFormats $InitialDirectory $Input $InputFileName $InputStreamMethods $Inspector $InstallationDate $InstallationDirectory $InterfaceEnvironment $IterationLimit $KernelCount $KernelID $Language $LaunchDirectory $LibraryPath $LicenseExpirationDate $LicenseID $LicenseProcesses $LicenseServer $LicenseSubprocesses $LicenseType $Line $Linked $LinkSupported $LoadedFiles $MachineAddresses $MachineDomain $MachineDomains $MachineEpsilon $MachineID $MachineName $MachinePrecision $MachineType $MaxExtraPrecision $MaxLicenseProcesses $MaxLicenseSubprocesses $MaxMachineNumber $MaxNumber $MaxPiecewiseCases $MaxPrecision $MaxRootDegree $MessageGroups $MessageList $MessagePrePrint $Messages $MinMachineNumber $MinNumber $MinorReleaseNumber $MinPrecision $ModuleNumber $NetworkLicense $NewMessage $NewSymbol $Notebooks $NumberMarks $Off $OperatingSystem $Output $OutputForms $OutputSizeLimit $OutputStreamMethods $Packages $ParentLink $ParentProcessID $PasswordFile $PatchLevelID $Path $PathnameSeparator $PerformanceGoal $PipeSupported $Post $Pre $PreferencesDirectory $PrePrint $PreRead $PrintForms $PrintLiteral $ProcessID $ProcessorCount $ProcessorType $ProductInformation $ProgramName $RandomState $RecursionLimit $ReleaseNumber $RootDirectory $ScheduledTask $ScriptCommandLine $SessionID $SetParentLink $SharedFunctions $SharedVariables $SoundDisplay $SoundDisplayFunction $SuppressInputFormHeads $SynchronousEvaluation $SyntaxHandler $System $SystemCharacterEncoding $SystemID $SystemWordLength $TemporaryDirectory $TemporaryPrefix $TextStyle $TimedOut $TimeUnit $TimeZone $TopDirectory $TraceOff $TraceOn $TracePattern $TracePostAction $TracePreAction $Urgent $UserAddOnsDirectory $UserBaseDirectory $UserDocumentsDirectory $UserName $Version $VersionNumber",
c:[{cN:"comment",b:/\(\*/,e:/\*\)/},e.ASM,e.QSM,e.CNM,{cN:"list",b:/\{/,e:/\}/,i:/:/}]}}),hljs.registerLanguage("matlab",function(e){var t=[e.CNM,{cN:"string",b:"'",e:"'",c:[e.BE,{b:"''"}]}],r={r:0,c:[{cN:"operator",b:/'['\.]*/}]};return{k:{keyword:"break case catch classdef continue else elseif end enumerated events for function global if methods otherwise parfor persistent properties return spmd switch try while",built_in:"sin sind sinh asin asind asinh cos cosd cosh acos acosd acosh tan tand tanh atan atand atan2 atanh sec secd sech asec asecd asech csc cscd csch acsc acscd acsch cot cotd coth acot acotd acoth hypot exp expm1 log log1p log10 log2 pow2 realpow reallog realsqrt sqrt nthroot nextpow2 abs angle complex conj imag real unwrap isreal cplxpair fix floor ceil round mod rem sign airy besselj bessely besselh besseli besselk beta betainc betaln ellipj ellipke erf erfc erfcx erfinv expint gamma gammainc gammaln psi legendre cross dot factor isprime primes gcd lcm rat rats perms nchoosek factorial cart2sph cart2pol pol2cart sph2cart hsv2rgb rgb2hsv zeros ones eye repmat rand randn linspace logspace freqspace meshgrid accumarray size length ndims numel disp isempty isequal isequalwithequalnans cat reshape diag blkdiag tril triu fliplr flipud flipdim rot90 find sub2ind ind2sub bsxfun ndgrid permute ipermute shiftdim circshift squeeze isscalar isvector ans eps realmax realmin pi i inf nan isnan isinf isfinite j why compan gallery hadamard hankel hilb invhilb magic pascal rosser toeplitz vander wilkinson"},i:'(//|"|#|/\\*|\\s+/\\w+)',c:[{cN:"function",bK:"function",e:"$",c:[e.UTM,{cN:"params",b:"\\(",e:"\\)"},{cN:"params",b:"\\[",e:"\\]"}]},{b:/[a-zA-Z_][a-zA-Z_0-9]*'['\.]*/,rB:!0,r:0,c:[{b:/[a-zA-Z_][a-zA-Z_0-9]*/,r:0},r.c[0]]},{cN:"matrix",b:"\\[",e:"\\]",c:t,r:0,starts:r},{cN:"cell",b:"\\{",e:/}/,c:t,r:0,starts:r},{b:/\)/,r:0,starts:r},e.C("^\\s*\\%\\{\\s*$","^\\s*\\%\\}\\s*$"),e.C("\\%","$")].concat(t)}}),hljs.registerLanguage("mel",function(e){return{k:"int float string vector matrix if else switch case default while do for in break continue global proc return about abs addAttr addAttributeEditorNodeHelp addDynamic addNewShelfTab addPP addPanelCategory addPrefixToName advanceToNextDrivenKey affectedNet affects aimConstraint air alias aliasAttr align alignCtx alignCurve alignSurface allViewFit ambientLight angle angleBetween animCone animCurveEditor animDisplay animView annotate appendStringArray applicationName applyAttrPreset applyTake arcLenDimContext arcLengthDimension arclen arrayMapper art3dPaintCtx artAttrCtx artAttrPaintVertexCtx artAttrSkinPaintCtx artAttrTool artBuildPaintMenu artFluidAttrCtx artPuttyCtx artSelectCtx artSetPaintCtx artUserPaintCtx assignCommand assignInputDevice assignViewportFactories attachCurve attachDeviceAttr attachSurface attrColorSliderGrp attrCompatibility attrControlGrp attrEnumOptionMenu attrEnumOptionMenuGrp attrFieldGrp attrFieldSliderGrp attrNavigationControlGrp attrPresetEditWin attributeExists attributeInfo attributeMenu attributeQuery autoKeyframe autoPlace bakeClip bakeFluidShading bakePartialHistory bakeResults bakeSimulation basename basenameEx batchRender bessel bevel bevelPlus binMembership bindSkin blend2 blendShape blendShapeEditor blendShapePanel blendTwoAttr blindDataType boneLattice boundary boxDollyCtx boxZoomCtx bufferCurve buildBookmarkMenu buildKeyframeMenu button buttonManip CBG cacheFile cacheFileCombine cacheFileMerge cacheFileTrack camera cameraView canCreateManip canvas capitalizeString catch catchQuiet ceil changeSubdivComponentDisplayLevel changeSubdivRegion channelBox character characterMap characterOutlineEditor characterize chdir checkBox checkBoxGrp checkDefaultRenderGlobals choice circle circularFillet clamp clear clearCache clip clipEditor clipEditorCurrentTimeCtx clipSchedule clipSchedulerOutliner clipTrimBefore closeCurve closeSurface cluster cmdFileOutput cmdScrollFieldExecuter cmdScrollFieldReporter cmdShell coarsenSubdivSelectionList collision color colorAtPoint colorEditor colorIndex colorIndexSliderGrp colorSliderButtonGrp colorSliderGrp columnLayout commandEcho commandLine commandPort compactHairSystem componentEditor compositingInterop computePolysetVolume condition cone confirmDialog connectAttr connectControl connectDynamic connectJoint connectionInfo constrain constrainValue constructionHistory container containsMultibyte contextInfo control convertFromOldLayers convertIffToPsd convertLightmap convertSolidTx convertTessellation convertUnit copyArray copyFlexor copyKey copySkinWeights cos cpButton cpCache cpClothSet cpCollision cpConstraint cpConvClothToMesh cpForces cpGetSolverAttr cpPanel cpProperty cpRigidCollisionFilter cpSeam cpSetEdit cpSetSolverAttr cpSolver cpSolverTypes cpTool cpUpdateClothUVs createDisplayLayer createDrawCtx createEditor createLayeredPsdFile createMotionField createNewShelf createNode createRenderLayer createSubdivRegion cross crossProduct ctxAbort ctxCompletion ctxEditMode ctxTraverse currentCtx currentTime currentTimeCtx currentUnit curve curveAddPtCtx curveCVCtx curveEPCtx curveEditorCtx curveIntersect curveMoveEPCtx curveOnSurface curveSketchCtx cutKey cycleCheck cylinder dagPose date defaultLightListCheckBox defaultNavigation defineDataServer defineVirtualDevice deformer deg_to_rad delete deleteAttr deleteShadingGroupsAndMaterials deleteShelfTab deleteUI deleteUnusedBrushes delrandstr detachCurve detachDeviceAttr detachSurface deviceEditor devicePanel dgInfo dgdirty dgeval dgtimer dimWhen directKeyCtx directionalLight dirmap dirname disable disconnectAttr disconnectJoint diskCache displacementToPoly displayAffected displayColor displayCull displayLevelOfDetail displayPref displayRGBColor displaySmoothness displayStats displayString displaySurface distanceDimContext distanceDimension doBlur dolly dollyCtx dopeSheetEditor dot dotProduct doubleProfileBirailSurface drag dragAttrContext draggerContext dropoffLocator duplicate duplicateCurve duplicateSurface dynCache dynControl dynExport dynExpression dynGlobals dynPaintEditor dynParticleCtx dynPref dynRelEdPanel dynRelEditor dynamicLoad editAttrLimits editDisplayLayerGlobals editDisplayLayerMembers editRenderLayerAdjustment editRenderLayerGlobals editRenderLayerMembers editor editorTemplate effector emit emitter enableDevice encodeString endString endsWith env equivalent equivalentTol erf error eval evalDeferred evalEcho event exactWorldBoundingBox exclusiveLightCheckBox exec executeForEachObject exists exp expression expressionEditorListen extendCurve extendSurface extrude fcheck fclose feof fflush fgetline fgetword file fileBrowserDialog fileDialog fileExtension fileInfo filetest filletCurve filter filterCurve filterExpand filterStudioImport findAllIntersections findAnimCurves findKeyframe findMenuItem findRelatedSkinCluster finder firstParentOf fitBspline flexor floatEq floatField floatFieldGrp floatScrollBar floatSlider floatSlider2 floatSliderButtonGrp floatSliderGrp floor flow fluidCacheInfo fluidEmitter fluidVoxelInfo flushUndo fmod fontDialog fopen formLayout format fprint frameLayout fread freeFormFillet frewind fromNativePath fwrite gamma gauss geometryConstraint getApplicationVersionAsFloat getAttr getClassification getDefaultBrush getFileList getFluidAttr getInputDeviceRange getMayaPanelTypes getModifiers getPanel getParticleAttr getPluginResource getenv getpid glRender glRenderEditor globalStitch gmatch goal gotoBindPose grabColor gradientControl gradientControlNoAttr graphDollyCtx graphSelectContext graphTrackCtx gravity grid gridLayout group groupObjectsByName HfAddAttractorToAS HfAssignAS HfBuildEqualMap HfBuildFurFiles HfBuildFurImages HfCancelAFR HfConnectASToHF HfCreateAttractor HfDeleteAS HfEditAS HfPerformCreateAS HfRemoveAttractorFromAS HfSelectAttached HfSelectAttractors HfUnAssignAS hardenPointCurve hardware hardwareRenderPanel headsUpDisplay headsUpMessage help helpLine hermite hide hilite hitTest hotBox hotkey hotkeyCheck hsv_to_rgb hudButton hudSlider hudSliderButton hwReflectionMap hwRender hwRenderLoad hyperGraph hyperPanel hyperShade hypot iconTextButton iconTextCheckBox iconTextRadioButton iconTextRadioCollection iconTextScrollList iconTextStaticLabel ikHandle ikHandleCtx ikHandleDisplayScale ikSolver ikSplineHandleCtx ikSystem ikSystemInfo ikfkDisplayMethod illustratorCurves image imfPlugins inheritTransform insertJoint insertJointCtx insertKeyCtx insertKnotCurve insertKnotSurface instance instanceable instancer intField intFieldGrp intScrollBar intSlider intSliderGrp interToUI internalVar intersect iprEngine isAnimCurve isConnected isDirty isParentOf isSameObject isTrue isValidObjectName isValidString isValidUiName isolateSelect itemFilter itemFilterAttr itemFilterRender itemFilterType joint jointCluster jointCtx jointDisplayScale jointLattice keyTangent keyframe keyframeOutliner keyframeRegionCurrentTimeCtx keyframeRegionDirectKeyCtx keyframeRegionDollyCtx keyframeRegionInsertKeyCtx keyframeRegionMoveKeyCtx keyframeRegionScaleKeyCtx keyframeRegionSelectKeyCtx keyframeRegionSetKeyCtx keyframeRegionTrackCtx keyframeStats lassoContext lattice latticeDeformKeyCtx launch launchImageEditor layerButton layeredShaderPort layeredTexturePort layout layoutDialog lightList lightListEditor lightListPanel lightlink lineIntersection linearPrecision linstep listAnimatable listAttr listCameras listConnections listDeviceAttachments listHistory listInputDeviceAxes listInputDeviceButtons listInputDevices listMenuAnnotation listNodeTypes listPanelCategories listRelatives listSets listTransforms listUnselected listerEditor loadFluid loadNewShelf loadPlugin loadPluginLanguageResources loadPrefObjects localizedPanelLabel lockNode loft log longNameOf lookThru ls lsThroughFilter lsType lsUI Mayatomr mag makeIdentity makeLive makePaintable makeRoll makeSingleSurface makeTubeOn makebot manipMoveContext manipMoveLimitsCtx manipOptions manipRotateContext manipRotateLimitsCtx manipScaleContext manipScaleLimitsCtx marker match max memory menu menuBarLayout menuEditor menuItem menuItemToShelf menuSet menuSetPref messageLine min minimizeApp mirrorJoint modelCurrentTimeCtx modelEditor modelPanel mouse movIn movOut move moveIKtoFK moveKeyCtx moveVertexAlongDirection multiProfileBirailSurface mute nParticle nameCommand nameField namespace namespaceInfo newPanelItems newton nodeCast nodeIconButton nodeOutliner nodePreset nodeType noise nonLinear normalConstraint normalize nurbsBoolean nurbsCopyUVSet nurbsCube nurbsEditUV nurbsPlane nurbsSelect nurbsSquare nurbsToPoly nurbsToPolygonsPref nurbsToSubdiv nurbsToSubdivPref nurbsUVSet nurbsViewDirectionVector objExists objectCenter objectLayer objectType objectTypeUI obsoleteProc oceanNurbsPreviewPlane offsetCurve offsetCurveOnSurface offsetSurface openGLExtension openMayaPref optionMenu optionMenuGrp optionVar orbit orbitCtx orientConstraint outlinerEditor outlinerPanel overrideModifier paintEffectsDisplay pairBlend palettePort paneLayout panel panelConfiguration panelHistory paramDimContext paramDimension paramLocator parent parentConstraint particle particleExists particleInstancer particleRenderInfo partition pasteKey pathAnimation pause pclose percent performanceOptions pfxstrokes pickWalk picture pixelMove planarSrf plane play playbackOptions playblast plugAttr plugNode pluginInfo pluginResourceUtil pointConstraint pointCurveConstraint pointLight pointMatrixMult pointOnCurve pointOnSurface pointPosition poleVectorConstraint polyAppend polyAppendFacetCtx polyAppendVertex polyAutoProjection polyAverageNormal polyAverageVertex polyBevel polyBlendColor polyBlindData polyBoolOp polyBridgeEdge polyCacheMonitor polyCheck polyChipOff polyClipboard polyCloseBorder polyCollapseEdge polyCollapseFacet polyColorBlindData polyColorDel polyColorPerVertex polyColorSet polyCompare polyCone polyCopyUV polyCrease polyCreaseCtx polyCreateFacet polyCreateFacetCtx polyCube polyCut polyCutCtx polyCylinder polyCylindricalProjection polyDelEdge polyDelFacet polyDelVertex polyDuplicateAndConnect polyDuplicateEdge polyEditUV polyEditUVShell polyEvaluate polyExtrudeEdge polyExtrudeFacet polyExtrudeVertex polyFlipEdge polyFlipUV polyForceUV polyGeoSampler polyHelix polyInfo polyInstallAction polyLayoutUV polyListComponentConversion polyMapCut polyMapDel polyMapSew polyMapSewMove polyMergeEdge polyMergeEdgeCtx polyMergeFacet polyMergeFacetCtx polyMergeUV polyMergeVertex polyMirrorFace polyMoveEdge polyMoveFacet polyMoveFacetUV polyMoveUV polyMoveVertex polyNormal polyNormalPerVertex polyNormalizeUV polyOptUvs polyOptions polyOutput polyPipe polyPlanarProjection polyPlane polyPlatonicSolid polyPoke polyPrimitive polyPrism polyProjection polyPyramid polyQuad polyQueryBlindData polyReduce polySelect polySelectConstraint polySelectConstraintMonitor polySelectCtx polySelectEditCtx polySeparate polySetToFaceNormal polySewEdge polyShortestPathCtx polySmooth polySoftEdge polySphere polySphericalProjection polySplit polySplitCtx polySplitEdge polySplitRing polySplitVertex polyStraightenUVBorder polySubdivideEdge polySubdivideFacet polyToSubdiv polyTorus polyTransfer polyTriangulate polyUVSet polyUnite polyWedgeFace popen popupMenu pose pow preloadRefEd print progressBar progressWindow projFileViewer projectCurve projectTangent projectionContext projectionManip promptDialog propModCtx propMove psdChannelOutliner psdEditTextureFile psdExport psdTextureFile putenv pwd python querySubdiv quit rad_to_deg radial radioButton radioButtonGrp radioCollection radioMenuItemCollection rampColorPort rand randomizeFollicles randstate rangeControl readTake rebuildCurve rebuildSurface recordAttr recordDevice redo reference referenceEdit referenceQuery refineSubdivSelectionList refresh refreshAE registerPluginResource rehash reloadImage removeJoint removeMultiInstance removePanelCategory rename renameAttr renameSelectionList renameUI render renderGlobalsNode renderInfo renderLayerButton renderLayerParent renderLayerPostProcess renderLayerUnparent renderManip renderPartition renderQualityNode renderSettings renderThumbnailUpdate renderWindowEditor renderWindowSelectContext renderer reorder reorderDeformers requires reroot resampleFluid resetAE resetPfxToPolyCamera resetTool resolutionNode retarget reverseCurve reverseSurface revolve rgb_to_hsv rigidBody rigidSolver roll rollCtx rootOf rot rotate rotationInterpolation roundConstantRadius rowColumnLayout rowLayout runTimeCommand runup sampleImage saveAllShelves saveAttrPreset saveFluid saveImage saveInitialState saveMenu savePrefObjects savePrefs saveShelf saveToolSettings scale scaleBrushBrightness scaleComponents scaleConstraint scaleKey scaleKeyCtx sceneEditor sceneUIReplacement scmh scriptCtx scriptEditorInfo scriptJob scriptNode scriptTable scriptToShelf scriptedPanel scriptedPanelType scrollField scrollLayout sculpt searchPathArray seed selLoadSettings select selectContext selectCurveCV selectKey selectKeyCtx selectKeyframeRegionCtx selectMode selectPref selectPriority selectType selectedNodes selectionConnection separator setAttr setAttrEnumResource setAttrMapping setAttrNiceNameResource setConstraintRestPosition setDefaultShadingGroup setDrivenKeyframe setDynamic setEditCtx setEditor setFluidAttr setFocus setInfinity setInputDeviceMapping setKeyCtx setKeyPath setKeyframe setKeyframeBlendshapeTargetWts setMenuMode setNodeNiceNameResource setNodeTypeFlag setParent setParticleAttr setPfxToPolyCamera setPluginResource setProject setStampDensity setStartupMessage setState setToolTo setUITemplate setXformManip sets shadingConnection shadingGeometryRelCtx shadingLightRelCtx shadingNetworkCompare shadingNode shapeCompare shelfButton shelfLayout shelfTabLayout shellField shortNameOf showHelp showHidden showManipCtx showSelectionInTitle showShadingGroupAttrEditor showWindow sign simplify sin singleProfileBirailSurface size sizeBytes skinCluster skinPercent smoothCurve smoothTangentSurface smoothstep snap2to2 snapKey snapMode snapTogetherCtx snapshot soft softMod softModCtx sort sound soundControl source spaceLocator sphere sphrand spotLight spotLightPreviewPort spreadSheetEditor spring sqrt squareSurface srtContext stackTrace startString startsWith stitchAndExplodeShell stitchSurface stitchSurfacePoints strcmp stringArrayCatenate stringArrayContains stringArrayCount stringArrayInsertAtIndex stringArrayIntersector stringArrayRemove stringArrayRemoveAtIndex stringArrayRemoveDuplicates stringArrayRemoveExact stringArrayToString stringToStringArray strip stripPrefixFromName stroke subdAutoProjection subdCleanTopology subdCollapse subdDuplicateAndConnect subdEditUV subdListComponentConversion subdMapCut subdMapSewMove subdMatchTopology subdMirror subdToBlind subdToPoly subdTransferUVsToCache subdiv subdivCrease subdivDisplaySmoothness substitute substituteAllString substituteGeometry substring surface surfaceSampler surfaceShaderList swatchDisplayPort switchTable symbolButton symbolCheckBox sysFile system tabLayout tan tangentConstraint texLatticeDeformContext texManipContext texMoveContext texMoveUVShellContext texRotateContext texScaleContext texSelectContext texSelectShortestPathCtx texSmudgeUVContext texWinToolCtx text textCurves textField textFieldButtonGrp textFieldGrp textManip textScrollList textToShelf textureDisplacePlane textureHairColor texturePlacementContext textureWindow threadCount threePointArcCtx timeControl timePort timerX toNativePath toggle toggleAxis toggleWindowVisibility tokenize tokenizeList tolerance tolower toolButton toolCollection toolDropped toolHasOptions toolPropertyWindow torus toupper trace track trackCtx transferAttributes transformCompare transformLimits translator trim trunc truncateFluidCache truncateHairCache tumble tumbleCtx turbulence twoPointArcCtx uiRes uiTemplate unassignInputDevice undo undoInfo ungroup uniform unit unloadPlugin untangleUV untitledFileName untrim upAxis updateAE userCtx uvLink uvSnapshot validateShelfName vectorize view2dToolCtx viewCamera viewClipPlane viewFit viewHeadOn viewLookAt viewManip viewPlace viewSet visor volumeAxis vortex waitCursor warning webBrowser webBrowserPrefs whatIs window windowPref wire wireContext workspace wrinkle wrinkleContext writeTake xbmLangPathList xform",i:"</",c:[e.CNM,e.ASM,e.QSM,{cN:"string",b:"`",e:"`",c:[e.BE]},{cN:"variable",v:[{b:"\\$\\d"},{b:"[\\$\\%\\@](\\^\\w\\b|#\\w+|[^\\s\\w{]|{\\w+}|\\w+)"},{b:"\\*(\\^\\w\\b|#\\w+|[^\\s\\w{]|{\\w+}|\\w+)",r:0}]},e.CLCM,e.CBCM]}}),hljs.registerLanguage("mercury",function(e){var t={keyword:"module use_module import_module include_module end_module initialise mutable initialize finalize finalise interface implementation pred mode func type inst solver any_pred any_func is semidet det nondet multi erroneous failure cc_nondet cc_multi typeclass instance where pragma promise external trace atomic or_else require_complete_switch require_det require_semidet require_multi require_nondet require_cc_multi require_cc_nondet require_erroneous require_failure",pragma:"inline no_inline type_spec source_file fact_table obsolete memo loop_check minimal_model terminates does_not_terminate check_termination promise_equivalent_clauses",preprocessor:"foreign_proc foreign_decl foreign_code foreign_type foreign_import_module foreign_export_enum foreign_export foreign_enum may_call_mercury will_not_call_mercury thread_safe not_thread_safe maybe_thread_safe promise_pure promise_semipure tabled_for_io local untrailed trailed attach_to_io_state can_pass_as_mercury_type stable will_not_throw_exception may_modify_trail will_not_modify_trail may_duplicate may_not_duplicate affects_liveness does_not_affect_liveness doesnt_affect_liveness no_sharing unknown_sharing sharing",built_in:"some all not if then else true fail false try catch catch_any semidet_true semidet_false semidet_fail impure_true impure semipure"},r={cN:"label",b:"XXX",e:"$",eW:!0,r:0},a=e.inherit(e.CLCM,{b:"%"}),i=e.inherit(e.CBCM,{r:0});a.c.push(r),i.c.push(r);var n={cN:"number",b:"0'.\\|0[box][0-9a-fA-F]*"},o=e.inherit(e.ASM,{r:0}),s=e.inherit(e.QSM,{r:0}),l={cN:"constant",b:"\\\\[abfnrtv]\\|\\\\x[0-9a-fA-F]*\\\\\\|%[-+# *.0-9]*[dioxXucsfeEgGp]",r:0};s.c.push(l);var c={cN:"built_in",v:[{b:"<=>"},{b:"<=",r:0},{b:"=>",r:0},{b:"/\\\\"},{b:"\\\\/"}]},d={cN:"built_in",v:[{b:":-\\|-->"},{b:"=",r:0}]};return{aliases:["m","moo"],k:t,c:[c,d,a,i,n,e.NM,o,s,{b:/:-/}]}}),hljs.registerLanguage("mizar",function(e){return{k:"environ vocabularies notations constructors definitions registrations theorems schemes requirements begin end definition registration cluster existence pred func defpred deffunc theorem proof let take assume then thus hence ex for st holds consider reconsider such that and in provided of as from be being by means equals implies iff redefine define now not or attr is mode suppose per cases set thesis contradiction scheme reserve struct correctness compatibility coherence symmetry assymetry reflexivity irreflexivity connectedness uniqueness commutativity idempotence involutiveness projectivity",c:[e.C("::","$")]}}),hljs.registerLanguage("monkey",function(e){var t={cN:"number",r:0,v:[{b:"[$][a-fA-F0-9]+"},e.NM]};return{cI:!0,k:{keyword:"public private property continue exit extern new try catch eachin not abstract final select case default const local global field end if then else elseif endif while wend repeat until forever for to step next return module inline throw",built_in:"DebugLog DebugStop Error Print ACos ACosr ASin ASinr ATan ATan2 ATan2r ATanr Abs Abs Ceil Clamp Clamp Cos Cosr Exp Floor Log Max Max Min Min Pow Sgn Sgn Sin Sinr Sqrt Tan Tanr Seed PI HALFPI TWOPI",literal:"true false null and or shl shr mod"},c:[e.C("#rem","#end"),e.C("'","$",{r:0}),{cN:"function",bK:"function method",e:"[(=:]|$",i:/\n/,c:[e.UTM]},{cN:"class",bK:"class interface",e:"$",c:[{bK:"extends implements"},e.UTM]},{cN:"variable",b:"\\b(self|super)\\b"},{cN:"preprocessor",bK:"import",e:"$"},{cN:"preprocessor",b:"\\s*#",e:"$",k:"if else elseif endif end then"},{cN:"pi",b:"^\\s*strict\\b"},{bK:"alias",e:"=",c:[e.UTM]},e.QSM,t]}}),hljs.registerLanguage("nginx",function(e){var t={cN:"variable",v:[{b:/\$\d+/},{b:/\$\{/,e:/}/},{b:"[\\$\\@]"+e.UIR}]},r={eW:!0,l:"[a-z/_]+",k:{built_in:"on off yes no true false none blocked debug info notice warn error crit select break last permanent redirect kqueue rtsig epoll poll /dev/poll"},r:0,i:"=>",c:[e.HCM,{cN:"string",c:[e.BE,t],v:[{b:/"/,e:/"/},{b:/'/,e:/'/}]},{cN:"url",b:"([a-z]+):/",e:"\\s",eW:!0,eE:!0,c:[t]},{cN:"regexp",c:[e.BE,t],v:[{b:"\\s\\^",e:"\\s|{|;",rE:!0},{b:"~\\*?\\s+",e:"\\s|{|;",rE:!0},{b:"\\*(\\.[a-z\\-]+)+"},{b:"([a-z\\-]+\\.)+\\*"}]},{cN:"number",b:"\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b"},{cN:"number",b:"\\b\\d+[kKmMgGdshdwy]*\\b",r:0},t]};return{aliases:["nginxconf"],c:[e.HCM,{b:e.UIR+"\\s",e:";|{",rB:!0,c:[{cN:"title",b:e.UIR,starts:r}],r:0}],i:"[^\\s\\}]"}}),hljs.registerLanguage("nimrod",function(e){return{aliases:["nim"],k:{keyword:"addr and as asm bind block break|0 case|0 cast const|0 continue|0 converter discard distinct|10 div do elif else|0 end|0 enum|0 except export finally for from generic if|0 import|0 in include|0 interface is isnot|10 iterator|10 let|0 macro method|10 mixin mod nil not notin|10 object|0 of or out proc|10 ptr raise ref|10 return shl shr static template|10 try|0 tuple type|0 using|0 var|0 when while|0 with without xor yield",literal:"shared guarded stdin stdout stderr result|10 true false"},c:[{cN:"decorator",b:/{\./,e:/\.}/,r:10},{cN:"string",b:/[a-zA-Z]\w*"/,e:/"/,c:[{b:/""/}]},{cN:"string",b:/([a-zA-Z]\w*)?"""/,e:/"""/},e.QSM,{cN:"type",b:/\b[A-Z]\w+\b/,r:0},{cN:"type",b:/\b(int|int8|int16|int32|int64|uint|uint8|uint16|uint32|uint64|float|float32|float64|bool|char|string|cstring|pointer|expr|stmt|void|auto|any|range|array|openarray|varargs|seq|set|clong|culong|cchar|cschar|cshort|cint|csize|clonglong|cfloat|cdouble|clongdouble|cuchar|cushort|cuint|culonglong|cstringarray|semistatic)\b/},{cN:"number",b:/\b(0[xX][0-9a-fA-F][_0-9a-fA-F]*)('?[iIuU](8|16|32|64))?/,r:0},{cN:"number",b:/\b(0o[0-7][_0-7]*)('?[iIuUfF](8|16|32|64))?/,r:0},{cN:"number",b:/\b(0(b|B)[01][_01]*)('?[iIuUfF](8|16|32|64))?/,r:0},{cN:"number",b:/\b(\d[_\d]*)('?[iIuUfF](8|16|32|64))?/,r:0},e.HCM]}}),hljs.registerLanguage("nix",function(e){var t={keyword:"rec with let in inherit assert if else then",constant:"true false or and null",built_in:"import abort baseNameOf dirOf isNull builtins map removeAttrs throw toString derivation"},r={cN:"subst",b:/\$\{/,e:/}/,k:t},a={cN:"variable",b:/[a-zA-Z0-9-_]+(\s*=)/},i={cN:"string",b:"''",e:"''",c:[r]},n={cN:"string",b:'"',e:'"',c:[r]},o=[e.NM,e.HCM,e.CBCM,i,n,a];return r.c=o,{aliases:["nixos"],k:t,c:o}}),hljs.registerLanguage("nsis",function(e){var t={cN:"symbol",b:"\\$(ADMINTOOLS|APPDATA|CDBURN_AREA|CMDLINE|COMMONFILES32|COMMONFILES64|COMMONFILES|COOKIES|DESKTOP|DOCUMENTS|EXEDIR|EXEFILE|EXEPATH|FAVORITES|FONTS|HISTORY|HWNDPARENT|INSTDIR|INTERNET_CACHE|LANGUAGE|LOCALAPPDATA|MUSIC|NETHOOD|OUTDIR|PICTURES|PLUGINSDIR|PRINTHOOD|PROFILE|PROGRAMFILES32|PROGRAMFILES64|PROGRAMFILES|QUICKLAUNCH|RECENT|RESOURCES_LOCALIZED|RESOURCES|SENDTO|SMPROGRAMS|SMSTARTUP|STARTMENU|SYSDIR|TEMP|TEMPLATES|VIDEOS|WINDIR)"},r={cN:"constant",b:"\\$+{[a-zA-Z0-9_]+}"},a={cN:"variable",b:"\\$+[a-zA-Z0-9_]+",i:"\\(\\){}"},i={cN:"constant",b:"\\$+\\([a-zA-Z0-9_]+\\)"},n={cN:"params",b:"(ARCHIVE|FILE_ATTRIBUTE_ARCHIVE|FILE_ATTRIBUTE_NORMAL|FILE_ATTRIBUTE_OFFLINE|FILE_ATTRIBUTE_READONLY|FILE_ATTRIBUTE_SYSTEM|FILE_ATTRIBUTE_TEMPORARY|HKCR|HKCU|HKDD|HKEY_CLASSES_ROOT|HKEY_CURRENT_CONFIG|HKEY_CURRENT_USER|HKEY_DYN_DATA|HKEY_LOCAL_MACHINE|HKEY_PERFORMANCE_DATA|HKEY_USERS|HKLM|HKPD|HKU|IDABORT|IDCANCEL|IDIGNORE|IDNO|IDOK|IDRETRY|IDYES|MB_ABORTRETRYIGNORE|MB_DEFBUTTON1|MB_DEFBUTTON2|MB_DEFBUTTON3|MB_DEFBUTTON4|MB_ICONEXCLAMATION|MB_ICONINFORMATION|MB_ICONQUESTION|MB_ICONSTOP|MB_OK|MB_OKCANCEL|MB_RETRYCANCEL|MB_RIGHT|MB_RTLREADING|MB_SETFOREGROUND|MB_TOPMOST|MB_USERICON|MB_YESNO|NORMAL|OFFLINE|READONLY|SHCTX|SHELL_CONTEXT|SYSTEM|TEMPORARY)"},o={cN:"constant",b:"\\!(addincludedir|addplugindir|appendfile|cd|define|delfile|echo|else|endif|error|execute|finalize|getdllversionsystem|ifdef|ifmacrodef|ifmacrondef|ifndef|if|include|insertmacro|macroend|macro|makensis|packhdr|searchparse|searchreplace|tempfile|undef|verbose|warning)"};return{cI:!1,k:{keyword:"Abort AddBrandingImage AddSize AllowRootDirInstall AllowSkipFiles AutoCloseWindow BGFont BGGradient BrandingText BringToFront Call CallInstDLL Caption ChangeUI CheckBitmap ClearErrors CompletedText ComponentText CopyFiles CRCCheck CreateDirectory CreateFont CreateShortCut Delete DeleteINISec DeleteINIStr DeleteRegKey DeleteRegValue DetailPrint DetailsButtonText DirText DirVar DirVerify EnableWindow EnumRegKey EnumRegValue Exch Exec ExecShell ExecWait ExpandEnvStrings File FileBufSize FileClose FileErrorText FileOpen FileRead FileReadByte FileReadUTF16LE FileReadWord FileSeek FileWrite FileWriteByte FileWriteUTF16LE FileWriteWord FindClose FindFirst FindNext FindWindow FlushINI FunctionEnd GetCurInstType GetCurrentAddress GetDlgItem GetDLLVersion GetDLLVersionLocal GetErrorLevel GetFileTime GetFileTimeLocal GetFullPathName GetFunctionAddress GetInstDirError GetLabelAddress GetTempFileName Goto HideWindow Icon IfAbort IfErrors IfFileExists IfRebootFlag IfSilent InitPluginsDir InstallButtonText InstallColors InstallDir InstallDirRegKey InstProgressFlags InstType InstTypeGetText InstTypeSetText IntCmp IntCmpU IntFmt IntOp IsWindow LangString LicenseBkColor LicenseData LicenseForceSelection LicenseLangString LicenseText LoadLanguageFile LockWindow LogSet LogText ManifestDPIAware ManifestSupportedOS MessageBox MiscButtonText Name Nop OutFile Page PageCallbacks PageExEnd Pop Push Quit ReadEnvStr ReadINIStr ReadRegDWORD ReadRegStr Reboot RegDLL Rename RequestExecutionLevel ReserveFile Return RMDir SearchPath SectionEnd SectionGetFlags SectionGetInstTypes SectionGetSize SectionGetText SectionGroupEnd SectionIn SectionSetFlags SectionSetInstTypes SectionSetSize SectionSetText SendMessage SetAutoClose SetBrandingImage SetCompress SetCompressor SetCompressorDictSize SetCtlColors SetCurInstType SetDatablockOptimize SetDateSave SetDetailsPrint SetDetailsView SetErrorLevel SetErrors SetFileAttributes SetFont SetOutPath SetOverwrite SetPluginUnload SetRebootFlag SetRegView SetShellVarContext SetSilent ShowInstDetails ShowUninstDetails ShowWindow SilentInstall SilentUnInstall Sleep SpaceTexts StrCmp StrCmpS StrCpy StrLen SubCaption SubSectionEnd Unicode UninstallButtonText UninstallCaption UninstallIcon UninstallSubCaption UninstallText UninstPage UnRegDLL Var VIAddVersionKey VIFileVersion VIProductVersion WindowIcon WriteINIStr WriteRegBin WriteRegDWORD WriteRegExpandStr WriteRegStr WriteUninstaller XPStyle",literal:"admin all auto both colored current false force hide highest lastused leave listonly none normal notset off on open print show silent silentlog smooth textonly true user "},c:[e.HCM,e.CBCM,{cN:"string",b:'"',e:'"',i:"\\n",c:[{cN:"symbol",b:"\\$(\\\\(n|r|t)|\\$)"},t,r,a,i]},e.C(";","$",{r:0}),{cN:"function",bK:"Function PageEx Section SectionGroup SubSection",e:"$"},o,r,a,i,n,e.NM,{cN:"literal",b:e.IR+"::"+e.IR}]}}),hljs.registerLanguage("objectivec",function(e){var t={cN:"built_in",b:"(AV|CA|CF|CG|CI|MK|MP|NS|UI)\\w+"},r={keyword:"int float while char export sizeof typedef const struct for union unsigned long volatile static bool mutable if do return goto void enum else break extern asm case short default double register explicit signed typename this switch continue wchar_t inline readonly assign readwrite self @synchronized id typeof nonatomic super unichar IBOutlet IBAction strong weak copy in out inout bycopy byref oneway __strong __weak __block __autoreleasing @private @protected @public @try @property @end @throw @catch @finally @autoreleasepool @synthesize @dynamic @selector @optional @required",literal:"false true FALSE TRUE nil YES NO NULL",built_in:"BOOL dispatch_once_t dispatch_queue_t dispatch_sync dispatch_async dispatch_once"},a=/[a-zA-Z@][a-zA-Z0-9_]*/,i="@interface @class @protocol @implementation";return{aliases:["m","mm","objc","obj-c"],k:r,l:a,i:"</",c:[t,e.CLCM,e.CBCM,e.CNM,e.QSM,{cN:"string",v:[{b:'@"',e:'"',i:"\\n",c:[e.BE]},{b:"'",e:"[^\\\\]'",i:"[^\\\\][^']"}]},{cN:"preprocessor",b:"#",e:"$",c:[{cN:"title",v:[{b:'"',e:'"'},{b:"<",e:">"}]}]},{cN:"class",b:"("+i.split(" ").join("|")+")\\b",e:"({|$)",eE:!0,k:i,l:a,c:[e.UTM]},{cN:"variable",b:"\\."+e.UIR,r:0}]}}),hljs.registerLanguage("ocaml",function(e){return{aliases:["ml"],k:{keyword:"and as assert asr begin class constraint do done downto else end exception external for fun function functor if in include inherit! inherit initializer land lazy let lor lsl lsr lxor match method!|10 method mod module mutable new object of open! open or private rec sig struct then to try type val! val virtual when while with parser value",built_in:"array bool bytes char exn|5 float int int32 int64 list lazy_t|5 nativeint|5 string unit in_channel out_channel ref",literal:"true false"},i:/\/\/|>>/,l:"[a-z_]\\w*!?",c:[{cN:"literal",b:"\\[(\\|\\|)?\\]|\\(\\)"},e.C("\\(\\*","\\*\\)",{c:["self"]}),{cN:"symbol",b:"'[A-Za-z_](?!')[\\w']*"},{cN:"tag",b:"`[A-Z][\\w']*"},{cN:"type",b:"\\b[A-Z][\\w']*",r:0},{b:"[a-z_]\\w*'[\\w']*"},e.inherit(e.ASM,{cN:"char",r:0}),e.inherit(e.QSM,{i:null}),{cN:"number",b:"\\b(0[xX][a-fA-F0-9_]+[Lln]?|0[oO][0-7_]+[Lln]?|0[bB][01_]+[Lln]?|[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)",r:0},{b:/[-=]>/}]}}),hljs.registerLanguage("oxygene",function(e){var t="abstract add and array as asc aspect assembly async begin break block by case class concat const copy constructor continue create default delegate desc distinct div do downto dynamic each else empty end ensure enum equals event except exit extension external false final finalize finalizer finally flags for forward from function future global group has if implementation implements implies in index inherited inline interface into invariants is iterator join locked locking loop matching method mod module namespace nested new nil not notify nullable of old on operator or order out override parallel params partial pinned private procedure property protected public queryable raise read readonly record reintroduce remove repeat require result reverse sealed select self sequence set shl shr skip static step soft take then to true try tuple type union unit unsafe until uses using var virtual raises volatile where while with write xor yield await mapped deprecated stdcall cdecl pascal register safecall overload library platform reference packed strict published autoreleasepool selector strong weak unretained",r=e.C("{","}",{
r:0}),a=e.C("\\(\\*","\\*\\)",{r:10}),i={cN:"string",b:"'",e:"'",c:[{b:"''"}]},n={cN:"string",b:"(#\\d+)+"},o={cN:"function",bK:"function constructor destructor procedure method",e:"[:;]",k:"function constructor|10 destructor|10 procedure|10 method|10",c:[e.TM,{cN:"params",b:"\\(",e:"\\)",k:t,c:[i,n]},r,a]};return{cI:!0,k:t,i:'("|\\$[G-Zg-z]|\\/\\*|</|=>|->)',c:[r,a,e.CLCM,i,n,e.NM,o,{cN:"class",b:"=\\bclass\\b",e:"end;",k:t,c:[i,n,r,a,e.CLCM,o]}]}}),hljs.registerLanguage("parser3",function(e){var t=e.C("{","}",{c:["self"]});return{sL:"xml",r:0,c:[e.C("^#","$"),e.C("\\^rem{","}",{r:10,c:[t]}),{cN:"preprocessor",b:"^@(?:BASE|USE|CLASS|OPTIONS)$",r:10},{cN:"title",b:"@[\\w\\-]+\\[[\\w^;\\-]*\\](?:\\[[\\w^;\\-]*\\])?(?:.*)$"},{cN:"variable",b:"\\$\\{?[\\w\\-\\.\\:]+\\}?"},{cN:"keyword",b:"\\^[\\w\\-\\.\\:]+"},{cN:"number",b:"\\^#[0-9a-fA-F]+"},e.CNM]}}),hljs.registerLanguage("perl",function(e){var t="getpwent getservent quotemeta msgrcv scalar kill dbmclose undef lc ma syswrite tr send umask sysopen shmwrite vec qx utime local oct semctl localtime readpipe do return format read sprintf dbmopen pop getpgrp not getpwnam rewinddir qqfileno qw endprotoent wait sethostent bless s|0 opendir continue each sleep endgrent shutdown dump chomp connect getsockname die socketpair close flock exists index shmgetsub for endpwent redo lstat msgctl setpgrp abs exit select print ref gethostbyaddr unshift fcntl syscall goto getnetbyaddr join gmtime symlink semget splice x|0 getpeername recv log setsockopt cos last reverse gethostbyname getgrnam study formline endhostent times chop length gethostent getnetent pack getprotoent getservbyname rand mkdir pos chmod y|0 substr endnetent printf next open msgsnd readdir use unlink getsockopt getpriority rindex wantarray hex system getservbyport endservent int chr untie rmdir prototype tell listen fork shmread ucfirst setprotoent else sysseek link getgrgid shmctl waitpid unpack getnetbyname reset chdir grep split require caller lcfirst until warn while values shift telldir getpwuid my getprotobynumber delete and sort uc defined srand accept package seekdir getprotobyname semop our rename seek if q|0 chroot sysread setpwent no crypt getc chown sqrt write setnetent setpriority foreach tie sin msgget map stat getlogin unless elsif truncate exec keys glob tied closedirioctl socket readlink eval xor readline binmode setservent eof ord bind alarm pipe atan2 getgrent exp time push setgrent gt lt or ne m|0 break given say state when",r={cN:"subst",b:"[$@]\\{",e:"\\}",k:t},a={b:"->{",e:"}"},i={cN:"variable",v:[{b:/\$\d/},{b:/[\$%@](\^\w\b|#\w+(::\w+)*|{\w+}|\w+(::\w*)*)/},{b:/[\$%@][^\s\w{]/,r:0}]},n=e.C("^(__END__|__DATA__)","\\n$",{r:5}),o=[e.BE,r,i],s=[i,e.HCM,n,e.C("^\\=\\w","\\=cut",{eW:!0}),a,{cN:"string",c:o,v:[{b:"q[qwxr]?\\s*\\(",e:"\\)",r:5},{b:"q[qwxr]?\\s*\\[",e:"\\]",r:5},{b:"q[qwxr]?\\s*\\{",e:"\\}",r:5},{b:"q[qwxr]?\\s*\\|",e:"\\|",r:5},{b:"q[qwxr]?\\s*\\<",e:"\\>",r:5},{b:"qw\\s+q",e:"q",r:5},{b:"'",e:"'",c:[e.BE]},{b:'"',e:'"'},{b:"`",e:"`",c:[e.BE]},{b:"{\\w+}",c:[],r:0},{b:"-?\\w+\\s*\\=\\>",c:[],r:0}]},{cN:"number",b:"(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b",r:0},{b:"(\\/\\/|"+e.RSR+"|\\b(split|return|print|reverse|grep)\\b)\\s*",k:"split return print reverse grep",r:0,c:[e.HCM,n,{cN:"regexp",b:"(s|tr|y)/(\\\\.|[^/])*/(\\\\.|[^/])*/[a-z]*",r:10},{cN:"regexp",b:"(m|qr)?/",e:"/[a-z]*",c:[e.BE],r:0}]},{cN:"sub",bK:"sub",e:"(\\s*\\(.*?\\))?[;{]",r:5},{cN:"operator",b:"-\\w\\b",r:0}];return r.c=s,a.c=s,{aliases:["pl"],k:t,c:s}}),hljs.registerLanguage("pf",function(e){var t={cN:"variable",b:/\$[\w\d#@][\w\d_]*/},r={cN:"variable",b:/</,e:/>/};return{aliases:["pf.conf"],l:/[a-z0-9_<>-]+/,k:{built_in:"block match pass load anchor|5 antispoof|10 set table",keyword:"in out log quick on rdomain inet inet6 proto from port os to routeallow-opts divert-packet divert-reply divert-to flags group icmp-typeicmp6-type label once probability recieved-on rtable prio queuetos tag tagged user keep fragment for os dropaf-to|10 binat-to|10 nat-to|10 rdr-to|10 bitmask least-stats random round-robinsource-hash static-portdup-to reply-to route-toparent bandwidth default min max qlimitblock-policy debug fingerprints hostid limit loginterface optimizationreassemble ruleset-optimization basic none profile skip state-defaultsstate-policy timeoutconst counters persistno modulate synproxy state|5 floating if-bound no-sync pflow|10 sloppysource-track global rule max-src-nodes max-src-states max-src-connmax-src-conn-rate overload flushscrub|5 max-mss min-ttl no-df|10 random-id",literal:"all any no-route self urpf-failed egress|5 unknown"},c:[e.HCM,e.NM,e.QSM,t,r]}}),hljs.registerLanguage("php",function(e){var t={cN:"variable",b:"\\$+[a-zA-Z_-ÿ][a-zA-Z0-9_-ÿ]*"},r={cN:"preprocessor",b:/<\?(php)?|\?>/},a={cN:"string",c:[e.BE,r],v:[{b:'b"',e:'"'},{b:"b'",e:"'"},e.inherit(e.ASM,{i:null}),e.inherit(e.QSM,{i:null})]},i={v:[e.BNM,e.CNM]};return{aliases:["php3","php4","php5","php6"],cI:!0,k:"and include_once list abstract global private echo interface as static endswitch array null if endwhile or const for endforeach self var while isset public protected exit foreach throw elseif include __FILE__ empty require_once do xor return parent clone use __CLASS__ __LINE__ else break print eval new catch __METHOD__ case exception default die require __FUNCTION__ enddeclare final try switch continue endfor endif declare unset true false trait goto instanceof insteadof __DIR__ __NAMESPACE__ yield finally",c:[e.CLCM,e.HCM,e.C("/\\*","\\*/",{c:[{cN:"phpdoc",b:"\\s@[A-Za-z]+"},r]}),e.C("__halt_compiler.+?;",!1,{eW:!0,k:"__halt_compiler",l:e.UIR}),{cN:"string",b:"<<<['\"]?\\w+['\"]?$",e:"^\\w+;",c:[e.BE]},r,t,{b:/(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/},{cN:"function",bK:"function",e:/[;{]/,eE:!0,i:"\\$|\\[|%",c:[e.UTM,{cN:"params",b:"\\(",e:"\\)",c:["self",t,e.CBCM,a,i]}]},{cN:"class",bK:"class interface",e:"{",eE:!0,i:/[:\(\$"]/,c:[{bK:"extends implements"},e.UTM]},{bK:"namespace",e:";",i:/[\.']/,c:[e.UTM]},{bK:"use",e:";",c:[e.UTM]},{b:"=>"},a,i]}}),hljs.registerLanguage("powershell",function(e){var t={b:"`[\\s\\S]",r:0},r={cN:"variable",v:[{b:/\$[\w\d][\w\d_:]*/}]},a={cN:"string",b:/"/,e:/"/,c:[t,r,{cN:"variable",b:/\$[A-z]/,e:/[^A-z]/}]},i={cN:"string",b:/'/,e:/'/};return{aliases:["ps"],l:/-?[A-z\.\-]+/,cI:!0,k:{keyword:"if else foreach return function do while until elseif begin for trap data dynamicparam end break throw param continue finally in switch exit filter try process catch",literal:"$null $true $false",built_in:"Add-Content Add-History Add-Member Add-PSSnapin Clear-Content Clear-Item Clear-Item Property Clear-Variable Compare-Object ConvertFrom-SecureString Convert-Path ConvertTo-Html ConvertTo-SecureString Copy-Item Copy-ItemProperty Export-Alias Export-Clixml Export-Console Export-Csv ForEach-Object Format-Custom Format-List Format-Table Format-Wide Get-Acl Get-Alias Get-AuthenticodeSignature Get-ChildItem Get-Command Get-Content Get-Credential Get-Culture Get-Date Get-EventLog Get-ExecutionPolicy Get-Help Get-History Get-Host Get-Item Get-ItemProperty Get-Location Get-Member Get-PfxCertificate Get-Process Get-PSDrive Get-PSProvider Get-PSSnapin Get-Service Get-TraceSource Get-UICulture Get-Unique Get-Variable Get-WmiObject Group-Object Import-Alias Import-Clixml Import-Csv Invoke-Expression Invoke-History Invoke-Item Join-Path Measure-Command Measure-Object Move-Item Move-ItemProperty New-Alias New-Item New-ItemProperty New-Object New-PSDrive New-Service New-TimeSpan New-Variable Out-Default Out-File Out-Host Out-Null Out-Printer Out-String Pop-Location Push-Location Read-Host Remove-Item Remove-ItemProperty Remove-PSDrive Remove-PSSnapin Remove-Variable Rename-Item Rename-ItemProperty Resolve-Path Restart-Service Resume-Service Select-Object Select-String Set-Acl Set-Alias Set-AuthenticodeSignature Set-Content Set-Date Set-ExecutionPolicy Set-Item Set-ItemProperty Set-Location Set-PSDebug Set-Service Set-TraceSource Set-Variable Sort-Object Split-Path Start-Service Start-Sleep Start-Transcript Stop-Process Stop-Service Stop-Transcript Suspend-Service Tee-Object Test-Path Trace-Command Update-FormatData Update-TypeData Where-Object Write-Debug Write-Error Write-Host Write-Output Write-Progress Write-Verbose Write-Warning",operator:"-ne -eq -lt -gt -ge -le -not -like -notlike -match -notmatch -contains -notcontains -in -notin -replace"},c:[e.HCM,e.NM,a,i,r]}}),hljs.registerLanguage("processing",function(e){return{k:{keyword:"BufferedReader PVector PFont PImage PGraphics HashMap boolean byte char color double float int long String Array FloatDict FloatList IntDict IntList JSONArray JSONObject Object StringDict StringList Table TableRow XML false synchronized int abstract float private char boolean static null if const for true while long throw strictfp finally protected import native final return void enum else break transient new catch instanceof byte super volatile case assert short package default double public try this switch continue throws protected public private",constant:"P2D P3D HALF_PI PI QUARTER_PI TAU TWO_PI",variable:"displayHeight displayWidth mouseY mouseX mousePressed pmouseX pmouseY key keyCode pixels focused frameCount frameRate height width",title:"setup draw",built_in:"size createGraphics beginDraw createShape loadShape PShape arc ellipse line point quad rect triangle bezier bezierDetail bezierPoint bezierTangent curve curveDetail curvePoint curveTangent curveTightness shape shapeMode beginContour beginShape bezierVertex curveVertex endContour endShape quadraticVertex vertex ellipseMode noSmooth rectMode smooth strokeCap strokeJoin strokeWeight mouseClicked mouseDragged mouseMoved mousePressed mouseReleased mouseWheel keyPressed keyPressedkeyReleased keyTyped print println save saveFrame day hour millis minute month second year background clear colorMode fill noFill noStroke stroke alpha blue brightness color green hue lerpColor red saturation modelX modelY modelZ screenX screenY screenZ ambient emissive shininess specular add createImage beginCamera camera endCamera frustum ortho perspective printCamera printProjection cursor frameRate noCursor exit loop noLoop popStyle pushStyle redraw binary boolean byte char float hex int str unbinary unhex join match matchAll nf nfc nfp nfs split splitTokens trim append arrayCopy concat expand reverse shorten sort splice subset box sphere sphereDetail createInput createReader loadBytes loadJSONArray loadJSONObject loadStrings loadTable loadXML open parseXML saveTable selectFolder selectInput beginRaw beginRecord createOutput createWriter endRaw endRecord PrintWritersaveBytes saveJSONArray saveJSONObject saveStream saveStrings saveXML selectOutput popMatrix printMatrix pushMatrix resetMatrix rotate rotateX rotateY rotateZ scale shearX shearY translate ambientLight directionalLight lightFalloff lights lightSpecular noLights normal pointLight spotLight image imageMode loadImage noTint requestImage tint texture textureMode textureWrap blend copy filter get loadPixels set updatePixels blendMode loadShader PShaderresetShader shader createFont loadFont text textFont textAlign textLeading textMode textSize textWidth textAscent textDescent abs ceil constrain dist exp floor lerp log mag map max min norm pow round sq sqrt acos asin atan atan2 cos degrees radians sin tan noise noiseDetail noiseSeed random randomGaussian randomSeed"},c:[e.CLCM,e.CBCM,e.ASM,e.QSM,e.CNM]}}),hljs.registerLanguage("profile",function(e){return{c:[e.CNM,{cN:"built_in",b:"{",e:"}$",eB:!0,eE:!0,c:[e.ASM,e.QSM],r:0},{cN:"filename",b:"[a-zA-Z_][\\da-zA-Z_]+\\.[\\da-zA-Z_]{1,3}",e:":",eE:!0},{cN:"header",b:"(ncalls|tottime|cumtime)",e:"$",k:"ncalls tottime|10 cumtime|10 filename",r:10},{cN:"summary",b:"function calls",e:"$",c:[e.CNM],r:10},e.ASM,e.QSM,{cN:"function",b:"\\(",e:"\\)$",c:[e.UTM],r:0}]}}),hljs.registerLanguage("prolog",function(e){var t={cN:"atom",b:/[a-z][A-Za-z0-9_]*/,r:0},r={cN:"name",v:[{b:/[A-Z][a-zA-Z0-9_]*/},{b:/_[A-Za-z0-9_]*/}],r:0},a={b:/\(/,e:/\)/,r:0},i={b:/\[/,e:/\]/},n={cN:"comment",b:/%/,e:/$/,c:[e.PWM]},o={cN:"string",b:/`/,e:/`/,c:[e.BE]},s={cN:"string",b:/0\'(\\\'|.)/},l={cN:"string",b:/0\'\\s/},c={b:/:-/},d=[t,r,a,c,i,n,e.CBCM,e.QSM,e.ASM,o,s,l,e.CNM];return a.c=d,i.c=d,{c:d.concat([{b:/\.$/}])}}),hljs.registerLanguage("protobuf",function(e){return{k:{keyword:"package import option optional required repeated group",built_in:"double float int32 int64 uint32 uint64 sint32 sint64 fixed32 fixed64 sfixed32 sfixed64 bool string bytes",literal:"true false"},c:[e.QSM,e.NM,e.CLCM,{cN:"class",bK:"message enum service",e:/\{/,i:/\n/,c:[e.inherit(e.TM,{starts:{eW:!0,eE:!0}})]},{cN:"function",bK:"rpc",e:/;/,eE:!0,k:"rpc returns"},{cN:"constant",b:/^\s*[A-Z_]+/,e:/\s*=/,eE:!0}]}}),hljs.registerLanguage("puppet",function(e){var t="augeas computer cron exec file filebucket host interface k5login macauthorization mailalias maillist mcx mount nagios_command nagios_contact nagios_contactgroup nagios_host nagios_hostdependency nagios_hostescalation nagios_hostextinfo nagios_hostgroup nagios_service firewall nagios_servicedependency nagios_serviceescalation nagios_serviceextinfo nagios_servicegroup nagios_timeperiod notify package resources router schedule scheduled_task selboolean selmodule service ssh_authorized_key sshkey stage tidy user vlan yumrepo zfs zone zpool",r="alias audit before loglevel noop require subscribe tag owner ensure group mode name|0 changes context force incl lens load_path onlyif provider returns root show_diff type_check en_address ip_address realname command environment hour monute month monthday special target weekday creates cwd ogoutput refresh refreshonly tries try_sleep umask backup checksum content ctime force ignore links mtime purge recurse recurselimit replace selinux_ignore_defaults selrange selrole seltype seluser source souirce_permissions sourceselect validate_cmd validate_replacement allowdupe attribute_membership auth_membership forcelocal gid ia_load_module members system host_aliases ip allowed_trunk_vlans description device_url duplex encapsulation etherchannel native_vlan speed principals allow_root auth_class auth_type authenticate_user k_of_n mechanisms rule session_owner shared options device fstype enable hasrestart directory present absent link atboot blockdevice device dump pass remounts poller_tag use message withpath adminfile allow_virtual allowcdrom category configfiles flavor install_options instance package_settings platform responsefile status uninstall_options vendor unless_system_user unless_uid binary control flags hasstatus manifest pattern restart running start stop allowdupe auths expiry gid groups home iterations key_membership keys managehome membership password password_max_age password_min_age profile_membership profiles project purge_ssh_keys role_membership roles salt shell uid baseurl cost descr enabled enablegroups exclude failovermethod gpgcheck gpgkey http_caching include includepkgs keepalive metadata_expire metalink mirrorlist priority protect proxy proxy_password proxy_username repo_gpgcheck s3_enabled skip_if_unavailable sslcacert sslclientcert sslclientkey sslverify mounted",a={keyword:"and case class default define else elsif false if in import enherits node or true undef unless main settings $string "+t,literal:r,built_in:"architecture augeasversion blockdevices boardmanufacturer boardproductname boardserialnumber cfkey dhcp_servers domain ec2_ ec2_userdata facterversion filesystems ldom fqdn gid hardwareisa hardwaremodel hostname id|0 interfaces ipaddress ipaddress_ ipaddress6 ipaddress6_ iphostnumber is_virtual kernel kernelmajversion kernelrelease kernelversion kernelrelease kernelversion lsbdistcodename lsbdistdescription lsbdistid lsbdistrelease lsbmajdistrelease lsbminordistrelease lsbrelease macaddress macaddress_ macosx_buildversion macosx_productname macosx_productversion macosx_productverson_major macosx_productversion_minor manufacturer memoryfree memorysize netmask metmask_ network_ operatingsystem operatingsystemmajrelease operatingsystemrelease osfamily partitions path physicalprocessorcount processor processorcount productname ps puppetversion rubysitedir rubyversion selinux selinux_config_mode selinux_config_policy selinux_current_mode selinux_current_mode selinux_enforced selinux_policyversion serialnumber sp_ sshdsakey sshecdsakey sshrsakey swapencrypted swapfree swapsize timezone type uniqueid uptime uptime_days uptime_hours uptime_seconds uuid virtual vlans xendomains zfs_version zonenae zones zpool_version"},i=e.C("#","$"),n={cN:"string",c:[e.BE],v:[{b:/'/,e:/'/},{b:/"/,e:/"/}]},o=[n,i,{cN:"keyword",bK:"class",e:"$|;",i:/=/,c:[e.inherit(e.TM,{b:"(::)?[A-Za-z_]\\w*(::\\w+)*"}),i,n]},{cN:"keyword",b:"([a-zA-Z_(::)]+ *\\{)",c:[n,i],r:0},{cN:"keyword",b:"(\\}|\\{)",r:0},{cN:"function",b:"[a-zA-Z_]+\\s*=>"},{cN:"constant",b:"(::)?(\\b[A-Z][a-z_]*(::)?)+",r:0},{cN:"number",b:"(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b",r:0}];return{aliases:["pp"],k:a,c:o}}),hljs.registerLanguage("python",function(e){var t={cN:"prompt",b:/^(>>>|\.\.\.) /},r={cN:"string",c:[e.BE],v:[{b:/(u|b)?r?'''/,e:/'''/,c:[t],r:10},{b:/(u|b)?r?"""/,e:/"""/,c:[t],r:10},{b:/(u|r|ur)'/,e:/'/,r:10},{b:/(u|r|ur)"/,e:/"/,r:10},{b:/(b|br)'/,e:/'/},{b:/(b|br)"/,e:/"/},e.ASM,e.QSM]},a={cN:"number",r:0,v:[{b:e.BNR+"[lLjJ]?"},{b:"\\b(0o[0-7]+)[lLjJ]?"},{b:e.CNR+"[lLjJ]?"}]},i={cN:"params",b:/\(/,e:/\)/,c:["self",t,a,r]};return{aliases:["py","gyp"],k:{keyword:"and elif is global as in if from raise for except finally print import pass return exec else break not with class assert yield try while continue del or def lambda nonlocal|10 None True False",built_in:"Ellipsis NotImplemented"},i:/(<\/|->|\?)/,c:[t,a,r,e.HCM,{v:[{cN:"function",bK:"def",r:10},{cN:"class",bK:"class"}],e:/:/,i:/[${=;\n,]/,c:[e.UTM,i]},{cN:"decorator",b:/@/,e:/$/},{b:/\b(print|exec)\(/}]}}),hljs.registerLanguage("q",function(e){var t={keyword:"do while select delete by update from",constant:"0b 1b",built_in:"neg not null string reciprocal floor ceiling signum mod xbar xlog and or each scan over prior mmu lsq inv md5 ltime gtime count first var dev med cov cor all any rand sums prds mins maxs fills deltas ratios avgs differ prev next rank reverse iasc idesc asc desc msum mcount mavg mdev xrank mmin mmax xprev rotate distinct group where flip type key til get value attr cut set upsert raze union inter except cross sv vs sublist enlist read0 read1 hopen hclose hdel hsym hcount peach system ltrim rtrim trim lower upper ssr view tables views cols xcols keys xkey xcol xasc xdesc fkeys meta lj aj aj0 ij pj asof uj ww wj wj1 fby xgroup ungroup ej save load rsave rload show csv parse eval min max avg wavg wsum sin cos tan sum",typename:"`float `double int `timestamp `timespan `datetime `time `boolean `symbol `char `byte `short `long `real `month `date `minute `second `guid"};return{aliases:["k","kdb"],k:t,l:/\b(`?)[A-Za-z0-9_]+\b/,c:[e.CLCM,e.QSM,e.CNM]}}),hljs.registerLanguage("r",function(e){var t="([a-zA-Z]|\\.[a-zA-Z.])[a-zA-Z0-9._]*";return{c:[e.HCM,{b:t,l:t,k:{keyword:"function if in break next repeat else for return switch while try tryCatch stop warning require library attach detach source setMethod setGeneric setGroupGeneric setClass ...",literal:"NULL NA TRUE FALSE T F Inf NaN NA_integer_|10 NA_real_|10 NA_character_|10 NA_complex_|10"},r:0},{cN:"number",b:"0[xX][0-9a-fA-F]+[Li]?\\b",r:0},{cN:"number",b:"\\d+(?:[eE][+\\-]?\\d*)?L\\b",r:0},{cN:"number",b:"\\d+\\.(?!\\d)(?:i\\b)?",r:0},{cN:"number",b:"\\d+(?:\\.\\d*)?(?:[eE][+\\-]?\\d*)?i?\\b",r:0},{cN:"number",b:"\\.\\d+(?:[eE][+\\-]?\\d*)?i?\\b",r:0},{b:"`",e:"`",r:0},{cN:"string",c:[e.BE],v:[{b:'"',e:'"'},{b:"'",e:"'"}]}]}}),hljs.registerLanguage("rib",function(e){return{k:"ArchiveRecord AreaLightSource Atmosphere Attribute AttributeBegin AttributeEnd Basis Begin Blobby Bound Clipping ClippingPlane Color ColorSamples ConcatTransform Cone CoordinateSystem CoordSysTransform CropWindow Curves Cylinder DepthOfField Detail DetailRange Disk Displacement Display End ErrorHandler Exposure Exterior Format FrameAspectRatio FrameBegin FrameEnd GeneralPolygon GeometricApproximation Geometry Hider Hyperboloid Identity Illuminate Imager Interior LightSource MakeCubeFaceEnvironment MakeLatLongEnvironment MakeShadow MakeTexture Matte MotionBegin MotionEnd NuPatch ObjectBegin ObjectEnd ObjectInstance Opacity Option Orientation Paraboloid Patch PatchMesh Perspective PixelFilter PixelSamples PixelVariance Points PointsGeneralPolygons PointsPolygons Polygon Procedural Projection Quantize ReadArchive RelativeDetail ReverseOrientation Rotate Scale ScreenWindow ShadingInterpolation ShadingRate Shutter Sides Skew SolidBegin SolidEnd Sphere SubdivisionMesh Surface TextureCoordinates Torus Transform TransformBegin TransformEnd TransformPoints Translate TrimCurve WorldBegin WorldEnd",i:"</",c:[e.HCM,e.CNM,e.ASM,e.QSM]}}),hljs.registerLanguage("roboconf",function(e){var t="[a-zA-Z-_][^\n{\r\n]+\\{";return{aliases:["graph","instances"],cI:!0,k:"import",c:[{cN:"facet",b:"^facet "+t,e:"}",k:"facet installer exports children extends",c:[e.HCM]},{cN:"instance-of",b:"^instance of "+t,e:"}",k:"name count channels instance-data instance-state instance of",c:[{cN:"keyword",b:"[a-zA-Z-_]+( |	)*:"},e.HCM]},{cN:"component",b:"^"+t,e:"}",l:"\\(?[a-zA-Z]+\\)?",k:"installer exports children extends imports facets alias (optional)",c:[{cN:"string",b:"\\.[a-zA-Z-_]+",e:"\\s|,|;",eE:!0},e.HCM]},e.HCM]}}),hljs.registerLanguage("rsl",function(e){return{k:{keyword:"float color point normal vector matrix while for if do return else break extern continue",built_in:"abs acos ambient area asin atan atmosphere attribute calculatenormal ceil cellnoise clamp comp concat cos degrees depth Deriv diffuse distance Du Dv environment exp faceforward filterstep floor format fresnel incident length lightsource log match max min mod noise normalize ntransform opposite option phong pnoise pow printf ptlined radians random reflect refract renderinfo round setcomp setxcomp setycomp setzcomp shadow sign sin smoothstep specular specularbrdf spline sqrt step tan texture textureinfo trace transform vtransform xcomp ycomp zcomp"},i:"</",c:[e.CLCM,e.CBCM,e.QSM,e.ASM,e.CNM,{cN:"preprocessor",b:"#",e:"$"},{cN:"shader",bK:"surface displacement light volume imager",e:"\\("},{cN:"shading",bK:"illuminate illuminance gather",e:"\\("}]}}),hljs.registerLanguage("ruleslanguage",function(e){return{k:{keyword:"BILL_PERIOD BILL_START BILL_STOP RS_EFFECTIVE_START RS_EFFECTIVE_STOP RS_JURIS_CODE RS_OPCO_CODE INTDADDATTRIBUTE|5 INTDADDVMSG|5 INTDBLOCKOP|5 INTDBLOCKOPNA|5 INTDCLOSE|5 INTDCOUNT|5 INTDCOUNTSTATUSCODE|5 INTDCREATEMASK|5 INTDCREATEDAYMASK|5 INTDCREATEFACTORMASK|5 INTDCREATEHANDLE|5 INTDCREATEOVERRIDEDAYMASK|5 INTDCREATEOVERRIDEMASK|5 INTDCREATESTATUSCODEMASK|5 INTDCREATETOUPERIOD|5 INTDDELETE|5 INTDDIPTEST|5 INTDEXPORT|5 INTDGETERRORCODE|5 INTDGETERRORMESSAGE|5 INTDISEQUAL|5 INTDJOIN|5 INTDLOAD|5 INTDLOADACTUALCUT|5 INTDLOADDATES|5 INTDLOADHIST|5 INTDLOADLIST|5 INTDLOADLISTDATES|5 INTDLOADLISTENERGY|5 INTDLOADLISTHIST|5 INTDLOADRELATEDCHANNEL|5 INTDLOADSP|5 INTDLOADSTAGING|5 INTDLOADUOM|5 INTDLOADUOMDATES|5 INTDLOADUOMHIST|5 INTDLOADVERSION|5 INTDOPEN|5 INTDREADFIRST|5 INTDREADNEXT|5 INTDRECCOUNT|5 INTDRELEASE|5 INTDREPLACE|5 INTDROLLAVG|5 INTDROLLPEAK|5 INTDSCALAROP|5 INTDSCALE|5 INTDSETATTRIBUTE|5 INTDSETDSTPARTICIPANT|5 INTDSETSTRING|5 INTDSETVALUE|5 INTDSETVALUESTATUS|5 INTDSHIFTSTARTTIME|5 INTDSMOOTH|5 INTDSORT|5 INTDSPIKETEST|5 INTDSUBSET|5 INTDTOU|5 INTDTOURELEASE|5 INTDTOUVALUE|5 INTDUPDATESTATS|5 INTDVALUE|5 STDEV INTDDELETEEX|5 INTDLOADEXACTUAL|5 INTDLOADEXCUT|5 INTDLOADEXDATES|5 INTDLOADEX|5 INTDLOADEXRELATEDCHANNEL|5 INTDSAVEEX|5 MVLOAD|5 MVLOADACCT|5 MVLOADACCTDATES|5 MVLOADACCTHIST|5 MVLOADDATES|5 MVLOADHIST|5 MVLOADLIST|5 MVLOADLISTDATES|5 MVLOADLISTHIST|5 IF FOR NEXT DONE SELECT END CALL ABORT CLEAR CHANNEL FACTOR LIST NUMBER OVERRIDE SET WEEK DISTRIBUTIONNODE ELSE WHEN THEN OTHERWISE IENUM CSV INCLUDE LEAVE RIDER SAVE DELETE NOVALUE SECTION WARN SAVE_UPDATE DETERMINANT LABEL REPORT REVENUE EACH IN FROM TOTAL CHARGE BLOCK AND OR CSV_FILE RATE_CODE AUXILIARY_DEMAND UIDACCOUNT RS BILL_PERIOD_SELECT HOURS_PER_MONTH INTD_ERROR_STOP SEASON_SCHEDULE_NAME ACCOUNTFACTOR ARRAYUPPERBOUND CALLSTOREDPROC GETADOCONNECTION GETCONNECT GETDATASOURCE GETQUALIFIER GETUSERID HASVALUE LISTCOUNT LISTOP LISTUPDATE LISTVALUE PRORATEFACTOR RSPRORATE SETBINPATH SETDBMONITOR WQ_OPEN BILLINGHOURS DATE DATEFROMFLOAT DATETIMEFROMSTRING DATETIMETOSTRING DATETOFLOAT DAY DAYDIFF DAYNAME DBDATETIME HOUR MINUTE MONTH MONTHDIFF MONTHHOURS MONTHNAME ROUNDDATE SAMEWEEKDAYLASTYEAR SECOND WEEKDAY WEEKDIFF YEAR YEARDAY YEARSTR COMPSUM HISTCOUNT HISTMAX HISTMIN HISTMINNZ HISTVALUE MAXNRANGE MAXRANGE MINRANGE COMPIKVA COMPKVA COMPKVARFROMKQKW COMPLF IDATTR FLAG LF2KW LF2KWH MAXKW POWERFACTOR READING2USAGE AVGSEASON MAXSEASON MONTHLYMERGE SEASONVALUE SUMSEASON ACCTREADDATES ACCTTABLELOAD CONFIGADD CONFIGGET CREATEOBJECT CREATEREPORT EMAILCLIENT EXPBLKMDMUSAGE EXPMDMUSAGE EXPORT_USAGE FACTORINEFFECT GETUSERSPECIFIEDSTOP INEFFECT ISHOLIDAY RUNRATE SAVE_PROFILE SETREPORTTITLE USEREXIT WATFORRUNRATE TO TABLE ACOS ASIN ATAN ATAN2 BITAND CEIL COS COSECANT COSH COTANGENT DIVQUOT DIVREM EXP FABS FLOOR FMOD FREPM FREXPN LOG LOG10 MAX MAXN MIN MINNZ MODF POW ROUND ROUND2VALUE ROUNDINT SECANT SIN SINH SQROOT TAN TANH FLOAT2STRING FLOAT2STRINGNC INSTR LEFT LEN LTRIM MID RIGHT RTRIM STRING STRINGNC TOLOWER TOUPPER TRIM NUMDAYS READ_DATE STAGING",built_in:"IDENTIFIER OPTIONS XML_ELEMENT XML_OP XML_ELEMENT_OF DOMDOCCREATE DOMDOCLOADFILE DOMDOCLOADXML DOMDOCSAVEFILE DOMDOCGETROOT DOMDOCADDPI DOMNODEGETNAME DOMNODEGETTYPE DOMNODEGETVALUE DOMNODEGETCHILDCT DOMNODEGETFIRSTCHILD DOMNODEGETSIBLING DOMNODECREATECHILDELEMENT DOMNODESETATTRIBUTE DOMNODEGETCHILDELEMENTCT DOMNODEGETFIRSTCHILDELEMENT DOMNODEGETSIBLINGELEMENT DOMNODEGETATTRIBUTECT DOMNODEGETATTRIBUTEI DOMNODEGETATTRIBUTEBYNAME DOMNODEGETBYNAME"},c:[e.CLCM,e.CBCM,e.ASM,e.QSM,e.CNM,{cN:"array",b:"#[a-zA-Z .]+"}]}}),hljs.registerLanguage("rust",function(e){var t=e.inherit(e.CBCM);return t.c.push("self"),{aliases:["rs"],k:{keyword:"alignof as be box break const continue crate do else enum extern false fn for if impl in let loop match mod mut offsetof once priv proc pub pure ref return self sizeof static struct super trait true type typeof unsafe unsized use virtual while yield int i8 i16 i32 i64 uint u8 u32 u64 float f32 f64 str char bool",built_in:"assert! assert_eq! bitflags! bytes! cfg! col! concat! concat_idents! debug_assert! debug_assert_eq! env! panic! file! format! format_args! include_bin! include_str! line! local_data_key! module_path! option_env! print! println! select! stringify! try! unimplemented! unreachable! vec! write! writeln!"},l:e.IR+"!?",i:"</",c:[e.CLCM,t,e.inherit(e.QSM,{i:null}),{cN:"string",b:/r(#*)".*?"\1(?!#)/},{cN:"string",b:/'\\?(x\w{2}|u\w{4}|U\w{8}|.)'/},{b:/'[a-zA-Z_][a-zA-Z0-9_]*/},{cN:"number",b:/\b(0[xbo][A-Fa-f0-9_]+|\d[\d_]*(\.[0-9_]+)?([eE][+-]?[0-9_]+)?)([uif](8|16|32|64|size))?/,r:0},{cN:"function",bK:"fn",e:"(\\(|<)",eE:!0,c:[e.UTM]},{cN:"preprocessor",b:"#\\!?\\[",e:"\\]"},{bK:"type",e:"(=|<)",c:[e.UTM],i:"\\S"},{bK:"trait enum",e:"({|<)",c:[e.UTM],i:"\\S"},{b:e.IR+"::"},{b:"->"}]}}),hljs.registerLanguage("scala",function(e){var t={cN:"annotation",b:"@[A-Za-z]+"},r={cN:"string",b:'u?r?"""',e:'"""',r:10},a={cN:"symbol",b:"'\\w[\\w\\d_]*(?!')"},i={cN:"type",b:"\\b[A-Z][A-Za-z0-9_]*",r:0},n={cN:"title",b:/[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/,r:0},o={cN:"class",bK:"class object trait type",e:/[:={\[(\n;]/,c:[{cN:"keyword",bK:"extends with",r:10},n]},s={cN:"function",bK:"def val",e:/[:={\[(\n;]/,c:[n]};return{k:{literal:"true false null",keyword:"type yield lazy override def with val var sealed abstract private trait object if forSome for while throw finally protected extends import final return else break new catch super class case package default try this match continue throws implicit"},c:[e.CLCM,e.CBCM,r,e.QSM,a,i,s,o,e.CNM,t]}}),hljs.registerLanguage("scheme",function(e){var t="[^\\(\\)\\[\\]\\{\\}\",'`;#|\\\\\\s]+",r="(\\-|\\+)?\\d+([./]\\d+)?",a=r+"[+\\-]"+r+"i",i={built_in:"case-lambda call/cc class define-class exit-handler field import inherit init-field interface let*-values let-values let/ec mixin opt-lambda override protect provide public rename require require-for-syntax syntax syntax-case syntax-error unit/sig unless when with-syntax and begin call-with-current-continuation call-with-input-file call-with-output-file case cond define define-syntax delay do dynamic-wind else for-each if lambda let let* let-syntax letrec letrec-syntax map or syntax-rules ' * + , ,@ - ... / ; < <= = => > >= ` abs acos angle append apply asin assoc assq assv atan boolean? caar cadr call-with-input-file call-with-output-file call-with-values car cdddar cddddr cdr ceiling char->integer char-alphabetic? char-ci<=? char-ci<? char-ci=? char-ci>=? char-ci>? char-downcase char-lower-case? char-numeric? char-ready? char-upcase char-upper-case? char-whitespace? char<=? char<? char=? char>=? char>? char? close-input-port close-output-port complex? cons cos current-input-port current-output-port denominator display eof-object? eq? equal? eqv? eval even? exact->inexact exact? exp expt floor force gcd imag-part inexact->exact inexact? input-port? integer->char integer? interaction-environment lcm length list list->string list->vector list-ref list-tail list? load log magnitude make-polar make-rectangular make-string make-vector max member memq memv min modulo negative? newline not null-environment null? number->string number? numerator odd? open-input-file open-output-file output-port? pair? peek-char port? positive? procedure? quasiquote quote quotient rational? rationalize read read-char real-part real? remainder reverse round scheme-report-environment set! set-car! set-cdr! sin sqrt string string->list string->number string->symbol string-append string-ci<=? string-ci<? string-ci=? string-ci>=? string-ci>? string-copy string-fill! string-length string-ref string-set! string<=? string<? string=? string>=? string>? string? substring symbol->string symbol? tan transcript-off transcript-on truncate values vector vector->list vector-fill! vector-length vector-ref vector-set! with-input-from-file with-output-to-file write write-char zero?"},n={cN:"shebang",b:"^#!",e:"$"},o={cN:"literal",b:"(#t|#f|#\\\\"+t+"|#\\\\.)"},s={cN:"number",v:[{b:r,r:0},{b:a,r:0},{b:"#b[0-1]+(/[0-1]+)?"},{b:"#o[0-7]+(/[0-7]+)?"},{b:"#x[0-9a-f]+(/[0-9a-f]+)?"}]},l=e.QSM,c=[e.C(";","$",{r:0}),e.C("#\\|","\\|#")],d={b:t,r:0},p={cN:"variable",b:"'"+t},u={eW:!0,r:0},m={cN:"list",v:[{b:"\\(",e:"\\)"},{b:"\\[",e:"\\]"}],c:[{cN:"keyword",b:t,l:t,k:i},u]};return u.c=[o,s,l,d,p,m].concat(c),{i:/\S/,c:[n,s,l,p,m].concat(c)}}),hljs.registerLanguage("scilab",function(e){var t=[e.CNM,{cN:"string",b:"'|\"",e:"'|\"",c:[e.BE,{b:"''"}]}];return{aliases:["sci"],k:{keyword:"abort break case clear catch continue do elseif else endfunction end for functionglobal if pause return resume select try then while%f %F %t %T %pi %eps %inf %nan %e %i %z %s",built_in:"abs and acos asin atan ceil cd chdir clearglobal cosh cos cumprod deff disp errorexec execstr exists exp eye gettext floor fprintf fread fsolve imag isdef isemptyisinfisnan isvector lasterror length load linspace list listfiles log10 log2 logmax min msprintf mclose mopen ones or pathconvert poly printf prod pwd rand realround sinh sin size gsort sprintf sqrt strcat strcmps tring sum system tanh tantype typename warning zeros matrix"},i:'("|#|/\\*|\\s+/\\w+)',c:[{cN:"function",bK:"function endfunction",e:"$",k:"function endfunction|10",c:[e.UTM,{cN:"params",b:"\\(",e:"\\)"}]},{cN:"transposed_variable",b:"[a-zA-Z_][a-zA-Z_0-9]*('+[\\.']*|[\\.']+)",e:"",r:0},{cN:"matrix",b:"\\[",e:"\\]'*[\\.']*",r:0,c:t},e.C("//","$")].concat(t)
}}),hljs.registerLanguage("scss",function(e){{var t="[a-zA-Z-][a-zA-Z0-9_-]*",r={cN:"variable",b:"(\\$"+t+")\\b"},a={cN:"function",b:t+"\\(",rB:!0,eE:!0,e:"\\("},i={cN:"hexcolor",b:"#[0-9A-Fa-f]+"};({cN:"attribute",b:"[A-Z\\_\\.\\-]+",e:":",eE:!0,i:"[^\\s]",starts:{cN:"value",eW:!0,eE:!0,c:[a,i,e.CSSNM,e.QSM,e.ASM,e.CBCM,{cN:"important",b:"!important"}]}})}return{cI:!0,i:"[=/|']",c:[e.CLCM,e.CBCM,a,{cN:"id",b:"\\#[A-Za-z0-9_-]+",r:0},{cN:"class",b:"\\.[A-Za-z0-9_-]+",r:0},{cN:"attr_selector",b:"\\[",e:"\\]",i:"$"},{cN:"tag",b:"\\b(a|abbr|acronym|address|area|article|aside|audio|b|base|big|blockquote|body|br|button|canvas|caption|cite|code|col|colgroup|command|datalist|dd|del|details|dfn|div|dl|dt|em|embed|fieldset|figcaption|figure|footer|form|frame|frameset|(h[1-6])|head|header|hgroup|hr|html|i|iframe|img|input|ins|kbd|keygen|label|legend|li|link|map|mark|meta|meter|nav|noframes|noscript|object|ol|optgroup|option|output|p|param|pre|progress|q|rp|rt|ruby|samp|script|section|select|small|span|strike|strong|style|sub|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|tt|ul|var|video)\\b",r:0},{cN:"pseudo",b:":(visited|valid|root|right|required|read-write|read-only|out-range|optional|only-of-type|only-child|nth-of-type|nth-last-of-type|nth-last-child|nth-child|not|link|left|last-of-type|last-child|lang|invalid|indeterminate|in-range|hover|focus|first-of-type|first-line|first-letter|first-child|first|enabled|empty|disabled|default|checked|before|after|active)"},{cN:"pseudo",b:"::(after|before|choices|first-letter|first-line|repeat-index|repeat-item|selection|value)"},r,{cN:"attribute",b:"\\b(z-index|word-wrap|word-spacing|word-break|width|widows|white-space|visibility|vertical-align|unicode-bidi|transition-timing-function|transition-property|transition-duration|transition-delay|transition|transform-style|transform-origin|transform|top|text-underline-position|text-transform|text-shadow|text-rendering|text-overflow|text-indent|text-decoration-style|text-decoration-line|text-decoration-color|text-decoration|text-align-last|text-align|tab-size|table-layout|right|resize|quotes|position|pointer-events|perspective-origin|perspective|page-break-inside|page-break-before|page-break-after|padding-top|padding-right|padding-left|padding-bottom|padding|overflow-y|overflow-x|overflow-wrap|overflow|outline-width|outline-style|outline-offset|outline-color|outline|orphans|order|opacity|object-position|object-fit|normal|none|nav-up|nav-right|nav-left|nav-index|nav-down|min-width|min-height|max-width|max-height|mask|marks|margin-top|margin-right|margin-left|margin-bottom|margin|list-style-type|list-style-position|list-style-image|list-style|line-height|letter-spacing|left|justify-content|initial|inherit|ime-mode|image-orientation|image-resolution|image-rendering|icon|hyphens|height|font-weight|font-variant-ligatures|font-variant|font-style|font-stretch|font-size-adjust|font-size|font-language-override|font-kerning|font-feature-settings|font-family|font|float|flex-wrap|flex-shrink|flex-grow|flex-flow|flex-direction|flex-basis|flex|filter|empty-cells|display|direction|cursor|counter-reset|counter-increment|content|column-width|column-span|column-rule-width|column-rule-style|column-rule-color|column-rule|column-gap|column-fill|column-count|columns|color|clip-path|clip|clear|caption-side|break-inside|break-before|break-after|box-sizing|box-shadow|box-decoration-break|bottom|border-width|border-top-width|border-top-style|border-top-right-radius|border-top-left-radius|border-top-color|border-top|border-style|border-spacing|border-right-width|border-right-style|border-right-color|border-right|border-radius|border-left-width|border-left-style|border-left-color|border-left|border-image-width|border-image-source|border-image-slice|border-image-repeat|border-image-outset|border-image|border-color|border-collapse|border-bottom-width|border-bottom-style|border-bottom-right-radius|border-bottom-left-radius|border-bottom-color|border-bottom|border|background-size|background-repeat|background-position|background-origin|background-image|background-color|background-clip|background-attachment|background-blend-mode|background|backface-visibility|auto|animation-timing-function|animation-play-state|animation-name|animation-iteration-count|animation-fill-mode|animation-duration|animation-direction|animation-delay|animation|align-self|align-items|align-content)\\b",i:"[^\\s]"},{cN:"value",b:"\\b(whitespace|wait|w-resize|visible|vertical-text|vertical-ideographic|uppercase|upper-roman|upper-alpha|underline|transparent|top|thin|thick|text|text-top|text-bottom|tb-rl|table-header-group|table-footer-group|sw-resize|super|strict|static|square|solid|small-caps|separate|se-resize|scroll|s-resize|rtl|row-resize|ridge|right|repeat|repeat-y|repeat-x|relative|progress|pointer|overline|outside|outset|oblique|nowrap|not-allowed|normal|none|nw-resize|no-repeat|no-drop|newspaper|ne-resize|n-resize|move|middle|medium|ltr|lr-tb|lowercase|lower-roman|lower-alpha|loose|list-item|line|line-through|line-edge|lighter|left|keep-all|justify|italic|inter-word|inter-ideograph|inside|inset|inline|inline-block|inherit|inactive|ideograph-space|ideograph-parenthesis|ideograph-numeric|ideograph-alpha|horizontal|hidden|help|hand|groove|fixed|ellipsis|e-resize|double|dotted|distribute|distribute-space|distribute-letter|distribute-all-lines|disc|disabled|default|decimal|dashed|crosshair|collapse|col-resize|circle|char|center|capitalize|break-word|break-all|bottom|both|bolder|bold|block|bidi-override|below|baseline|auto|always|all-scroll|absolute|table|table-cell)\\b"},{cN:"value",b:":",e:";",c:[a,r,i,e.CSSNM,e.QSM,e.ASM,{cN:"important",b:"!important"}]},{cN:"at_rule",b:"@",e:"[{;]",k:"mixin include extend for if else each while charset import debug media page content font-face namespace warn",c:[a,r,e.QSM,e.ASM,i,e.CSSNM,{cN:"preprocessor",b:"\\s[A-Za-z0-9_.-]+",r:0}]}]}}),hljs.registerLanguage("smali",function(e){var t=["add","and","cmp","cmpg","cmpl","const","div","double","float","goto","if","int","long","move","mul","neg","new","nop","not","or","rem","return","shl","shr","sput","sub","throw","ushr","xor"],r=["aget","aput","array","check","execute","fill","filled","goto/16","goto/32","iget","instance","invoke","iput","monitor","packed","sget","sparse"],a=["transient","constructor","abstract","final","synthetic","public","private","protected","static","bridge","system"];return{aliases:["smali"],c:[{cN:"string",b:'"',e:'"',r:0},e.C("#","$",{r:0}),{cN:"keyword",b:"\\s*\\.end\\s[a-zA-Z0-9]*",r:1},{cN:"keyword",b:"^[ ]*\\.[a-zA-Z]*",r:0},{cN:"keyword",b:"\\s:[a-zA-Z_0-9]*",r:0},{cN:"keyword",b:"\\s("+a.join("|")+")",r:1},{cN:"keyword",b:"\\[",r:0},{cN:"instruction",b:"\\s("+t.join("|")+")\\s",r:1},{cN:"instruction",b:"\\s("+t.join("|")+")((\\-|/)[a-zA-Z0-9]+)+\\s",r:10},{cN:"instruction",b:"\\s("+r.join("|")+")((\\-|/)[a-zA-Z0-9]+)*\\s",r:10},{cN:"class",b:"L[^(;:\n]*;",r:0},{cN:"function",b:'( |->)[^(\n ;"]*\\(',r:0},{cN:"function",b:"\\)",r:0},{cN:"variable",b:"[vp][0-9]+",r:0}]}}),hljs.registerLanguage("smalltalk",function(e){var t="[a-z][a-zA-Z0-9_]*",r={cN:"char",b:"\\$.{1}"},a={cN:"symbol",b:"#"+e.UIR};return{aliases:["st"],k:"self super nil true false thisContext",c:[e.C('"','"'),e.ASM,{cN:"class",b:"\\b[A-Z][A-Za-z0-9_]*",r:0},{cN:"method",b:t+":",r:0},e.CNM,a,r,{cN:"localvars",b:"\\|[ ]*"+t+"([ ]+"+t+")*[ ]*\\|",rB:!0,e:/\|/,i:/\S/,c:[{b:"(\\|[ ]*)?"+t}]},{cN:"array",b:"\\#\\(",e:"\\)",c:[e.ASM,r,e.CNM,a]}]}}),hljs.registerLanguage("sml",function(e){return{aliases:["ml"],k:{keyword:"abstype and andalso as case datatype do else end eqtype exception fn fun functor handle if in include infix infixr let local nonfix of op open orelse raise rec sharing sig signature struct structure then type val with withtype where while",built_in:"array bool char exn int list option order real ref string substring vector unit word",literal:"true false NONE SOME LESS EQUAL GREATER nil"},i:/\/\/|>>/,l:"[a-z_]\\w*!?",c:[{cN:"literal",b:"\\[(\\|\\|)?\\]|\\(\\)"},e.C("\\(\\*","\\*\\)",{c:["self"]}),{cN:"symbol",b:"'[A-Za-z_](?!')[\\w']*"},{cN:"tag",b:"`[A-Z][\\w']*"},{cN:"type",b:"\\b[A-Z][\\w']*",r:0},{b:"[a-z_]\\w*'[\\w']*"},e.inherit(e.ASM,{cN:"char",r:0}),e.inherit(e.QSM,{i:null}),{cN:"number",b:"\\b(0[xX][a-fA-F0-9_]+[Lln]?|0[oO][0-7_]+[Lln]?|0[bB][01_]+[Lln]?|[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)",r:0},{b:/[-=]>/}]}}),hljs.registerLanguage("sql",function(e){var t=e.C("--","$");return{cI:!0,i:/[<>]/,c:[{cN:"operator",bK:"begin end start commit rollback savepoint lock alter create drop rename call delete do handler insert load replace select truncate update set show pragma grant merge describe use explain help declare prepare execute deallocate savepoint release unlock purge reset change stop analyze cache flush optimize repair kill install uninstall checksum restore check backup revoke",e:/;/,eW:!0,k:{keyword:"abs absolute acos action add adddate addtime aes_decrypt aes_encrypt after aggregate all allocate alter analyze and any are as asc ascii asin assertion at atan atan2 atn2 authorization authors avg backup before begin benchmark between bin binlog bit_and bit_count bit_length bit_or bit_xor both by cache call cascade cascaded case cast catalog ceil ceiling chain change changed char_length character_length charindex charset check checksum checksum_agg choose close coalesce coercibility collate collation collationproperty column columns columns_updated commit compress concat concat_ws concurrent connect connection connection_id consistent constraint constraints continue contributors conv convert convert_tz corresponding cos cot count count_big crc32 create cross cume_dist curdate current current_date current_time current_timestamp current_user cursor curtime data database databases datalength date_add date_format date_sub dateadd datediff datefromparts datename datepart datetime2fromparts datetimeoffsetfromparts day dayname dayofmonth dayofweek dayofyear deallocate declare decode default deferrable deferred degrees delayed delete des_decrypt des_encrypt des_key_file desc describe descriptor diagnostics difference disconnect distinct distinctrow div do domain double drop dumpfile each else elt enclosed encode encrypt end end-exec engine engines eomonth errors escape escaped event eventdata events except exception exec execute exists exp explain export_set extended external extract fast fetch field fields find_in_set first first_value floor flush for force foreign format found found_rows from from_base64 from_days from_unixtime full function get get_format get_lock getdate getutcdate global go goto grant grants greatest group group_concat grouping grouping_id gtid_subset gtid_subtract handler having help hex high_priority hosts hour ident_current ident_incr ident_seed identified identity if ifnull ignore iif ilike immediate in index indicator inet6_aton inet6_ntoa inet_aton inet_ntoa infile initially inner innodb input insert install instr intersect into is is_free_lock is_ipv4 is_ipv4_compat is_ipv4_mapped is_not is_not_null is_used_lock isdate isnull isolation join key kill language last last_day last_insert_id last_value lcase lead leading least leaves left len lenght level like limit lines ln load load_file local localtime localtimestamp locate lock log log10 log2 logfile logs low_priority lower lpad ltrim make_set makedate maketime master master_pos_wait match matched max md5 medium merge microsecond mid min minute mod mode module month monthname mutex name_const names national natural nchar next no no_write_to_binlog not now nullif nvarchar oct octet_length of old_password on only open optimize option optionally or ord order outer outfile output pad parse partial partition password patindex percent_rank percentile_cont percentile_disc period_add period_diff pi plugin position pow power pragma precision prepare preserve primary prior privileges procedure procedure_analyze processlist profile profiles public publishingservername purge quarter query quick quote quotename radians rand read references regexp relative relaylog release release_lock rename repair repeat replace replicate reset restore restrict return returns reverse revoke right rlike rollback rollup round row row_count rows rpad rtrim savepoint schema scroll sec_to_time second section select serializable server session session_user set sha sha1 sha2 share show sign sin size slave sleep smalldatetimefromparts snapshot some soname soundex sounds_like space sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows sql_no_cache sql_small_result sql_variant_property sqlstate sqrt square start starting status std stddev stddev_pop stddev_samp stdev stdevp stop str str_to_date straight_join strcmp string stuff subdate substr substring subtime subtring_index sum switchoffset sysdate sysdatetime sysdatetimeoffset system_user sysutcdatetime table tables tablespace tan temporary terminated tertiary_weights then time time_format time_to_sec timediff timefromparts timestamp timestampadd timestampdiff timezone_hour timezone_minute to to_base64 to_days to_seconds todatetimeoffset trailing transaction translation trigger trigger_nestlevel triggers trim truncate try_cast try_convert try_parse ucase uncompress uncompressed_length unhex unicode uninstall union unique unix_timestamp unknown unlock update upgrade upped upper usage use user user_resources using utc_date utc_time utc_timestamp uuid uuid_short validate_password_strength value values var var_pop var_samp variables variance varp version view warnings week weekday weekofyear weight_string when whenever where with work write xml xor year yearweek zon",literal:"true false null",built_in:"array bigint binary bit blob boolean char character date dec decimal float int integer interval number numeric real serial smallint varchar varying int8 serial8 text"},c:[{cN:"string",b:"'",e:"'",c:[e.BE,{b:"''"}]},{cN:"string",b:'"',e:'"',c:[e.BE,{b:'""'}]},{cN:"string",b:"`",e:"`",c:[e.BE]},e.CNM,e.CBCM,t]},e.CBCM,t]}}),hljs.registerLanguage("stata",function(e){return{aliases:["do","ado"],cI:!0,k:"if else in foreach for forv forva forval forvalu forvalue forvalues by bys bysort xi quietly qui capture about ac ac_7 acprplot acprplot_7 adjust ado adopath adoupdate alpha ameans an ano anov anova anova_estat anova_terms anovadef aorder ap app appe appen append arch arch_dr arch_estat arch_p archlm areg areg_p args arima arima_dr arima_estat arima_p as asmprobit asmprobit_estat asmprobit_lf asmprobit_mfx__dlg asmprobit_p ass asse asser assert avplot avplot_7 avplots avplots_7 bcskew0 bgodfrey binreg bip0_lf biplot bipp_lf bipr_lf bipr_p biprobit bitest bitesti bitowt blogit bmemsize boot bootsamp bootstrap bootstrap_8 boxco_l boxco_p boxcox boxcox_6 boxcox_p bprobit br break brier bro brow brows browse brr brrstat bs bs_7 bsampl_w bsample bsample_7 bsqreg bstat bstat_7 bstat_8 bstrap bstrap_7 ca ca_estat ca_p cabiplot camat canon canon_8 canon_8_p canon_estat canon_p cap caprojection capt captu captur capture cat cc cchart cchart_7 cci cd censobs_table centile cf char chdir checkdlgfiles checkestimationsample checkhlpfiles checksum chelp ci cii cl class classutil clear cli clis clist clo clog clog_lf clog_p clogi clogi_sw clogit clogit_lf clogit_p clogitp clogl_sw cloglog clonevar clslistarray cluster cluster_measures cluster_stop cluster_tree cluster_tree_8 clustermat cmdlog cnr cnre cnreg cnreg_p cnreg_sw cnsreg codebook collaps4 collapse colormult_nb colormult_nw compare compress conf confi confir confirm conren cons const constr constra constrai constrain constraint continue contract copy copyright copysource cor corc corr corr2data corr_anti corr_kmo corr_smc corre correl correla correlat correlate corrgram cou coun count cox cox_p cox_sw coxbase coxhaz coxvar cprplot cprplot_7 crc cret cretu cretur creturn cross cs cscript cscript_log csi ct ct_is ctset ctst_5 ctst_st cttost cumsp cumsp_7 cumul cusum cusum_7 cutil d datasig datasign datasigna datasignat datasignatu datasignatur datasignature datetof db dbeta de dec deco decod decode deff des desc descr descri describ describe destring dfbeta dfgls dfuller di di_g dir dirstats dis discard disp disp_res disp_s displ displa display distinct do doe doed doedi doedit dotplot dotplot_7 dprobit drawnorm drop ds ds_util dstdize duplicates durbina dwstat dydx e ed edi edit egen eivreg emdef en enc enco encod encode eq erase ereg ereg_lf ereg_p ereg_sw ereghet ereghet_glf ereghet_glf_sh ereghet_gp ereghet_ilf ereghet_ilf_sh ereghet_ip eret eretu eretur ereturn err erro error est est_cfexist est_cfname est_clickable est_expand est_hold est_table est_unhold est_unholdok estat estat_default estat_summ estat_vce_only esti estimates etodow etof etomdy ex exi exit expand expandcl fac fact facto factor factor_estat factor_p factor_pca_rotated factor_rotate factormat fcast fcast_compute fcast_graph fdades fdadesc fdadescr fdadescri fdadescrib fdadescribe fdasav fdasave fdause fh_st file open file read file close file filefilter fillin find_hlp_file findfile findit findit_7 fit fl fli flis flist for5_0 form forma format fpredict frac_154 frac_adj frac_chk frac_cox frac_ddp frac_dis frac_dv frac_in frac_mun frac_pp frac_pq frac_pv frac_wgt frac_xo fracgen fracplot fracplot_7 fracpoly fracpred fron_ex fron_hn fron_p fron_tn fron_tn2 frontier ftodate ftoe ftomdy ftowdate g gamhet_glf gamhet_gp gamhet_ilf gamhet_ip gamma gamma_d2 gamma_p gamma_sw gammahet gdi_hexagon gdi_spokes ge gen gene gener genera generat generate genrank genstd genvmean gettoken gl gladder gladder_7 glim_l01 glim_l02 glim_l03 glim_l04 glim_l05 glim_l06 glim_l07 glim_l08 glim_l09 glim_l10 glim_l11 glim_l12 glim_lf glim_mu glim_nw1 glim_nw2 glim_nw3 glim_p glim_v1 glim_v2 glim_v3 glim_v4 glim_v5 glim_v6 glim_v7 glm glm_6 glm_p glm_sw glmpred glo glob globa global glogit glogit_8 glogit_p gmeans gnbre_lf gnbreg gnbreg_5 gnbreg_p gomp_lf gompe_sw gomper_p gompertz gompertzhet gomphet_glf gomphet_glf_sh gomphet_gp gomphet_ilf gomphet_ilf_sh gomphet_ip gphdot gphpen gphprint gprefs gprobi_p gprobit gprobit_8 gr gr7 gr_copy gr_current gr_db gr_describe gr_dir gr_draw gr_draw_replay gr_drop gr_edit gr_editviewopts gr_example gr_example2 gr_export gr_print gr_qscheme gr_query gr_read gr_rename gr_replay gr_save gr_set gr_setscheme gr_table gr_undo gr_use graph graph7 grebar greigen greigen_7 greigen_8 grmeanby grmeanby_7 gs_fileinfo gs_filetype gs_graphinfo gs_stat gsort gwood h hadimvo hareg hausman haver he heck_d2 heckma_p heckman heckp_lf heckpr_p heckprob hel help hereg hetpr_lf hetpr_p hetprob hettest hexdump hilite hist hist_7 histogram hlogit hlu hmeans hotel hotelling hprobit hreg hsearch icd9 icd9_ff icd9p iis impute imtest inbase include inf infi infil infile infix inp inpu input ins insheet insp inspe inspec inspect integ inten intreg intreg_7 intreg_p intrg2_ll intrg_ll intrg_ll2 ipolate iqreg ir irf irf_create irfm iri is_svy is_svysum isid istdize ivprob_1_lf ivprob_lf ivprobit ivprobit_p ivreg ivreg_footnote ivtob_1_lf ivtob_lf ivtobit ivtobit_p jackknife jacknife jknife jknife_6 jknife_8 jkstat joinby kalarma1 kap kap_3 kapmeier kappa kapwgt kdensity kdensity_7 keep ksm ksmirnov ktau kwallis l la lab labe label labelbook ladder levels levelsof leverage lfit lfit_p li lincom line linktest lis list lloghet_glf lloghet_glf_sh lloghet_gp lloghet_ilf lloghet_ilf_sh lloghet_ip llogi_sw llogis_p llogist llogistic llogistichet lnorm_lf lnorm_sw lnorma_p lnormal lnormalhet lnormhet_glf lnormhet_glf_sh lnormhet_gp lnormhet_ilf lnormhet_ilf_sh lnormhet_ip lnskew0 loadingplot loc loca local log logi logis_lf logistic logistic_p logit logit_estat logit_p loglogs logrank loneway lookfor lookup lowess lowess_7 lpredict lrecomp lroc lroc_7 lrtest ls lsens lsens_7 lsens_x lstat ltable ltable_7 ltriang lv lvr2plot lvr2plot_7 m ma mac macr macro makecns man manova manova_estat manova_p manovatest mantel mark markin markout marksample mat mat_capp mat_order mat_put_rr mat_rapp mata mata_clear mata_describe mata_drop mata_matdescribe mata_matsave mata_matuse mata_memory mata_mlib mata_mosave mata_rename mata_which matalabel matcproc matlist matname matr matri matrix matrix_input__dlg matstrik mcc mcci md0_ md1_ md1debug_ md2_ md2debug_ mds mds_estat mds_p mdsconfig mdslong mdsmat mdsshepard mdytoe mdytof me_derd mean means median memory memsize meqparse mer merg merge mfp mfx mhelp mhodds minbound mixed_ll mixed_ll_reparm mkassert mkdir mkmat mkspline ml ml_5 ml_adjs ml_bhhhs ml_c_d ml_check ml_clear ml_cnt ml_debug ml_defd ml_e0 ml_e0_bfgs ml_e0_cycle ml_e0_dfp ml_e0i ml_e1 ml_e1_bfgs ml_e1_bhhh ml_e1_cycle ml_e1_dfp ml_e2 ml_e2_cycle ml_ebfg0 ml_ebfr0 ml_ebfr1 ml_ebh0q ml_ebhh0 ml_ebhr0 ml_ebr0i ml_ecr0i ml_edfp0 ml_edfr0 ml_edfr1 ml_edr0i ml_eds ml_eer0i ml_egr0i ml_elf ml_elf_bfgs ml_elf_bhhh ml_elf_cycle ml_elf_dfp ml_elfi ml_elfs ml_enr0i ml_enrr0 ml_erdu0 ml_erdu0_bfgs ml_erdu0_bhhh ml_erdu0_bhhhq ml_erdu0_cycle ml_erdu0_dfp ml_erdu0_nrbfgs ml_exde ml_footnote ml_geqnr ml_grad0 ml_graph ml_hbhhh ml_hd0 ml_hold ml_init ml_inv ml_log ml_max ml_mlout ml_mlout_8 ml_model ml_nb0 ml_opt ml_p ml_plot ml_query ml_rdgrd ml_repor ml_s_e ml_score ml_searc ml_technique ml_unhold mleval mlf_ mlmatbysum mlmatsum mlog mlogi mlogit mlogit_footnote mlogit_p mlopts mlsum mlvecsum mnl0_ mor more mov move mprobit mprobit_lf mprobit_p mrdu0_ mrdu1_ mvdecode mvencode mvreg mvreg_estat n nbreg nbreg_al nbreg_lf nbreg_p nbreg_sw nestreg net newey newey_7 newey_p news nl nl_7 nl_9 nl_9_p nl_p nl_p_7 nlcom nlcom_p nlexp2 nlexp2_7 nlexp2a nlexp2a_7 nlexp3 nlexp3_7 nlgom3 nlgom3_7 nlgom4 nlgom4_7 nlinit nllog3 nllog3_7 nllog4 nllog4_7 nlog_rd nlogit nlogit_p nlogitgen nlogittree nlpred no nobreak noi nois noisi noisil noisily note notes notes_dlg nptrend numlabel numlist odbc old_ver olo olog ologi ologi_sw ologit ologit_p ologitp on one onew onewa oneway op_colnm op_comp op_diff op_inv op_str opr opro oprob oprob_sw oprobi oprobi_p oprobit oprobitp opts_exclusive order orthog orthpoly ou out outf outfi outfil outfile outs outsh outshe outshee outsheet ovtest pac pac_7 palette parse parse_dissim pause pca pca_8 pca_display pca_estat pca_p pca_rotate pcamat pchart pchart_7 pchi pchi_7 pcorr pctile pentium pergram pergram_7 permute permute_8 personal peto_st pkcollapse pkcross pkequiv pkexamine pkexamine_7 pkshape pksumm pksumm_7 pl plo plot plugin pnorm pnorm_7 poisgof poiss_lf poiss_sw poisso_p poisson poisson_estat post postclose postfile postutil pperron pr prais prais_e prais_e2 prais_p predict predictnl preserve print pro prob probi probit probit_estat probit_p proc_time procoverlay procrustes procrustes_estat procrustes_p profiler prog progr progra program prop proportion prtest prtesti pwcorr pwd q\\s qby qbys qchi qchi_7 qladder qladder_7 qnorm qnorm_7 qqplot qqplot_7 qreg qreg_c qreg_p qreg_sw qu quadchk quantile quantile_7 que quer query range ranksum ratio rchart rchart_7 rcof recast reclink recode reg reg3 reg3_p regdw regr regre regre_p2 regres regres_p regress regress_estat regriv_p remap ren rena renam rename renpfix repeat replace report reshape restore ret retu retur return rm rmdir robvar roccomp roccomp_7 roccomp_8 rocf_lf rocfit rocfit_8 rocgold rocplot rocplot_7 roctab roctab_7 rolling rologit rologit_p rot rota rotat rotate rotatemat rreg rreg_p ru run runtest rvfplot rvfplot_7 rvpplot rvpplot_7 sa safesum sample sampsi sav save savedresults saveold sc sca scal scala scalar scatter scm_mine sco scob_lf scob_p scobi_sw scobit scor score scoreplot scoreplot_help scree screeplot screeplot_help sdtest sdtesti se search separate seperate serrbar serrbar_7 serset set set_defaults sfrancia sh she shel shell shewhart shewhart_7 signestimationsample signrank signtest simul simul_7 simulate simulate_8 sktest sleep slogit slogit_d2 slogit_p smooth snapspan so sor sort spearman spikeplot spikeplot_7 spikeplt spline_x split sqreg sqreg_p sret sretu sretur sreturn ssc st st_ct st_hc st_hcd st_hcd_sh st_is st_issys st_note st_promo st_set st_show st_smpl st_subid stack statsby statsby_8 stbase stci stci_7 stcox stcox_estat stcox_fr stcox_fr_ll stcox_p stcox_sw stcoxkm stcoxkm_7 stcstat stcurv stcurve stcurve_7 stdes stem stepwise stereg stfill stgen stir stjoin stmc stmh stphplot stphplot_7 stphtest stphtest_7 stptime strate strate_7 streg streg_sw streset sts sts_7 stset stsplit stsum sttocc sttoct stvary stweib su suest suest_8 sum summ summa summar summari summariz summarize sunflower sureg survcurv survsum svar svar_p svmat svy svy_disp svy_dreg svy_est svy_est_7 svy_estat svy_get svy_gnbreg_p svy_head svy_header svy_heckman_p svy_heckprob_p svy_intreg_p svy_ivreg_p svy_logistic_p svy_logit_p svy_mlogit_p svy_nbreg_p svy_ologit_p svy_oprobit_p svy_poisson_p svy_probit_p svy_regress_p svy_sub svy_sub_7 svy_x svy_x_7 svy_x_p svydes svydes_8 svygen svygnbreg svyheckman svyheckprob svyintreg svyintreg_7 svyintrg svyivreg svylc svylog_p svylogit svymarkout svymarkout_8 svymean svymlog svymlogit svynbreg svyolog svyologit svyoprob svyoprobit svyopts svypois svypois_7 svypoisson svyprobit svyprobt svyprop svyprop_7 svyratio svyreg svyreg_p svyregress svyset svyset_7 svyset_8 svytab svytab_7 svytest svytotal sw sw_8 swcnreg swcox swereg swilk swlogis swlogit swologit swoprbt swpois swprobit swqreg swtobit swweib symmetry symmi symplot symplot_7 syntax sysdescribe sysdir sysuse szroeter ta tab tab1 tab2 tab_or tabd tabdi tabdis tabdisp tabi table tabodds tabodds_7 tabstat tabu tabul tabula tabulat tabulate te tempfile tempname tempvar tes test testnl testparm teststd tetrachoric time_it timer tis tob tobi tobit tobit_p tobit_sw token tokeni tokeniz tokenize tostring total translate translator transmap treat_ll treatr_p treatreg trim trnb_cons trnb_mean trpoiss_d2 trunc_ll truncr_p truncreg tsappend tset tsfill tsline tsline_ex tsreport tsrevar tsrline tsset tssmooth tsunab ttest ttesti tut_chk tut_wait tutorial tw tware_st two twoway twoway__fpfit_serset twoway__function_gen twoway__histogram_gen twoway__ipoint_serset twoway__ipoints_serset twoway__kdensity_gen twoway__lfit_serset twoway__normgen_gen twoway__pci_serset twoway__qfit_serset twoway__scatteri_serset twoway__sunflower_gen twoway_ksm_serset ty typ type typeof u unab unabbrev unabcmd update us use uselabel var var_mkcompanion var_p varbasic varfcast vargranger varirf varirf_add varirf_cgraph varirf_create varirf_ctable varirf_describe varirf_dir varirf_drop varirf_erase varirf_graph varirf_ograph varirf_rename varirf_set varirf_table varlist varlmar varnorm varsoc varstable varstable_w varstable_w2 varwle vce vec vec_fevd vec_mkphi vec_p vec_p_w vecirf_create veclmar veclmar_w vecnorm vecnorm_w vecrank vecstable verinst vers versi versio version view viewsource vif vwls wdatetof webdescribe webseek webuse weib1_lf weib2_lf weib_lf weib_lf0 weibhet_glf weibhet_glf_sh weibhet_glfa weibhet_glfa_sh weibhet_gp weibhet_ilf weibhet_ilf_sh weibhet_ilfa weibhet_ilfa_sh weibhet_ip weibu_sw weibul_p weibull weibull_c weibull_s weibullhet wh whelp whi which whil while wilc_st wilcoxon win wind windo window winexec wntestb wntestb_7 wntestq xchart xchart_7 xcorr xcorr_7 xi xi_6 xmlsav xmlsave xmluse xpose xsh xshe xshel xshell xt_iis xt_tis xtab_p xtabond xtbin_p xtclog xtcloglog xtcloglog_8 xtcloglog_d2 xtcloglog_pa_p xtcloglog_re_p xtcnt_p xtcorr xtdata xtdes xtfront_p xtfrontier xtgee xtgee_elink xtgee_estat xtgee_makeivar xtgee_p xtgee_plink xtgls xtgls_p xthaus xthausman xtht_p xthtaylor xtile xtint_p xtintreg xtintreg_8 xtintreg_d2 xtintreg_p xtivp_1 xtivp_2 xtivreg xtline xtline_ex xtlogit xtlogit_8 xtlogit_d2 xtlogit_fe_p xtlogit_pa_p xtlogit_re_p xtmixed xtmixed_estat xtmixed_p xtnb_fe xtnb_lf xtnbreg xtnbreg_pa_p xtnbreg_refe_p xtpcse xtpcse_p xtpois xtpoisson xtpoisson_d2 xtpoisson_pa_p xtpoisson_refe_p xtpred xtprobit xtprobit_8 xtprobit_d2 xtprobit_re_p xtps_fe xtps_lf xtps_ren xtps_ren_8 xtrar_p xtrc xtrc_p xtrchh xtrefe_p xtreg xtreg_be xtreg_fe xtreg_ml xtreg_pa_p xtreg_re xtregar xtrere_p xtset xtsf_ll xtsf_llti xtsum xttab xttest0 xttobit xttobit_8 xttobit_p xttrans yx yxview__barlike_draw yxview_area_draw yxview_bar_draw yxview_dot_draw yxview_dropline_draw yxview_function_draw yxview_iarrow_draw yxview_ilabels_draw yxview_normal_draw yxview_pcarrow_draw yxview_pcbarrow_draw yxview_pccapsym_draw yxview_pcscatter_draw yxview_pcspike_draw yxview_rarea_draw yxview_rbar_draw yxview_rbarm_draw yxview_rcap_draw yxview_rcapsym_draw yxview_rconnected_draw yxview_rline_draw yxview_rscatter_draw yxview_rspike_draw yxview_spike_draw yxview_sunflower_draw zap_s zinb zinb_llf zinb_plf zip zip_llf zip_p zip_plf zt_ct_5 zt_hc_5 zt_hcd_5 zt_is_5 zt_iss_5 zt_sho_5 zt_smp_5 ztbase_5 ztcox_5 ztdes_5 ztereg_5 ztfill_5 ztgen_5 ztir_5 ztjoin_5 ztnb ztnb_p ztp ztp_p zts_5 ztset_5 ztspli_5 ztsum_5 zttoct_5 ztvary_5 ztweib_5",c:[{cN:"label",v:[{b:"\\$\\{?[a-zA-Z0-9_]+\\}?"},{b:"`[a-zA-Z0-9_]+'"}]},{cN:"string",v:[{b:'`"[^\r\n]*?"\''},{b:'"[^\r\n"]*"'}]},{cN:"literal",v:[{b:"\\b(abs|acos|asin|atan|atan2|atanh|ceil|cloglog|comb|cos|digamma|exp|floor|invcloglog|invlogit|ln|lnfact|lnfactorial|lngamma|log|log10|max|min|mod|reldif|round|sign|sin|sqrt|sum|tan|tanh|trigamma|trunc|betaden|Binomial|binorm|binormal|chi2|chi2tail|dgammapda|dgammapdada|dgammapdadx|dgammapdx|dgammapdxdx|F|Fden|Ftail|gammaden|gammap|ibeta|invbinomial|invchi2|invchi2tail|invF|invFtail|invgammap|invibeta|invnchi2|invnFtail|invnibeta|invnorm|invnormal|invttail|nbetaden|nchi2|nFden|nFtail|nibeta|norm|normal|normalden|normd|npnchi2|tden|ttail|uniform|abbrev|char|index|indexnot|length|lower|ltrim|match|plural|proper|real|regexm|regexr|regexs|reverse|rtrim|string|strlen|strlower|strltrim|strmatch|strofreal|strpos|strproper|strreverse|strrtrim|strtrim|strupper|subinstr|subinword|substr|trim|upper|word|wordcount|_caller|autocode|byteorder|chop|clip|cond|e|epsdouble|epsfloat|group|inlist|inrange|irecode|matrix|maxbyte|maxdouble|maxfloat|maxint|maxlong|mi|minbyte|mindouble|minfloat|minint|minlong|missing|r|recode|replay|return|s|scalar|d|date|day|dow|doy|halfyear|mdy|month|quarter|week|year|d|daily|dofd|dofh|dofm|dofq|dofw|dofy|h|halfyearly|hofd|m|mofd|monthly|q|qofd|quarterly|tin|twithin|w|weekly|wofd|y|yearly|yh|ym|yofd|yq|yw|cholesky|colnumb|colsof|corr|det|diag|diag0cnt|el|get|hadamard|I|inv|invsym|issym|issymmetric|J|matmissing|matuniform|mreldif|nullmat|rownumb|rowsof|sweep|syminv|trace|vec|vecdiag)(?=\\(|$)"}]},e.C("^[ 	]*\\*.*$",!1),e.CLCM,e.CBCM]}}),hljs.registerLanguage("step21",function(e){var t="[A-Z_][A-Z0-9_.]*",r="END-ISO-10303-21;",a={literal:"",built_in:"",keyword:"HEADER ENDSEC DATA"},i={cN:"preprocessor",b:"ISO-10303-21;",r:10},n=[e.CLCM,e.CBCM,e.C("/\\*\\*!","\\*/"),e.CNM,e.inherit(e.ASM,{i:null}),e.inherit(e.QSM,{i:null}),{cN:"string",b:"'",e:"'"},{cN:"label",v:[{b:"#",e:"\\d+",i:"\\W"}]}];return{aliases:["p21","step","stp"],cI:!0,l:t,k:a,c:[{cN:"preprocessor",b:r,r:10},i].concat(n)}}),hljs.registerLanguage("stylus",function(e){var t={cN:"variable",b:"\\$"+e.IR},r={cN:"hexcolor",b:"#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})",r:10},a=["charset","css","debug","extend","font-face","for","import","include","media","mixin","page","warn","while"],i=["after","before","first-letter","first-line","active","first-child","focus","hover","lang","link","visited"],n=["a","abbr","address","article","aside","audio","b","blockquote","body","button","canvas","caption","cite","code","dd","del","details","dfn","div","dl","dt","em","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","html","i","iframe","img","input","ins","kbd","label","legend","li","mark","menu","nav","object","ol","p","q","quote","samp","section","span","strong","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","tr","ul","var","video"],o="[\\.\\s\\n\\[\\:,]",s=["align-content","align-items","align-self","animation","animation-delay","animation-direction","animation-duration","animation-fill-mode","animation-iteration-count","animation-name","animation-play-state","animation-timing-function","auto","backface-visibility","background","background-attachment","background-clip","background-color","background-image","background-origin","background-position","background-repeat","background-size","border","border-bottom","border-bottom-color","border-bottom-left-radius","border-bottom-right-radius","border-bottom-style","border-bottom-width","border-collapse","border-color","border-image","border-image-outset","border-image-repeat","border-image-slice","border-image-source","border-image-width","border-left","border-left-color","border-left-style","border-left-width","border-radius","border-right","border-right-color","border-right-style","border-right-width","border-spacing","border-style","border-top","border-top-color","border-top-left-radius","border-top-right-radius","border-top-style","border-top-width","border-width","bottom","box-decoration-break","box-shadow","box-sizing","break-after","break-before","break-inside","caption-side","clear","clip","clip-path","color","column-count","column-fill","column-gap","column-rule","column-rule-color","column-rule-style","column-rule-width","column-span","column-width","columns","content","counter-increment","counter-reset","cursor","direction","display","empty-cells","filter","flex","flex-basis","flex-direction","flex-flow","flex-grow","flex-shrink","flex-wrap","float","font","font-family","font-feature-settings","font-kerning","font-language-override","font-size","font-size-adjust","font-stretch","font-style","font-variant","font-variant-ligatures","font-weight","height","hyphens","icon","image-orientation","image-rendering","image-resolution","ime-mode","inherit","initial","justify-content","left","letter-spacing","line-height","list-style","list-style-image","list-style-position","list-style-type","margin","margin-bottom","margin-left","margin-right","margin-top","marks","mask","max-height","max-width","min-height","min-width","nav-down","nav-index","nav-left","nav-right","nav-up","none","normal","object-fit","object-position","opacity","order","orphans","outline","outline-color","outline-offset","outline-style","outline-width","overflow","overflow-wrap","overflow-x","overflow-y","padding","padding-bottom","padding-left","padding-right","padding-top","page-break-after","page-break-before","page-break-inside","perspective","perspective-origin","pointer-events","position","quotes","resize","right","tab-size","table-layout","text-align","text-align-last","text-decoration","text-decoration-color","text-decoration-line","text-decoration-style","text-indent","text-overflow","text-rendering","text-shadow","text-transform","text-underline-position","top","transform","transform-origin","transform-style","transition","transition-delay","transition-duration","transition-property","transition-timing-function","unicode-bidi","vertical-align","visibility","white-space","widows","width","word-break","word-spacing","word-wrap","z-index"],l=["\\{","\\}","\\?","(\\bReturn\\b)","(\\bEnd\\b)","(\\bend\\b)",";","#\\s","\\*\\s","===\\s","\\|","%"];

return{aliases:["styl"],cI:!1,i:"("+l.join("|")+")",k:"if else for in",c:[e.QSM,e.ASM,e.CLCM,e.CBCM,r,{b:"\\.[a-zA-Z][a-zA-Z0-9_-]*"+o,rB:!0,c:[{cN:"class",b:"\\.[a-zA-Z][a-zA-Z0-9_-]*"}]},{b:"\\#[a-zA-Z][a-zA-Z0-9_-]*"+o,rB:!0,c:[{cN:"id",b:"\\#[a-zA-Z][a-zA-Z0-9_-]*"}]},{b:"\\b("+n.join("|")+")"+o,rB:!0,c:[{cN:"tag",b:"\\b[a-zA-Z][a-zA-Z0-9_-]*"}]},{cN:"pseudo",b:"&?:?:\\b("+i.join("|")+")"+o},{cN:"at_rule",b:"@("+a.join("|")+")\\b"},t,e.CSSNM,e.NM,{cN:"function",b:"\\b[a-zA-Z][a-zA-Z0-9_-]*\\(.*\\)",i:"[\\n]",rB:!0,c:[{cN:"title",b:"\\b[a-zA-Z][a-zA-Z0-9_-]*"},{cN:"params",b:/\(/,e:/\)/,c:[r,t,e.ASM,e.CSSNM,e.NM,e.QSM]}]},{cN:"attribute",b:"\\b("+s.reverse().join("|")+")\\b"}]}}),hljs.registerLanguage("swift",function(e){var t={keyword:"class deinit enum extension func import init let protocol static struct subscript typealias var break case continue default do else fallthrough if in for return switch where while as dynamicType is new super self Self Type __COLUMN__ __FILE__ __FUNCTION__ __LINE__ associativity didSet get infix inout left mutating none nonmutating operator override postfix precedence prefix right set unowned unowned safe unsafe weak willSet",literal:"true false nil",built_in:"abs advance alignof alignofValue assert bridgeFromObjectiveC bridgeFromObjectiveCUnconditional bridgeToObjectiveC bridgeToObjectiveCUnconditional c contains count countElements countLeadingZeros debugPrint debugPrintln distance dropFirst dropLast dump encodeBitsAsWords enumerate equal false filter find getBridgedObjectiveCType getVaList indices insertionSort isBridgedToObjectiveC isBridgedVerbatimToObjectiveC isUniquelyReferenced join lexicographicalCompare map max maxElement min minElement nil numericCast partition posix print println quickSort reduce reflect reinterpretCast reverse roundUpToAlignment sizeof sizeofValue sort split startsWith strideof strideofValue swap swift toString transcode true underestimateCount unsafeReflect withExtendedLifetime withObjectAtPlusZero withUnsafePointer withUnsafePointerToObject withUnsafePointers withVaList"},r={cN:"type",b:"\\b[A-Z][\\w']*",r:0},a=e.C("/\\*","\\*/",{c:["self"]}),i={cN:"subst",b:/\\\(/,e:"\\)",k:t,c:[]},n={cN:"number",b:"\\b([\\d_]+(\\.[\\deE_]+)?|0x[a-fA-F0-9_]+(\\.[a-fA-F0-9p_]+)?|0b[01_]+|0o[0-7_]+)\\b",r:0},o=e.inherit(e.QSM,{c:[i,e.BE]});return i.c=[n],{k:t,c:[o,e.CLCM,a,r,n,{cN:"func",bK:"func",e:"{",eE:!0,c:[e.inherit(e.TM,{b:/[A-Za-z$_][0-9A-Za-z$_]*/,i:/\(/}),{cN:"generics",b:/</,e:/>/,i:/>/},{cN:"params",b:/\(/,e:/\)/,endsParent:!0,k:t,c:["self",n,o,e.CBCM,{b:":"}],i:/["']/}],i:/\[|%/},{cN:"class",bK:"struct protocol class extension enum",k:t,e:"\\{",eE:!0,c:[e.inherit(e.TM,{b:/[A-Za-z$_][0-9A-Za-z$_]*/})]},{cN:"preprocessor",b:"(@assignment|@class_protocol|@exported|@final|@lazy|@noreturn|@NSCopying|@NSManaged|@objc|@optional|@required|@auto_closure|@noreturn|@IBAction|@IBDesignable|@IBInspectable|@IBOutlet|@infix|@prefix|@postfix)"}]}}),hljs.registerLanguage("tcl",function(e){return{aliases:["tk"],k:"after append apply array auto_execok auto_import auto_load auto_mkindex auto_mkindex_old auto_qualify auto_reset bgerror binary break catch cd chan clock close concat continue dde dict encoding eof error eval exec exit expr fblocked fconfigure fcopy file fileevent filename flush for foreach format gets glob global history http if incr info interp join lappend|10 lassign|10 lindex|10 linsert|10 list llength|10 load lrange|10 lrepeat|10 lreplace|10 lreverse|10 lsearch|10 lset|10 lsort|10 mathfunc mathop memory msgcat namespace open package parray pid pkg::create pkg_mkIndex platform platform::shell proc puts pwd read refchan regexp registry regsub|10 rename return safe scan seek set socket source split string subst switch tcl_endOfWord tcl_findLibrary tcl_startOfNextWord tcl_startOfPreviousWord tcl_wordBreakAfter tcl_wordBreakBefore tcltest tclvars tell time tm trace unknown unload unset update uplevel upvar variable vwait while",c:[e.C(";[ \\t]*#","$"),e.C("^[ \\t]*#","$"),{bK:"proc",e:"[\\{]",eE:!0,c:[{cN:"symbol",b:"[ \\t\\n\\r]+(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*",e:"[ \\t\\n\\r]",eW:!0,eE:!0}]},{cN:"variable",eE:!0,v:[{b:"\\$(\\{)?(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*\\(([a-zA-Z0-9_])*\\)",e:"[^a-zA-Z0-9_\\}\\$]"},{b:"\\$(\\{)?(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*",e:"(\\))?[^a-zA-Z0-9_\\}\\$]"}]},{cN:"string",c:[e.BE],v:[e.inherit(e.ASM,{i:null}),e.inherit(e.QSM,{i:null})]},{cN:"number",v:[e.BNM,e.CNM]}]}}),hljs.registerLanguage("tex",function(e){var t={cN:"command",b:"\\\\[a-zA-Zа-яА-я]+[\\*]?"},r={cN:"command",b:"\\\\[^a-zA-Zа-яА-я0-9]"},a={cN:"special",b:"[{}\\[\\]\\&#~]",r:0};return{c:[{b:"\\\\[a-zA-Zа-яА-я]+[\\*]? *= *-?\\d*\\.?\\d+(pt|pc|mm|cm|in|dd|cc|ex|em)?",rB:!0,c:[t,r,{cN:"number",b:" *=",e:"-?\\d*\\.?\\d+(pt|pc|mm|cm|in|dd|cc|ex|em)?",eB:!0}],r:10},t,r,a,{cN:"formula",b:"\\$\\$",e:"\\$\\$",c:[t,r,a],r:0},{cN:"formula",b:"\\$",e:"\\$",c:[t,r,a],r:0},e.C("%","$",{r:0})]}}),hljs.registerLanguage("thrift",function(e){var t="bool byte i16 i32 i64 double string binary";return{k:{keyword:"namespace const typedef struct enum service exception void oneway set list map required optional",built_in:t,literal:"true false"},c:[e.QSM,e.NM,e.CLCM,e.CBCM,{cN:"class",bK:"struct enum service exception",e:/\{/,i:/\n/,c:[e.inherit(e.TM,{starts:{eW:!0,eE:!0}})]},{b:"\\b(set|list|map)\\s*<",e:">",k:t,c:["self"]}]}}),hljs.registerLanguage("twig",function(e){var t={cN:"params",b:"\\(",e:"\\)"},r="attribute block constant cycle date dump include max min parent random range source template_from_string",a={cN:"function",bK:r,r:0,c:[t]},i={cN:"filter",b:/\|[A-Za-z_]+:?/,k:"abs batch capitalize convert_encoding date date_modify default escape first format join json_encode keys last length lower merge nl2br number_format raw replace reverse round slice sort split striptags title trim upper url_encode",c:[a]},n="autoescape block do embed extends filter flush for if import include macro sandbox set spaceless use verbatim";return n=n+" "+n.split(" ").map(function(e){return"end"+e}).join(" "),{aliases:["craftcms"],cI:!0,sL:"xml",subLanguageMode:"continuous",c:[e.C(/\{#/,/#}/),{cN:"template_tag",b:/\{%/,e:/%}/,k:n,c:[i,a]},{cN:"variable",b:/\{\{/,e:/}}/,c:[i,a]}]}}),hljs.registerLanguage("typescript",function(e){return{aliases:["ts"],k:{keyword:"in if for while finally var new function|0 do return void else break catch instanceof with throw case default try this switch continue typeof delete let yield const class public private get set super interface extendsstatic constructor implements enum export import declare type protected",literal:"true false null undefined NaN Infinity",built_in:"eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent encodeURI encodeURIComponent escape unescape Object Function Boolean Error EvalError InternalError RangeError ReferenceError StopIteration SyntaxError TypeError URIError Number Math Date String RegExp Array Float32Array Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require module console window document any number boolean string void"},c:[{cN:"pi",b:/^\s*('|")use strict('|")/,r:0},e.ASM,e.QSM,e.CLCM,e.CBCM,e.CNM,{b:"("+e.RSR+"|\\b(case|return|throw)\\b)\\s*",k:"return throw case",c:[e.CLCM,e.CBCM,e.RM,{b:/</,e:/>;/,r:0,sL:"xml"}],r:0},{cN:"function",bK:"function",e:/\{/,eE:!0,c:[e.inherit(e.TM,{b:/[A-Za-z$_][0-9A-Za-z$_]*/}),{cN:"params",b:/\(/,e:/\)/,c:[e.CLCM,e.CBCM],i:/["'\(]/}],i:/\[|%/,r:0},{cN:"constructor",bK:"constructor",e:/\{/,eE:!0,r:10},{cN:"module",bK:"module",e:/\{/,eE:!0},{cN:"interface",bK:"interface",e:/\{/,eE:!0},{b:/\$[(.]/},{b:"\\."+e.IR,r:0}]}}),hljs.registerLanguage("vala",function(e){return{k:{keyword:"char uchar unichar int uint long ulong short ushort int8 int16 int32 int64 uint8 uint16 uint32 uint64 float double bool struct enum string void weak unowned owned async signal static abstract interface override while do for foreach else switch case break default return try catch public private protected internal using new this get set const stdout stdin stderr var",built_in:"DBus GLib CCode Gee Object",literal:"false true null"},c:[{cN:"class",bK:"class interface delegate namespace",e:"{",eE:!0,i:"[^,:\\n\\s\\.]",c:[e.UTM]},e.CLCM,e.CBCM,{cN:"string",b:'"""',e:'"""',r:5},e.ASM,e.QSM,e.CNM,{cN:"preprocessor",b:"^#",e:"$",r:2},{cN:"constant",b:" [A-Z_]+ ",r:0}]}}),hljs.registerLanguage("vbnet",function(e){return{aliases:["vb"],cI:!0,k:{keyword:"addhandler addressof alias and andalso aggregate ansi as assembly auto binary by byref byval call case catch class compare const continue custom declare default delegate dim distinct do each equals else elseif end enum erase error event exit explicit finally for friend from function get global goto group handles if implements imports in inherits interface into is isfalse isnot istrue join key let lib like loop me mid mod module mustinherit mustoverride mybase myclass namespace narrowing new next not notinheritable notoverridable of off on operator option optional or order orelse overloads overridable overrides paramarray partial preserve private property protected public raiseevent readonly redim rem removehandler resume return select set shadows shared skip static step stop structure strict sub synclock take text then throw to try unicode until using when where while widening with withevents writeonly xor",built_in:"boolean byte cbool cbyte cchar cdate cdec cdbl char cint clng cobj csbyte cshort csng cstr ctype date decimal directcast double gettype getxmlnamespace iif integer long object sbyte short single string trycast typeof uinteger ulong ushort",literal:"true false nothing"},i:"//|{|}|endif|gosub|variant|wend",c:[e.inherit(e.QSM,{c:[{b:'""'}]}),e.C("'","$",{rB:!0,c:[{cN:"xmlDocTag",b:"'''|<!--|-->",c:[e.PWM]},{cN:"xmlDocTag",b:"</?",e:">",c:[e.PWM]}]}),e.CNM,{cN:"preprocessor",b:"#",e:"$",k:"if else elseif end region externalsource"}]}}),hljs.registerLanguage("vbscript",function(e){return{aliases:["vbs"],cI:!0,k:{keyword:"call class const dim do loop erase execute executeglobal exit for each next function if then else on error option explicit new private property let get public randomize redim rem select case set stop sub while wend with end to elseif is or xor and not class_initialize class_terminate default preserve in me byval byref step resume goto",built_in:"lcase month vartype instrrev ubound setlocale getobject rgb getref string weekdayname rnd dateadd monthname now day minute isarray cbool round formatcurrency conversions csng timevalue second year space abs clng timeserial fixs len asc isempty maths dateserial atn timer isobject filter weekday datevalue ccur isdate instr datediff formatdatetime replace isnull right sgn array snumeric log cdbl hex chr lbound msgbox ucase getlocale cos cdate cbyte rtrim join hour oct typename trim strcomp int createobject loadpicture tan formatnumber mid scriptenginebuildversion scriptengine split scriptengineminorversion cint sin datepart ltrim sqr scriptenginemajorversion time derived eval date formatpercent exp inputbox left ascw chrw regexp server response request cstr err",literal:"true false null nothing empty"},i:"//",c:[e.inherit(e.QSM,{c:[{b:'""'}]}),e.C(/'/,/$/,{r:0}),e.CNM]}}),hljs.registerLanguage("vbscript-html",function(e){return{sL:"xml",subLanguageMode:"continuous",c:[{b:"<%",e:"%>",sL:"vbscript"}]}}),hljs.registerLanguage("verilog",function(e){return{aliases:["v"],cI:!0,k:{keyword:"always and assign begin buf bufif0 bufif1 case casex casez cmos deassign default defparam disable edge else end endcase endfunction endmodule endprimitive endspecify endtable endtask event for force forever fork function if ifnone initial inout input join macromodule module nand negedge nmos nor not notif0 notif1 or output parameter pmos posedge primitive pulldown pullup rcmos release repeat rnmos rpmos rtran rtranif0 rtranif1 specify specparam table task timescale tran tranif0 tranif1 wait while xnor xor",typename:"highz0 highz1 integer large medium pull0 pull1 real realtime reg scalared signed small strong0 strong1 supply0 supply0 supply1 supply1 time tri tri0 tri1 triand trior trireg vectored wand weak0 weak1 wire wor"},c:[e.CBCM,e.CLCM,e.QSM,{cN:"number",b:"\\b(\\d+'(b|h|o|d|B|H|O|D))?[0-9xzXZ]+",c:[e.BE],r:0},{cN:"typename",b:"\\.\\w+",r:0},{cN:"value",b:"#\\((?!parameter).+\\)"},{cN:"keyword",b:"\\+|-|\\*|/|%|<|>|=|#|`|\\!|&|\\||@|:|\\^|~|\\{|\\}",r:0}]}}),hljs.registerLanguage("vhdl",function(e){var t="\\d(_|\\d)*",r="[eE][-+]?"+t,a=t+"(\\."+t+")?("+r+")?",i="\\w+",n=t+"#"+i+"(\\."+i+")?#("+r+")?",o="\\b("+n+"|"+a+")";return{cI:!0,k:{keyword:"abs access after alias all and architecture array assert attribute begin block body buffer bus case component configuration constant context cover disconnect downto default else elsif end entity exit fairness file for force function generate generic group guarded if impure in inertial inout is label library linkage literal loop map mod nand new next nor not null of on open or others out package port postponed procedure process property protected pure range record register reject release rem report restrict restrict_guarantee return rol ror select sequence severity shared signal sla sll sra srl strong subtype then to transport type unaffected units until use variable vmode vprop vunit wait when while with xnor xor",typename:"boolean bit character severity_level integer time delay_length natural positive string bit_vector file_open_kind file_open_status std_ulogic std_ulogic_vector std_logic std_logic_vector unsigned signed boolean_vector integer_vector real_vector time_vector"},i:"{",c:[e.CBCM,e.C("--","$"),e.QSM,{cN:"number",b:o,r:0},{cN:"literal",b:"'(U|X|0|1|Z|W|L|H|-)'",c:[e.BE]},{cN:"attribute",b:"'[A-Za-z](_?[A-Za-z0-9])*",c:[e.BE]}]}}),hljs.registerLanguage("vim",function(e){return{l:/[!#@\w]+/,k:{keyword:"N|0 P|0 X|0 a|0 ab abc abo al am an|0 ar arga argd arge argdo argg argl argu as au aug aun b|0 bN ba bad bd be bel bf bl bm bn bo bp br brea breaka breakd breakl bro bufdo buffers bun bw c|0 cN cNf ca cabc caddb cad caddf cal cat cb cc ccl cd ce cex cf cfir cgetb cgete cg changes chd che checkt cl cla clo cm cmapc cme cn cnew cnf cno cnorea cnoreme co col colo com comc comp con conf cope cp cpf cq cr cs cst cu cuna cunme cw d|0 delm deb debugg delc delf dif diffg diffo diffp diffpu diffs diffthis dig di dl dell dj dli do doautoa dp dr ds dsp e|0 ea ec echoe echoh echom echon el elsei em en endfo endf endt endw ene ex exe exi exu f|0 files filet fin fina fini fir fix fo foldc foldd folddoc foldo for fu g|0 go gr grepa gu gv ha h|0 helpf helpg helpt hi hid his i|0 ia iabc if ij il im imapc ime ino inorea inoreme int is isp iu iuna iunme j|0 ju k|0 keepa kee keepj lN lNf l|0 lad laddb laddf la lan lat lb lc lch lcl lcs le lefta let lex lf lfir lgetb lgete lg lgr lgrepa lh ll lla lli lmak lm lmapc lne lnew lnf ln loadk lo loc lockv lol lope lp lpf lr ls lt lu lua luad luaf lv lvimgrepa lw m|0 ma mak map mapc marks mat me menut mes mk mks mksp mkv mkvie mod mz mzf nbc nb nbs n|0 new nm nmapc nme nn nnoreme noa no noh norea noreme norm nu nun nunme ol o|0 om omapc ome on ono onoreme opt ou ounme ow p|0 profd prof pro promptr pc ped pe perld po popu pp pre prev ps pt ptN ptf ptj ptl ptn ptp ptr pts pu pw py3 python3 py3d py3f py pyd pyf q|0 quita qa r|0 rec red redi redr redraws reg res ret retu rew ri rightb rub rubyd rubyf rund ru rv s|0 sN san sa sal sav sb sbN sba sbf sbl sbm sbn sbp sbr scrip scripte scs se setf setg setl sf sfir sh sim sig sil sl sla sm smap smapc sme sn sni sno snor snoreme sor so spelld spe spelli spellr spellu spellw sp spr sre st sta startg startr star stopi stj sts sun sunm sunme sus sv sw sy synti sync t|0 tN tabN tabc tabdo tabe tabf tabfir tabl tabm tabnew tabn tabo tabp tabr tabs tab ta tags tc tcld tclf te tf th tj tl tm tn to tp tr try ts tu u|0 undoj undol una unh unl unlo unm unme uns up v|0 ve verb vert vim vimgrepa vi viu vie vm vmapc vme vne vn vnoreme vs vu vunme windo w|0 wN wa wh wi winc winp wn wp wq wqa ws wu wv x|0 xa xmapc xm xme xn xnoreme xu xunme y|0 z|0 ~ Next Print append abbreviate abclear aboveleft all amenu anoremenu args argadd argdelete argedit argglobal arglocal argument ascii autocmd augroup aunmenu buffer bNext ball badd bdelete behave belowright bfirst blast bmodified bnext botright bprevious brewind break breakadd breakdel breaklist browse bunload bwipeout change cNext cNfile cabbrev cabclear caddbuffer caddexpr caddfile call catch cbuffer cclose center cexpr cfile cfirst cgetbuffer cgetexpr cgetfile chdir checkpath checktime clist clast close cmap cmapclear cmenu cnext cnewer cnfile cnoremap cnoreabbrev cnoremenu copy colder colorscheme command comclear compiler continue confirm copen cprevious cpfile cquit crewind cscope cstag cunmap cunabbrev cunmenu cwindow delete delmarks debug debuggreedy delcommand delfunction diffupdate diffget diffoff diffpatch diffput diffsplit digraphs display deletel djump dlist doautocmd doautoall deletep drop dsearch dsplit edit earlier echo echoerr echohl echomsg else elseif emenu endif endfor endfunction endtry endwhile enew execute exit exusage file filetype find finally finish first fixdel fold foldclose folddoopen folddoclosed foldopen function global goto grep grepadd gui gvim hardcopy help helpfind helpgrep helptags highlight hide history insert iabbrev iabclear ijump ilist imap imapclear imenu inoremap inoreabbrev inoremenu intro isearch isplit iunmap iunabbrev iunmenu join jumps keepalt keepmarks keepjumps lNext lNfile list laddexpr laddbuffer laddfile last language later lbuffer lcd lchdir lclose lcscope left leftabove lexpr lfile lfirst lgetbuffer lgetexpr lgetfile lgrep lgrepadd lhelpgrep llast llist lmake lmap lmapclear lnext lnewer lnfile lnoremap loadkeymap loadview lockmarks lockvar lolder lopen lprevious lpfile lrewind ltag lunmap luado luafile lvimgrep lvimgrepadd lwindow move mark make mapclear match menu menutranslate messages mkexrc mksession mkspell mkvimrc mkview mode mzscheme mzfile nbclose nbkey nbsart next nmap nmapclear nmenu nnoremap nnoremenu noautocmd noremap nohlsearch noreabbrev noremenu normal number nunmap nunmenu oldfiles open omap omapclear omenu only onoremap onoremenu options ounmap ounmenu ownsyntax print profdel profile promptfind promptrepl pclose pedit perl perldo pop popup ppop preserve previous psearch ptag ptNext ptfirst ptjump ptlast ptnext ptprevious ptrewind ptselect put pwd py3do py3file python pydo pyfile quit quitall qall read recover redo redir redraw redrawstatus registers resize retab return rewind right rightbelow ruby rubydo rubyfile rundo runtime rviminfo substitute sNext sandbox sargument sall saveas sbuffer sbNext sball sbfirst sblast sbmodified sbnext sbprevious sbrewind scriptnames scriptencoding scscope set setfiletype setglobal setlocal sfind sfirst shell simalt sign silent sleep slast smagic smapclear smenu snext sniff snomagic snoremap snoremenu sort source spelldump spellgood spellinfo spellrepall spellundo spellwrong split sprevious srewind stop stag startgreplace startreplace startinsert stopinsert stjump stselect sunhide sunmap sunmenu suspend sview swapname syntax syntime syncbind tNext tabNext tabclose tabedit tabfind tabfirst tablast tabmove tabnext tabonly tabprevious tabrewind tag tcl tcldo tclfile tearoff tfirst throw tjump tlast tmenu tnext topleft tprevious trewind tselect tunmenu undo undojoin undolist unabbreviate unhide unlet unlockvar unmap unmenu unsilent update vglobal version verbose vertical vimgrep vimgrepadd visual viusage view vmap vmapclear vmenu vnew vnoremap vnoremenu vsplit vunmap vunmenu write wNext wall while winsize wincmd winpos wnext wprevious wqall wsverb wundo wviminfo xit xall xmapclear xmap xmenu xnoremap xnoremenu xunmap xunmenu yank",built_in:"abs acos add and append argc argidx argv asin atan atan2 browse browsedir bufexists buflisted bufloaded bufname bufnr bufwinnr byte2line byteidx call ceil changenr char2nr cindent clearmatches col complete complete_add complete_check confirm copy cos cosh count cscope_connection cursor deepcopy delete did_filetype diff_filler diff_hlID empty escape eval eventhandler executable exists exp expand extend feedkeys filereadable filewritable filter finddir findfile float2nr floor fmod fnameescape fnamemodify foldclosed foldclosedend foldlevel foldtext foldtextresult foreground function garbagecollect get getbufline getbufvar getchar getcharmod getcmdline getcmdpos getcmdtype getcwd getfontname getfperm getfsize getftime getftype getline getloclist getmatches getpid getpos getqflist getreg getregtype gettabvar gettabwinvar getwinposx getwinposy getwinvar glob globpath has has_key haslocaldir hasmapto histadd histdel histget histnr hlexists hlID hostname iconv indent index input inputdialog inputlist inputrestore inputsave inputsecret insert invert isdirectory islocked items join keys len libcall libcallnr line line2byte lispindent localtime log log10 luaeval map maparg mapcheck match matchadd matcharg matchdelete matchend matchlist matchstr max min mkdir mode mzeval nextnonblank nr2char or pathshorten pow prevnonblank printf pumvisible py3eval pyeval range readfile reltime reltimestr remote_expr remote_foreground remote_peek remote_read remote_send remove rename repeat resolve reverse round screenattr screenchar screencol screenrow search searchdecl searchpair searchpairpos searchpos server2client serverlist setbufvar setcmdpos setline setloclist setmatches setpos setqflist setreg settabvar settabwinvar setwinvar sha256 shellescape shiftwidth simplify sin sinh sort soundfold spellbadword spellsuggest split sqrt str2float str2nr strchars strdisplaywidth strftime stridx string strlen strpart strridx strtrans strwidth submatch substitute synconcealed synID synIDattr synIDtrans synstack system tabpagebuflist tabpagenr tabpagewinnr tagfiles taglist tan tanh tempname tolower toupper tr trunc type undofile undotree values virtcol visualmode wildmenumode winbufnr wincol winheight winline winnr winrestcmd winrestview winsaveview winwidth writefile xor"},i:/[{:]/,c:[e.NM,e.ASM,{cN:"string",b:/"((\\")|[^"\n])*("|\n)/},{cN:"variable",b:/[bwtglsav]:[\w\d_]*/},{cN:"function",bK:"function function!",e:"$",r:0,c:[e.TM,{cN:"params",b:"\\(",e:"\\)"}]}]}}),hljs.registerLanguage("x86asm",function(e){return{cI:!0,l:"\\.?"+e.IR,k:{keyword:"lock rep repe repz repne repnz xaquire xrelease bnd nobnd aaa aad aam aas adc add and arpl bb0_reset bb1_reset bound bsf bsr bswap bt btc btr bts call cbw cdq cdqe clc cld cli clts cmc cmp cmpsb cmpsd cmpsq cmpsw cmpxchg cmpxchg486 cmpxchg8b cmpxchg16b cpuid cpu_read cpu_write cqo cwd cwde daa das dec div dmint emms enter equ f2xm1 fabs fadd faddp fbld fbstp fchs fclex fcmovb fcmovbe fcmove fcmovnb fcmovnbe fcmovne fcmovnu fcmovu fcom fcomi fcomip fcomp fcompp fcos fdecstp fdisi fdiv fdivp fdivr fdivrp femms feni ffree ffreep fiadd ficom ficomp fidiv fidivr fild fimul fincstp finit fist fistp fisttp fisub fisubr fld fld1 fldcw fldenv fldl2e fldl2t fldlg2 fldln2 fldpi fldz fmul fmulp fnclex fndisi fneni fninit fnop fnsave fnstcw fnstenv fnstsw fpatan fprem fprem1 fptan frndint frstor fsave fscale fsetpm fsin fsincos fsqrt fst fstcw fstenv fstp fstsw fsub fsubp fsubr fsubrp ftst fucom fucomi fucomip fucomp fucompp fxam fxch fxtract fyl2x fyl2xp1 hlt ibts icebp idiv imul in inc incbin insb insd insw int int01 int1 int03 int3 into invd invpcid invlpg invlpga iret iretd iretq iretw jcxz jecxz jrcxz jmp jmpe lahf lar lds lea leave les lfence lfs lgdt lgs lidt lldt lmsw loadall loadall286 lodsb lodsd lodsq lodsw loop loope loopne loopnz loopz lsl lss ltr mfence monitor mov movd movq movsb movsd movsq movsw movsx movsxd movzx mul mwait neg nop not or out outsb outsd outsw packssdw packsswb packuswb paddb paddd paddsb paddsiw paddsw paddusb paddusw paddw pand pandn pause paveb pavgusb pcmpeqb pcmpeqd pcmpeqw pcmpgtb pcmpgtd pcmpgtw pdistib pf2id pfacc pfadd pfcmpeq pfcmpge pfcmpgt pfmax pfmin pfmul pfrcp pfrcpit1 pfrcpit2 pfrsqit1 pfrsqrt pfsub pfsubr pi2fd pmachriw pmaddwd pmagw pmulhriw pmulhrwa pmulhrwc pmulhw pmullw pmvgezb pmvlzb pmvnzb pmvzb pop popa popad popaw popf popfd popfq popfw por prefetch prefetchw pslld psllq psllw psrad psraw psrld psrlq psrlw psubb psubd psubsb psubsiw psubsw psubusb psubusw psubw punpckhbw punpckhdq punpckhwd punpcklbw punpckldq punpcklwd push pusha pushad pushaw pushf pushfd pushfq pushfw pxor rcl rcr rdshr rdmsr rdpmc rdtsc rdtscp ret retf retn rol ror rdm rsdc rsldt rsm rsts sahf sal salc sar sbb scasb scasd scasq scasw sfence sgdt shl shld shr shrd sidt sldt skinit smi smint smintold smsw stc std sti stosb stosd stosq stosw str sub svdc svldt svts swapgs syscall sysenter sysexit sysret test ud0 ud1 ud2b ud2 ud2a umov verr verw fwait wbinvd wrshr wrmsr xadd xbts xchg xlatb xlat xor cmove cmovz cmovne cmovnz cmova cmovnbe cmovae cmovnb cmovb cmovnae cmovbe cmovna cmovg cmovnle cmovge cmovnl cmovl cmovnge cmovle cmovng cmovc cmovnc cmovo cmovno cmovs cmovns cmovp cmovpe cmovnp cmovpo je jz jne jnz ja jnbe jae jnb jb jnae jbe jna jg jnle jge jnl jl jnge jle jng jc jnc jo jno js jns jpo jnp jpe jp sete setz setne setnz seta setnbe setae setnb setnc setb setnae setcset setbe setna setg setnle setge setnl setl setnge setle setng sets setns seto setno setpe setp setpo setnp addps addss andnps andps cmpeqps cmpeqss cmpleps cmpless cmpltps cmpltss cmpneqps cmpneqss cmpnleps cmpnless cmpnltps cmpnltss cmpordps cmpordss cmpunordps cmpunordss cmpps cmpss comiss cvtpi2ps cvtps2pi cvtsi2ss cvtss2si cvttps2pi cvttss2si divps divss ldmxcsr maxps maxss minps minss movaps movhps movlhps movlps movhlps movmskps movntps movss movups mulps mulss orps rcpps rcpss rsqrtps rsqrtss shufps sqrtps sqrtss stmxcsr subps subss ucomiss unpckhps unpcklps xorps fxrstor fxrstor64 fxsave fxsave64 xgetbv xsetbv xsave xsave64 xsaveopt xsaveopt64 xrstor xrstor64 prefetchnta prefetcht0 prefetcht1 prefetcht2 maskmovq movntq pavgb pavgw pextrw pinsrw pmaxsw pmaxub pminsw pminub pmovmskb pmulhuw psadbw pshufw pf2iw pfnacc pfpnacc pi2fw pswapd maskmovdqu clflush movntdq movnti movntpd movdqa movdqu movdq2q movq2dq paddq pmuludq pshufd pshufhw pshuflw pslldq psrldq psubq punpckhqdq punpcklqdq addpd addsd andnpd andpd cmpeqpd cmpeqsd cmplepd cmplesd cmpltpd cmpltsd cmpneqpd cmpneqsd cmpnlepd cmpnlesd cmpnltpd cmpnltsd cmpordpd cmpordsd cmpunordpd cmpunordsd cmppd comisd cvtdq2pd cvtdq2ps cvtpd2dq cvtpd2pi cvtpd2ps cvtpi2pd cvtps2dq cvtps2pd cvtsd2si cvtsd2ss cvtsi2sd cvtss2sd cvttpd2pi cvttpd2dq cvttps2dq cvttsd2si divpd divsd maxpd maxsd minpd minsd movapd movhpd movlpd movmskpd movupd mulpd mulsd orpd shufpd sqrtpd sqrtsd subpd subsd ucomisd unpckhpd unpcklpd xorpd addsubpd addsubps haddpd haddps hsubpd hsubps lddqu movddup movshdup movsldup clgi stgi vmcall vmclear vmfunc vmlaunch vmload vmmcall vmptrld vmptrst vmread vmresume vmrun vmsave vmwrite vmxoff vmxon invept invvpid pabsb pabsw pabsd palignr phaddw phaddd phaddsw phsubw phsubd phsubsw pmaddubsw pmulhrsw pshufb psignb psignw psignd extrq insertq movntsd movntss lzcnt blendpd blendps blendvpd blendvps dppd dpps extractps insertps movntdqa mpsadbw packusdw pblendvb pblendw pcmpeqq pextrb pextrd pextrq phminposuw pinsrb pinsrd pinsrq pmaxsb pmaxsd pmaxud pmaxuw pminsb pminsd pminud pminuw pmovsxbw pmovsxbd pmovsxbq pmovsxwd pmovsxwq pmovsxdq pmovzxbw pmovzxbd pmovzxbq pmovzxwd pmovzxwq pmovzxdq pmuldq pmulld ptest roundpd roundps roundsd roundss crc32 pcmpestri pcmpestrm pcmpistri pcmpistrm pcmpgtq popcnt getsec pfrcpv pfrsqrtv movbe aesenc aesenclast aesdec aesdeclast aesimc aeskeygenassist vaesenc vaesenclast vaesdec vaesdeclast vaesimc vaeskeygenassist vaddpd vaddps vaddsd vaddss vaddsubpd vaddsubps vandpd vandps vandnpd vandnps vblendpd vblendps vblendvpd vblendvps vbroadcastss vbroadcastsd vbroadcastf128 vcmpeq_ospd vcmpeqpd vcmplt_ospd vcmpltpd vcmple_ospd vcmplepd vcmpunord_qpd vcmpunordpd vcmpneq_uqpd vcmpneqpd vcmpnlt_uspd vcmpnltpd vcmpnle_uspd vcmpnlepd vcmpord_qpd vcmpordpd vcmpeq_uqpd vcmpnge_uspd vcmpngepd vcmpngt_uspd vcmpngtpd vcmpfalse_oqpd vcmpfalsepd vcmpneq_oqpd vcmpge_ospd vcmpgepd vcmpgt_ospd vcmpgtpd vcmptrue_uqpd vcmptruepd vcmplt_oqpd vcmple_oqpd vcmpunord_spd vcmpneq_uspd vcmpnlt_uqpd vcmpnle_uqpd vcmpord_spd vcmpeq_uspd vcmpnge_uqpd vcmpngt_uqpd vcmpfalse_ospd vcmpneq_ospd vcmpge_oqpd vcmpgt_oqpd vcmptrue_uspd vcmppd vcmpeq_osps vcmpeqps vcmplt_osps vcmpltps vcmple_osps vcmpleps vcmpunord_qps vcmpunordps vcmpneq_uqps vcmpneqps vcmpnlt_usps vcmpnltps vcmpnle_usps vcmpnleps vcmpord_qps vcmpordps vcmpeq_uqps vcmpnge_usps vcmpngeps vcmpngt_usps vcmpngtps vcmpfalse_oqps vcmpfalseps vcmpneq_oqps vcmpge_osps vcmpgeps vcmpgt_osps vcmpgtps vcmptrue_uqps vcmptrueps vcmplt_oqps vcmple_oqps vcmpunord_sps vcmpneq_usps vcmpnlt_uqps vcmpnle_uqps vcmpord_sps vcmpeq_usps vcmpnge_uqps vcmpngt_uqps vcmpfalse_osps vcmpneq_osps vcmpge_oqps vcmpgt_oqps vcmptrue_usps vcmpps vcmpeq_ossd vcmpeqsd vcmplt_ossd vcmpltsd vcmple_ossd vcmplesd vcmpunord_qsd vcmpunordsd vcmpneq_uqsd vcmpneqsd vcmpnlt_ussd vcmpnltsd vcmpnle_ussd vcmpnlesd vcmpord_qsd vcmpordsd vcmpeq_uqsd vcmpnge_ussd vcmpngesd vcmpngt_ussd vcmpngtsd vcmpfalse_oqsd vcmpfalsesd vcmpneq_oqsd vcmpge_ossd vcmpgesd vcmpgt_ossd vcmpgtsd vcmptrue_uqsd vcmptruesd vcmplt_oqsd vcmple_oqsd vcmpunord_ssd vcmpneq_ussd vcmpnlt_uqsd vcmpnle_uqsd vcmpord_ssd vcmpeq_ussd vcmpnge_uqsd vcmpngt_uqsd vcmpfalse_ossd vcmpneq_ossd vcmpge_oqsd vcmpgt_oqsd vcmptrue_ussd vcmpsd vcmpeq_osss vcmpeqss vcmplt_osss vcmpltss vcmple_osss vcmpless vcmpunord_qss vcmpunordss vcmpneq_uqss vcmpneqss vcmpnlt_usss vcmpnltss vcmpnle_usss vcmpnless vcmpord_qss vcmpordss vcmpeq_uqss vcmpnge_usss vcmpngess vcmpngt_usss vcmpngtss vcmpfalse_oqss vcmpfalsess vcmpneq_oqss vcmpge_osss vcmpgess vcmpgt_osss vcmpgtss vcmptrue_uqss vcmptruess vcmplt_oqss vcmple_oqss vcmpunord_sss vcmpneq_usss vcmpnlt_uqss vcmpnle_uqss vcmpord_sss vcmpeq_usss vcmpnge_uqss vcmpngt_uqss vcmpfalse_osss vcmpneq_osss vcmpge_oqss vcmpgt_oqss vcmptrue_usss vcmpss vcomisd vcomiss vcvtdq2pd vcvtdq2ps vcvtpd2dq vcvtpd2ps vcvtps2dq vcvtps2pd vcvtsd2si vcvtsd2ss vcvtsi2sd vcvtsi2ss vcvtss2sd vcvtss2si vcvttpd2dq vcvttps2dq vcvttsd2si vcvttss2si vdivpd vdivps vdivsd vdivss vdppd vdpps vextractf128 vextractps vhaddpd vhaddps vhsubpd vhsubps vinsertf128 vinsertps vlddqu vldqqu vldmxcsr vmaskmovdqu vmaskmovps vmaskmovpd vmaxpd vmaxps vmaxsd vmaxss vminpd vminps vminsd vminss vmovapd vmovaps vmovd vmovq vmovddup vmovdqa vmovqqa vmovdqu vmovqqu vmovhlps vmovhpd vmovhps vmovlhps vmovlpd vmovlps vmovmskpd vmovmskps vmovntdq vmovntqq vmovntdqa vmovntpd vmovntps vmovsd vmovshdup vmovsldup vmovss vmovupd vmovups vmpsadbw vmulpd vmulps vmulsd vmulss vorpd vorps vpabsb vpabsw vpabsd vpacksswb vpackssdw vpackuswb vpackusdw vpaddb vpaddw vpaddd vpaddq vpaddsb vpaddsw vpaddusb vpaddusw vpalignr vpand vpandn vpavgb vpavgw vpblendvb vpblendw vpcmpestri vpcmpestrm vpcmpistri vpcmpistrm vpcmpeqb vpcmpeqw vpcmpeqd vpcmpeqq vpcmpgtb vpcmpgtw vpcmpgtd vpcmpgtq vpermilpd vpermilps vperm2f128 vpextrb vpextrw vpextrd vpextrq vphaddw vphaddd vphaddsw vphminposuw vphsubw vphsubd vphsubsw vpinsrb vpinsrw vpinsrd vpinsrq vpmaddwd vpmaddubsw vpmaxsb vpmaxsw vpmaxsd vpmaxub vpmaxuw vpmaxud vpminsb vpminsw vpminsd vpminub vpminuw vpminud vpmovmskb vpmovsxbw vpmovsxbd vpmovsxbq vpmovsxwd vpmovsxwq vpmovsxdq vpmovzxbw vpmovzxbd vpmovzxbq vpmovzxwd vpmovzxwq vpmovzxdq vpmulhuw vpmulhrsw vpmulhw vpmullw vpmulld vpmuludq vpmuldq vpor vpsadbw vpshufb vpshufd vpshufhw vpshuflw vpsignb vpsignw vpsignd vpslldq vpsrldq vpsllw vpslld vpsllq vpsraw vpsrad vpsrlw vpsrld vpsrlq vptest vpsubb vpsubw vpsubd vpsubq vpsubsb vpsubsw vpsubusb vpsubusw vpunpckhbw vpunpckhwd vpunpckhdq vpunpckhqdq vpunpcklbw vpunpcklwd vpunpckldq vpunpcklqdq vpxor vrcpps vrcpss vrsqrtps vrsqrtss vroundpd vroundps vroundsd vroundss vshufpd vshufps vsqrtpd vsqrtps vsqrtsd vsqrtss vstmxcsr vsubpd vsubps vsubsd vsubss vtestps vtestpd vucomisd vucomiss vunpckhpd vunpckhps vunpcklpd vunpcklps vxorpd vxorps vzeroall vzeroupper pclmullqlqdq pclmulhqlqdq pclmullqhqdq pclmulhqhqdq pclmulqdq vpclmullqlqdq vpclmulhqlqdq vpclmullqhqdq vpclmulhqhqdq vpclmulqdq vfmadd132ps vfmadd132pd vfmadd312ps vfmadd312pd vfmadd213ps vfmadd213pd vfmadd123ps vfmadd123pd vfmadd231ps vfmadd231pd vfmadd321ps vfmadd321pd vfmaddsub132ps vfmaddsub132pd vfmaddsub312ps vfmaddsub312pd vfmaddsub213ps vfmaddsub213pd vfmaddsub123ps vfmaddsub123pd vfmaddsub231ps vfmaddsub231pd vfmaddsub321ps vfmaddsub321pd vfmsub132ps vfmsub132pd vfmsub312ps vfmsub312pd vfmsub213ps vfmsub213pd vfmsub123ps vfmsub123pd vfmsub231ps vfmsub231pd vfmsub321ps vfmsub321pd vfmsubadd132ps vfmsubadd132pd vfmsubadd312ps vfmsubadd312pd vfmsubadd213ps vfmsubadd213pd vfmsubadd123ps vfmsubadd123pd vfmsubadd231ps vfmsubadd231pd vfmsubadd321ps vfmsubadd321pd vfnmadd132ps vfnmadd132pd vfnmadd312ps vfnmadd312pd vfnmadd213ps vfnmadd213pd vfnmadd123ps vfnmadd123pd vfnmadd231ps vfnmadd231pd vfnmadd321ps vfnmadd321pd vfnmsub132ps vfnmsub132pd vfnmsub312ps vfnmsub312pd vfnmsub213ps vfnmsub213pd vfnmsub123ps vfnmsub123pd vfnmsub231ps vfnmsub231pd vfnmsub321ps vfnmsub321pd vfmadd132ss vfmadd132sd vfmadd312ss vfmadd312sd vfmadd213ss vfmadd213sd vfmadd123ss vfmadd123sd vfmadd231ss vfmadd231sd vfmadd321ss vfmadd321sd vfmsub132ss vfmsub132sd vfmsub312ss vfmsub312sd vfmsub213ss vfmsub213sd vfmsub123ss vfmsub123sd vfmsub231ss vfmsub231sd vfmsub321ss vfmsub321sd vfnmadd132ss vfnmadd132sd vfnmadd312ss vfnmadd312sd vfnmadd213ss vfnmadd213sd vfnmadd123ss vfnmadd123sd vfnmadd231ss vfnmadd231sd vfnmadd321ss vfnmadd321sd vfnmsub132ss vfnmsub132sd vfnmsub312ss vfnmsub312sd vfnmsub213ss vfnmsub213sd vfnmsub123ss vfnmsub123sd vfnmsub231ss vfnmsub231sd vfnmsub321ss vfnmsub321sd rdfsbase rdgsbase rdrand wrfsbase wrgsbase vcvtph2ps vcvtps2ph adcx adox rdseed clac stac xstore xcryptecb xcryptcbc xcryptctr xcryptcfb xcryptofb montmul xsha1 xsha256 llwpcb slwpcb lwpval lwpins vfmaddpd vfmaddps vfmaddsd vfmaddss vfmaddsubpd vfmaddsubps vfmsubaddpd vfmsubaddps vfmsubpd vfmsubps vfmsubsd vfmsubss vfnmaddpd vfnmaddps vfnmaddsd vfnmaddss vfnmsubpd vfnmsubps vfnmsubsd vfnmsubss vfrczpd vfrczps vfrczsd vfrczss vpcmov vpcomb vpcomd vpcomq vpcomub vpcomud vpcomuq vpcomuw vpcomw vphaddbd vphaddbq vphaddbw vphadddq vphaddubd vphaddubq vphaddubw vphaddudq vphadduwd vphadduwq vphaddwd vphaddwq vphsubbw vphsubdq vphsubwd vpmacsdd vpmacsdqh vpmacsdql vpmacssdd vpmacssdqh vpmacssdql vpmacsswd vpmacssww vpmacswd vpmacsww vpmadcsswd vpmadcswd vpperm vprotb vprotd vprotq vprotw vpshab vpshad vpshaq vpshaw vpshlb vpshld vpshlq vpshlw vbroadcasti128 vpblendd vpbroadcastb vpbroadcastw vpbroadcastd vpbroadcastq vpermd vpermpd vpermps vpermq vperm2i128 vextracti128 vinserti128 vpmaskmovd vpmaskmovq vpsllvd vpsllvq vpsravd vpsrlvd vpsrlvq vgatherdpd vgatherqpd vgatherdps vgatherqps vpgatherdd vpgatherqd vpgatherdq vpgatherqq xabort xbegin xend xtest andn bextr blci blcic blsi blsic blcfill blsfill blcmsk blsmsk blsr blcs bzhi mulx pdep pext rorx sarx shlx shrx tzcnt tzmsk t1mskc valignd valignq vblendmpd vblendmps vbroadcastf32x4 vbroadcastf64x4 vbroadcasti32x4 vbroadcasti64x4 vcompresspd vcompressps vcvtpd2udq vcvtps2udq vcvtsd2usi vcvtss2usi vcvttpd2udq vcvttps2udq vcvttsd2usi vcvttss2usi vcvtudq2pd vcvtudq2ps vcvtusi2sd vcvtusi2ss vexpandpd vexpandps vextractf32x4 vextractf64x4 vextracti32x4 vextracti64x4 vfixupimmpd vfixupimmps vfixupimmsd vfixupimmss vgetexppd vgetexpps vgetexpsd vgetexpss vgetmantpd vgetmantps vgetmantsd vgetmantss vinsertf32x4 vinsertf64x4 vinserti32x4 vinserti64x4 vmovdqa32 vmovdqa64 vmovdqu32 vmovdqu64 vpabsq vpandd vpandnd vpandnq vpandq vpblendmd vpblendmq vpcmpltd vpcmpled vpcmpneqd vpcmpnltd vpcmpnled vpcmpd vpcmpltq vpcmpleq vpcmpneqq vpcmpnltq vpcmpnleq vpcmpq vpcmpequd vpcmpltud vpcmpleud vpcmpnequd vpcmpnltud vpcmpnleud vpcmpud vpcmpequq vpcmpltuq vpcmpleuq vpcmpnequq vpcmpnltuq vpcmpnleuq vpcmpuq vpcompressd vpcompressq vpermi2d vpermi2pd vpermi2ps vpermi2q vpermt2d vpermt2pd vpermt2ps vpermt2q vpexpandd vpexpandq vpmaxsq vpmaxuq vpminsq vpminuq vpmovdb vpmovdw vpmovqb vpmovqd vpmovqw vpmovsdb vpmovsdw vpmovsqb vpmovsqd vpmovsqw vpmovusdb vpmovusdw vpmovusqb vpmovusqd vpmovusqw vpord vporq vprold vprolq vprolvd vprolvq vprord vprorq vprorvd vprorvq vpscatterdd vpscatterdq vpscatterqd vpscatterqq vpsraq vpsravq vpternlogd vpternlogq vptestmd vptestmq vptestnmd vptestnmq vpxord vpxorq vrcp14pd vrcp14ps vrcp14sd vrcp14ss vrndscalepd vrndscaleps vrndscalesd vrndscaless vrsqrt14pd vrsqrt14ps vrsqrt14sd vrsqrt14ss vscalefpd vscalefps vscalefsd vscalefss vscatterdpd vscatterdps vscatterqpd vscatterqps vshuff32x4 vshuff64x2 vshufi32x4 vshufi64x2 kandnw kandw kmovw knotw kortestw korw kshiftlw kshiftrw kunpckbw kxnorw kxorw vpbroadcastmb2q vpbroadcastmw2d vpconflictd vpconflictq vplzcntd vplzcntq vexp2pd vexp2ps vrcp28pd vrcp28ps vrcp28sd vrcp28ss vrsqrt28pd vrsqrt28ps vrsqrt28sd vrsqrt28ss vgatherpf0dpd vgatherpf0dps vgatherpf0qpd vgatherpf0qps vgatherpf1dpd vgatherpf1dps vgatherpf1qpd vgatherpf1qps vscatterpf0dpd vscatterpf0dps vscatterpf0qpd vscatterpf0qps vscatterpf1dpd vscatterpf1dps vscatterpf1qpd vscatterpf1qps prefetchwt1 bndmk bndcl bndcu bndcn bndmov bndldx bndstx sha1rnds4 sha1nexte sha1msg1 sha1msg2 sha256rnds2 sha256msg1 sha256msg2 hint_nop0 hint_nop1 hint_nop2 hint_nop3 hint_nop4 hint_nop5 hint_nop6 hint_nop7 hint_nop8 hint_nop9 hint_nop10 hint_nop11 hint_nop12 hint_nop13 hint_nop14 hint_nop15 hint_nop16 hint_nop17 hint_nop18 hint_nop19 hint_nop20 hint_nop21 hint_nop22 hint_nop23 hint_nop24 hint_nop25 hint_nop26 hint_nop27 hint_nop28 hint_nop29 hint_nop30 hint_nop31 hint_nop32 hint_nop33 hint_nop34 hint_nop35 hint_nop36 hint_nop37 hint_nop38 hint_nop39 hint_nop40 hint_nop41 hint_nop42 hint_nop43 hint_nop44 hint_nop45 hint_nop46 hint_nop47 hint_nop48 hint_nop49 hint_nop50 hint_nop51 hint_nop52 hint_nop53 hint_nop54 hint_nop55 hint_nop56 hint_nop57 hint_nop58 hint_nop59 hint_nop60 hint_nop61 hint_nop62 hint_nop63",
literal:"ip eip rip al ah bl bh cl ch dl dh sil dil bpl spl r8b r9b r10b r11b r12b r13b r14b r15b ax bx cx dx si di bp sp r8w r9w r10w r11w r12w r13w r14w r15w eax ebx ecx edx esi edi ebp esp eip r8d r9d r10d r11d r12d r13d r14d r15d rax rbx rcx rdx rsi rdi rbp rsp r8 r9 r10 r11 r12 r13 r14 r15 cs ds es fs gs ss st st0 st1 st2 st3 st4 st5 st6 st7 mm0 mm1 mm2 mm3 mm4 mm5 mm6 mm7 xmm0  xmm1  xmm2  xmm3  xmm4  xmm5  xmm6  xmm7  xmm8  xmm9 xmm10  xmm11 xmm12 xmm13 xmm14 xmm15 xmm16 xmm17 xmm18 xmm19 xmm20 xmm21 xmm22 xmm23 xmm24 xmm25 xmm26 xmm27 xmm28 xmm29 xmm30 xmm31 ymm0  ymm1  ymm2  ymm3  ymm4  ymm5  ymm6  ymm7  ymm8  ymm9 ymm10  ymm11 ymm12 ymm13 ymm14 ymm15 ymm16 ymm17 ymm18 ymm19 ymm20 ymm21 ymm22 ymm23 ymm24 ymm25 ymm26 ymm27 ymm28 ymm29 ymm30 ymm31 zmm0  zmm1  zmm2  zmm3  zmm4  zmm5  zmm6  zmm7  zmm8  zmm9 zmm10  zmm11 zmm12 zmm13 zmm14 zmm15 zmm16 zmm17 zmm18 zmm19 zmm20 zmm21 zmm22 zmm23 zmm24 zmm25 zmm26 zmm27 zmm28 zmm29 zmm30 zmm31 k0 k1 k2 k3 k4 k5 k6 k7 bnd0 bnd1 bnd2 bnd3 cr0 cr1 cr2 cr3 cr4 cr8 dr0 dr1 dr2 dr3 dr8 tr3 tr4 tr5 tr6 tr7 r0 r1 r2 r3 r4 r5 r6 r7 r0b r1b r2b r3b r4b r5b r6b r7b r0w r1w r2w r3w r4w r5w r6w r7w r0d r1d r2d r3d r4d r5d r6d r7d r0h r1h r2h r3h r0l r1l r2l r3l r4l r5l r6l r7l r8l r9l r10l r11l r12l r13l r14l r15l",pseudo:"db dw dd dq dt ddq do dy dz resb resw resd resq rest resdq reso resy resz incbin equ times",preprocessor:"%define %xdefine %+ %undef %defstr %deftok %assign %strcat %strlen %substr %rotate %elif %else %endif %ifmacro %ifctx %ifidn %ifidni %ifid %ifnum %ifstr %iftoken %ifempty %ifenv %error %warning %fatal %rep %endrep %include %push %pop %repl %pathsearch %depend %use %arg %stacksize %local %line %comment %endcomment .nolist byte word dword qword nosplit rel abs seg wrt strict near far a32 ptr __FILE__ __LINE__ __SECT__  __BITS__ __OUTPUT_FORMAT__ __DATE__ __TIME__ __DATE_NUM__ __TIME_NUM__ __UTC_DATE__ __UTC_TIME__ __UTC_DATE_NUM__ __UTC_TIME_NUM__  __PASS__ struc endstruc istruc at iend align alignb sectalign daz nodaz up down zero default option assume public ",built_in:"bits use16 use32 use64 default section segment absolute extern global common cpu float __utf16__ __utf16le__ __utf16be__ __utf32__ __utf32le__ __utf32be__ __float8__ __float16__ __float32__ __float64__ __float80m__ __float80e__ __float128l__ __float128h__ __Infinity__ __QNaN__ __SNaN__ Inf NaN QNaN SNaN float8 float16 float32 float64 float80m float80e float128l float128h __FLOAT_DAZ__ __FLOAT_ROUND__ __FLOAT__"},c:[e.C(";","$",{r:0}),{cN:"number",b:"\\b(?:([0-9][0-9_]*)?\\.[0-9_]*(?:[eE][+-]?[0-9_]+)?|(0[Xx])?[0-9][0-9_]*\\.?[0-9_]*(?:[pP](?:[+-]?[0-9_]+)?)?)\\b",r:0},{cN:"number",b:"\\$[0-9][0-9A-Fa-f]*",r:0},{cN:"number",b:"\\b(?:[0-9A-Fa-f][0-9A-Fa-f_]*[HhXx]|[0-9][0-9_]*[DdTt]?|[0-7][0-7_]*[QqOo]|[0-1][0-1_]*[BbYy])\\b"},{cN:"number",b:"\\b(?:0[HhXx][0-9A-Fa-f_]+|0[DdTt][0-9_]+|0[QqOo][0-7_]+|0[BbYy][0-1_]+)\\b"},e.QSM,{cN:"string",b:"'",e:"[^\\\\]'",r:0},{cN:"string",b:"`",e:"[^\\\\]`",r:0},{cN:"string",b:"\\.[A-Za-z0-9]+",r:0},{cN:"label",b:"^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)",r:0},{cN:"label",b:"^\\s*%%[A-Za-z0-9_$#@~.?]*:",r:0},{cN:"argument",b:"%[0-9]+",r:0},{cN:"built_in",b:"%!S+",r:0}]}}),hljs.registerLanguage("xl",function(e){var t="ObjectLoader Animate MovieCredits Slides Filters Shading Materials LensFlare Mapping VLCAudioVideo StereoDecoder PointCloud NetworkAccess RemoteControl RegExp ChromaKey Snowfall NodeJS Speech Charts",r={keyword:"if then else do while until for loop import with is as where when by data constant",literal:"true false nil",type:"integer real text name boolean symbol infix prefix postfix block tree",built_in:"in mod rem and or xor not abs sign floor ceil sqrt sin cos tan asin acos atan exp expm1 log log2 log10 log1p pi at",module:t,id:"text_length text_range text_find text_replace contains page slide basic_slide title_slide title subtitle fade_in fade_out fade_at clear_color color line_color line_width texture_wrap texture_transform texture scale_?x scale_?y scale_?z? translate_?x translate_?y translate_?z? rotate_?x rotate_?y rotate_?z? rectangle circle ellipse sphere path line_to move_to quad_to curve_to theme background contents locally time mouse_?x mouse_?y mouse_buttons"},a={cN:"constant",b:"[A-Z][A-Z_0-9]+",r:0},i={cN:"variable",b:"([A-Z][a-z_0-9]+)+",r:0},n={cN:"id",b:"[a-z][a-z_0-9]+",r:0},o={cN:"string",b:'"',e:'"',i:"\\n"},s={cN:"string",b:"'",e:"'",i:"\\n"},l={cN:"string",b:"<<",e:">>"},c={cN:"number",b:"[0-9]+#[0-9A-Z_]+(\\.[0-9-A-Z_]+)?#?([Ee][+-]?[0-9]+)?",r:10},d={cN:"import",bK:"import",e:"$",k:{keyword:"import",module:t},r:0,c:[o]},p={cN:"function",b:"[a-z].*->"};return{aliases:["tao"],l:/[a-zA-Z][a-zA-Z0-9_?]*/,k:r,c:[e.CLCM,e.CBCM,o,s,l,p,d,a,i,n,c,e.NM]}});;
(function(root) {
	"use strict";

	function codeHighlightLinenums(code, opts) {
		opts = opts || {};
		var hljs = opts.hljs,
			lang = opts.lang,
			start = opts.start || 0;
		// prevent errors by hljs
		code = code || '';
		if(lang && /:/.test(lang)) {
			start = +lang.split(/:/)[1];
			lang = lang.split(/:/)[0];
		} else {
			start = +start;
		}

		if(lang && hljs) {
			code = hljs.highlight(lang, code).value;
		}

		if(start) {
			// move all closing spans to the previous line
			code = code.replace(/([\r\n]\s*)(<\/span>)/ig, '$2$1');

			// replace spans with line-wraps inside them
			code = cleanLineBreaks(code);

			code = code.split(/\r\n|\r|\n/);
			var max = (start + code.length).toString().length;

			code = code
				.map(function(line, i) {
					return '<span class="line width-' + max + '" start="' + (start + i) + '">' + line + '</span>';
				})
				.join('\n');
		}

		return code;
	}

	// Simplified parser that looks for opening & closing spans, and walks the tree.
	// If there are any unclosed spans when a newline is encountered, we close them on the previous line,
	// and copy them forward to the next line.
	function cleanLineBreaks(code) {
		var openSpans = [],
			matcher = /<\/?span[^>]*>|\r\n|\r|\n/ig,
			newline = /\r\n|\r|\n/,
			closingTag = /^<\//;

		return code.replace(matcher, function(match) {
			if(newline.test(match)) {
				if(openSpans.length) {
					return openSpans.map(function() { return '</span>' }).join('') + match + openSpans.join('');
				} else {
					return match;
				}
			} else if(closingTag.test(match)) {
				openSpans.pop();
				return match;
			} else {
				openSpans.push(match);
				return match;
			}
		});
	}

	(function(factory) {
		if(typeof define === 'function' && define.amd) {
			// AMD. Register as an anonymous module.
			define(factory)
		} else if(typeof exports === 'object') {
			/**
			 * Node. Does not work with strict CommonJS, but
			 * only CommonJS-like environments that support module.exports,
			 * like Node.
			 */
			module.exports = factory();
		} else {
			// Browser globals (root is window)
			root.codeHighlightLinenums = factory();
		}
	}(function() {
		/**
		 * Just return a value to define the module export.
		 * This example returns an object, but the module
		 * can return a function as the exported value.
		 */
		return codeHighlightLinenums;
	}))

})(this);;
/**
 * marked - a markdown parser
 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/chjj/marked
 */

;(function() {

/**
 * Block-Level Grammar
 */

var block = {
  newline: /^\n+/,
  code: /^( {4}[^\n]+\n*)+/,
  fences: noop,
  hr: /^( *[-*_]){3,} *(?:\n+|$)/,
  heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
  nptable: noop,
  lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
  blockquote: /^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,
  list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
  html: /^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,
  table: noop,
  paragraph: /^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,
  text: /^[^\n]+/
};

block.bullet = /(?:[*+-]|\d+\.)/;
block.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;
block.item = replace(block.item, 'gm')
  (/bull/g, block.bullet)
  ();

block.list = replace(block.list)
  (/bull/g, block.bullet)
  ('hr', '\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))')
  ('def', '\\n+(?=' + block.def.source + ')')
  ();

block.blockquote = replace(block.blockquote)
  ('def', block.def)
  ();

block._tag = '(?!(?:'
  + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code'
  + '|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo'
  + '|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b';

block.html = replace(block.html)
  ('comment', /<!--[\s\S]*?-->/)
  ('closed', /<(tag)[\s\S]+?<\/\1>/)
  ('closing', /<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)
  (/tag/g, block._tag)
  ();

block.paragraph = replace(block.paragraph)
  ('hr', block.hr)
  ('heading', block.heading)
  ('lheading', block.lheading)
  ('blockquote', block.blockquote)
  ('tag', '<' + block._tag)
  ('def', block.def)
  ();

/**
 * Normal Block Grammar
 */

block.normal = merge({}, block);

/**
 * GFM Block Grammar
 */

block.gfm = merge({}, block.normal, {
  fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,
  paragraph: /^/,
  heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
});

block.gfm.paragraph = replace(block.paragraph)
  ('(?!', '(?!'
    + block.gfm.fences.source.replace('\\1', '\\2') + '|'
    + block.list.source.replace('\\1', '\\3') + '|')
  ();

/**
 * GFM + Tables Block Grammar
 */

block.tables = merge({}, block.gfm, {
  nptable: /^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,
  table: /^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/
});

/**
 * Block Lexer
 */

function Lexer(options) {
  this.tokens = [];
  this.tokens.links = {};
  this.options = options || marked.defaults;
  this.rules = block.normal;

  if (this.options.gfm) {
    if (this.options.tables) {
      this.rules = block.tables;
    } else {
      this.rules = block.gfm;
    }
  }
}

/**
 * Expose Block Rules
 */

Lexer.rules = block;

/**
 * Static Lex Method
 */

Lexer.lex = function(src, options) {
  var lexer = new Lexer(options);
  return lexer.lex(src);
};

/**
 * Preprocessing
 */

Lexer.prototype.lex = function(src) {
  src = src
    .replace(/\r\n|\r/g, '\n')
    .replace(/\t/g, '    ')
    .replace(/\u00a0/g, ' ')
    .replace(/\u2424/g, '\n');

  return this.token(src, true);
};

/**
 * Lexing
 */

Lexer.prototype.token = function(src, top, bq) {
  var src = src.replace(/^ +$/gm, '')
    , next
    , loose
    , cap
    , bull
    , b
    , item
    , space
    , i
    , l;

  while (src) {
    // newline
    if (cap = this.rules.newline.exec(src)) {
      src = src.substring(cap[0].length);
      if (cap[0].length > 1) {
        this.tokens.push({
          type: 'space'
        });
      }
    }

    // code
    if (cap = this.rules.code.exec(src)) {
      src = src.substring(cap[0].length);
      cap = cap[0].replace(/^ {4}/gm, '');
      this.tokens.push({
        type: 'code',
        text: !this.options.pedantic
          ? cap.replace(/\n+$/, '')
          : cap
      });
      continue;
    }

    // fences (gfm)
    if (cap = this.rules.fences.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'code',
        lang: cap[2],
        text: cap[3] || ''
      });
      continue;
    }

    // heading
    if (cap = this.rules.heading.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'heading',
        depth: cap[1].length,
        text: cap[2]
      });
      continue;
    }

    // table no leading pipe (gfm)
    if (top && (cap = this.rules.nptable.exec(src))) {
      src = src.substring(cap[0].length);

      item = {
        type: 'table',
        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        cells: cap[3].replace(/\n$/, '').split('\n')
      };

      for (i = 0; i < item.align.length; i++) {
        if (/^ *-+: *$/.test(item.align[i])) {
          item.align[i] = 'right';
        } else if (/^ *:-+: *$/.test(item.align[i])) {
          item.align[i] = 'center';
        } else if (/^ *:-+ *$/.test(item.align[i])) {
          item.align[i] = 'left';
        } else {
          item.align[i] = null;
        }
      }

      for (i = 0; i < item.cells.length; i++) {
        item.cells[i] = item.cells[i].split(/ *\| */);
      }

      this.tokens.push(item);

      continue;
    }

    // lheading
    if (cap = this.rules.lheading.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'heading',
        depth: cap[2] === '=' ? 1 : 2,
        text: cap[1]
      });
      continue;
    }

    // hr
    if (cap = this.rules.hr.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'hr'
      });
      continue;
    }

    // blockquote
    if (cap = this.rules.blockquote.exec(src)) {
      src = src.substring(cap[0].length);

      this.tokens.push({
        type: 'blockquote_start'
      });

      cap = cap[0].replace(/^ *> ?/gm, '');

      // Pass `top` to keep the current
      // "toplevel" state. This is exactly
      // how markdown.pl works.
      this.token(cap, top, true);

      this.tokens.push({
        type: 'blockquote_end'
      });

      continue;
    }

    // list
    if (cap = this.rules.list.exec(src)) {
      src = src.substring(cap[0].length);
      bull = cap[2];

      this.tokens.push({
        type: 'list_start',
        ordered: bull.length > 1
      });

      // Get each top-level item.
      cap = cap[0].match(this.rules.item);

      next = false;
      l = cap.length;
      i = 0;

      for (; i < l; i++) {
        item = cap[i];

        // Remove the list item's bullet
        // so it is seen as the next token.
        space = item.length;
        item = item.replace(/^ *([*+-]|\d+\.) +/, '');

        // Outdent whatever the
        // list item contains. Hacky.
        if (~item.indexOf('\n ')) {
          space -= item.length;
          item = !this.options.pedantic
            ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '')
            : item.replace(/^ {1,4}/gm, '');
        }

        // Determine whether the next list item belongs here.
        // Backpedal if it does not belong in this list.
        if (this.options.smartLists && i !== l - 1) {
          b = block.bullet.exec(cap[i + 1])[0];
          if (bull !== b && !(bull.length > 1 && b.length > 1)) {
            src = cap.slice(i + 1).join('\n') + src;
            i = l - 1;
          }
        }

        // Determine whether item is loose or not.
        // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
        // for discount behavior.
        loose = next || /\n\n(?!\s*$)/.test(item);
        if (i !== l - 1) {
          next = item.charAt(item.length - 1) === '\n';
          if (!loose) loose = next;
        }

        this.tokens.push({
          type: loose
            ? 'loose_item_start'
            : 'list_item_start'
        });

        // Recurse.
        this.token(item, false, bq);

        this.tokens.push({
          type: 'list_item_end'
        });
      }

      this.tokens.push({
        type: 'list_end'
      });

      continue;
    }

    // html
    if (cap = this.rules.html.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: this.options.sanitize
          ? 'paragraph'
          : 'html',
        pre: !this.options.sanitizer
          && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
        text: cap[0]
      });
      continue;
    }

    // def
    if ((!bq && top) && (cap = this.rules.def.exec(src))) {
      src = src.substring(cap[0].length);
      this.tokens.links[cap[1].toLowerCase()] = {
        href: cap[2],
        title: cap[3]
      };
      continue;
    }

    // table (gfm)
    if (top && (cap = this.rules.table.exec(src))) {
      src = src.substring(cap[0].length);

      item = {
        type: 'table',
        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        cells: cap[3].replace(/(?: *\| *)?\n$/, '').split('\n')
      };

      for (i = 0; i < item.align.length; i++) {
        if (/^ *-+: *$/.test(item.align[i])) {
          item.align[i] = 'right';
        } else if (/^ *:-+: *$/.test(item.align[i])) {
          item.align[i] = 'center';
        } else if (/^ *:-+ *$/.test(item.align[i])) {
          item.align[i] = 'left';
        } else {
          item.align[i] = null;
        }
      }

      for (i = 0; i < item.cells.length; i++) {
        item.cells[i] = item.cells[i]
          .replace(/^ *\| *| *\| *$/g, '')
          .split(/ *\| */);
      }

      this.tokens.push(item);

      continue;
    }

    // top-level paragraph
    if (top && (cap = this.rules.paragraph.exec(src))) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'paragraph',
        text: cap[1].charAt(cap[1].length - 1) === '\n'
          ? cap[1].slice(0, -1)
          : cap[1]
      });
      continue;
    }

    // text
    if (cap = this.rules.text.exec(src)) {
      // Top-level should never reach here.
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'text',
        text: cap[0]
      });
      continue;
    }

    if (src) {
      throw new
        Error('Infinite loop on byte: ' + src.charCodeAt(0));
    }
  }

  return this.tokens;
};

/**
 * Inline-Level Grammar
 */

var inline = {
  escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
  autolink: /^<([^ >]+(@|:\/)[^ >]+)>/,
  url: noop,
  tag: /^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,
  link: /^!?\[(inside)\]\(href\)/,
  reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
  nolink: /^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,
  strong: /^__([\s\S]+?)__(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
  em: /^\b_((?:[^_]|__)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,
  code: /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,
  br: /^ {2,}\n(?!\s*$)/,
  del: noop,
  text: /^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/
};

inline._inside = /(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;
inline._href = /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;

inline.link = replace(inline.link)
  ('inside', inline._inside)
  ('href', inline._href)
  ();

inline.reflink = replace(inline.reflink)
  ('inside', inline._inside)
  ();

/**
 * Normal Inline Grammar
 */

inline.normal = merge({}, inline);

/**
 * Pedantic Inline Grammar
 */

inline.pedantic = merge({}, inline.normal, {
  strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
  em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
});

/**
 * GFM Inline Grammar
 */

inline.gfm = merge({}, inline.normal, {
  escape: replace(inline.escape)('])', '~|])')(),
  url: /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,
  del: /^~~(?=\S)([\s\S]*?\S)~~/,
  text: replace(inline.text)
    (']|', '~]|')
    ('|', '|https?://|')
    ()
});

/**
 * GFM + Line Breaks Inline Grammar
 */

inline.breaks = merge({}, inline.gfm, {
  br: replace(inline.br)('{2,}', '*')(),
  text: replace(inline.gfm.text)('{2,}', '*')()
});

/**
 * Inline Lexer & Compiler
 */

function InlineLexer(links, options) {
  this.options = options || marked.defaults;
  this.links = links;
  this.rules = inline.normal;
  this.renderer = this.options.renderer || new Renderer;
  this.renderer.options = this.options;

  if (!this.links) {
    throw new
      Error('Tokens array requires a `links` property.');
  }

  if (this.options.gfm) {
    if (this.options.breaks) {
      this.rules = inline.breaks;
    } else {
      this.rules = inline.gfm;
    }
  } else if (this.options.pedantic) {
    this.rules = inline.pedantic;
  }
}

/**
 * Expose Inline Rules
 */

InlineLexer.rules = inline;

/**
 * Static Lexing/Compiling Method
 */

InlineLexer.output = function(src, links, options) {
  var inline = new InlineLexer(links, options);
  return inline.output(src);
};

/**
 * Lexing/Compiling
 */

InlineLexer.prototype.output = function(src) {
  var out = ''
    , link
    , text
    , href
    , cap;

  while (src) {
    // escape
    if (cap = this.rules.escape.exec(src)) {
      src = src.substring(cap[0].length);
      out += cap[1];
      continue;
    }

    // autolink
    if (cap = this.rules.autolink.exec(src)) {
      src = src.substring(cap[0].length);
      if (cap[2] === '@') {
        text = cap[1].charAt(6) === ':'
          ? this.mangle(cap[1].substring(7))
          : this.mangle(cap[1]);
        href = this.mangle('mailto:') + text;
      } else {
        text = escape(cap[1]);
        href = text;
      }
      out += this.renderer.link(href, null, text);
      continue;
    }

    // url (gfm)
    if (!this.inLink && (cap = this.rules.url.exec(src))) {
      src = src.substring(cap[0].length);
      text = escape(cap[1]);
      href = text;
      out += this.renderer.link(href, null, text);
      continue;
    }

    // tag
    if (cap = this.rules.tag.exec(src)) {
      if (!this.inLink && /^<a /i.test(cap[0])) {
        this.inLink = true;
      } else if (this.inLink && /^<\/a>/i.test(cap[0])) {
        this.inLink = false;
      }
      src = src.substring(cap[0].length);
      out += this.options.sanitize
        ? this.options.sanitizer
          ? this.options.sanitizer(cap[0])
          : escape(cap[0])
        : cap[0]
      continue;
    }

    // link
    if (cap = this.rules.link.exec(src)) {
      src = src.substring(cap[0].length);
      this.inLink = true;
      out += this.outputLink(cap, {
        href: cap[2],
        title: cap[3]
      });
      this.inLink = false;
      continue;
    }

    // reflink, nolink
    if ((cap = this.rules.reflink.exec(src))
        || (cap = this.rules.nolink.exec(src))) {
      src = src.substring(cap[0].length);
      link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
      link = this.links[link.toLowerCase()];
      if (!link || !link.href) {
        out += cap[0].charAt(0);
        src = cap[0].substring(1) + src;
        continue;
      }
      this.inLink = true;
      out += this.outputLink(cap, link);
      this.inLink = false;
      continue;
    }

    // strong
    if (cap = this.rules.strong.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.strong(this.output(cap[2] || cap[1]));
      continue;
    }

    // em
    if (cap = this.rules.em.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.em(this.output(cap[2] || cap[1]));
      continue;
    }

    // code
    if (cap = this.rules.code.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.codespan(escape(cap[2], true));
      continue;
    }

    // br
    if (cap = this.rules.br.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.br();
      continue;
    }

    // del (gfm)
    if (cap = this.rules.del.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.del(this.output(cap[1]));
      continue;
    }

    // text
    if (cap = this.rules.text.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.text(escape(this.smartypants(cap[0])));
      continue;
    }

    if (src) {
      throw new
        Error('Infinite loop on byte: ' + src.charCodeAt(0));
    }
  }

  return out;
};

/**
 * Compile Link
 */

InlineLexer.prototype.outputLink = function(cap, link) {
  var href = escape(link.href)
    , title = link.title ? escape(link.title) : null;

  return cap[0].charAt(0) !== '!'
    ? this.renderer.link(href, title, this.output(cap[1]))
    : this.renderer.image(href, title, escape(cap[1]));
};

/**
 * Smartypants Transformations
 */

InlineLexer.prototype.smartypants = function(text) {
  if (!this.options.smartypants) return text;
  return text
    // em-dashes
    .replace(/---/g, '\u2014')
    // en-dashes
    .replace(/--/g, '\u2013')
    // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
    // closing singles & apostrophes
    .replace(/'/g, '\u2019')
    // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201c')
    // closing doubles
    .replace(/"/g, '\u201d')
    // ellipses
    .replace(/\.{3}/g, '\u2026');
};

/**
 * Mangle Links
 */

InlineLexer.prototype.mangle = function(text) {
  if (!this.options.mangle) return text;
  var out = ''
    , l = text.length
    , i = 0
    , ch;

  for (; i < l; i++) {
    ch = text.charCodeAt(i);
    if (Math.random() > 0.5) {
      ch = 'x' + ch.toString(16);
    }
    out += '&#' + ch + ';';
  }

  return out;
};

/**
 * Renderer
 */

function Renderer(options) {
  this.options = options || {};
}

Renderer.prototype.code = function(code, lang, escaped) {
  if (this.options.highlight) {
    var out = this.options.highlight(code, lang);
    if (out != null && out !== code) {
      escaped = true;
      code = out;
    }
  }

  if (!lang) {
    return '<pre><code>'
      + (escaped ? code : escape(code, true))
      + '\n</code></pre>';
  }

  return '<pre><code class="'
    + this.options.langPrefix
    + escape(lang, true)
    + '">'
    + (escaped ? code : escape(code, true))
    + '\n</code></pre>\n';
};

Renderer.prototype.blockquote = function(quote) {
  return '<blockquote>\n' + quote + '</blockquote>\n';
};

Renderer.prototype.html = function(html) {
  return html;
};

Renderer.prototype.heading = function(text, level, raw) {
  return '<h'
    + level
    + ' id="'
    + this.options.headerPrefix
    + raw.toLowerCase().replace(/[^\w]+/g, '-')
    + '">'
    + text
    + '</h'
    + level
    + '>\n';
};

Renderer.prototype.hr = function() {
  return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
};

Renderer.prototype.list = function(body, ordered) {
  var type = ordered ? 'ol' : 'ul';
  return '<' + type + '>\n' + body + '</' + type + '>\n';
};

Renderer.prototype.listitem = function(text) {
  return '<li>' + text + '</li>\n';
};

Renderer.prototype.paragraph = function(text) {
  return '<p>' + text + '</p>\n';
};

Renderer.prototype.table = function(header, body) {
  return '<table>\n'
    + '<thead>\n'
    + header
    + '</thead>\n'
    + '<tbody>\n'
    + body
    + '</tbody>\n'
    + '</table>\n';
};

Renderer.prototype.tablerow = function(content) {
  return '<tr>\n' + content + '</tr>\n';
};

Renderer.prototype.tablecell = function(content, flags) {
  var type = flags.header ? 'th' : 'td';
  var tag = flags.align
    ? '<' + type + ' style="text-align:' + flags.align + '">'
    : '<' + type + '>';
  return tag + content + '</' + type + '>\n';
};

// span level renderer
Renderer.prototype.strong = function(text) {
  return '<strong>' + text + '</strong>';
};

Renderer.prototype.em = function(text) {
  return '<em>' + text + '</em>';
};

Renderer.prototype.codespan = function(text) {
  return '<code>' + text + '</code>';
};

Renderer.prototype.br = function() {
  return this.options.xhtml ? '<br/>' : '<br>';
};

Renderer.prototype.del = function(text) {
  return '<del>' + text + '</del>';
};

Renderer.prototype.link = function(href, title, text) {
  if (this.options.sanitize) {
    try {
      var prot = decodeURIComponent(unescape(href))
        .replace(/[^\w:]/g, '')
        .toLowerCase();
    } catch (e) {
      return '';
    }
    if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0) {
      return '';
    }
  }
  var out = '<a href="' + href + '"';
  if (title) {
    out += ' title="' + title + '"';
  }
  out += '>' + text + '</a>';
  return out;
};

Renderer.prototype.image = function(href, title, text) {
  var out = '<img src="' + href + '" alt="' + text + '"';
  if (title) {
    out += ' title="' + title + '"';
  }
  out += this.options.xhtml ? '/>' : '>';
  return out;
};

Renderer.prototype.text = function(text) {
  return text;
};

/**
 * Parsing & Compiling
 */

function Parser(options) {
  this.tokens = [];
  this.token = null;
  this.options = options || marked.defaults;
  this.options.renderer = this.options.renderer || new Renderer;
  this.renderer = this.options.renderer;
  this.renderer.options = this.options;
}

/**
 * Static Parse Method
 */

Parser.parse = function(src, options, renderer) {
  var parser = new Parser(options, renderer);
  return parser.parse(src);
};

/**
 * Parse Loop
 */

Parser.prototype.parse = function(src) {
  this.inline = new InlineLexer(src.links, this.options, this.renderer);
  this.tokens = src.reverse();

  var out = '';
  while (this.next()) {
    out += this.tok();
  }

  return out;
};

/**
 * Next Token
 */

Parser.prototype.next = function() {
  return this.token = this.tokens.pop();
};

/**
 * Preview Next Token
 */

Parser.prototype.peek = function() {
  return this.tokens[this.tokens.length - 1] || 0;
};

/**
 * Parse Text Tokens
 */

Parser.prototype.parseText = function() {
  var body = this.token.text;

  while (this.peek().type === 'text') {
    body += '\n' + this.next().text;
  }

  return this.inline.output(body);
};

/**
 * Parse Current Token
 */

Parser.prototype.tok = function() {
  switch (this.token.type) {
    case 'space': {
      return '';
    }
    case 'hr': {
      return this.renderer.hr();
    }
    case 'heading': {
      return this.renderer.heading(
        this.inline.output(this.token.text),
        this.token.depth,
        this.token.text);
    }
    case 'code': {
      return this.renderer.code(this.token.text,
        this.token.lang,
        this.token.escaped);
    }
    case 'table': {
      var header = ''
        , body = ''
        , i
        , row
        , cell
        , flags
        , j;

      // header
      cell = '';
      for (i = 0; i < this.token.header.length; i++) {
        flags = { header: true, align: this.token.align[i] };
        cell += this.renderer.tablecell(
          this.inline.output(this.token.header[i]),
          { header: true, align: this.token.align[i] }
        );
      }
      header += this.renderer.tablerow(cell);

      for (i = 0; i < this.token.cells.length; i++) {
        row = this.token.cells[i];

        cell = '';
        for (j = 0; j < row.length; j++) {
          cell += this.renderer.tablecell(
            this.inline.output(row[j]),
            { header: false, align: this.token.align[j] }
          );
        }

        body += this.renderer.tablerow(cell);
      }
      return this.renderer.table(header, body);
    }
    case 'blockquote_start': {
      var body = '';

      while (this.next().type !== 'blockquote_end') {
        body += this.tok();
      }

      return this.renderer.blockquote(body);
    }
    case 'list_start': {
      var body = ''
        , ordered = this.token.ordered;

      while (this.next().type !== 'list_end') {
        body += this.tok();
      }

      return this.renderer.list(body, ordered);
    }
    case 'list_item_start': {
      var body = '';

      while (this.next().type !== 'list_item_end') {
        body += this.token.type === 'text'
          ? this.parseText()
          : this.tok();
      }

      return this.renderer.listitem(body);
    }
    case 'loose_item_start': {
      var body = '';

      while (this.next().type !== 'list_item_end') {
        body += this.tok();
      }

      return this.renderer.listitem(body);
    }
    case 'html': {
      var html = !this.token.pre && !this.options.pedantic
        ? this.inline.output(this.token.text)
        : this.token.text;
      return this.renderer.html(html);
    }
    case 'paragraph': {
      return this.renderer.paragraph(this.inline.output(this.token.text));
    }
    case 'text': {
      return this.renderer.paragraph(this.parseText());
    }
  }
};

/**
 * Helpers
 */

function escape(html, encode) {
  return html
    .replace(!encode ? /&(?!#?\w+;)/g : /&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function unescape(html) {
  return html.replace(/&([#\w]+);/g, function(_, n) {
    n = n.toLowerCase();
    if (n === 'colon') return ':';
    if (n.charAt(0) === '#') {
      return n.charAt(1) === 'x'
        ? String.fromCharCode(parseInt(n.substring(2), 16))
        : String.fromCharCode(+n.substring(1));
    }
    return '';
  });
}

function replace(regex, opt) {
  regex = regex.source;
  opt = opt || '';
  return function self(name, val) {
    if (!name) return new RegExp(regex, opt);
    val = val.source || val;
    val = val.replace(/(^|[^\[])\^/g, '$1');
    regex = regex.replace(name, val);
    return self;
  };
}

function noop() {}
noop.exec = noop;

function merge(obj) {
  var i = 1
    , target
    , key;

  for (; i < arguments.length; i++) {
    target = arguments[i];
    for (key in target) {
      if (Object.prototype.hasOwnProperty.call(target, key)) {
        obj[key] = target[key];
      }
    }
  }

  return obj;
}


/**
 * Marked
 */

function marked(src, opt, callback) {
  if (callback || typeof opt === 'function') {
    if (!callback) {
      callback = opt;
      opt = null;
    }

    opt = merge({}, marked.defaults, opt || {});

    var highlight = opt.highlight
      , tokens
      , pending
      , i = 0;

    try {
      tokens = Lexer.lex(src, opt)
    } catch (e) {
      return callback(e);
    }

    pending = tokens.length;

    var done = function(err) {
      if (err) {
        opt.highlight = highlight;
        return callback(err);
      }

      var out;

      try {
        out = Parser.parse(tokens, opt);
      } catch (e) {
        err = e;
      }

      opt.highlight = highlight;

      return err
        ? callback(err)
        : callback(null, out);
    };

    if (!highlight || highlight.length < 3) {
      return done();
    }

    delete opt.highlight;

    if (!pending) return done();

    for (; i < tokens.length; i++) {
      (function(token) {
        if (token.type !== 'code') {
          return --pending || done();
        }
        return highlight(token.text, token.lang, function(err, code) {
          if (err) return done(err);
          if (code == null || code === token.text) {
            return --pending || done();
          }
          token.text = code;
          token.escaped = true;
          --pending || done();
        });
      })(tokens[i]);
    }

    return;
  }
  try {
    if (opt) opt = merge({}, marked.defaults, opt);
    return Parser.parse(Lexer.lex(src, opt), opt);
  } catch (e) {
    e.message += '\nPlease report this to https://github.com/chjj/marked.';
    if ((opt || marked.defaults).silent) {
      return '<p>An error occured:</p><pre>'
        + escape(e.message + '', true)
        + '</pre>';
    }
    throw e;
  }
}

/**
 * Options
 */

marked.options =
marked.setOptions = function(opt) {
  merge(marked.defaults, opt);
  return marked;
};

marked.defaults = {
  gfm: true,
  tables: true,
  breaks: false,
  pedantic: false,
  sanitize: false,
  sanitizer: null,
  mangle: true,
  smartLists: false,
  silent: false,
  highlight: null,
  langPrefix: 'lang-',
  smartypants: false,
  headerPrefix: '',
  renderer: new Renderer,
  xhtml: false
};

/**
 * Expose
 */

marked.Parser = Parser;
marked.parser = Parser.parse;

marked.Renderer = Renderer;

marked.Lexer = Lexer;
marked.lexer = Lexer.lex;

marked.InlineLexer = InlineLexer;
marked.inlineLexer = InlineLexer.output;

marked.parse = marked;

if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = marked;
} else if (typeof define === 'function' && define.amd) {
  define(function() { return marked; });
} else {
  this.marked = marked;
}

}).call(function() {
  return this || (typeof window !== 'undefined' ? window : global);
}());
;
/**
 * State-based routing for AngularJS
 * @version v0.4.3
 * @link http://angular-ui.github.com/
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */

/* commonjs package manager support (eg componentjs) */
if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
  module.exports = 'ui.router';
}

(function (window, angular, undefined) {
/*jshint globalstrict:true*/
/*global angular:false*/
'use strict';

var isDefined = angular.isDefined,
    isFunction = angular.isFunction,
    isString = angular.isString,
    isObject = angular.isObject,
    isArray = angular.isArray,
    forEach = angular.forEach,
    extend = angular.extend,
    copy = angular.copy,
    toJson = angular.toJson;

function inherit(parent, extra) {
  return extend(new (extend(function() {}, { prototype: parent }))(), extra);
}

function merge(dst) {
  forEach(arguments, function(obj) {
    if (obj !== dst) {
      forEach(obj, function(value, key) {
        if (!dst.hasOwnProperty(key)) dst[key] = value;
      });
    }
  });
  return dst;
}

/**
 * Finds the common ancestor path between two states.
 *
 * @param {Object} first The first state.
 * @param {Object} second The second state.
 * @return {Array} Returns an array of state names in descending order, not including the root.
 */
function ancestors(first, second) {
  var path = [];

  for (var n in first.path) {
    if (first.path[n] !== second.path[n]) break;
    path.push(first.path[n]);
  }
  return path;
}

/**
 * IE8-safe wrapper for `Object.keys()`.
 *
 * @param {Object} object A JavaScript object.
 * @return {Array} Returns the keys of the object as an array.
 */
function objectKeys(object) {
  if (Object.keys) {
    return Object.keys(object);
  }
  var result = [];

  forEach(object, function(val, key) {
    result.push(key);
  });
  return result;
}

/**
 * IE8-safe wrapper for `Array.prototype.indexOf()`.
 *
 * @param {Array} array A JavaScript array.
 * @param {*} value A value to search the array for.
 * @return {Number} Returns the array index value of `value`, or `-1` if not present.
 */
function indexOf(array, value) {
  if (Array.prototype.indexOf) {
    return array.indexOf(value, Number(arguments[2]) || 0);
  }
  var len = array.length >>> 0, from = Number(arguments[2]) || 0;
  from = (from < 0) ? Math.ceil(from) : Math.floor(from);

  if (from < 0) from += len;

  for (; from < len; from++) {
    if (from in array && array[from] === value) return from;
  }
  return -1;
}

/**
 * Merges a set of parameters with all parameters inherited between the common parents of the
 * current state and a given destination state.
 *
 * @param {Object} currentParams The value of the current state parameters ($stateParams).
 * @param {Object} newParams The set of parameters which will be composited with inherited params.
 * @param {Object} $current Internal definition of object representing the current state.
 * @param {Object} $to Internal definition of object representing state to transition to.
 */
function inheritParams(currentParams, newParams, $current, $to) {
  var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];

  for (var i in parents) {
    if (!parents[i] || !parents[i].params) continue;
    parentParams = objectKeys(parents[i].params);
    if (!parentParams.length) continue;

    for (var j in parentParams) {
      if (indexOf(inheritList, parentParams[j]) >= 0) continue;
      inheritList.push(parentParams[j]);
      inherited[parentParams[j]] = currentParams[parentParams[j]];
    }
  }
  return extend({}, inherited, newParams);
}

/**
 * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
 *
 * @param {Object} a The first object.
 * @param {Object} b The second object.
 * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
 *                     it defaults to the list of keys in `a`.
 * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
 */
function equalForKeys(a, b, keys) {
  if (!keys) {
    keys = [];
    for (var n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
  }

  for (var i=0; i<keys.length; i++) {
    var k = keys[i];
    if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
  }
  return true;
}

/**
 * Returns the subset of an object, based on a list of keys.
 *
 * @param {Array} keys
 * @param {Object} values
 * @return {Boolean} Returns a subset of `values`.
 */
function filterByKeys(keys, values) {
  var filtered = {};

  forEach(keys, function (name) {
    filtered[name] = values[name];
  });
  return filtered;
}

// like _.indexBy
// when you know that your index values will be unique, or you want last-one-in to win
function indexBy(array, propName) {
  var result = {};
  forEach(array, function(item) {
    result[item[propName]] = item;
  });
  return result;
}

// extracted from underscore.js
// Return a copy of the object only containing the whitelisted properties.
function pick(obj) {
  var copy = {};
  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
  forEach(keys, function(key) {
    if (key in obj) copy[key] = obj[key];
  });
  return copy;
}

// extracted from underscore.js
// Return a copy of the object omitting the blacklisted properties.
function omit(obj) {
  var copy = {};
  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
  for (var key in obj) {
    if (indexOf(keys, key) == -1) copy[key] = obj[key];
  }
  return copy;
}

function pluck(collection, key) {
  var result = isArray(collection) ? [] : {};

  forEach(collection, function(val, i) {
    result[i] = isFunction(key) ? key(val) : val[key];
  });
  return result;
}

function filter(collection, callback) {
  var array = isArray(collection);
  var result = array ? [] : {};
  forEach(collection, function(val, i) {
    if (callback(val, i)) {
      result[array ? result.length : i] = val;
    }
  });
  return result;
}

function map(collection, callback) {
  var result = isArray(collection) ? [] : {};

  forEach(collection, function(val, i) {
    result[i] = callback(val, i);
  });
  return result;
}

// issue #2676 #2889
function silenceUncaughtInPromise (promise) {
  return promise.then(undefined, function() {}) && promise;
}

/**
 * @ngdoc overview
 * @name ui.router.util
 *
 * @description
 * # ui.router.util sub-module
 *
 * This module is a dependency of other sub-modules. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 *
 */
angular.module('ui.router.util', ['ng']);

/**
 * @ngdoc overview
 * @name ui.router.router
 * 
 * @requires ui.router.util
 *
 * @description
 * # ui.router.router sub-module
 *
 * This module is a dependency of other sub-modules. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 */
angular.module('ui.router.router', ['ui.router.util']);

/**
 * @ngdoc overview
 * @name ui.router.state
 * 
 * @requires ui.router.router
 * @requires ui.router.util
 *
 * @description
 * # ui.router.state sub-module
 *
 * This module is a dependency of the main ui.router module. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 * 
 */
angular.module('ui.router.state', ['ui.router.router', 'ui.router.util']);

/**
 * @ngdoc overview
 * @name ui.router
 *
 * @requires ui.router.state
 *
 * @description
 * # ui.router
 * 
 * ## The main module for ui.router 
 * There are several sub-modules included with the ui.router module, however only this module is needed
 * as a dependency within your angular app. The other modules are for organization purposes. 
 *
 * The modules are:
 * * ui.router - the main "umbrella" module
 * * ui.router.router - 
 * 
 * *You'll need to include **only** this module as the dependency within your angular app.*
 * 
 * <pre>
 * <!doctype html>
 * <html ng-app="myApp">
 * <head>
 *   <script src="js/angular.js"></script>
 *   <!-- Include the ui-router script -->
 *   <script src="js/angular-ui-router.min.js"></script>
 *   <script>
 *     // ...and add 'ui.router' as a dependency
 *     var myApp = angular.module('myApp', ['ui.router']);
 *   </script>
 * </head>
 * <body>
 * </body>
 * </html>
 * </pre>
 */
angular.module('ui.router', ['ui.router.state']);

angular.module('ui.router.compat', ['ui.router']);

/**
 * @ngdoc object
 * @name ui.router.util.$resolve
 *
 * @requires $q
 * @requires $injector
 *
 * @description
 * Manages resolution of (acyclic) graphs of promises.
 */
$Resolve.$inject = ['$q', '$injector'];
function $Resolve(  $q,    $injector) {
  
  var VISIT_IN_PROGRESS = 1,
      VISIT_DONE = 2,
      NOTHING = {},
      NO_DEPENDENCIES = [],
      NO_LOCALS = NOTHING,
      NO_PARENT = extend($q.when(NOTHING), { $$promises: NOTHING, $$values: NOTHING });
  

  /**
   * @ngdoc function
   * @name ui.router.util.$resolve#study
   * @methodOf ui.router.util.$resolve
   *
   * @description
   * Studies a set of invocables that are likely to be used multiple times.
   * <pre>
   * $resolve.study(invocables)(locals, parent, self)
   * </pre>
   * is equivalent to
   * <pre>
   * $resolve.resolve(invocables, locals, parent, self)
   * </pre>
   * but the former is more efficient (in fact `resolve` just calls `study` 
   * internally).
   *
   * @param {object} invocables Invocable objects
   * @return {function} a function to pass in locals, parent and self
   */
  this.study = function (invocables) {
    if (!isObject(invocables)) throw new Error("'invocables' must be an object");
    var invocableKeys = objectKeys(invocables || {});
    
    // Perform a topological sort of invocables to build an ordered plan
    var plan = [], cycle = [], visited = {};
    function visit(value, key) {
      if (visited[key] === VISIT_DONE) return;
      
      cycle.push(key);
      if (visited[key] === VISIT_IN_PROGRESS) {
        cycle.splice(0, indexOf(cycle, key));
        throw new Error("Cyclic dependency: " + cycle.join(" -> "));
      }
      visited[key] = VISIT_IN_PROGRESS;
      
      if (isString(value)) {
        plan.push(key, [ function() { return $injector.get(value); }], NO_DEPENDENCIES);
      } else {
        var params = $injector.annotate(value);
        forEach(params, function (param) {
          if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
        });
        plan.push(key, value, params);
      }
      
      cycle.pop();
      visited[key] = VISIT_DONE;
    }
    forEach(invocables, visit);
    invocables = cycle = visited = null; // plan is all that's required
    
    function isResolve(value) {
      return isObject(value) && value.then && value.$$promises;
    }
    
    return function (locals, parent, self) {
      if (isResolve(locals) && self === undefined) {
        self = parent; parent = locals; locals = null;
      }
      if (!locals) locals = NO_LOCALS;
      else if (!isObject(locals)) {
        throw new Error("'locals' must be an object");
      }       
      if (!parent) parent = NO_PARENT;
      else if (!isResolve(parent)) {
        throw new Error("'parent' must be a promise returned by $resolve.resolve()");
      }
      
      // To complete the overall resolution, we have to wait for the parent
      // promise and for the promise for each invokable in our plan.
      var resolution = $q.defer(),
          result = silenceUncaughtInPromise(resolution.promise),
          promises = result.$$promises = {},
          values = extend({}, locals),
          wait = 1 + plan.length/3,
          merged = false;

      silenceUncaughtInPromise(result);
          
      function done() {
        // Merge parent values we haven't got yet and publish our own $$values
        if (!--wait) {
          if (!merged) merge(values, parent.$$values); 
          result.$$values = values;
          result.$$promises = result.$$promises || true; // keep for isResolve()
          delete result.$$inheritedValues;
          resolution.resolve(values);
        }
      }
      
      function fail(reason) {
        result.$$failure = reason;
        resolution.reject(reason);
      }

      // Short-circuit if parent has already failed
      if (isDefined(parent.$$failure)) {
        fail(parent.$$failure);
        return result;
      }
      
      if (parent.$$inheritedValues) {
        merge(values, omit(parent.$$inheritedValues, invocableKeys));
      }

      // Merge parent values if the parent has already resolved, or merge
      // parent promises and wait if the parent resolve is still in progress.
      extend(promises, parent.$$promises);
      if (parent.$$values) {
        merged = merge(values, omit(parent.$$values, invocableKeys));
        result.$$inheritedValues = omit(parent.$$values, invocableKeys);
        done();
      } else {
        if (parent.$$inheritedValues) {
          result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
        }        
        parent.then(done, fail);
      }
      
      // Process each invocable in the plan, but ignore any where a local of the same name exists.
      for (var i=0, ii=plan.length; i<ii; i+=3) {
        if (locals.hasOwnProperty(plan[i])) done();
        else invoke(plan[i], plan[i+1], plan[i+2]);
      }
      
      function invoke(key, invocable, params) {
        // Create a deferred for this invocation. Failures will propagate to the resolution as well.
        var invocation = $q.defer(), waitParams = 0;
        function onfailure(reason) {
          invocation.reject(reason);
          fail(reason);
        }
        // Wait for any parameter that we have a promise for (either from parent or from this
        // resolve; in that case study() will have made sure it's ordered before us in the plan).
        forEach(params, function (dep) {
          if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
            waitParams++;
            promises[dep].then(function (result) {
              values[dep] = result;
              if (!(--waitParams)) proceed();
            }, onfailure);
          }
        });
        if (!waitParams) proceed();
        function proceed() {
          if (isDefined(result.$$failure)) return;
          try {
            invocation.resolve($injector.invoke(invocable, self, values));
            invocation.promise.then(function (result) {
              values[key] = result;
              done();
            }, onfailure);
          } catch (e) {
            onfailure(e);
          }
        }
        // Publish promise synchronously; invocations further down in the plan may depend on it.
        promises[key] = silenceUncaughtInPromise(invocation.promise);
      }
      
      return result;
    };
  };
  
  /**
   * @ngdoc function
   * @name ui.router.util.$resolve#resolve
   * @methodOf ui.router.util.$resolve
   *
   * @description
   * Resolves a set of invocables. An invocable is a function to be invoked via 
   * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
   * An invocable can either return a value directly,
   * or a `$q` promise. If a promise is returned it will be resolved and the 
   * resulting value will be used instead. Dependencies of invocables are resolved 
   * (in this order of precedence)
   *
   * - from the specified `locals`
   * - from another invocable that is part of this `$resolve` call
   * - from an invocable that is inherited from a `parent` call to `$resolve` 
   *   (or recursively
   * - from any ancestor `$resolve` of that parent).
   *
   * The return value of `$resolve` is a promise for an object that contains 
   * (in this order of precedence)
   *
   * - any `locals` (if specified)
   * - the resolved return values of all injectables
   * - any values inherited from a `parent` call to `$resolve` (if specified)
   *
   * The promise will resolve after the `parent` promise (if any) and all promises 
   * returned by injectables have been resolved. If any invocable 
   * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
   * invocable is rejected, the `$resolve` promise is immediately rejected with the 
   * same error. A rejection of a `parent` promise (if specified) will likewise be 
   * propagated immediately. Once the `$resolve` promise has been rejected, no 
   * further invocables will be called.
   * 
   * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
   * to throw an error. As a special case, an injectable can depend on a parameter 
   * with the same name as the injectable, which will be fulfilled from the `parent` 
   * injectable of the same name. This allows inherited values to be decorated. 
   * Note that in this case any other injectable in the same `$resolve` with the same
   * dependency would see the decorated value, not the inherited value.
   *
   * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
   * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
   * exception.
   *
   * Invocables are invoked eagerly as soon as all dependencies are available. 
   * This is true even for dependencies inherited from a `parent` call to `$resolve`.
   *
   * As a special case, an invocable can be a string, in which case it is taken to 
   * be a service name to be passed to `$injector.get()`. This is supported primarily 
   * for backwards-compatibility with the `resolve` property of `$routeProvider` 
   * routes.
   *
   * @param {object} invocables functions to invoke or 
   * `$injector` services to fetch.
   * @param {object} locals  values to make available to the injectables
   * @param {object} parent  a promise returned by another call to `$resolve`.
   * @param {object} self  the `this` for the invoked methods
   * @return {object} Promise for an object that contains the resolved return value
   * of all invocables, as well as any inherited and local values.
   */
  this.resolve = function (invocables, locals, parent, self) {
    return this.study(invocables)(locals, parent, self);
  };
}

angular.module('ui.router.util').service('$resolve', $Resolve);



/**
 * @ngdoc object
 * @name ui.router.util.$templateFactoryProvider
 *
 * @description
 * Provider for $templateFactory. Manages which template-loading mechanism to
 * use, and will default to the most recent one ($templateRequest on Angular
 * versions starting from 1.3, $http otherwise).
 */
function TemplateFactoryProvider() {
  var shouldUnsafelyUseHttp = angular.version.minor < 3;

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactoryProvider#shouldUnsafelyUseHttp
   * @methodOf ui.router.util.$templateFactoryProvider
   *
   * @description
   * Forces $templateFactory to use $http instead of $templateRequest. This
   * might cause XSS, as $http doesn't enforce the regular security checks for
   * templates that have been introduced in Angular 1.3. Note that setting this
   * to false on Angular older than 1.3.x will crash, as the $templateRequest
   * service (and the security checks) are not implemented on these versions.
   *
   * See the $sce documentation, section
   * <a href="https://docs.angularjs.org/api/ng/service/$sce#impact-on-loading-templates">
   * Impact on loading templates</a> for more details about this mechanism.
   *
   * @param {boolean} value
   */
  this.shouldUnsafelyUseHttp = function(value) {
    shouldUnsafelyUseHttp = !!value;
  };

  /**
   * @ngdoc object
   * @name ui.router.util.$templateFactory
   *
   * @requires $http
   * @requires $templateCache
   * @requires $injector
   *
   * @description
   * Service. Manages loading of templates.
   */
  this.$get = ['$http', '$templateCache', '$injector', function($http, $templateCache, $injector){
    return new TemplateFactory($http, $templateCache, $injector, shouldUnsafelyUseHttp);}];
}


/**
 * @ngdoc object
 * @name ui.router.util.$templateFactory
 *
 * @requires $http
 * @requires $templateCache
 * @requires $injector
 *
 * @description
 * Service. Manages loading of templates.
 */
function TemplateFactory($http, $templateCache, $injector, shouldUnsafelyUseHttp) {

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromConfig
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template from a configuration object. 
   *
   * @param {object} config Configuration object for which to load a template. 
   * The following properties are search in the specified order, and the first one 
   * that is defined is used to create the template:
   *
   * @param {string|object} config.template html string template or function to 
   * load via {@link ui.router.util.$templateFactory#fromString fromString}.
   * @param {string|object} config.templateUrl url to load or a function returning 
   * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
   * @param {Function} config.templateProvider function to invoke via 
   * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
   * @param {object} params  Parameters to pass to the template function.
   * @param {object} locals Locals to pass to `invoke` if the template is loaded 
   * via a `templateProvider`. Defaults to `{ params: params }`.
   *
   * @return {string|object}  The template html as a string, or a promise for 
   * that string,or `null` if no template is configured.
   */
  this.fromConfig = function (config, params, locals) {
    return (
      isDefined(config.template) ? this.fromString(config.template, params) :
      isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) :
      isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) :
      null
    );
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromString
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template from a string or a function returning a string.
   *
   * @param {string|object} template html template as a string or function that 
   * returns an html template as a string.
   * @param {object} params Parameters to pass to the template function.
   *
   * @return {string|object} The template html as a string, or a promise for that 
   * string.
   */
  this.fromString = function (template, params) {
    return isFunction(template) ? template(params) : template;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromUrl
   * @methodOf ui.router.util.$templateFactory
   * 
   * @description
   * Loads a template from the a URL via `$http` and `$templateCache`.
   *
   * @param {string|Function} url url of the template to load, or a function 
   * that returns a url.
   * @param {Object} params Parameters to pass to the url function.
   * @return {string|Promise.<string>} The template html as a string, or a promise 
   * for that string.
   */
  this.fromUrl = function (url, params) {
    if (isFunction(url)) url = url(params);
    if (url == null) return null;
    else {
      if(!shouldUnsafelyUseHttp) {
        return $injector.get('$templateRequest')(url);
      } else {
        return $http
          .get(url, { cache: $templateCache, headers: { Accept: 'text/html' }})
          .then(function(response) { return response.data; });
      }
    }
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromProvider
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template by invoking an injectable provider function.
   *
   * @param {Function} provider Function to invoke via `$injector.invoke`
   * @param {Object} params Parameters for the template.
   * @param {Object} locals Locals to pass to `invoke`. Defaults to 
   * `{ params: params }`.
   * @return {string|Promise.<string>} The template html as a string, or a promise 
   * for that string.
   */
  this.fromProvider = function (provider, params, locals) {
    return $injector.invoke(provider, null, locals || { params: params });
  };
}

angular.module('ui.router.util').provider('$templateFactory', TemplateFactoryProvider);

var $$UMFP; // reference to $UrlMatcherFactoryProvider

/**
 * @ngdoc object
 * @name ui.router.util.type:UrlMatcher
 *
 * @description
 * Matches URLs against patterns and extracts named parameters from the path or the search
 * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
 * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
 * do not influence whether or not a URL is matched, but their values are passed through into
 * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
 *
 * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
 * syntax, which optionally allows a regular expression for the parameter to be specified:
 *
 * * `':'` name - colon placeholder
 * * `'*'` name - catch-all placeholder
 * * `'{' name '}'` - curly placeholder
 * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
 *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
 *
 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
 * must be unique within the pattern (across both path and search parameters). For colon
 * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
 * number of characters other than '/'. For catch-all placeholders the path parameter matches
 * any number of characters.
 *
 * Examples:
 *
 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
 * * `'/user/{id:[^/]*}'` - Same as the previous example.
 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
 *   parameter consists of 1 to 8 hex digits.
 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
 *   path into the parameter 'path'.
 * * `'/files/*path'` - ditto.
 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
 *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
 *
 * @param {string} pattern  The pattern to compile into a matcher.
 * @param {Object} config  A configuration object hash:
 * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
 *   an existing UrlMatcher
 *
 * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
 * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
 *
 * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
 *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
 *   non-null) will start with this prefix.
 *
 * @property {string} source  The pattern that was passed into the constructor
 *
 * @property {string} sourcePath  The path portion of the source property
 *
 * @property {string} sourceSearch  The search portion of the source property
 *
 * @property {string} regex  The constructed regex that will be used to match against the url when
 *   it is time to determine which url will match.
 *
 * @returns {Object}  New `UrlMatcher` object
 */
function UrlMatcher(pattern, config, parentMatcher) {
  config = extend({ params: {} }, isObject(config) ? config : {});

  // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
  //   '*' name
  //   ':' name
  //   '{' name '}'
  //   '{' name ':' regexp '}'
  // The regular expression is somewhat complicated due to the need to allow curly braces
  // inside the regular expression. The placeholder regexp breaks down as follows:
  //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
  //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
  //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
  //    [^{}\\]+                       - anything other than curly braces or backslash
  //    \\.                            - a backslash escape
  //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
  var placeholder       = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
      searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
      compiled = '^', last = 0, m,
      segments = this.segments = [],
      parentParams = parentMatcher ? parentMatcher.params : {},
      params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(),
      paramNames = [];

  function addParameter(id, type, config, location) {
    paramNames.push(id);
    if (parentParams[id]) return parentParams[id];
    if (!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
    if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
    params[id] = new $$UMFP.Param(id, type, config, location);
    return params[id];
  }

  function quoteRegExp(string, pattern, squash, optional) {
    var surroundPattern = ['',''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
    if (!pattern) return result;
    switch(squash) {
      case false: surroundPattern = ['(', ')' + (optional ? "?" : "")]; break;
      case true:
        result = result.replace(/\/$/, '');
        surroundPattern = ['(?:\/(', ')|\/)?'];
      break;
      default:    surroundPattern = ['(' + squash + "|", ')?']; break;
    }
    return result + surroundPattern[0] + pattern + surroundPattern[1];
  }

  this.source = pattern;

  // Split into static segments separated by path parameter placeholders.
  // The number of segments is always 1 more than the number of parameters.
  function matchDetails(m, isSearch) {
    var id, regexp, segment, type, cfg, arrayMode;
    id          = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
    cfg         = config.params[id];
    segment     = pattern.substring(last, m.index);
    regexp      = isSearch ? m[4] : m[4] || (m[1] == '*' ? '.*' : null);

    if (regexp) {
      type      = $$UMFP.type(regexp) || inherit($$UMFP.type("string"), { pattern: new RegExp(regexp, config.caseInsensitive ? 'i' : undefined) });
    }

    return {
      id: id, regexp: regexp, segment: segment, type: type, cfg: cfg
    };
  }

  var p, param, segment;
  while ((m = placeholder.exec(pattern))) {
    p = matchDetails(m, false);
    if (p.segment.indexOf('?') >= 0) break; // we're into the search part

    param = addParameter(p.id, p.type, p.cfg, "path");
    compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash, param.isOptional);
    segments.push(p.segment);
    last = placeholder.lastIndex;
  }
  segment = pattern.substring(last);

  // Find any search parameter names and remove them from the last segment
  var i = segment.indexOf('?');

  if (i >= 0) {
    var search = this.sourceSearch = segment.substring(i);
    segment = segment.substring(0, i);
    this.sourcePath = pattern.substring(0, last + i);

    if (search.length > 0) {
      last = 0;
      while ((m = searchPlaceholder.exec(search))) {
        p = matchDetails(m, true);
        param = addParameter(p.id, p.type, p.cfg, "search");
        last = placeholder.lastIndex;
        // check if ?&
      }
    }
  } else {
    this.sourcePath = pattern;
    this.sourceSearch = '';
  }

  compiled += quoteRegExp(segment) + (config.strict === false ? '\/?' : '') + '$';
  segments.push(segment);

  this.regexp = new RegExp(compiled, config.caseInsensitive ? 'i' : undefined);
  this.prefix = segments[0];
  this.$$paramNames = paramNames;
}

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#concat
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Returns a new matcher for a pattern constructed by appending the path part and adding the
 * search parameters of the specified pattern to this pattern. The current pattern is not
 * modified. This can be understood as creating a pattern for URLs that are relative to (or
 * suffixes of) the current pattern.
 *
 * @example
 * The following two matchers are equivalent:
 * <pre>
 * new UrlMatcher('/user/{id}?q').concat('/details?date');
 * new UrlMatcher('/user/{id}/details?q&date');
 * </pre>
 *
 * @param {string} pattern  The pattern to append.
 * @param {Object} config  An object hash of the configuration for the matcher.
 * @returns {UrlMatcher}  A matcher for the concatenated pattern.
 */
UrlMatcher.prototype.concat = function (pattern, config) {
  // Because order of search parameters is irrelevant, we can add our own search
  // parameters to the end of the new pattern. Parse the new pattern by itself
  // and then join the bits together, but it's much easier to do this on a string level.
  var defaultConfig = {
    caseInsensitive: $$UMFP.caseInsensitive(),
    strict: $$UMFP.strictMode(),
    squash: $$UMFP.defaultSquashPolicy()
  };
  return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
};

UrlMatcher.prototype.toString = function () {
  return this.source;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#exec
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Tests the specified path against this matcher, and returns an object containing the captured
 * parameter values, or null if the path does not match. The returned object contains the values
 * of any search parameters that are mentioned in the pattern, but their value may be null if
 * they are not present in `searchParams`. This means that search parameters are always treated
 * as optional.
 *
 * @example
 * <pre>
 * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
 *   x: '1', q: 'hello'
 * });
 * // returns { id: 'bob', q: 'hello', r: null }
 * </pre>
 *
 * @param {string} path  The URL path to match, e.g. `$location.path()`.
 * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
 * @returns {Object}  The captured parameter values.
 */
UrlMatcher.prototype.exec = function (path, searchParams) {
  var m = this.regexp.exec(path);
  if (!m) return null;
  searchParams = searchParams || {};

  var paramNames = this.parameters(), nTotal = paramNames.length,
    nPath = this.segments.length - 1,
    values = {}, i, j, cfg, paramName;

  if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");

  function decodePathArray(string) {
    function reverseString(str) { return str.split("").reverse().join(""); }
    function unquoteDashes(str) { return str.replace(/\\-/g, "-"); }

    var split = reverseString(string).split(/-(?!\\)/);
    var allReversed = map(split, reverseString);
    return map(allReversed, unquoteDashes).reverse();
  }

  var param, paramVal;
  for (i = 0; i < nPath; i++) {
    paramName = paramNames[i];
    param = this.params[paramName];
    paramVal = m[i+1];
    // if the param value matches a pre-replace pair, replace the value before decoding.
    for (j = 0; j < param.replace.length; j++) {
      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
    }
    if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
    values[paramName] = param.value(paramVal);
  }
  for (/**/; i < nTotal; i++) {
    paramName = paramNames[i];
    values[paramName] = this.params[paramName].value(searchParams[paramName]);
    param = this.params[paramName];
    paramVal = searchParams[paramName];
    for (j = 0; j < param.replace.length; j++) {
      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
    }
    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
    values[paramName] = param.value(paramVal);
  }

  return values;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#parameters
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Returns the names of all path and search parameters of this pattern in an unspecified order.
 *
 * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
 *    pattern has no parameters, an empty array is returned.
 */
UrlMatcher.prototype.parameters = function (param) {
  if (!isDefined(param)) return this.$$paramNames;
  return this.params[param] || null;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#validates
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Checks an object hash of parameters to validate their correctness according to the parameter
 * types of this `UrlMatcher`.
 *
 * @param {Object} params The object hash of parameters to validate.
 * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
 */
UrlMatcher.prototype.validates = function (params) {
  return this.params.$$validates(params);
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#format
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Creates a URL that matches this pattern by substituting the specified values
 * for the path and search parameters. Null values for path parameters are
 * treated as empty strings.
 *
 * @example
 * <pre>
 * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
 * // returns '/user/bob?q=yes'
 * </pre>
 *
 * @param {Object} values  the values to substitute for the parameters in this pattern.
 * @returns {string}  the formatted URL (path and optionally search part).
 */
UrlMatcher.prototype.format = function (values) {
  values = values || {};
  var segments = this.segments, params = this.parameters(), paramset = this.params;
  if (!this.validates(values)) return null;

  var i, search = false, nPath = segments.length - 1, nTotal = params.length, result = segments[0];

  function encodeDashes(str) { // Replace dashes with encoded "\-"
    return encodeURIComponent(str).replace(/-/g, function(c) { return '%5C%' + c.charCodeAt(0).toString(16).toUpperCase(); });
  }

  for (i = 0; i < nTotal; i++) {
    var isPathParam = i < nPath;
    var name = params[i], param = paramset[name], value = param.value(values[name]);
    var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
    var squash = isDefaultValue ? param.squash : false;
    var encoded = param.type.encode(value);

    if (isPathParam) {
      var nextSegment = segments[i + 1];
      var isFinalPathParam = i + 1 === nPath;

      if (squash === false) {
        if (encoded != null) {
          if (isArray(encoded)) {
            result += map(encoded, encodeDashes).join("-");
          } else {
            result += encodeURIComponent(encoded);
          }
        }
        result += nextSegment;
      } else if (squash === true) {
        var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
        result += nextSegment.match(capture)[1];
      } else if (isString(squash)) {
        result += squash + nextSegment;
      }

      if (isFinalPathParam && param.squash === true && result.slice(-1) === '/') result = result.slice(0, -1);
    } else {
      if (encoded == null || (isDefaultValue && squash !== false)) continue;
      if (!isArray(encoded)) encoded = [ encoded ];
      if (encoded.length === 0) continue;
      encoded = map(encoded, encodeURIComponent).join('&' + name + '=');
      result += (search ? '&' : '?') + (name + '=' + encoded);
      search = true;
    }
  }

  return result;
};

/**
 * @ngdoc object
 * @name ui.router.util.type:Type
 *
 * @description
 * Implements an interface to define custom parameter types that can be decoded from and encoded to
 * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
 * objects when matching or formatting URLs, or comparing or validating parameter values.
 *
 * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
 * information on registering custom types.
 *
 * @param {Object} config  A configuration object which contains the custom type definition.  The object's
 *        properties will override the default methods and/or pattern in `Type`'s public interface.
 * @example
 * <pre>
 * {
 *   decode: function(val) { return parseInt(val, 10); },
 *   encode: function(val) { return val && val.toString(); },
 *   equals: function(a, b) { return this.is(a) && a === b; },
 *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
 *   pattern: /\d+/
 * }
 * </pre>
 *
 * @property {RegExp} pattern The regular expression pattern used to match values of this type when
 *           coming from a substring of a URL.
 *
 * @returns {Object}  Returns a new `Type` object.
 */
function Type(config) {
  extend(this, config);
}

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#is
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Detects whether a value is of a particular type. Accepts a native (decoded) value
 * and determines whether it matches the current `Type` object.
 *
 * @param {*} val  The value to check.
 * @param {string} key  Optional. If the type check is happening in the context of a specific
 *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
 *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
 * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
 */
Type.prototype.is = function(val, key) {
  return true;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#encode
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
 * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
 * only needs to be a representation of `val` that has been coerced to a string.
 *
 * @param {*} val  The value to encode.
 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
 *        meta-programming of `Type` objects.
 * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
 */
Type.prototype.encode = function(val, key) {
  return val;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#decode
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Converts a parameter value (from URL string or transition param) to a custom/native value.
 *
 * @param {string} val  The URL parameter value to decode.
 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
 *        meta-programming of `Type` objects.
 * @returns {*}  Returns a custom representation of the URL parameter value.
 */
Type.prototype.decode = function(val, key) {
  return val;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#equals
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Determines whether two decoded values are equivalent.
 *
 * @param {*} a  A value to compare against.
 * @param {*} b  A value to compare against.
 * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
 */
Type.prototype.equals = function(a, b) {
  return a == b;
};

Type.prototype.$subPattern = function() {
  var sub = this.pattern.toString();
  return sub.substr(1, sub.length - 2);
};

Type.prototype.pattern = /.*/;

Type.prototype.toString = function() { return "{Type:" + this.name + "}"; };

/** Given an encoded string, or a decoded object, returns a decoded object */
Type.prototype.$normalize = function(val) {
  return this.is(val) ? val : this.decode(val);
};

/*
 * Wraps an existing custom Type as an array of Type, depending on 'mode'.
 * e.g.:
 * - urlmatcher pattern "/path?{queryParam[]:int}"
 * - url: "/path?queryParam=1&queryParam=2
 * - $stateParams.queryParam will be [1, 2]
 * if `mode` is "auto", then
 * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
 * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
 */
Type.prototype.$asArray = function(mode, isSearch) {
  if (!mode) return this;
  if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");

  function ArrayType(type, mode) {
    function bindTo(type, callbackName) {
      return function() {
        return type[callbackName].apply(type, arguments);
      };
    }

    // Wrap non-array value as array
    function arrayWrap(val) { return isArray(val) ? val : (isDefined(val) ? [ val ] : []); }
    // Unwrap array value for "auto" mode. Return undefined for empty array.
    function arrayUnwrap(val) {
      switch(val.length) {
        case 0: return undefined;
        case 1: return mode === "auto" ? val[0] : val;
        default: return val;
      }
    }
    function falsey(val) { return !val; }

    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
    function arrayHandler(callback, allTruthyMode) {
      return function handleArray(val) {
        if (isArray(val) && val.length === 0) return val;
        val = arrayWrap(val);
        var result = map(val, callback);
        if (allTruthyMode === true)
          return filter(result, falsey).length === 0;
        return arrayUnwrap(result);
      };
    }

    // Wraps type (.equals) functions to operate on each value of an array
    function arrayEqualsHandler(callback) {
      return function handleArray(val1, val2) {
        var left = arrayWrap(val1), right = arrayWrap(val2);
        if (left.length !== right.length) return false;
        for (var i = 0; i < left.length; i++) {
          if (!callback(left[i], right[i])) return false;
        }
        return true;
      };
    }

    this.encode = arrayHandler(bindTo(type, 'encode'));
    this.decode = arrayHandler(bindTo(type, 'decode'));
    this.is     = arrayHandler(bindTo(type, 'is'), true);
    this.equals = arrayEqualsHandler(bindTo(type, 'equals'));
    this.pattern = type.pattern;
    this.$normalize = arrayHandler(bindTo(type, '$normalize'));
    this.name = type.name;
    this.$arrayMode = mode;
  }

  return new ArrayType(this, mode);
};



/**
 * @ngdoc object
 * @name ui.router.util.$urlMatcherFactory
 *
 * @description
 * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
 * is also available to providers under the name `$urlMatcherFactoryProvider`.
 */
function $UrlMatcherFactory() {
  $$UMFP = this;

  var isCaseInsensitive = false, isStrictMode = true, defaultSquashPolicy = false;

  // Use tildes to pre-encode slashes.
  // If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
  // and bidirectional encoding/decoding fails.
  // Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
  function valToString(val) { return val != null ? val.toString().replace(/(~|\/)/g, function (m) { return {'~':'~~', '/':'~2F'}[m]; }) : val; }
  function valFromString(val) { return val != null ? val.toString().replace(/(~~|~2F)/g, function (m) { return {'~~':'~', '~2F':'/'}[m]; }) : val; }

  var $types = {}, enqueue = true, typeQueue = [], injector, defaultTypes = {
    "string": {
      encode: valToString,
      decode: valFromString,
      // TODO: in 1.0, make string .is() return false if value is undefined/null by default.
      // In 0.2.x, string params are optional by default for backwards compat
      is: function(val) { return val == null || !isDefined(val) || typeof val === "string"; },
      pattern: /[^/]*/
    },
    "int": {
      encode: valToString,
      decode: function(val) { return parseInt(val, 10); },
      is: function(val) { return val !== undefined && val !== null && this.decode(val.toString()) === val; },
      pattern: /-?\d+/
    },
    "bool": {
      encode: function(val) { return val ? 1 : 0; },
      decode: function(val) { return parseInt(val, 10) !== 0; },
      is: function(val) { return val === true || val === false; },
      pattern: /0|1/
    },
    "date": {
      encode: function (val) {
        if (!this.is(val))
          return undefined;
        return [ val.getFullYear(),
          ('0' + (val.getMonth() + 1)).slice(-2),
          ('0' + val.getDate()).slice(-2)
        ].join("-");
      },
      decode: function (val) {
        if (this.is(val)) return val;
        var match = this.capture.exec(val);
        return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
      },
      is: function(val) { return val instanceof Date && !isNaN(val.valueOf()); },
      equals: function (a, b) { return this.is(a) && this.is(b) && a.toISOString() === b.toISOString(); },
      pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
      capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
    },
    "json": {
      encode: angular.toJson,
      decode: angular.fromJson,
      is: angular.isObject,
      equals: angular.equals,
      pattern: /[^/]*/
    },
    "any": { // does not encode/decode
      encode: angular.identity,
      decode: angular.identity,
      equals: angular.equals,
      pattern: /.*/
    }
  };

  function getDefaultConfig() {
    return {
      strict: isStrictMode,
      caseInsensitive: isCaseInsensitive
    };
  }

  function isInjectable(value) {
    return (isFunction(value) || (isArray(value) && isFunction(value[value.length - 1])));
  }

  /**
   * [Internal] Get the default value of a parameter, which may be an injectable function.
   */
  $UrlMatcherFactory.$$getDefaultValue = function(config) {
    if (!isInjectable(config.value)) return config.value;
    if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
    return injector.invoke(config.value);
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#caseInsensitive
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Defines whether URL matching should be case sensitive (the default behavior), or not.
   *
   * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
   * @returns {boolean} the current value of caseInsensitive
   */
  this.caseInsensitive = function(value) {
    if (isDefined(value))
      isCaseInsensitive = value;
    return isCaseInsensitive;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#strictMode
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Defines whether URLs should match trailing slashes, or not (the default behavior).
   *
   * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
   * @returns {boolean} the current value of strictMode
   */
  this.strictMode = function(value) {
    if (isDefined(value))
      isStrictMode = value;
    return isStrictMode;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Sets the default behavior when generating or matching URLs with default parameter values.
   *
   * @param {string} value A string that defines the default parameter URL squashing behavior.
   *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
   *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
   *             parameter is surrounded by slashes, squash (remove) one slash from the URL
   *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
   *             the parameter value from the URL and replace it with this string.
   */
  this.defaultSquashPolicy = function(value) {
    if (!isDefined(value)) return defaultSquashPolicy;
    if (value !== true && value !== false && !isString(value))
      throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
    defaultSquashPolicy = value;
    return value;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#compile
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
   *
   * @param {string} pattern  The URL pattern.
   * @param {Object} config  The config object hash.
   * @returns {UrlMatcher}  The UrlMatcher.
   */
  this.compile = function (pattern, config) {
    return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#isMatcher
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
   *
   * @param {Object} object  The object to perform the type check against.
   * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
   *          implementing all the same methods.
   */
  this.isMatcher = function (o) {
    if (!isObject(o)) return false;
    var result = true;

    forEach(UrlMatcher.prototype, function(val, name) {
      if (isFunction(val)) {
        result = result && (isDefined(o[name]) && isFunction(o[name]));
      }
    });
    return result;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#type
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
   * generate URLs with typed parameters.
   *
   * @param {string} name  The type name.
   * @param {Object|Function} definition   The type definition. See
   *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
   * @param {Object|Function} definitionFn (optional) A function that is injected before the app
   *        runtime starts.  The result of this function is merged into the existing `definition`.
   *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
   *
   * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
   *
   * @example
   * This is a simple example of a custom type that encodes and decodes items from an
   * array, using the array index as the URL-encoded value:
   *
   * <pre>
   * var list = ['John', 'Paul', 'George', 'Ringo'];
   *
   * $urlMatcherFactoryProvider.type('listItem', {
   *   encode: function(item) {
   *     // Represent the list item in the URL using its corresponding index
   *     return list.indexOf(item);
   *   },
   *   decode: function(item) {
   *     // Look up the list item by index
   *     return list[parseInt(item, 10)];
   *   },
   *   is: function(item) {
   *     // Ensure the item is valid by checking to see that it appears
   *     // in the list
   *     return list.indexOf(item) > -1;
   *   }
   * });
   *
   * $stateProvider.state('list', {
   *   url: "/list/{item:listItem}",
   *   controller: function($scope, $stateParams) {
   *     console.log($stateParams.item);
   *   }
   * });
   *
   * // ...
   *
   * // Changes URL to '/list/3', logs "Ringo" to the console
   * $state.go('list', { item: "Ringo" });
   * </pre>
   *
   * This is a more complex example of a type that relies on dependency injection to
   * interact with services, and uses the parameter name from the URL to infer how to
   * handle encoding and decoding parameter values:
   *
   * <pre>
   * // Defines a custom type that gets a value from a service,
   * // where each service gets different types of values from
   * // a backend API:
   * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
   *
   *   // Matches up services to URL parameter names
   *   var services = {
   *     user: Users,
   *     post: Posts
   *   };
   *
   *   return {
   *     encode: function(object) {
   *       // Represent the object in the URL using its unique ID
   *       return object.id;
   *     },
   *     decode: function(value, key) {
   *       // Look up the object by ID, using the parameter
   *       // name (key) to call the correct service
   *       return services[key].findById(value);
   *     },
   *     is: function(object, key) {
   *       // Check that object is a valid dbObject
   *       return angular.isObject(object) && object.id && services[key];
   *     }
   *     equals: function(a, b) {
   *       // Check the equality of decoded objects by comparing
   *       // their unique IDs
   *       return a.id === b.id;
   *     }
   *   };
   * });
   *
   * // In a config() block, you can then attach URLs with
   * // type-annotated parameters:
   * $stateProvider.state('users', {
   *   url: "/users",
   *   // ...
   * }).state('users.item', {
   *   url: "/{user:dbObject}",
   *   controller: function($scope, $stateParams) {
   *     // $stateParams.user will now be an object returned from
   *     // the Users service
   *   },
   *   // ...
   * });
   * </pre>
   */
  this.type = function (name, definition, definitionFn) {
    if (!isDefined(definition)) return $types[name];
    if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");

    $types[name] = new Type(extend({ name: name }, definition));
    if (definitionFn) {
      typeQueue.push({ name: name, def: definitionFn });
      if (!enqueue) flushTypeQueue();
    }
    return this;
  };

  // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
  function flushTypeQueue() {
    while(typeQueue.length) {
      var type = typeQueue.shift();
      if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
      angular.extend($types[type.name], injector.invoke(type.def));
    }
  }

  // Register default types. Store them in the prototype of $types.
  forEach(defaultTypes, function(type, name) { $types[name] = new Type(extend({name: name}, type)); });
  $types = inherit($types, {});

  /* No need to document $get, since it returns this */
  this.$get = ['$injector', function ($injector) {
    injector = $injector;
    enqueue = false;
    flushTypeQueue();

    forEach(defaultTypes, function(type, name) {
      if (!$types[name]) $types[name] = new Type(type);
    });
    return this;
  }];

  this.Param = function Param(id, type, config, location) {
    var self = this;
    config = unwrapShorthand(config);
    type = getType(config, type, location);
    var arrayMode = getArrayMode();
    type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
    if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined)
      config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
    var isOptional = config.value !== undefined;
    var squash = getSquashPolicy(config, isOptional);
    var replace = getReplace(config, arrayMode, isOptional, squash);

    function unwrapShorthand(config) {
      var keys = isObject(config) ? objectKeys(config) : [];
      var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 &&
                        indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
      if (isShorthand) config = { value: config };
      config.$$fn = isInjectable(config.value) ? config.value : function () { return config.value; };
      return config;
    }

    function getType(config, urlType, location) {
      if (config.type && urlType) throw new Error("Param '"+id+"' has two type configurations.");
      if (urlType) return urlType;
      if (!config.type) return (location === "config" ? $types.any : $types.string);

      if (angular.isString(config.type))
        return $types[config.type];
      if (config.type instanceof Type)
        return config.type;
      return new Type(config.type);
    }

    // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
    function getArrayMode() {
      var arrayDefaults = { array: (location === "search" ? "auto" : false) };
      var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
      return extend(arrayDefaults, arrayParamNomenclature, config).array;
    }

    /**
     * returns false, true, or the squash value to indicate the "default parameter url squash policy".
     */
    function getSquashPolicy(config, isOptional) {
      var squash = config.squash;
      if (!isOptional || squash === false) return false;
      if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
      if (squash === true || isString(squash)) return squash;
      throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
    }

    function getReplace(config, arrayMode, isOptional, squash) {
      var replace, configuredKeys, defaultPolicy = [
        { from: "",   to: (isOptional || arrayMode ? undefined : "") },
        { from: null, to: (isOptional || arrayMode ? undefined : "") }
      ];
      replace = isArray(config.replace) ? config.replace : [];
      if (isString(squash))
        replace.push({ from: squash, to: undefined });
      configuredKeys = map(replace, function(item) { return item.from; } );
      return filter(defaultPolicy, function(item) { return indexOf(configuredKeys, item.from) === -1; }).concat(replace);
    }

    /**
     * [Internal] Get the default value of a parameter, which may be an injectable function.
     */
    function $$getDefaultValue() {
      if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
      var defaultValue = injector.invoke(config.$$fn);
      if (defaultValue !== null && defaultValue !== undefined && !self.type.is(defaultValue))
        throw new Error("Default value (" + defaultValue + ") for parameter '" + self.id + "' is not an instance of Type (" + self.type.name + ")");
      return defaultValue;
    }

    /**
     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
     * default value, which may be the result of an injectable function.
     */
    function $value(value) {
      function hasReplaceVal(val) { return function(obj) { return obj.from === val; }; }
      function $replace(value) {
        var replacement = map(filter(self.replace, hasReplaceVal(value)), function(obj) { return obj.to; });
        return replacement.length ? replacement[0] : value;
      }
      value = $replace(value);
      return !isDefined(value) ? $$getDefaultValue() : self.type.$normalize(value);
    }

    function toString() { return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}"; }

    extend(this, {
      id: id,
      type: type,
      location: location,
      array: arrayMode,
      squash: squash,
      replace: replace,
      isOptional: isOptional,
      value: $value,
      dynamic: undefined,
      config: config,
      toString: toString
    });
  };

  function ParamSet(params) {
    extend(this, params || {});
  }

  ParamSet.prototype = {
    $$new: function() {
      return inherit(this, extend(new ParamSet(), { $$parent: this}));
    },
    $$keys: function () {
      var keys = [], chain = [], parent = this,
        ignore = objectKeys(ParamSet.prototype);
      while (parent) { chain.push(parent); parent = parent.$$parent; }
      chain.reverse();
      forEach(chain, function(paramset) {
        forEach(objectKeys(paramset), function(key) {
            if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
        });
      });
      return keys;
    },
    $$values: function(paramValues) {
      var values = {}, self = this;
      forEach(self.$$keys(), function(key) {
        values[key] = self[key].value(paramValues && paramValues[key]);
      });
      return values;
    },
    $$equals: function(paramValues1, paramValues2) {
      var equal = true, self = this;
      forEach(self.$$keys(), function(key) {
        var left = paramValues1 && paramValues1[key], right = paramValues2 && paramValues2[key];
        if (!self[key].type.equals(left, right)) equal = false;
      });
      return equal;
    },
    $$validates: function $$validate(paramValues) {
      var keys = this.$$keys(), i, param, rawVal, normalized, encoded;
      for (i = 0; i < keys.length; i++) {
        param = this[keys[i]];
        rawVal = paramValues[keys[i]];
        if ((rawVal === undefined || rawVal === null) && param.isOptional)
          break; // There was no parameter value, but the param is optional
        normalized = param.type.$normalize(rawVal);
        if (!param.type.is(normalized))
          return false; // The value was not of the correct Type, and could not be decoded to the correct Type
        encoded = param.type.encode(normalized);
        if (angular.isString(encoded) && !param.type.pattern.exec(encoded))
          return false; // The value was of the correct type, but when encoded, did not match the Type's regexp
      }
      return true;
    },
    $$parent: undefined
  };

  this.ParamSet = ParamSet;
}

// Register as a provider so it's available to other providers
angular.module('ui.router.util').provider('$urlMatcherFactory', $UrlMatcherFactory);
angular.module('ui.router.util').run(['$urlMatcherFactory', function($urlMatcherFactory) { }]);

/**
 * @ngdoc object
 * @name ui.router.router.$urlRouterProvider
 *
 * @requires ui.router.util.$urlMatcherFactoryProvider
 * @requires $locationProvider
 *
 * @description
 * `$urlRouterProvider` has the responsibility of watching `$location`. 
 * When `$location` changes it runs through a list of rules one by one until a 
 * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
 * a url in a state configuration. All urls are compiled into a UrlMatcher object.
 *
 * There are several methods on `$urlRouterProvider` that make it useful to use directly
 * in your module config.
 */
$UrlRouterProvider.$inject = ['$locationProvider', '$urlMatcherFactoryProvider'];
function $UrlRouterProvider(   $locationProvider,   $urlMatcherFactory) {
  var rules = [], otherwise = null, interceptDeferred = false, listener;

  // Returns a string that is a prefix of all strings matching the RegExp
  function regExpPrefix(re) {
    var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
    return (prefix != null) ? prefix[1].replace(/\\(.)/g, "$1") : '';
  }

  // Interpolates matched values into a String.replace()-style pattern
  function interpolate(pattern, match) {
    return pattern.replace(/\$(\$|\d{1,2})/, function (m, what) {
      return match[what === '$' ? 0 : Number(what)];
    });
  }

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#rule
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Defines rules that are used by `$urlRouterProvider` to find matches for
   * specific URLs.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   // Here's an example of how you might allow case insensitive urls
   *   $urlRouterProvider.rule(function ($injector, $location) {
   *     var path = $location.path(),
   *         normalized = path.toLowerCase();
   *
   *     if (path !== normalized) {
   *       return normalized;
   *     }
   *   });
   * });
   * </pre>
   *
   * @param {function} rule Handler function that takes `$injector` and `$location`
   * services as arguments. You can use them to return a valid path as a string.
   *
   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
   */
  this.rule = function (rule) {
    if (!isFunction(rule)) throw new Error("'rule' must be a function");
    rules.push(rule);
    return this;
  };

  /**
   * @ngdoc object
   * @name ui.router.router.$urlRouterProvider#otherwise
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Defines a path that is used when an invalid route is requested.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   // if the path doesn't match any of the urls you configured
   *   // otherwise will take care of routing the user to the
   *   // specified url
   *   $urlRouterProvider.otherwise('/index');
   *
   *   // Example of using function rule as param
   *   $urlRouterProvider.otherwise(function ($injector, $location) {
   *     return '/a/valid/url';
   *   });
   * });
   * </pre>
   *
   * @param {string|function} rule The url path you want to redirect to or a function 
   * rule that returns the url path. The function version is passed two params: 
   * `$injector` and `$location` services, and must return a url string.
   *
   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
   */
  this.otherwise = function (rule) {
    if (isString(rule)) {
      var redirect = rule;
      rule = function () { return redirect; };
    }
    else if (!isFunction(rule)) throw new Error("'rule' must be a function");
    otherwise = rule;
    return this;
  };


  function handleIfMatch($injector, handler, match) {
    if (!match) return false;
    var result = $injector.invoke(handler, handler, { $match: match });
    return isDefined(result) ? result : true;
  }

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#when
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Registers a handler for a given url matching. 
   * 
   * If the handler is a string, it is
   * treated as a redirect, and is interpolated according to the syntax of match
   * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
   *
   * If the handler is a function, it is injectable. It gets invoked if `$location`
   * matches. You have the option of inject the match object as `$match`.
   *
   * The handler can return
   *
   * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
   *   will continue trying to find another one that matches.
   * - **string** which is treated as a redirect and passed to `$location.url()`
   * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
   *     if ($state.$current.navigable !== state ||
   *         !equalForKeys($match, $stateParams) {
   *      $state.transitionTo(state, $match, false);
   *     }
   *   });
   * });
   * </pre>
   *
   * @param {string|object} what The incoming path that you want to redirect.
   * @param {string|function} handler The path you want to redirect your user to.
   */
  this.when = function (what, handler) {
    var redirect, handlerIsString = isString(handler);
    if (isString(what)) what = $urlMatcherFactory.compile(what);

    if (!handlerIsString && !isFunction(handler) && !isArray(handler))
      throw new Error("invalid 'handler' in when()");

    var strategies = {
      matcher: function (what, handler) {
        if (handlerIsString) {
          redirect = $urlMatcherFactory.compile(handler);
          handler = ['$match', function ($match) { return redirect.format($match); }];
        }
        return extend(function ($injector, $location) {
          return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
        }, {
          prefix: isString(what.prefix) ? what.prefix : ''
        });
      },
      regex: function (what, handler) {
        if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");

        if (handlerIsString) {
          redirect = handler;
          handler = ['$match', function ($match) { return interpolate(redirect, $match); }];
        }
        return extend(function ($injector, $location) {
          return handleIfMatch($injector, handler, what.exec($location.path()));
        }, {
          prefix: regExpPrefix(what)
        });
      }
    };

    var check = { matcher: $urlMatcherFactory.isMatcher(what), regex: what instanceof RegExp };

    for (var n in check) {
      if (check[n]) return this.rule(strategies[n](what, handler));
    }

    throw new Error("invalid 'what' in when()");
  };

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#deferIntercept
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Disables (or enables) deferring location change interception.
   *
   * If you wish to customize the behavior of syncing the URL (for example, if you wish to
   * defer a transition but maintain the current URL), call this method at configuration time.
   * Then, at run time, call `$urlRouter.listen()` after you have configured your own
   * `$locationChangeSuccess` event handler.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *
   *   // Prevent $urlRouter from automatically intercepting URL changes;
   *   // this allows you to configure custom behavior in between
   *   // location changes and route synchronization:
   *   $urlRouterProvider.deferIntercept();
   *
   * }).run(function ($rootScope, $urlRouter, UserService) {
   *
   *   $rootScope.$on('$locationChangeSuccess', function(e) {
   *     // UserService is an example service for managing user state
   *     if (UserService.isLoggedIn()) return;
   *
   *     // Prevent $urlRouter's default handler from firing
   *     e.preventDefault();
   *
   *     UserService.handleLogin().then(function() {
   *       // Once the user has logged in, sync the current URL
   *       // to the router:
   *       $urlRouter.sync();
   *     });
   *   });
   *
   *   // Configures $urlRouter's listener *after* your custom listener
   *   $urlRouter.listen();
   * });
   * </pre>
   *
   * @param {boolean} defer Indicates whether to defer location change interception. Passing
            no parameter is equivalent to `true`.
   */
  this.deferIntercept = function (defer) {
    if (defer === undefined) defer = true;
    interceptDeferred = defer;
  };

  /**
   * @ngdoc object
   * @name ui.router.router.$urlRouter
   *
   * @requires $location
   * @requires $rootScope
   * @requires $injector
   * @requires $browser
   *
   * @description
   *
   */
  this.$get = $get;
  $get.$inject = ['$location', '$rootScope', '$injector', '$browser', '$sniffer'];
  function $get(   $location,   $rootScope,   $injector,   $browser,   $sniffer) {

    var baseHref = $browser.baseHref(), location = $location.url(), lastPushedUrl;

    function appendBasePath(url, isHtml5, absolute) {
      if (baseHref === '/') return url;
      if (isHtml5) return baseHref.slice(0, -1) + url;
      if (absolute) return baseHref.slice(1) + url;
      return url;
    }

    // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
    function update(evt) {
      if (evt && evt.defaultPrevented) return;
      var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
      lastPushedUrl = undefined;
      // TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
      //if (ignoreUpdate) return true;

      function check(rule) {
        var handled = rule($injector, $location);

        if (!handled) return false;
        if (isString(handled)) $location.replace().url(handled);
        return true;
      }
      var n = rules.length, i;

      for (i = 0; i < n; i++) {
        if (check(rules[i])) return;
      }
      // always check otherwise last to allow dynamic updates to the set of rules
      if (otherwise) check(otherwise);
    }

    function listen() {
      listener = listener || $rootScope.$on('$locationChangeSuccess', update);
      return listener;
    }

    if (!interceptDeferred) listen();

    return {
      /**
       * @ngdoc function
       * @name ui.router.router.$urlRouter#sync
       * @methodOf ui.router.router.$urlRouter
       *
       * @description
       * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
       * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
       * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
       * with the transition by calling `$urlRouter.sync()`.
       *
       * @example
       * <pre>
       * angular.module('app', ['ui.router'])
       *   .run(function($rootScope, $urlRouter) {
       *     $rootScope.$on('$locationChangeSuccess', function(evt) {
       *       // Halt state change from even starting
       *       evt.preventDefault();
       *       // Perform custom logic
       *       var meetsRequirement = ...
       *       // Continue with the update and state transition if logic allows
       *       if (meetsRequirement) $urlRouter.sync();
       *     });
       * });
       * </pre>
       */
      sync: function() {
        update();
      },

      listen: function() {
        return listen();
      },

      update: function(read) {
        if (read) {
          location = $location.url();
          return;
        }
        if ($location.url() === location) return;

        $location.url(location);
        $location.replace();
      },

      push: function(urlMatcher, params, options) {
         var url = urlMatcher.format(params || {});

        // Handle the special hash param, if needed
        if (url !== null && params && params['#']) {
            url += '#' + params['#'];
        }

        $location.url(url);
        lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
        if (options && options.replace) $location.replace();
      },

      /**
       * @ngdoc function
       * @name ui.router.router.$urlRouter#href
       * @methodOf ui.router.router.$urlRouter
       *
       * @description
       * A URL generation method that returns the compiled URL for a given
       * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
       *
       * @example
       * <pre>
       * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
       *   person: "bob"
       * });
       * // $bob == "/about/bob";
       * </pre>
       *
       * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
       * @param {object=} params An object of parameter values to fill the matcher's required parameters.
       * @param {object=} options Options object. The options are:
       *
       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
       *
       * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
       */
      href: function(urlMatcher, params, options) {
        if (!urlMatcher.validates(params)) return null;

        var isHtml5 = $locationProvider.html5Mode();
        if (angular.isObject(isHtml5)) {
          isHtml5 = isHtml5.enabled;
        }

        isHtml5 = isHtml5 && $sniffer.history;
        
        var url = urlMatcher.format(params);
        options = options || {};

        if (!isHtml5 && url !== null) {
          url = "#" + $locationProvider.hashPrefix() + url;
        }

        // Handle special hash param, if needed
        if (url !== null && params && params['#']) {
          url += '#' + params['#'];
        }

        url = appendBasePath(url, isHtml5, options.absolute);

        if (!options.absolute || !url) {
          return url;
        }

        var slash = (!isHtml5 && url ? '/' : ''), port = $location.port();
        port = (port === 80 || port === 443 ? '' : ':' + port);

        return [$location.protocol(), '://', $location.host(), port, slash, url].join('');
      }
    };
  }
}

angular.module('ui.router.router').provider('$urlRouter', $UrlRouterProvider);

/**
 * @ngdoc object
 * @name ui.router.state.$stateProvider
 *
 * @requires ui.router.router.$urlRouterProvider
 * @requires ui.router.util.$urlMatcherFactoryProvider
 *
 * @description
 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
 * on state.
 *
 * A state corresponds to a "place" in the application in terms of the overall UI and
 * navigation. A state describes (via the controller / template / view properties) what
 * the UI looks like and does at that place.
 *
 * States often have things in common, and the primary way of factoring out these
 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
 * nested states.
 *
 * The `$stateProvider` provides interfaces to declare these states for your app.
 */
$StateProvider.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];
function $StateProvider(   $urlRouterProvider,   $urlMatcherFactory) {

  var root, states = {}, $state, queue = {}, abstractKey = 'abstract';

  // Builds state properties from definition passed to registerState()
  var stateBuilder = {

    // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
    // state.children = [];
    // if (parent) parent.children.push(state);
    parent: function(state) {
      if (isDefined(state.parent) && state.parent) return findState(state.parent);
      // regex matches any valid composite state name
      // would match "contact.list" but not "contacts"
      var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
      return compositeName ? findState(compositeName[1]) : root;
    },

    // inherit 'data' from parent and override by own values (if any)
    data: function(state) {
      if (state.parent && state.parent.data) {
        state.data = state.self.data = inherit(state.parent.data, state.data);
      }
      return state.data;
    },

    // Build a URLMatcher if necessary, either via a relative or absolute URL
    url: function(state) {
      var url = state.url, config = { params: state.params || {} };

      if (isString(url)) {
        if (url.charAt(0) == '^') return $urlMatcherFactory.compile(url.substring(1), config);
        return (state.parent.navigable || root).url.concat(url, config);
      }

      if (!url || $urlMatcherFactory.isMatcher(url)) return url;
      throw new Error("Invalid url '" + url + "' in state '" + state + "'");
    },

    // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
    navigable: function(state) {
      return state.url ? state : (state.parent ? state.parent.navigable : null);
    },

    // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
    ownParams: function(state) {
      var params = state.url && state.url.params || new $$UMFP.ParamSet();
      forEach(state.params || {}, function(config, id) {
        if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
      });
      return params;
    },

    // Derive parameters for this state and ensure they're a super-set of parent's parameters
    params: function(state) {
      var ownParams = pick(state.ownParams, state.ownParams.$$keys());
      return state.parent && state.parent.params ? extend(state.parent.params.$$new(), ownParams) : new $$UMFP.ParamSet();
    },

    // If there is no explicit multi-view configuration, make one up so we don't have
    // to handle both cases in the view directive later. Note that having an explicit
    // 'views' property will mean the default unnamed view properties are ignored. This
    // is also a good time to resolve view names to absolute names, so everything is a
    // straight lookup at link time.
    views: function(state) {
      var views = {};

      forEach(isDefined(state.views) ? state.views : { '': state }, function (view, name) {
        if (name.indexOf('@') < 0) name += '@' + state.parent.name;
        view.resolveAs = view.resolveAs || state.resolveAs || '$resolve';
        views[name] = view;
      });
      return views;
    },

    // Keep a full path from the root down to this state as this is needed for state activation.
    path: function(state) {
      return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
    },

    // Speed up $state.contains() as it's used a lot
    includes: function(state) {
      var includes = state.parent ? extend({}, state.parent.includes) : {};
      includes[state.name] = true;
      return includes;
    },

    $delegates: {}
  };

  function isRelative(stateName) {
    return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
  }

  function findState(stateOrName, base) {
    if (!stateOrName) return undefined;

    var isStr = isString(stateOrName),
        name  = isStr ? stateOrName : stateOrName.name,
        path  = isRelative(name);

    if (path) {
      if (!base) throw new Error("No reference point given for path '"  + name + "'");
      base = findState(base);
      
      var rel = name.split("."), i = 0, pathLength = rel.length, current = base;

      for (; i < pathLength; i++) {
        if (rel[i] === "" && i === 0) {
          current = base;
          continue;
        }
        if (rel[i] === "^") {
          if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
          current = current.parent;
          continue;
        }
        break;
      }
      rel = rel.slice(i).join(".");
      name = current.name + (current.name && rel ? "." : "") + rel;
    }
    var state = states[name];

    if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
      return state;
    }
    return undefined;
  }

  function queueState(parentName, state) {
    if (!queue[parentName]) {
      queue[parentName] = [];
    }
    queue[parentName].push(state);
  }

  function flushQueuedChildren(parentName) {
    var queued = queue[parentName] || [];
    while(queued.length) {
      registerState(queued.shift());
    }
  }

  function registerState(state) {
    // Wrap a new object around the state so we can store our private details easily.
    state = inherit(state, {
      self: state,
      resolve: state.resolve || {},
      toString: function() { return this.name; }
    });

    var name = state.name;
    if (!isString(name) || name.indexOf('@') >= 0) throw new Error("State must have a valid name");
    if (states.hasOwnProperty(name)) throw new Error("State '" + name + "' is already defined");

    // Get parent name
    var parentName = (name.indexOf('.') !== -1) ? name.substring(0, name.lastIndexOf('.'))
        : (isString(state.parent)) ? state.parent
        : (isObject(state.parent) && isString(state.parent.name)) ? state.parent.name
        : '';

    // If parent is not registered yet, add state to queue and register later
    if (parentName && !states[parentName]) {
      return queueState(parentName, state.self);
    }

    for (var key in stateBuilder) {
      if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
    }
    states[name] = state;

    // Register the state in the global state list and with $urlRouter if necessary.
    if (!state[abstractKey] && state.url) {
      $urlRouterProvider.when(state.url, ['$match', '$stateParams', function ($match, $stateParams) {
        if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) {
          $state.transitionTo(state, $match, { inherit: true, location: false });
        }
      }]);
    }

    // Register any queued children
    flushQueuedChildren(name);

    return state;
  }

  // Checks text to see if it looks like a glob.
  function isGlob (text) {
    return text.indexOf('*') > -1;
  }

  // Returns true if glob matches current $state name.
  function doesStateMatchGlob (glob) {
    var globSegments = glob.split('.'),
        segments = $state.$current.name.split('.');

    //match single stars
    for (var i = 0, l = globSegments.length; i < l; i++) {
      if (globSegments[i] === '*') {
        segments[i] = '*';
      }
    }

    //match greedy starts
    if (globSegments[0] === '**') {
       segments = segments.slice(indexOf(segments, globSegments[1]));
       segments.unshift('**');
    }
    //match greedy ends
    if (globSegments[globSegments.length - 1] === '**') {
       segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
       segments.push('**');
    }

    if (globSegments.length != segments.length) {
      return false;
    }

    return segments.join('') === globSegments.join('');
  }


  // Implicit root state that is always active
  root = registerState({
    name: '',
    url: '^',
    views: null,
    'abstract': true
  });
  root.navigable = null;


  /**
   * @ngdoc function
   * @name ui.router.state.$stateProvider#decorator
   * @methodOf ui.router.state.$stateProvider
   *
   * @description
   * Allows you to extend (carefully) or override (at your own peril) the 
   * `stateBuilder` object used internally by `$stateProvider`. This can be used 
   * to add custom functionality to ui-router, for example inferring templateUrl 
   * based on the state name.
   *
   * When passing only a name, it returns the current (original or decorated) builder
   * function that matches `name`.
   *
   * The builder functions that can be decorated are listed below. Though not all
   * necessarily have a good use case for decoration, that is up to you to decide.
   *
   * In addition, users can attach custom decorators, which will generate new 
   * properties within the state's internal definition. There is currently no clear 
   * use-case for this beyond accessing internal states (i.e. $state.$current), 
   * however, expect this to become increasingly relevant as we introduce additional 
   * meta-programming features.
   *
   * **Warning**: Decorators should not be interdependent because the order of 
   * execution of the builder functions in non-deterministic. Builder functions 
   * should only be dependent on the state definition object and super function.
   *
   *
   * Existing builder functions and current return values:
   *
   * - **parent** `{object}` - returns the parent state object.
   * - **data** `{object}` - returns state data, including any inherited data that is not
   *   overridden by own values (if any).
   * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
   *   or `null`.
   * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
   *   navigable).
   * - **params** `{object}` - returns an array of state params that are ensured to 
   *   be a super-set of parent's params.
   * - **views** `{object}` - returns a views object where each key is an absolute view 
   *   name (i.e. "viewName@stateName") and each value is the config object 
   *   (template, controller) for the view. Even when you don't use the views object 
   *   explicitly on a state config, one is still created for you internally.
   *   So by decorating this builder function you have access to decorating template 
   *   and controller properties.
   * - **ownParams** `{object}` - returns an array of params that belong to the state, 
   *   not including any params defined by ancestor states.
   * - **path** `{string}` - returns the full path from the root down to this state. 
   *   Needed for state activation.
   * - **includes** `{object}` - returns an object that includes every state that 
   *   would pass a `$state.includes()` test.
   *
   * @example
   * <pre>
   * // Override the internal 'views' builder with a function that takes the state
   * // definition, and a reference to the internal function being overridden:
   * $stateProvider.decorator('views', function (state, parent) {
   *   var result = {},
   *       views = parent(state);
   *
   *   angular.forEach(views, function (config, name) {
   *     var autoName = (state.name + '.' + name).replace('.', '/');
   *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
   *     result[name] = config;
   *   });
   *   return result;
   * });
   *
   * $stateProvider.state('home', {
   *   views: {
   *     'contact.list': { controller: 'ListController' },
   *     'contact.item': { controller: 'ItemController' }
   *   }
   * });
   *
   * // ...
   *
   * $state.go('home');
   * // Auto-populates list and item views with /partials/home/contact/list.html,
   * // and /partials/home/contact/item.html, respectively.
   * </pre>
   *
   * @param {string} name The name of the builder function to decorate. 
   * @param {object} func A function that is responsible for decorating the original 
   * builder function. The function receives two parameters:
   *
   *   - `{object}` - state - The state config object.
   *   - `{object}` - super - The original builder function.
   *
   * @return {object} $stateProvider - $stateProvider instance
   */
  this.decorator = decorator;
  function decorator(name, func) {
    /*jshint validthis: true */
    if (isString(name) && !isDefined(func)) {
      return stateBuilder[name];
    }
    if (!isFunction(func) || !isString(name)) {
      return this;
    }
    if (stateBuilder[name] && !stateBuilder.$delegates[name]) {
      stateBuilder.$delegates[name] = stateBuilder[name];
    }
    stateBuilder[name] = func;
    return this;
  }

  /**
   * @ngdoc function
   * @name ui.router.state.$stateProvider#state
   * @methodOf ui.router.state.$stateProvider
   *
   * @description
   * Registers a state configuration under a given state name. The stateConfig object
   * has the following acceptable properties.
   *
   * @param {string} name A unique state name, e.g. "home", "about", "contacts".
   * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
   * @param {object} stateConfig State configuration object.
   * @param {string|function=} stateConfig.template
   * <a id='template'></a>
   *   html template as a string or a function that returns
   *   an html template as a string which should be used by the uiView directives. This property 
   *   takes precedence over templateUrl.
   *   
   *   If `template` is a function, it will be called with the following parameters:
   *
   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
   *     applying the current state
   *
   * <pre>template:
   *   "<h1>inline template definition</h1>" +
   *   "<div ui-view></div>"</pre>
   * <pre>template: function(params) {
   *       return "<h1>generated template</h1>"; }</pre>
   * </div>
   *
   * @param {string|function=} stateConfig.templateUrl
   * <a id='templateUrl'></a>
   *
   *   path or function that returns a path to an html
   *   template that should be used by uiView.
   *   
   *   If `templateUrl` is a function, it will be called with the following parameters:
   *
   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
   *     applying the current state
   *
   * <pre>templateUrl: "home.html"</pre>
   * <pre>templateUrl: function(params) {
   *     return myTemplates[params.pageId]; }</pre>
   *
   * @param {function=} stateConfig.templateProvider
   * <a id='templateProvider'></a>
   *    Provider function that returns HTML content string.
   * <pre> templateProvider:
   *       function(MyTemplateService, params) {
   *         return MyTemplateService.getTemplate(params.pageId);
   *       }</pre>
   *
   * @param {string|function=} stateConfig.controller
   * <a id='controller'></a>
   *
   *  Controller fn that should be associated with newly
   *   related scope or the name of a registered controller if passed as a string.
   *   Optionally, the ControllerAs may be declared here.
   * <pre>controller: "MyRegisteredController"</pre>
   * <pre>controller:
   *     "MyRegisteredController as fooCtrl"}</pre>
   * <pre>controller: function($scope, MyService) {
   *     $scope.data = MyService.getData(); }</pre>
   *
   * @param {function=} stateConfig.controllerProvider
   * <a id='controllerProvider'></a>
   *
   * Injectable provider function that returns the actual controller or string.
   * <pre>controllerProvider:
   *   function(MyResolveData) {
   *     if (MyResolveData.foo)
   *       return "FooCtrl"
   *     else if (MyResolveData.bar)
   *       return "BarCtrl";
   *     else return function($scope) {
   *       $scope.baz = "Qux";
   *     }
   *   }</pre>
   *
   * @param {string=} stateConfig.controllerAs
   * <a id='controllerAs'></a>
   * 
   * A controller alias name. If present the controller will be
   *   published to scope under the controllerAs name.
   * <pre>controllerAs: "myCtrl"</pre>
   *
   * @param {string|object=} stateConfig.parent
   * <a id='parent'></a>
   * Optionally specifies the parent state of this state.
   *
   * <pre>parent: 'parentState'</pre>
   * <pre>parent: parentState // JS variable</pre>
   *
   * @param {object=} stateConfig.resolve
   * <a id='resolve'></a>
   *
   * An optional map&lt;string, function&gt; of dependencies which
   *   should be injected into the controller. If any of these dependencies are promises, 
   *   the router will wait for them all to be resolved before the controller is instantiated.
   *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
   *   and the values of the resolved promises are injected into any controllers that reference them.
   *   If any  of the promises are rejected the $stateChangeError event is fired.
   *
   *   The map object is:
   *   
   *   - key - {string}: name of dependency to be injected into controller
   *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
   *     it is injected and return value it treated as dependency. If result is a promise, it is 
   *     resolved before its value is injected into controller.
   *
   * <pre>resolve: {
   *     myResolve1:
   *       function($http, $stateParams) {
   *         return $http.get("/api/foos/"+stateParams.fooID);
   *       }
   *     }</pre>
   *
   * @param {string=} stateConfig.url
   * <a id='url'></a>
   *
   *   A url fragment with optional parameters. When a state is navigated or
   *   transitioned to, the `$stateParams` service will be populated with any 
   *   parameters that were passed.
   *
   *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
   *   more details on acceptable patterns )
   *
   * examples:
   * <pre>url: "/home"
   * url: "/users/:userid"
   * url: "/books/{bookid:[a-zA-Z_-]}"
   * url: "/books/{categoryid:int}"
   * url: "/books/{publishername:string}/{categoryid:int}"
   * url: "/messages?before&after"
   * url: "/messages?{before:date}&{after:date}"
   * url: "/messages/:mailboxid?{before:date}&{after:date}"
   * </pre>
   *
   * @param {object=} stateConfig.views
   * <a id='views'></a>
   * an optional map&lt;string, object&gt; which defined multiple views, or targets views
   * manually/explicitly.
   *
   * Examples:
   *
   * Targets three named `ui-view`s in the parent state's template
   * <pre>views: {
   *     header: {
   *       controller: "headerCtrl",
   *       templateUrl: "header.html"
   *     }, body: {
   *       controller: "bodyCtrl",
   *       templateUrl: "body.html"
   *     }, footer: {
   *       controller: "footCtrl",
   *       templateUrl: "footer.html"
   *     }
   *   }</pre>
   *
   * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
   * <pre>views: {
   *     'header@top': {
   *       controller: "msgHeaderCtrl",
   *       templateUrl: "msgHeader.html"
   *     }, 'body': {
   *       controller: "messagesCtrl",
   *       templateUrl: "messages.html"
   *     }
   *   }</pre>
   *
   * @param {boolean=} [stateConfig.abstract=false]
   * <a id='abstract'></a>
   * An abstract state will never be directly activated,
   *   but can provide inherited properties to its common children states.
   * <pre>abstract: true</pre>
   *
   * @param {function=} stateConfig.onEnter
   * <a id='onEnter'></a>
   *
   * Callback function for when a state is entered. Good way
   *   to trigger an action or dispatch an event, such as opening a dialog.
   * If minifying your scripts, make sure to explicitly annotate this function,
   * because it won't be automatically annotated by your build tools.
   *
   * <pre>onEnter: function(MyService, $stateParams) {
   *     MyService.foo($stateParams.myParam);
   * }</pre>
   *
   * @param {function=} stateConfig.onExit
   * <a id='onExit'></a>
   *
   * Callback function for when a state is exited. Good way to
   *   trigger an action or dispatch an event, such as opening a dialog.
   * If minifying your scripts, make sure to explicitly annotate this function,
   * because it won't be automatically annotated by your build tools.
   *
   * <pre>onExit: function(MyService, $stateParams) {
   *     MyService.cleanup($stateParams.myParam);
   * }</pre>
   *
   * @param {boolean=} [stateConfig.reloadOnSearch=true]
   * <a id='reloadOnSearch'></a>
   *
   * If `false`, will not retrigger the same state
   *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
   *   Useful for when you'd like to modify $location.search() without triggering a reload.
   * <pre>reloadOnSearch: false</pre>
   *
   * @param {object=} stateConfig.data
   * <a id='data'></a>
   *
   * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
   *   prototypally inherited.  In other words, adding a data property to a state adds it to
   *   the entire subtree via prototypal inheritance.
   *
   * <pre>data: {
   *     requiredRole: 'foo'
   * } </pre>
   *
   * @param {object=} stateConfig.params
   * <a id='params'></a>
   *
   * A map which optionally configures parameters declared in the `url`, or
   *   defines additional non-url parameters.  For each parameter being
   *   configured, add a configuration object keyed to the name of the parameter.
   *
   *   Each parameter configuration object may contain the following properties:
   *
   *   - ** value ** - {object|function=}: specifies the default value for this
   *     parameter.  This implicitly sets this parameter as optional.
   *
   *     When UI-Router routes to a state and no value is
   *     specified for this parameter in the URL or transition, the
   *     default value will be used instead.  If `value` is a function,
   *     it will be injected and invoked, and the return value used.
   *
   *     *Note*: `undefined` is treated as "no default value" while `null`
   *     is treated as "the default value is `null`".
   *
   *     *Shorthand*: If you only need to configure the default value of the
   *     parameter, you may use a shorthand syntax.   In the **`params`**
   *     map, instead mapping the param name to a full parameter configuration
   *     object, simply set map it to the default parameter value, e.g.:
   *
   * <pre>// define a parameter's default value
   * params: {
   *     param1: { value: "defaultValue" }
   * }
   * // shorthand default values
   * params: {
   *     param1: "defaultValue",
   *     param2: "param2Default"
   * }</pre>
   *
   *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
   *     treated as an array of values.  If you specified a Type, the value will be
   *     treated as an array of the specified Type.  Note: query parameter values
   *     default to a special `"auto"` mode.
   *
   *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
   *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
   *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
   *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
   *     value (e.g.: `{ foo: '1' }`).
   *
   * <pre>params: {
   *     param1: { array: true }
   * }</pre>
   *
   *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
   *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
   *     configured default squash policy.
   *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
   *
   *   There are three squash settings:
   *
   *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
   *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
   *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
   *       This can allow for cleaner looking URLs.
   *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
   *
   * <pre>params: {
   *     param1: {
   *       value: "defaultId",
   *       squash: true
   * } }
   * // squash "defaultValue" to "~"
   * params: {
   *     param1: {
   *       value: "defaultValue",
   *       squash: "~"
   * } }
   * </pre>
   *
   *
   * @example
   * <pre>
   * // Some state name examples
   *
   * // stateName can be a single top-level name (must be unique).
   * $stateProvider.state("home", {});
   *
   * // Or it can be a nested state name. This state is a child of the
   * // above "home" state.
   * $stateProvider.state("home.newest", {});
   *
   * // Nest states as deeply as needed.
   * $stateProvider.state("home.newest.abc.xyz.inception", {});
   *
   * // state() returns $stateProvider, so you can chain state declarations.
   * $stateProvider
   *   .state("home", {})
   *   .state("about", {})
   *   .state("contacts", {});
   * </pre>
   *
   */
  this.state = state;
  function state(name, definition) {
    /*jshint validthis: true */
    if (isObject(name)) definition = name;
    else definition.name = name;
    registerState(definition);
    return this;
  }

  /**
   * @ngdoc object
   * @name ui.router.state.$state
   *
   * @requires $rootScope
   * @requires $q
   * @requires ui.router.state.$view
   * @requires $injector
   * @requires ui.router.util.$resolve
   * @requires ui.router.state.$stateParams
   * @requires ui.router.router.$urlRouter
   *
   * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
   * you'd like to test against the current active state.
   * @property {object} current A reference to the state's config object. However 
   * you passed it in. Useful for accessing custom data.
   * @property {object} transition Currently pending transition. A promise that'll 
   * resolve or reject.
   *
   * @description
   * `$state` service is responsible for representing states as well as transitioning
   * between them. It also provides interfaces to ask for current state or even states
   * you're coming from.
   */
  this.$get = $get;
  $get.$inject = ['$rootScope', '$q', '$view', '$injector', '$resolve', '$stateParams', '$urlRouter', '$location', '$urlMatcherFactory'];
  function $get(   $rootScope,   $q,   $view,   $injector,   $resolve,   $stateParams,   $urlRouter,   $location,   $urlMatcherFactory) {

    var TransitionSupersededError = new Error('transition superseded');

    var TransitionSuperseded = silenceUncaughtInPromise($q.reject(TransitionSupersededError));
    var TransitionPrevented = silenceUncaughtInPromise($q.reject(new Error('transition prevented')));
    var TransitionAborted = silenceUncaughtInPromise($q.reject(new Error('transition aborted')));
    var TransitionFailed = silenceUncaughtInPromise($q.reject(new Error('transition failed')));

    // Handles the case where a state which is the target of a transition is not found, and the user
    // can optionally retry or defer the transition
    function handleRedirect(redirect, state, params, options) {
      /**
       * @ngdoc event
       * @name ui.router.state.$state#$stateNotFound
       * @eventOf ui.router.state.$state
       * @eventType broadcast on root scope
       * @description
       * Fired when a requested state **cannot be found** using the provided state name during transition.
       * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
       * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
       * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
       * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
       *
       * @param {Object} event Event object.
       * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
       * @param {State} fromState Current state object.
       * @param {Object} fromParams Current state params.
       *
       * @example
       *
       * <pre>
       * // somewhere, assume lazy.state has not been defined
       * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
       *
       * // somewhere else
       * $scope.$on('$stateNotFound',
       * function(event, unfoundState, fromState, fromParams){
       *     console.log(unfoundState.to); // "lazy.state"
       *     console.log(unfoundState.toParams); // {a:1, b:2}
       *     console.log(unfoundState.options); // {inherit:false} + default options
       * })
       * </pre>
       */
      var evt = $rootScope.$broadcast('$stateNotFound', redirect, state, params);

      if (evt.defaultPrevented) {
        $urlRouter.update();
        return TransitionAborted;
      }

      if (!evt.retry) {
        return null;
      }

      // Allow the handler to return a promise to defer state lookup retry
      if (options.$retry) {
        $urlRouter.update();
        return TransitionFailed;
      }
      var retryTransition = $state.transition = $q.when(evt.retry);

      retryTransition.then(function() {
        if (retryTransition !== $state.transition) {
          $rootScope.$broadcast('$stateChangeCancel', redirect.to, redirect.toParams, state, params);
          return TransitionSuperseded;
        }
        redirect.options.$retry = true;
        return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
      }, function() {
        return TransitionAborted;
      });
      $urlRouter.update();

      return retryTransition;
    }

    root.locals = { resolve: null, globals: { $stateParams: {} } };

    $state = {
      params: {},
      current: root.self,
      $current: root,
      transition: null
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#reload
     * @methodOf ui.router.state.$state
     *
     * @description
     * A method that force reloads the current state. All resolves are re-resolved,
     * controllers reinstantiated, and events re-fired.
     *
     * @example
     * <pre>
     * var app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     $state.reload();
     *   }
     * });
     * </pre>
     *
     * `reload()` is just an alias for:
     * <pre>
     * $state.transitionTo($state.current, $stateParams, { 
     *   reload: true, inherit: false, notify: true
     * });
     * </pre>
     *
     * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
     * @example
     * <pre>
     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
     * //and current state is 'contacts.detail.item'
     * var app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     //will reload 'contact.detail' and 'contact.detail.item' states
     *     $state.reload('contact.detail');
     *   }
     * });
     * </pre>
     *
     * `reload()` is just an alias for:
     * <pre>
     * $state.transitionTo($state.current, $stateParams, { 
     *   reload: true, inherit: false, notify: true
     * });
     * </pre>

     * @returns {promise} A promise representing the state of the new transition. See
     * {@link ui.router.state.$state#methods_go $state.go}.
     */
    $state.reload = function reload(state) {
      return $state.transitionTo($state.current, $stateParams, { reload: state || true, inherit: false, notify: true});
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#go
     * @methodOf ui.router.state.$state
     *
     * @description
     * Convenience method for transitioning to a new state. `$state.go` calls 
     * `$state.transitionTo` internally but automatically sets options to 
     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
     * This allows you to easily use an absolute or relative to path and specify 
     * only the parameters you'd like to update (while letting unspecified parameters 
     * inherit from the currently active ancestor states).
     *
     * @example
     * <pre>
     * var app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.go('contact.detail');
     *   };
     * });
     * </pre>
     * <img src='../ngdoc_assets/StateGoExamples.png'/>
     *
     * @param {string} to Absolute state name or relative state path. Some examples:
     *
     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
     * - `$state.go('^')` - will go to a parent state
     * - `$state.go('^.sibling')` - will go to a sibling state
     * - `$state.go('.child.grandchild')` - will go to grandchild state
     *
     * @param {object=} params A map of the parameters that will be sent to the state, 
     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
     * defined parameters. Only parameters specified in the state definition can be overridden, new 
     * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
     * will get you all current parameters, etc.
     * @param {object=} options Options object. The options are:
     *
     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
     * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
     *    have changed.  It will reload the resolves and views of the current state and parent states.
     *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
     *    the transition reloads the resolves and views for that matched state, and all its children states.
     *
     * @returns {promise} A promise representing the state of the new transition.
     *
     * Possible success values:
     *
     * - $state.current
     *
     * <br/>Possible rejection values:
     *
     * - 'transition superseded' - when a newer transition has been started after this one
     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
     *   when a `$stateNotFound` `event.retry` promise errors.
     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
     * - *resolve error* - when an error has occurred with a `resolve`
     *
     */
    $state.go = function go(to, params, options) {
      return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#transitionTo
     * @methodOf ui.router.state.$state
     *
     * @description
     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
     *
     * @example
     * <pre>
     * var app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.transitionTo('contact.detail');
     *   };
     * });
     * </pre>
     *
     * @param {string} to State name.
     * @param {object=} toParams A map of the parameters that will be sent to the state,
     * will populate $stateParams.
     * @param {object=} options Options object. The options are:
     *
     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
     * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
     *    use this when you want to force a reload when *everything* is the same, including search params.
     *    if String, then will reload the state with the name given in reload, and any children.
     *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
     *
     * @returns {promise} A promise representing the state of the new transition. See
     * {@link ui.router.state.$state#methods_go $state.go}.
     */
    $state.transitionTo = function transitionTo(to, toParams, options) {
      toParams = toParams || {};
      options = extend({
        location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
      }, options || {});

      var from = $state.$current, fromParams = $state.params, fromPath = from.path;
      var evt, toState = findState(to, options.relative);

      // Store the hash param for later (since it will be stripped out by various methods)
      var hash = toParams['#'];

      if (!isDefined(toState)) {
        var redirect = { to: to, toParams: toParams, options: options };
        var redirectResult = handleRedirect(redirect, from.self, fromParams, options);

        if (redirectResult) {
          return redirectResult;
        }

        // Always retry once if the $stateNotFound was not prevented
        // (handles either redirect changed or state lazy-definition)
        to = redirect.to;
        toParams = redirect.toParams;
        options = redirect.options;
        toState = findState(to, options.relative);

        if (!isDefined(toState)) {
          if (!options.relative) throw new Error("No such state '" + to + "'");
          throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
        }
      }
      if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
      if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
      if (!toState.params.$$validates(toParams)) return TransitionFailed;

      toParams = toState.params.$$values(toParams);
      to = toState;

      var toPath = to.path;

      // Starting from the root of the path, keep all levels that haven't changed
      var keep = 0, state = toPath[keep], locals = root.locals, toLocals = [];

      if (!options.reload) {
        while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
          locals = toLocals[keep] = state.locals;
          keep++;
          state = toPath[keep];
        }
      } else if (isString(options.reload) || isObject(options.reload)) {
        if (isObject(options.reload) && !options.reload.name) {
          throw new Error('Invalid reload state object');
        }
        
        var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
        if (options.reload && !reloadState) {
          throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
        }

        while (state && state === fromPath[keep] && state !== reloadState) {
          locals = toLocals[keep] = state.locals;
          keep++;
          state = toPath[keep];
        }
      }

      // If we're going to the same state and all locals are kept, we've got nothing to do.
      // But clear 'transition', as we still want to cancel any other pending transitions.
      // TODO: We may not want to bump 'transition' if we're called from a location change
      // that we've initiated ourselves, because we might accidentally abort a legitimate
      // transition initiated from code?
      if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
        if (hash) toParams['#'] = hash;
        $state.params = toParams;
        copy($state.params, $stateParams);
        copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
        if (options.location && to.navigable && to.navigable.url) {
          $urlRouter.push(to.navigable.url, toParams, {
            $$avoidResync: true, replace: options.location === 'replace'
          });
          $urlRouter.update(true);
        }
        $state.transition = null;
        return $q.when($state.current);
      }

      // Filter parameters before we pass them to event handlers etc.
      toParams = filterByKeys(to.params.$$keys(), toParams || {});
      
      // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
      if (hash) toParams['#'] = hash;
      
      // Broadcast start event and cancel the transition if requested
      if (options.notify) {
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeStart
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired when the state transition **begins**. You can use `event.preventDefault()`
         * to prevent the transition from happening and then the transition promise will be
         * rejected with a `'transition prevented'` value.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         *
         * @example
         *
         * <pre>
         * $rootScope.$on('$stateChangeStart',
         * function(event, toState, toParams, fromState, fromParams){
         *     event.preventDefault();
         *     // transitionTo() promise will be rejected with
         *     // a 'transition prevented' error
         * })
         * </pre>
         */
        if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams, options).defaultPrevented) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          //Don't update and resync url if there's been a new transition started. see issue #2238, #600
          if ($state.transition == null) $urlRouter.update();
          return TransitionPrevented;
        }
      }

      // Resolve locals for the remaining states, but don't update any global state just
      // yet -- if anything fails to resolve the current state needs to remain untouched.
      // We also set up an inheritance chain for the locals here. This allows the view directive
      // to quickly look up the correct definition for each view in the current state. Even
      // though we create the locals object itself outside resolveState(), it is initially
      // empty and gets filled asynchronously. We need to keep track of the promise for the
      // (fully resolved) current locals, and pass this down the chain.
      var resolved = $q.when(locals);

      for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
        locals = toLocals[l] = inherit(locals);
        resolved = resolveState(state, toParams, state === to, resolved, locals, options);
      }

      // Once everything is resolved, we are ready to perform the actual transition
      // and return a promise for the new state. We also keep track of what the
      // current promise is, so that we can detect overlapping transitions and
      // keep only the outcome of the last transition.
      var transition = $state.transition = resolved.then(function () {
        var l, entering, exiting;

        if ($state.transition !== transition) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          return TransitionSuperseded;
        }

        // Exit 'from' states not kept
        for (l = fromPath.length - 1; l >= keep; l--) {
          exiting = fromPath[l];
          if (exiting.self.onExit) {
            $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
          }
          exiting.locals = null;
        }

        // Enter 'to' states not kept
        for (l = keep; l < toPath.length; l++) {
          entering = toPath[l];
          entering.locals = toLocals[l];
          if (entering.self.onEnter) {
            $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
          }
        }

        // Run it again, to catch any transitions in callbacks
        if ($state.transition !== transition) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          return TransitionSuperseded;
        }

        // Update globals in $state
        $state.$current = to;
        $state.current = to.self;
        $state.params = toParams;
        copy($state.params, $stateParams);
        $state.transition = null;

        if (options.location && to.navigable) {
          $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
            $$avoidResync: true, replace: options.location === 'replace'
          });
        }

        if (options.notify) {
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeSuccess
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired once the state transition is **complete**.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         */
          $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
        }
        $urlRouter.update(true);

        return $state.current;
      }).then(null, function (error) {
        // propagate TransitionSuperseded error without emitting $stateChangeCancel
        // as it was already emitted in the success handler above
        if (error === TransitionSupersededError) return TransitionSuperseded;

        if ($state.transition !== transition) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          return TransitionSuperseded;
        }

        $state.transition = null;
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeError
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired when an **error occurs** during transition. It's important to note that if you
         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
         * they will not throw traditionally. You must listen for this $stateChangeError event to
         * catch **ALL** errors.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         * @param {Error} error The resolve error object.
         */
        evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);

        if (!evt.defaultPrevented) {
          $urlRouter.update();
        }

        return $q.reject(error);
      });

      silenceUncaughtInPromise(transition);
      return transition;
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#is
     * @methodOf ui.router.state.$state
     *
     * @description
     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
     * but only checks for the full state name. If params is supplied then it will be
     * tested for strict equality against the current active params object, so all params
     * must match with none missing and no extras.
     *
     * @example
     * <pre>
     * $state.$current.name = 'contacts.details.item';
     *
     * // absolute name
     * $state.is('contact.details.item'); // returns true
     * $state.is(contactDetailItemStateObject); // returns true
     *
     * // relative name (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
     * </pre>
     *
     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
     * to test against the current active state.
     * @param {object=} options An options object.  The options are:
     *
     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
     * test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it is the state.
     */
    $state.is = function is(stateOrName, params, options) {
      options = extend({ relative: $state.$current }, options || {});
      var state = findState(stateOrName, options.relative);

      if (!isDefined(state)) { return undefined; }
      if ($state.$current !== state) { return false; }

      return !params || objectKeys(params).reduce(function(acc, key) {
        var paramDef = state.params[key];
        return acc && (!paramDef || paramDef.type.equals($stateParams[key], params[key]));
      }, true);
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#includes
     * @methodOf ui.router.state.$state
     *
     * @description
     * A method to determine if the current active state is equal to or is the child of the
     * state stateName. If any params are passed then they will be tested for a match as well.
     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
     *
     * @example
     * Partial and relative names
     * <pre>
     * $state.$current.name = 'contacts.details.item';
     *
     * // Using partial names
     * $state.includes("contacts"); // returns true
     * $state.includes("contacts.details"); // returns true
     * $state.includes("contacts.details.item"); // returns true
     * $state.includes("contacts.list"); // returns false
     * $state.includes("about"); // returns false
     *
     * // Using relative names (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
     * </pre>
     *
     * Basic globbing patterns
     * <pre>
     * $state.$current.name = 'contacts.details.item.url';
     *
     * $state.includes("*.details.*.*"); // returns true
     * $state.includes("*.details.**"); // returns true
     * $state.includes("**.item.**"); // returns true
     * $state.includes("*.details.item.url"); // returns true
     * $state.includes("*.details.*.url"); // returns true
     * $state.includes("*.details.*"); // returns false
     * $state.includes("item.**"); // returns false
     * </pre>
     *
     * @param {string} stateOrName A partial name, relative name, or glob pattern
     * to be searched for within the current state name.
     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
     * that you'd like to test against the current active state.
     * @param {object=} options An options object.  The options are:
     *
     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
     * .includes will test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it does include the state
     */
    $state.includes = function includes(stateOrName, params, options) {
      options = extend({ relative: $state.$current }, options || {});
      if (isString(stateOrName) && isGlob(stateOrName)) {
        if (!doesStateMatchGlob(stateOrName)) {
          return false;
        }
        stateOrName = $state.$current.name;
      }

      var state = findState(stateOrName, options.relative);
      if (!isDefined(state)) { return undefined; }
      if (!isDefined($state.$current.includes[state.name])) { return false; }
      if (!params) { return true; }

      var keys = objectKeys(params);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i], paramDef = state.params[key];
        if (paramDef && !paramDef.type.equals($stateParams[key], params[key])) {
          return false;
        }
      }

      return objectKeys(params).reduce(function(acc, key) {
        var paramDef = state.params[key];
        return acc && !paramDef || paramDef.type.equals($stateParams[key], params[key]);
      }, true);
    };


    /**
     * @ngdoc function
     * @name ui.router.state.$state#href
     * @methodOf ui.router.state.$state
     *
     * @description
     * A url generation method that returns the compiled url for the given state populated with the given params.
     *
     * @example
     * <pre>
     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
     * </pre>
     *
     * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
     * @param {object=} params An object of parameter values to fill the state's required parameters.
     * @param {object=} options Options object. The options are:
     *
     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
     *    ancestor with a valid url).
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
     * 
     * @returns {string} compiled state url
     */
    $state.href = function href(stateOrName, params, options) {
      options = extend({
        lossy:    true,
        inherit:  true,
        absolute: false,
        relative: $state.$current
      }, options || {});

      var state = findState(stateOrName, options.relative);

      if (!isDefined(state)) return null;
      if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
      
      var nav = (state && options.lossy) ? state.navigable : state;

      if (!nav || nav.url === undefined || nav.url === null) {
        return null;
      }
      return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys().concat('#'), params || {}), {
        absolute: options.absolute
      });
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#get
     * @methodOf ui.router.state.$state
     *
     * @description
     * Returns the state configuration object for any specific state or all states.
     *
     * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
     * the requested state. If not provided, returns an array of ALL state configs.
     * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
     * @returns {Object|Array} State configuration object or array of all objects.
     */
    $state.get = function (stateOrName, context) {
      if (arguments.length === 0) return map(objectKeys(states), function(name) { return states[name].self; });
      var state = findState(stateOrName, context || $state.$current);
      return (state && state.self) ? state.self : null;
    };

    function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
      // Make a restricted $stateParams with only the parameters that apply to this state if
      // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
      // we also need $stateParams to be available for any $injector calls we make during the
      // dependency resolution process.
      var $stateParams = (paramsAreFiltered) ? params : filterByKeys(state.params.$$keys(), params);
      var locals = { $stateParams: $stateParams };

      // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
      // We're also including $stateParams in this; that way the parameters are restricted
      // to the set that should be visible to the state, and are independent of when we update
      // the global $state and $stateParams values.
      dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
      var promises = [dst.resolve.then(function (globals) {
        dst.globals = globals;
      })];
      if (inherited) promises.push(inherited);

      function resolveViews() {
        var viewsPromises = [];

        // Resolve template and dependencies for all views.
        forEach(state.views, function (view, name) {
          var injectables = (view.resolve && view.resolve !== state.resolve ? view.resolve : {});
          injectables.$template = [ function () {
            return $view.load(name, { view: view, locals: dst.globals, params: $stateParams, notify: options.notify }) || '';
          }];

          viewsPromises.push($resolve.resolve(injectables, dst.globals, dst.resolve, state).then(function (result) {
            // References to the controller (only instantiated at link time)
            if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
              var injectLocals = angular.extend({}, injectables, dst.globals);
              result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
            } else {
              result.$$controller = view.controller;
            }
            // Provide access to the state itself for internal use
            result.$$state = state;
            result.$$controllerAs = view.controllerAs;
            result.$$resolveAs = view.resolveAs;
            dst[name] = result;
          }));
        });

        return $q.all(viewsPromises).then(function(){
          return dst.globals;
        });
      }

      // Wait for all the promises and then return the activation object
      return $q.all(promises).then(resolveViews).then(function (values) {
        return dst;
      });
    }

    return $state;
  }

  function shouldSkipReload(to, toParams, from, fromParams, locals, options) {
    // Return true if there are no differences in non-search (path/object) params, false if there are differences
    function nonSearchParamsEqual(fromAndToState, fromParams, toParams) {
      // Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
      function notSearchParam(key) {
        return fromAndToState.params[key].location != "search";
      }
      var nonQueryParamKeys = fromAndToState.params.$$keys().filter(notSearchParam);
      var nonQueryParams = pick.apply({}, [fromAndToState.params].concat(nonQueryParamKeys));
      var nonQueryParamSet = new $$UMFP.ParamSet(nonQueryParams);
      return nonQueryParamSet.$$equals(fromParams, toParams);
    }

    // If reload was not explicitly requested
    // and we're transitioning to the same state we're already in
    // and    the locals didn't change
    //     or they changed in a way that doesn't merit reloading
    //        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
    // Then return true.
    if (!options.reload && to === from &&
      (locals === from.locals || (to.self.reloadOnSearch === false && nonSearchParamsEqual(from, fromParams, toParams)))) {
      return true;
    }
  }
}

angular.module('ui.router.state')
  .factory('$stateParams', function () { return {}; })
  .constant("$state.runtime", { autoinject: true })
  .provider('$state', $StateProvider)
  // Inject $state to initialize when entering runtime. #2574
  .run(['$injector', function ($injector) {
    // Allow tests (stateSpec.js) to turn this off by defining this constant
    if ($injector.get("$state.runtime").autoinject) {
      $injector.get('$state');
    }
  }]);


$ViewProvider.$inject = [];
function $ViewProvider() {

  this.$get = $get;
  /**
   * @ngdoc object
   * @name ui.router.state.$view
   *
   * @requires ui.router.util.$templateFactory
   * @requires $rootScope
   *
   * @description
   *
   */
  $get.$inject = ['$rootScope', '$templateFactory'];
  function $get(   $rootScope,   $templateFactory) {
    return {
      // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
      /**
       * @ngdoc function
       * @name ui.router.state.$view#load
       * @methodOf ui.router.state.$view
       *
       * @description
       *
       * @param {string} name name
       * @param {object} options option object.
       */
      load: function load(name, options) {
        var result, defaults = {
          template: null, controller: null, view: null, locals: null, notify: true, async: true, params: {}
        };
        options = extend(defaults, options);

        if (options.view) {
          result = $templateFactory.fromConfig(options.view, options.params, options.locals);
        }
        return result;
      }
    };
  }
}

angular.module('ui.router.state').provider('$view', $ViewProvider);

/**
 * @ngdoc object
 * @name ui.router.state.$uiViewScrollProvider
 *
 * @description
 * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
 */
function $ViewScrollProvider() {

  var useAnchorScroll = false;

  /**
   * @ngdoc function
   * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
   * @methodOf ui.router.state.$uiViewScrollProvider
   *
   * @description
   * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
   * scrolling based on the url anchor.
   */
  this.useAnchorScroll = function () {
    useAnchorScroll = true;
  };

  /**
   * @ngdoc object
   * @name ui.router.state.$uiViewScroll
   *
   * @requires $anchorScroll
   * @requires $timeout
   *
   * @description
   * When called with a jqLite element, it scrolls the element into view (after a
   * `$timeout` so the DOM has time to refresh).
   *
   * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
   * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
   */
  this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
    if (useAnchorScroll) {
      return $anchorScroll;
    }

    return function ($element) {
      return $timeout(function () {
        $element[0].scrollIntoView();
      }, 0, false);
    };
  }];
}

angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-view
 *
 * @requires ui.router.state.$state
 * @requires $compile
 * @requires $controller
 * @requires $injector
 * @requires ui.router.state.$uiViewScroll
 * @requires $document
 *
 * @restrict ECA
 *
 * @description
 * The ui-view directive tells $state where to place your templates.
 *
 * @param {string=} name A view name. The name should be unique amongst the other views in the
 * same state. You can have views of the same name that live in different states.
 *
 * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
 * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
 * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
 * scroll ui-view elements into view when they are populated during a state activation.
 *
 * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
 * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
 *
 * @param {string=} onload Expression to evaluate whenever the view updates.
 *
 * @example
 * A view can be unnamed or named.
 * <pre>
 * <!-- Unnamed -->
 * <div ui-view></div>
 *
 * <!-- Named -->
 * <div ui-view="viewName"></div>
 * </pre>
 *
 * You can only have one unnamed view within any template (or root html). If you are only using a
 * single view and it is unnamed then you can populate it like so:
 * <pre>
 * <div ui-view></div>
 * $stateProvider.state("home", {
 *   template: "<h1>HELLO!</h1>"
 * })
 * </pre>
 *
 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#methods_state `views`}
 * config property, by name, in this case an empty name:
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }    
 * })
 * </pre>
 *
 * But typically you'll only use the views property if you name your view or have more than one view
 * in the same template. There's not really a compelling reason to name a view if its the only one,
 * but you could if you wanted, like so:
 * <pre>
 * <div ui-view="main"></div>
 * </pre>
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "main": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }    
 * })
 * </pre>
 *
 * Really though, you'll use views to set up multiple views:
 * <pre>
 * <div ui-view></div>
 * <div ui-view="chart"></div>
 * <div ui-view="data"></div>
 * </pre>
 *
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     },
 *     "chart": {
 *       template: "<chart_thing/>"
 *     },
 *     "data": {
 *       template: "<data_thing/>"
 *     }
 *   }    
 * })
 * </pre>
 *
 * Examples for `autoscroll`:
 *
 * <pre>
 * <!-- If autoscroll present with no expression,
 *      then scroll ui-view into view -->
 * <ui-view autoscroll/>
 *
 * <!-- If autoscroll present with valid expression,
 *      then scroll ui-view into view if expression evaluates to true -->
 * <ui-view autoscroll='true'/>
 * <ui-view autoscroll='false'/>
 * <ui-view autoscroll='scopeVariable'/>
 * </pre>
 *
 * Resolve data:
 *
 * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
 * can be customized using [[ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
 *
 * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
 * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
 * depends on `$resolve` data.
 *
 * Example usage of $resolve in a view template
 * <pre>
 * $stateProvider.state('home', {
 *   template: '<my-component user="$resolve.user"></my-component>',
 *   resolve: {
 *     user: function(UserService) { return UserService.fetchUser(); }
 *   }
 * });
 * </pre>
 */
$ViewDirective.$inject = ['$state', '$injector', '$uiViewScroll', '$interpolate', '$q'];
function $ViewDirective(   $state,   $injector,   $uiViewScroll,   $interpolate,   $q) {

  function getService() {
    return ($injector.has) ? function(service) {
      return $injector.has(service) ? $injector.get(service) : null;
    } : function(service) {
      try {
        return $injector.get(service);
      } catch (e) {
        return null;
      }
    };
  }

  var service = getService(),
      $animator = service('$animator'),
      $animate = service('$animate');

  // Returns a set of DOM manipulation functions based on which Angular version
  // it should use
  function getRenderer(attrs, scope) {
    var statics = function() {
      return {
        enter: function (element, target, cb) { target.after(element); cb(); },
        leave: function (element, cb) { element.remove(); cb(); }
      };
    };

    if ($animate) {
      return {
        enter: function(element, target, cb) {
          if (angular.version.minor > 2) {
            $animate.enter(element, null, target).then(cb);
          } else {
            $animate.enter(element, null, target, cb);
          }
        },
        leave: function(element, cb) {
          if (angular.version.minor > 2) {
            $animate.leave(element).then(cb);
          } else {
            $animate.leave(element, cb);
          }
        }
      };
    }

    if ($animator) {
      var animate = $animator && $animator(scope, attrs);

      return {
        enter: function(element, target, cb) {animate.enter(element, null, target); cb(); },
        leave: function(element, cb) { animate.leave(element); cb(); }
      };
    }

    return statics();
  }

  var directive = {
    restrict: 'ECA',
    terminal: true,
    priority: 400,
    transclude: 'element',
    compile: function (tElement, tAttrs, $transclude) {
      return function (scope, $element, attrs) {
        var previousEl, currentEl, currentScope, latestLocals,
            onloadExp     = attrs.onload || '',
            autoScrollExp = attrs.autoscroll,
            renderer      = getRenderer(attrs, scope),
            inherited     = $element.inheritedData('$uiView');

        scope.$on('$stateChangeSuccess', function() {
          updateView(false);
        });

        updateView(true);

        function cleanupLastView() {
          if (previousEl) {
            previousEl.remove();
            previousEl = null;
          }

          if (currentScope) {
            currentScope.$destroy();
            currentScope = null;
          }

          if (currentEl) {
            var $uiViewData = currentEl.data('$uiViewAnim');
            renderer.leave(currentEl, function() {
              $uiViewData.$$animLeave.resolve();
              previousEl = null;
            });

            previousEl = currentEl;
            currentEl = null;
          }
        }

        function updateView(firstTime) {
          var newScope,
              name            = getUiViewName(scope, attrs, $element, $interpolate),
              previousLocals  = name && $state.$current && $state.$current.locals[name];

          if (!firstTime && previousLocals === latestLocals) return; // nothing to do
          newScope = scope.$new();
          latestLocals = $state.$current.locals[name];

          /**
           * @ngdoc event
           * @name ui.router.state.directive:ui-view#$viewContentLoading
           * @eventOf ui.router.state.directive:ui-view
           * @eventType emits on ui-view directive scope
           * @description
           *
           * Fired once the view **begins loading**, *before* the DOM is rendered.
           *
           * @param {Object} event Event object.
           * @param {string} viewName Name of the view.
           */
          newScope.$emit('$viewContentLoading', name);

          var clone = $transclude(newScope, function(clone) {
            var animEnter = $q.defer(), animLeave = $q.defer();
            var viewAnimData = {
              $animEnter: animEnter.promise,
              $animLeave: animLeave.promise,
              $$animLeave: animLeave
            };

            clone.data('$uiViewAnim', viewAnimData);
            renderer.enter(clone, $element, function onUiViewEnter() {
              animEnter.resolve();
              if(currentScope) {
                currentScope.$emit('$viewContentAnimationEnded');
              }

              if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
                $uiViewScroll(clone);
              }
            });
            cleanupLastView();
          });

          currentEl = clone;
          currentScope = newScope;
          /**
           * @ngdoc event
           * @name ui.router.state.directive:ui-view#$viewContentLoaded
           * @eventOf ui.router.state.directive:ui-view
           * @eventType emits on ui-view directive scope
           * @description
           * Fired once the view is **loaded**, *after* the DOM is rendered.
           *
           * @param {Object} event Event object.
           * @param {string} viewName Name of the view.
           */
          currentScope.$emit('$viewContentLoaded', name);
          currentScope.$eval(onloadExp);
        }
      };
    }
  };

  return directive;
}

$ViewDirectiveFill.$inject = ['$compile', '$controller', '$state', '$interpolate'];
function $ViewDirectiveFill (  $compile,   $controller,   $state,   $interpolate) {
  return {
    restrict: 'ECA',
    priority: -400,
    compile: function (tElement) {
      var initial = tElement.html();
      if (tElement.empty) {
        tElement.empty();
      } else {
        // ng 1.0.0 doesn't have empty(), which cleans up data and handlers
        tElement[0].innerHTML = null;
      }

      return function (scope, $element, attrs) {
        var current = $state.$current,
            name = getUiViewName(scope, attrs, $element, $interpolate),
            locals  = current && current.locals[name];

        if (! locals) {
          $element.html(initial);
          $compile($element.contents())(scope);
          return;
        }

        $element.data('$uiView', { name: name, state: locals.$$state });
        $element.html(locals.$template ? locals.$template : initial);

        var resolveData = angular.extend({}, locals);
        scope[locals.$$resolveAs] = resolveData;

        var link = $compile($element.contents());

        if (locals.$$controller) {
          locals.$scope = scope;
          locals.$element = $element;
          var controller = $controller(locals.$$controller, locals);
          if (locals.$$controllerAs) {
            scope[locals.$$controllerAs] = controller;
            scope[locals.$$controllerAs][locals.$$resolveAs] = resolveData;
          }
          if (isFunction(controller.$onInit)) controller.$onInit();
          $element.data('$ngControllerController', controller);
          $element.children().data('$ngControllerController', controller);
        }

        link(scope);
      };
    }
  };
}

/**
 * Shared ui-view code for both directives:
 * Given scope, element, and its attributes, return the view's name
 */
function getUiViewName(scope, attrs, element, $interpolate) {
  var name = $interpolate(attrs.uiView || attrs.name || '')(scope);
  var uiViewCreatedBy = element.inheritedData('$uiView');
  return name.indexOf('@') >= 0 ?  name :  (name + '@' + (uiViewCreatedBy ? uiViewCreatedBy.state.name : ''));
}

angular.module('ui.router.state').directive('uiView', $ViewDirective);
angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);

function parseStateRef(ref, current) {
  var preparsed = ref.match(/^\s*({[^}]*})\s*$/), parsed;
  if (preparsed) ref = current + '(' + preparsed[1] + ')';
  parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
  if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
  return { state: parsed[1], paramExpr: parsed[3] || null };
}

function stateContext(el) {
  var stateData = el.parent().inheritedData('$uiView');

  if (stateData && stateData.state && stateData.state.name) {
    return stateData.state;
  }
}

function getTypeInfo(el) {
  // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
  var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
  var isForm = el[0].nodeName === "FORM";

  return {
    attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
    isAnchor: el.prop("tagName").toUpperCase() === "A",
    clickable: !isForm
  };
}

function clickHook(el, $state, $timeout, type, current) {
  return function(e) {
    var button = e.which || e.button, target = current();

    if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
      // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
      var transition = $timeout(function() {
        $state.go(target.state, target.params, target.options);
      });
      e.preventDefault();

      // if the state has no URL, ignore one preventDefault from the <a> directive.
      var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1: 0;

      e.preventDefault = function() {
        if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
      };
    }
  };
}

function defaultOpts(el, $state) {
  return { relative: stateContext(el) || $state.$current, inherit: true };
}

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref
 *
 * @requires ui.router.state.$state
 * @requires $timeout
 *
 * @restrict A
 *
 * @description
 * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
 * URL, the directive will automatically generate & update the `href` attribute via
 * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
 * the link will trigger a state transition with optional parameters.
 *
 * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
 * handled natively by the browser.
 *
 * You can also use relative state paths within ui-sref, just like the relative
 * paths passed to `$state.go()`. You just need to be aware that the path is relative
 * to the state that the link lives in, in other words the state that loaded the
 * template containing the link.
 *
 * You can specify options to pass to {@link ui.router.state.$state#methods_go $state.go()}
 * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
 * and `reload`.
 *
 * @example
 * Here's an example of how you'd use ui-sref and how it would compile. If you have the
 * following template:
 * <pre>
 * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
 *     </li>
 * </ul>
 * </pre>
 *
 * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
 * <pre>
 * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
 *     </li>
 * </ul>
 *
 * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
 * </pre>
 *
 * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
 * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
 */
$StateRefDirective.$inject = ['$state', '$timeout'];
function $StateRefDirective($state, $timeout) {
  return {
    restrict: 'A',
    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
    link: function(scope, element, attrs, uiSrefActive) {
      var ref    = parseStateRef(attrs.uiSref, $state.current.name);
      var def    = { state: ref.state, href: null, params: null };
      var type   = getTypeInfo(element);
      var active = uiSrefActive[1] || uiSrefActive[0];
      var unlinkInfoFn = null;
      var hookFn;

      def.options = extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});

      var update = function(val) {
        if (val) def.params = angular.copy(val);
        def.href = $state.href(ref.state, def.params, def.options);

        if (unlinkInfoFn) unlinkInfoFn();
        if (active) unlinkInfoFn = active.$$addStateInfo(ref.state, def.params);
        if (def.href !== null) attrs.$set(type.attr, def.href);
      };

      if (ref.paramExpr) {
        scope.$watch(ref.paramExpr, function(val) { if (val !== def.params) update(val); }, true);
        def.params = angular.copy(scope.$eval(ref.paramExpr));
      }
      update();

      if (!type.clickable) return;
      hookFn = clickHook(element, $state, $timeout, type, function() { return def; });
      element[element.on ? 'on' : 'bind']("click", hookFn);
      scope.$on('$destroy', function() {
        element[element.off ? 'off' : 'unbind']("click", hookFn);
      });
    }
  };
}

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-state
 *
 * @requires ui.router.state.uiSref
 *
 * @restrict A
 *
 * @description
 * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
 * params and override options.
 *
 * @param {string} ui-state 'stateName' can be any valid absolute or relative state
 * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#methods_href $state.href()}
 * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
 */
$StateRefDynamicDirective.$inject = ['$state', '$timeout'];
function $StateRefDynamicDirective($state, $timeout) {
  return {
    restrict: 'A',
    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
    link: function(scope, element, attrs, uiSrefActive) {
      var type   = getTypeInfo(element);
      var active = uiSrefActive[1] || uiSrefActive[0];
      var group  = [attrs.uiState, attrs.uiStateParams || null, attrs.uiStateOpts || null];
      var watch  = '[' + group.map(function(val) { return val || 'null'; }).join(', ') + ']';
      var def    = { state: null, params: null, options: null, href: null };
      var unlinkInfoFn = null;
      var hookFn;

      function runStateRefLink (group) {
        def.state = group[0]; def.params = group[1]; def.options = group[2];
        def.href = $state.href(def.state, def.params, def.options);

        if (unlinkInfoFn) unlinkInfoFn();
        if (active) unlinkInfoFn = active.$$addStateInfo(def.state, def.params);
        if (def.href) attrs.$set(type.attr, def.href);
      }

      scope.$watch(watch, runStateRefLink, true);
      runStateRefLink(scope.$eval(watch));

      if (!type.clickable) return;
      hookFn = clickHook(element, $state, $timeout, type, function() { return def; });
      element[element.on ? 'on' : 'bind']("click", hookFn);
      scope.$on('$destroy', function() {
        element[element.off ? 'off' : 'unbind']("click", hookFn);
      });
    }
  };
}


/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref-active
 *
 * @requires ui.router.state.$state
 * @requires ui.router.state.$stateParams
 * @requires $interpolate
 *
 * @restrict A
 *
 * @description
 * A directive working alongside ui-sref to add classes to an element when the
 * related ui-sref directive's state is active, and removing them when it is inactive.
 * The primary use-case is to simplify the special appearance of navigation menus
 * relying on `ui-sref`, by having the "active" state's menu button appear different,
 * distinguishing it from the inactive menu items.
 *
 * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
 * ui-sref-active found at the same level or above the ui-sref will be used.
 *
 * Will activate when the ui-sref's target state or any child state is active. If you
 * need to activate only when the ui-sref target state is active and *not* any of
 * it's children, then you will use
 * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
 *
 * @example
 * Given the following template:
 * <pre>
 * <ul>
 *   <li ui-sref-active="active" class="item">
 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
 *   </li>
 * </ul>
 * </pre>
 *
 *
 * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
 * the resulting HTML will appear as (note the 'active' class):
 * <pre>
 * <ul>
 *   <li ui-sref-active="active" class="item active">
 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
 *   </li>
 * </ul>
 * </pre>
 *
 * The class name is interpolated **once** during the directives link time (any further changes to the
 * interpolated value are ignored).
 *
 * Multiple classes may be specified in a space-separated format:
 * <pre>
 * <ul>
 *   <li ui-sref-active='class1 class2 class3'>
 *     <a ui-sref="app.user">link</a>
 *   </li>
 * </ul>
 * </pre>
 *
 * It is also possible to pass ui-sref-active an expression that evaluates
 * to an object hash, whose keys represent active class names and whose
 * values represent the respective state names/globs.
 * ui-sref-active will match if the current active state **includes** any of
 * the specified state names/globs, even the abstract ones.
 *
 * @Example
 * Given the following template, with "admin" being an abstract state:
 * <pre>
 * <div ui-sref-active="{'active': 'admin.*'}">
 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
 * </div>
 * </pre>
 *
 * When the current state is "admin.roles" the "active" class will be applied
 * to both the <div> and <a> elements. It is important to note that the state
 * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
 */

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref-active-eq
 *
 * @requires ui.router.state.$state
 * @requires ui.router.state.$stateParams
 * @requires $interpolate
 *
 * @restrict A
 *
 * @description
 * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
 * when the exact target state used in the `ui-sref` is active; no child states.
 *
 */
$StateRefActiveDirective.$inject = ['$state', '$stateParams', '$interpolate'];
function $StateRefActiveDirective($state, $stateParams, $interpolate) {
  return  {
    restrict: "A",
    controller: ['$scope', '$element', '$attrs', '$timeout', function ($scope, $element, $attrs, $timeout) {
      var states = [], activeClasses = {}, activeEqClass, uiSrefActive;

      // There probably isn't much point in $observing this
      // uiSrefActive and uiSrefActiveEq share the same directive object with some
      // slight difference in logic routing
      activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);

      try {
        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
      } catch (e) {
        // Do nothing. uiSrefActive is not a valid expression.
        // Fall back to using $interpolate below
      }
      uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
      if (isObject(uiSrefActive)) {
        forEach(uiSrefActive, function(stateOrName, activeClass) {
          if (isString(stateOrName)) {
            var ref = parseStateRef(stateOrName, $state.current.name);
            addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
          }
        });
      }

      // Allow uiSref to communicate with uiSrefActive[Equals]
      this.$$addStateInfo = function (newState, newParams) {
        // we already got an explicit state provided by ui-sref-active, so we
        // shadow the one that comes from ui-sref
        if (isObject(uiSrefActive) && states.length > 0) {
          return;
        }
        var deregister = addState(newState, newParams, uiSrefActive);
        update();
        return deregister;
      };

      $scope.$on('$stateChangeSuccess', update);

      function addState(stateName, stateParams, activeClass) {
        var state = $state.get(stateName, stateContext($element));
        var stateHash = createStateHash(stateName, stateParams);

        var stateInfo = {
          state: state || { name: stateName },
          params: stateParams,
          hash: stateHash
        };

        states.push(stateInfo);
        activeClasses[stateHash] = activeClass;

        return function removeState() {
          var idx = states.indexOf(stateInfo);
          if (idx !== -1) states.splice(idx, 1);
        };
      }

      /**
       * @param {string} state
       * @param {Object|string} [params]
       * @return {string}
       */
      function createStateHash(state, params) {
        if (!isString(state)) {
          throw new Error('state should be a string');
        }
        if (isObject(params)) {
          return state + toJson(params);
        }
        params = $scope.$eval(params);
        if (isObject(params)) {
          return state + toJson(params);
        }
        return state;
      }

      // Update route state
      function update() {
        for (var i = 0; i < states.length; i++) {
          if (anyMatch(states[i].state, states[i].params)) {
            addClass($element, activeClasses[states[i].hash]);
          } else {
            removeClass($element, activeClasses[states[i].hash]);
          }

          if (exactMatch(states[i].state, states[i].params)) {
            addClass($element, activeEqClass);
          } else {
            removeClass($element, activeEqClass);
          }
        }
      }

      function addClass(el, className) { $timeout(function () { el.addClass(className); }); }
      function removeClass(el, className) { el.removeClass(className); }
      function anyMatch(state, params) { return $state.includes(state.name, params); }
      function exactMatch(state, params) { return $state.is(state.name, params); }

      update();
    }]
  };
}

angular.module('ui.router.state')
  .directive('uiSref', $StateRefDirective)
  .directive('uiSrefActive', $StateRefActiveDirective)
  .directive('uiSrefActiveEq', $StateRefActiveDirective)
  .directive('uiState', $StateRefDynamicDirective);

/**
 * @ngdoc filter
 * @name ui.router.state.filter:isState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
 */
$IsStateFilter.$inject = ['$state'];
function $IsStateFilter($state) {
  var isFilter = function (state, params) {
    return $state.is(state, params);
  };
  isFilter.$stateful = true;
  return isFilter;
}

/**
 * @ngdoc filter
 * @name ui.router.state.filter:includedByState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
 */
$IncludedByStateFilter.$inject = ['$state'];
function $IncludedByStateFilter($state) {
  var includesFilter = function (state, params, options) {
    return $state.includes(state, params, options);
  };
  includesFilter.$stateful = true;
  return  includesFilter;
}

angular.module('ui.router.state')
  .filter('isState', $IsStateFilter)
  .filter('includedByState', $IncludedByStateFilter);
})(window, window.angular);;
/*!
 * js-data
 * @version 2.8.2 - Homepage <http://www.js-data.io/>
 * @author Jason Dobry <jason.dobry@gmail.com>
 * @copyright (c) 2014-2015 Jason Dobry 
 * @license MIT <https://github.com/js-data/js-data/blob/master/LICENSE>
 * 
 * @overview Robust framework-agnostic data store.
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["JSData"] = factory();
	else
		root["JSData"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var _datastoreIndex = __webpack_require__(1);

	var _utils = __webpack_require__(2);

	var _errors = __webpack_require__(3);

	/**
	 * The library export.
	 *   - window.JSData
	 *   - require('js-data')
	 *   - define(['js-data', function (JSData) { ... }]);
	 *   - import JSData from 'js-data'
	 */
	module.exports = {
	  DS: _datastoreIndex['default'],
	  DSUtils: _utils['default'],
	  DSErrors: _errors['default'],
	  createStore: function createStore(options) {
	    return new _datastoreIndex['default'](options);
	  },
	  version: {
	    full: '2.8.2',
	    major: parseInt('2', 10),
	    minor: parseInt('8', 10),
	    patch: parseInt('2', 10),
	    alpha:  true ? 'false' : false,
	    beta:  true ? 'false' : false
	  }
	};

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	/* jshint eqeqeq:false */

	var _utils = __webpack_require__(2);

	var _errors = __webpack_require__(3);

	var _sync_methodsIndex = __webpack_require__(30);

	var _async_methodsIndex = __webpack_require__(36);

	function lifecycleNoopCb(resource, attrs, cb) {
	  cb(null, attrs);
	}

	function lifecycleNoop(resource, attrs) {
	  return attrs;
	}

	function compare(_x, _x2, _x3, _x4) {
	  var _again = true;

	  _function: while (_again) {
	    var orderBy = _x,
	        index = _x2,
	        a = _x3,
	        b = _x4;
	    def = cA = cB = undefined;
	    _again = false;

	    var def = orderBy[index];
	    var cA = _utils['default'].get(a, def[0]);
	    var cB = _utils['default'].get(b, def[0]);
	    if (_utils['default']._s(cA)) {
	      cA = _utils['default'].upperCase(cA);
	    }
	    if (_utils['default']._s(cB)) {
	      cB = _utils['default'].upperCase(cB);
	    }
	    if (def[1] === 'DESC') {
	      if (cB < cA) {
	        return -1;
	      } else if (cB > cA) {
	        return 1;
	      } else {
	        if (index < orderBy.length - 1) {
	          _x = orderBy;
	          _x2 = index + 1;
	          _x3 = a;
	          _x4 = b;
	          _again = true;
	          continue _function;
	        } else {
	          return 0;
	        }
	      }
	    } else {
	      if (cA < cB) {
	        return -1;
	      } else if (cA > cB) {
	        return 1;
	      } else {
	        if (index < orderBy.length - 1) {
	          _x = orderBy;
	          _x2 = index + 1;
	          _x3 = a;
	          _x4 = b;
	          _again = true;
	          continue _function;
	        } else {
	          return 0;
	        }
	      }
	    }
	  }
	}

	var Defaults = (function () {
	  function Defaults() {
	    _classCallCheck(this, Defaults);
	  }

	  _createClass(Defaults, [{
	    key: 'errorFn',
	    value: function errorFn(a, b) {
	      if (this.error && typeof this.error === 'function') {
	        try {
	          if (typeof a === 'string') {
	            throw new Error(a);
	          } else {
	            throw a;
	          }
	        } catch (err) {
	          a = err;
	        }
	        this.error(this.name || null, a || null, b || null);
	      }
	    }
	  }]);

	  return Defaults;
	})();

	var defaultsPrototype = Defaults.prototype;

	defaultsPrototype.actions = {};
	defaultsPrototype.afterCreate = lifecycleNoopCb;
	defaultsPrototype.afterCreateCollection = lifecycleNoop;
	defaultsPrototype.afterCreateInstance = lifecycleNoop;
	defaultsPrototype.afterDestroy = lifecycleNoopCb;
	defaultsPrototype.afterEject = lifecycleNoop;
	defaultsPrototype.afterFind = lifecycleNoopCb;
	defaultsPrototype.afterFindAll = lifecycleNoopCb;
	defaultsPrototype.afterInject = lifecycleNoop;
	defaultsPrototype.afterLoadRelations = lifecycleNoopCb;
	defaultsPrototype.afterReap = lifecycleNoop;
	defaultsPrototype.afterUpdate = lifecycleNoopCb;
	defaultsPrototype.afterValidate = lifecycleNoopCb;
	defaultsPrototype.allowSimpleWhere = true;
	defaultsPrototype.basePath = '';
	defaultsPrototype.beforeCreate = lifecycleNoopCb;
	defaultsPrototype.beforeCreateCollection = lifecycleNoop;
	defaultsPrototype.beforeCreateInstance = lifecycleNoop;
	defaultsPrototype.beforeDestroy = lifecycleNoopCb;
	defaultsPrototype.beforeEject = lifecycleNoop;
	defaultsPrototype.beforeInject = lifecycleNoop;
	defaultsPrototype.beforeReap = lifecycleNoop;
	defaultsPrototype.beforeUpdate = lifecycleNoopCb;
	defaultsPrototype.beforeValidate = lifecycleNoopCb;
	defaultsPrototype.bypassCache = false;
	defaultsPrototype.cacheResponse = !!_utils['default'].w;
	defaultsPrototype.csp = false;
	defaultsPrototype.clearEmptyQueries = true;
	defaultsPrototype.computed = {};
	defaultsPrototype.defaultAdapter = 'http';
	defaultsPrototype.debug = false;
	defaultsPrototype.defaultValues = {};
	defaultsPrototype.eagerEject = false;
	// TODO: Implement eagerInject in DS#create
	defaultsPrototype.eagerInject = false;
	defaultsPrototype.endpoint = '';
	defaultsPrototype.error = console ? function (a, b, c) {
	  return console[typeof console.error === 'function' ? 'error' : 'log'](a, b, c);
	} : false;
	defaultsPrototype.errorHandler = function () {
	  return _utils['default'].Promise.reject(arguments[0]);
	};
	defaultsPrototype.fallbackAdapters = ['http'];
	defaultsPrototype.findStrictCache = false;
	defaultsPrototype.idAttribute = 'id';
	defaultsPrototype.ignoredChanges = [/\$/];
	defaultsPrototype.instanceEvents = !!_utils['default'].w;
	defaultsPrototype.keepChangeHistory = false;
	defaultsPrototype.linkRelations = !!_utils['default'].w;
	defaultsPrototype.log = console ? function (a, b, c, d, e) {
	  return console[typeof console.info === 'function' ? 'info' : 'log'](a, b, c, d, e);
	} : false;

	defaultsPrototype.logFn = function (a, b, c, d) {
	  var _this = this;
	  if (_this.debug && _this.log && typeof _this.log === 'function') {
	    _this.log(_this.name || null, a || null, b || null, c || null, d || null);
	  }
	};

	defaultsPrototype.maxAge = false;
	defaultsPrototype.methods = {};
	defaultsPrototype.notify = !!_utils['default'].w;
	defaultsPrototype.omit = [];
	defaultsPrototype.onConflict = 'merge';
	defaultsPrototype.reapAction = _utils['default'].w ? 'inject' : 'none';
	defaultsPrototype.reapInterval = _utils['default'].w ? 30000 : false;
	defaultsPrototype.relationsEnumerable = false;
	defaultsPrototype.resetHistoryOnInject = true;
	defaultsPrototype.returnMeta = false;
	defaultsPrototype.scopes = {};
	defaultsPrototype.strategy = 'single';
	defaultsPrototype.upsert = !!_utils['default'].w;
	defaultsPrototype.useClass = true;
	defaultsPrototype.useFilter = false;
	defaultsPrototype.validate = lifecycleNoopCb;
	defaultsPrototype.watchChanges = !!_utils['default'].w;

	var escapeRegExp = /([.*+?^=!:${}()|[\]\/\\])/g;
	var percentRegExp = /%/g;
	var underscoreRegExp = /_/g;

	function escape(pattern) {
	  return pattern.replace(escapeRegExp, '\\$1');
	}

	function like(pattern, flags) {
	  return new RegExp('^' + escape(pattern).replace(percentRegExp, '.*').replace(underscoreRegExp, '.') + '$', flags);
	}

	defaultsPrototype.defaultFilter = function (collection, resourceName, params, options) {
	  var filtered = collection;
	  var where = null;
	  var reserved = {
	    skip: '',
	    offset: '',
	    where: '',
	    limit: '',
	    orderBy: '',
	    sort: ''
	  };

	  params = params || {};
	  options = options || {};

	  if (_utils['default']._o(params.where)) {
	    where = params.where;
	  } else {
	    where = {};
	  }

	  if (options.allowSimpleWhere) {
	    _utils['default'].forOwn(params, function (value, key) {
	      if (!(key in reserved) && !(key in where)) {
	        where[key] = {
	          '==': value
	        };
	      }
	    });
	  }

	  if (_utils['default'].isEmpty(where)) {
	    where = null;
	  }

	  if (where) {
	    filtered = _utils['default'].filter(filtered, function (attrs) {
	      var first = true;
	      var keep = true;
	      _utils['default'].forOwn(where, function (clause, field) {
	        if (!_utils['default']._o(clause)) {
	          clause = {
	            '==': clause
	          };
	        }
	        _utils['default'].forOwn(clause, function (term, op) {
	          var expr = undefined;
	          var isOr = op[0] === '|';
	          var val = _utils['default'].get(attrs, field);
	          op = isOr ? op.substr(1) : op;
	          if (op === '==') {
	            expr = val == term; // eslint-disable-line
	          } else if (op === '===') {
	              expr = val === term;
	            } else if (op === '!=') {
	              expr = val != term; // eslint-disable-line
	            } else if (op === '!==') {
	                expr = val !== term;
	              } else if (op === '>') {
	                expr = val > term;
	              } else if (op === '>=') {
	                expr = val >= term;
	              } else if (op === '<') {
	                expr = val < term;
	              } else if (op === '<=') {
	                expr = val <= term;
	              } else if (op === 'isectEmpty') {
	                expr = !_utils['default'].intersection(val || [], term || []).length;
	              } else if (op === 'isectNotEmpty') {
	                expr = _utils['default'].intersection(val || [], term || []).length;
	              } else if (op === 'in') {
	                if (_utils['default']._s(term)) {
	                  expr = term.indexOf(val) !== -1;
	                } else {
	                  expr = _utils['default'].contains(term, val);
	                }
	              } else if (op === 'notIn') {
	                if (_utils['default']._s(term)) {
	                  expr = term.indexOf(val) === -1;
	                } else {
	                  expr = !_utils['default'].contains(term, val);
	                }
	              } else if (op.indexOf('like') === 0) {
	                expr = like(term, op.substr(4)).exec(val) !== null;
	              } else if (op.indexOf('notLike') === 0) {
	                expr = like(term, op.substr(7)).exec(val) === null;
	              } else if (op === 'contains') {
	                if (_utils['default']._s(val)) {
	                  expr = val.indexOf(term) !== -1;
	                } else {
	                  expr = _utils['default'].contains(val, term);
	                }
	              } else if (op === 'notContains') {
	                if (_utils['default']._s(val)) {
	                  expr = val.indexOf(term) === -1;
	                } else {
	                  expr = !_utils['default'].contains(val, term);
	                }
	              }
	          if (expr !== undefined) {
	            keep = first ? expr : isOr ? keep || expr : keep && expr;
	          }
	          first = false;
	        });
	      });
	      return keep;
	    });
	  }

	  var orderBy = null;

	  if (_utils['default']._s(params.orderBy)) {
	    orderBy = [[params.orderBy, 'ASC']];
	  } else if (_utils['default']._a(params.orderBy)) {
	    orderBy = params.orderBy;
	  }

	  if (!orderBy && _utils['default']._s(params.sort)) {
	    orderBy = [[params.sort, 'ASC']];
	  } else if (!orderBy && _utils['default']._a(params.sort)) {
	    orderBy = params.sort;
	  }

	  // Apply 'orderBy'
	  if (orderBy) {
	    (function () {
	      var index = 0;
	      _utils['default'].forEach(orderBy, function (def, i) {
	        if (_utils['default']._s(def)) {
	          orderBy[i] = [def, 'ASC'];
	        } else if (!_utils['default']._a(def)) {
	          throw new _errors['default'].IA('DS.filter("' + resourceName + '"[, params][, options]): ' + _utils['default'].toJson(def) + ': Must be a string or an array!', {
	            params: {
	              'orderBy[i]': {
	                actual: typeof def,
	                expected: 'string|array'
	              }
	            }
	          });
	        }
	      });
	      filtered = _utils['default'].sort(filtered, function (a, b) {
	        return compare(orderBy, index, a, b);
	      });
	    })();
	  }

	  var limit = _utils['default']._n(params.limit) ? params.limit : null;
	  var skip = null;

	  if (_utils['default']._n(params.skip)) {
	    skip = params.skip;
	  } else if (_utils['default']._n(params.offset)) {
	    skip = params.offset;
	  }

	  // Apply 'limit' and 'skip'
	  if (limit && skip) {
	    filtered = _utils['default'].slice(filtered, skip, Math.min(filtered.length, skip + limit));
	  } else if (_utils['default']._n(limit)) {
	    filtered = _utils['default'].slice(filtered, 0, Math.min(filtered.length, limit));
	  } else if (_utils['default']._n(skip)) {
	    if (skip < filtered.length) {
	      filtered = _utils['default'].slice(filtered, skip);
	    } else {
	      filtered = [];
	    }
	  }

	  return filtered === collection ? filtered.slice() : filtered;
	};

	var DS = (function () {
	  function DS(options) {
	    _classCallCheck(this, DS);

	    var _this = this;
	    options = options || {};

	    _this.store = {};
	    _this.definitions = {};
	    _this.adapters = {};
	    _this.defaults = new Defaults();
	    _this.observe = _utils['default'].observe;
	    _utils['default'].forOwn(options, function (v, k) {
	      if (k === 'omit') {
	        _this.defaults.omit = v.concat(Defaults.prototype.omit);
	      } else {
	        _this.defaults[k] = v;
	      }
	    });

	    var P = _utils['default'].Promise;

	    if (P && !P.prototype.spread) {
	      P.prototype.spread = function (cb) {
	        return this.then(function (arr) {
	          return cb.apply(this, arr);
	        });
	      };
	    }

	    _utils['default'].Events(_this);
	  }

	  _createClass(DS, [{
	    key: 'getAdapterName',
	    value: function getAdapterName(options) {
	      var errorIfNotExist = false;
	      options = options || {};
	      if (_utils['default']._s(options)) {
	        errorIfNotExist = true;
	        options = {
	          adapter: options
	        };
	      }
	      if (this.adapters[options.adapter]) {
	        return options.adapter;
	      } else if (errorIfNotExist) {
	        throw new Error(options.adapter + ' is not a registered adapter!');
	      } else {
	        return options.defaultAdapter;
	      }
	    }
	  }, {
	    key: 'getAdapter',
	    value: function getAdapter(options) {
	      options = options || {};
	      return this.adapters[this.getAdapterName(options)];
	    }
	  }, {
	    key: 'registerAdapter',
	    value: function registerAdapter(name, Adapter, options) {
	      var _this = this;
	      options = options || {};
	      if (_utils['default'].isFunction(Adapter)) {
	        _this.adapters[name] = new Adapter(options);
	      } else {
	        _this.adapters[name] = Adapter;
	      }
	      if (options['default']) {
	        _this.defaults.defaultAdapter = name;
	      }
	    }
	  }, {
	    key: 'is',
	    value: function is(resourceName, instance) {
	      var definition = this.definitions[resourceName];
	      if (!definition) {
	        throw new _errors['default'].NER(resourceName);
	      }
	      return instance instanceof definition[definition['class']];
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      var _this2 = this;

	      var ejected = {};
	      _utils['default'].forOwn(this.definitions, function (definition) {
	        var name = definition.name;
	        ejected[name] = definition.ejectAll();
	        _this2.store[name].completedQueries = {};
	        _this2.store[name].queryData = {};
	      });
	      return ejected;
	    }
	  }, {
	    key: 'errorFn',
	    value: function errorFn() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }

	      var options = args[args.length - 1];
	      var defaultHandler = this.defaults.errorHandler;
	      var errorHandler = options ? options.errorHandler : defaultHandler;
	      errorHandler = errorHandler || defaultHandler;
	      return function (err) {
	        return errorHandler.apply(undefined, [err].concat(args));
	      };
	    }
	  }]);

	  return DS;
	})();

	var dsPrototype = DS.prototype;

	dsPrototype.getAdapterName.shorthand = false;
	dsPrototype.getAdapter.shorthand = false;
	dsPrototype.registerAdapter.shorthand = false;
	dsPrototype.errors = _errors['default'];
	dsPrototype.utils = _utils['default'];

	function addMethods(target, obj) {
	  _utils['default'].forOwn(obj, function (v, k) {
	    target[k] = v;
	    target[k].before = function (fn) {
	      var orig = target[k];
	      target[k] = function () {
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          args[_key2] = arguments[_key2];
	        }

	        return orig.apply(this, fn.apply(this, args) || args);
	      };
	    };
	  });
	}

	addMethods(dsPrototype, _sync_methodsIndex['default']);
	addMethods(dsPrototype, _async_methodsIndex['default']);

	exports['default'] = DS;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint eqeqeq:false */

	/**
	 * Mix of ES6 and CommonJS module imports because the interop of Babel + Webpack + ES6 modules + CommonJS isn't very good.
	 */

	var _errors = __webpack_require__(3);

	var BinaryHeap = __webpack_require__(4);
	var forEach = __webpack_require__(5);
	var slice = __webpack_require__(6);
	var forOwn = __webpack_require__(7);
	var contains = __webpack_require__(10);
	var deepMixIn = __webpack_require__(12);
	var pascalCase = __webpack_require__(14);
	var remove = __webpack_require__(21);
	var pick = __webpack_require__(22);
	var _keys = __webpack_require__(23);
	var sort = __webpack_require__(24);
	var upperCase = __webpack_require__(19);
	var get = __webpack_require__(25);
	var set = __webpack_require__(27);
	var observe = __webpack_require__(29);
	var w = undefined,
	    P = undefined,
	    File = undefined;
	var objectProto = Object.prototype;
	var toString = objectProto.toString;

	/**
	 * Attempt to detect the global Promise constructor.
	 * JSData will still work without one, as long you do something like this:
	 *
	 * var JSData = require('js-data');
	 * JSData.DSUtils.Promise = MyPromiseLib;
	 */
	try {
	  P = Promise;
	} catch (e) {
	  console.error('js-data requires a global Promise constructor!');
	}

	try {
	  File = window.File;
	} catch (e) {
	  File = function () {};
	}

	function _isArray(value) {
	  return toString.call(value) === '[object Array]' || false;
	}

	var isArray = Array.isArray || _isArray;

	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]' || false;
	}

	// adapted from lodash.isString
	function isString(value) {
	  return typeof value === 'string' || value && typeof value === 'object' && toString.call(value) === '[object String]' || false;
	}

	function isObject(value) {
	  return toString.call(value) === '[object Object]' || false;
	}

	// adapted from lodash.isDate
	function isDate(value) {
	  return value && typeof value === 'object' && toString.call(value) === '[object Date]' || false;
	}

	// adapted from lodash.isNumber
	function isNumber(value) {
	  var type = typeof value;
	  return type === 'number' || value && type === 'object' && toString.call(value) === '[object Number]' || false;
	}

	// adapted from lodash.isFunction
	function isFunction(value) {
	  return typeof value === 'function' || value && toString.call(value) === '[object Function]' || false;
	}

	// shorthand argument checking functions, using these shaves 1.18 kb off of the minified build
	function isStringOrNumber(value) {
	  return isString(value) || isNumber(value);
	}

	function isStringOrNumberErr(field) {
	  return new _errors['default'].IA('"' + field + '" must be a string or a number!');
	}

	function isObjectErr(field) {
	  return new _errors['default'].IA('"' + field + '" must be an object!');
	}

	function isArrayErr(field) {
	  return new _errors['default'].IA('"' + field + '" must be an array!');
	}

	// adapted from mout.isEmpty
	function isEmpty(val) {
	  if (val == null) {
	    // jshint ignore:line
	    // typeof null == 'object' so we check it first
	    return true;
	  } else if (typeof val === 'string' || isArray(val)) {
	    return !val.length;
	  } else if (typeof val === 'object') {
	    var result = true;
	    forOwn(val, function () {
	      result = false;
	      return false; // break loop
	    });
	    return result;
	  } else {
	    return true;
	  }
	}

	// Find the intersection between two arrays
	function intersection(array1, array2) {
	  if (!array1 || !array2) {
	    return [];
	  }
	  var result = [];
	  var item = undefined;
	  for (var i = 0, _length = array1.length; i < _length; i++) {
	    item = array1[i];
	    if (contains(result, item)) {
	      continue;
	    }
	    if (contains(array2, item)) {
	      result.push(item);
	    }
	  }
	  return result;
	}

	function filter(array, cb, thisObj) {
	  var results = [];
	  forEach(array, function (value, key, arr) {
	    if (cb(value, key, arr)) {
	      results.push(value);
	    }
	  }, thisObj);
	  return results;
	}

	/**
	 * Attempt to detect whether we are in the browser.
	 */
	try {
	  w = window;
	  w = {};
	} catch (e) {
	  w = null;
	}

	/**
	 * Event mixin. Usage:
	 *
	 * function handler() { ... }
	 * Events(myObject);
	 * myObject.on('foo', handler);
	 * myObject.emit('foo', 'some', 'data');
	 * myObject.off('foo', handler);
	 */
	function Events(target) {
	  var events = {};
	  target = target || this;
	  Object.defineProperties(target, {
	    on: {
	      value: function value(type, func, ctx) {
	        events[type] = events[type] || [];
	        events[type].push({
	          f: func,
	          c: ctx
	        });
	      }
	    },
	    off: {
	      value: function value(type, func) {
	        var listeners = events[type];
	        if (!listeners) {
	          events = {};
	        } else if (func) {
	          for (var i = 0; i < listeners.length; i++) {
	            if (listeners[i].f === func) {
	              listeners.splice(i, 1);
	              break;
	            }
	          }
	        } else {
	          listeners.splice(0, listeners.length);
	        }
	      }
	    },
	    emit: {
	      value: function value() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }

	        var listeners = events[args.shift()] || [];
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].f.apply(listeners[i].c, args);
	          }
	        }
	      }
	    }
	  });
	}

	/**
	 * Lifecycle hooks that should support promises.
	 */
	var toPromisify = ['beforeValidate', 'validate', 'afterValidate', 'beforeCreate', 'afterCreate', 'beforeUpdate', 'afterUpdate', 'beforeDestroy', 'afterDestroy'];

	/**
	 * Return whether "prop" is in the blacklist.
	 */
	var isBlacklisted = observe.isBlacklisted;

	// adapted from angular.copy
	function copy(source, destination, stackSource, stackDest, blacklist) {
	  if (!destination) {
	    destination = source;
	    if (source) {
	      if (isArray(source)) {
	        destination = copy(source, [], stackSource, stackDest, blacklist);
	      } else if (isDate(source)) {
	        destination = new Date(source.getTime());
	      } else if (isRegExp(source)) {
	        destination = new RegExp(source.source, source.toString().match(/[^\/]*$/)[0]);
	        destination.lastIndex = source.lastIndex;
	      } else if (isObject(source)) {
	        destination = copy(source, Object.create(Object.getPrototypeOf(source)), stackSource, stackDest, blacklist);
	      }
	    }
	  } else {
	    if (source === destination) {
	      throw new Error('Cannot copy! Source and destination are identical.');
	    }

	    stackSource = stackSource || [];
	    stackDest = stackDest || [];

	    if (isObject(source)) {
	      var index = stackSource.indexOf(source);
	      if (index !== -1) {
	        return stackDest[index];
	      }

	      stackSource.push(source);
	      stackDest.push(destination);
	    }

	    var result = undefined;
	    if (isArray(source)) {
	      var i = undefined;
	      destination.length = 0;
	      for (i = 0; i < source.length; i++) {
	        result = copy(source[i], null, stackSource, stackDest, blacklist);
	        if (isObject(source[i])) {
	          stackSource.push(source[i]);
	          stackDest.push(result);
	        }
	        destination.push(result);
	      }
	    } else {
	      if (isArray(destination)) {
	        destination.length = 0;
	      } else {
	        forEach(destination, function (value, key) {
	          delete destination[key];
	        });
	      }
	      for (var key in source) {
	        if (source.hasOwnProperty(key)) {
	          if (isBlacklisted(key, blacklist)) {
	            continue;
	          }
	          result = copy(source[key], null, stackSource, stackDest, blacklist);
	          if (isObject(source[key])) {
	            stackSource.push(source[key]);
	            stackDest.push(result);
	          }
	          destination[key] = result;
	        }
	      }
	    }
	  }
	  return destination;
	}

	// adapted from angular.equals
	function equals(_x, _x2) {
	  var _again = true;

	  _function: while (_again) {
	    var o1 = _x,
	        o2 = _x2;
	    t1 = t2 = length = key = keySet = undefined;
	    _again = false;

	    if (o1 === o2) {
	      return true;
	    }
	    if (o1 === null || o2 === null) {
	      return false;
	    }
	    if (o1 !== o1 && o2 !== o2) {
	      // eslint-disable-line
	      return true;
	    } // NaN === NaN
	    var t1 = typeof o1;
	    var t2 = typeof o2;
	    var length, key, keySet;
	    if (t1 == t2) {
	      // eslint-disable-line
	      if (t1 == 'object') {
	        // eslint-disable-line
	        if (isArray(o1)) {
	          if (!isArray(o2)) {
	            return false;
	          }
	          if ((length = o1.length) === o2.length) {
	            // jshint ignore:line
	            for (key = 0; key < length; key++) {
	              if (!equals(o1[key], o2[key])) {
	                return false;
	              }
	            }
	            return true;
	          }
	        } else if (isDate(o1)) {
	          if (!isDate(o2)) {
	            return false;
	          }
	          _x = o1.getTime();
	          _x2 = o2.getTime();
	          _again = true;
	          continue _function;
	        } else if (isRegExp(o1) && isRegExp(o2)) {
	          return o1.toString() == o2.toString(); // eslint-disable-line
	        } else {
	            if (isArray(o2)) {
	              return false;
	            }
	            keySet = {};
	            for (key in o1) {
	              if (key.charAt(0) === '$' || isFunction(o1[key])) {
	                continue;
	              }
	              if (!equals(o1[key], o2[key])) {
	                return false;
	              }
	              keySet[key] = true;
	            }
	            for (key in o2) {
	              if (!keySet.hasOwnProperty(key) && key.charAt(0) !== '$' && o2[key] !== undefined && !isFunction(o2[key])) {
	                return false;
	              }
	            }
	            return true;
	          }
	      }
	    }
	    return false;
	  }
	}

	/**
	 * Given either an instance or the primary key of an instance, return the primary key.
	 */
	function resolveId(definition, idOrInstance) {
	  if (isString(idOrInstance) || isNumber(idOrInstance)) {
	    return idOrInstance;
	  } else if (idOrInstance && definition) {
	    return idOrInstance[definition.idAttribute] || idOrInstance;
	  } else {
	    return idOrInstance;
	  }
	}

	/**
	 * Given either an instance or the primary key of an instance, return the instance.
	 */
	function resolveItem(resource, idOrInstance) {
	  if (resource && (isString(idOrInstance) || isNumber(idOrInstance))) {
	    return resource.index[idOrInstance] || idOrInstance;
	  } else {
	    return idOrInstance;
	  }
	}

	function isValidString(val) {
	  return val != null && val !== ''; // jshint ignore:line
	}

	function join(items, separator) {
	  separator = separator || '';
	  return filter(items, isValidString).join(separator);
	}

	function makePath() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }

	  var result = join(args, '/');
	  return result.replace(/([^:\/]|^)\/{2,}/g, '$1/');
	}

	exports['default'] = {
	  Promise: P,
	  /**
	   * Method to wrap an "options" object so that it will inherit from
	   * some parent object, such as a resource definition.
	   */
	  _: function _(parent, options) {
	    var _this = this;
	    parent = parent || {};
	    options = options || {};
	    if (options && options.constructor === parent.constructor) {
	      return options;
	    } else if (!isObject(options)) {
	      throw new _errors['default'].IA('"options" must be an object!');
	    }
	    forEach(toPromisify, function (name) {
	      if (typeof options[name] === 'function' && options[name].toString().indexOf('for (var _len = arg') === -1) {
	        options[name] = _this.promisify(options[name]);
	      }
	    });
	    // Dynamic constructor function
	    var O = function Options(attrs) {
	      var self = this;
	      forOwn(attrs, function (value, key) {
	        self[key] = value;
	      });
	    };
	    // Inherit from some parent object
	    O.prototype = parent;
	    // Give us a way to get the original options back.
	    O.prototype.orig = function () {
	      var orig = {};
	      forOwn(this, function (value, key) {
	        orig[key] = value;
	      });
	      return orig;
	    };
	    return new O(options);
	  },
	  _n: isNumber,
	  _s: isString,
	  _sn: isStringOrNumber,
	  _snErr: isStringOrNumberErr,
	  _o: isObject,
	  _oErr: isObjectErr,
	  _a: isArray,
	  _aErr: isArrayErr,
	  applyScope: function applyScope(definition, params, options) {
	    var scope = options.scope;
	    var _params = copy(params);
	    if (scope) {
	      if (isString(scope)) {
	        scope = [scope];
	      }
	    } else {
	      scope = [];
	    }
	    scope.unshift('defaultScope');
	    forEach(scope, function (_scope) {
	      var scopeDef = options.scopes[_scope];
	      if (typeof scopeDef === 'function') {
	        deepMixIn(params, scopeDef(definition));
	      } else if (scopeDef) {
	        deepMixIn(params, scopeDef);
	      }
	    });
	    deepMixIn(params, _params);
	  },
	  compute: function compute(fn, field) {
	    var _this = this;
	    var args = [];
	    if (!isObject(fn)) {
	      forEach(fn.deps, function (dep) {
	        args.push(get(_this, dep));
	      });
	      // compute property
	      set(_this, field, fn[fn.length - 1].apply(_this, args));
	    }
	  },
	  contains: contains,
	  copy: copy,
	  deepMixIn: deepMixIn,
	  diffObjectFromOldObject: observe.diffObjectFromOldObject,
	  BinaryHeap: BinaryHeap,
	  equals: equals,
	  Events: Events,
	  filter: filter,
	  fillIn: function fillIn(target, obj) {
	    forOwn(obj, function (v, k) {
	      if (!(k in target)) {
	        target[k] = v;
	      }
	    });
	    return target;
	  },
	  forEach: forEach,
	  forOwn: forOwn,
	  fromJson: function fromJson(json) {
	    return isString(json) ? JSON.parse(json) : json;
	  },
	  get: get,
	  intersection: intersection,
	  isArray: isArray,
	  isBlacklisted: isBlacklisted,
	  isEmpty: isEmpty,
	  isFunction: isFunction,
	  isObject: isObject,
	  isNumber: isNumber,
	  isString: isString,
	  keys: _keys,
	  makePath: makePath,
	  observe: observe,
	  omit: function omit(obj, bl) {
	    var toRemove = [];
	    forOwn(obj, function (v, k) {
	      if (isBlacklisted(k, bl)) {
	        toRemove.push(k);
	      }
	    });
	    forEach(toRemove, function (k) {
	      delete obj[k];
	    });
	    return obj;
	  },
	  pascalCase: pascalCase,
	  pick: pick,
	  // Turn the given node-style callback function into one that can return a promise.
	  promisify: function promisify(fn, target) {
	    var _this = this;
	    if (!fn) {
	      return;
	    } else if (typeof fn !== 'function') {
	      throw new Error('Can only promisify functions!');
	    }
	    return function () {
	      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }

	      return new _this.Promise(function (resolve, reject) {
	        args.push(function (err, result) {
	          if (err) {
	            reject(err);
	          } else {
	            resolve(result);
	          }
	        });

	        try {
	          var promise = fn.apply(target || this, args);
	          if (promise && promise.then) {
	            promise.then(resolve, reject);
	          }
	        } catch (err) {
	          reject(err);
	        }
	      });
	    };
	  },
	  remove: remove,
	  set: set,
	  slice: slice,
	  sort: sort,
	  toJson: JSON.stringify,
	  updateTimestamp: function updateTimestamp(timestamp) {
	    var newTimestamp = typeof Date.now === 'function' ? Date.now() : new Date().getTime();
	    if (timestamp && newTimestamp <= timestamp) {
	      return timestamp + 1;
	    } else {
	      return newTimestamp;
	    }
	  },
	  upperCase: upperCase,
	  // Return a copy of "object" with cycles removed.
	  removeCircular: function removeCircular(object) {
	    return (function rmCirc(value, ctx) {
	      var i = undefined;
	      var nu = undefined;

	      if (typeof value === 'object' && value !== null && !(value instanceof Boolean) && !(value instanceof Date) && !(value instanceof Number) && !(value instanceof RegExp) && !(value instanceof String) && (!File || !(value instanceof File))) {
	        // check if current object points back to itself
	        var cur = ctx.cur;
	        var parent = ctx.ctx;
	        while (parent) {
	          if (parent.cur === cur) {
	            return undefined;
	          }
	          parent = parent.ctx;
	        }

	        if (isArray(value)) {
	          nu = [];
	          for (i = 0; i < value.length; i += 1) {
	            nu[i] = rmCirc(value[i], { ctx: ctx, cur: value[i] });
	          }
	        } else {
	          nu = {};
	          forOwn(value, function (v, k) {
	            nu[k] = rmCirc(value[k], { ctx: ctx, cur: value[k] });
	          });
	        }
	        return nu;
	      }
	      return value;
	    })(object, { ctx: null, cur: object });
	  },
	  resolveItem: resolveItem,
	  resolveId: resolveId,
	  respond: function respond(response, meta, options) {
	    if (options.returnMeta === 'array') {
	      return [response, meta];
	    } else if (options.returnMeta === 'object') {
	      return { response: response, meta: meta };
	    } else {
	      return response;
	    }
	  },
	  w: w,
	  // This is where the magic of relations happens.
	  applyRelationGettersToTarget: function applyRelationGettersToTarget(store, definition, target) {
	    this.forEach(definition.relationList, function (def) {
	      var relationName = def.relation;
	      var localField = def.localField;
	      var localKey = def.localKey;
	      var foreignKey = def.foreignKey;
	      var localKeys = def.localKeys;
	      var foreignKeys = def.foreignKeys;
	      var enumerable = typeof def.enumerable === 'boolean' ? def.enumerable : !!definition.relationsEnumerable;
	      if (typeof def.link === 'boolean' ? def.link : !!definition.linkRelations) {
	        delete target[localField];
	        var prop = {
	          enumerable: enumerable
	        };
	        if (def.type === 'belongsTo') {
	          prop.get = function () {
	            var key = get(this, localKey);
	            var hasKey = !!(key || key === 0);
	            return hasKey ? definition.getResource(relationName).get(key) : undefined;
	          };
	          prop.set = function (parent) {
	            if (parent) {
	              set(this, localKey, get(parent, definition.getResource(relationName).idAttribute));
	            }
	            return get(this, localField);
	          };
	        } else if (def.type === 'hasMany') {
	          prop.get = function () {
	            var params = {};
	            if (foreignKey) {
	              params[foreignKey] = this[definition.idAttribute];
	              return definition.getResource(relationName).defaultFilter.call(store, store.store[relationName].collection, relationName, params, { allowSimpleWhere: true });
	            } else if (localKeys) {
	              var keys = get(this, localKeys) || [];
	              return definition.getResource(relationName).getAll(isArray(keys) ? keys : _keys(keys));
	            } else if (foreignKeys) {
	              set(params, 'where.' + foreignKeys + '.contains', this[definition.idAttribute]);
	              return definition.getResource(relationName).defaultFilter.call(store, store.store[relationName].collection, relationName, params);
	            }
	            return undefined;
	          };
	          prop.set = function (children) {
	            var _this2 = this;

	            if (children && children.length) {
	              (function () {
	                var id = get(_this2, definition.idAttribute);
	                if (foreignKey) {
	                  forEach(children, function (child) {
	                    set(child, foreignKey, id);
	                  });
	                } else if (localKeys) {
	                  (function () {
	                    var keys = [];
	                    forEach(children, function (child) {
	                      keys.push(get(child, definition.getResource(relationName).idAttribute));
	                    });
	                    set(_this2, localKeys, keys);
	                  })();
	                } else if (foreignKeys) {
	                  forEach(children, function (child) {
	                    var keys = get(child, foreignKeys);
	                    if (keys) {
	                      if (!contains(keys, id)) {
	                        keys.push(id);
	                      }
	                    } else {
	                      set(child, foreignKeys, [id]);
	                    }
	                  });
	                }
	              })();
	            }
	            return get(this, localField);
	          };
	        } else if (def.type === 'hasOne') {
	          if (localKey) {
	            prop.get = function () {
	              var key = get(this, localKey);
	              var hasKey = !!(key || key === 0);
	              return hasKey ? definition.getResource(relationName).get(key) : undefined;
	            };
	            prop.set = function (sibling) {
	              if (sibling) {
	                set(this, localKey, get(sibling, definition.getResource(relationName).idAttribute));
	              }
	              return get(this, localField);
	            };
	          } else {
	            prop.get = function () {
	              var params = {};
	              params[foreignKey] = this[definition.idAttribute];
	              var items = params[foreignKey] ? definition.getResource(relationName).defaultFilter.call(store, store.store[relationName].collection, relationName, params, { allowSimpleWhere: true }) : [];
	              if (items.length) {
	                return items[0];
	              }
	              return undefined;
	            };
	            prop.set = function (sibling) {
	              if (sibling) {
	                set(sibling, foreignKey, get(this, definition.idAttribute));
	              }
	              return get(this, localField);
	            };
	          }
	        }
	        if (def.get) {
	          (function () {
	            var orig = prop.get;
	            prop.get = function () {
	              var _this3 = this;

	              return def.get(definition, def, this, function () {
	                for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	                  args[_key4] = arguments[_key4];
	                }

	                return orig.apply(_this3, args);
	              });
	            };
	          })();
	        }
	        Object.defineProperty(target, localField, prop);
	      }
	    });
	  }
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * Thrown during a method call when an argument passed into the method is invalid.
	 */

	var IllegalArgumentError = (function (_Error) {
	  _inherits(IllegalArgumentError, _Error);

	  function IllegalArgumentError(message) {
	    _classCallCheck(this, IllegalArgumentError);

	    _get(Object.getPrototypeOf(IllegalArgumentError.prototype), 'constructor', this).call(this);
	    if (typeof Error.captureStackTrace === 'function') {
	      Error.captureStackTrace(this, this.constructor);
	    }
	    this.type = this.constructor.name;
	    this.message = message;
	  }

	  /**
	   * Thrown when an invariant is violated or unrecoverable error is encountered during execution.
	   */
	  return IllegalArgumentError;
	})(Error);

	var RuntimeError = (function (_Error2) {
	  _inherits(RuntimeError, _Error2);

	  function RuntimeError(message) {
	    _classCallCheck(this, RuntimeError);

	    _get(Object.getPrototypeOf(RuntimeError.prototype), 'constructor', this).call(this);
	    if (typeof Error.captureStackTrace === 'function') {
	      Error.captureStackTrace(this, this.constructor);
	    }
	    this.type = this.constructor.name;
	    this.message = message;
	  }

	  /**
	   * Thrown when attempting to access or work with a non-existent resource.
	   */
	  return RuntimeError;
	})(Error);

	var NonexistentResourceError = (function (_Error3) {
	  _inherits(NonexistentResourceError, _Error3);

	  function NonexistentResourceError(resourceName) {
	    _classCallCheck(this, NonexistentResourceError);

	    _get(Object.getPrototypeOf(NonexistentResourceError.prototype), 'constructor', this).call(this);
	    if (typeof Error.captureStackTrace === 'function') {
	      Error.captureStackTrace(this, this.constructor);
	    }
	    this.type = this.constructor.name;
	    this.message = resourceName + ' is not a registered resource!';
	  }

	  return NonexistentResourceError;
	})(Error);

	exports['default'] = {
	  IllegalArgumentError: IllegalArgumentError,
	  IA: IllegalArgumentError,
	  RuntimeError: RuntimeError,
	  R: RuntimeError,
	  NonexistentResourceError: NonexistentResourceError,
	  NER: NonexistentResourceError
	};

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * yabh
	 * @version 1.1.0 - Homepage <http://jmdobry.github.io/yabh/>
	 * @author Jason Dobry <jason.dobry@gmail.com>
	 * @copyright (c) 2015 Jason Dobry 
	 * @license MIT <https://github.com/jmdobry/yabh/blob/master/LICENSE>
	 * 
	 * @overview Yet another Binary Heap.
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define("yabh", factory);
		else if(typeof exports === 'object')
			exports["BinaryHeap"] = factory();
		else
			root["BinaryHeap"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};

	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {

	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;

	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};

	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;

	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}


	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;

	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;

	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";

	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {

		/**
		 * @method bubbleUp
		 * @param {array} heap The heap.
		 * @param {function} weightFunc The weight function.
		 * @param {number} n The index of the element to bubble up.
		 */
		function bubbleUp(heap, weightFunc, n) {
		  var element = heap[n];
		  var weight = weightFunc(element);
		  // When at 0, an element can not go up any further.
		  while (n > 0) {
		    // Compute the parent element's index, and fetch it.
		    var parentN = Math.floor((n + 1) / 2) - 1;
		    var _parent = heap[parentN];
		    // If the parent has a lesser weight, things are in order and we
		    // are done.
		    if (weight >= weightFunc(_parent)) {
		      break;
		    } else {
		      heap[parentN] = element;
		      heap[n] = _parent;
		      n = parentN;
		    }
		  }
		}

		/**
		 * @method bubbleDown
		 * @param {array} heap The heap.
		 * @param {function} weightFunc The weight function.
		 * @param {number} n The index of the element to sink down.
		 */
		var bubbleDown = function bubbleDown(heap, weightFunc, n) {
		  var length = heap.length;
		  var node = heap[n];
		  var nodeWeight = weightFunc(node);

		  while (true) {
		    var child2N = (n + 1) * 2,
		        child1N = child2N - 1;
		    var swap = null;
		    if (child1N < length) {
		      var child1 = heap[child1N],
		          child1Weight = weightFunc(child1);
		      // If the score is less than our node's, we need to swap.
		      if (child1Weight < nodeWeight) {
		        swap = child1N;
		      }
		    }
		    // Do the same checks for the other child.
		    if (child2N < length) {
		      var child2 = heap[child2N],
		          child2Weight = weightFunc(child2);
		      if (child2Weight < (swap === null ? nodeWeight : weightFunc(heap[child1N]))) {
		        swap = child2N;
		      }
		    }

		    if (swap === null) {
		      break;
		    } else {
		      heap[n] = heap[swap];
		      heap[swap] = node;
		      n = swap;
		    }
		  }
		};

		function BinaryHeap(weightFunc, compareFunc) {
		  if (!weightFunc) {
		    weightFunc = function (x) {
		      return x;
		    };
		  }
		  if (!compareFunc) {
		    compareFunc = function (x, y) {
		      return x === y;
		    };
		  }
		  if (typeof weightFunc !== 'function') {
		    throw new Error('BinaryHeap([weightFunc][, compareFunc]): "weightFunc" must be a function!');
		  }
		  if (typeof compareFunc !== 'function') {
		    throw new Error('BinaryHeap([weightFunc][, compareFunc]): "compareFunc" must be a function!');
		  }
		  this.weightFunc = weightFunc;
		  this.compareFunc = compareFunc;
		  this.heap = [];
		}

		var BHProto = BinaryHeap.prototype;

		BHProto.push = function (node) {
		  this.heap.push(node);
		  bubbleUp(this.heap, this.weightFunc, this.heap.length - 1);
		};

		BHProto.peek = function () {
		  return this.heap[0];
		};

		BHProto.pop = function () {
		  var front = this.heap[0];
		  var end = this.heap.pop();
		  if (this.heap.length > 0) {
		    this.heap[0] = end;
		    bubbleDown(this.heap, this.weightFunc, 0);
		  }
		  return front;
		};

		BHProto.remove = function (node) {
		  var length = this.heap.length;
		  for (var i = 0; i < length; i++) {
		    if (this.compareFunc(this.heap[i], node)) {
		      var removed = this.heap[i];
		      var end = this.heap.pop();
		      if (i !== length - 1) {
		        this.heap[i] = end;
		        bubbleUp(this.heap, this.weightFunc, i);
		        bubbleDown(this.heap, this.weightFunc, i);
		      }
		      return removed;
		    }
		  }
		  return null;
		};

		BHProto.removeAll = function () {
		  this.heap = [];
		};

		BHProto.size = function () {
		  return this.heap.length;
		};

		module.exports = BinaryHeap;

	/***/ }
	/******/ ])
	});
	;

/***/ },
/* 5 */
/***/ function(module, exports) {

	

	    /**
	     * Array forEach
	     */
	    function forEach(arr, callback, thisObj) {
	        if (arr == null) {
	            return;
	        }
	        var i = -1,
	            len = arr.length;
	        while (++i < len) {
	            // we iterate over sparse items since there is no way to make it
	            // work properly on IE 7-8. see #64
	            if ( callback.call(thisObj, arr[i], i, arr) === false ) {
	                break;
	            }
	        }
	    }

	    module.exports = forEach;




/***/ },
/* 6 */
/***/ function(module, exports) {

	

	    /**
	     * Create slice of source array or array-like object
	     */
	    function slice(arr, start, end){
	        var len = arr.length;

	        if (start == null) {
	            start = 0;
	        } else if (start < 0) {
	            start = Math.max(len + start, 0);
	        } else {
	            start = Math.min(start, len);
	        }

	        if (end == null) {
	            end = len;
	        } else if (end < 0) {
	            end = Math.max(len + end, 0);
	        } else {
	            end = Math.min(end, len);
	        }

	        var result = [];
	        while (start < end) {
	            result.push(arr[start++]);
	        }

	        return result;
	    }

	    module.exports = slice;




/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var hasOwn = __webpack_require__(8);
	var forIn = __webpack_require__(9);

	    /**
	     * Similar to Array/forEach but works over object properties and fixes Don't
	     * Enum bug on IE.
	     * based on: http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
	     */
	    function forOwn(obj, fn, thisObj){
	        forIn(obj, function(val, key){
	            if (hasOwn(obj, key)) {
	                return fn.call(thisObj, obj[key], key, obj);
	            }
	        });
	    }

	    module.exports = forOwn;




/***/ },
/* 8 */
/***/ function(module, exports) {

	

	    /**
	     * Safer Object.hasOwnProperty
	     */
	     function hasOwn(obj, prop){
	         return Object.prototype.hasOwnProperty.call(obj, prop);
	     }

	     module.exports = hasOwn;




/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var hasOwn = __webpack_require__(8);

	    var _hasDontEnumBug,
	        _dontEnums;

	    function checkDontEnum(){
	        _dontEnums = [
	                'toString',
	                'toLocaleString',
	                'valueOf',
	                'hasOwnProperty',
	                'isPrototypeOf',
	                'propertyIsEnumerable',
	                'constructor'
	            ];

	        _hasDontEnumBug = true;

	        for (var key in {'toString': null}) {
	            _hasDontEnumBug = false;
	        }
	    }

	    /**
	     * Similar to Array/forEach but works over object properties and fixes Don't
	     * Enum bug on IE.
	     * based on: http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
	     */
	    function forIn(obj, fn, thisObj){
	        var key, i = 0;
	        // no need to check if argument is a real object that way we can use
	        // it for arrays, functions, date, etc.

	        //post-pone check till needed
	        if (_hasDontEnumBug == null) checkDontEnum();

	        for (key in obj) {
	            if (exec(fn, obj, key, thisObj) === false) {
	                break;
	            }
	        }


	        if (_hasDontEnumBug) {
	            var ctor = obj.constructor,
	                isProto = !!ctor && obj === ctor.prototype;

	            while (key = _dontEnums[i++]) {
	                // For constructor, if it is a prototype object the constructor
	                // is always non-enumerable unless defined otherwise (and
	                // enumerated above).  For non-prototype objects, it will have
	                // to be defined on this object, since it cannot be defined on
	                // any prototype objects.
	                //
	                // For other [[DontEnum]] properties, check if the value is
	                // different than Object prototype value.
	                if (
	                    (key !== 'constructor' ||
	                        (!isProto && hasOwn(obj, key))) &&
	                    obj[key] !== Object.prototype[key]
	                ) {
	                    if (exec(fn, obj, key, thisObj) === false) {
	                        break;
	                    }
	                }
	            }
	        }
	    }

	    function exec(fn, obj, key, thisObj){
	        return fn.call(thisObj, obj[key], key, obj);
	    }

	    module.exports = forIn;




/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var indexOf = __webpack_require__(11);

	    /**
	     * If array contains values.
	     */
	    function contains(arr, val) {
	        return indexOf(arr, val) !== -1;
	    }
	    module.exports = contains;



/***/ },
/* 11 */
/***/ function(module, exports) {

	

	    /**
	     * Array.indexOf
	     */
	    function indexOf(arr, item, fromIndex) {
	        fromIndex = fromIndex || 0;
	        if (arr == null) {
	            return -1;
	        }

	        var len = arr.length,
	            i = fromIndex < 0 ? len + fromIndex : fromIndex;
	        while (i < len) {
	            // we iterate over sparse items since there is no way to make it
	            // work properly on IE 7-8. see #64
	            if (arr[i] === item) {
	                return i;
	            }

	            i++;
	        }

	        return -1;
	    }

	    module.exports = indexOf;



/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var forOwn = __webpack_require__(7);
	var isPlainObject = __webpack_require__(13);

	    /**
	     * Mixes objects into the target object, recursively mixing existing child
	     * objects.
	     */
	    function deepMixIn(target, objects) {
	        var i = 0,
	            n = arguments.length,
	            obj;

	        while(++i < n){
	            obj = arguments[i];
	            if (obj) {
	                forOwn(obj, copyProp, target);
	            }
	        }

	        return target;
	    }

	    function copyProp(val, key) {
	        var existing = this[key];
	        if (isPlainObject(val) && isPlainObject(existing)) {
	            deepMixIn(existing, val);
	        } else {
	            this[key] = val;
	        }
	    }

	    module.exports = deepMixIn;




/***/ },
/* 13 */
/***/ function(module, exports) {

	

	    /**
	     * Checks if the value is created by the `Object` constructor.
	     */
	    function isPlainObject(value) {
	        return (!!value && typeof value === 'object' &&
	            value.constructor === Object);
	    }

	    module.exports = isPlainObject;




/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(15);
	var camelCase = __webpack_require__(16);
	var upperCase = __webpack_require__(19);
	    /**
	     * camelCase + UPPERCASE first char
	     */
	    function pascalCase(str){
	        str = toString(str);
	        return camelCase(str).replace(/^[a-z]/, upperCase);
	    }

	    module.exports = pascalCase;



/***/ },
/* 15 */
/***/ function(module, exports) {

	

	    /**
	     * Typecast a value to a String, using an empty string value for null or
	     * undefined.
	     */
	    function toString(val){
	        return val == null ? '' : val.toString();
	    }

	    module.exports = toString;




/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(15);
	var replaceAccents = __webpack_require__(17);
	var removeNonWord = __webpack_require__(18);
	var upperCase = __webpack_require__(19);
	var lowerCase = __webpack_require__(20);
	    /**
	    * Convert string to camelCase text.
	    */
	    function camelCase(str){
	        str = toString(str);
	        str = replaceAccents(str);
	        str = removeNonWord(str)
	            .replace(/[\-_]/g, ' ') //convert all hyphens and underscores to spaces
	            .replace(/\s[a-z]/g, upperCase) //convert first char of each word to UPPERCASE
	            .replace(/\s+/g, '') //remove spaces
	            .replace(/^[A-Z]/g, lowerCase); //convert first char to lowercase
	        return str;
	    }
	    module.exports = camelCase;



/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(15);
	    /**
	    * Replaces all accented chars with regular ones
	    */
	    function replaceAccents(str){
	        str = toString(str);

	        // verifies if the String has accents and replace them
	        if (str.search(/[\xC0-\xFF]/g) > -1) {
	            str = str
	                    .replace(/[\xC0-\xC5]/g, "A")
	                    .replace(/[\xC6]/g, "AE")
	                    .replace(/[\xC7]/g, "C")
	                    .replace(/[\xC8-\xCB]/g, "E")
	                    .replace(/[\xCC-\xCF]/g, "I")
	                    .replace(/[\xD0]/g, "D")
	                    .replace(/[\xD1]/g, "N")
	                    .replace(/[\xD2-\xD6\xD8]/g, "O")
	                    .replace(/[\xD9-\xDC]/g, "U")
	                    .replace(/[\xDD]/g, "Y")
	                    .replace(/[\xDE]/g, "P")
	                    .replace(/[\xE0-\xE5]/g, "a")
	                    .replace(/[\xE6]/g, "ae")
	                    .replace(/[\xE7]/g, "c")
	                    .replace(/[\xE8-\xEB]/g, "e")
	                    .replace(/[\xEC-\xEF]/g, "i")
	                    .replace(/[\xF1]/g, "n")
	                    .replace(/[\xF2-\xF6\xF8]/g, "o")
	                    .replace(/[\xF9-\xFC]/g, "u")
	                    .replace(/[\xFE]/g, "p")
	                    .replace(/[\xFD\xFF]/g, "y");
	        }
	        return str;
	    }
	    module.exports = replaceAccents;



/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(15);
	    // This pattern is generated by the _build/pattern-removeNonWord.js script
	    var PATTERN = /[^\x20\x2D0-9A-Z\x5Fa-z\xC0-\xD6\xD8-\xF6\xF8-\xFF]/g;

	    /**
	     * Remove non-word chars.
	     */
	    function removeNonWord(str){
	        str = toString(str);
	        return str.replace(PATTERN, '');
	    }

	    module.exports = removeNonWord;



/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(15);
	    /**
	     * "Safer" String.toUpperCase()
	     */
	    function upperCase(str){
	        str = toString(str);
	        return str.toUpperCase();
	    }
	    module.exports = upperCase;



/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(15);
	    /**
	     * "Safer" String.toLowerCase()
	     */
	    function lowerCase(str){
	        str = toString(str);
	        return str.toLowerCase();
	    }

	    module.exports = lowerCase;



/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var indexOf = __webpack_require__(11);

	    /**
	     * Remove a single item from the array.
	     * (it won't remove duplicates, just a single item)
	     */
	    function remove(arr, item){
	        var idx = indexOf(arr, item);
	        if (idx !== -1) arr.splice(idx, 1);
	    }

	    module.exports = remove;



/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var slice = __webpack_require__(6);

	    /**
	     * Return a copy of the object, filtered to only have values for the whitelisted keys.
	     */
	    function pick(obj, var_keys){
	        var keys = typeof arguments[1] !== 'string'? arguments[1] : slice(arguments, 1),
	            out = {},
	            i = 0, key;
	        while (key = keys[i++]) {
	            out[key] = obj[key];
	        }
	        return out;
	    }

	    module.exports = pick;




/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var forOwn = __webpack_require__(7);

	    /**
	     * Get object keys
	     */
	     var keys = Object.keys || function (obj) {
	            var keys = [];
	            forOwn(obj, function(val, key){
	                keys.push(key);
	            });
	            return keys;
	        };

	    module.exports = keys;




/***/ },
/* 24 */
/***/ function(module, exports) {

	

	    /**
	     * Merge sort (http://en.wikipedia.org/wiki/Merge_sort)
	     */
	    function mergeSort(arr, compareFn) {
	        if (arr == null) {
	            return [];
	        } else if (arr.length < 2) {
	            return arr;
	        }

	        if (compareFn == null) {
	            compareFn = defaultCompare;
	        }

	        var mid, left, right;

	        mid   = ~~(arr.length / 2);
	        left  = mergeSort( arr.slice(0, mid), compareFn );
	        right = mergeSort( arr.slice(mid, arr.length), compareFn );

	        return merge(left, right, compareFn);
	    }

	    function defaultCompare(a, b) {
	        return a < b ? -1 : (a > b? 1 : 0);
	    }

	    function merge(left, right, compareFn) {
	        var result = [];

	        while (left.length && right.length) {
	            if (compareFn(left[0], right[0]) <= 0) {
	                // if 0 it should preserve same order (stable)
	                result.push(left.shift());
	            } else {
	                result.push(right.shift());
	            }
	        }

	        if (left.length) {
	            result.push.apply(result, left);
	        }

	        if (right.length) {
	            result.push.apply(result, right);
	        }

	        return result;
	    }

	    module.exports = mergeSort;




/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var isPrimitive = __webpack_require__(26);

	    /**
	     * get "nested" object property
	     */
	    function get(obj, prop){
	        var parts = prop.split('.'),
	            last = parts.pop();

	        while (prop = parts.shift()) {
	            obj = obj[prop];
	            if (obj == null) return;
	        }

	        return obj[last];
	    }

	    module.exports = get;




/***/ },
/* 26 */
/***/ function(module, exports) {

	

	    /**
	     * Checks if the object is a primitive
	     */
	    function isPrimitive(value) {
	        // Using switch fallthrough because it's simple to read and is
	        // generally fast: http://jsperf.com/testing-value-is-primitive/5
	        switch (typeof value) {
	            case "string":
	            case "number":
	            case "boolean":
	                return true;
	        }

	        return value == null;
	    }

	    module.exports = isPrimitive;




/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var namespace = __webpack_require__(28);

	    /**
	     * set "nested" object property
	     */
	    function set(obj, prop, val){
	        var parts = (/^(.+)\.(.+)$/).exec(prop);
	        if (parts){
	            namespace(obj, parts[1])[parts[2]] = val;
	        } else {
	            obj[prop] = val;
	        }
	    }

	    module.exports = set;




/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var forEach = __webpack_require__(5);

	    /**
	     * Create nested object if non-existent
	     */
	    function namespace(obj, path){
	        if (!path) return obj;
	        forEach(path.split('.'), function(key){
	            if (!obj[key]) {
	                obj[key] = {};
	            }
	            obj = obj[key];
	        });
	        return obj;
	    }

	    module.exports = namespace;




/***/ },
/* 29 */
/***/ function(module, exports) {

	/*
	 * Copyright (c) 2014 The Polymer Project Authors. All rights reserved.
	 * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
	 * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
	 * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
	 * Code distributed by Google as part of the polymer project is also
	 * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
	 */

	// Modifications
	// Copyright 2014-2015 Jason Dobry
	//
	// Summary of modifications:
	// Fixed use of "delete" keyword for IE8 compatibility
	// Exposed diffObjectFromOldObject on the exported object
	// Added the "equals" argument to diffObjectFromOldObject to be used to check equality
	// Added a way in diffObjectFromOldObject to ignore changes to certain properties
	// Removed all code related to:
	// - ArrayObserver
	// - ArraySplice
	// - PathObserver
	// - CompoundObserver
	// - Path
	// - ObserverTransform

	(function(global) {
	  var testingExposeCycleCount = global.testingExposeCycleCount;

	  // Detect and do basic sanity checking on Object/Array.observe.
	  function detectObjectObserve() {
	    if (typeof Object.observe !== 'function' ||
	        typeof Array.observe !== 'function') {
	      return false;
	    }

	    var records = [];

	    function callback(recs) {
	      records = recs;
	    }

	    var test = {};
	    var arr = [];
	    Object.observe(test, callback);
	    Array.observe(arr, callback);
	    test.id = 1;
	    test.id = 2;
	    delete test.id;
	    arr.push(1, 2);
	    arr.length = 0;

	    Object.deliverChangeRecords(callback);
	    if (records.length !== 5)
	      return false;

	    if (records[0].type != 'add' ||
	        records[1].type != 'update' ||
	        records[2].type != 'delete' ||
	        records[3].type != 'splice' ||
	        records[4].type != 'splice') {
	      return false;
	    }

	    Object.unobserve(test, callback);
	    Array.unobserve(arr, callback);

	    return true;
	  }

	  var hasObserve = detectObjectObserve();

	  var createObject = ('__proto__' in {}) ?
	    function(obj) { return obj; } :
	    function(obj) {
	      var proto = obj.__proto__;
	      if (!proto)
	        return obj;
	      var newObject = Object.create(proto);
	      Object.getOwnPropertyNames(obj).forEach(function(name) {
	        Object.defineProperty(newObject, name,
	                             Object.getOwnPropertyDescriptor(obj, name));
	      });
	      return newObject;
	    };

	  var MAX_DIRTY_CHECK_CYCLES = 1000;

	  function dirtyCheck(observer) {
	    var cycles = 0;
	    while (cycles < MAX_DIRTY_CHECK_CYCLES && observer.check_()) {
	      cycles++;
	    }
	    if (testingExposeCycleCount)
	      global.dirtyCheckCycleCount = cycles;

	    return cycles > 0;
	  }

	  function objectIsEmpty(object) {
	    for (var prop in object)
	      return false;
	    return true;
	  }

	  function diffIsEmpty(diff) {
	    return objectIsEmpty(diff.added) &&
	           objectIsEmpty(diff.removed) &&
	           objectIsEmpty(diff.changed);
	  }

	  function isBlacklisted(prop, bl) {
	    if (!bl || !bl.length) {
	      return false;
	    }
	    var matches;
	    for (var i = 0; i < bl.length; i++) {
	      if ((Object.prototype.toString.call(bl[i]) === '[object RegExp]' && bl[i].test(prop)) || bl[i] === prop) {
	        return matches = prop;
	      }
	    }
	    return !!matches;
	  }

	  function diffObjectFromOldObject(object, oldObject, equals, bl) {
	    var added = {};
	    var removed = {};
	    var changed = {};

	    for (var prop in oldObject) {
	      var newValue = object[prop];

	      if (isBlacklisted(prop, bl))
	        continue;

	      if (newValue !== undefined && (equals ? equals(newValue, oldObject[prop]) : newValue === oldObject[prop]))
	        continue;

	      if (!(prop in object)) {
	        removed[prop] = undefined;
	        continue;
	      }

	      if (equals ? !equals(newValue, oldObject[prop]) : newValue !== oldObject[prop])
	        changed[prop] = newValue;
	    }

	    for (var prop in object) {
	      if (prop in oldObject)
	        continue;

	      if (isBlacklisted(prop, bl))
	        continue;

	      added[prop] = object[prop];
	    }

	    if (Array.isArray(object) && object.length !== oldObject.length)
	      changed.length = object.length;

	    return {
	      added: added,
	      removed: removed,
	      changed: changed
	    };
	  }

	  var eomTasks = [];
	  function runEOMTasks() {
	    if (!eomTasks.length)
	      return false;

	    for (var i = 0; i < eomTasks.length; i++) {
	      eomTasks[i]();
	    }
	    eomTasks.length = 0;
	    return true;
	  }

	  var runEOM = hasObserve ? (function(){
	    return function(fn) {
	      return Promise.resolve().then(fn);
	    }
	  })() :
	  (function() {
	    return function(fn) {
	      eomTasks.push(fn);
	    };
	  })();

	  var observedObjectCache = [];

	  function newObservedObject() {
	    var observer;
	    var object;
	    var discardRecords = false;
	    var first = true;

	    function callback(records) {
	      if (observer && observer.state_ === OPENED && !discardRecords)
	        observer.check_(records);
	    }

	    return {
	      open: function(obs) {
	        if (observer)
	          throw Error('ObservedObject in use');

	        if (!first)
	          Object.deliverChangeRecords(callback);

	        observer = obs;
	        first = false;
	      },
	      observe: function(obj, arrayObserve) {
	        object = obj;
	        if (arrayObserve)
	          Array.observe(object, callback);
	        else
	          Object.observe(object, callback);
	      },
	      deliver: function(discard) {
	        discardRecords = discard;
	        Object.deliverChangeRecords(callback);
	        discardRecords = false;
	      },
	      close: function() {
	        observer = undefined;
	        Object.unobserve(object, callback);
	        observedObjectCache.push(this);
	      }
	    };
	  }

	  function getObservedObject(observer, object, arrayObserve) {
	    var dir = observedObjectCache.pop() || newObservedObject();
	    dir.open(observer);
	    dir.observe(object, arrayObserve);
	    return dir;
	  }

	  var UNOPENED = 0;
	  var OPENED = 1;
	  var CLOSED = 2;

	  var nextObserverId = 1;

	  function Observer() {
	    this.state_ = UNOPENED;
	    this.callback_ = undefined;
	    this.target_ = undefined; // TODO(rafaelw): Should be WeakRef
	    this.directObserver_ = undefined;
	    this.value_ = undefined;
	    this.id_ = nextObserverId++;
	  }

	  Observer.prototype = {
	    open: function(callback, target) {
	      if (this.state_ != UNOPENED)
	        throw Error('Observer has already been opened.');

	      addToAll(this);
	      this.callback_ = callback;
	      this.target_ = target;
	      this.connect_();
	      this.state_ = OPENED;
	      return this.value_;
	    },

	    close: function() {
	      if (this.state_ != OPENED)
	        return;

	      removeFromAll(this);
	      this.disconnect_();
	      this.value_ = undefined;
	      this.callback_ = undefined;
	      this.target_ = undefined;
	      this.state_ = CLOSED;
	    },

	    deliver: function() {
	      if (this.state_ != OPENED)
	        return;

	      dirtyCheck(this);
	    },

	    report_: function(changes) {
	      try {
	        this.callback_.apply(this.target_, changes);
	      } catch (ex) {
	        Observer._errorThrownDuringCallback = true;
	        console.error('Exception caught during observer callback: ' +
	                       (ex.stack || ex));
	      }
	    },

	    discardChanges: function() {
	      this.check_(undefined, true);
	      return this.value_;
	    }
	  }

	  var collectObservers = !hasObserve;
	  var allObservers;
	  Observer._allObserversCount = 0;

	  if (collectObservers) {
	    allObservers = [];
	  }

	  function addToAll(observer) {
	    Observer._allObserversCount++;
	    if (!collectObservers)
	      return;

	    allObservers.push(observer);
	  }

	  function removeFromAll(observer) {
	    Observer._allObserversCount--;
	  }

	  var runningMicrotaskCheckpoint = false;

	  global.Platform = global.Platform || {};

	  global.Platform.performMicrotaskCheckpoint = function() {
	    if (runningMicrotaskCheckpoint)
	      return;

	    if (!collectObservers)
	      return;

	    runningMicrotaskCheckpoint = true;

	    var cycles = 0;
	    var anyChanged, toCheck;

	    do {
	      cycles++;
	      toCheck = allObservers;
	      allObservers = [];
	      anyChanged = false;

	      for (var i = 0; i < toCheck.length; i++) {
	        var observer = toCheck[i];
	        if (observer.state_ != OPENED)
	          continue;

	        if (observer.check_())
	          anyChanged = true;

	        allObservers.push(observer);
	      }
	      if (runEOMTasks())
	        anyChanged = true;
	    } while (cycles < MAX_DIRTY_CHECK_CYCLES && anyChanged);

	    if (testingExposeCycleCount)
	      global.dirtyCheckCycleCount = cycles;

	    runningMicrotaskCheckpoint = false;
	  };

	  if (collectObservers) {
	    global.Platform.clearObservers = function() {
	      allObservers = [];
	    };
	  }

	  function ObjectObserver(object) {
	    Observer.call(this);
	    this.value_ = object;
	    this.oldObject_ = undefined;
	  }

	  ObjectObserver.prototype = createObject({
	    __proto__: Observer.prototype,

	    arrayObserve: false,

	    connect_: function(callback, target) {
	      if (hasObserve) {
	        this.directObserver_ = getObservedObject(this, this.value_,
	                                                 this.arrayObserve);
	      } else {
	        this.oldObject_ = this.copyObject(this.value_);
	      }

	    },

	    copyObject: function(object) {
	      var copy = Array.isArray(object) ? [] : {};
	      for (var prop in object) {
	        copy[prop] = object[prop];
	      };
	      if (Array.isArray(object))
	        copy.length = object.length;
	      return copy;
	    },

	    check_: function(changeRecords, skipChanges) {
	      var diff;
	      var oldValues;
	      if (hasObserve) {
	        if (!changeRecords)
	          return false;

	        oldValues = {};
	        diff = diffObjectFromChangeRecords(this.value_, changeRecords,
	                                           oldValues);
	      } else {
	        oldValues = this.oldObject_;
	        diff = diffObjectFromOldObject(this.value_, this.oldObject_);
	      }

	      if (diffIsEmpty(diff))
	        return false;

	      if (!hasObserve)
	        this.oldObject_ = this.copyObject(this.value_);

	      this.report_([
	        diff.added || {},
	        diff.removed || {},
	        diff.changed || {},
	        function(property) {
	          return oldValues[property];
	        }
	      ]);

	      return true;
	    },

	    disconnect_: function() {
	      if (hasObserve) {
	        this.directObserver_.close();
	        this.directObserver_ = undefined;
	      } else {
	        this.oldObject_ = undefined;
	      }
	    },

	    deliver: function() {
	      if (this.state_ != OPENED)
	        return;

	      if (hasObserve)
	        this.directObserver_.deliver(false);
	      else
	        dirtyCheck(this);
	    },

	    discardChanges: function() {
	      if (this.directObserver_)
	        this.directObserver_.deliver(true);
	      else
	        this.oldObject_ = this.copyObject(this.value_);

	      return this.value_;
	    }
	  });

	  var observerSentinel = {};

	  var expectedRecordTypes = {
	    add: true,
	    update: true,
	    'delete': true
	  };

	  function diffObjectFromChangeRecords(object, changeRecords, oldValues) {
	    var added = {};
	    var removed = {};

	    for (var i = 0; i < changeRecords.length; i++) {
	      var record = changeRecords[i];
	      if (!expectedRecordTypes[record.type]) {
	        console.error('Unknown changeRecord type: ' + record.type);
	        console.error(record);
	        continue;
	      }

	      if (!(record.name in oldValues))
	        oldValues[record.name] = record.oldValue;

	      if (record.type == 'update')
	        continue;

	      if (record.type == 'add') {
	        if (record.name in removed)
	          delete removed[record.name];
	        else
	          added[record.name] = true;

	        continue;
	      }

	      // type = 'delete'
	      if (record.name in added) {
	        delete added[record.name];
	        delete oldValues[record.name];
	      } else {
	        removed[record.name] = true;
	      }
	    }

	    for (var prop in added)
	      added[prop] = object[prop];

	    for (var prop in removed)
	      removed[prop] = undefined;

	    var changed = {};
	    for (var prop in oldValues) {
	      if (prop in added || prop in removed)
	        continue;

	      var newValue = object[prop];
	      if (oldValues[prop] !== newValue)
	        changed[prop] = newValue;
	    }

	    return {
	      added: added,
	      removed: removed,
	      changed: changed
	    };
	  }

	  // Export the observe-js object for **Node.js**, with backwards-compatibility
	  // for the old `require()` API. Also ensure `exports` is not a DOM Element.
	  // If we're in the browser, export as a global object.

	  global.Observer = Observer;
	  global.isBlacklisted = isBlacklisted;
	  global.Observer.runEOM_ = runEOM;
	  global.Observer.observerSentinel_ = observerSentinel; // for testing.
	  global.Observer.hasObjectObserve = hasObserve;
	  global.diffObjectFromOldObject = diffObjectFromOldObject;
	  global.ObjectObserver = ObjectObserver;

	})(exports);


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var _utils = __webpack_require__(2);

	var _errors = __webpack_require__(3);

	var NER = _errors['default'].NER;
	var IA = _errors['default'].IA;
	var R = _errors['default'].R;

	var fakeId = 'DS_' + new Date().getTime();

	function diffIsEmpty(diff) {
	  return !(_utils['default'].isEmpty(diff.added) && _utils['default'].isEmpty(diff.removed) && _utils['default'].isEmpty(diff.changed));
	}

	function check(fnName, resourceName, id, options) {
	  var _this = this;
	  var definition = _this.definitions[resourceName];
	  options = options || {};

	  id = _utils['default'].resolveId(definition, id);
	  if (!definition) {
	    throw new NER(resourceName);
	  } else if (!_utils['default']._sn(id)) {
	    throw _utils['default']._snErr('id');
	  }
	  id = id === fakeId ? undefined : id;

	  options = _utils['default']._(definition, options);


	  return { _this: _this, definition: definition, _resourceName: resourceName, _id: id, _options: options };
	}

	exports['default'] = {
	  // Return the changes for the given item, if any.
	  //
	  // @param resourceName The name of the type of resource of the item whose changes are to be returned.
	  // @param id The primary key of the item whose changes are to be returned.
	  // @param options Optional configuration.
	  // @param options.ignoredChanges Array of strings or regular expressions of fields, the changes of which are to be ignored.
	  // @returns The changes of the given item, if any.
	  changes: function changes(resourceName, id, options) {
	    var _check$call = check.call(this, 'changes', resourceName, id, options);

	    var _this = _check$call._this;
	    var definition = _check$call.definition;
	    var _resourceName = _check$call._resourceName;
	    var _id = _check$call._id;
	    var _options = _check$call._options;

	    var item = definition.get(_id);
	    if (item) {
	      var _ret = (function () {
	        var observer = _this.store[_resourceName].observers[_id];
	        if (observer && typeof observer === 'function') {
	          // force observation handler to be fired for item if there are changes and `Object.observe` is not available
	          observer.deliver();
	        }

	        var ignoredChanges = _options.ignoredChanges || [];
	        // add linked relations to list of ignored changes
	        _utils['default'].forEach(definition.relationFields, function (field) {
	          if (!_utils['default'].contains(ignoredChanges, field)) {
	            ignoredChanges.push(field);
	          }
	        });
	        // calculate changes
	        var diff = _utils['default'].diffObjectFromOldObject(item, _this.store[_resourceName].previousAttributes[_id], _utils['default'].equals, ignoredChanges);
	        // remove functions from diff
	        _utils['default'].forOwn(diff, function (changeset, name) {
	          var toKeep = [];
	          _utils['default'].forOwn(changeset, function (value, field) {
	            if (!_utils['default'].isFunction(value)) {
	              toKeep.push(field);
	            }
	          });
	          diff[name] = _utils['default'].pick(diff[name], toKeep);
	        });
	        // definitely ignore changes to linked relations
	        _utils['default'].forEach(definition.relationFields, function (field) {
	          delete diff.added[field];
	          delete diff.removed[field];
	          delete diff.changed[field];
	        });
	        return {
	          v: diff
	        };
	      })();

	      if (typeof _ret === 'object') return _ret.v;
	    }
	  },

	  // Return the change history of the given item, if any.
	  //
	  // @param resourceName The name of the type of resource of the item whose change history is to be returned.
	  // @param id The primary key of the item whose change history is to be returned.
	  // @returns The change history of the given item, if any.
	  changeHistory: function changeHistory(resourceName, id) {
	    var _check$call2 = check.call(this, 'changeHistory', resourceName, id || fakeId);

	    var _this = _check$call2._this;
	    var definition = _check$call2.definition;
	    var _resourceName = _check$call2._resourceName;
	    var _id = _check$call2._id;

	    var resource = _this.store[_resourceName];

	    if (!definition.keepChangeHistory) {
	      definition.errorFn('changeHistory is disabled for this resource!');
	    } else {
	      if (_resourceName) {
	        var item = definition.get(_id);
	        if (item) {
	          return resource.changeHistories[_id];
	        }
	      } else {
	        return resource.changeHistory;
	      }
	    }
	  },

	  commit: function commit(resourceName, id) {
	    var _check$call3 = check.call(this, 'commit', resourceName, id);

	    var _this = _check$call3._this;
	    var definition = _check$call3.definition;
	    var _resourceName = _check$call3._resourceName;
	    var _id = _check$call3._id;

	    var resource = _this.store[_resourceName];
	    var item = _this.store[_resourceName].index[_id];
	    if (item) {
	      resource.previousAttributes[_id] = _utils['default'].copy(item, null, null, null, definition.relationFields);
	    }

	    if (resource.changeHistories[_id].length) {
	      _utils['default'].forEach(resource.changeHistories[_id], function (changeRecord) {
	        _utils['default'].remove(resource.changeHistory, changeRecord);
	      });
	      resource.changeHistories[_id].splice(0, resource.changeHistories[_id].length);
	    }
	    return item;
	  },

	  // Re-compute the computed properties of the given item.
	  //
	  // @param resourceName The name of the type of resource of the item whose computed properties are to be re-computed.
	  // @param instance The instance whose computed properties are to be re-computed.
	  // @returns The item whose computed properties were re-computed.
	  compute: function compute(resourceName, instance) {
	    var _this = this;
	    var definition = _this.definitions[resourceName];

	    instance = _utils['default'].resolveItem(_this.store[resourceName], instance);
	    if (!definition) {
	      throw new NER(resourceName);
	    } else if (!instance) {
	      throw new R('Item not in the store!');
	    } else if (!_utils['default']._o(instance) && !_utils['default']._sn(instance)) {
	      throw new IA('"instance" must be an object, string or number!');
	    }


	    // re-compute all computed properties
	    _utils['default'].forOwn(definition.computed, function (fn, field) {
	      _utils['default'].compute.call(instance, fn, field);
	    });
	    return instance;
	  },

	  // Factory function to create an instance of the specified Resource.
	  //
	  // @param resourceName The name of the type of resource of which to create an instance.
	  // @param attrs Hash of properties with which to initialize the instance.
	  // @param options Optional configuration.
	  // @param options.defaults Default values with which to initialize the instance.
	  // @returns The new instance.
	  createInstance: function createInstance(resourceName, attrs, options) {
	    var definition = this.definitions[resourceName];
	    var item = undefined;

	    attrs = attrs || {};

	    if (!definition) {
	      throw new NER(resourceName);
	    } else if (attrs && !_utils['default'].isObject(attrs)) {
	      throw new IA('"attrs" must be an object!');
	    }

	    options = _utils['default']._(definition, options);

	    // lifecycle
	    options.beforeCreateInstance(options, attrs);

	    // grab instance constructor function from Resource definition
	    var Constructor = definition[definition['class']];

	    // create instance
	    item = new Constructor();

	    if (definition.instanceEvents) {
	      _utils['default'].Events(item);
	    }

	    // add default values
	    if (options.defaultValues) {
	      _utils['default'].deepMixIn(item, options.defaultValues);
	    }
	    _utils['default'].deepMixIn(item, attrs);

	    // compute computed properties
	    if (definition.computed) {
	      definition.compute(item);
	    }
	    // lifecycle
	    options.afterCreateInstance(options, item);
	    return item;
	  },

	  // Create a new collection of the specified Resource.
	  //
	  // @param resourceName The name of the type of resource of which to create a collection
	  // @param arr Possibly empty array of data from which to create the collection.
	  // @param params The criteria by which to filter items. Will be passed to `DS#findAll` if `fetch` is called. See http://www.js-data.io/docs/query-syntax
	  // @param options Optional configuration.
	  // @param options.notify Whether to call the beforeCreateCollection and afterCreateCollection lifecycle hooks..
	  // @returns The new collection.
	  createCollection: function createCollection(resourceName, arr, params, options) {
	    var _this = this;
	    var definition = _this.definitions[resourceName];

	    arr = arr || [];
	    params = params || {};

	    if (!definition) {
	      throw new NER(resourceName);
	    } else if (arr && !_utils['default'].isArray(arr)) {
	      throw new IA('"arr" must be an array!');
	    }

	    options = _utils['default']._(definition, options);


	    // lifecycle
	    options.beforeCreateCollection(options, arr);

	    // define the API for this collection
	    Object.defineProperties(arr, {
	      //  Call DS#findAll with the params of this collection, filling the collection with the results.
	      fetch: {
	        value: function value(params, options) {
	          var __this = this;
	          __this.params = params || __this.params;
	          return definition.findAll(__this.params, options).then(function (data) {
	            if (data === __this) {
	              return __this;
	            }
	            data.unshift(__this.length);
	            data.unshift(0);
	            __this.splice.apply(__this, data);
	            data.shift();
	            data.shift();
	            if (data.$$injected) {
	              _this.store[resourceName].queryData[_utils['default'].toJson(__this.params)] = __this;
	              __this.$$injected = true;
	            }
	            return __this;
	          });
	        }
	      },
	      // params for this collection. See http://www.js-data.io/docs/query-syntax
	      params: {
	        value: params,
	        writable: true
	      },
	      // name of the resource type of this collection
	      resourceName: {
	        value: resourceName
	      }
	    });

	    // lifecycle
	    options.afterCreateCollection(options, arr);
	    return arr;
	  },
	  defineResource: __webpack_require__(31),
	  digest: function digest() {
	    this.observe.Platform.performMicrotaskCheckpoint();
	  },
	  eject: __webpack_require__(32),
	  ejectAll: __webpack_require__(33),
	  filter: __webpack_require__(34),

	  // Return the item with the given primary key if its in the store.
	  //
	  // @param resourceName The name of the type of resource of the item to retrieve.
	  // @param id The primary key of the item to retrieve.
	  // @returns The item with the given primary key if it's in the store.
	  // /
	  get: function get(resourceName, id) {
	    var _check$call4 = check.call(this, 'get', resourceName, id);

	    var _this = _check$call4._this;
	    var _resourceName = _check$call4._resourceName;
	    var _id = _check$call4._id;

	    // return the item if it exists
	    return _this.store[_resourceName].index[_id];
	  },

	  // Return the items in the store that have the given primary keys.
	  //
	  // @param resourceName The name of the type of resource of the items to retrieve.
	  // @param ids The primary keys of the items to retrieve.
	  // @returns The items with the given primary keys if they're in the store.
	  getAll: function getAll(resourceName, ids) {
	    var _this = this;
	    var definition = _this.definitions[resourceName];
	    var resource = _this.store[resourceName];
	    var collection = [];

	    if (!definition) {
	      throw new NER(resourceName);
	    } else if (ids && !_utils['default']._a(ids)) {
	      throw _utils['default']._aErr('ids');
	    }


	    if (_utils['default']._a(ids)) {
	      // return just the items with the given primary keys
	      var _length = ids.length;
	      for (var i = 0; i < _length; i++) {
	        if (resource.index[ids[i]]) {
	          collection.push(resource.index[ids[i]]);
	        }
	      }
	    } else {
	      // most efficient of retrieving ALL items from the store
	      collection = resource.collection.slice();
	    }

	    return collection;
	  },

	  // Return the whether the item with the given primary key has any changes.
	  //
	  // @param resourceName The name of the type of resource of the item.
	  // @param id The primary key of the item.
	  // @returns Whether the item with the given primary key has any changes.
	  hasChanges: function hasChanges(resourceName, id) {
	    var _check$call5 = check.call(this, 'hasChanges', resourceName, id);

	    var definition = _check$call5.definition;
	    var _id = _check$call5._id;

	    return definition.get(_id) ? diffIsEmpty(definition.changes(_id)) : false;
	  },
	  inject: __webpack_require__(35),

	  // Return the timestamp from the last time the item with the given primary key was changed.
	  //
	  // @param resourceName The name of the type of resource of the item.
	  // @param id The primary key of the item.
	  // @returns Timestamp from the last time the item was changed.
	  lastModified: function lastModified(resourceName, id) {
	    var _check$call6 = check.call(this, 'lastModified', resourceName, id || fakeId);

	    var _this = _check$call6._this;
	    var _resourceName = _check$call6._resourceName;
	    var _id = _check$call6._id;

	    var resource = _this.store[_resourceName];

	    if (_id) {
	      if (!(_id in resource.modified)) {
	        resource.modified[_id] = 0;
	      }
	      return resource.modified[_id];
	    }
	    return resource.collectionModified;
	  },

	  // Return the timestamp from the last time the item with the given primary key was saved via an adapter.
	  //
	  // @param resourceName The name of the type of resource of the item.
	  // @param id The primary key of the item.
	  // @returns Timestamp from the last time the item was saved.
	  lastSaved: function lastSaved(resourceName, id) {
	    var _check$call7 = check.call(this, 'lastSaved', resourceName, id || fakeId);

	    var _this = _check$call7._this;
	    var _resourceName = _check$call7._resourceName;
	    var _id = _check$call7._id;

	    var resource = _this.store[_resourceName];

	    if (!(_id in resource.saved)) {
	      resource.saved[_id] = 0;
	    }
	    return resource.saved[_id];
	  },

	  // Return the previous attributes of the item with the given primary key before it was changed.
	  //
	  // @param resourceName The name of the type of resource of the item.
	  // @param id The primary key of the item.
	  // @returns The previous attributes of the item
	  previous: function previous(resourceName, id) {
	    var _check$call8 = check.call(this, 'previous', resourceName, id);

	    var _this = _check$call8._this;
	    var _resourceName = _check$call8._resourceName;
	    var _id = _check$call8._id;

	    var resource = _this.store[_resourceName];

	    // return resource from cache
	    return resource.previousAttributes[_id] ? _utils['default'].copy(resource.previousAttributes[_id]) : undefined;
	  },

	  // Revert all attributes of the item with the given primary key to their previous values.
	  //
	  // @param resourceName The name of the type of resource of the item.
	  // @param id The primary key of the item.
	  // @param options Optional configuration.
	  // @returns The reverted item
	  revert: function revert(resourceName, id, options) {
	    var _check$call9 = check.call(this, 'revert', resourceName, id, options);

	    var _this = _check$call9._this;
	    var definition = _check$call9.definition;
	    var _resourceName = _check$call9._resourceName;
	    var _id = _check$call9._id;
	    var _options = _check$call9._options;

	    var preserve = _options.preserve || [];
	    var injectObj = {};

	    if (preserve.length === 0) {
	      injectObj = _this.previous(_resourceName, _id);
	    } else {
	      var _ret2 = (function () {
	        var instance = definition.get(id);
	        var previousInstance = _this.previous(_resourceName, _id);

	        if (!instance) {
	          return {
	            v: undefined
	          };
	        }

	        _utils['default'].forOwn(instance, function (value, key) {
	          if (_utils['default'].contains(preserve, key)) {
	            injectObj[key] = instance[key];
	          } else {
	            injectObj[key] = previousInstance[key];
	          }
	        });
	      })();

	      if (typeof _ret2 === 'object') return _ret2.v;
	    }

	    return definition.inject(injectObj, {
	      onConflict: 'replace'
	    });
	  }
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint evil:true, loopfunc:true */

	var _utils = __webpack_require__(2);

	var _errors = __webpack_require__(3);

	/**
	 * These are DS methods that will be proxied by instances. e.g.
	 *
	 * var store = new JSData.DS()
	 * var User = store.defineResource('user')
	 * var user = User.createInstance({ id: 1 })
	 *
	 * store.update(resourceName, id, attrs[, options]) // DS method
	 * User.update(id, attrs[, options]) // DS method proxied on a Resource
	 * user.DSUpdate(attrs[, options]) // DS method proxied on an Instance
	 */
	var instanceMethods = ['compute', 'eject', 'refresh', 'save', 'update', 'destroy', 'loadRelations', 'changeHistory', 'changes', 'commit', 'hasChanges', 'lastModified', 'lastSaved', 'previous', 'revert'];

	module.exports = function defineResource(definition) {
	  var _this = this;
	  var definitions = _this.definitions;

	  /**
	   * This allows the name-only definition shorthand.
	   * store.defineResource('user') is the same as store.defineResource({ name: 'user'})
	   */
	  if (_utils['default']._s(definition)) {
	    definition = {
	      name: definition.replace(/\s/gi, '')
	    };
	  }
	  if (!_utils['default']._o(definition)) {
	    throw _utils['default']._oErr('definition');
	  } else if (!_utils['default']._s(definition.name)) {
	    throw new _errors['default'].IA('"name" must be a string!');
	  } else if (definitions[definition.name]) {
	    throw new _errors['default'].R(definition.name + ' is already registered!');
	  }

	  /**
	   * Dynamic Resource constructor function.
	   *
	   * A Resource inherits from the defaults of the data store that created it.
	   */
	  function Resource(options) {
	    this.defaultValues = {};
	    this.methods = {};
	    this.computed = {};
	    this.scopes = {};
	    this.actions = {};
	    _utils['default'].deepMixIn(this, options);
	    var parent = _this.defaults;
	    if (definition['extends'] && definitions[definition['extends']]) {
	      parent = definitions[definition['extends']];
	    }
	    _utils['default'].fillIn(this.defaultValues, parent.defaultValues);
	    _utils['default'].fillIn(this.methods, parent.methods);
	    _utils['default'].fillIn(this.computed, parent.computed);
	    _utils['default'].fillIn(this.scopes, parent.scopes);
	    _utils['default'].fillIn(this.actions, parent.actions);
	    this.endpoint = 'endpoint' in options ? options.endpoint : this.name;
	  }

	  try {
	    var def;

	    var _class;

	    var _ret = (function () {
	      // Resources can inherit from another resource instead of inheriting directly from the data store defaults.
	      if (definition['extends'] && definitions[definition['extends']]) {
	        // Inherit from another resource
	        Resource.prototype = definitions[definition['extends']];
	      } else {
	        // Inherit from global defaults
	        Resource.prototype = _this.defaults;
	      }
	      definitions[definition.name] = new Resource(definition);

	      def = definitions[definition.name];

	      def.getResource = function (resourceName) {
	        return _this.definitions[resourceName];
	      };


	      if (!_utils['default']._s(def.idAttribute)) {
	        throw new _errors['default'].IA('"idAttribute" must be a string!');
	      }

	      // Setup nested parent configuration
	      if (def.relations) {
	        def.relationList = [];
	        def.relationFields = [];
	        _utils['default'].forOwn(def.relations, function (relatedModels, type) {
	          _utils['default'].forOwn(relatedModels, function (defs, relationName) {
	            if (!_utils['default']._a(defs)) {
	              relatedModels[relationName] = [defs];
	            }
	            _utils['default'].forEach(relatedModels[relationName], function (d) {
	              d.type = type;
	              d.relation = relationName;
	              d.name = def.name;
	              def.relationList.push(d);
	              if (d.localField) {
	                def.relationFields.push(d.localField);
	              }
	            });
	          });
	        });
	        if (def.relations.belongsTo) {
	          _utils['default'].forOwn(def.relations.belongsTo, function (relatedModel, modelName) {
	            _utils['default'].forEach(relatedModel, function (relation) {
	              if (relation.parent) {
	                def.parent = modelName;
	                def.parentKey = relation.localKey;
	                def.parentField = relation.localField;
	              }
	            });
	          });
	        }
	        if (typeof Object.freeze === 'function') {
	          Object.freeze(def.relations);
	          Object.freeze(def.relationList);
	        }
	      }

	      // Create the wrapper class for the new resource
	      _class = def['class'] = _utils['default'].pascalCase(def.name);

	      try {
	        if (typeof def.useClass === 'function') {
	          if (def.csp) {
	            def[_class] = function () {
	              def.useClass.call(this);
	            };
	          } else {
	            def[_class] = new Function('def', 'return function ' + _class + '() { def.useClass.call(this); }')(def); // eslint-disable-line
	          }
	          def[_class].prototype = (function (proto) {
	            function Ctor() {}

	            Ctor.prototype = proto;
	            return new Ctor();
	          })(def.useClass.prototype);
	        } else if (def.csp) {
	          def[_class] = function () {};
	        } else {
	          def[_class] = new Function('return function ' + _class + '() {}')(); // eslint-disable-line
	        }
	      } catch (e) {
	        def[_class] = function () {};
	      }

	      // Apply developer-defined instance methods
	      _utils['default'].forOwn(def.methods, function (fn, m) {
	        def[_class].prototype[m] = fn;
	      });

	      /**
	       * var user = User.createInstance({ id: 1 })
	       * user.set('foo', 'bar')
	       */
	      def[_class].prototype.set = function (key, value) {
	        var _this2 = this;

	        _utils['default'].set(this, key, value);
	        def.compute(this);
	        if (def.instanceEvents) {
	          setTimeout(function () {
	            _this2.emit('DS.change', def, _this2);
	          }, 0);
	        }
	        def.handleChange(this);
	        return this;
	      };

	      /**
	       * var user = User.createInstance({ id: 1 })
	       * user.get('id') // 1
	       */
	      def[_class].prototype.get = function (key) {
	        return _utils['default'].get(this, key);
	      };

	      // Setup the relation links
	      _utils['default'].applyRelationGettersToTarget(_this, def, def[_class].prototype);

	      var parentOmit = null;
	      if (!def.hasOwnProperty('omit')) {
	        parentOmit = def.omit;
	        def.omit = [];
	      } else {
	        parentOmit = _this.defaults.omit;
	      }
	      def.omit = def.omit.concat(parentOmit || []);

	      // Prepare for computed properties
	      _utils['default'].forOwn(def.computed, function (fn, field) {
	        if (_utils['default'].isFunction(fn)) {
	          def.computed[field] = [fn];
	          fn = def.computed[field];
	        }
	        if (def.methods && field in def.methods) {
	          def.errorFn('Computed property "' + field + '" conflicts with previously defined prototype method!');
	        }
	        def.omit.push(field);
	        if (_utils['default'].isArray(fn)) {
	          var deps;
	          if (fn.length === 1) {
	            var match = fn[0].toString().match(/function.*?\(([\s\S]*?)\)/);
	            deps = match[1].split(',');
	            deps = _utils['default'].filter(deps, function (x) {
	              return x;
	            });
	            def.computed[field] = deps.concat(fn);
	            fn = def.computed[field];
	            if (deps.length) {
	              def.errorFn('Use the computed property array syntax for compatibility with minified code!');
	            }
	          }
	          deps = fn.slice(0, fn.length - 1);
	          _utils['default'].forEach(deps, function (val, index) {
	            deps[index] = val.trim();
	          });
	          fn.deps = _utils['default'].filter(deps, function (dep) {
	            return !!dep;
	          });
	        } else if (_utils['default'].isObject(fn)) {
	          Object.defineProperty(def[_class].prototype, field, fn);
	        }
	      });

	      // add instance proxies of DS methods
	      _utils['default'].forEach(instanceMethods, function (name) {
	        def[_class].prototype['DS' + _utils['default'].pascalCase(name)] = function () {
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }

	          args.unshift(this[def.idAttribute] || this);
	          args.unshift(def.name);
	          return _this[name].apply(_this, args);
	        };
	      });

	      // manually add instance proxy for DS#create
	      def[_class].prototype.DSCreate = function () {
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          args[_key2] = arguments[_key2];
	        }

	        args.unshift(this);
	        args.unshift(def.name);
	        return _this.create.apply(_this, args);
	      };

	      // Initialize store data for the new resource
	      _this.store[def.name] = {
	        collection: [],
	        expiresHeap: new _utils['default'].BinaryHeap(function (x) {
	          return x.expires;
	        }, function (x, y) {
	          return x.item === y;
	        }),
	        completedQueries: {},
	        queryData: {},
	        pendingQueries: {},
	        index: {},
	        modified: {},
	        saved: {},
	        previousAttributes: {},
	        observers: {},
	        changeHistories: {},
	        changeHistory: [],
	        collectionModified: 0
	      };

	      var resource = _this.store[def.name];

	      // start the reaping
	      if (def.reapInterval) {
	        setInterval(function () {
	          return def.reap();
	        }, def.reapInterval);
	      }

	      // proxy DS methods with shorthand ones
	      var fns = ['registerAdapter', 'getAdapterName', 'getAdapter', 'is', '!clear'];
	      for (var key in _this) {
	        if (typeof _this[key] === 'function') {
	          fns.push(key);
	        }
	      }

	      /**
	       * Create the Resource shorthands that proxy DS methods. e.g.
	       *
	       * var store = new JSData.DS()
	       * var User = store.defineResource('user')
	       *
	       * store.update(resourceName, id, attrs[, options]) // DS method
	       * User.update(id, attrs[, options]) // DS method proxied on a Resource
	       */
	      _utils['default'].forEach(fns, function (key) {
	        var k = key;
	        if (k[0] === '!') {
	          return;
	        }
	        if (_this[k].shorthand !== false) {
	          def[k] = function () {
	            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	              args[_key3] = arguments[_key3];
	            }

	            args.unshift(def.name);
	            return _this[k].apply(_this, args);
	          };
	          def[k].before = function (fn) {
	            var orig = def[k];
	            def[k] = function () {
	              for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	                args[_key4] = arguments[_key4];
	              }

	              return orig.apply(def, fn.apply(def, args) || args);
	            };
	          };
	        } else {
	          def[k] = function () {
	            for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	              args[_key5] = arguments[_key5];
	            }

	            return _this[k].apply(_this, args);
	          };
	        }
	      });

	      def.beforeValidate = _utils['default'].promisify(def.beforeValidate);
	      def.validate = _utils['default'].promisify(def.validate);
	      def.afterValidate = _utils['default'].promisify(def.afterValidate);
	      def.beforeCreate = _utils['default'].promisify(def.beforeCreate);
	      def.afterCreate = _utils['default'].promisify(def.afterCreate);
	      def.afterFind = _utils['default'].promisify(def.afterFind);
	      def.afterFindAll = _utils['default'].promisify(def.afterFindAll);
	      def.afterLoadRelations = _utils['default'].promisify(def.afterLoadRelations);
	      def.beforeUpdate = _utils['default'].promisify(def.beforeUpdate);
	      def.afterUpdate = _utils['default'].promisify(def.afterUpdate);
	      def.beforeDestroy = _utils['default'].promisify(def.beforeDestroy);
	      def.afterDestroy = _utils['default'].promisify(def.afterDestroy);

	      var defaultAdapter = undefined;
	      if (def.hasOwnProperty('defaultAdapter')) {
	        defaultAdapter = def.defaultAdapter;
	      }

	      // setup "actions"
	      _utils['default'].forOwn(def.actions, function (action, name) {
	        if (def[name] && !def.actions[name]) {
	          throw new Error('Cannot override existing method "' + name + '"!');
	        }
	        action.request = action.request || function (config) {
	          return config;
	        };
	        action.response = action.response || function (response) {
	          return response;
	        };
	        action.responseError = action.responseError || function (err) {
	          return _utils['default'].Promise.reject(err);
	        };
	        def[name] = function (id, options) {
	          if (_utils['default']._o(id)) {
	            options = id;
	          }
	          options = options || {};
	          var adapter = def.getAdapter(action.adapter || defaultAdapter || 'http');
	          var config = _utils['default'].deepMixIn({}, action);
	          if (!options.hasOwnProperty('endpoint') && config.endpoint) {
	            options.endpoint = config.endpoint;
	          }
	          if (typeof options.getEndpoint === 'function') {
	            config.url = options.getEndpoint(def, options);
	          } else {
	            var args = [options.basePath || def.basePath || adapter.defaults.basePath, adapter.getEndpoint(def, _utils['default']._sn(id) ? id : null, options)];
	            if (_utils['default']._sn(id)) {
	              args.push(id);
	            }
	            args.push(action.pathname || name);
	            config.url = _utils['default'].makePath.apply(null, args);
	          }
	          config.method = config.method || 'GET';
	          config.resourceName = def.name;
	          _utils['default'].deepMixIn(config, options);
	          return new _utils['default'].Promise(function (resolve) {
	            return resolve(config);
	          }).then(options.request || action.request).then(function (config) {
	            return adapter.HTTP(config);
	          }).then(function (data) {
	            if (data && data.config) {
	              data.config.resourceName = def.name;
	            }
	            return data;
	          }).then(options.response || action.response, options.responseError || action.responseError);
	        };
	      });

	      // mix in events
	      _utils['default'].Events(def);

	      def.handleChange = function (data) {
	        resource.collectionModified = _utils['default'].updateTimestamp(resource.collectionModified);
	        if (def.notify) {
	          setTimeout(function () {
	            def.emit('DS.change', def, data);
	          }, 0);
	        }
	      };


	      return {
	        v: def
	      };
	    })();

	    if (typeof _ret === 'object') return _ret.v;
	  } catch (err) {
	    _this.defaults.errorFn(err);
	    delete definitions[definition.name];
	    delete _this.store[definition.name];
	    throw err;
	  }
	};

/***/ },
/* 32 */
/***/ function(module, exports) {

	/* jshint eqeqeq:false */
	/**
	 * Eject an item from the store, if it is currently in the store.
	 *
	 * @param resourceName The name of the resource type of the item eject.
	 * @param id The primary key of the item to eject.
	 * @param options Optional configuration.
	 * @param options.notify Whether to emit the "DS.beforeEject" and "DS.afterEject" events
	 * @param options.clearEmptyQueries Whether to remove cached findAll queries that become empty as a result of this method call.
	 * @returns The ejected item if one was ejected.
	 */
	module.exports = function eject(resourceName, id, options) {
	  var _this = this;
	  var DSUtils = _this.utils;
	  var definition = _this.definitions[resourceName];
	  var resource = _this.store[resourceName];
	  var item = undefined;
	  var found = false;

	  id = DSUtils.resolveId(definition, id);

	  if (!definition) {
	    throw new _this.errors.NER(resourceName);
	  } else if (!DSUtils._sn(id)) {
	    throw DSUtils._snErr('id');
	  }

	  options = DSUtils._(definition, options);


	  // find the item to eject
	  for (var i = 0; i < resource.collection.length; i++) {
	    if (resource.collection[i][definition.idAttribute] == id) {
	      // eslint-disable-line
	      item = resource.collection[i];
	      // remove its expiration timestamp
	      resource.expiresHeap.remove(item);
	      found = true;
	      break;
	    }
	  }
	  if (found) {
	    var _ret = (function () {
	      // lifecycle
	      definition.beforeEject(options, item);
	      if (options.notify) {
	        definition.emit('DS.beforeEject', definition, item);
	      }

	      // find the item in any ($$injected) cached queries
	      var toRemove = [];
	      DSUtils.forOwn(resource.queryData, function (items, queryHash) {
	        if (items.$$injected) {
	          DSUtils.remove(items, item);
	        }
	        // optionally remove any empty queries
	        if (!items.length && options.clearEmptyQueries) {
	          toRemove.push(queryHash);
	        }
	      });

	      // clean up
	      DSUtils.forEach(resource.changeHistories[id], function (changeRecord) {
	        DSUtils.remove(resource.changeHistory, changeRecord);
	      });
	      DSUtils.forEach(toRemove, function (queryHash) {
	        delete resource.completedQueries[queryHash];
	        delete resource.queryData[queryHash];
	      });
	      if (resource.observers[id] && typeof resource.observers[id].close === 'function') {
	        // stop observation
	        resource.observers[id].close();
	      }
	      delete resource.observers[id];
	      delete resource.index[id];
	      delete resource.previousAttributes[id];
	      delete resource.completedQueries[id];
	      delete resource.pendingQueries[id];
	      delete resource.changeHistories[id];
	      delete resource.modified[id];
	      delete resource.saved[id];
	      if (definition.instanceEvents && item.off) {
	        item.off();
	      }

	      // remove it from the store
	      resource.collection.splice(i, 1);
	      // collection has been modified
	      definition.handleChange(item);

	      // lifecycle
	      definition.afterEject(options, item);
	      if (options.notify) {
	        definition.emit('DS.afterEject', definition, item);
	      }

	      return {
	        v: item
	      };
	    })();

	    if (typeof _ret === 'object') return _ret.v;
	  }
	};

/***/ },
/* 33 */
/***/ function(module, exports) {

	/**
	 * Eject a collection of items from the store, if any items currently in the store match the given criteria.
	 *
	 * @param resourceName The name of the resource type of the items eject.
	 * @param params The criteria by which to match items to eject. See http://www.js-data.io/docs/query-syntax
	 * @param options Optional configuration.
	 * @returns The collection of items that were ejected, if any.
	 */
	module.exports = function ejectAll(resourceName, params, options) {
	  var _this = this;
	  var DSUtils = _this.utils;
	  var definition = _this.definitions[resourceName];
	  params = params || {};

	  if (!definition) {
	    throw new _this.errors.NER(resourceName);
	  } else if (!DSUtils._o(params)) {
	    throw DSUtils._oErr('params');
	  }

	  options = DSUtils._(definition, options);

	  DSUtils.applyScope(definition, params, options);

	  var resource = _this.store[resourceName];
	  var queryHash = DSUtils.toJson(params);

	  // get items that match the criteria
	  var items = definition.filter(params);

	  if (DSUtils.isEmpty(params)) {
	    // remove all completed queries if ejecting all items
	    resource.completedQueries = {};
	  } else {
	    // remove matching completed query, if any
	    delete resource.completedQueries[queryHash];
	  }
	  // prepare to remove matching items
	  DSUtils.forEach(items, function (item) {
	    if (item && item[definition.idAttribute]) {
	      definition.eject(item[definition.idAttribute], options);
	    }
	  });
	  // collection has been modified
	  definition.handleChange(items);
	  return items;
	};

/***/ },
/* 34 */
/***/ function(module, exports) {

	/**
	 * Return the subset of items currently in the store that match the given criteria.
	 *
	 * The actual filtering is delegated to DS#defaults.defaultFilter, which can be overridden by developers.
	 *
	 * @param resourceName The name of the resource type of the items to filter.
	 * @param params The criteria by which to filter items. See http://www.js-data.io/docs/query-syntax
	 * @param options Optional configuration.
	 * @returns Matching items.
	 */
	module.exports = function filter(resourceName, params, options) {
	  var _this = this;
	  var DSUtils = _this.utils;
	  var definition = _this.definitions[resourceName];

	  if (!definition) {
	    throw new _this.errors.NER(resourceName);
	  } else if (params && !DSUtils._o(params)) {
	    throw DSUtils._oErr('params');
	  }

	  // Protect against null
	  params = params || {};
	  options = DSUtils._(definition, options);

	  DSUtils.applyScope(definition, params, options);

	  // delegate filtering to DS#defaults.defaultFilter, which can be overridden by developers.
	  return definition.defaultFilter.call(_this, _this.store[resourceName].collection, resourceName, params, options);
	};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var _utils = __webpack_require__(2);

	var _errors = __webpack_require__(3);

	/**
	 * This is a beast of a file, but it's where a significant portion of the magic happens.
	 *
	 * DS#inject makes up the core of how data gets into the store.
	 */

	/**
	 * This factory function produces an observer handler function tailor-made for the current item being injected.
	 *
	 * The observer handler is what allows computed properties and change tracking to function.
	 *
	 * @param definition Resource definition produced by DS#defineResource
	 * @param resource Resource data as internally stored by the data store
	 * @returns {Function} Observer handler function
	 * @private
	 */
	function makeObserverHandler(definition, resource) {
	  var DS = this;

	  // using "var" avoids a JSHint error
	  var name = definition.name;

	  /**
	   * This will be called by observe-js when a new change record is available for the observed object
	   *
	   * @param added Change record for added properties
	   * @param removed Change record for removed properties
	   * @param changed Change record for changed properties
	   * @param oldValueFn Function that can be used to get the previous value of a changed property
	   * @param firstTime Whether this is the first time this function is being called for the given item. Will only be true once.
	   */
	  return function _react(added, removed, changed, oldValueFn, firstTime) {
	    var target = this;
	    var item = undefined;

	    // Get the previous primary key of the observed item, in-case some knucklehead changed it
	    var innerId = oldValueFn && oldValueFn(definition.idAttribute) ? oldValueFn(definition.idAttribute) : target[definition.idAttribute];

	    // Ignore changes to relation links
	    _utils['default'].forEach(definition.relationFields, function (field) {
	      delete added[field];
	      delete removed[field];
	      delete changed[field];
	    });

	    // Detect whether there are actually any changes
	    if (!_utils['default'].isEmpty(added) || !_utils['default'].isEmpty(removed) || !_utils['default'].isEmpty(changed) || firstTime) {
	      item = DS.get(name, innerId);

	      // update item and collection "modified" timestamps
	      resource.modified[innerId] = _utils['default'].updateTimestamp(resource.modified[innerId]);

	      if (item && definition.instanceEvents) {
	        setTimeout(function () {
	          item.emit('DS.change', definition, item);
	        }, 0);
	      }

	      definition.handleChange(item);

	      // Save a change record for the item
	      if (definition.keepChangeHistory) {
	        var changeRecord = {
	          resourceName: name,
	          target: item,
	          added: added,
	          removed: removed,
	          changed: changed,
	          timestamp: resource.modified[innerId]
	        };
	        resource.changeHistories[innerId].push(changeRecord);
	        resource.changeHistory.push(changeRecord);
	      }
	    }

	    // Recompute computed properties if any computed properties depend on changed properties
	    if (definition.computed) {
	      item = item || DS.get(name, innerId);
	      _utils['default'].forOwn(definition.computed, function (fn, field) {
	        if (_utils['default']._o(fn)) {
	          return;
	        }
	        var compute = false;
	        // check if required fields changed
	        _utils['default'].forEach(fn.deps, function (dep) {
	          if (dep in added || dep in removed || dep in changed || !(field in item)) {
	            compute = true;
	          }
	        });
	        compute = compute || !fn.deps.length;
	        if (compute) {
	          _utils['default'].compute.call(item, fn, field);
	        }
	      });
	    }

	    if (definition.idAttribute in changed) {
	      definition.errorFn('Doh! You just changed the primary key of an object! Your data for the "' + name + '" resource is now in an undefined (probably broken) state.');
	    }
	  };
	}

	/**
	 * A recursive function for injecting data into the store.
	 *
	 * @param definition Resource definition produced by DS#defineResource
	 * @param resource Resource data as internally stored by the data store
	 * @param attrs The data to be injected. Will be an object or an array of objects.
	 * @param options Optional configuration.
	 * @returns The injected data
	 * @private
	 */
	function _inject(definition, resource, attrs, options) {
	  var _this = this;
	  var injected = undefined;

	  if (_utils['default']._a(attrs)) {
	    // have an array of objects, go ahead and inject each one individually and return the resulting array
	    injected = [];
	    for (var i = 0; i < attrs.length; i++) {
	      injected.push(_inject.call(_this, definition, resource, attrs[i], options));
	    }
	  } else {
	    // check if "idAttribute" is a computed property
	    var c = definition.computed;
	    var idA = definition.idAttribute;
	    // compute the primary key if necessary
	    if (c && c[idA]) {
	      (function () {
	        var args = [];
	        _utils['default'].forEach(c[idA].deps, function (dep) {
	          args.push(attrs[dep]);
	        });
	        attrs[idA] = c[idA][c[idA].length - 1].apply(attrs, args);
	      })();
	    }

	    if (!(idA in attrs)) {
	      var error = new _errors['default'].R(definition.name + '.inject: "attrs" must contain the property specified by "idAttribute"!');
	      options.errorFn(error);
	      throw error;
	    } else {
	      try {
	        (function () {
	          // when injecting object that contain their nested relations, this code
	          // will recursively inject them into their proper places in the data store.
	          // Magic!
	          _utils['default'].forEach(definition.relationList, function (def) {
	            var relationName = def.relation;
	            var relationDef = _this.definitions[relationName];
	            var toInject = attrs[def.localField];
	            if (typeof def.inject === 'function') {
	              def.inject(definition, def, attrs);
	            } else if (toInject && def.inject !== false) {
	              if (!relationDef) {
	                throw new _errors['default'].R(definition.name + ' relation is defined but the resource is not!');
	              }
	              // handle injecting hasMany relations
	              if (_utils['default']._a(toInject)) {
	                (function () {
	                  var items = [];
	                  _utils['default'].forEach(toInject, function (toInjectItem) {
	                    if (toInjectItem !== _this.store[relationName].index[toInjectItem[relationDef.idAttribute]]) {
	                      try {
	                        var injectedItem = relationDef.inject(toInjectItem, options.orig());
	                        if (def.foreignKey) {
	                          _utils['default'].set(injectedItem, def.foreignKey, attrs[definition.idAttribute]);
	                        }
	                        items.push(injectedItem);
	                      } catch (err) {
	                        options.errorFn(err, 'Failed to inject ' + def.type + ' relation: "' + relationName + '"!');
	                      }
	                    }
	                  });
	                })();
	              } else {
	                // handle injecting belongsTo and hasOne relations
	                if (toInject !== _this.store[relationName].index[toInject[relationDef.idAttribute]]) {
	                  try {
	                    var _injected = relationDef.inject(attrs[def.localField], options.orig());
	                    if (def.foreignKey) {
	                      _utils['default'].set(_injected, def.foreignKey, attrs[definition.idAttribute]);
	                    }
	                  } catch (err) {
	                    options.errorFn(err, 'Failed to inject ' + def.type + ' relation: "' + relationName + '"!');
	                  }
	                }
	              }
	            }
	          });

	          // primary key of item being injected
	          var id = attrs[idA];
	          // item being injected
	          var item = definition.get(id);
	          // 0 if the item is new, otherwise the previous last modified timestamp of the item
	          var initialLastModified = item ? resource.modified[id] : 0;

	          // item is new
	          if (!item) {
	            if (attrs instanceof definition[definition['class']]) {
	              item = attrs;
	            } else {
	              item = new definition[definition['class']]();
	            }

	            if (definition.instanceEvents && typeof item.emit !== 'function') {
	              _utils['default'].Events(item);
	            }
	            // remove relation properties from the item, since those relations have been injected by now
	            _utils['default'].forEach(definition.relationList, function (def) {
	              if (typeof def.link === 'boolean' ? def.link : !!definition.linkRelations) {
	                delete attrs[def.localField];
	              }
	            });

	            // copy remaining properties to the injected item
	            _utils['default'].deepMixIn(item, attrs);

	            // add item to collection
	            resource.collection.push(item);
	            resource.changeHistories[id] = [];

	            // create the observer handler for the data to be injected
	            var _react = makeObserverHandler.call(_this, definition, resource);

	            // If we're in the browser, start observation
	            if (definition.watchChanges) {
	              resource.observers[id] = new _this.observe.ObjectObserver(item);
	              resource.observers[id].open(_react, item);
	            }

	            // index item
	            resource.index[id] = item;
	            // fire observation handler for the first time
	            _react.call(item, {}, {}, {}, null, true);
	            // save "previous" attributes of the injected item, for change diffs later
	            resource.previousAttributes[id] = _utils['default'].copy(item, null, null, null, definition.relationFields);
	          } else {
	            // item is being re-injected
	            // new properties take precedence
	            if (options.onConflict === 'merge') {
	              _utils['default'].deepMixIn(item, attrs);
	            } else if (options.onConflict === 'replace') {
	              _utils['default'].forOwn(item, function (v, k) {
	                if (k !== definition.idAttribute) {
	                  if (!attrs.hasOwnProperty(k)) {
	                    delete item[k];
	                  }
	                }
	              });
	              _utils['default'].forOwn(attrs, function (v, k) {
	                if (k !== definition.idAttribute) {
	                  item[k] = v;
	                }
	              });
	            }

	            if (definition.resetHistoryOnInject) {
	              // clear change history for item
	              _this.commit(definition.name, id);
	            }
	            if (resource.observers[id] && typeof resource.observers[id] === 'function') {
	              // force observation callback to be fired if there are any changes to the item and `Object.observe` is not available
	              resource.observers[id].deliver();
	            }
	          }
	          // update modified timestamp of item
	          resource.modified[id] = initialLastModified && resource.modified[id] === initialLastModified ? _utils['default'].updateTimestamp(resource.modified[id]) : resource.modified[id];

	          // reset expiry tracking for item
	          resource.expiresHeap.remove(item);
	          var timestamp = new Date().getTime();
	          resource.expiresHeap.push({
	            item: item,
	            timestamp: timestamp,
	            expires: definition.maxAge ? timestamp + definition.maxAge : Number.MAX_VALUE
	          });

	          // final injected item
	          injected = item;
	        })();
	      } catch (err) {
	        options.errorFn(err, attrs);
	      }
	    }
	  }
	  return injected;
	}

	/**
	 * Inject the given object or array of objects into the data store.
	 *
	 * @param resourceName The name of the type of resource of the data to be injected.
	 * @param attrs Object or array of objects. Objects must contain a primary key.
	 * @param options Optional configuration.
	 * @param options.notify Whether to emit the "DS.beforeInject" and "DS.afterInject" events.
	 * @returns The injected data.
	 */
	module.exports = function inject(resourceName, attrs, options) {
	  var _this = this;
	  var definition = _this.definitions[resourceName];
	  var resource = _this.store[resourceName];
	  var injected = undefined;

	  if (!definition) {
	    throw new _errors['default'].NER(resourceName);
	  } else if (!_utils['default']._o(attrs) && !_utils['default']._a(attrs)) {
	    throw new _errors['default'].IA(resourceName + '.inject: "attrs" must be an object or an array!');
	  }

	  options = _utils['default']._(definition, options);

	  // lifecycle
	  options.beforeInject(options, attrs);
	  if (options.notify) {
	    definition.emit('DS.beforeInject', definition, attrs);
	  }

	  // start the recursive injection of data
	  injected = _inject.call(_this, definition, resource, attrs, options);

	  // collection was modified
	  definition.handleChange(injected);

	  // lifecycle
	  options.afterInject(options, injected);
	  if (options.notify) {
	    definition.emit('DS.afterInject', definition, injected);
	  }

	  return injected;
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	exports['default'] = {
	  create: __webpack_require__(37),
	  destroy: __webpack_require__(38),
	  destroyAll: __webpack_require__(39),
	  find: __webpack_require__(40),
	  findAll: __webpack_require__(41),
	  loadRelations: __webpack_require__(42),
	  reap: __webpack_require__(43),
	  refresh: function refresh(resourceName, id, options) {
	    var _this = this;
	    var DSUtils = _this.utils;

	    return new DSUtils.Promise(function (resolve, reject) {
	      var definition = _this.definitions[resourceName];
	      id = DSUtils.resolveId(_this.definitions[resourceName], id);
	      if (!definition) {
	        reject(new _this.errors.NER(resourceName));
	      } else if (!DSUtils._sn(id)) {
	        reject(DSUtils._snErr('id'));
	      } else {
	        options = DSUtils._(definition, options);
	        options.bypassCache = true;
	        resolve(_this.get(resourceName, id));
	      }
	    }).then(function (item) {
	      return item ? _this.find(resourceName, id, options) : item;
	    })['catch'](_this.errorFn('refresh', resourceName, id, options));
	  },
	  refreshAll: function refreshAll(resourceName, params, options) {
	    var _this = this;
	    var DSUtils = _this.utils;
	    var definition = _this.definitions[resourceName];
	    params = params || {};

	    return new DSUtils.Promise(function (resolve, reject) {
	      if (!definition) {
	        reject(new _this.errors.NER(resourceName));
	      } else if (!DSUtils._o(params)) {
	        reject(DSUtils._oErr('params'));
	      } else {
	        options = DSUtils._(definition, options);
	        options.bypassCache = true;
	        resolve(_this.filter(resourceName, params, options));
	      }
	    }).then(function (existing) {
	      options.bypassCache = true;
	      return _this.findAll(resourceName, params, options).then(function (found) {
	        DSUtils.forEach(existing, function (item) {
	          if (found.indexOf(item) === -1) {
	            definition.eject(item);
	          }
	        });
	        return found;
	      });
	    })['catch'](_this.errorFn('refreshAll', resourceName, params, options));
	  },
	  save: __webpack_require__(44),
	  update: __webpack_require__(45),
	  updateAll: __webpack_require__(46)
	};

/***/ },
/* 37 */
/***/ function(module, exports) {

	/**
	 * Using an adapter, create a new item.
	 *
	 * Generally a primary key will NOT be provided in the properties hash,
	 * because the adapter's persistence layer should be generating one.
	 *
	 * @param resourceName The name of the type of resource of the new item.
	 * @param attrs Hash of properties with which to create the new item.
	 * @param options Optional configuration.
	 * @param options.cacheResponse Whether the newly created item as returned by the adapter should be injected into the data store.
	 * @param options.upsert If the properties hash contains a primary key, attempt to call DS#update instead.
	 * @param options.notify Whether to emit the "DS.beforeCreate" and "DS.afterCreate" events.
	 * @param options.beforeValidate Lifecycle hook.
	 * @param options.validate Lifecycle hook.
	 * @param options.afterValidate Lifecycle hook.
	 * @param options.beforeCreate Lifecycle hook.
	 * @param options.afterCreate Lifecycle hook.
	 */
	module.exports = function create(resourceName, attrs, options) {
	  var _this = this;
	  var DSUtils = _this.utils;
	  var definition = _this.definitions[resourceName];
	  var adapter = undefined;

	  options = options || {};
	  attrs = attrs || {};

	  var rejectionError = undefined;
	  if (!definition) {
	    rejectionError = new _this.errors.NER(resourceName);
	  } else if (!DSUtils._o(attrs)) {
	    rejectionError = DSUtils._oErr('attrs');
	  } else {
	    options = DSUtils._(definition, options);
	    if (options.upsert && DSUtils._sn(attrs[definition.idAttribute])) {
	      return _this.update(resourceName, attrs[definition.idAttribute], attrs, options);
	    }
	  }

	  return new DSUtils.Promise(function (resolve, reject) {
	    if (rejectionError) {
	      reject(rejectionError);
	    } else {
	      resolve(attrs);
	    }
	  })
	  // start lifecycle
	  .then(function (attrs) {
	    return options.beforeValidate.call(attrs, options, attrs);
	  }).then(function (attrs) {
	    return options.validate.call(attrs, options, attrs);
	  }).then(function (attrs) {
	    return options.afterValidate.call(attrs, options, attrs);
	  }).then(function (attrs) {
	    return options.beforeCreate.call(attrs, options, attrs);
	  }).then(function (attrs) {
	    if (options.notify) {
	      definition.emit('DS.beforeCreate', definition, attrs);
	    }
	    adapter = _this.getAdapterName(options);
	    return _this.adapters[adapter].create(definition, DSUtils.omit(attrs, options.omit), options);
	  }).then(function (attrs) {
	    return options.afterCreate.call(attrs, options, attrs);
	  }).then(function (attrs) {
	    if (options.notify) {
	      definition.emit('DS.afterCreate', definition, attrs);
	    }
	    if (options.cacheResponse) {
	      // injected created intem into the store
	      var created = _this.inject(definition.name, attrs, options.orig());
	      var id = created[definition.idAttribute];
	      // mark item's `find` query as completed, so a subsequent `find` call for this item will resolve immediately
	      var resource = _this.store[resourceName];
	      resource.completedQueries[id] = new Date().getTime();
	      resource.saved[id] = DSUtils.updateTimestamp(resource.saved[id]);
	      return created;
	    } else {
	      // just return an un-injected instance
	      return _this.createInstance(resourceName, attrs, options);
	    }
	  }).then(function (item) {
	    return DSUtils.respond(item, { adapter: adapter }, options);
	  })['catch'](_this.errorFn('create', resourceName, attrs, options));
	};

/***/ },
/* 38 */
/***/ function(module, exports) {

	/**
	 * Using an adapter, destroy an item.
	 *
	 * @param resourceName The name of the type of resource of the item to destroy.
	 * @param id The primary key of the item to destroy.
	 * @param options Optional configuration.
	 * @param options.eagerEject Whether to eject the item from the store before the adapter operation completes, re-injecting if the adapter operation fails.
	 * @param options.notify Whether to emit the "DS.beforeDestroy" and "DS.afterDestroy" events.
	 * @param options.beforeDestroy Lifecycle hook.
	 * @param options.afterDestroy Lifecycle hook.
	 * @returns The primary key of the destroyed item.
	 */
	module.exports = function destroy(resourceName, id, options) {
	  var _this = this;
	  var DSUtils = _this.utils;
	  var definition = _this.definitions[resourceName];
	  var item = undefined,
	      adapter = undefined;

	  return new DSUtils.Promise(function (resolve, reject) {
	    id = DSUtils.resolveId(definition, id);
	    if (!definition) {
	      reject(new _this.errors.NER(resourceName));
	    } else if (!DSUtils._sn(id)) {
	      reject(DSUtils._snErr('id'));
	    } else {
	      // check if the item is in the store
	      item = definition.get(id) || { id: id };
	      options = DSUtils._(definition, options);
	      resolve(item);
	    }
	  })
	  // start lifecycle
	  .then(function (attrs) {
	    return options.beforeDestroy.call(attrs, options, attrs);
	  }).then(function (attrs) {
	    if (options.notify) {
	      definition.emit('DS.beforeDestroy', definition, attrs);
	    }
	    // don't wait for the adapter, remove the item from the store
	    if (options.eagerEject) {
	      definition.eject(id);
	    }
	    adapter = definition.getAdapter(options);
	    return adapter.destroy(definition, id, options);
	  }).then(function () {
	    return options.afterDestroy.call(item, options, item);
	  }).then(function (item) {
	    if (options.notify) {
	      definition.emit('DS.afterDestroy', definition, item);
	    }
	    // make sure the item is removed from the store
	    definition.eject(id);
	    return DSUtils.respond(id, { adapter: adapter }, options);
	  })['catch'](function (err) {
	    // rollback by re-injecting the item into the store
	    if (options && options.eagerEject && item) {
	      definition.inject(item, { notify: false });
	    }
	    return _this.errorFn('destroy', resourceName, id, options)(err);
	  });
	};

/***/ },
/* 39 */
/***/ function(module, exports) {

	/**
	 * Using an adapter, destroy an item.
	 *
	 * @param resourceName The name of the type of resource of the item to destroy.
	 * @param params The criteria by which to filter items to destroy. See http://www.js-data.io/docs/query-syntax
	 * @param options Optional configuration.
	 * @param options.eagerEject Whether to eject the items from the store before the adapter operation completes, re-injecting if the adapter operation fails.
	 * @param options.notify Whether to emit the "DS.beforeDestroy" and "DS.afterDestroy" events.
	 * @param options.beforeDestroy Lifecycle hook.
	 * @param options.afterDestroy Lifecycle hook.
	 * @returns The ejected items, if any.
	 */
	module.exports = function destroyAll(resourceName, params, options) {
	  var _this = this;
	  var DSUtils = _this.utils;
	  var definition = _this.definitions[resourceName];
	  var ejected = undefined,
	      toEject = undefined,
	      adapter = undefined;

	  params = params || {};

	  return new DSUtils.Promise(function (resolve, reject) {
	    if (!definition) {
	      reject(new _this.errors.NER(resourceName));
	    } else if (!DSUtils._o(params)) {
	      reject(DSUtils._oErr('attrs'));
	    } else {
	      options = DSUtils._(definition, options);
	      DSUtils.applyScope(definition, params, options);
	      resolve();
	    }
	  }).then(function () {
	    // find items that are to be ejected from the store
	    toEject = definition.defaultFilter.call(_this, resourceName, params);
	    return options.beforeDestroy(options, toEject);
	  }).then(function () {
	    if (options.notify) {
	      definition.emit('DS.beforeDestroy', definition, toEject);
	    }
	    // don't wait for the adapter, remove the items from the store
	    if (options.eagerEject) {
	      ejected = definition.ejectAll(params);
	    }
	    adapter = definition.getAdapterName(options);
	    return _this.adapters[adapter].destroyAll(definition, params, options);
	  }).then(function () {
	    return options.afterDestroy(options, toEject);
	  }).then(function () {
	    if (options.notify) {
	      definition.emit('DS.afterDestroy', definition, toEject);
	    }
	    // make sure items are removed from the store
	    return ejected || definition.ejectAll(params);
	  }).then(function (items) {
	    return DSUtils.respond(items, { adapter: adapter }, options);
	  })['catch'](function (err) {
	    // rollback by re-injecting the items into the store
	    if (options && options.eagerEject && ejected) {
	      definition.inject(ejected, { notify: false });
	    }
	    return _this.errorFn('destroyAll', resourceName, params, options)(err);
	  });
	};

/***/ },
/* 40 */
/***/ function(module, exports) {

	/* jshint -W082 */

	/**
	 * Using an adapter, retrieve a single item.
	 *
	 * @param resourceName The of the type of resource of the item to retrieve.
	 * @param id The primary key of the item to retrieve.
	 * @param options Optional configuration.
	 * @param options.bypassCache Whether to ignore any cached item and force the retrieval through the adapter.
	 * @param options.cacheResponse Whether to inject the found item into the data store.
	 * @param options.strictCache Whether to only consider items to be "cached" if they were injected into the store as the result of `find` or `findAll`.
	 * @param options.strategy The retrieval strategy to use.
	 * @param options.findStrategy The retrieval strategy to use. Overrides "strategy".
	 * @param options.fallbackAdapters Array of names of adapters to use if using "fallback" strategy.
	 * @param options.findFallbackAdapters Array of names of adapters to use if using "fallback" strategy. Overrides "fallbackAdapters".
	 * @returns The item.
	 */
	module.exports = function find(resourceName, id, options) {
	  var _this = this;
	  var DSUtils = _this.utils;
	  var definition = _this.definitions[resourceName];
	  var resource = _this.store[resourceName];
	  var adapter = undefined;

	  return new DSUtils.Promise(function (resolve, reject) {
	    if (!definition) {
	      reject(new _this.errors.NER(resourceName));
	    } else if (!DSUtils._sn(id)) {
	      reject(DSUtils._snErr('id'));
	    } else {
	      options = DSUtils._(definition, options);

	      if (options.params) {
	        options.params = DSUtils.copy(options.params);
	      }

	      if (options.bypassCache || !options.cacheResponse) {
	        delete resource.completedQueries[id];
	      }

	      var expired = options.maxAge && id in resource.completedQueries && resource.completedQueries[id] + options.maxAge < new Date().getTime();

	      if ((!options.findStrictCache || id in resource.completedQueries) && definition.get(id) && !options.bypassCache && !expired) {
	        // resolve immediately with the cached item
	        resolve(definition.get(id));
	      } else {
	        // we're going to delegate to the adapter next
	        delete resource.completedQueries[id];
	        resolve();
	      }
	    }
	  }).then(function (item) {
	    if (!item) {
	      if (!(id in resource.pendingQueries)) {
	        var promise = undefined;
	        var strategy = options.findStrategy || options.strategy;

	        // try subsequent adapters if the preceeding one fails
	        if (strategy === 'fallback') {
	          var makeFallbackCall = function makeFallbackCall(index) {
	            adapter = definition.getAdapterName((options.findFallbackAdapters || options.fallbackAdapters)[index]);
	            return _this.adapters[adapter].find(definition, id, options)['catch'](function (err) {
	              index++;
	              if (index < options.fallbackAdapters.length) {
	                return makeFallbackCall(index);
	              } else {
	                return DSUtils.Promise.reject(err);
	              }
	            });
	          };

	          promise = makeFallbackCall(0);
	        } else {
	          adapter = definition.getAdapterName(options);
	          // just make a single attempt
	          promise = _this.adapters[adapter].find(definition, id, options);
	        }

	        resource.pendingQueries[id] = promise.then(function (data) {
	          return options.afterFind.call(data, options, data);
	        }).then(function (data) {
	          // Query is no longer pending
	          delete resource.pendingQueries[id];
	          if (options.cacheResponse) {
	            // inject the item into the data store
	            var injected = definition.inject(data, options.orig());
	            // mark the item as "cached"
	            resource.completedQueries[id] = new Date().getTime();
	            resource.saved[id] = DSUtils.updateTimestamp(resource.saved[id]);
	            return injected;
	          } else {
	            // just return an un-injected instance
	            return definition.createInstance(data, options.orig());
	          }
	        });
	      }
	      return resource.pendingQueries[id];
	    } else {
	      // resolve immediately with the item
	      return item;
	    }
	  }).then(function (item) {
	    return DSUtils.respond(item, { adapter: adapter }, options);
	  })['catch'](function (err) {
	    if (resource) {
	      delete resource.pendingQueries[id];
	    }
	    return _this.errorFn('find', resourceName, id, options)(err);
	  });
	};

/***/ },
/* 41 */
/***/ function(module, exports) {

	/* jshint -W082 */
	function processResults(data, resourceName, queryHash, options) {
	  var _this = this;
	  var DSUtils = _this.utils;
	  var definition = _this.definitions[resourceName];
	  var resource = _this.store[resourceName];
	  var idAttribute = _this.definitions[resourceName].idAttribute;
	  var date = new Date().getTime();

	  data = data || [];

	  // Query is no longer pending
	  delete resource.pendingQueries[queryHash];
	  resource.completedQueries[queryHash] = date;

	  // Merge the new values into the cache
	  var injected = definition.inject(data, options.orig());

	  // Make sure each object is added to completedQueries
	  if (DSUtils._a(injected)) {
	    DSUtils.forEach(injected, function (item) {
	      if (item) {
	        var id = item[idAttribute];
	        if (id) {
	          resource.completedQueries[id] = date;
	          resource.saved[id] = DSUtils.updateTimestamp(resource.saved[id]);
	        }
	      }
	    });
	  } else {
	    options.errorFn('response is expected to be an array!');
	    resource.completedQueries[injected[idAttribute]] = date;
	  }

	  return injected;
	}

	/**
	 * Using an adapter, retrieve a collection of items.
	 *
	 * @param resourceName The name of the type of resource of the items to retrieve.
	 * @param params The criteria by which to filter items to retrieve. See http://www.js-data.io/docs/query-syntax
	 * @param options Optional configuration.
	 * @param options.bypassCache Whether to ignore any cached query for these items and force the retrieval through the adapter.
	 * @param options.cacheResponse Whether to inject the found items into the data store.
	 * @returns The items.
	 */
	module.exports = function findAll(resourceName, params, options) {
	  var _this = this;
	  var DSUtils = _this.utils;
	  var definition = _this.definitions[resourceName];
	  var resource = _this.store[resourceName];
	  var queryHash = undefined,
	      adapter = undefined;

	  return new DSUtils.Promise(function (resolve, reject) {
	    params = params || {};

	    if (!_this.definitions[resourceName]) {
	      reject(new _this.errors.NER(resourceName));
	    } else if (!DSUtils._o(params)) {
	      reject(DSUtils._oErr('params'));
	    } else {
	      options = DSUtils._(definition, options);
	      queryHash = DSUtils.toJson(params);

	      if (options.params) {
	        options.params = DSUtils.copy(options.params);
	      }

	      DSUtils.applyScope(definition, params, options);

	      // force a new request
	      if (options.bypassCache || !options.cacheResponse) {
	        delete resource.completedQueries[queryHash];
	        delete resource.queryData[queryHash];
	      }

	      var expired = options.maxAge && queryHash in resource.completedQueries && resource.completedQueries[queryHash] + options.maxAge < new Date().getTime();

	      if (queryHash in resource.completedQueries && !expired) {
	        if (options.useFilter) {
	          if (options.localKeys) {
	            resolve(definition.getAll(options.localKeys, options.orig()));
	          } else {
	            // resolve immediately by filtering data from the data store
	            resolve(definition.filter(params, options.orig()));
	          }
	        } else {
	          // resolve immediately by returning the cached array from the previously made query
	          resolve(resource.queryData[queryHash]);
	        }
	      } else {
	        resolve();
	      }
	    }
	  }).then(function (items) {
	    if (!items) {
	      if (!(queryHash in resource.pendingQueries)) {
	        var promise = undefined;
	        var strategy = options.findAllStrategy || options.strategy;

	        // try subsequent adapters if the preceeding one fails
	        if (strategy === 'fallback') {
	          var makeFallbackCall = function makeFallbackCall(index) {
	            adapter = definition.getAdapterName((options.findAllFallbackAdapters || options.fallbackAdapters)[index]);
	            return _this.adapters[adapter].findAll(definition, params, options)['catch'](function (err) {
	              index++;
	              if (index < options.fallbackAdapters.length) {
	                return makeFallbackCall(index);
	              } else {
	                return DSUtils.Promise.reject(err);
	              }
	            });
	          };

	          promise = makeFallbackCall(0);
	        } else {
	          adapter = definition.getAdapterName(options);
	          // just make a single attempt
	          promise = _this.adapters[adapter].findAll(definition, params, options);
	        }

	        resource.pendingQueries[queryHash] = promise.then(function (data) {
	          return options.afterFindAll.call(data, options, data);
	        }).then(function (data) {
	          // Query is no longer pending
	          delete resource.pendingQueries[queryHash];
	          if (options.cacheResponse) {
	            // inject the items into the data store
	            resource.queryData[queryHash] = processResults.call(_this, data, resourceName, queryHash, options);
	            resource.queryData[queryHash].$$injected = true;
	            return resource.queryData[queryHash];
	          } else {
	            DSUtils.forEach(data, function (item, i) {
	              data[i] = definition.createInstance(item, options.orig());
	            });
	            return data;
	          }
	        });
	      }

	      return resource.pendingQueries[queryHash];
	    } else {
	      // resolve immediately with the items
	      return items;
	    }
	  }).then(function (items) {
	    return DSUtils.respond(items, { adapter: adapter }, options);
	  })['catch'](function (err) {
	    if (resource) {
	      delete resource.pendingQueries[queryHash];
	    }
	    return _this.errorFn('findAll', resourceName, params, options)(err);
	  });
	};

/***/ },
/* 42 */
/***/ function(module, exports) {

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	/**
	 * Load the specified relations for the given instance.
	 *
	 * @param resourceName The name of the type of resource of the instance for which to load relations.
	 * @param instance The instance or the primary key of the instance.
	 * @param relations An array of the relations to load.
	 * @param options Optional configuration.
	 * @returns The instance, now with its relations loaded.
	 */
	module.exports = function loadRelations(resourceName, instance, relations, options) {
	  var _this = this;
	  var DSUtils = _this.utils;
	  var DSErrors = _this.errors;

	  var definition = _this.definitions[resourceName];
	  var _options = undefined;

	  return new DSUtils.Promise(function (resolve, reject) {
	    if (DSUtils._sn(instance)) {
	      instance = definition.get(instance);
	    }

	    if (DSUtils._s(relations)) {
	      relations = [relations];
	    }

	    relations = relations || [];

	    if (!definition) {
	      reject(new DSErrors.NER(resourceName));
	    } else if (!DSUtils._o(instance)) {
	      reject(new DSErrors.IA('"instance(id)" must be a string, number or object!'));
	    } else if (!DSUtils._a(relations)) {
	      reject(new DSErrors.IA('"relations" must be a string or an array!'));
	    } else {
	      (function () {
	        _options = DSUtils._(definition, options);

	        var tasks = [];

	        DSUtils.forEach(definition.relationList, function (def) {
	          var relationName = def.relation;
	          var relationDef = definition.getResource(relationName);
	          var __options = DSUtils._(relationDef, options);

	          // relations can be loaded based on resource name or field name
	          if (!relations.length || DSUtils.contains(relations, relationName) || DSUtils.contains(relations, def.localField)) {
	            var task = undefined;
	            var params = {};
	            if (__options.allowSimpleWhere) {
	              params[def.foreignKey] = instance[definition.idAttribute];
	            } else {
	              params.where = {};
	              params.where[def.foreignKey] = {
	                '==': instance[definition.idAttribute]
	              };
	            }

	            var orig = __options.orig();
	            var defKey = def.localKey ? DSUtils.get(instance, def.localKey) : null;
	            var hasDefKey = !!(defKey || defKey === 0);

	            if (typeof def.load === 'function') {
	              task = def.load(definition, def, instance, orig);
	            } else {
	              if (def.type === 'hasMany') {
	                if (def.localKeys) {
	                  delete params[def.foreignKey];
	                  var keys = DSUtils.get(instance, def.localKeys) || [];
	                  keys = DSUtils._a(keys) ? keys : DSUtils.keys(keys);
	                  params.where = _defineProperty({}, relationDef.idAttribute, {
	                    'in': keys
	                  });
	                  orig.localKeys = keys;
	                } else if (def.foreignKeys) {
	                  delete params[def.foreignKey];
	                  params.where = _defineProperty({}, def.foreignKeys, {
	                    contains: instance[definition.idAttribute]
	                  });
	                }
	                task = relationDef.findAll(params, orig);
	              } else if (def.type === 'hasOne') {
	                if (def.localKey && hasDefKey) {
	                  task = relationDef.find(defKey, orig);
	                } else if (def.foreignKey) {
	                  task = relationDef.findAll(params, orig).then(function (hasOnes) {
	                    return hasOnes.length ? hasOnes[0] : null;
	                  });
	                }
	              } else if (hasDefKey) {
	                task = relationDef.find(defKey, orig);
	              }
	            }

	            if (task) {
	              if (!_options.linkRelations) {
	                task = task.then(function (data) {
	                  instance[def.localField] = data;
	                });
	              }
	              tasks.push(task);
	            }
	          }
	        });

	        resolve(tasks);
	      })();
	    }
	  }).then(function (tasks) {
	    return DSUtils.Promise.all(tasks);
	  }).then(function () {
	    return _options.afterLoadRelations.call(instance, _options, instance);
	  })['catch'](_this.errorFn('loadRelations', resourceName, instance, relations, options));
	};

/***/ },
/* 43 */
/***/ function(module, exports) {

	/**
	 * Find expired items of the specified resource type and perform the configured action.
	 *
	 * @param resourceName The name of the type of resource of the items to reap.
	 * @param options Optional configuration.
	 * @returns The reaped items.
	 */
	module.exports = function reap(resourceName, options) {
	  var _this = this;
	  var DSUtils = _this.utils;
	  var definition = _this.definitions[resourceName];
	  var resource = _this.store[resourceName];

	  return new DSUtils.Promise(function (resolve, reject) {
	    if (!definition) {
	      reject(new _this.errors.NER(resourceName));
	    } else {
	      options = DSUtils._(definition, options);
	      if (!options.hasOwnProperty('notify')) {
	        options.notify = false;
	      }
	      var items = [];
	      var now = new Date().getTime();
	      var expiredItem = undefined;

	      // find the expired items
	      while ((expiredItem = resource.expiresHeap.peek()) && expiredItem.expires < now) {
	        items.push(expiredItem.item);
	        delete expiredItem.item;
	        resource.expiresHeap.pop();
	      }
	      resolve(items);
	    }
	  }).then(function (items) {
	    // only hit lifecycle if there are items
	    if (items.length) {
	      definition.beforeReap(options, items);
	      if (options.notify) {
	        definition.emit('DS.beforeReap', definition, items);
	      }
	    }

	    if (options.reapAction === 'inject') {
	      (function () {
	        var timestamp = new Date().getTime();
	        DSUtils.forEach(items, function (item) {
	          resource.expiresHeap.push({
	            item: item,
	            timestamp: timestamp,
	            expires: definition.maxAge ? timestamp + definition.maxAge : Number.MAX_VALUE
	          });
	        });
	      })();
	    } else if (options.reapAction === 'eject') {
	      DSUtils.forEach(items, function (item) {
	        definition.eject(item[definition.idAttribute]);
	      });
	    } else if (options.reapAction === 'refresh') {
	      var _ret2 = (function () {
	        var tasks = [];
	        DSUtils.forEach(items, function (item) {
	          tasks.push(definition.refresh(item[definition.idAttribute]));
	        });
	        return {
	          v: DSUtils.Promise.all(tasks)
	        };
	      })();

	      if (typeof _ret2 === 'object') return _ret2.v;
	    }
	    return items;
	  }).then(function (items) {
	    // only hit lifecycle if there are items
	    if (items.length) {
	      definition.afterReap(options, items);
	      if (options.notify) {
	        definition.emit('DS.afterReap', definition, items);
	      }
	    }
	    return items;
	  })['catch'](_this.errorFn('reap', resourceName, options));
	};

/***/ },
/* 44 */
/***/ function(module, exports) {

	/**
	 * Save a single item in its present state.
	 *
	 * @param resourceName The name of the type of resource of the item.
	 * @param id The primary key of the item.
	 * @param options Optional congifuration.
	 * @returns The item, now saved.
	 */
	module.exports = function save(resourceName, id, options) {
	  var _this = this;
	  var DSUtils = _this.utils;
	  var DSErrors = _this.errors;

	  var definition = _this.definitions[resourceName];
	  var resource = _this.store[resourceName];
	  var item = undefined,
	      noChanges = undefined,
	      adapter = undefined;

	  return new DSUtils.Promise(function (resolve, reject) {
	    id = DSUtils.resolveId(definition, id);
	    if (!definition) {
	      reject(new DSErrors.NER(resourceName));
	    } else if (!DSUtils._sn(id)) {
	      reject(DSUtils._snErr('id'));
	    } else if (!definition.get(id)) {
	      reject(new DSErrors.R('id "' + id + '" not found in cache!'));
	    } else {
	      item = definition.get(id);
	      options = DSUtils._(definition, options);
	      resolve(item);
	    }
	  })
	  // start lifecycle
	  .then(function (attrs) {
	    return options.beforeValidate.call(attrs, options, attrs);
	  }).then(function (attrs) {
	    return options.validate.call(attrs, options, attrs);
	  }).then(function (attrs) {
	    return options.afterValidate.call(attrs, options, attrs);
	  }).then(function (attrs) {
	    return options.beforeUpdate.call(attrs, options, attrs);
	  }).then(function (attrs) {
	    if (options.notify) {
	      definition.emit('DS.beforeUpdate', definition, attrs);
	    }
	    // only send changed properties to the adapter
	    if (options.changesOnly) {
	      if (resource.observers[id] && typeof resource.observers[id] === 'function') {
	        resource.observers[id].deliver();
	      }
	      var toKeep = [];
	      var changes = definition.changes(id);

	      for (var key in changes.added) {
	        toKeep.push(key);
	      }
	      for (key in changes.changed) {
	        toKeep.push(key);
	      }
	      changes = DSUtils.pick(attrs, toKeep);
	      // no changes? no save
	      if (DSUtils.isEmpty(changes)) {
	        // no changes, return
	        noChanges = true;
	        return attrs;
	      } else {
	        attrs = changes;
	      }
	    }
	    adapter = definition.getAdapterName(options);
	    return _this.adapters[adapter].update(definition, id, DSUtils.omit(attrs, options.omit), options);
	  }).then(function (data) {
	    return options.afterUpdate.call(data, options, data);
	  }).then(function (attrs) {
	    if (options.notify) {
	      definition.emit('DS.afterUpdate', definition, attrs);
	    }
	    if (noChanges) {
	      // no changes, just return
	      return attrs;
	    } else if (options.cacheResponse) {
	      // inject the reponse into the store, updating the item
	      var injected = definition.inject(attrs, options.orig());
	      var _id = injected[definition.idAttribute];
	      // mark the item as "saved"
	      resource.saved[_id] = DSUtils.updateTimestamp(resource.saved[_id]);
	      if (!definition.resetHistoryOnInject) {
	        resource.previousAttributes[_id] = DSUtils.copy(injected, null, null, null, definition.relationFields);
	      }
	      return injected;
	    } else {
	      // just return an instance
	      return definition.createInstance(attrs, options.orig());
	    }
	  }).then(function (item) {
	    return DSUtils.respond(item, { adapter: adapter }, options);
	  })['catch'](_this.errorFn('save', resourceName, id, options));
	};

/***/ },
/* 45 */
/***/ function(module, exports) {

	/**
	 * Update a single item using the supplied properties hash.
	 *
	 * @param resourceName The name of the type of resource of the item to update.
	 * @param id The primary key of the item to update.
	 * @param attrs The attributes with which to update the item.
	 * @param options Optional configuration.
	 * @returns The item, now updated.
	 */
	module.exports = function update(resourceName, id, attrs, options) {
	  var _this = this;
	  var DSUtils = _this.utils;
	  var DSErrors = _this.errors;

	  var definition = _this.definitions[resourceName];
	  var adapter = undefined;

	  return new DSUtils.Promise(function (resolve, reject) {
	    id = DSUtils.resolveId(definition, id);
	    if (!definition) {
	      reject(new DSErrors.NER(resourceName));
	    } else if (!DSUtils._sn(id)) {
	      reject(DSUtils._snErr('id'));
	    } else {
	      options = DSUtils._(definition, options);
	      resolve(attrs);
	    }
	  })
	  // start lifecycle
	  .then(function (attrs) {
	    return options.beforeValidate.call(attrs, options, attrs);
	  }).then(function (attrs) {
	    return options.validate.call(attrs, options, attrs);
	  }).then(function (attrs) {
	    return options.afterValidate.call(attrs, options, attrs);
	  }).then(function (attrs) {
	    return options.beforeUpdate.call(attrs, options, attrs);
	  }).then(function (attrs) {
	    if (options.notify) {
	      definition.emit('DS.beforeUpdate', definition, attrs);
	    }
	    adapter = definition.getAdapterName(options);
	    return _this.adapters[adapter].update(definition, id, DSUtils.omit(attrs, options.omit), options);
	  }).then(function (data) {
	    return options.afterUpdate.call(data, options, data);
	  }).then(function (attrs) {
	    if (options.notify) {
	      definition.emit('DS.afterUpdate', definition, attrs);
	    }
	    if (options.cacheResponse) {
	      // inject the updated item into the store
	      var injected = definition.inject(attrs, options.orig());
	      var resource = _this.store[resourceName];
	      var _id = injected[definition.idAttribute];
	      // mark the item as "saved"
	      resource.saved[_id] = DSUtils.updateTimestamp(resource.saved[_id]);
	      if (!definition.resetHistoryOnInject) {
	        resource.previousAttributes[_id] = DSUtils.copy(injected, null, null, null, definition.relationFields);
	      }
	      return injected;
	    } else {
	      // just return an instance
	      return definition.createInstance(attrs, options.orig());
	    }
	  }).then(function (item) {
	    return DSUtils.respond(item, { adapter: adapter }, options);
	  })['catch'](_this.errorFn('update', resourceName, id, attrs, options));
	};

/***/ },
/* 46 */
/***/ function(module, exports) {

	/**
	 * Update a collection of items using the supplied properties hash.
	 *
	 * @param resourceName The name of the type of resource of the items to update.
	 * @param attrs  The attributes with which to update the item.
	 * @param params The criteria by which to select items to update. See http://www.js-data.io/docs/query-syntax
	 * @param options Optional configuration.
	 * @returns The updated items.
	 */
	module.exports = function updateAll(resourceName, attrs, params, options) {
	  var _this = this;
	  var DSUtils = _this.utils;
	  var DSErrors = _this.errors;

	  var definition = _this.definitions[resourceName];
	  var adapter = undefined;

	  return new DSUtils.Promise(function (resolve, reject) {
	    if (!definition) {
	      reject(new DSErrors.NER(resourceName));
	    } else {
	      options = DSUtils._(definition, options);
	      DSUtils.applyScope(definition, params, options);
	      resolve(attrs);
	    }
	  })
	  // start lifecycle
	  .then(function (attrs) {
	    return options.beforeValidate.call(attrs, options, attrs);
	  }).then(function (attrs) {
	    return options.validate.call(attrs, options, attrs);
	  }).then(function (attrs) {
	    return options.afterValidate.call(attrs, options, attrs);
	  }).then(function (attrs) {
	    return options.beforeUpdate.call(attrs, options, attrs);
	  }).then(function (attrs) {
	    if (options.notify) {
	      definition.emit('DS.beforeUpdate', definition, attrs);
	    }
	    adapter = definition.getAdapterName(options);
	    return _this.adapters[adapter].updateAll(definition, DSUtils.omit(attrs, options.omit), params, options);
	  }).then(function (data) {
	    return options.afterUpdate.call(data, options, data);
	  }).then(function (data) {
	    if (options.notify) {
	      definition.emit('DS.afterUpdate', definition, attrs);
	    }
	    var origOptions = options.orig();
	    if (options.cacheResponse) {
	      var _ret = (function () {
	        // inject the updated items into the store
	        var injected = definition.inject(data, origOptions);
	        var resource = _this.store[resourceName];
	        // mark the items as "saved"
	        DSUtils.forEach(injected, function (i) {
	          var id = i[definition.idAttribute];
	          resource.saved[id] = DSUtils.updateTimestamp(resource.saved[id]);
	          if (!definition.resetHistoryOnInject) {
	            resource.previousAttributes[id] = DSUtils.copy(i, null, null, null, definition.relationFields);
	          }
	        });
	        return {
	          v: injected
	        };
	      })();

	      if (typeof _ret === 'object') return _ret.v;
	    } else {
	      var _ret2 = (function () {
	        // just return instances
	        var instances = [];
	        DSUtils.forEach(data, function (item) {
	          instances.push(definition.createInstance(item, origOptions));
	        });
	        return {
	          v: instances
	        };
	      })();

	      if (typeof _ret2 === 'object') return _ret2.v;
	    }
	  }).then(function (items) {
	    return DSUtils.respond(items, { adapter: adapter }, options);
	  })['catch'](_this.errorFn('updateAll', resourceName, attrs, params, options));
	};

/***/ }
/******/ ])
});
;
;
/*!
 * js-data-angular
 * @version 3.1.0 - Homepage <https://www.js-data.io/docs/js-data-angular/>
 * @author Jason Dobry <jason.dobry@gmail.com>
 * @copyright (c) 2014-2015 Jason Dobry 
 * @license MIT <https://github.com/js-data/js-data-angular/blob/master/LICENSE>
 * 
 * @overview Angular wrapper for js-data.
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("js-data"), require("angular"), (function webpackLoadOptionalExternalModule() { try { return require("axios"); } catch(e) {} }()));
	else if(typeof define === 'function' && define.amd)
		define(["js-data", "angular"], function webpackLoadOptionalExternalModuleAmd(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_4__) {
			return factory(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_4__, root["axios"]);
		});
	else if(typeof exports === 'object')
		exports["jsDataAngularModuleName"] = factory(require("js-data"), require("angular"), (function webpackLoadOptionalExternalModule() { try { return require("axios"); } catch(e) {} }()));
	else
		root["jsDataAngularModuleName"] = factory(root["JSData"], root["angular"], root["axios"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	/* jshint loopfunc:true */
	var JSData = __webpack_require__(1);
	var DSHttpAdapter = __webpack_require__(2);
	var angular = __webpack_require__(4);

	var DSUtils = JSData.DSUtils;
	var DSErrors = JSData.DSErrors;
	var isString = DSUtils.isString;
	var isNumber = DSUtils.isNumber;
	var isObject = DSUtils.isObject;
	var set = DSUtils.set;
	var resolveId = DSUtils.resolveId;

	var adapters = [{
	  project: 'js-data-localstorage',
	  name: 'localstorage',
	  'class': 'DSLocalStorageAdapter'
	}, {
	  project: 'js-data-localforage',
	  name: 'localforage',
	  'class': 'DSLocalForageAdapter'
	}, {
	  project: 'js-data-firebase',
	  name: 'firebase',
	  'class': 'DSFirebaseAdapter'
	}, {
	  project: 'js-data-sql',
	  name: 'sql',
	  'class': 'DSSqlAdapter'
	}];

	var functionsToWrap = ['compute', 'digest', 'eject', 'inject'];

	function registerAdapter(adapter) {
	  var Adapter = undefined;

	  try {
	    Adapter = __webpack_require__(5)(adapter.project);
	  } catch (e) {}

	  if (!Adapter) {
	    Adapter = window[adapter['class']];
	  }

	  if (Adapter) {
	    adapter.loaded = true;
	    angular.module('js-data').provider(adapter['class'], function () {
	      var _this = this;
	      _this.defaults = {};
	      _this.$get = [function () {
	        return new Adapter(_this.defaults);
	      }];
	    });
	  }
	}

	var DSHttpAdapterProvider = function DSHttpAdapterProvider() {
	  _classCallCheck(this, DSHttpAdapterProvider);

	  var defaults = {};
	  this.defaults = defaults;

	  this.$get = ['$http', 'DS', function ($http, DS) {
	    defaults.http = defaults.http || $http;
	    var adapter = new DSHttpAdapter(defaults);
	    DS.registerAdapter('http', adapter, { 'default': true });
	    return adapter;
	  }];
	};

	var DSProvider = function DSProvider() {
	  _classCallCheck(this, DSProvider);

	  var _this = this;
	  var deps = [];

	  for (var i = 0; i < adapters.length; i++) {
	    if (adapters[i].loaded) {
	      deps.push(adapters[i]['class']);
	    }
	  }

	  _this.defaults = {};

	  JSData.DS.prototype.bindAll = function (resourceName, params, scope, expr, cb) {
	    var _this = this;

	    params = params || {};

	    if (!_this.definitions[resourceName]) {
	      throw new DSErrors.NER(resourceName);
	    } else if (!isObject(params)) {
	      throw new DSErrors.IA('"params" must be an object!');
	    } else if (!isObject(scope)) {
	      throw new DSErrors.IA('"scope" must be an object!');
	    } else if (!isString(expr)) {
	      throw new DSErrors.IA('"expr" must be a string!');
	    }

	    try {
	      return scope.$watch(function () {
	        return _this.lastModified(resourceName);
	      }, function () {
	        var items = _this.filter(resourceName, params);
	        set(scope, expr, items);
	        if (cb) {
	          cb(null, items);
	        }
	      });
	    } catch (err) {
	      if (cb) {
	        cb(err);
	      } else {
	        throw err;
	      }
	    }
	  };

	  JSData.DS.prototype.bindOne = function (resourceName, id, scope, expr, cb) {
	    var _this = this;

	    id = resolveId(_this.definitions[resourceName], id);
	    if (!_this.definitions[resourceName]) {
	      throw new DSErrors.NER(resourceName);
	    } else if (!isString(id) && !isNumber(id)) {
	      throw new DSErrors.IA('"id" must be a string or a number!');
	    } else if (!isObject(scope)) {
	      throw new DSErrors.IA('"scope" must be an object!');
	    } else if (!isString(expr)) {
	      throw new DSErrors.IA('"expr" must be a string!');
	    }

	    try {
	      return scope.$watch(function () {
	        return _this.lastModified(resourceName, id);
	      }, function () {
	        var item = _this.get(resourceName, id);
	        if (item) {
	          _this.compute(resourceName, id);
	        }
	        set(scope, expr, item);
	        if (cb) {
	          cb(null, item);
	        }
	      });
	    } catch (err) {
	      if (cb) {
	        cb(err);
	      } else {
	        throw err;
	      }
	    }
	  };

	  function load() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    var $rootScope = args[args.length - 2];
	    var $q = args[args.length - 1];
	    var store = new JSData.DS(_this.defaults);
	    var originals = {};

	    function QPromise(executor) {
	      var deferred = $q.defer();

	      try {
	        executor(angular.bind(deferred, deferred.resolve), angular.bind(deferred, deferred.reject));
	      } catch (err) {
	        deferred.reject(err);
	      }

	      return deferred.promise;
	    }

	    QPromise.all = $q.all;
	    QPromise.when = $q.when;
	    QPromise.reject = $q.reject;

	    DSUtils.Promise = QPromise;

	    // Register any adapters that have been loaded
	    if (args.length) {
	      for (var i = 0; i < args.length; i++) {
	        for (var j = 0; j < adapters.length; j++) {
	          if (adapters[j].loaded && !adapters[j].registered) {
	            adapters[j].registered = true;
	            store.registerAdapter(adapters[j].name, args[i]);
	            break;
	          }
	        }
	      }
	    }

	    // Wrap certain sync functions with $apply

	    var _loop = function () {
	      var name = functionsToWrap[k];
	      originals[name] = store[name];
	      store[name] = function () {
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          args[_key2] = arguments[_key2];
	        }

	        if (!$rootScope.$$phase) {
	          return $rootScope.$apply(function () {
	            return originals[name].apply(store, args);
	          });
	        }
	        return originals[name].apply(store, args);
	      };
	    };

	    for (var k = 0; k < functionsToWrap.length; k++) {
	      _loop();
	    }

	    // Hook into the digest loop
	    if (typeof Object.observe !== 'function' || typeof Array.observe !== 'function') {
	      $rootScope.$watch(function () {
	        return store.observe.Platform.performMicrotaskCheckpoint();
	      });
	    }

	    return store;
	  }

	  deps.push('$rootScope');
	  deps.push('$q');
	  deps.push(load);

	  _this.$get = deps;
	};

	angular.module('js-data', ['ng']).value('DSUtils', DSUtils).value('DSErrors', DSErrors).value('DSVersion', JSData.version).provider('DS', DSProvider).provider('DSHttpAdapter', DSHttpAdapterProvider).run(['DS', 'DSHttpAdapter', function (DS, DSHttpAdapter) {
	  DS.registerAdapter('http', DSHttpAdapter, { 'default': true });
	}]);

	for (var i = 0; i < adapters.length; i++) {
	  registerAdapter(adapters[i]);
	}

	// return the module name
	module.exports = 'js-data';
	module.exports.name = 'js-data';

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var JSData = __webpack_require__(1);
	var axios = null;

	try {
	  axios = __webpack_require__(3);
	} catch (e) {}

	var DSUtils = JSData.DSUtils;
	var deepMixIn = DSUtils.deepMixIn;
	var removeCircular = DSUtils.removeCircular;
	var copy = DSUtils.copy;
	var makePath = DSUtils.makePath;
	var isString = DSUtils.isString;
	var isNumber = DSUtils.isNumber;

	var Defaults = (function () {
	  function Defaults() {
	    _classCallCheck(this, Defaults);
	  }

	  _createClass(Defaults, [{
	    key: 'queryTransform',
	    value: function queryTransform(resourceConfig, params) {
	      return params;
	    }
	  }, {
	    key: 'deserialize',
	    value: function deserialize(resourceConfig, data) {
	      return data ? 'data' in data ? data.data : data : data;
	    }
	  }, {
	    key: 'serialize',
	    value: function serialize(resourceConfig, data) {
	      return data;
	    }
	  }, {
	    key: 'log',
	    value: function log() {}
	  }, {
	    key: 'error',
	    value: function error() {}
	  }]);

	  return Defaults;
	})();

	var defaultsPrototype = Defaults.prototype;

	defaultsPrototype.basePath = '';

	defaultsPrototype.forceTrailingSlash = '';

	defaultsPrototype.httpConfig = {};

	defaultsPrototype.verbsUseBasePath = false;

	var DSHttpAdapter = (function () {
	  function DSHttpAdapter(options) {
	    _classCallCheck(this, DSHttpAdapter);

	    options = options || {};
	    this.defaults = new Defaults();
	    if (console) {
	      this.defaults.log = function (a, b) {
	        return console[typeof console.info === 'function' ? 'info' : 'log'](a, b);
	      };
	    }
	    if (console) {
	      this.defaults.error = function (a, b) {
	        return console[typeof console.error === 'function' ? 'error' : 'log'](a, b);
	      };
	    }
	    deepMixIn(this.defaults, options);
	    this.http = options.http || axios;
	  }

	  _createClass(DSHttpAdapter, [{
	    key: 'getEndpoint',
	    value: function getEndpoint(resourceConfig, id, options) {
	      var _this2 = this;

	      options = options || {};
	      options.params = options.params || {};

	      var item = undefined;
	      var parentKey = resourceConfig.parentKey;
	      var endpoint = options.hasOwnProperty('endpoint') ? options.endpoint : resourceConfig.endpoint;
	      var parentField = resourceConfig.parentField;
	      var parentDef = resourceConfig.getResource(resourceConfig.parent);
	      var parentId = options.params[parentKey];

	      if (parentId === false || !parentKey || !parentDef) {
	        if (parentId === false) {
	          delete options.params[parentKey];
	        }
	        return endpoint;
	      } else {
	        delete options.params[parentKey];

	        if (DSUtils._sn(id)) {
	          item = resourceConfig.get(id);
	        } else if (DSUtils._o(id)) {
	          item = id;
	        }

	        if (item) {
	          parentId = parentId || item[parentKey] || (item[parentField] ? item[parentField][parentDef.idAttribute] : null);
	        }

	        if (parentId) {
	          var _ret = (function () {
	            delete options.endpoint;
	            var _options = {};
	            DSUtils.forOwn(options, function (value, key) {
	              _options[key] = value;
	            });
	            return {
	              v: DSUtils.makePath(_this2.getEndpoint(parentDef, parentId, DSUtils._(parentDef, _options)), parentId, endpoint)
	            };
	          })();

	          if (typeof _ret === 'object') return _ret.v;
	        } else {
	          return endpoint;
	        }
	      }
	    }
	  }, {
	    key: 'getPath',
	    value: function getPath(method, resourceConfig, id, options) {
	      var _this = this;
	      options = options || {};
	      if (isString(options.urlPath)) {
	        return makePath.apply(DSUtils, [options.basePath || _this.defaults.basePath || resourceConfig.basePath, options.urlPath]);
	      } else {
	        var args = [options.basePath || _this.defaults.basePath || resourceConfig.basePath, this.getEndpoint(resourceConfig, isString(id) || isNumber(id) || method === 'create' ? id : null, options)];
	        if (method === 'find' || method === 'update' || method === 'destroy') {
	          args.push(id);
	        }
	        return makePath.apply(DSUtils, args);
	      }
	    }
	  }, {
	    key: 'HTTP',
	    value: function HTTP(config) {
	      var _this = this;
	      var start = new Date();
	      config = copy(config);
	      config = deepMixIn(config, _this.defaults.httpConfig);
	      if (!('verbsUseBasePath' in config)) {
	        config.verbsUseBasePath = _this.defaults.verbsUseBasePath;
	      }
	      if (!config.urlOverride && config.verbsUseBasePath) {
	        config.url = makePath(config.basePath || _this.defaults.basePath, config.url);
	      }
	      if (_this.defaults.forceTrailingSlash && config.url[config.url.length - 1] !== '/' && !config.urlOverride) {
	        config.url += '/';
	      }
	      if (typeof config.data === 'object') {
	        config.data = removeCircular(config.data);
	      }
	      config.method = config.method.toUpperCase();
	      var suffix = config.suffix || _this.defaults.suffix;
	      if (suffix && config.url.substr(config.url.length - suffix.length) !== suffix && !config.urlOverride) {
	        config.url += suffix;
	      }

	      // logs the HTTP response
	      function logResponse(data, isRejection) {
	        data = data || {};
	        // examine the data object
	        if (data instanceof Error) {
	          // log the Error object
	          _this.defaults.error('FAILED: ' + (data.message || 'Unknown Error'), data);
	          return DSUtils.Promise.reject(data);
	        } else if (typeof data === 'object') {
	          var str = start.toUTCString() + ' - ' + config.method + ' ' + config.url + ' - ' + data.status + ' ' + (new Date().getTime() - start.getTime()) + 'ms';

	          if (data.status >= 200 && data.status < 300 && !isRejection) {
	            if (_this.defaults.log) {
	              _this.defaults.log(str, data);
	            }
	            return data;
	          } else {
	            if (_this.defaults.error) {
	              _this.defaults.error('FAILED: ' + str, data);
	            }
	            return DSUtils.Promise.reject(data);
	          }
	        } else {
	          // unknown type for 'data' that is not an Object or Error
	          _this.defaults.error('FAILED', data);
	          return DSUtils.Promise.reject(data);
	        }
	      }

	      if (!this.http) {
	        throw new Error('You have not configured this adapter with an http library!');
	      }

	      return this.http(config).then(logResponse, function (data) {
	        return logResponse(data, true);
	      });
	    }
	  }, {
	    key: 'GET',
	    value: function GET(url, config) {
	      config = config || {};
	      config.method = config.method || 'get';
	      config.urlOverride = !!config.url;
	      config.url = config.url || url;
	      return this.HTTP(config);
	    }
	  }, {
	    key: 'POST',
	    value: function POST(url, attrs, config) {
	      config = config || {};
	      config.method = config.method || 'post';
	      config.urlOverride = !!config.url;
	      config.url = config.url || url;
	      config.data = config.data || attrs;
	      return this.HTTP(config);
	    }
	  }, {
	    key: 'PUT',
	    value: function PUT(url, attrs, config) {
	      config = config || {};
	      config.method = config.method || 'put';
	      config.urlOverride = !!config.url;
	      config.url = config.url || url;
	      config.data = config.data || attrs;
	      return this.HTTP(config);
	    }
	  }, {
	    key: 'DEL',
	    value: function DEL(url, config) {
	      config = config || {};
	      config.method = config.method || 'delete';
	      config.urlOverride = !!config.url;
	      config.url = config.url || url;
	      return this.HTTP(config);
	    }
	  }, {
	    key: 'find',
	    value: function find(resourceConfig, id, options) {
	      var _this = this;
	      options = options ? copy(options) : {};
	      options.suffix = options.suffix || resourceConfig.suffix;
	      options.params = options.params || {};
	      options.params = _this.defaults.queryTransform(resourceConfig, options.params);
	      return _this.GET(_this.getPath('find', resourceConfig, id, options), options).then(function (data) {
	        var item = (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
	        return !item ? DSUtils.Promise.reject(new Error('Not Found!')) : item;
	      });
	    }
	  }, {
	    key: 'findAll',
	    value: function findAll(resourceConfig, params, options) {
	      var _this = this;
	      options = options ? copy(options) : {};
	      options.suffix = options.suffix || resourceConfig.suffix;
	      options.params = options.params || {};
	      if (params) {
	        params = _this.defaults.queryTransform(resourceConfig, params);
	        deepMixIn(options.params, params);
	      }
	      return _this.GET(_this.getPath('findAll', resourceConfig, params, options), options).then(function (data) {
	        return (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
	      });
	    }
	  }, {
	    key: 'create',
	    value: function create(resourceConfig, attrs, options) {
	      var _this = this;
	      options = options ? copy(options) : {};
	      options.suffix = options.suffix || resourceConfig.suffix;
	      options.params = options.params || {};
	      options.params = _this.defaults.queryTransform(resourceConfig, options.params);
	      return _this.POST(_this.getPath('create', resourceConfig, attrs, options), options.serialize ? options.serialize(resourceConfig, attrs) : _this.defaults.serialize(resourceConfig, attrs), options).then(function (data) {
	        return (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
	      });
	    }
	  }, {
	    key: 'update',
	    value: function update(resourceConfig, id, attrs, options) {
	      var _this = this;
	      options = options ? copy(options) : {};
	      options.suffix = options.suffix || resourceConfig.suffix;
	      options.params = options.params || {};
	      options.params = _this.defaults.queryTransform(resourceConfig, options.params);
	      return _this.PUT(_this.getPath('update', resourceConfig, id, options), options.serialize ? options.serialize(resourceConfig, attrs) : _this.defaults.serialize(resourceConfig, attrs), options).then(function (data) {
	        return (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
	      });
	    }
	  }, {
	    key: 'updateAll',
	    value: function updateAll(resourceConfig, attrs, params, options) {
	      var _this = this;
	      options = options ? copy(options) : {};
	      options.suffix = options.suffix || resourceConfig.suffix;
	      options.params = options.params || {};
	      if (params) {
	        params = _this.defaults.queryTransform(resourceConfig, params);
	        deepMixIn(options.params, params);
	      }
	      return this.PUT(_this.getPath('updateAll', resourceConfig, attrs, options), options.serialize ? options.serialize(resourceConfig, attrs) : _this.defaults.serialize(resourceConfig, attrs), options).then(function (data) {
	        return (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
	      });
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy(resourceConfig, id, options) {
	      var _this = this;
	      options = options ? copy(options) : {};
	      options.suffix = options.suffix || resourceConfig.suffix;
	      options.params = options.params || {};
	      options.params = _this.defaults.queryTransform(resourceConfig, options.params);
	      return _this.DEL(_this.getPath('destroy', resourceConfig, id, options), options).then(function (data) {
	        return (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
	      });
	    }
	  }, {
	    key: 'destroyAll',
	    value: function destroyAll(resourceConfig, params, options) {
	      var _this = this;
	      options = options ? copy(options) : {};
	      options.suffix = options.suffix || resourceConfig.suffix;
	      options.params = options.params || {};
	      if (params) {
	        params = _this.defaults.queryTransform(resourceConfig, params);
	        deepMixIn(options.params, params);
	      }
	      return this.DEL(_this.getPath('destroyAll', resourceConfig, params, options), options).then(function (data) {
	        return (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
	      });
	    }
	  }]);

	  return DSHttpAdapter;
	})();

	module.exports = DSHttpAdapter;

/***/ },
/* 3 */
/***/ function(module, exports) {

	if(typeof __WEBPACK_EXTERNAL_MODULE_3__ === 'undefined') {var e = new Error("Cannot find module \"axios\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var map = {};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 5;


/***/ }
/******/ ])
});
;;
(function () {
  'use strict';

  var appConfig = window.config;
  var appConfigModule = angular.module('Q.config.app-config', []).run(['$rootScope', function ($rootScope) {
    $rootScope.appConfig = appConfig;
  }]);

  var IGNORED_ERRORS = /InvalidAccessError|SecurityError/;

  // Use to decorate a function to prevent errors.
  var tryFunctionHelperModule = angular.module('Q.helpers.try-function', []).factory('tryFunction', ['$log', function ($log) {
    return function tryFunction(fn) {
      return function () {
        try {
          return fn.apply(undefined, arguments);
        } catch (ex) {
          if (IGNORED_ERRORS.test(ex)) {
            // Log security errors as warnings instead of debug so they're visible in production
            $log.warn('[SmartIDE] Security error (expected):', ex);
          } else {
            // $log.error automatically sends to Sentry
            $log.error(ex);
          }
        }
      };
    };
  }]);

  /* eslint-disable angular/no-private-call,angular/timeout-service */

  var timerHelperModule = angular.module('Q.helpers.timer-helper', []).factory('timerHelper', ['$rootScope', '$window', '$q', '$exceptionHandler', '$$q', function ($rootScope, $window, $q, $exceptionHandler, $$q) {
    var deferreds = {};

    /**
     * Drop-in replacement for Angular's $timeout, but designed to run outside the framework a bit,
     * so it doesn't cause Angular to stay in a "non-stable" state for testing purposes.
     *
     * @param fn
     * @param delay
     * @param invokeApply
     * @param args
     */
    function longTimeout(fn, delay) {
      for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        args[_key - 3] = arguments[_key];
      }

      var invokeApply = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (!angular.isFunction(fn)) {
        invokeApply = delay;
        delay = fn;
        fn = angular.noop;
      }

      var deferred = (invokeApply ? $q : $$q).defer();
      var promise = deferred.promise;
      var timeoutId = void 0;

      timeoutId = $window.setTimeout(function () {
        try {
          deferred.resolve(fn.apply(null, args));
        } catch (e) {
          deferred.reject(e);
          $exceptionHandler(e);
        } finally {
          delete deferreds[promise.$$timeoutId];
        }

        if (invokeApply) $rootScope.$apply();
      }, delay);

      promise.$$timeoutId = timeoutId;
      deferreds[timeoutId] = deferred;

      return promise;
    }

    /**
     * Cancels a previously configured longTimeout
     * @param promise Promise to cancel that was returned from longTimeout()
     * @returns {boolean}
     */
    longTimeout.cancel = function (promise) {
      if (promise && promise.$$timeoutId in deferreds) {
        // Timeout cancels should not report an unhandled promise.
        deferreds[promise.$$timeoutId].promise.catch(angular.noop);
        deferreds[promise.$$timeoutId].reject('canceled');
        delete deferreds[promise.$$timeoutId];
        return $window.clearTimeout(promise.$$timeoutId);
      }
      return false;
    };

    /**
     * Creates a recurring timer that is more guaranteed to run every [delay] milliseconds than $interval
     * @param fn Function to call on every tick
     * @param delay How often to run the timer
     * @param invokeApply Whether or not to invoke apply after each event
     * @param args Extra args passed to the function
     * @returns {{ stop, start, running }} An object that can be used to cancel the timer.
     */
    function runEvery(fn, delay) {
      for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        args[_key2 - 3] = arguments[_key2];
      }

      var invokeApply = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var nextEventTime = Date.now() + delay;

      var ret = {
        stop: function stop() {
          runEvery.cancel(this);
        },
        start: function start() {
          if (!this.running) {
            queueNextEvent();
          }
        }
      };

      function event() {
        // queue next event first, so it can be stopped/canceled by the timed event
        queueNextEvent();
        fn.apply(undefined, args);
      }

      function queueNextEvent() {
        if (ret.$$runEveryPromise) {
          runEvery.cancel(ret);
        }
        var now = Date.now();
        // determine the next trigger delay--skipping over any frames we've already passed if necessary
        while (nextEventTime < now) {
          nextEventTime += delay;
        }var eventDelay = nextEventTime - now;
        nextEventTime += delay;

        ret.$$runEveryPromise = longTimeout(event, eventDelay, invokeApply);
        event.running = true;
      }

      event();

      return ret;
    }

    /**
     * Cancels a runEvery event
     * @param event
     */
    runEvery.cancel = function (event) {
      if (event && event.$$runEveryPromise) {
        longTimeout.cancel(event.$$runEveryPromise);
        event.$$runEveryPromise = false;
        event.running = false;
      }
    };

    return {
      longTimeout: longTimeout,
      runEvery: runEvery
    };
  }]);

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var asyncToGenerator = function (fn) {
    return function () {
      var gen = fn.apply(this, arguments);
      return new Promise(function (resolve, reject) {
        function step(key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }

          if (info.done) {
            resolve(value);
          } else {
            return Promise.resolve(value).then(function (value) {
              step("next", value);
            }, function (err) {
              step("throw", err);
            });
          }
        }

        return step("next");
      });
    };
  };

  var classCallCheck = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var defineProperty = function (obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  };

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();

  var toConsumableArray = function (arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    } else {
      return Array.from(arr);
    }
  };

  function isPrimitive(v) {
    return !isFunction(v) && !isObject(v);
  }

  function isString(s) {
    return typeof s === 'string';
  }

  function isObject(value) {
    return value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
  }

  function isFunction(v) {
    return typeof v === 'function';
  }

  var isArray = Array.isArray;

  function isDate(v) {
    return Object.prototype.toString.call(v) === '[object Date]';
  }

  /**
   * Stops an event from happening
   * @param $event
   */
  function stopEvent($event) {
    if (isFunction($event)) {
      return function (ev) {
        stopEvent(ev);

        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        return $event.apply(undefined, args);
      };
    }
    if ($event) {
      if ($event.preventDefault) $event.preventDefault();
      $event.returnValue = false;
      stopBubbling($event);
    }
  }

  /**
   * Stops an event from propagating
   * @param $event
   */
  function stopBubbling($event) {
    if ($event) {
      if ($event.stopPropagation) $event.stopPropagation();
      $event.cancelBubble = true;
    }
  }

  var CustomEvent = function () {
    if (isFunction(window.CustomEvent)) return window.CustomEvent; // For modern browsers

    function CustomEvent(event) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$bubbles = _ref.bubbles,
          bubbles = _ref$bubbles === undefined ? false : _ref$bubbles,
          _ref$cancelable = _ref.cancelable,
          cancelable = _ref$cancelable === undefined ? false : _ref$cancelable,
          detail = _ref.detail;

      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, bubbles, cancelable, detail);
      return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    return window.CustomEvent = CustomEvent;
  }();

  /**
   * Adds simple event channels to any object (on, off, emit)
   * @param obj
   * @returns obj
   */
  function eventEmitter(obj) {
    var _listeners = {};

    /**
     * Registers an event listener on a named event
     * @param name {string} Name of event
     * @param listener {function} Listener
     * @returns {function} Deregistration function
     */
    function on(name, listener) {
      var namedListeners = _listeners[name];
      if (!namedListeners) {
        _listeners[name] = namedListeners = [];
      }
      namedListeners.push(listener);
      return off.bind(obj, name, listener);
    }

    /**
     * Deregisters an event listener on a named event
     * @param name {string|true} Name of event. If true, destroys all listeners
     * @param listener {function} Listener to deregister
     */
    function off(name, listener) {
      if (name === true) {
        // disable _all_ listeners
        Object.keys(_listeners).forEach(function (k) {
          delete _listeners[k];
        });
      } else {
        var namedListeners = _listeners[name];
        if (namedListeners) {
          var indexOfListener = namedListeners.indexOf(listener);
          if (indexOfListener !== -1) {
            namedListeners.splice(indexOfListener, 1);
          }
        }
      }
    }

    /**
     * Emits a named event
     * @param name {string} Name of event
     * @param args {*} Additional arguments to the event
     * @returns {{name: *, preventDefault: (function()), defaultPrevented: boolean}} Resulting event object
     */
    function emit(name) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      var namedListeners = _listeners[name];
      var event = {
        name: name,
        preventDefault: function preventDefault() {
          event.defaultPrevented = true;
        },

        defaultPrevented: false
      };
      if (namedListeners) {
        namedListeners.forEach(function (l) {
          return isFunction(l) && l.apply(undefined, [event].concat(args));
        });
      }
      return event;
    }

    obj.on = on;
    obj.off = off;
    obj.emit = emit;

    return obj;
  }

  // Intercom is no longer used. This module remains as a compatibility layer for
  // existing support entrypoints (eg. `intercom-button`) and now routes users to
  // email-based support.
  var intercomServiceModule = angular.module('Q.services.intercom-service', [timerHelperModule]).factory('intercomService', ['$window', 'timerHelper', '$rootScope', '$log', function ($window, timerHelper, $rootScope, $log) {
    var SUPPORT_EMAIL = 'support@qualified.io';
    var DEFAULT_SUBJECT = 'Qualified Support';

    var updateTimer = null;

    function buildMailtoHref() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          subject = _ref.subject,
          body = _ref.body;

      var params = [];
      if (subject) params.push('subject=' + encodeURIComponent(subject));
      if (body) params.push('body=' + encodeURIComponent(body));
      var query = params.length ? '?' + params.join('&') : '';
      return 'mailto:' + SUPPORT_EMAIL + query;
    }

    function openMailto() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          subject = _ref2.subject,
          body = _ref2.body;

      try {
        $window.location.href = buildMailtoHref({ subject: subject, body: body });
      } catch (e) {
        // Don't break the UI if navigation fails in some embedded contexts.
        $log.debug(e);
      }
    }

    var service = {
      // Compatibility no-ops (Intercom removed)
      setUser: function setUser() {
        $rootScope.$broadcast('intercom.isActive', false);
        return service;
      },
      unsetUser: function unsetUser() {
        $rootScope.$broadcast('intercom.isActive', false);
        return service;
      },
      trackPage: function trackPage() {
        return service;
      },
      trackEvent: function trackEvent() {
        return service;
      },
      delayUpdate: function delayUpdate(delay, data) {
        timerHelper.longTimeout.cancel(updateTimer);

        updateTimer = timerHelper.longTimeout(function () {
          service.update(data);
        }, delay || 2000, false);
      },
      update: function update() {
        return service;
      },
      show: function show(msg) {
        var body = '';
        if (msg && msg !== true) body = String(msg);
        openMailto({ subject: DEFAULT_SUBJECT, body: body });
        return service;
      },
      hide: function hide() {
        return service;
      },
      toggle: function toggle() {
        return service.show();
      },
      isActive: function isActive() {
        return false;
      },
      showWidget: function showWidget() {
        // Always allow support entrypoints to render, even though Intercom is gone.
        return true;
      },
      supportMailtoHref: function supportMailtoHref() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            subject = _ref3.subject,
            body = _ref3.body;

        return buildMailtoHref({
          subject: subject || DEFAULT_SUBJECT,
          body: body
        });
      }
    };

    return service;
  }]).run(['$rootScope', 'intercomService', function ($rootScope, intercomService) {
    $rootScope.$on('$stateChangeSuccess', function () {
      return intercomService.delayUpdate(1000);
    });
  }]).directive('intercomHide', function () {
    return {
      restrict: 'A',
      link: function link(scope, elem) {
        // Intercom is removed, but keep the element visible for support entrypoints.
        elem.toggleClass('ng-hide', false);
      }
    };
  }).directive('intercomButton', ['intercomService', function (intercomService) {
    return {
      restrict: 'A',
      link: function link(scope, elem, attr) {
        elem.addClass('intercom-button');
        elem.attr('tabindex', 0);
        var msgAttr = attr.intercomButtonMessage;
        var msg = msgAttr === 'true' || msgAttr === '' ? '' : msgAttr;

        var existingHref = elem.attr('href');
        var shouldSetHref = !existingHref || existingHref === '' || existingHref === '#';
        if (shouldSetHref) {
          elem.attr('href', intercomService.supportMailtoHref({ body: msg }));
          elem.attr('target', '_blank');
          elem.attr('rel', 'noopener');
        }

        // Ensure mailto works even if something prevents default navigation.
        elem.on('click', function (event) {
          if (shouldSetHref) {
            stopEvent(event);
            intercomService.show(msg);
          }
        });
        if (!attr.title && !attr.tooltip) {
          elem.attr('title', 'Email Qualified Support');
        }
      }
    };
  }]).directive('modalContent', ['$compile', function ($compile) {
    return {
      restrict: 'C',
      link: function link(scope, elem) {
        var nodeLink = $compile('<a intercom-button track-click="Support Email Clicked" track-data="{ui: {region: \'dialog\'}}"></a>')(scope);
        elem.append(nodeLink);
      }
    };
  }]);

  function noop() {}

  function identity(v) {
    return v;
  }

  var separatedWords = /([a-z0-9])[^a-z0-9]([a-z0-9])/gi;
  var camelCasedWords = /([a-z0-9])([A-Z])/g;

  var htmlSymbols = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;'
  };

  var toString = String;

  var pastTenseExceptions = {
    are: 'were',
    eat: 'ate',
    go: 'went',
    have: 'had',
    inherit: 'inherited',
    is: 'was',
    run: 'ran',
    sit: 'sat',
    visit: 'visited'
  };

  // taken from https://gist.github.com/letsgetrandy/1e05a68ea74ba6736eb5
  function pastTense(verb) {
    // if already past tensed
    if (/ed$/.test(verb)) {
      return verb;
    }
    if (pastTenseExceptions[verb]) {
      return pastTenseExceptions[verb];
    }
    if (/e$/i.test(verb)) {
      return verb + 'd';
    }
    if (/[aeiou]c$/i.test(verb)) {
      return verb + 'ked';
    }
    if (/el$/i.test(verb)) {
      return verb + 'ed';
    }
    if (/[aeio][aeiou][dlmnprst]$/.test(verb)) {
      return verb + 'ed';
    }
    if (/[aeiou][b-df-hj-np-tv-z]+[aeiou][bdglmnprst]$/i.test(verb)) {
      return verb + 'ed';
    }
    if (/[aeiou][bdglmnprst]$/i.test(verb)) {
      return verb.replace(/(.+[aeiou])([bdglmnprst])/, '$1$2$2ed');
    }
    return verb + 'ed';
  }

  function upperCaseWords(str) {
    return toString(str).replace(/(?:^|\s)\S/g, function (a) {
      return a.toUpperCase();
    });
  }

  function snakeCase(str) {
    return _replaceCase(str, '$1_$2').toLowerCase();
  }

  function pascalCase(str) {
    return ucFirst(toString(str).replace(separatedWords, function (m, l1, l2) {
      return l1 + l2.toUpperCase();
    }));
  }

  function camelCase(str) {
    return lcFirst(pascalCase(str));
  }

  function ucFirst(str) {
    str = toString(str);
    return str.length === 0 ? str : str[0].toUpperCase() + str.slice(1);
  }

  function lcFirst(str) {
    str = toString(str);
    return str.length === 0 ? str : str[0].toLowerCase() + str.slice(1);
  }

  function compare(a, b) {
    a = toStringEmpty(a);
    b = toStringEmpty(b);
    return a === b ? 0 : a < b ? -1 : 1;
  }

  function compareIgnoreCase(a, b) {
    return compare(toStringEmpty(a).toUpperCase(), toStringEmpty(b).toUpperCase());
  }

  function escapeHTML(str) {
    return toString(str).replace(/&amp;/g, '&').replace(/[&<>]/g, function (m) {
      return htmlSymbols[m];
    });
  }

  function escapeRegex(str) {
    return toString(str).replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
  }

  function toStringEmpty(str) {
    if (str === null || str === undefined) {
      return '';
    } else {
      return toString(str);
    }
  }

  //// private functions

  function _replaceCase(str, replacement) {
    return toString(str).replace(separatedWords, replacement).replace(camelCasedWords, replacement);
  }

  // TAKEN FROM https://developer.mozilla.org/en-US/docs/Web/API/document/cookie
  // 1.3 version of angular-cookies does not support setting path values which we require, so using the MDN version
  // TODO: upgrade once angular 1.4 is upgraded
  function escapeCookieKey(sKey) {
    return encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&');
  }

  function getCookie(sKey) {
    if (!sKey) {
      return null;
    }
    var searchPattern = new RegExp('(?:(?:^|.*;)\\s*' + escapeCookieKey(sKey) + '\\s*\\=\\s*([^;]*).*$)|^.*$');
    return decodeURIComponent(document.cookie.replace(searchPattern, '$1')) || null;
  }

  function setCookie(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
      return false;
    }
    var sExpires = '';
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + vEnd;
          break;
        case String:
          sExpires = '; expires=' + vEnd;
          break;
        case Date:
          sExpires = '; expires=' + vEnd.toUTCString();
          break;
      }
    }
    document.cookie = encodeURIComponent(sKey) + '=' + encodeURIComponent(sValue) + sExpires + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '') + (bSecure ? '; secure' : '');
    return true;
  }

  function hasCookie(sKey) {
    if (!sKey) {
      return false;
    }
    return new RegExp('(?:^|;\\s*)' + escapeCookieKey(sKey) + '\\s*\\=').test(document.cookie);
  }

  var UTM_KEY = '$qualified$utm';

  // captures UTM properties on page load and preserves them across the site
  var utmProps = {};

  try {
    var storage = JSON.parse(window.localStorage[UTM_KEY] || '{}');
    Object.assign(utmProps, storage);
  } catch (err) {}
  /* ignore errors */


  // even if we couldn't parse the stored props, lets try to get new ones
  try {
    if (window.URL) {
      var utmTester = /^utm_/;
      var params = new URL(document.location).searchParams;
      if (params) {
        params.forEach(function (val, key) {
          var k = key.toLowerCase();
          if (utmTester.test(k) && val) {
            if (val === 'null') {
              delete utmProps[k];
            } else {
              utmProps[k] = val;
            }
          }
        });
        utmProps.referrer = document.referrer;
        utmProps.initialReferrer = utmProps.initialReferrer || document.referrer;
        window.localStorage[UTM_KEY] = JSON.stringify(utmProps);
      }
    }
  } catch (err) {
    /* ignore errors */
  }

  var ACCOUNT_SERVICE_KEY = 'accountService';

  var accountService = void 0;

  function getAccountService($injector) {
    if (!accountService) {
      accountService = $injector.has(ACCOUNT_SERVICE_KEY) && $injector.get(ACCOUNT_SERVICE_KEY);
    }
    return accountService;
  }

  function getUser($injector) {
    var account = getAccountService($injector);
    return account && account.get().user;
  }

  function isLoggedIn($injector) {
    return !!getUser($injector);
  }

  function getTeam($injector) {
    var user = getUser($injector);
    return user && user.team;
  }

  function getImpersonateId() {
    return getCookie('impersonator_id');
  }

  var trackerServiceModule = angular.module('Q.services.tracker-service', [tryFunctionHelperModule, intercomServiceModule]).factory('tracker', ['$window', 'intercomService', '$injector', 'tryFunction', '$log', function ($window, intercomService, $injector, tryFunction, $log) {
    // assign the appname as a custom session variable
    if ($window.ga) {
      $window.ga('set', 'dimension1', appConfig.appName);
    }

    var service = {
      shouldTrack: shouldTrack,

      setUser: tryFunction(function (user) {
        if (shouldTrack()) {
          if ($window.analytics) {
            if (user.user) {
              user = user.user;
            }

            service.user = user;

            var userData = {};

            if (user.team) {
              $window.analytics.group(user.teamId, user.team);
              // some analytics services don't respond to analytics.group, so track the key team properties as fields
              userData = {
                customer: {
                  id: user.team.customerId,
                  name: user.team.customer && user.team.customer.name,
                  state: user.team.customer && user.team.customer.state,
                  trialEndedAt: user.team.customer && user.team.customer.trialEndedAt
                },
                team: {
                  name: user.team.name,
                  primary: user.team.primaryTeam,
                  // legacy trait
                  subscriptionState: user.team.customer && user.team.customer.state,
                  state: user.team.state
                }
              };
            }

            $window.analytics.identify(user.id, angular.extend({}, user, userData), setContext());
          }

          // Implement fullstory set user here (Datadog rum replacement)

          intercomService.setUser(angular.extend({}, user, utmProps));
        }
      }),
      unsetUser: tryFunction(function () {
        service.user = null;

        if ($window.analytics) {
          $window.analytics.reset();
        }
        if ($window.mixpanel && $window.mixpanel.cookie) {
          $window.mixpanel.cookie.clear();
        }
        // Implement fullstory clear user here (Datadog rum replacement)

        intercomService.unsetUser();
      }),
      trackPage: tryFunction(function (name, props, options) {
        props = props || {};
        props.app = appConfig.appName;
        props.env = appConfig.env;

        if ($window.analytics && shouldTrack()) {
          $window.analytics.page(name, props, setContext(options));
        }
        intercomService.trackPage();
      }),
      trackEvent: tryFunction(function (name, properties) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        if (appConfig.devMode) {
          $log.debug('trackEvent:', name, properties, options);
        }

        if (shouldTrack()) {
          var $state = $injector.has('$state') && $injector.get('$state');
          // always include these basic properties
          var props = angular.extend({
            app: appConfig.appName,
            env: appConfig.env,
            ui: {}
          }, properties);
          props.ui.$state = $state && $state.current && $state.current.name;

          if ($window.analytics) {
            $window.analytics.track(name, props, setContext(options));
          } else if ($window.ga) {
            var _props = properties || {};
            $window.ga('send', 'event', {
              eventCategory: appConfig.appName,
              eventAction: name,
              // try to guess which key--if any--might work as the event label
              eventLabel: _props[['name', 'title', 'state', 'label', 'message', 'id'].find(function (k) {
                return _props[k];
              })],
              eventValue: !isNaN(_props.value) ? _props.value : null
            });
          }
          // Implement fullstory add action here (Datadog rum replacement)

          if (options.intercom !== false) {
            intercomService.trackEvent(name, properties);
          }
        }
      }),
      trackError: tryFunction(function (name, properties) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        $log.error(name, properties);
        service.trackEvent('Error: ' + name, properties, options);
      }),
      // extended version of trackEvent, which takes a model instance. If the properties are provided as a
      // function, the result of that function will be be returned. If no properties are provided, then
      // the properties will be derived from the model instance.
      trackModelEvent: tryFunction(function (instance, name, properties) {
        if (!instance) return;
        // if track properties were specifically configured then use those instead
        if (properties) {
          if (angular.isFunction(properties)) {
            properties = properties(instance);
          }
          // if the instance support a trackProperties method, then use that as the default. Otherwise
          // just use key fields from the instance itself.
        } else {
          var defaults = {
            id: instance.id,
            $type: instance.$type,
            name: instance.name,
            title: instance.title,
            candidate: instance.candidate ? instance.candidate.email : undefined,
            team: instance.team ? instance.team.name : undefined
          };
          properties = instance.trackProperties ? instance.trackProperties(defaults) : defaults;
        }
        service.trackEvent(name, properties, { intercom: false });
      })
    };

    function shouldTrack() {
      var accountService = getAccountService($injector);
      var account = accountService && accountService.get();

      // If there is a current user
      if (account.user) {
        return account.verified && // must be verified in the service
        account.user.role !== 'staff' && // must not be a staff member
        !account.user.demoAccount && ( // must not be a demo account
        account.user.$type !== 'Candidate' || !account.user.isActive || account.user.isActive()) && // must not be an inactive candidate
        !getImpersonateId(); // must not be impersonating this user
      }
      // otherwise we do not currently track anonymous users
      return false;
    }

    function setContext(options) {
      options = options || {};
      // by default segment only passes along utm values if they are in the current url.
      // We are going to pull them from the cookie so that everything gets tracked back to the source referrer.
      options.context = {
        campaign: {
          name: utmProps.utm_campaign,
          source: utmProps.utm_source,
          medium: utmProps.utm_medium,
          term: utmProps.utm_term,
          content: utmProps.utm_content
        }
      };

      return options;
    }

    return service;
  }]).run(['tracker', '$rootScope', '$injector', 'tryFunction', function (tracker, $rootScope, $injector, tryFunction) {
    var rebroadcastEvents = ['app.accountSet', 'app.login', 'app.logout'];

    rebroadcastEvents.forEach(function (event) {
      $rootScope.$on(event, function (e, args) {
        if (tracker.shouldTrack()) {
          $rootScope.$broadcast('tracker.' + event, args);
        }
      });
    });

    $rootScope.$on('model.actionEndpoint.success', tryFunction(function (e, args) {
      var track = args.options.track;
      if (track) {
        if (angular.isString(track)) {
          track = { event: track };
        }

        if (track === true) {
          track = { event: true };
        } else if (!track.event) {
          track.event = true;
        }

        if (track.event === true) {
          var verb = upperCaseWords(pastTense(args.name));
          track.event = args.model.name + ' ' + verb;
        }

        tracker.trackModelEvent(args.instance, track.event, track.properties);
      }
    }));

    // handles model that are configured to automatically track their CUD events
    $rootScope.$on('model.changed', tryFunction(function (e, args) {
      var track = args.config.meta && args.config.meta.track && args.config.meta.track[args.action];
      if (track) {
        var event = args.action + 'd';
        if (event === 'destroyd') event = 'destroyed';
        event = upperCaseWords(pastTense(event));
        tracker.trackModelEvent(args.instance, args.resourceName + ' ' + event, track === true ? null : track);
      }
    }));

    // collect the previous state on the ui.router $stateChangeStart
    // because the nestedPageTitleHelper pulls the current title
    var previousState = void 0;
    var stateDelimiter = ':';

    $rootScope.$on('tracker.app.accountSet', function (e, account) {
      return tracker.setUser(account);
    });
    $rootScope.$on('tracker.app.logout', function () {
      return tracker.unsetUser();
    });

    $rootScope.$on('$stateChangeStart', tryFunction(function (event, toState, toParams, fromState) {
      // default to tracking state changes unless the
      // route explicitly sets track to false
      if (fromState.track !== false) {
        var fromPageTitle = fromState && fromState.data && fromState.data.pageTitle;
        if (fromPageTitle && !angular.isString(fromPageTitle)) {
          previousState = $injector.invoke(fromPageTitle);
          if (angular.isArray(previousState)) {
            previousState = previousState.join(stateDelimiter);
          }
        } else {
          previousState = '';
        }
      } else {
        previousState = '';
      }
    }));

    $rootScope.$on('$stateChangeSuccess', tryFunction(function (event, toState, toParams, fromState) {
      // these events are noisy as hell so lets not track them in the development environment and save
      // ourselves some money
      // default to tracking state changes unless the
      // route explicitly sets track to false
      if (toState.track !== false && toState.name !== 'error') {
        var toPageTitle = toState.data && toState.data.pageTitle;
        if (toPageTitle && !angular.isString(toPageTitle)) {
          toPageTitle = $injector.invoke(toPageTitle);
          if (angular.isArray(toPageTitle)) {
            toPageTitle = toPageTitle.join(stateDelimiter);
          }
        }

        var props = {
          title: toPageTitle,
          fromStateName: previousState || fromState.name || '',
          toParams: toParams
        };

        // srefProps are set by the ui-sref directive, which utilize the triggering
        // element's track-data attribute.
        angular.merge(props, tracker.srefProps);
        tracker.srefProps = null;

        // turn mixpanel off in dev mode
        var options = {
          mixpanel: appConfig.env !== 'dev'
        };

        var pageName = toState.data && toState.data.label;
        if (!pageName && toPageTitle) {
          pageName = toPageTitle.split(':')[0];
        }

        tracker.trackPage(pageName || toState.name, props, options);
      }
    }));
  }]);

  /**
   * Returns an object with all cyclical references replaced with `«cyclical value»`
   * @param {*} data - Any value
   * @param {Set} foundObjects - A set of already found objects when recursing
   * @returns {*} A copy of the data without any cycles
   */
  function toNonCyclicalObject(data) {
    var foundObjects = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();

    var result = void 0;
    if (foundObjects.has(data)) {
      result = '«cyclical value»';
    } else if (isArray(data)) {
      foundObjects.add(data);
      result = data.map(function (v) {
        return toNonCyclicalObject(v, foundObjects);
      });
      foundObjects.delete(data);
    } else if (isObject(data)) {
      foundObjects.add(data);
      var newObj = {};
      Object.keys(data).forEach(function (k) {
        newObj[k] = toNonCyclicalObject(data[k], foundObjects);
      });
      result = newObj;
      foundObjects.delete(data);
    } else {
      result = data;
    }
    return result;
  }

  /**
   * Returns a copy of the data safe for Sentry logging
   * @param {*} data - Any data we want to send to Sentry
   * @param {number} maxDepth - The maximum depth before we render the data as a JSON string (so it isn't lost)
   * @returns {*} A copy of the data safe to log to Sentry
   */
  function toSentrySafeObject(data) {
    var maxDepth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

    var newObj = {};
    Object.keys(data).forEach(function (k) {
      var v = data[k];
      if (isPrimitive(v)) {
        newObj[k] = v;
      } else if (isArray(v)) {
        if (maxDepth > 0) {
          newObj[k] = v.map(function (v) {
            return toSentrySafeObject(v, maxDepth - 1);
          });
        } else {
          newObj[k] = JSON.stringify(toNonCyclicalObject(v));
        }
      } else if (isObject(v)) {
        if (maxDepth > 0) {
          newObj[k] = toSentrySafeObject(v, maxDepth - 1);
        } else {
          newObj[k] = JSON.stringify(toNonCyclicalObject(v));
        }
      }
    });
    return newObj;
  }

  function defineValue(parent, key, value) {
    Object.defineProperty(parent, key, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  function lazyProperty(parent, key, getter) {
    var prop = void 0;
    Object.defineProperty(parent, key, {
      get: function get$$1() {
        if (prop === undefined) {
          prop = getter.call(parent, key);
        }
        return prop;
      },

      enumerable: false,
      configurable: true
    });
  }

  /**
   * Returns true if the values are different, with special cases for `null` and `undefined`
   * @param {*} originalVal The original value
   * @param {*} updatedVal The updated value
   * @param {String?} k Optional key being used. If the key is `$$hasKey`, we ignore it
   * @returns {boolean}
   */
  function isDiff(originalVal, updatedVal, k) {
    return k !== '$$hashKey' && !angular.equals(originalVal, updatedVal) && updatedVal !== undefined && !(updatedVal === null && originalVal === undefined);
  }

  /**
   * Can be used to return the differences between an existing object and another one.
   * Does NOT identify removed properties on the updated object (instead, set them to null).
   * @param original {Object} Existing model
   * @param updated {Object} Updated model or changes
   * @param skipProperty {Function} If provided, use to filter out properties
   * @returns {{$empty}} Hash of changes, plus a param $empty which is true if there are no changes
   */
  function diff(original, updated) {
    var skipProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : angular.noop;

    var changes = original ? {} : angular.extend({}, updated);
    if (original) {
      angular.forEach(updated, function (v, k) {
        if (!skipProperty(k, v) && isDiff(original[k], v, k)) {
          changes[k] = v;
        }
      });
    }
    defineValue(changes, '$empty', !Object.keys(changes).length);
    return changes;
  }

  function pluck(k, o) {
    if (o === undefined) {
      return pluck.bind(null, k);
    }
    if (k.indexOf('.')) {
      k = k.split('.');
      for (var i = 0; i < k.length; i++) {
        o = o[k[i]];
        if (o === undefined || o === null) return o;
      }
      return o;
    } else {
      return o[k];
    }
  }

  /**
   * Returns a flattened object with all of the prototype chain properties merged in.
   *
   * Stops at one of the following prototypes:
   *  - non-Object (e.g., null)
   *  - Object
   *  - if provided, the base class
   *
   *  The final object is not included in the assigned model.
   *
   *  NOTE: the returned model is a SHALLOW copy of the properties using Object.assign! Modifying nested objects
   *    *will* modify the original data.
   *
   * @param {*} object - Object we want to flatten
   * @param {*?} baseClass - Optional class for stopping
   * @returns {null|Object} If object is not an Object, is exactly Object or is the baseClass prototype, returns null.
   *   Otherwise returns a new object containing the flattened prototype chain.
   */
  function flattenPrototypeChain(object, baseClass) {
    if (!isObject(object) || object === Object || baseClass && object === baseClass.prototype) {
      return null;
    }
    return Object.assign(flattenPrototypeChain(Object.getPrototypeOf(object), baseClass) || {}, object);
  }

  var oldOnerror = window.onerror;
  var booted = false;
  var doc = window.document;
  window.onerror = prebootError;
  // used because we have to re-throw errors to see them with source maps
  var lastException = null;

  function prebootError(msg /*, url, line, col, error*/) {
    if (oldOnerror) {
      oldOnerror.apply(this, arguments);
    }
    if (!booted && doc) {
      var appName = '';
      if (window.config && window.config.appName) {
        appName = encodeURIComponent(window.config.appName + ' ');
      }
      // wipe out the body content
      doc.body.innerHTML = '<div class="loading-exception">\n\t<h2>Error: Unable to start the application!</h2>\n\t<p>We were unable to get the application started! You can try reloading the page, or <a href="mailto:team@qualified.io?subject=' + appName + 'Application%20Startup%20Issues" target="_blank">contact the team at Qualified.</a></p>\n\t<p>The error that occurred is:</p>\n\t<pre><code>' + msg + '</code></pre>\n</div>';
    }
  }

  function isPlainObject(obj) {
    return angular.isObject(obj) && Object.getPrototypeOf(obj) === Object.prototype;
  }

  function sentryOpts(args) {
    var opts = {};
    if (args.length) {
      if (angular.isString(args[0])) {
        opts.extra = { extraMessage: args.shift() };
      } else if (angular.isNumber(args[0].status) || isPlainObject(args[0])) {
        // capture additional data if this is an $http request or it's a plain object
        opts.extra = toSentrySafeObject(args.shift());
      }
    }
    return opts;
  }

  function sendToSentry($log) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    try {
      if (window.Sentry && (!window.config || !window.config.devMode)) {
        args = args.filter(angular.identity);
        var sent = false;
        // handle simple string arguments
        if (args.length && angular.isString(args[0])) {
          window.Sentry.captureMessage(args.shift(), sentryOpts(args));
          sent = true;
        }
        // handle Error arguments (we might capture 2 events)
        if (args.length && args[0] instanceof Error) {
          window.Sentry.captureException(args.shift(), sentryOpts(args));
          sent = true;
        }
        // handle anything else
        if (!sent) {
          window.Sentry.captureMessage('Non-Error Logged', sentryOpts(args));
        }
      }
    } catch (e) {
      $log.warn('Error logging failure:');
      $log.warn(e);
    }
  }

  var exceptionHandlerServiceModule = angular.module('Q.services.exception-handler', []).run(['$log', '$rootScope', '$injector', '$q', function ($log, $rootScope, $injector, $q) {
    booted = true;
    if (window.onerror === prebootError) {
      window.onerror = oldOnerror;
    } // otherwise, someone else overwrote the onerror, so we just leave it

    // wrap the built-in $log.error function so it sends it to Sentry (after booting)
    var oldError = $log.error;
    $log.error = function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      oldError.apply($log, args);
      sendToSentry.apply(undefined, [$log].concat(args));
    };

    $log.reject = function () {
      $log.error.apply($log, arguments);
      return $q.reject(arguments.length <= 0 ? undefined : arguments[0]);
    };

    if (window.Sentry) {
      window.Sentry.setTags({
        appName: appConfig.appName,
        env: appConfig.env
      });
      $rootScope.$on('app.accountSet', function ($event, account) {
        if (account && account.user) {
          var user = account.user;
          window.Sentry.setUser({
            id: user.id,
            email: user.email
          });
          var impersonateId = getImpersonateId();
          if (impersonateId) {
            // track that this is an impersonated session
            window.Sentry.setTags({ impersonateId: impersonateId });
          }
        }
      });
      $rootScope.$on('app.logout', function () {
        return window.Sentry.setUser();
      });
    }
  }]).factory('$exceptionHandler', ['$log', '$injector', function ($log, $injector) {
    return function log(exception, cause) {
      if (lastException === exception) return;

      if (cause) {
        try {
          exception.message += ' (caused by "' + cause + '")';
        } catch (e) {
          $log.error('Cause: ', cause);
          // we cannot modify the message without error sometimes
        }
      }
      $log.error(exception);

      if (!booted) {
        // send any uncaught errors to Sentry directly before booting
        sendToSentry($log, exception);
      }

      if (appConfig.devMode && $injector.has('$state')) {
        try {
          var $state = $injector.get('$state');
          $state.go('error', { error: exception, didLog: true });
        } catch (e) {}
      }

      lastException = exception;
      if (exception.stack) {
        // re-throw so we get stack traces with source maps
        // eslint-disable-next-line angular/timeout-service
        setTimeout(function () {
          throw exception;
        });
      }
    };
  }]);

  var landingTrackerServiceModule = angular.module('Q.services.tracker-service', []).factory('trackerService', ['$window', function ($window) {
    return {
      trackEvent: function trackEvent(event, props) {
        if ($window.analytics && $window.analytics.track) {
          $window.analytics.track(event, angular.extend({ app: 'Landing' }, props || {}));
        }
      }
    };
  }]);

  var landingTrackClickComponentModule = angular.module('Q.components.track-click', [landingTrackerServiceModule])
  /**
   * @ngdoc directive
   * @docType shared
   * @category directive
   * @name trackClick
   * @description
   * Tracks a click on an element
   *
   * @restrict A
   * @element ANY
   * @param {string} trackClick String to use as the tracked event name, not interpolated
   * @param {expression=} trackData Hash of key-values to store with the track
   *
   * @example
   * <example>
   * <a track-click="event.name" track-data="{ properties }"></a>
   * </example>
   */
  .directive('trackClick', ['trackerService', function (trackerService) {
    return {
      restrict: 'A',
      replace: false,
      link: function link(scope, elem, attrs) {
        elem.on('click', function () {
          trackerService.trackEvent(attrs.trackClick, attrs.trackData ? scope.$eval(attrs.trackData) : null);
        });
      }
    };
  }]);

  var bubbleDialogTemplate = "<div class=\"bubble-dialog popover {{::className}} {{::positionClass}} {{::closeable?'bubble-dialog-closeable':''}}\"> <div class=\"arrow\"></div> <div class=\"popover-inner\"> <div class=\"popover-close\" ng-click=\"remove()\"></div> <div class=\"popover-title\" ng-if=\"title\">{{title}}</div> <div class=\"popover-content\"> <div class=\"content\" ng-bind-html=\"content\" ng-if=\"!contentTemplate\"></div> <div class=\"content\" compile-template=\"contentTemplate\" ng-if=\"contentTemplate\"></div> <div class=\"btn-container\" ng-if=\"buttons\"> <button ng-repeat=\"button in buttons\" class=\"{{button.className || 'btn btn-default'}}\" ng-click=\"button.resolve($event)\"> {{button.title}} </button> </div> </div> </div> </div> ";

  var bubbleDialogMenuTemplate = "<div class=\"bubble-dialog popover bubble-dialog-menu {{::className}} {{::positionClass}}\"> <div class=\"arrow\"></div> <div class=\"popover-inner\" compile-template=\"menu\"></div> </div> ";

  /* eslint-disable angular/timeout-service */

  var MutationObserver = window.MutationObserver || window.webkitMutationObserver;

  var nodeChangeListenerServiceModule = angular.module('Q.services.node-change-listener', []).factory('nodeChangeListener', ['$window', function ($window) {
    /**
     * Listens to DOM changes on a given node using browser methods.
     *
     * @param node Node to listen on
     * @param fn {Function} Function to call on DOM changes
     * @returns {Function} Function to disconnect the listener
     */
    function listenForChanges(node, fn) {
      var stopListening = angular.noop;

      if (node instanceof angular.element) {
        node = node[0];
      }

      if (MutationObserver) {
        // listen for any subtree changes
        var mutationObserverOpts = {
          childList: true,
          characterData: true,
          attributes: true,
          subtree: true
        };
        var observer = new MutationObserver(function () {
          observer.disconnect();
          var event = new CustomEvent('MutationEvent');
          fn(event);
          observer.observe(node, mutationObserverOpts);
        });
        observer.observe(node, mutationObserverOpts);

        stopListening = function stopListening() {
          return observer.disconnect();
        };
      } else {
        var ignoringMutations = false;
        var subtreeDebounce = null;
        var subtreeTrigger = function subtreeTrigger(event) {
          if (subtreeDebounce) $window.clearTimeout(subtreeDebounce);
          subtreeDebounce = $window.setTimeout(function () {
            if (ignoringMutations) return;
            ignoringMutations = true;
            fn(event);
            subtreeDebounce = null;
            ignoringMutations = false;
          }, 10);
        };

        var $node = angular.element(node);
        $node.on('DOMSubtreeModified', subtreeTrigger);

        stopListening = function stopListening() {
          return $node.off('DOMSubtreeModified', subtreeTrigger);
        };
      }

      return stopListening;
    }

    return {
      listen: listenForChanges
    };
  }]);

  var WINDOW_EVT_RESIZE = 'window:resize';

  var windowEventHelperModule = angular.module('Q.helpers.window-event-helper', []).run(['$rootScope', '$document', '$window', '$timeout', function ($rootScope, $document, $window, $timeout) {
    function _configEvents(element, prefix, events) {
      events.forEach(function (evtName) {
        var names = evtName.split(';');
        element.on(names[0], function (event) {
          names.forEach(function (n) {
            $rootScope.$broadcast(prefix + ':' + n, event);
          });
        });
      });
    }

    _configEvents(angular.element($window), 'window', ['resize', 'focus', 'blur', 'orientationchange;resize', 'message']);

    _configEvents($document, 'document', ['focusin']);

    // Special case for focus out, because we usually want to see if the active element changed, which needs a delay
    $document.on('focusout', function (event) {
      $rootScope.$broadcast('document:focusout', event);
      $timeout(function () {
        $rootScope.$broadcast('document:focusoutActiveElement', event, $document[0].activeElement);
      }, 0);
    });

    // set up document focus events based on polling
    var doc = $document[0];
    if (angular.isFunction(doc.hasFocus)) {
      var docHadFocus = doc.hasFocus();
      $window.setInterval(function checkFocus() {
        if (docHadFocus !== doc.hasFocus()) {
          docHadFocus = doc.hasFocus();
          $rootScope.$applyAsync(function () {
            $rootScope.$broadcast('document:' + (docHadFocus ? 'focus' : 'blur'));
          });
        }
      }, 250);
    }
  }]);

  /**
   * From angular-ui UI.Layout
   */

  // broadcast when the layout is being resized (manually or otherwise)
  var UI_LAYOUT_EVT_RESIZE = 'ui.layout.resize';
  // broadcast after redrawing during manual resize
  var UI_LAYOUT_EVT_DRAW_COMPLETE = 'ui.layout.draw-complete';

  var UI_LAYOUT_AUTO_SIZE = 'auto';

  var uiLayoutComponentModule = angular.module('Q.components.ui-layout', [windowEventHelperModule]).controller('uiLayoutCtrl', ['$scope', '$attrs', '$element', '$timeout', 'LayoutContainer', 'Layout', '$log', function uiLayoutCtrl($scope, $attrs, $element, $timeout, LayoutContainer, Layout, $log) {
    var ctrl = this;
    var opts = angular.extend({}, $scope.$eval($attrs.uiLayout), $scope.$eval($attrs.options));
    var numOfSplitbars = 0;
    //var cache = {};
    var animationFrameRequested = void 0;
    var lastPos = void 0;

    // regex to verify size is properly set to pixels or percent
    var sizePattern = /\d+\s*(px|%)\s*$/i;

    Layout.addLayout(ctrl);

    ctrl.containers = [];
    ctrl.movingSplitbar = null;
    ctrl.bounds = $element[0].getBoundingClientRect();
    ctrl.isUsingColumnFlow = opts.flow === 'column';
    ctrl.sizeProperties = !ctrl.isUsingColumnFlow ? {
      sizeProperty: 'height',
      offsetSize: 'offsetHeight',
      offsetPos: 'top',
      flowProperty: 'top',
      oppositeFlowProperty: 'bottom',
      mouseProperty: 'clientY',
      flowPropertyPosition: 'y'
    } : {
      sizeProperty: 'width',
      offsetSize: 'offsetWidth',
      offsetPos: 'left',
      flowProperty: 'left',
      oppositeFlowProperty: 'right',
      mouseProperty: 'clientX',
      flowPropertyPosition: 'x'
    };

    $element
    // Force the layout to fill the parent space
    // fix no height layout...
    .addClass('stretch')
    // set the layout css class
    .addClass('ui-layout-' + (opts.flow || 'row'));

    // Initial global size definition
    opts.sizes = opts.sizes || [];
    opts.maxSizes = opts.maxSizes || [];
    opts.minSizes = opts.minSizes || [];
    opts.dividerSize = opts.dividerSize === undefined ? 10 : opts.dividerSize;
    ctrl.opts = opts;

    $scope.updateDisplay = function () {
      ctrl.calculate();
    };

    var debounceEvent = void 0;

    function draw() {
      var position = ctrl.sizeProperties.flowProperty;
      var dividerSize = parseInt(opts.dividerSize);
      var elementSize = $element[0][ctrl.sizeProperties.offsetSize];

      if (ctrl.movingSplitbar !== null) {
        var splitbarIndex = ctrl.containers.indexOf(ctrl.movingSplitbar);
        var nextSplitbarIndex = splitbarIndex + 2 < ctrl.containers.length ? splitbarIndex + 2 : null;

        if (splitbarIndex > -1) {
          var processedContainers = ctrl.processSplitbar(ctrl.containers[splitbarIndex]);
          var beforeContainer = processedContainers.beforeContainer;
          var afterContainer = processedContainers.afterContainer;

          // calculate container positons
          var difference = ctrl.movingSplitbar[position] - lastPos;
          var newPosition = ctrl.movingSplitbar[position] - difference;

          // Keep the bar in the window (no left/top 100%)
          newPosition = Math.min(elementSize - dividerSize, newPosition);

          // Keep the bar from going past the previous element min/max values
          if (angular.isNumber(beforeContainer.beforeMinValue) && newPosition < beforeContainer.beforeMinValue) {
            newPosition = beforeContainer.beforeMinValue;
          }
          if (angular.isNumber(beforeContainer.beforeMaxValue) && newPosition > beforeContainer.beforeMaxValue) {
            newPosition = beforeContainer.beforeMaxValue;
          }

          // Keep the bar from going past the next element min/max values
          if (afterContainer !== null && angular.isNumber(afterContainer.afterMinValue) && newPosition > afterContainer.afterMinValue - dividerSize) {
            newPosition = afterContainer.afterMinValue - dividerSize;
          }
          if (afterContainer !== null && angular.isNumber(afterContainer.afterMaxValue) && newPosition < afterContainer.afterMaxValue) {
            newPosition = afterContainer.afterMaxValue;
          }

          // resize the before container
          beforeContainer.size = newPosition - beforeContainer[position];
          // store the current value to preserve this size during onResize
          beforeContainer.previousSize = beforeContainer.size;

          // update after container position
          var oldAfterContainerPosition = afterContainer[position];
          afterContainer[position] = newPosition + dividerSize;

          //update after container size if the position has changed
          if (afterContainer[position] !== oldAfterContainerPosition) {
            afterContainer.size = nextSplitbarIndex !== null ? oldAfterContainerPosition + afterContainer.size - (newPosition + dividerSize) : elementSize - (newPosition + dividerSize);
            // store the current value to preserve this size during onResize
            afterContainer.previousSize = afterContainer.size;
          }

          // move the splitbar
          ctrl.movingSplitbar[position] = newPosition;

          // broadcast an event that resize happened (debounced to 50ms)
          if (debounceEvent) $timeout.cancel(debounceEvent);
          debounceEvent = $timeout(function () {
            $scope.$broadcast(UI_LAYOUT_EVT_RESIZE, 'draw');
            $scope.$emit(UI_LAYOUT_EVT_DRAW_COMPLETE);
            debounceEvent = null;
          }, 50);
        }
      }

      //Enable a new animation frame
      animationFrameRequested = null;
    }

    function offset(element) {
      var rawDomNode = element[0];
      var body = document.documentElement || document.body;
      var scrollX = window.pageXOffset || body.scrollLeft;
      var scrollY = window.pageYOffset || body.scrollTop;
      var clientRect = rawDomNode.getBoundingClientRect();
      var x = clientRect.left + scrollX;
      var y = clientRect.top + scrollY;
      return { left: x, top: y };
    }

    /**
     * Returns the current value for an option
     * @param  option   The option to get the value for
     * @return The value of the option. Returns null if there was no option set.
     */
    function optionValue(option) {
      if (angular.isNumber(option) || angular.isString(option) && option.match(sizePattern)) {
        return option;
      } else {
        return null;
      }
    }

    //================================================================================
    // Public Controller Functions
    //================================================================================
    ctrl.mouseDownHandler = function (splitbar) {
      // only trigger when left mouse button is pressed:
      $element.addClass('ui-layout-resizing');
      ctrl.movingSplitbar = splitbar;
      ctrl.processSplitbar(splitbar);
    };
    ctrl.mouseUpHandler = function () {
      $element.removeClass('ui-layout-resizing');
      ctrl.movingSplitbar = null;
    };

    ctrl.mouseMoveHandler = function (mouseEvent) {
      var mousePos = mouseEvent[ctrl.sizeProperties.mouseProperty] || mouseEvent.originalEvent && mouseEvent.originalEvent[ctrl.sizeProperties.mouseProperty] || (mouseEvent.targetTouches ? mouseEvent.targetTouches[0][ctrl.sizeProperties.mouseProperty] : 0);

      lastPos = mousePos - offset($element)[ctrl.sizeProperties.offsetPos];

      //Cancel previous rAF call
      if (animationFrameRequested) {
        window.cancelAnimationFrame(animationFrameRequested);
      }

      //TODO: cache layout values

      //Animate the page outside the event
      animationFrameRequested = window.requestAnimationFrame(draw);
    };

    /**
     * Returns the min and max values of the ctrl.containers on each side of the container submitted
     * @param container
     * @returns {*}
     */
    ctrl.processSplitbar = function (container) {
      var index = ctrl.containers.indexOf(container);

      var setValues = function setValues(container) {
        var start = container[ctrl.sizeProperties.flowProperty];
        var end = container[ctrl.sizeProperties.flowProperty] + container.size;

        container.beforeMinValue = angular.isNumber(container.minSize) ? start + container.minSize : start;
        container.beforeMaxValue = angular.isNumber(container.maxSize) ? start + container.maxSize : null;

        container.afterMinValue = angular.isNumber(container.minSize) ? end - container.minSize : end;
        container.afterMaxValue = angular.isNumber(container.maxSize) ? end - container.maxSize : null;
      };

      //verify the container was found in the list
      if (index > -1) {
        var beforeContainer = index > 0 ? ctrl.containers[index - 1] : null;
        var afterContainer = index + 1 <= ctrl.containers.length ? ctrl.containers[index + 1] : null;

        if (beforeContainer !== null) setValues(beforeContainer);
        if (afterContainer !== null) setValues(afterContainer);

        return {
          beforeContainer: beforeContainer,
          afterContainer: afterContainer
        };
      }

      return null;
    };

    /**
     * Checks if a string has a percent symbol in it.
     * @param num
     * @returns {boolean}
     */
    ctrl.isPercent = function (num) {
      return !!(num && angular.isString(num) && num.indexOf('%') > -1);
    };

    /**
     * Converts a number to pixels from percent.
     * @param size
     * @param parentSize
     * @returns {number}
     */
    ctrl.convertToPixels = function (size, parentSize) {
      return Math.floor(parentSize * (parseInt(size) / 100));
    };

    var isAuto = function isAuto(i) {
      return opts.sizes[i] === UI_LAYOUT_AUTO_SIZE;
    };

    /**
     * Sets the size for each container initially and on window resize.
     */
    ctrl.calculate = function () {
      var dividerSize = parseInt(opts.dividerSize);
      var elementSize = $element[0].getBoundingClientRect()[ctrl.sizeProperties.sizeProperty];
      var originalSize = elementSize - dividerSize * numOfSplitbars;
      var containers = ctrl.containers;
      var containerCount = containers.length;

      if (originalSize > 0 && containerCount > 0 && $element.children().length > 0) {
        var availableSize = originalSize;
        var usedSpace = 0;
        var numOfAutoContainers = 0;
        var lastAuto = void 0;
        var autoSize = void 0;
        var sizes = opts.sizes;
        var minSizes = opts.minSizes;
        var maxSizes = opts.maxSizes;

        // calculate sizing for containers
        for (var i = 0; i < containerCount; i++) {
          if (!LayoutContainer.isSplitbar(containers[i])) {
            var c = containers[i];
            if (!isAuto(i)) {
              sizes[i] = c.isCentral ? UI_LAYOUT_AUTO_SIZE : optionValue(c.previousSize) || UI_LAYOUT_AUTO_SIZE;
            }
            minSizes[i] = optionValue(c.minSize);
            maxSizes[i] = optionValue(c.maxSize);

            if (!isAuto(i)) {
              if (ctrl.isPercent(sizes[i])) {
                sizes[i] = ctrl.convertToPixels(sizes[i], originalSize);
              } else {
                sizes[i] = parseInt(sizes[i]);
              }
            }

            if (minSizes[i] !== null) {
              if (ctrl.isPercent(minSizes[i])) {
                minSizes[i] = ctrl.convertToPixels(minSizes[i], originalSize);
              } else {
                minSizes[i] = parseInt(minSizes[i]);
              }

              // don't allow the container size to be smaller than the minSize
              if (sizes[i] < minSizes[i]) sizes[i] = minSizes[i];
            }

            if (maxSizes[i] !== null) {
              if (ctrl.isPercent(maxSizes[i])) {
                maxSizes[i] = ctrl.convertToPixels(maxSizes[i], originalSize);
              } else {
                maxSizes[i] = parseInt(maxSizes[i]);
              }

              // don't allow the container size to be larger than the maxSize
              if (sizes[i] > maxSizes[i]) sizes[i] = maxSizes[i];
            }

            if (isAuto(i)) {
              numOfAutoContainers++;
            } else {
              availableSize -= sizes[i];
            }
          }
        }

        // calculate initial autoSize
        autoSize = numOfAutoContainers > 0 ? Math.floor(availableSize / numOfAutoContainers) : 0;

        // Now scan again to check for any auto container outside it's min/max limits
        for (var _i = 0; _i < containerCount; _i++) {
          if (!LayoutContainer.isSplitbar(containers[_i]) && isAuto(_i)) {
            var maxSize = maxSizes[_i];
            var minSize = minSizes[_i];
            if (maxSize && maxSize < autoSize) {
              // adjust available size if the container would be too wide
              availableSize -= maxSize;
              numOfAutoContainers--;
            } else if (minSize && minSize > autoSize) {
              // adjust available size if the container would be too narrow
              // Note: this _could_ leave us with too much content for the space, so it might overflow
              //   this is likely preferable to crushing content
              availableSize -= minSize;
              numOfAutoContainers--;
            } else {
              // track the last truly auto container for the remainder
              lastAuto = _i;
            }
          }
        }

        // recalculate autosize in case we converted an autosize container
        autoSize = numOfAutoContainers > 0 ? Math.floor(availableSize / numOfAutoContainers) : 0;
        /*
         * When the parent size is odd, rounding down the `autoSize` leaves a remainder.
         * This remainder is added to the last auto-sized container in a layout.
         */
        var remainder = Math.max(0, availableSize - autoSize * numOfAutoContainers);
        for (var _i2 = 0; _i2 < containerCount; _i2++) {
          var _c = containers[_i2];
          _c[ctrl.sizeProperties.flowProperty] = usedSpace;
          _c.maxSize = maxSizes[_i2];
          _c.minSize = minSizes[_i2];

          if (!LayoutContainer.isSplitbar(_c)) {
            var newSize = void 0;
            if (isAuto(_i2)) {
              newSize = Math.min(_c.maxSize || Infinity, Math.max(_c.minSize || 0, autoSize));
              // add the rounding down remainder to the last auto-sized container in the layout
              if (_i2 === lastAuto) {
                newSize += remainder;
              }
            } else {
              newSize = sizes[_i2];
              if (availableSize < 0) {
                // the first fixed container must lose some width if we have negative space due to min/max
                newSize = Math.min(_c.maxSize || Infinity, Math.max(_c.minSize || 0, newSize + availableSize));
                availableSize = 0;
              }
            }

            _c.size = newSize !== null ? newSize : autoSize;
          } else {
            _c.size = dividerSize;
          }

          usedSpace += _c.size;
        }
      }

      if (debounceEvent) $timeout.cancel(debounceEvent);
      debounceEvent = $timeout(function () {
        $scope.$broadcast(UI_LAYOUT_EVT_RESIZE, 'calculate');
        debounceEvent = null;
      }, 50);
    };

    /**
     * Adds a container to the list of layout ctrl.containers.
     * @param container The container to add
     */
    ctrl.addContainer = function (container) {
      var index = ctrl.indexOfElement(container.element);
      if (!angular.isDefined(index) || index < 0 || ctrl.containers.length < index) {
        $log.error('Invalid index to add container; i=' + index + ', len=', ctrl.containers.length);
        return;
      }

      if (LayoutContainer.isSplitbar(container)) {
        numOfSplitbars++;
      }

      container.index = index;
      ctrl.containers.splice(index, 0, container);

      ctrl.calculate();
    };

    /**
     * Remove a container from the list of layout ctrl.containers.
     * @param  container
     */
    ctrl.removeContainer = function (container) {
      var index = ctrl.containers.indexOf(container);
      if (index >= 0) {
        if (!LayoutContainer.isSplitbar(container)) {
          if (ctrl.containers.length > 2) {
            // Assume there's a sidebar between each container
            // We need to remove this container and the sidebar next to it
            if (index === ctrl.containers.length - 1) {
              // We're removing the last element, the side bar is on the left
              ctrl.containers[index - 1].element.remove();
            } else {
              // The side bar is on the right
              ctrl.containers[index + 1].element.remove();
            }
          }
        } else {
          numOfSplitbars--;
        }

        // Need to re-check the index, as a side bar may have been removed
        var newIndex = ctrl.containers.indexOf(container);
        if (newIndex >= 0) {
          ctrl.containers.splice(newIndex, 1);
          ctrl.opts.maxSizes.splice(newIndex, 1);
          ctrl.opts.minSizes.splice(newIndex, 1);
          ctrl.opts.sizes.splice(newIndex, 1);
        }
        ctrl.calculate();
      } else {
        $log.error('removeContainer for container that did not exist!');
      }
    };

    /**
     * Returns an array of layout ctrl.containers.
     * @returns {Array}
     */
    ctrl.getContainers = function () {
      return ctrl.containers;
    };

    /**
     * Returns the container object of the splitbar that is before the one passed in.
     * @param currentSplitbar
     */
    ctrl.getPreviousSplitbarContainer = function (currentSplitbar) {
      if (LayoutContainer.isSplitbar(currentSplitbar)) {
        var currentSplitbarIndex = ctrl.containers.indexOf(currentSplitbar);
        var previousSplitbarIndex = currentSplitbarIndex - 2;
        if (previousSplitbarIndex >= 0) {
          return ctrl.containers[previousSplitbarIndex];
        }
        return null;
      }
      return null;
    };

    /**
     * Returns the container object of the splitbar that is after the one passed in.
     * @param currentSplitbar
     */
    ctrl.getNextSplitbarContainer = function (currentSplitbar) {
      if (LayoutContainer.isSplitbar(currentSplitbar)) {
        var currentSplitbarIndex = ctrl.containers.indexOf(currentSplitbar);
        var nextSplitbarIndex = currentSplitbarIndex + 2;
        if (currentSplitbarIndex > 0 && nextSplitbarIndex < ctrl.containers.length) {
          return ctrl.containers[nextSplitbarIndex];
        }
        return null;
      }
      return null;
    };

    /**
     * Checks whether the container before this one is a split bar
     * @param  {container}  container The container to check
     * @return {Boolean}    true if the element before is a splitbar, false otherwise
     */
    ctrl.hasSplitbarBefore = function (container) {
      var index = ctrl.containers.indexOf(container);
      if (1 <= index) {
        return LayoutContainer.isSplitbar(ctrl.containers[index - 1]);
      }

      return false;
    };

    /**
     * Checks whether the container after this one is a split bar
     * @param  {container}  container The container to check
     * @return {Boolean}    true if the element after is a splitbar, false otherwise
     */
    ctrl.hasSplitbarAfter = function (container) {
      var index = ctrl.containers.indexOf(container);
      if (index < ctrl.containers.length - 1) {
        return LayoutContainer.isSplitbar(ctrl.containers[index + 1]);
      }

      return false;
    };

    /**
     * Checks whether the passed in element is a ui-layout type element.
     * @param  {element}  element The element to check
     * @return {Boolean}          true if the element is a layout element, false otherwise.
     */
    ctrl.isLayoutElement = function (element) {
      return element.hasAttribute('ui-layout-container') || element.hasAttribute('ui-splitbar') || element.nodeName === 'UI-LAYOUT-CONTAINER';
    };

    /**
     * Retrieve the index of an element within it's parents context.
     * @param  {element} element The element to get the index of
     * @return {int}             The index of the element within it's parent
     */
    ctrl.indexOfElement = function (element) {
      var parent = element.parent();
      var children = parent.children();
      var containerIndex = 0;
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        if (ctrl.isLayoutElement(child)) {
          if (element[0] === children[i]) {
            return containerIndex;
          }
          containerIndex++;
        }
      }
      return -1;
    };

    return ctrl;
  }]).directive('uiLayout', ['$timeout', function ($timeout) {
    return {
      restrict: 'AE',
      controller: 'uiLayoutCtrl',
      require: ['^uiLayout', '?rememberUi'],
      link: function link(scope, element, attrs, _ref) {
        var _ref2 = slicedToArray(_ref, 2),
            uiLayoutCtrl = _ref2[0],
            rememberUiCtrl = _ref2[1];

        scope.$watch(function () {
          return element[0][uiLayoutCtrl.sizeProperties.offsetSize];
        }, function () {
          uiLayoutCtrl.calculate();
        });

        function onResize() {
          scope.$evalAsync(function () {
            uiLayoutCtrl.calculate();
          });
        }

        scope.$on(WINDOW_EVT_RESIZE, onResize);

        // enable storing sizes to localstorage
        $timeout(function () {
          if (rememberUiCtrl) {
            // attempt to reload the previous setup
            var sizes = rememberUiCtrl.retrieve();
            if (sizes && angular.isArray(sizes)) {
              _writeBackSizes(sizes);
              // force an update
              uiLayoutCtrl.calculate();
            }

            scope.$on(UI_LAYOUT_EVT_RESIZE, function (evt, method) {
              var total = element[0].getBoundingClientRect()[uiLayoutCtrl.sizeProperties.sizeProperty];

              var sizes = uiLayoutCtrl.opts.sizes.map(function (s, i) {
                var pctSize = Math.min(100, 100 * (uiLayoutCtrl.containers[i].size + 10) / total);
                return s !== 'auto' ? pctSize : s;
              });
              if (sizes.length) {
                rememberUiCtrl.store(sizes);

                // when the user makes an adjustment, we replace the current attribute sizes with
                // percentages, so window resizes work
                if (method !== 'calculate') {
                  _writeBackSizes(sizes);
                }
              }
            });
          }
        });

        // Writes the current sizes as percentages back onto the child elements
        function _writeBackSizes(sizes) {
          uiLayoutCtrl.containers.forEach(function (c, i) {
            // ignore splitter bars, auto-sized panes, and completely hidden panes
            if (i % 2 === 0 && sizes[i] !== 'auto' && sizes[i] !== 0) {
              c.element.attr('size', Math.min(100, sizes[i]) + '%');
              c.previousSize = sizes[i] + '%';
            }
          });
        }
      }
    };
  }]).directive('uiSplitbar', ['LayoutContainer', function (LayoutContainer) {
    // Get all the page.
    var htmlElement = angular.element(document.body.parentElement);

    return {
      restrict: 'EAC',
      require: '^uiLayout',
      scope: {},

      link: function link(scope, element, attrs, ctrl) {
        element.addClass('stretch');
        element.addClass('ui-splitbar');

        var animationClass = ctrl.isUsingColumnFlow ? 'animate-column' : 'animate-row';
        element.addClass(animationClass);

        scope.splitbar = LayoutContainer.Splitbar();
        scope.splitbar.element = element;

        element.on('mousedown touchstart', function handleMouseDown(e) {
          if (e.button === 0 || e.type === 'touchstart') {
            // only trigger when left mouse button is pressed:
            e.preventDefault();
            e.stopPropagation();

            ctrl.mouseDownHandler(scope.splitbar);

            htmlElement.on('mousemove touchmove', handleMouseMove);
            return false;
          }
        });

        function handleMouseMove(event) {
          scope.$apply(function () {
            return ctrl.mouseMoveHandler(event);
          });
        }

        function handleMouseUp() {
          scope.$apply(ctrl.mouseUpHandler);
          htmlElement.off('mousemove touchmove', handleMouseMove);
        }

        htmlElement.on('mouseup touchend', handleMouseUp);

        scope.$watch('splitbar.size', function (newValue) {
          element.css(ctrl.sizeProperties.sizeProperty, newValue + 'px');
        });

        scope.$watch('splitbar.' + ctrl.sizeProperties.flowProperty, function (newValue) {
          element.css(ctrl.sizeProperties.flowProperty, newValue + 'px');
        });

        //Add splitbar to layout container list
        ctrl.addContainer(scope.splitbar);

        element.on('$destroy', function () {
          ctrl.removeContainer(scope.splitbar);
          htmlElement.off('mouseup touchend', handleMouseUp);
          htmlElement.off('mousemove touchmove', handleMouseMove);
          scope.$evalAsync();
        });
      }
    };
  }]).directive('uiLayoutContainer', ['LayoutContainer', '$compile', function (LayoutContainer, $compile) {
    return {
      restrict: 'AE',
      require: '^uiLayout',
      scope: {
        resizable: '=',
        size: '@',
        minSize: '@',
        maxSize: '@'
      },

      compile: function compile() {
        return {
          pre: function pre(scope, element, attrs, ctrl) {
            scope.container = LayoutContainer.Container();
            scope.container.element = element;
            scope.container.id = element.attr('id') || null;
            scope.container.layoutId = ctrl.id;
            scope.container.isCentral = attrs.uiLayoutContainer === 'central';

            if (angular.isDefined(scope.resizable)) {
              scope.container.resizable = scope.resizable;
            }
            scope.container.size = scope.size;
            scope.container.previousSize = scope.size;
            scope.container.minSize = scope.minSize;
            scope.container.maxSize = scope.maxSize;
            ctrl.addContainer(scope.container);

            element.on('$destroy', function () {
              ctrl.removeContainer(scope.container);
              scope.$evalAsync();
            });
          },
          post: function post(scope, element, attrs, ctrl) {
            element.addClass('stretch');
            element.addClass('ui-layout-container');

            var animationClass = ctrl.isUsingColumnFlow ? 'animate-column' : 'animate-row';
            element.addClass(animationClass);

            scope.$watch('container.size', function (newValue) {
              element.css(ctrl.sizeProperties.sizeProperty, newValue + 'px');
              if (newValue === 0) {
                element.addClass('ui-layout-hidden');
              } else {
                element.removeClass('ui-layout-hidden');
              }
            });

            scope.$watch('container.' + ctrl.sizeProperties.flowProperty, function (newValue) {
              element.css(ctrl.sizeProperties.flowProperty, newValue + 'px');
            });

            //TODO: add ability to disable auto-adding a splitbar after the container
            var parent = element.parent();
            var children = parent.children();
            var index = ctrl.indexOfElement(element);
            var splitbar = angular.element('<div ui-splitbar></div>');
            if (0 < index && !ctrl.hasSplitbarBefore(scope.container)) {
              angular.element(children[index - 1]).after(splitbar);
              $compile(splitbar)(scope);
            } else if (index < children.length - 1) {
              element.after(splitbar);
              $compile(splitbar)(scope);
            }
          }
        };
      }
    };
  }]).factory('Layout', function () {
    var layouts = [];

    return {
      addLayout: function addLayout(ctrl) {
        ctrl.id = layouts.length;
        layouts.push(ctrl);
      }
    };
  }).factory('LayoutContainer', function () {
    function BaseContainer() {
      /**
       * Stores element's id if provided
       * @type {string}
       */
      this.id = null;

      /**
       * Id of the parent layout
       * @type {number}
       */
      this.layoutId = null;

      /**
       * Central container that is always resized
       * @type {boolean}
       */
      this.isCentral = false;

      /**
       * actual size of the container, which is changed on every updateDisplay
       * @type {any}
       */
      this.size = UI_LAYOUT_AUTO_SIZE;

      /**
       * cache for the last uncollapsed size
       * @type {any}
       */
      this.previousSize = null;

      this.maxSize = null;
      this.minSize = null;
      this.resizable = true;
      this.element = null;
    }

    // Splitbar container
    function SplitbarContainer() {
      this.size = 10;
      this.left = 0;
      this.top = 0;
      this.element = null;
    }

    return {
      Container: function Container(initialSize) {
        return new BaseContainer(initialSize);
      },
      Splitbar: function Splitbar() {
        return new SplitbarContainer();
      },
      isSplitbar: function isSplitbar(container) {
        return container instanceof SplitbarContainer;
      }
    };
  });

  /* eslint-disable angular/timeout-service */

  var scrollMonitorServiceModule = angular.module('Q.services.scroll-monitor-service', [nodeChangeListenerServiceModule, windowEventHelperModule])

  /**
   * A service to make it easier to monitor scrolling and perform updates based on it.
   *
   * The service reduces event listeners by grouping scroll listeners per item, and also sharing a single
   * window.resize listener across all scroll listeners.
   *
   * The individual node scroll listeners can further benefit by including an optional element with the event
   * listener.  In this case, the single onScroll event will also update whether or not the item is visible,
   * and set it on the scroll listener return object.
   *
   */
  .factory('scrollMonitorService', ['$document', '$window', 'nodeChangeListener', '$rootScope', '$timeout', '$log', function ($document, $window, nodeChangeListener, $rootScope, $timeout, $log) {
    var scrollListeners = [];
    var doc = $document[0];

    /**
     * Creates a Listener for scroll-related events on a given viewport (DOM node or $window)
     */

    var Listener = function () {
      /**
       * Create a new Listener object
       * @param viewport {string|HTMLElement} The viewport on which we want to listen, defaults to window
       */
      function Listener(viewport) {
        var _this = this;

        classCallCheck(this, Listener);

        this.viewport = viewport;
        this.$viewport = angular.element(viewport);
        this.scrollWatchers = [];
        this.lastScrollTop = 0;
        this.lastHeight = 0;
        this.$destroyed = false;

        this.scrollTrigger = this.triggerUpdate.bind(this);
        this.$viewport.on('scroll touchmove', this.scrollTrigger);
        // ensure we always clean up if the dom node is destroyed
        this.$viewport.on('$destroy', function () {
          return _this.destroy();
        });

        // for non-window-level watches, we also look for DOM changes
        // otherwise, the resize event should be good enough
        if (viewport.nodeType) {
          this.nodeChangeListenerStop = nodeChangeListener.listen(viewport, function (event) {
            _this.triggerUpdate(event, true);
          });
        }

        scrollListeners.push(this);
      }

      /**
       * Trigger an update to all registered scrollWatchers
       * The goal with this design was to minimize calculation of the same data as much as possible.
       * If we have hundreds of event listeners, we don't want to perform the same work looking them up
       * every time.
       *
       * @param {Event} event The Event object for this update
       * @param {boolean} forceUpdate If true, forces an update regardless of scroll or height changes
       */


      createClass(Listener, [{
        key: 'triggerUpdate',
        value: function triggerUpdate(event, forceUpdate) {
          if (this.$destroyed) return;

          var viewport = this.$viewport;
          var viewportScrollTop = viewport.scrollTop();
          var viewportHeight = viewport.offsetHeight();

          if (forceUpdate !== true && viewportScrollTop === this.lastScrollTop && viewportHeight === this.lastHeight) return;

          this.lastScrollTop = viewportScrollTop;
          this.lastHeight = viewportHeight;

          var viewportTop = this.$viewport.offsetTop();

          var len = this.scrollWatchers.length;
          var i = len - 1;
          var sw = void 0;
          var elementTop = void 0;
          var elementHeight = void 0;
          var data = void 0;

          for (; i >= 0; i--) {
            if (viewport.length === 0) {
              $log.error("Invariant violation: expected viewport[0] to be defined but it wasn't");
              continue;
            }

            data = {
              viewport: viewport,
              viewportTop: viewportTop,
              viewportHeight: viewportHeight,
              viewportScrollTop: viewportScrollTop,
              viewportScrollHeight: viewport[0].scrollHeight
            };
            sw = this.scrollWatchers[i];
            if (sw) {
              if (sw.$elem) {
                // note whether the element is visible
                elementTop = sw.$elem.offsetTop();
                elementHeight = sw.elem.offsetHeight;
                data.element = sw.elem;
                data.elementTop = elementTop;
                data.elementHeight = elementHeight;
                Listener._setIsVisible(viewportTop, viewportHeight, viewportScrollTop, sw, data);
              }
              sw.notify(event, data);
            }
          }
        }

        /**
         * Mainly used to set the initial isVisible value on a ScrollWatcher, but it can also be used to
         * update the isVisible value out-of-band
         *
         * @param scrollWatcher
         */

      }, {
        key: 'setIsVisible',
        value: function setIsVisible(scrollWatcher) {
          Listener._setIsVisible(this.$viewport.offsetTop(), this.$viewport.offsetHeight(), this.$viewport.scrollTop(), scrollWatcher, {});
        }
      }, {
        key: 'addScrollWatcher',
        value: function addScrollWatcher(scrollWatcher) {
          var _this2 = this;

          if (this.$destroyed) return;
          this.scrollWatchers.push(scrollWatcher);
          $timeout.cancel(this._swAddedEvent);
          this._swAddedEvent = $timeout(function () {
            _this2.triggerUpdate(new CustomEvent('scrollWatcherAdded'), true);
          });
        }
      }, {
        key: 'removeScrollWatcher',
        value: function removeScrollWatcher(scrollWatcher) {
          var idx = this.scrollWatchers.indexOf(scrollWatcher);
          if (idx > -1) {
            this.scrollWatchers.splice(idx, 1);
            if (this.scrollWatchers.length === 0) {
              this.destroy();
            }
          }
        }
      }, {
        key: 'destroy',
        value: function destroy() {
          this.$viewport.off('scroll touchmove', this.scrollTrigger);
          if (this.nodeChangeListenerStop) {
            this.nodeChangeListenerStop();
          }
          this.scrollWatchers.length = 0;
          var idx = scrollListeners.indexOf(this);
          if (idx > -1) {
            scrollListeners.splice(idx, 1);
          }
          this.$destroyed = true;
        }
      }], [{
        key: '_setIsVisible',
        value: function _setIsVisible(viewportTop, viewportHeight, viewportScrollTop, scrollWatcher, data) {
          var elementTop = scrollWatcher.$elem.offsetTop() - viewportTop;
          var elementHeight = scrollWatcher.elem.offsetHeight;
          data.element = scrollWatcher.elem;
          data.elementTop = elementTop;
          data.elementHeight = elementHeight;
          scrollWatcher.isVisible = data.isVisible =
          // ensure the top is above the bottom of the viewport (with optional offset)
          viewportScrollTop + viewportHeight + scrollWatcher.offset > elementTop &&
          // ensure the bottoms is below the top of the viewport (with optional offset)
          viewportScrollTop - scrollWatcher.offset < elementTop + elementHeight;
        }
      }]);
      return Listener;
    }();

    var ScrollWatcher = function () {
      function ScrollWatcher(listener, callback, elem) {
        var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        classCallCheck(this, ScrollWatcher);

        this.listener = listener;
        this.callback = callback;
        if (elem) {
          elem = _getElement(elem);
          this.elem = elem;
          this.$elem = angular.element(elem);
          this.offset = offset;
          this.update();
        }
      }

      createClass(ScrollWatcher, [{
        key: 'update',
        value: function update() {
          this.listener.setIsVisible(this);
        }
      }, {
        key: 'notify',
        value: function notify(event, data) {
          this.callback(event, data, this);
        }
      }, {
        key: 'destroy',
        value: function destroy() {
          this.listener.removeScrollWatcher(this);
        }
      }]);
      return ScrollWatcher;
    }();

    var svc = {
      /**
       * Adds a scroll listener to the provided viewport.
       *
       * @param viewport {HTMLElement|String} The node or selector for the node to watch
       * @param callback {function} The callback function on scroll (will be called with event, viewportData, and ScrollWatcher arguments
       * @param elem {HTMLElement|String} Optional element to monitor for visibility and offset information
       * @param offset Optional value for adding an offset when calculating whether the elem is visible or not
       * @returns {ScrollWatcher}
       */
      addListener: function addListener(viewport, callback) {
        var elem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

        viewport = _getElement(viewport);
        var listener = scrollListeners.find(function (e) {
          return e.viewport === viewport;
        });
        if (!listener) {
          listener = new Listener(viewport);
        }

        var scrollWatcher = new ScrollWatcher(listener, callback, elem, offset);

        listener.addScrollWatcher(scrollWatcher);
        return scrollWatcher;
      },
      updateListeners: function updateListeners(event) {
        var i = 0;
        var len = scrollListeners.length;
        for (; i < len; i++) {
          if (!scrollListeners[i]) {
            $log.error("Invariant violation: scrollListeners[i] was supposed to be defined but wasn't");
            continue;
          }

          scrollListeners[i].triggerUpdate(event, true);
        }
      }
    };

    // on resize, fire all scroll listeners, but use only one listener for the whole application
    $rootScope.$on(WINDOW_EVT_RESIZE, function ($e, event) {
      return svc.updateListeners(event);
    });

    // also capture ui layout events
    $rootScope.$on(UI_LAYOUT_EVT_DRAW_COMPLETE, svc.updateListeners);

    return svc;

    //// private methods

    // returns a pure DOM element, or window if none provided
    function _getElement(elem) {
      if (!elem) return $window;

      if (angular.isString(elem)) {
        elem = doc.querySelector(elem);
      } else if (elem.length) {
        elem = elem[0];
      }

      if (!elem) {
        throw new Error('Unable to find element for scrollMonitorService: ' + elem);
      }

      if (elem.nodeType === 9) {
        elem = $window;
      }

      return elem;
    }
  }]);

  var uiBootstrapPositionModule = 'ui.bootstrap.position';

  var positionHelperModule = angular.module('Q.helpers.position-helper', [uiBootstrapPositionModule, scrollMonitorServiceModule]).factory('positionHelper', ['$window', '$document', '$position', 'scrollMonitorService', '$timeout', function ($window, $document, $position, scrollMonitorService, $timeout) {
    /**
     * Positions the popup around the element once
     *
     * @param element {Node} Element to position around
     * @param popup {Node} Popup element
     * @param position {String} position property
     * @param hasArrow {boolean} If true, align the nested arrow as well
     * @param setMinWidth {boolean} If true, set the min width to the element width
     * @param mousePosition {Object} If provided, the popup is oriented around the {pageX,pageY} properties
     */
    function positionPopup(element, popup) {
      var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'bottom';

      var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
          _ref$hasArrow = _ref.hasArrow,
          hasArrow = _ref$hasArrow === undefined ? false : _ref$hasArrow,
          _ref$setMinWidth = _ref.setMinWidth,
          setMinWidth = _ref$setMinWidth === undefined ? false : _ref$setMinWidth,
          _ref$mousePosition = _ref.mousePosition,
          mousePosition = _ref$mousePosition === undefined ? null : _ref$mousePosition;

      // don't move the popup if the element isn't attached
      if (!element.isVisible()) return;

      var popupPosition = $position.positionElements(element, popup, position, true);

      // params for making sure the node stays on-screen
      var horizontal = /^left/.test(position) || /^right/.test(position);
      var vertical = /^bottom/.test(position) || /^top/.test(position);
      var $body = angular.element($document[0].body);
      var $win = angular.element($window);
      var winWidth = Math.min($body.offsetWidth(), $win.offsetWidth());
      var winHeight = Math.max($body.offsetHeight(), $win.offsetHeight());
      var popupWidth = popup.offsetWidth();
      var popupHeight = popup.offsetHeight();
      var arrowOffsetAdjustment = 18;
      var arrowAdjustments = { x: 0, y: 0 };

      if (mousePosition) {
        var elBounds = element[0].getBoundingClientRect();
        if (vertical) {
          // top and bottom are horizontally centered
          popupPosition.left += mousePosition.pageX - (elBounds.left + elBounds.width / 2);
        } else if (position === 'right') {
          popupPosition.left -= elBounds.right - mousePosition.pageX;
        } else {
          popupPosition.left += mousePosition.pageX - elBounds.left;
        }
        if (horizontal) {
          // left and right are vertically centered
          popupPosition.top += mousePosition.pageY - (elBounds.top + elBounds.height / 2);
        } else if (position === 'top') {
          popupPosition.top -= elBounds.top - mousePosition.pageY;
        } else {
          popupPosition.top += elBounds.top - mousePosition.pageY;
        }
      }

      popupPosition['margin-left'] = null;
      popupPosition['margin-right'] = null;
      popupPosition['margin-top'] = null;
      popupPosition['margin-bottom'] = null;

      if (setMinWidth) {
        popupPosition['min-width'] = element.offsetWidth() + 'px';
      }

      // ensure we're not off the right edge
      if (popupPosition.left + popupWidth > winWidth - 2) {
        var finalLeft = winWidth - 2 - popupWidth;
        if (vertical && hasArrow) {
          arrowAdjustments.x = Math.min((popupWidth - arrowOffsetAdjustment) / 2, popupPosition.left - finalLeft);
        }
        popupPosition['margin-right'] = '0px';
        popupPosition.left = finalLeft;
      }
      // ensure we're not off the left edge (overrides right side)
      if (popupPosition.left < 2) {
        if (vertical && hasArrow) {
          arrowAdjustments.x = Math.max((arrowOffsetAdjustment - popupWidth) / 2, popupPosition.left - 2);
        }
        popupPosition['margin-left'] = '0px';
        popupPosition.left = 2;
      }
      // ensure we're not off the bottom edge
      if (popupPosition.top + popupHeight > winHeight - 2) {
        var finalTop = winHeight - 2 - popupHeight;
        if (horizontal && hasArrow) {
          arrowAdjustments.y = Math.min((popupHeight - arrowOffsetAdjustment) / 2, popupPosition.top - finalTop);
        }
        popupPosition['margin-top'] = '0px';
        popupPosition.top = finalTop;
      }
      // ensure we're not off the top edge (overrides bottom side)
      if (popupPosition.top < 2) {
        if (horizontal && hasArrow) {
          arrowAdjustments.y = Math.max((arrowOffsetAdjustment - popupHeight) / 2, popupPosition.top - 2);
        }
        popupPosition['margin-bottom'] = '0px';
        popupPosition.top = 2;
      }

      // final styling changes
      popupPosition.top += 'px';
      popupPosition.left += 'px';

      popup.css(popupPosition);
      // offset arrow if necessary
      if (hasArrow) {
        popup.querySelector('.arrow').css({
          transform: 'translate(' + arrowAdjustments.x + 'px, ' + arrowAdjustments.y + 'px)'
        });
      }
    }

    /**
     * Automatically positions the popup near the element, and watches to ensure it stays in place.
     *
     * @param $scope Scope for listening on
     * @param element Element to position around
     * @param popup Popup element
     * @param position position property
     * @param opts Options passed to the positionPopup function
     * @returns {function()} Deregistration function, only necessary if the popup is closed before the scope is destroyed
     */
    function autoPositionPopup($scope, element, popup, position, opts) {
      popup.css({ opacity: 0 });

      function setPosition() {
        $timeout(function () {
          positionPopup(element, popup, position, opts);
          popup.css({ opacity: null });
        }, 0, false);
      }

      setPosition();

      if (opts.mousePosition) {
        // only position once if we're using mouse position
        return angular.noop;
      }

      var scrollMonitor = scrollMonitorService.addListener(element.scrollableParent(), setPosition);
      var unlistenDestroy = $scope.$on('$destroy', function () {
        return scrollMonitor.destroy();
      });
      var unlistenWatch = $scope.$watch(setPosition);

      return function () {
        scrollMonitor.destroy();
        unlistenDestroy();
        unlistenWatch();
      };
    }

    function topOrBottom(el, estimatedHeight) {
      var position = 'bottom';
      // if within 200px (or 1/3) of the bottom, switch to top
      var elOffset = el.offset();
      var parent = el.scrollableParent();
      var parentOffset = parent.offset();
      var variance = Math.max(estimatedHeight || 0, Math.min(200, parentOffset.height / 3));
      if (elOffset.bottom - parent.scrollTop() > parentOffset.bottom - variance) {
        position = 'top';
      }
      return position;
    }

    return {
      autoPositionPopup: autoPositionPopup,
      positionPopup: positionPopup,
      topOrBottom: topOrBottom
    };
  }]);

  // This really doesn't do anything, but makes the import code more consistent;
  var ngSanitizeModule = 'ngSanitize';
  var ngAnimateModule = 'ngAnimate';

  /* eslint-disable angular/timeout-service */

  var doc$1 = window.document;

  function fixQuery(s) {
    // corrects IDs that aren't valid CSS-style IDs
    return s.replace(/#([^a-z][-\w]+)/gi, '[id="$1"]');
  }

  function querySelector(s) {
    return isString(s) ? doc$1.querySelector(fixQuery(s)) : s;
  }

  var scrollToComponentModule = angular.module('Q.components.scroll-to', []).directive('scrollTo', ['$window', 'scrollToElement', '$timeout', function ($window, scrollToElement, $timeout) {
    return {
      restrict: 'A',
      link: function link(scope, elem, attrs) {
        // used so we don't replace the history state on page load
        var initialLoad = false;

        elem.on('click', function (event) {
          var target = _getTarget(attrs);

          event.preventDefault();
          if (!initialLoad && _isAnchor(target) && $window.history && $window.history.replaceState) {
            $window.history.replaceState({}, '', $window.location.href.replace(/#.*/, '') + target);
          }
          initialLoad = false;

          scrollToElement({
            target: target,
            scrollTarget: attrs.scrollTarget,
            relativeParent: attrs.relativeParent
          });

          elem[0].blur();
        });

        var hash = $window.location.hash;

        $timeout(function () {
          // handle page-loads
          var target = _getTarget(attrs);
          if (_isAnchor(target) && hash === target) {
            initialLoad = true;
            $timeout(function () {
              return elem.triggerHandler('click');
            });
          }
        }, 250);
      }
    };

    //// private functions

    function _isAnchor(target) {
      return (/^#/.test(target)
      );
    }

    function _getTarget(attrs) {
      var target = attrs.scrollTo;
      if (!target) {
        target = attrs.href;
        if (target) {
          target = target.replace(/.*#/, '#');
        }
      }
      return target;
    }
  }]).directive('scrollHere', ['scrollToElement', '$timeout', function (scrollToElement, $timeout) {
    return {
      restrict: 'A',
      link: function link(scope, elem, attrs) {
        $timeout(function () {
          if (attrs.scrollHere && !scope.$eval(attrs.scrollHere)) {
            return;
          }
          scrollToElement({
            target: elem[0],
            scrollTarget: attrs.scrollTarget,
            relativeParent: attrs.relativeParent,
            offset: attrs.scrollOffset || 0,
            ignoreIfVisible: true
          });
        }, 250);
      }
    };
  }]).factory('preserveScroll', ['$timeout', function ($timeout) {
    return function (target, changeEvent) {
      var $target = angular.element(querySelector(target));
      var scrollParent = $target.scrollableParent();
      // determine current offset from top of parent frame
      var diff = $target.offsetTop() - scrollParent.scrollTop();

      // enable event to change
      var newTarget = changeEvent();
      $timeout(function () {
        // after a digest cycle, adjust the scroll so we don't appear to have changed
        if (newTarget) {
          target = newTarget;
        }
        // re-look up the node if necessary
        var $target = angular.element(querySelector(target));
        scrollParent.scrollTop($target.offsetTop() - diff);
      });
    };
  }]).factory('scrollToElement', ['$window', '$document', '$rootScope', '$q', function ($window, $document, $rootScope, $q) {
    var animFrame = void 0;

    /**
     * Scrolls to a target element
     * @param target {string|HTMLElement|angular.element} Element to scroll to (required)
     * @param scrollTarget {string|HTMLElement|angular.element?} Element to scroll. If not provided, determined automatically
     * @param relativeParent {string|HTMLElement|angular.element?} If provided, used to determine the top of the element for relatively positioned elements
     * @param ignoreIfVisible {boolean?} If true, don't scroll if the element is already visible
     * @param offset {number?} If provided, offset the final value by this much
     * @param center {boolean|number?} If true, center the item in the view. If a number, it should be between 0 and 1, and is used to offset the value by that %. .5 is centered, .25 is 1/4 from the top, etc.
     * @returns {*}
     */
    function scrollToElement(_ref) {
      var target = _ref.target,
          scrollTarget = _ref.scrollTarget,
          relativeParent = _ref.relativeParent,
          ignoreIfVisible = _ref.ignoreIfVisible,
          _ref$offset = _ref.offset,
          offset = _ref$offset === undefined ? 0 : _ref$offset,
          _ref$center = _ref.center,
          center = _ref$center === undefined ? false : _ref$center;

      if (animFrame) {
        $window.cancelAnimationFrame(animFrame);
        animFrame = null;
      }

      var _calculateScrollTo2 = _calculateScrollTo(target, scrollTarget, relativeParent, offset, center),
          $scrollTarget = _calculateScrollTo2.$scrollTarget,
          scrollOffset = _calculateScrollTo2.scrollOffset,
          scrollRelative = _calculateScrollTo2.scrollRelative,
          isVisible$$1 = _calculateScrollTo2.isVisible;

      if (!$scrollTarget || ignoreIfVisible && isVisible$$1 || !scrollRelative) {
        return $q.resolve(false);
      }

      var animTime = Math.min(500, Math.abs(scrollRelative));
      var start = Date.now();

      var deferred = $q.defer();

      $rootScope.$broadcast('scrollTo.scrolling', true);
      _animateScroll();

      return deferred.promise;

      //// private functions

      function _animateScroll() {
        var now = Date.now();
        var percentTime = (now - start) / animTime;
        var percentScroll = percentTime >= 1 ? 1 : 0.5 + Math.cos(percentTime * Math.PI - Math.PI) / 2;
        var currentScrollTo = scrollOffset + Math.ceil(percentScroll * scrollRelative);

        $scrollTarget.scrollTop(currentScrollTo);

        // continue until done
        if (percentScroll < 1) {
          animFrame = $window.requestAnimationFrame(_animateScroll);
        } else {
          $rootScope.$broadcast('scrollTo.scrolling', false);
          animFrame = null;
          deferred.resolve(true);
        }
      }
    }

    scrollToElement.query = _query;

    return scrollToElement;

    function _query(node) {
      return angular.isString(node) ? querySelector(node) : node;
    }

    function _calculateScrollTo(target, scrollTarget, relativeParent) {
      var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var center = arguments[4];

      target = _query(target);
      if (!target) return {};

      var $target = angular.element(target);
      var targetHeight = $target.offsetHeight();

      scrollTarget = scrollTarget ? _query(scrollTarget) : $target.scrollableParent()[0];
      relativeParent = relativeParent || scrollTarget;

      var $scrollTarget = angular.element(scrollTarget);
      var scrollTargetHeight = $scrollTarget.offsetHeight();
      var relativeParentTop = 0;
      if (relativeParent && relativeParent !== $window) {
        relativeParentTop = angular.element(_query(relativeParent)).offsetTop();
      }
      if (offset && angular.isString(offset)) {
        offset = angular.element(_query(offset)).offsetHeight();
      }

      // calculate the final scroll value
      var scrollTo = $target.offsetTop() - relativeParentTop - $scrollTarget.getFixedNodeOffsets();
      if (center && targetHeight < scrollTargetHeight) {
        var centeringOffsetRatio = angular.isNumber(center) ? center : 0.5;
        // try to center the node in the view
        scrollTo -= (scrollTargetHeight - targetHeight) * centeringOffsetRatio;
      }
      scrollTo -= offset;

      var scrollOffset = $scrollTarget.scrollTop();
      var scrollRelative = scrollTo - scrollOffset;
      var targetBottom = scrollTo + targetHeight;
      var scrollTargetBottom = scrollOffset + scrollTargetHeight;
      var isVisible$$1 = scrollTo > scrollOffset && targetBottom < scrollTargetBottom;

      return {
        scrollTo: scrollTo,
        scrollOffset: scrollOffset,
        scrollRelative: scrollRelative,
        $scrollTarget: $scrollTarget,
        isVisible: isVisible$$1
      };
    }
  }]);

  var IS_MAC = window.navigator.userAgent.includes('Mac OS X');
  var IS_WINDOWS = window.navigator.userAgent.includes('Windows');

  var keycodesModule = angular.module('Q.constants.keycodes', []).constant('KeyCodes', {
    // Use $event.which === KeyCodes.KEY_NAME for correct matching
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    RETURN: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    ESCAPE: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT_ARROW: 37,
    UP_ARROW: 38,
    RIGHT_ARROW: 39,
    DOWN_ARROW: 40,
    INSERT: 45,
    DELETE: 46,
    COMMAND: 224,
    // some useful utility & display properties
    IS_MAC: IS_MAC,
    COMMAND_KEY: IS_MAC ? 'Cmd' : 'Ctrl',
    isCommand: function isCommand(event) {
      return !!event[IS_MAC ? 'metaKey' : 'ctrlKey'];
    },
    isShift: function isShift(event) {
      return !!event.shiftKey;
    },
    isAlt: function isAlt(event) {
      return !!event.altKey;
    },

    SYMBOLS: {
      COMMAND_KEY: IS_MAC ? '\u2318' : 'Ctrl',
      ALT_KEY: IS_MAC ? '\u2325' : 'Alt',
      CONTROL_KEY: IS_MAC ? '\u2303' : 'Ctrl',
      SHIFT_KEY: IS_MAC ? '\u21E7' : 'Shift',
      LEFT_ARROW: '\u2190',
      UP_ARROW_ARROW: '\u2190',
      RIGHT_ARROW: '\u2192',
      DOWN_ARROW: '\u2193',
      ENTER: IS_MAC ? '\u23CE' : 'Enter'
    }
  }).run(['$rootScope', 'KeyCodes', function ($rootScope, KeyCodes) {
    $rootScope.KeyCodes = KeyCodes;
  }]);

  var _compiledTemplate = void 0;
  var _compiledMenuTemplate = void 0;

  var bubbleDialogComponentModule = angular.module('Q.components.bubble-dialog', [ngSanitizeModule, positionHelperModule, scrollToComponentModule, keycodesModule])

  /**
   * @docType shared
   * @category service
   * @name Bubble-Dialog-Service
   * @description
   * A service that allows you to create a bubble dialog
   * @returns A factory object {object}
   */
  .factory('bubbleDialogService', ['$compile', '$rootScope', '$templateRequest', '$timeout', '$q', '$document', '$window', '$animate', 'positionHelper', 'scrollToElement', 'KeyCodes', function ($compile, $rootScope, $templateRequest, $timeout, $q, $document, $window, $animate, positionHelper, scrollToElement, KeyCodes) {
    /**
     * @parent Bubble-Dialog-Service
     * @name open
     * @description
     * A method that will open a bubble dialog on an element
     * @param scope {$rootScope.Scope} The angular scope to use for the bubble dialog's content (will be inherited)
     * @param {Object} el An element to position the bubble dialog relative to
     * @param {Object} opts A series of options that allow you configure the bubble dialog (title, content, buttons, position)
     * @param {string?} opts.content Optional content for the dialog (HTML OK) (req'd if no template)
     * @param {string?} opts.contentTemplate Optional content as template for the dialog (will be compiled)
     * @param {string?} opts.template Optional complete template for the dialog (must include all of the popover elements)
     * @param {string?} opts.menu Optional menu template for the dialog, which is used to render the bubble as a dropdown menu (handles layout, styling)
     * @param {string?} opts.position Optional text value indicating where to show the popup. Default is above or below based on how close `el` is to the window edge
     * @param {string?} opts.positionArrow If provided, use to center the tooltip
     * @param {boolean?} opts.closeable If true, then show a close button when hovering over the bubble
     * @param {string?} opts.title Optional title for the dialog
     * @param {string?} opts.className Optional class name to add to the dialog
     * @param {Array<Object>?} opts.buttons Optional buttons to append to the end
     * @param {number?} opts.delay If provided, delays showing the bubble for delay milliseconds
     * @param {number?} opts.estimatedHeight If provided, will be used to help determine default placement (top or bottom)
     * @param {Object?} opts.mousePosition If provided, anchors the bubble around this {pageX,pageY} point
     * @param {boolean?|string?} opts.autofocus If provided, enables focusing on the menu and keyboard navigation. If a string, used as the selector for the initial item
     * @returns {object} object representative of the bubble dialog instance just opened {object}
     */
    function open(scope, el, opts) {
      el = angular.element(el);
      var position = opts.position || positionHelper.topOrBottom(el, opts.estimatedHeight);
      var delayTimeout = null;
      var cancelDelayedRender = function cancelDelayedRender() {
        if (delayTimeout) {
          $timeout.cancel(delayTimeout);
          delayTimeout = null;
        }
      };

      var existingBubbleInstance = el.data('bubbleDialog');
      if (existingBubbleInstance && existingBubbleInstance.scope && !existingBubbleInstance.closed) {
        if (!opts.buttons && !opts.template && !opts.menu) {
          // just update scope
          existingBubbleInstance.scope.title = opts.title;
          existingBubbleInstance.scope.content = opts.content;
          existingBubbleInstance.scope.contentTemplate = opts.contentTemplate;
          existingBubbleInstance.scope.position = position;
          return existingBubbleInstance;
        } else {
          // destroy the existing bubble (can't have multiple on an element)
          existingBubbleInstance.closeImmediately();
        }
      }

      var bubbleScope = void 0;
      var bubbleEl = void 0;
      var stateChangeDereg = void 0;
      var scopeDereg = void 0;
      var deferred = $q.defer();

      var bubbleInstance = {
        scope: null,
        bubbleElement: null,
        target: el[0],
        showNow: function showNow() {
          if (!bubbleInstance.rendering) {
            renderBubble();
          }
        },
        close: function close() {
          bubbleInstance.closed = true;
          stateChangeDereg && stateChangeDereg();
          scopeDereg && scopeDereg();
          cancelDelayedRender();
          if (bubbleScope) {
            bubbleScope.remove();
          } else if (bubbleEl) {
            // ensure the node isn't stuck on screen for some reason
            bubbleEl.remove();
          }
          // remove from element
          el.data('bubbleDialog', null);
          deferred.reject('closed');
        },
        closeImmediately: function closeImmediately() {
          bubbleInstance.immediate = true;
          bubbleInstance.close();
        },

        result: deferred.promise
      };
      // never persist across page changes
      stateChangeDereg = scope.$on('$stateChangeStart', bubbleInstance.closeImmediately);
      scopeDereg = scope.$on('$destroy', bubbleInstance.closeImmediately);

      function setHandlers(enable) {
        var method = enable ? 'on' : 'off';
        bubbleEl[method]('click touchstart', stopBubbling);
        // Removed because it was causing unexpected behavior with tooltips nested inside links
        // Could not resolve the original reasoning behind stopping bubbling
        // el[method]("click touchstart", EventUtils.stopBubbling);
        $document[method]('keydown', escapeKeyDown);
        $document[method]('mousedown', escapeClick);
        // on mobile, these functions make sure we don't close on scroll (or long press) events
        $document[method]('touchstart', escapeTouchStart);
        $document[method]('touchend', escapeTouchEnd);
      }

      function isOutsideNode(event) {
        var target = event.target;
        var bubbleNode = bubbleInstance.bubbleElement;
        return target && bubbleNode && !bubbleNode[0].contains(target) && !el[0].contains(target);
      }

      function escapeKeyDown(event) {
        if (event.which === 27) {
          deferred.reject('escape key press');
        }
      }

      function escapeClick(event) {
        if (isOutsideNode(event)) {
          deferred.reject('user clicked elsewhere');
        }
      }

      var touchStartTime = -Infinity;

      function escapeTouchStart() {
        touchStartTime = Date.now();
      }

      function escapeTouchEnd(event) {
        if (Date.now() - touchStartTime < 150) {
          escapeClick(event);
        }
      }

      function renderBubble() {
        if (bubbleInstance.closed || !bubbleInstance.compiledTemplate) return;
        bubbleInstance.rendering = true;
        cancelDelayedRender();
        el.addClass('bubble-showing');

        bubbleInstance.scope = bubbleScope = scope.$new();
        bubbleScope.closeable = opts.closeable;
        bubbleScope.title = opts.title;
        bubbleScope.content = opts.content;
        bubbleScope.contentTemplate = opts.contentTemplate;
        bubbleScope.buttons = opts.buttons;
        bubbleScope.className = (opts.className || '') + (opts.title ? ' titled' : '');
        bubbleScope.menu = opts.menu;
        bubbleScope.position = position;
        bubbleScope.positionClass = position.split('-')[0] + ' ' + position;
        bubbleScope.removing = false;

        bubbleScope.remove = function () {
          if (bubbleScope.removing) return;
          el.removeClass('bubble-showing');

          bubbleScope.removing = true;

          if (bubbleEl) {
            setHandlers(false);
            bubbleScope.$applyAsync(function () {
              if (bubbleInstance.immediate) {
                bubbleEl.remove();
                bubbleScope.$destroy();
              } else {
                $animate.removeClass(bubbleEl, 'showing').then(function () {
                  bubbleEl.remove();
                  bubbleScope.$destroy();
                });
              }
            });
          } else {
            bubbleScope.$destroy();
          }
        };
        deferred.promise.finally(bubbleInstance.close);

        bubbleInstance.compiledTemplate(bubbleScope, function (_bubbleEl) {
          if (bubbleInstance.closed) return;

          bubbleInstance.bubbleElement = bubbleEl = _bubbleEl;

          var $body = angular.element($document[0].body);

          $body.append(bubbleEl);

          $window.requestAnimationFrame(function () {
            positionHelper.autoPositionPopup(bubbleScope, opts.positionArrow || el, bubbleEl, position, {
              hasArrow: true,
              mousePosition: opts.mousePosition
            });
          });

          if (opts.menu) {
            // auto close on click for menus
            bubbleEl.on('click', bubbleInstance.close);
          }

          $animate.addClass(bubbleEl, 'showing').then(function () {
            bubbleInstance.rendering = true;
            deferred.notify({
              ready: true,
              element: bubbleEl
            });
          });

          if (opts.autofocus) {
            // focuses in on the first selectable item
            // Note: this only works well if everything has an explicit `tabindex`
            var selector = angular.isString(opts.autofocus) ? opts.autofocus : '[tabindex]';
            $timeout(function () {
              bubbleEl.querySelector(selector).focus();
              scrollToElement({
                target: opts.positionArrow || el,
                ignoreIfVisible: true,
                center: true
              });

              // setup keystrokes
              bubbleEl.querySelectorAll('[tabindex]').on('keydown', function (event) {
                var target = event.target;
                if (!target || KeyCodes.isCommand(event) || KeyCodes.isShift(event) || KeyCodes.isAlt(event)) {
                  return;
                }
                var which = event.which;
                if (which === KeyCodes.ENTER) {
                  stopEvent(event);
                  angular.element(target).triggerHandler('click');
                } else if (which === KeyCodes.DOWN_ARROW || which === KeyCodes.UP_ARROW) {
                  var nodes = bubbleEl.querySelectorAll('[tabindex]');
                  var idx = Array.from(nodes).indexOf(target) + (which === KeyCodes.DOWN_ARROW ? 1 : -1);
                  var focusNode = nodes[idx];
                  if (focusNode && focusNode.focus) {
                    stopEvent(event);
                    focusNode.focus();
                  }
                }
              });
            }, 100, false);
          }

          setHandlers(true);
        });
      }

      function setupBubble() {
        delayTimeout = $timeout(renderBubble, opts.delay || 0);
      }

      var compiledTemplate = _compiledTemplate;
      if (opts.template) {
        compiledTemplate = $compile(opts.template);
      } else if (opts.menu) {
        if (!_compiledMenuTemplate) {
          _compiledMenuTemplate = $compile(bubbleDialogMenuTemplate);
        }
        compiledTemplate = _compiledMenuTemplate;
      }
      if (!compiledTemplate) {
        compiledTemplate = _compiledTemplate = $compile(bubbleDialogTemplate);
      }
      bubbleInstance.compiledTemplate = compiledTemplate;
      $timeout(setupBubble, 0);

      el.data('bubbleDialog', bubbleInstance);

      if (opts.buttons) {
        opts.buttons.forEach(function (button) {
          button.resolve = function ($event) {
            stopEvent($event);
            deferred.resolve(button.title);
          };
        });
      }

      return bubbleInstance;
    }

    return {
      open: open
    };
  }])
  /**
   * @ngdoc directive
   * @docType shared
   * @category directive
   * @name bubbleDialog
   * @restrict A
   * @element ANY
   * @description
   * Pops up a bubble dialog window with a message.
   *
   * @param {expression} bubbleDialog Message to show
   * @param {expression} bubbleDialogTemplate content as template to show (overrides content)
   * @param {template} bubbleDialogTitle Optional title
   * @param {template} bubbleDialogPosition Optional position argument
   *
   * @returns Directive Definition Object {object}
   */
  .directive('bubbleDialog', ['bubbleDialogService', function (bubbleDialogService) {
    var ACTIVE_CLASS = 'bubble-dialog-active';
    return {
      restrict: 'A',
      require: '?^tooltip',
      link: function link(scope, element, attrs, tooltipCtrl) {
        var instance = null;

        element.on('click', function (event) {
          stopEvent(event);

          if (instance && !instance.closed) {
            instance.close();
            instance = null;
            if (tooltipCtrl) tooltipCtrl.setDisabled(false);
            element.removeClass(ACTIVE_CLASS);
          } else {
            if (tooltipCtrl) tooltipCtrl.setDisabled(true);
            element.addClass(ACTIVE_CLASS);

            instance = bubbleDialogService.open(scope, element, {
              title: attrs.bubbleDialogTitle,
              content: scope.$eval(attrs.bubbleDialog),
              contentTemplate: scope.$eval(attrs.bubbleDialogTemplate),
              position: attrs.bubbleDialogPosition || undefined,
              className: 'bubble-dialog-simple ' + (attrs.bubbleDialogClassName || '')
            });
          }
        });
      }
    };
  }]);

  var tooltipComponentModule = angular.module('Q.components.tooltip', [bubbleDialogComponentModule])

  /**
   * @ngdoc directive
   * @name tooltip
   * @description
   * A popover tooltip shown on mouseover
   * @element ANY
   * @param {template} tooltip - Text of the tooltip
   * @param {template} alt - Text of the tooltip unless specified by {@param tooltip}
   * @param {template} tooltipPosition - Position of the tooltip
   * @param {template} tooltipDelay - Adjust how long to wait before showing, defaults to 600
   * @param {template} tooltipShortcutHint - If provided, show a shortcut key hint
   *
   * @example
   * <example>
   * <div class="btn btn-default" tooltip="Simple Tooltip">Hover me!</div>
   * </example>
   */
  .directive('tooltip', ['bubbleDialogService', '$document', '$sce', function (bubbleDialogService, $document, $sce) {
    var lastInstance = void 0;

    return {
      restrict: 'A',
      controller: function controller() {
        var ctrl = this;
        ctrl.instance = null;
        ctrl.disabled = false;
        ctrl.setDisabled = function (disabled) {
          ctrl.disabled = disabled;
          if (disabled && ctrl.instance) {
            ctrl.instance.close();
            ctrl.instance = null;
          }
        };
      },
      require: ['tooltip', '?tooltipHelpIcon'],
      link: function link(scope, element, attrs, _ref) {
        var _ref2 = slicedToArray(_ref, 2),
            tooltipCtrl = _ref2[0],
            tooltipHelpIconCtrl = _ref2[1];

        var getContent = function getContent() {
          return attrs.tooltip || attrs.alt;
        };

        var isOpen = tooltipCtrl.isOpen = function () {
          return getContent() && !tooltipCtrl.disabled && tooltipCtrl.instance && !tooltipCtrl.instance.closed;
        };

        var open = tooltipCtrl.open = function () {
          var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

          if (getContent() && !tooltipCtrl.disabled) {
            if (isOpen()) {
              if (delay === 0 && tooltipCtrl.instance && lastInstance === tooltipCtrl.instance) {
                tooltipCtrl.instance.showNow();
              }
            } else {
              if (lastInstance) {
                scope.$applyAsync(lastInstance.close);
              }
              var content = getContent();
              if (attrs.tooltipShortcutHint) {
                content = $sce.trustAsHtml('<span class="tooltip-shortcut"><span>' + content + '</span><span class="shortcut-hint">' + attrs.tooltipShortcutHint + '</span></span>');
              }
              tooltipCtrl.instance = lastInstance = bubbleDialogService.open(scope, element, {
                closeable: true,
                content: content,
                position: attrs.tooltipPosition,
                positionArrow: tooltipCtrl.helpIconElement,
                className: 'tooltip',
                delay: delay
              });
            }
          }
        };

        var close = tooltipCtrl.close = function () {
          if (tooltipCtrl.instance) {
            tooltipCtrl.instance.close();
            tooltipCtrl.instance = null;
          }
        };

        tooltipCtrl.toggle = function () {
          var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

          if (isOpen()) {
            close();
          } else {
            open(delay);
          }
        };

        var delay = function delay() {
          return +(attrs.tooltipDelay || (tooltipHelpIconCtrl ? 0 : 600));
        };

        element.on('mouseenter', function () {
          return open(delay());
        }).on('mouseleave', close);

        scope.$on('$destroy', close);
      }
    };
  }])

  // A simple component that renders a question mark in a circle, which can be used for highlighting a tooltip
  // If added below a tooltip, it enables that tooltip to be opened explicitly by clicking
  // It can also be used as the source of a tooltip (with the same click-to-show behavior)
  .component('tooltipHelpIcon', {
    require: {
      tooltipCtrl: '^tooltip'
    },
    template: '',
    controller: ['$element', '$scope', function controller($element, $scope) {
      var ctrl = this;
      ctrl.$onInit = function () {
        ctrl.tooltipCtrl.helpIconElement = $element;
      };
      $element.on('mouseenter', function (event) {
        if ($element.attr('tooltip')) return;
        stopEvent(event);
        $scope.$applyAsync(function () {
          return ctrl.tooltipCtrl.open();
        });
      });
      $element.on('click', function (event) {
        stopEvent(event);
        $scope.$applyAsync(function () {
          return ctrl.tooltipCtrl.toggle();
        });
      });
    }]
  }).directive('dropdownToggle', function () {
    return {
      restrict: 'A',
      require: ['?^dropdown', '?^tooltip'],
      link: function link(scope, el, attr, _ref3) {
        var _ref4 = slicedToArray(_ref3, 2),
            dropdownCtrl = _ref4[0],
            tooltipCtrl = _ref4[1];

        if (dropdownCtrl && tooltipCtrl) {
          scope.$watch(function () {
            return dropdownCtrl.isOpen();
          }, tooltipCtrl.setDisabled);
        }
      }
    };
  });

  var frameworkDemosTemplate = "<ul class=\"frameworks\"> <li ng-repeat=\"demo in demos\" class=\"language\"> <a ng-href=\"{{ demo.link }}\" target=\"_blank\" rel=\"noopener\" track-click=\"Demo Assessment Clicked\" track-data=\"{ demo: demo.title }\" tooltip=\"{{ demo.purpose }}\" tooltip-position=\"top\"> <span ng-if=\"demo.icon\" class=\"language-icon icon-lang-{{ demo.icon }}\"></span> <span ng-if=\"demo.backgroundImage\" class=\"language-icon language-icon-bg-image\" ng-style=\"{ 'background-image': demo.backgroundImage }\"></span> <span class=\"title\" ng-bind=\"demo.title\"></span> </a> </li> </ul> ";

  var defaultDemos = [{ title: 'Ruby on Rails', icon: 'rails' }, { title: 'Node.js', icon: 'nodejs' }, { title: 'AngularJS', icon: 'angular' }, { title: 'React', icon: 'react' }, { title: 'MongoDB', icon: 'mongo' }, { title: 'PostgreSQL', icon: 'postgresql' }, { title: 'SQLite', icon: 'sqlite' }, { title: 'Redis', icon: 'redis' }];

  var frameworkDemosComponentModule = angular.module('Q.components.framework-demos', [tooltipComponentModule, landingTrackClickComponentModule]).directive('frameworkDemos', ['$http', '$window', '$document', function ($http, $window, $document) {
    var demos = null;

    var linkBase = appConfig.assessRoute + '/';

    return {
      scope: {},
      restrict: 'E',
      template: frameworkDemosTemplate,
      link: function link(scope) {
        var makeClickable = function makeClickable() {
          scope.demos = demos;
          $document.find('html').addClass('has-live-demos');
        };

        if (demos) {
          makeClickable();
        } else {
          scope.demos = defaultDemos;
          $http.get(appConfig.apiRoot + 'assessments/demos').then(function (resp) {
            demos = resp && resp.data && resp.data.data;
            if (demos) {
              demos.forEach(function (d) {
                var galleryImage = d.galleryImage;
                d.backgroundImage = 'url("' + appConfig.cloudinaryBaseUrl + '/' + galleryImage.fileId + '.' + galleryImage.fileFormat + '")';
                d.link = linkBase + d.id;
              });
              makeClickable();
            }
          });
        }
      }
    };
  }]);

  function determineWhereElementIsInViewport($el, viewportHeight, delayPercent) {
    var elementBounds = $el[0].getBoundingClientRect();

    var panelTop = elementBounds.top;
    var panelBottom = elementBounds.bottom;

    // pixel buffer until deciding to show the element
    var delayPx = delayPercent * elementBounds.height;

    var topAboveHalf = panelTop < viewportHeight / 2;
    var bottomVisible = topAboveHalf && panelBottom - delayPx > 0 && panelBottom < viewportHeight;
    var topVisible = topAboveHalf && panelTop + delayPx <= viewportHeight && panelTop > 0;

    if ($el.data('hidden') && (bottomVisible || topVisible)) {
      // scrolled into view
      return true;
    } else if (!$el.data('hidden') && (panelBottom < 0 || panelTop > viewportHeight)) {
      // scrolled out of view
      return false;
    }

    // no change
    return null;
  }

  var onScrollAddClassComponentModule = angular.module('Q.components.on-scroll-add-class', [windowEventHelperModule]).directive('onScrollAddClass', ['$document', '$window', '$timeout', function ($document, $window, $timeout) {
    var delayPercent = 0.5; // lower = more eager to hide / show, higher = less eager
    var document = $document[0].documentElement;

    return {
      restrict: 'A',
      require: ['onScrollAddClass', '^?hasSteps'],
      controller: function controller() {},

      link: function link(scope, el, attr, _ref) {
        var _ref2 = slicedToArray(_ref, 2),
            onScrollAddClassCtrl = _ref2[0],
            hasStepsCtrl = _ref2[1];

        var checkPending = false;
        var lastStarted = -Infinity;

        function onScroll() {
          if (!checkPending) {
            checkPending = true;
            $window.requestAnimationFrame(function () {
              var setVisibility = determineWhereElementIsInViewport(el, document.clientHeight, delayPercent);
              if (setVisibility !== null) {
                toggleVisible(setVisibility);
              }
              checkPending = false;
            });
          }
        }

        var isFinishedTimeout = null;

        function toggleVisible(visible) {
          var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

          // don't re-run within 10s
          if (!force && Date.now() - lastStarted < 10000) return;

          var wasVisible = !el.data('hidden');
          el.toggleClass(attr.onScrollAddClass || 'is-visible', visible);
          el.data('hidden', !visible);

          // animation finished styling
          if (!visible || !wasVisible) {
            el.removeClass('is-finished');
            if (isFinishedTimeout) {
              $timeout.cancel(isFinishedTimeout);
              isFinishedTimeout = null;
            }
            var runtime = 1000 * attr.onScrollRuntime;
            if (visible) {
              lastStarted = Date.now();
            }
            if (visible && runtime) {
              isFinishedTimeout = $timeout(function () {
                el.addClass('is-finished');
              }, runtime, false);
            }
          }
        }

        var documentListenerEvents = 'scroll';
        $document.on(documentListenerEvents, onScroll);
        scope.$on(WINDOW_EVT_RESIZE, onScroll);
        scope.$on('$destroy', function () {
          $document.off(documentListenerEvents, onScroll);
        });

        // initialise
        scope.$evalAsync(onScroll);
        onScrollAddClassCtrl.runAnimation = function () {
          if (!el.data('hidden')) {
            $window.requestAnimationFrame(function () {
              toggleVisible(false, true);
              $window.requestAnimationFrame(function () {
                return toggleVisible(true, true);
              });
            });
          }
        };

        if (hasStepsCtrl) {
          hasStepsCtrl.add(onScrollAddClassCtrl.runAnimation);
        }
      }
    };
  }]).directive('hasSteps', ['$timeout', '$interval', function ($timeout, $interval) {
    return {
      restrict: 'A',
      controller: function controller() {
        var anims = [];
        this.add = function (animFn) {
          return anims.push(animFn);
        };
        this.runAnim = function () {
          anims.forEach(function (animFn) {
            return animFn();
          });
        };
      },
      link: function link(scope, el, attr, hasStepsCtrl) {
        var $inputs = el.querySelectorAll('input');
        var $labels = el.querySelectorAll('labels');

        var timerRunning = false;
        var active = 0;

        var startTimer = function startTimer() {
          var setActive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : active;

          if (timerRunning) return;
          active = setActive;
          timerRunning = true;
          var timer = $interval(function () {
            if (timerRunning) {
              active = (active + 1) % $inputs.length;
              $inputs.prop('checked', false);
              $inputs.eq(active).prop('checked', true);
              hasStepsCtrl.runAnim();
            } else {
              $interval.cancel(timer);
            }
          }, 10 * 1000, false); // auto-switch active step every 10 seconds
        };
        startTimer();
        $inputs.on('change', function () {
          hasStepsCtrl.runAnim();
        });

        var restartTimer = void 0;
        var clickOnOption = function clickOnOption(event, $elements) {
          timerRunning = false;
          hasStepsCtrl.runAnim();
          if (restartTimer) {
            $timeout.cancel(restartTimer);
          }
          // restart switching timer after 3 minutes
          restartTimer = $timeout(function () {
            var target = event.target;
            var idx = Array.from($elements).indexOf(target);
            startTimer(idx > -1 ? idx : active);
          }, 3 * 60 * 1000, false);
        };

        $inputs.on('click', function (event) {
          clickOnOption(event, $inputs);
        });
        $labels.on('click', function (event) {
          clickOnOption(event, $labels);
        });
      }
    };
  }]).directive('onScrollAddClassClickable', function () {
    return {
      restrict: 'A',
      require: '^onScrollAddClass',
      link: function link(scope, el, attr, onScrollAddClassCtrl) {
        el.on('click', function () {
          return onScrollAddClassCtrl.runAnimation();
        });
      }
    };
  });

  var previewVideoTemplate = "<div class=\"preview-video-popup\"> <div class=\"backdrop\" ng-click=\"hide()\"></div> <div class=\"video\"> <span class=\"hide-button\" ng-click=\"hide()\"></span> <iframe width=\"1280\" height=\"720\" ng-src=\"{{ url }}\" frameborder=\"0\" allowfullscreen></iframe> </div> </div> ";

  var previewVideoComponentModule = angular.module('Q.components.preview-video', []).directive('previewVideo', ['$window', '$document', '$compile', '$rootScope', '$animate', '$sce', '$timeout', function ($window, $document, $compile, $rootScope, $animate, $sce, $timeout) {
    var playerElem = null;
    var playerScope = null;

    function showVideo(id) {
      // YouTube Options:
      // autoplay=1 - Play Automatically
      // enablejsapi=1 - Enables JS Control
      // modestbranding=1 - Reduces YouTube nonsense
      // playsinline=1 - Enables inline playback in some iOS situations
      // rel=0 - No related videos
      // showinfo=0 - Less noise before the video starts
      // color=white - White controls (not red)
      // iv_load_policy=3 - Hides video annotations
      var url = $sce.trustAsResourceUrl('https://www.youtube.com/embed/' + id + '?autoplay=1&enablejsapi=1&modestbranding=1&playsinline=1&rel=0&showinfo=0&color=white&iv_load_policy=3&vq=hd720');
      if (!playerElem) {
        playerScope = $rootScope.$new();
        playerScope.hide = hideVideo;
        playerElem = $compile(previewVideoTemplate)(playerScope);
        $animate.enter(playerElem, $document.find('body')).then(function () {
          return $timeout(function () {
            return playerScope.url = url;
          }, 200);
        });
      }
    }

    function hideVideo() {
      if (playerElem) {
        var oldScope = playerScope;
        $animate.leave(playerElem).then(function () {
          return oldScope.$destroy();
        });
        playerElem = null;
        playerScope = null;
      }
    }

    return {
      restrict: 'A',
      link: function link(scope, elem, attr) {
        elem.on('click', function ($event) {
          stopEvent($event);
          showVideo(attr.previewVideo);
        });
      }
    };
  }]);

  var scrollOnFocusDirectiveModule = angular.module('Q.components.scroll-on-focus', [scrollToComponentModule]).directive('scrollOnFocus', function () {
    return {
      restrict: 'A',
      controller: 'ScrollOnFocusCtrl'
    };
  })

  // Note: Controllers usually imply an integrated component, you probably want to use a component instead of
  // a full directive, unless you need lots of DOM manipulation
  .controller('ScrollOnFocusCtrl', ['$element', 'scrollToElement', function ScrollOnFocusCtrl($element, scrollToElement) {
    var ctrl = this;
    ctrl.check = function ($elem) {
      // we check for labels as well, to make sure the entire input control is visible
      var $label = $element.querySelector('label[for="' + $elem.attr('id') + '"]');
      if (!$elem.isInView() || $label.length && !$label.isInView()) {
        // scroll the label (preferred) or the element into view, and position 25% from the top
        scrollToElement({
          target: $label.length ? $label : $elem,
          center: 0.25
        });
      }
    };
  }]).directive('input', scrollOnFocusInputDirective).directive('select', scrollOnFocusInputDirective).directive('textarea', scrollOnFocusInputDirective);

  /* @ngInject */
  function scrollOnFocusInputDirective() {
    return {
      restrict: 'E',
      require: '^^?scrollOnFocus',
      link: function link(scope, $elem, attr, scrollOnFocusCtrl) {
        if (scrollOnFocusCtrl) {
          $elem.on('focus', function () {
            scrollOnFocusCtrl.check($elem);
          });
        }
      }
    };
  }

  var checkEmailServiceModule = angular.module('Q.services.check-email-service', []).factory('checkEmailService', ['$http', function ($http) {
    return {
      check: function check(email, type) {
        return $http.post(appConfig.apiRoot + 'account/precheck', {
          data: {
            $type: type,
            email: email
          }
        }, {
          ignoreLoadingBar: true
        }).then(function (res) {
          var data = res.data;
          return data && data.data || {};
        }).catch(function () {
          return {};
        });
      }
    };
  }]);

  /* eslint-disable angular/no-private-call */

  var compileTemplateComponentModule = angular.module('Q.components.compile-template', [])

  /**
   * @docType shared
   * @category directive
   *
   * @ngdoc directive
   *
   * @name compileTemplate
   * @restrict EA
   * @scope
   * @priority 400
   *
   * @description
   * Compiles and injects a template, similar to ng-include, but works with templates stored in strings, rather than
   * asynchronous template loading.
   *
   * Note: Unlike ng-include, this directive is always synchronous, and therefore doesn't have an onload attribute,
   * doesn't autoscroll, and doesn't broadcast any events.
   *
   * @param {expression} compileTemplate|src Angular expression returning the template to compile and inject
   * @param {expression} scope Override scope source
   * @param {expression} scopeVars Add custom vars to the new scope
   *
   */
  .directive('compileTemplate', ['$compile', '$animate', function ($compile, $animate) {
    return {
      restrict: 'EA',
      priority: 400,
      terminal: true,
      transclude: 'element',
      controller: angular.noop,
      compile: function compile(tElement, tAttr) {
        var srcExp = tAttr.compileTemplate || tAttr.src;

        return function (scope, el, attr, ctrl, $transclude) {
          var currentScope = void 0;
          var previousElement = void 0;
          var currentElement = void 0;

          var cleanupCurrentContent = function cleanupCurrentContent() {
            if (previousElement) {
              // in case we somehow get new content while the old content is still animating away
              previousElement.remove();
              previousElement = null;
            }
            if (currentScope) {
              currentScope.$destroy();
              currentScope = null;
            }
            if (currentElement) {
              $animate.leave(currentElement).done(function (response) {
                if (response !== false) previousElement = null;
              });
              previousElement = currentElement;
              currentElement = null;
            }
          };

          scope.$watch(srcExp, function compileTemplateWatchAction(template) {
            cleanupCurrentContent();

            // only render if the template is truthy, or any string (including '')
            if (template || angular.isString(template)) {
              if (scope.$$destroyed) return;
              ctrl.template = template;
              currentScope = (tAttr.scope ? scope.$eval(tAttr.scope) : scope).$new();
              if (tAttr.scopeVars) {
                angular.extend(currentScope, scope.$eval(tAttr.scopeVars));
              }
              currentElement = $transclude(currentScope, function (clone) {
                $animate.enter(clone, null, el);
              });
            }
          });
        };
      }
    };
  }])

  // This directive is called during the $transclude call of the first `ngInclude` directive.
  // It will replace and compile the content of the element with the loaded template.
  // We need this directive so that the element content is already filled when
  // the link function of another directive on the same element as ngInclude
  // is called.
  .directive('compileTemplate', ['$compile', function ($compile) {
    return {
      restrict: 'ECA',
      priority: -400,
      require: 'compileTemplate',
      link: function link(scope, $element, $attr, ctrl) {
        // Copied from ngInclude, but we don't need it right now
        // if(toString.call($element[0]).match(/SVG/)) {
        // 	// WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
        // 	// support innerHTML, so detect this here and try to generate the contents
        // 	// specially.
        // 	$element.empty();
        // 	$compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
        // 		function namespaceAdaptedClone(clone) {
        // 			$element.append(clone);
        // 		}, { futureParentElement: $element });
        // 	return;
        // }

        $element.html(ctrl.template);
        $compile($element.contents())(scope);
      }
    };
  }]);

  var FORM_GROUP_MESSAGES = [];

  function addFormGroupMessage(key, message) {
    FORM_GROUP_MESSAGES.push({
      key: key,
      message: message
    });
  }

  var formGroupMessagesComponentModule = angular.module('Q.components.forms.form-group-messages', [compileTemplateComponentModule]).factory('FORM_GROUP_MESSAGES', function () {
    FORM_GROUP_MESSAGES.add = addFormGroupMessage;
    addFormGroupMessage('required', function ($input, formGroupField) {
      return 'Please provide ' + formGroupField.name + '.';
    });
    addFormGroupMessage('match', 'This password doesn\'t match the first one.');
    addFormGroupMessage('minLength', function ($input, formGroupField) {
      if (formGroupField.minAndMaxLength) {
        return formGroupField.nameCapitalized + ' must be between ' + formGroupField.minlength + ' and ' + formGroupField.maxlength + ' characters long.';
      } else if (formGroupField.minlength) {
        return 'Please enter at least ' + formGroupField.minlength + ' character' + (formGroupField.minlength === 1 ? '' : 's') + '.';
      } else {
        return formGroupField.nameCapitalized + ' is too short.';
      }
    });
    addFormGroupMessage('maxLength', function ($input, formGroupField) {
      if (formGroupField.minAndMaxLength) {
        return formGroupField.nameCapitalized + ' must be between ' + formGroupField.minlength + ' and ' + formGroupField.maxlength + ' characters long.';
      } else if (formGroupField.maxlength) {
        return 'Please enter no more than ' + formGroupField.maxlength + ' character' + (formGroupField.maxlength === 1 ? '' : 's') + '.';
      } else {
        return formGroupField.nameCapitalized + ' is too long.';
      }
    });
    addFormGroupMessage('min', function ($input, formGroupField) {
      if (formGroupField.minAndMax) {
        return formGroupField.nameCapitalized + ' must be between ' + formGroupField.min + ' and ' + formGroupField.max + ' (inclusive).';
      } else if (formGroupField.min) {
        return formGroupField.nameCapitalized + ' must be ' + formGroupField.min + ' or greater.';
      } else {
        return formGroupField.nameCapitalized + ' is too small.';
      }
    });
    addFormGroupMessage('max', function ($input, formGroupField) {
      if (formGroupField.minAndMax) {
        return formGroupField.nameCapitalized + ' must be between ' + formGroupField.min + ' and ' + formGroupField.max + ' (inclusive).';
      } else if (formGroupField.max) {
        return formGroupField.nameCapitalized + ' must be ' + formGroupField.max + ' or smaller.';
      } else {
        return formGroupField.nameCapitalized + ' is too big.';
      }
    });
    addFormGroupMessage('minTags', function ($input, formGroupField) {
      if (formGroupField.minAndMaxTags) {
        return formGroupField.nameCapitalized + ' must have between ' + formGroupField.minTags + ' and ' + formGroupField.maxTags + ' items (inclusive).';
      } else {
        return formGroupField.nameCapitalized + ' must have at least ' + formGroupField.minTags + ' item' + (formGroupField.minTags === 1 ? '' : 's') + '.';
      }
    });
    addFormGroupMessage('maxTags', function ($input, formGroupField) {
      if (formGroupField.minAndMaxTags) {
        return formGroupField.nameCapitalized + ' must have between ' + formGroupField.minTags + ' and ' + formGroupField.maxTags + ' items (inclusive).';
      } else {
        return formGroupField.nameCapitalized + ' must have no more than ' + formGroupField.maxTags + ' item' + (formGroupField.maxTags === 1 ? '' : 's') + '.';
      }
    });
    addFormGroupMessage('url', 'Please provide a valid website URL.');
    addFormGroupMessage('email', 'Please provide a valid email address.');
    addFormGroupMessage('date', 'Please provide a valid date.');
    addFormGroupMessage('number', 'Please provide a valid number.');
    addFormGroupMessage('loginIncorrect', 'Incorrect password or username.');
    addFormGroupMessage('accountLocked', 'This account is no longer active.');

    return FORM_GROUP_MESSAGES;
  }).directive('formGroupMessages', ['$animate', '$timeout', 'FORM_GROUP_MESSAGES', function ($animate, $timeout, FORM_GROUP_MESSAGES) {
    var SHOULD_SHOW_CLASS = 'msg-shouldshow';
    var SHOULD_HIDE_CLASS = 'msg-shouldhide';

    return {
      restrict: 'E',
      require: ['^^form', '^^formGroup'],
      scope: true,
      compile: function compile(tElement) {
        var customMessages = tElement.html().trim();
        tElement.html('<compile-template src="messageContent"></compile-template>');

        return function postLink(scope, elem, attrs, _ref) {
          var _ref2 = slicedToArray(_ref, 2),
              ngFormCtrl = _ref2[0],
              formGroupCtrl = _ref2[1];

          elem.addClass('help-block');

          formGroupCtrl.configureMessages = function ($inputs) {
            var input = $inputs && $inputs[0];
            var $input = scope.$input = input && angular.element(input);
            var formGroupCtrlAttrs = formGroupCtrl.attrs || {};

            if (!$input) return;

            // --- configuring field properties ---

            var min = $input.attr('min');
            var max = $input.attr('max');
            var minLength = $input.attr('minlength');
            var ngMinLength = $input.attr('ng-minlength');
            var maxLength = $input.attr('maxlength');
            var ngMaxLength = $input.attr('ng-maxlength');
            var minTags = $input.attr('min-tags');
            var maxTags = $input.attr('max-tags');

            var formGroupField = formGroupCtrl.formGroupField = scope.formGroupField = {
              name: formGroupCtrlAttrs.fieldName || formGroupCtrlAttrs.label || 'a value',
              nameCapitalized: formGroupCtrlAttrs.fieldNameCapitalized || ucFirst(formGroupCtrlAttrs.fieldName || formGroupCtrlAttrs.label || 'the value'),
              min: min,
              max: max,
              minAndMax: min && max,
              minlength: minLength || ngMinLength && scope.$eval(ngMinLength),
              maxlength: maxLength || ngMaxLength && scope.$eval(ngMaxLength),
              minTags: minTags && scope.$eval(minTags),
              maxTags: maxTags && scope.$eval(maxTags)
            };
            formGroupField.minAndMaxLength = formGroupField.minlength && formGroupField.maxlength;
            formGroupField.minAndMaxTags = formGroupField.minTags && formGroupField.maxTags;

            var getFormField = function getFormField() {
              return ngFormCtrl[$input.attr('name')];
            };
            var getFormFieldErrors = function getFormFieldErrors() {
              var field = getFormField();
              return field && field.$error || {};
            };

            // --- setting the message ---

            var lastErrorClass = '';

            function updateMessage() {
              elem.removeClass(lastErrorClass);
              var hadError = false;
              var errors = getFormFieldErrors();
              if (Object.keys(errors).length) {
                var msgs = FORM_GROUP_MESSAGES;
                if (customMessages) {
                  var _msgs;

                  msgs = [];
                  angular.forEach(scope.$eval(customMessages), function (message, key) {
                    msgs.push({ key: key, message: message });
                  });
                  (_msgs = msgs).push.apply(_msgs, toConsumableArray(FORM_GROUP_MESSAGES));
                }
                scope.messageContent = '';
                hadError = msgs.some(function (_ref3) {
                  var key = _ref3.key,
                      message = _ref3.message;

                  if (errors[key]) {
                    lastErrorClass = key;
                    elem.addClass(lastErrorClass);
                    scope.messageContent = angular.isFunction(message) ? message($input, formGroupField) : message;
                    return true;
                  }
                });
              }
              elem.toggleClass('ng-active', hadError);
              elem.toggleClass('ng-inactive', !hadError);
            }

            scope.$watch(function () {
              return Object.keys(getFormFieldErrors()).join();
            }, updateMessage);

            // --- hiding if the form wasn't submitted ---

            elem.addClass(SHOULD_HIDE_CLASS);
            scope.$watch(function () {
              var field = getFormField();
              // leftoverText is because tagsInput is marking the field as pristine if we error on the first item
              return ngFormCtrl && isFormSubmitted(ngFormCtrl) || field && (!field.$pristine || field.$error.leftoverText) && field.$touched;
            }, function (shouldShow) {
              $animate.setClass(elem, shouldShow ? SHOULD_SHOW_CLASS : SHOULD_HIDE_CLASS, shouldShow ? SHOULD_HIDE_CLASS : SHOULD_SHOW_CLASS);
            });
          };
        };
      }
    };
  }]);

  function isFormSubmitted(form) {
    /* eslint-disable angular/no-private-call */
    while (!form.$submitted && form.$$parentForm && form.$$parentForm.$name) {
      form = form.$$parentForm;
    }
    /* eslint-enable */
    return form.$submitted;
  }

  var uniqueEmailValidatorComponentModule = angular.module('Q.components.forms.unique-email-validator', [checkEmailServiceModule, formGroupMessagesComponentModule]).directive('uniqueEmail', ['checkEmailService', '$q', '$timeout', 'FORM_GROUP_MESSAGES', function (checkEmailService, $q, $timeout, FORM_GROUP_MESSAGES) {
    var DEBOUNCE_RATE = 1000;

    FORM_GROUP_MESSAGES.add('uniqueEmail', 'That email has already been used to sign up.');

    return {
      require: 'ngModel',
      link: function link(scope, el, attrs, ngModel) {
        // tracks whether we have a delayed check in progress
        var activeTimer = null;
        // tracks number of active checks heading to the server
        var activeRequests = 0;

        ngModel.$asyncValidators.uniqueEmail = function (modelValue) {
          // no value
          if (!modelValue) return $q.when(true);

          // disabled
          if (attrs.uniqueEmail && !scope.$eval(attrs.uniqueEmail)) return $q.when(true);

          // We just cancel any timer still running
          if (activeTimer) {
            $timeout.cancel(activeTimer);
          }

          // if we already have an active request, debounce!
          if (activeRequests) {
            // NOTE: Do NOT combine these statements.
            // We can only cancel a timer if it's the original promise returned from $timeout!
            activeTimer = $timeout(angular.noop, DEBOUNCE_RATE);

            return activeTimer.then(function () {
              return activeTimer = null;
            }).then(check);
          } else {
            return check();
          }

          function check() {
            activeRequests++;
            return checkEmailService.check(modelValue, attrs.uniqueEmailModel).then(function (data) {
              activeRequests--;
              if (!data.exists) {
                ngModel.flagInvalid = !!data.invalid;
                ngModel.flagJunk = !!data.junk;
                ngModel.flagGeneric = !!(data.generic || data.junk);
                return true;
              } else {
                return $q.reject();
              }
            });
          }
        };
      }
    };
  }]);

  var btnCtaSVGTemplate = "<svg height=\"230\" preserveAspectRatio=\"none\" viewBox=\"0 0 249 230\" width=\"249\" xmlns=\"http://www.w3.org/2000/svg\"><linearGradient id=\"cta-hover-gradient\" x1=\"0%\" x2=\"100%\" y1=\"0%\" y2=\"0%\"><stop offset=\"0\" stop-color=\"#338632\"/><stop offset=\"1\" stop-color=\"#307C84\"/></linearGradient><g fill=\"none\" fill-rule=\"evenodd\"><path class=\"bg-path\" d=\"M-50 230V0h349z\" fill=\"url(#cta-hover-gradient)\" fill-rule=\"nonzero\"/><g fill=\"#fff\"><path class=\"l1\" d=\"M211.968-13.804l31.922 2.232-17.858 255.376-31.922-2.232z\" fill-opacity=\".27\"/><path class=\"l2\" d=\"M166.178-13.525l23.942 1.674-17.858 255.376-23.941-1.674z\" fill-opacity=\".3\"/><path class=\"l3\" d=\"M119.391-13.316l17.956 1.256-17.857 255.376-17.956-1.256z\" fill-opacity=\".21\"/><path class=\"l4\" d=\"M73.602-13.037l9.976.698L65.72 243.037l-9.976-.698z\" fill-opacity=\".3\"/><path class=\"l5\" d=\"M26.815-12.828l3.99.28-17.858 255.376-3.99-.28z\" fill-opacity=\".24\"/></g></g></svg>";

  var btnCtaDirectiveModule = angular.module('Q.components.btn-cta', []).directive('btnCta', function () {
    return {
      restrict: 'A',
      link: function link(scope, el, attr) {
        var text = attr.btnCta || el.text();
        el.empty();
        el.addClass('btn-cta');
        el.append(btnCtaSVGTemplate);
        var span = angular.element('<span>');
        span.text(text);
        el.append(span);
      }
    };
  });

  var elasticComponentModule = 'monospaced.elastic';

  var DATA_MAP = {
    firstName: 'contactFirstName',
    lastName: 'contactLastName',
    email: 'contactEmail',
    title: 'contactTitle'
  };

  var formData = {
    firstName: '',
    lastName: '',
    email: '',
    title: ''
  };

  var salesLeadData = function salesLeadData() {
    var data = null;
    try {
      if (window.sessionStorage && window.sessionStorage.qSalesLead) {
        data = JSON.parse(window.sessionStorage.qSalesLead);
      }
    } catch (err) {}
    return data || {};
  };

  Object.assign(formData, salesLeadData());

  var salesLeadFormComponentModule = angular.module('Q.components.sales-lead-form', [landingTrackerServiceModule, uniqueEmailValidatorComponentModule, scrollToComponentModule, scrollOnFocusDirectiveModule, btnCtaDirectiveModule, elasticComponentModule]).directive('salesLeadForm', ['$http', 'trackerService', '$document', '$window', 'scrollToElement', function ($http, trackerService, $document, $window, scrollToElement) {
    return function (scope) {
      var ctrl = {};
      scope.$ctrl = ctrl;

      ctrl.disabled = false;
      ctrl.data = formData;

      ctrl.supportEmailHref = function () {
        var subject = encodeURIComponent('Signup help');
        var body = encodeURIComponent('Hello, I\'m trying to sign up with ' + formData.email + '!');
        return 'mailto:support@qualified.io?subject=' + subject + '&body=' + body;
      };

      var possibleStudent = true;
      ctrl.checkEducation = function () {
        if (possibleStudent) {
          ctrl.showEducationWarning = /@.+\.edu$/i.test(formData.email) || /student/i.test(formData.title);
        }
      };
      ctrl.setNotStudent = function () {
        possibleStudent = false;
        ctrl.showEducationWarning = false;
      };

      ctrl.saveSalesLeadData = function () {
        try {
          if (window.sessionStorage) {
            window.sessionStorage.qSalesLead = JSON.stringify(formData);
          }
        } catch (err) {}
        return true;
      };

      ctrl.submit = function () {
        ctrl.disabled = true;
        ctrl.saveSalesLeadData();
        var data = angular.merge({ type: 'freetrial' }, formData, {
          marketing: utmProps
        });
        angular.forEach(DATA_MAP, function (to, from) {
          data[to] = data[from];
          delete data[from];
        });
        trackerService.trackEvent('landing.salesLead.freetrial.submit', data);
        $http.post('/api/v1/sales_leads/', { data: data }).then(function () {
          trackerService.trackEvent('landing.salesLead.freetrial.success', data);
          $window.location = '/signup-success';
        }).catch(function () {
          ctrl.error = true;
          trackerService.trackEvent('landing.salesLead.freetrial.error', data);
        }).finally(function () {
          ctrl.disabled = false;
          scrollToElement({ target: '#signup' });
        });
      };
    };
  }]);

  var sectionAutoLinkComponentModule = angular.module('Q.components.section-auto-link', []).directive('section', ['$window', function SectionAutoLink($window) {
    return {
      restrict: 'E',
      link: function link(scope, elem, attr) {
        if (!attr.id || attr.noSectionLink !== undefined) return;
        var header = elem.find('h1').eq(0);
        if (!header.length) return;
        var link = angular.element('<a class="section-link" title="Link directly to this section.">');
        link.attr('href', '#' + $window.encodeURIComponent(attr.id));
        header.prepend(link);
      }
    };
  }]);

  var RECRUITMENT = {
    $recruitment: true,
    $education: false,
    participant: 'candidate',
    Participant: 'Candidate',
    participants: 'candidates',
    Participants: 'Candidates'
  };
  var EDUCATION = {
    $recruitment: false,
    $education: true,
    participant: 'student',
    Participant: 'Student',
    participants: 'students',
    Participants: 'Students'
  };
  var types = {
    recruitment: RECRUITMENT,
    education: EDUCATION
  };

  // Sort of hackish way to configure variances based on a recruiting or education target

  var productTypeServiceModule = angular.module('Q.services.product-type-service', []).constant('PT', angular.extend({}, RECRUITMENT)).factory('productTypeService', ['$rootScope', 'PT', '$document', function ($rootScope, PT, $document) {
    /**
     * Replaces occurrences `{{word}}` with either the matching product type string, or leaving `word`
     * untouched if there's no match.
     * @param {String} string String to modify
     */
    function replace(string) {
      return string.replace(/\{\{(\w+)\}\}/g, function (_, w) {
        return PT[w] || w;
      });
    }

    /**
     * Returns the correct for for the given count
     * @param {String} single
     * @param {String} plural
     * @param {Number} count
     * @returns {String}
     */
    function pluralize(single, plural, count) {
      return count === 1 ? single : plural;
    }

    return {
      types: types,
      // Intital setup, sets the product to default recruitment mode, to ensure we have something
      // if the app has not loaded
      init: function init() {
        this.setProduct('recruitment');
      },

      /**
       * Sets the current product type based on the team
       * Can be called after setup, but should be set as early as possible.
       * @param {Team|String} team Team object to use for configuring the app
       */
      setProduct: function setProduct(team) {
        $rootScope.PT = RECRUITMENT;
        var productTypes = team && team.productTypes;
        if (team === 'education') {
          $rootScope.PT = EDUCATION;
        } else if (productTypes && !productTypes.recruitment) {
          if (productTypes.education) {
            $rootScope.PT = EDUCATION;
          }
        }
        var rPT = $rootScope.PT;
        rPT.$replace = replace;
        rPT.$pluralize = pluralize.bind(rPT, rPT.participant, rPT.participants);
        rPT.$Pluralize = pluralize.bind(rPT, rPT.Participant, rPT.Participants);

        angular.extend(PT, rPT);
        $document.toggleClass('product-type-recruitment', PT.$recruitment);
        $document.toggleClass('product-type-education', PT.$education);
      },

      replace: replace
    };
  }]).directive('qPt', ['PT', function (PT) {
    return {
      link: function link(scope, elem) {
        var text = elem.text();
        var key = text.replace(/\W+/, '');
        if (PT[key]) {
          // we do it this way to preserve whitespace & punctuation
          elem.text(text.replace(key, PT[key]));
        }
      }
    };
  }]).run(['$rootScope', 'productTypeService', function ($rootScope, productTypeService) {
    productTypeService.init();
    $rootScope.$on('app.accountSet', function ($event, account) {
      if (account && account.user && account.user.team) {
        productTypeService.setProduct(account.user.team);
      }
    });
  }]);

  var _dateMatcher = /^\d{4,6}(-\d\d){2}(T\d\d(:\d\d){0,2}(\.\d{3})?(Z?([-+]\d\d:\d\d)?)?)?$/;

  /**
   * Walks an object tree and replaces strings that look like ISO8601 dates and timestamps
   * with actual Date objects
   *
   * @param data Anything for input
   * @returns {*} Output with date strings replaced with dates
   */
  function parseDates(data) {
    if (!isObject(data)) return data;

    angular.forEach(data, function (val, key) {
      if (isString(val) && _dateMatcher.test(val)) {
        try {
          data[key] = new Date(val);
        } catch (e) {} // ignoring date errors is acceptable
      } else if (isObject(val)) {
        parseDates(val);
      }
    });

    return data;
  }

  var configServiceModule = angular.module('Q.services.config-service', []).factory('configService', ['$http', '$log', '$q', function ($http, $log, $q) {
    var data = null;
    var loading = null;
    var overrodeDelay = void 0;

    return {
      get config() {
        return data || {};
      },
      load: function load() {
        var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (!force && data) {
          return $q.when(data);
        } else {
          var ts = force ? '?' + Date.now() : '';
          if (!loading) {
            loading = $http.get(appConfig.baseApiRoot + 'config' + ts).then(function (response) {
              if (!response || !response.data) {
                return $q.reject();
              }
              data = parseDates(response.data);
              data.timeDiffMS = 0;
              data.ignoreTimeDelay = function () {
                overrodeDelay = true;
                data.significantTimeDelay = false;
              };
              if (isDate(data.currentTime)) {
                data.timeDiffMS = new Date() - data.currentTime;
                if (!overrodeDelay) {
                  // true if server-client time difference is greater than 5 minutes
                  data.significantTimeDelay = Math.abs(data.timeDiffMS) > 300000;
                }
              }
              return data;
            }).catch(function (err) {
              $log.error('Failed to obtain api config', err);
              return $q.reject();
            }).finally(function () {
              loading = null;
            });
          }
          return loading;
        }
      }
    };
  }]);

  var billingFeaturesServiceModule = angular.module('Q.services.billing-features-service', [productTypeServiceModule, configServiceModule]).factory('billingFeaturesService', ['PT', 'configService', function (PT, configService) {
    var config = {};

    var load = function load() {
      return configService.load().then(function (cfg) {
        return Object.assign(config, cfg.billing);
      });
    };

    // returns the default for the plan, useful for when the feature does not have a specified value
    var featureDefault = function featureDefault(name) {
      var featureSet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'trial';

      var feature = config.features[name];
      if (!feature) return;

      if (feature.enum) {
        // for enums, we first try to match a value to the feature set
        var value = null;
        Object.keys(feature.enum).forEach(function (key) {
          var val = feature.enum[key];
          if (val.featureSets && val.featureSets.indexOf(featureSet) >= 0) {
            value = key;
          }
        });
        // return that value, or the default if no feature set specific value was found
        return value || feature.default;
      } else if (feature.featureSets) {
        return feature.featureSets.indexOf(featureSet) >= 0;
      } else {
        return feature.alwaysOn;
      }
    };

    var catalog = function catalog(features) {
      // we start off with the extra features which are not actually tracked as features (because they are standard),
      // but that we wish to still display within the list.
      var featureSet = {
        assess: {
          priority: -2,
          image: '/shared/images/qualified-assess-horizontal.svg',
          alt: 'Qualified Assess',
          enabled: true,
          tooltip: 'Send Challenges to quickly and painlessly measure your ' + PT.participants + '\' ability'
        },
        interact: {
          priority: -1,
          image: '/shared/images/qualified-interact-horizontal.svg',
          alt: 'Qualified Interact',
          enabled: true,
          tooltip: 'Live sessions between a ' + PT.participant + ' and one or more team member(s)'
        }
      };

      defineValue(featureSet, 'asList', Object.values(featureSet));

      // the server stores participant slug values which need to be dynamically replaced
      var participate = function participate(text, up) {
        if (text) {
          return text.replace('@participant', up ? PT.Participant : PT.participant).replace('@participants', up ? PT.Participants : PT.participants);
        }
      };

      load().then(function () {
        // weave in the features returned from the server
        Object.keys(config.features || {}).forEach(function (key) {
          var cfg = featureSet[key] = angular.copy(config.features[key]);
          cfg.displayName = participate(cfg.displayName, true);
          cfg.tooltip = participate(cfg.blurb);

          // track enum values so that we can display those properly
          if (cfg.enum) {
            cfg.value = features[key] || featureDefault(key, features.baseFeatureSet);
            cfg.label = upperCaseWords(cfg.value);
            cfg.enabled = !!cfg.value;
            cfg.values = Object.keys(cfg.enum);
            cfg.upgradeValue = cfg.values[cfg.values.length - 1];
            cfg.upgradeLabel = upperCaseWords(cfg.upgradeValue);
            cfg.upgradable = cfg.label !== cfg.upgradeLabel;
          } else {
            cfg.enabled = features && (features[key] === true || features[key] !== false && featureDefault(key, features.baseFeatureSet));
          }

          cfg.defaultUpgradeDisplay = cfg.defaultDisplay = cfg.shortDisplay || cfg.displayName;
          if (cfg.label) {
            cfg.defaultDisplay += ': ' + cfg.label;
          }
          if (cfg.upgradeLabel) {
            cfg.defaultUpgradeDisplay += ': ' + cfg.upgradeLabel;
          }

          // setup a priority, which is used for sorting alphabetically but first by
          // priority so that feature set features are not spread out all over the place.
          // since by default, we choose the first plan to list features, and that plan should
          // be the lowest, this should result in a decent order to display
          cfg.priority = cfg.enabled || cfg.enum ? 2 : 3;
        });

        defineValue(featureSet, 'asList', Object.values(featureSet).sort(function (a, b) {
          return a.priority - b.priority || compareIgnoreCase(a.defaultDisplay, b.defaultDisplay);
        }));
      });

      return featureSet;
    };

    return {
      featureDefault: featureDefault,
      config: config,
      load: load,
      catalog: catalog
    };
  }]);

  var billingPlansServiceModule = angular.module('Q.services.billing-plans-service', [billingFeaturesServiceModule]).constant('CUSTOM_PLAN', {
    id: 'custom',
    description: 'No matter what size organization you are, or what use case you have, we have plans designed for teams that will work for you.',
    planCategory: 'custom',
    planCategoryName: 'Team',
    basePrice: null,
    baseIntervalName: '12 Month',
    features: {
      baseFeatureSet: 'custom'
    }
  }).factory('billingPlansService', ['$http', 'billingFeaturesService', 'CUSTOM_PLAN', function ($http, billingFeaturesService, CUSTOM_PLAN) {
    function planApi(plan, customer) {
      var api = angular.extend(plan, {
        featuresList: billingFeaturesService.catalog(plan.features),
        featureStatus: function featureStatus(key) {
          var feature = this.featuresList[key];
          if (feature) {
            if (feature.label) {
              return 'labeled';
            }

            if (this.id === 'custom') {
              // if the custom plan and the feature is not a starter feature, then it's a premium not included
              // in all team based plans, so let's convey that via a different icon
              if (!feature.enabled || feature.featureSets && feature.featureSets.indexOf('growth') === -1) {
                return 'optional';
              }
            }

            if (feature.enabled) {
              return 'enabled';
            }
          }

          return 'disabled';
        },
        pricingLabel: function pricingLabel() {
          if (plan.baseIntervalPriceFloat || 0 > 0) {
            return '' + plan.basePriceFloat.toLocaleString('en');
          } else if (plan.bulkPriceFloat || 0 > 0) {
            return '' + plan.bulkPriceFloat.toLocaleString('en');
          } else if (plan.burstUnitPriceFloat > 0) {
            return plan.burstUnitPriceFloat.toLocaleString('en') + ' per ' + plan.usageMeasureUnitName;
          }
        },
        isBulk: function isBulk() {
          return (plan.baseIntervalPriceFloat || 0) === 0 && (plan.bulkPriceFloat || 0) > 0;
        },
        intervalLabel: function intervalLabel() {
          var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'base';
          var ignoreBulk = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

          // if there is no base plan, and there is an up-front bulk price, then treat it as a bulk
          // plan. NOTE: we don't check planCategory == 'bulk' here because its possible for other plans,
          // such as "pilot", to also be bulk-like.
          if (!ignoreBulk && plan.isBulk()) {
            return 'Once';
          }

          var name = plan[type + 'IntervalName'] || '';
          switch (name) {
            case '1 Month':
              return 'Monthly';
            case '3 Month':
              return 'Quarterly';
            case '6 Month':
              return 'Semi-Annually';
            case '12 Month':
              return 'Annually';
            case '1 Week':
              return 'Weekly';
            case '2 Week':
              return 'Semi-Monthly';
            case '':
              return null;
            default:
              return 'Every ' + name + 's';
          }
        },
        creditsLabel: function creditsLabel() {
          if (plan.id === 'custom') {
            return 'Different Options Available';
          } else if (plan.recurringUsageAllotment === 0) {
            return 'Charged as Used';
          } else {
            var interval = (plan.usageIntervalName + 's').replace('1 Months', 'Month').replace('1 Weeks', 'Week');

            interval = 'Every ' + interval;
            interval = interval.replace('Every 12 Months', 'Annually');

            return plan.recurringUsageAllotment.toLocaleString('en') + ' ' + plan.usageMeasureUnitName.replace('Assessment ', '') + 's ' + interval;
          }
        },
        ctaLabel: function ctaLabel() {
          if (plan.isCurrent) {
            return 'Current';
          } else if (plan.id === 'custom' || plan.isDisabled) {
            return 'Contact Us';
          } else if (!customer) {
            return 'Start Free Trial';
          } else if (plan.isScheduledDowngrade) {
            return 'Cancel Scheduled Downgrade';
          } else if (plan.id === 'custom' || plan.isDisabled) {
            return 'Contact Us';
          } else if (plan.isBulk()) {
            return 'Purchase';
          } else if (customer && customer.plan && customer.isPaying) {
            if (customer.plan.basePrice > plan.basePrice) {
              return 'Downgrade';
            }
            return 'Switch';
          }

          return 'Subscribe';
        }
      });

      // we also want to disable any customers under contract from making changes
      if (customer && customer.contractId) {
        api.isDisabled = true;
      }

      if (customer && customer.scheduledChanges && customer.scheduledPlan && customer.scheduledPlan.billingPlanId === plan.id) {
        api.isScheduledDowngrade = true;
      }

      return api;
    }

    var svc = {
      cache: null,
      extendedApi: function extendedApi(customer) {
        var plans = [],
            customerPlan = false;

        var addCustomerPlan = function addCustomerPlan(isPublic) {
          // we want to make sure we don't add a duplicate plan, so try to find an existing one first
          var existing = customer.plan.billingPlanId && plans.find(function (p) {
            return p.id === customer.plan.billingPlanId;
          });

          // need to make a copy and add the features to the plan, since customer plans store
          // features at the customer level
          var plan = existing || angular.copy(customer.plan);
          plan.id = customer.plan.billingPlanId;
          plan.features = customer.features;
          plan.public = isPublic;
          plan.isDisabled = customer.isPaying;
          plan.isCurrent = true;

          if (customer.state === 'non_renewing') {
            plan.cancelsAt = customer.currentBaseTermEnd;
          }

          if (customer.scheduledPlan) {
            plan.downgradesAt = customer.currentBaseTermEnd;
          }

          if (!existing) plans.push(plan);
          customerPlan = true;
        };

        // go through each available plan and decide if we should replace it with the current plan
        svc.cache.forEach(function (plan) {
          if (customer && customer.plan && customer.plan.planCategory === plan.planCategory && !customerPlan && customer.isPaying) {
            addCustomerPlan(true);
          } else if (!plans.find(function (p) {
            return p.id === plan.id;
          })) {
            plans.push(plan);
          }
        });

        // if the customer has a plan and it hasn't been added yet, then it must be a non-standard plan
        if (customer && customer.plan && !customerPlan && customer.isPaying) {
          addCustomerPlan();
        }

        // add custom plan if there are only 1 or 2 plans available, and the last plan is not an enteprise plan
        if (!plans.length || plans.length < 3 && plans[plans.length - 1].planCategory !== 'enterprise') {
          plans.push(CUSTOM_PLAN);
        }

        plans = plans.map(function (plan) {
          var copy = angular.copy(plan);
          return planApi(copy, customer);
        });

        return plans.sort(function (a, b) {
          return a.basePrice + a.bulkPrice > b.basePrice + b.bulkPrice ? 1 : -1;
        });
      },
      load: function load(customer) {
        return $http.get(appConfig.apiRoot + 'billing/plans').then(function (response) {
          svc.cache = response.data && response.data.data || [];
          return svc.extendedApi(customer);
        });
      }
    };

    return svc;
  }]);

  var billingPlansTableTemplate = "<table class=\"selected-{{ $ctrl.selected + 1 }}\" ng-class=\"{ 'features-hidden': !$ctrl.showFeatures }\"> <thead> <tr> <th></th> <td ng-repeat=\"plan in $ctrl.plans track by plan.id\" ng-style=\"{ 'min-width': $ctrl.width() }\"> <div> <a href ng-click=\"$ctrl.prevPlan()\" class=\"prev-plan\"></a> <span ng-bind=\"plan.displayName || plan.planCategoryName\"></span> <a href ng-click=\"$ctrl.nextPlan()\" class=\"next-plan\"></a> </div> </td> </tr> </thead> <tbody class=\"prices\"> <tr class=\"price\"> <th></th> <td ng-repeat=\"plan in $ctrl.plans track by plan.id\"> <span ng-show=\"plan.pricingLabel()\"> <span class=\"unit\">$</span>{{ plan.pricingLabel() }} </span> <a href ng-show=\"plan.id === 'custom'\" ng-click=\"$ctrl.onSelect({ plan: plan, event: 'pricingContact' })\" id=\"{{ ::$ctrl.baseTrackingKey }}.salesLeadEnterprise--{{ ::$ctrl.baseTrackingKey }}.planPricing\"> Contact Us For Pricing </a> </td> </tr> <tr class=\"billing-note\" ng-class=\"{'landing': $ctrl.landing}\"> <th></th> <td ng-repeat=\"plan in $ctrl.plans track by plan.id\"> <strong>Billed {{ plan.intervalLabel() }}</strong> <button class=\"button btn-primary\" tabindex=\"0\" id=\"{{ ::$ctrl.baseTrackingKey }}.{{ :: plan.id === 'custom' ? 'salesLeadEnterprise' : 'signup' }}--{{ ::$ctrl.baseTrackingKey }}.planCta\" ng-if=\"!$ctrl.landing\" ng-disabled=\"plan.isDisabled\" ng-click=\"$ctrl.onSelect({ plan: plan, event: 'cta' })\"> {{ plan.ctaLabel() }} </button> </td> </tr> <tr class=\"billing-note\" ng-if=\"$ctrl.landing\"> <th></th> <td ng-repeat=\"plan in $ctrl.plans track by plan.id\"> {{ plan.description }} </td> </tr> </tbody> <tbody class=\"features\" ng-if=\"$ctrl.showFeatures\"> <tr class=\"credits\"> <th><span>Included Usage</span></th> <td ng-repeat=\"plan in $ctrl.plans track by plan.id\"> <div ng-class=\"{ enterprise: plan.id === 'custom' }\"> {{ plan.creditsLabel() }} <tooltip-help-icon ng-if=\"plan.id !== 'custom' && plan.burstUnitPriceFloat > 0\" tooltip=\"If you go beyond what your plan includes, we got you covered. Simply pay ${{ plan.burstUnitPriceFloat }} per each {{ plan.usageMeasureUnitName.toLowerCase() }}, charged only after you have used all of your included usage credits for the given cycle.\"></tooltip-help-icon> </div> </td> </tr> <tr class=\"user-seats\"> <th> <span>User Seats</span> </th> <td ng-repeat=\"plan in $ctrl.plans track by plan.id\"> <span ng-if=\"plan.includedPremiumSeats\"> {{ plan.includedPremiumSeats }} Manager{{ plan.includedPremiumSeats\n          === 1 ? '' : 's' }} </span> <span ng-if=\"plan.includedRestrictedSeats\"> <span ng-if=\"plan.includedPremiumSeats\">/ </span> {{ plan.includedRestrictedSeats }} Reviewer{{\n          plan.includedRestrictedSeats === 1 ? '' : 's' }} </span> <tooltip-help-icon ng-if=\"plan.features.additionalTeamMembers\" tooltip=\"{{ $ctrl.seatsTooltip(plan) }}\"></tooltip-help-icon> <div class=\"enterprise\" ng-if=\"!plan.includedPremiumSeats\"> Configurable Managers and Reviewers </div> </td> </tr> </tbody> <tbody class=\"features group\" ng-if=\"$ctrl.showFeatures\" ng-repeat=\"group in $ctrl.groups\"> <tr class=\"group-heading\" ng-if=\"group.label\"> <th> <span class=\"group-{{ group.label.toLowerCase() }}\">{{ group.label }}</span> </th> <td ng-repeat=\"plan in $ctrl.plans track by plan.id\"></td> </tr> <tr class=\"feature\" ng-repeat=\"feature in group.features\" ng-if=\"(feature.displayName || feature.image) && !feature.hidden\"> <th tooltip=\"{{ feature.tooltip }}\"> <span ng-if=\"feature.displayName\">{{ feature.displayName }}</span> <img ng-if=\"feature.image\" ng-src=\"{{ feature.image }}\" alt=\"{{ feature.alt }}\"> <tooltip-help-icon></tooltip-help-icon> </th> <td ng-repeat=\"plan in $ctrl.plans track by plan.id\"> <span class=\"icon-plus\" ng-if=\"plan.featureStatus(feature.key) === 'optional'\" tooltip=\"This feature is included within our enterprise team plans. Contact us to learn more.\"> <span>+</span> </span> <span class=\"icon-checkmark\" ng-if=\"plan.featureStatus(feature.key) === 'enabled'\"> <span>✓</span> </span> <span class=\"custom-text\" ng-if=\"plan.featureStatus(feature.key) === 'labeled'\"> {{ plan.featuresList[feature.key].label }} </span> </td> </tr> </tbody> </table> <div class=\"features-toggle\" ng-if=\"!$ctrl.showFeatures\"> <button class=\"btn-default btn-sm\" ng-click=\"$ctrl.showFeatures = true\"> Compare Plan Features </button> </div> ";

  var groups = [{ id: undefined, label: 'Platform' }, { id: 'content', label: 'Content' }, { id: 'team', label: 'Teamwork' }, { id: 'integrate', label: 'Integrate' }, { id: 'support', label: 'Support' }];

  var billingPlansTableComponentModule = angular.module('Q.components.billing-plans-table', []).component('billingPlansTable', {
    bindings: {
      plans: '<',
      onSelect: '&',
      customer: '<',
      showBurst: '<',
      hideFeatures: '<',
      landing: '<'
    },
    controller: 'BillingPlansTableCtrl',
    template: billingPlansTableTemplate
  }).controller('BillingPlansTableCtrl', function BillingPlansTableCtrl() {
    var ctrl = this;

    ctrl.width = function () {
      return 100 / (ctrl.plans.length + 1) + '%';
    };

    ctrl.selected = 0;
    ctrl.nextPlan = function () {
      ctrl.selected = (ctrl.selected + 1) % ctrl.plans.length;
    };
    ctrl.prevPlan = function () {
      ctrl.selected = (ctrl.selected + ctrl.plans.length - 1) % ctrl.plans.length;
    };

    ctrl.$onInit = function () {
      ctrl.baseTrackingKey = ctrl.customer ? 'hire' : 'landing';
      ctrl.showFeatures = !ctrl.hideFeatures;
      setFeatures();

      ctrl.$onChanges = setFeatures;
    };

    function setFeatures() {
      // sort the features by plan, so that each plan's unique features are clustered together
      var features = [];
      if (ctrl.plans[0]) {
        var list = ctrl.plans[0].featuresList;
        // if we want to show the actual burst prices, then hide the generic feature
        if (ctrl.showBurst) delete list.burstUsage;

        angular.forEach(list, function (feature, key) {
          feature.key = key;
          features.push(feature);
          for (var i = 1; i < ctrl.plans.length; i++) {
            if (ctrl.plans[i - 1].featuresList[key].enabled) {
              feature.priority = i;
              return;
            }
          }
        });
      }

      ctrl.features = features.sort(function (a, b) {
        if (a.priority === b.priority) {
          if (a.image || b.image) {
            if (a.image && b.image) {
              return a.key > b.key ? 1 : -1;
            }
            return a.image && !b.image ? -1 : 1;
          }
          return a.displayName > b.displayName ? 1 : -1;
        }
        return a.priority > b.priority ? 1 : -1;
      });

      ctrl.seatsTooltip = function (plan) {
        var tips = [];
        if (plan.additionalPremiumSeatPriceFloat > 0) {
          tips.push('$' + plan.additionalPremiumSeatPriceFloat + ' a month per additional manager seat');
        }
        if (plan.additionalRestrictedSeatPriceFloat > 0) {
          tips.push('$' + plan.additionalRestrictedSeatPriceFloat + ' a month per additional reviewer seat');
        }

        return tips.join(', ');
      };

      ctrl.groups = groups.map(function (g) {
        g.features = ctrl.features.filter(function (f) {
          return f.group === g.id;
        });
        return g;
      });
    }
  });

  var subscriptionsTemplate = "<billing-plans-table plans=\"plans\" ng-if=\"plans.length > 0\" on-select=\"select(plan, event)\" hide-features=\"false\" landing=\"true\" show-burst=\"false\"></billing-plans-table> ";

  var subscriptionsComponentModule = angular.module('Q.components.subscriptions', [productTypeServiceModule, billingPlansTableComponentModule, billingFeaturesServiceModule, billingPlansServiceModule]).directive('subscriptions', ['billingPlansService', 'billingFeaturesService', 'productTypeService', '$timeout', '$location', '$document', function (billingPlansService, billingFeaturesService, productTypeService, $timeout, $location, $document) {
    var educationReferrers = /education/;

    return {
      restrict: 'E',
      scope: {
        onSelect: '&',
        discount: '='
      },
      template: subscriptionsTemplate,
      link: function link(scope) {
        scope.plans = [];
        scope.productType = 'recruitment';
        if ($location.search().education || educationReferrers.test($document[0].referrer)) {
          scope.productType = 'education';
        }

        scope.switchProductType = function () {
          productTypeService.setProduct(scope.productType);
          billingFeaturesService.load().then(function () {
            billingPlansService.load().then(function (plans) {
              scope.plans = plans;
            });
          });
        };
        scope.switchProductType();

        scope.select = function (plan, eventName) {
          scope.onSelect({ plan: plan, eventName: eventName });
        };
      }
    };
  }]);

  angular.extend(window.config, {
    appId: 'landing',
    appPath: '/',
    appName: 'Landing'
  });

  var angularCoreConfigModule = angular.module('Q.config.angular-log', []).config(['$logProvider', '$compileProvider', '$qProvider', function ($logProvider, $compileProvider, $qProvider) {
    // Only log debug events on dev mode
    $logProvider.debugEnabled(appConfig.devMode);

    // Only render debug data on dev mode, or when debug=true in the URL
    $compileProvider.debugInfoEnabled(appConfig.devMode || /debug=true/.test(window.location.search));

    // Prevent $q from throwing errors on unhandled rejections on newer versions
    if ($qProvider.errorOnUnhandledRejections) {
      // TODO: is it worth cleaning up the codebase for this?
      $qProvider.errorOnUnhandledRejections(false);
    }
  }]).run(['$timeout', function ($timeout) {
    // Disables pre-load error handling after the application loads
    $timeout(function () {
      // At this point, we should be able to rely on Angular for rendering errors
      appConfig.isLoaded = true;
    }, 1, false);
  }]);

  var configModule = angular.module('Q.config', [appConfigModule, angularCoreConfigModule]).config(['$anchorScrollProvider', function ($anchorScrollProvider) {
    $anchorScrollProvider.disableAutoScrolling();
  }]);

  var articleCarouselTemplate = "<div class=\"small-screen-articles\"> <p ng-repeat=\"article in $ctrl.articles track by $index\"> <a ng-href=\"{{article.link}}\" target=\"_blank\" rel=\"noreferrer\" track-click=\"Article Viewed\" track-data=\"{ ui: {region: 'body'} }\" bind-html-unsafe=\"article.logo\" title=\"{{article.source}}\"></a> </p> </div> <div class=\"large-screen-articles\"> <ul class=\"article-selector\"> <li ng-repeat=\"article in $ctrl.articles track by $index\" ng-class=\"{ active: $index === $ctrl.activeIndex }\"> <span ng-click=\"$ctrl.jump($index)\" bind-html-unsafe=\"article.logo\" title=\"{{article.source}}\"></span> </li> </ul> <div class=\"articles-wrapper\" ng-class=\"{ ready: $ctrl.ready, reverse: $ctrl.reverse }\"> <div ng-repeat=\"article in $ctrl.articles track by $index\" class=\"article-link\" ng-class=\"{ active: $index === $ctrl.activeIndex, prev: $index === $ctrl.prevIndex }\"> <a ng-href=\"{{article.link}}\" target=\"_blank\" rel=\"noreferrer\" track-click=\"Article Viewed\" track-data=\"{ ui: {region: 'body'} }\"> <h2 ng-bind=\"article.title\"></h2> <p ng-bind=\"article.description\"></p> </a> <p class=\"article-button\"> <a href=\"{{article.link}}\" class=\"btn-basic light-bg\" target=\"_blank\" rel=\"noreferrer\" track-click=\"Article Viewed\" track-data=\"{ ui: {region: 'body'} }\"> Read more at {{article.source}} </a> </p> </div> </div> </div> ";

  var entrepreneurLogo = "<svg height=\"49\" viewBox=\"0 0 247 49\" width=\"247\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M.36 32.796l3.114-.496V3.564L0 3.113.18 0h21.744l-.541 8.706-4.331-.135-.27-5.458H10.06V16.06h2.932l.677-2.978 3.022.09v8.932H13.67l-.722-3.067h-2.932V32.75h6.766l.632-5.955 4.556.135L22.33 36H.226zm24 3.248l.135-2.662 2.436-.496V14.751l-2.842-.27v-2.707l7.128-1.038.541 1.534v1.038c1.714-1.805 3.79-2.887 6.451-2.887 3.88 0 6.767 2.345 6.767 6.992V32.84l2.571.496L47.412 36H38.93V18.766c0-2.48-.902-3.88-3.158-3.88-.767 0-1.308.136-1.895.362-.36.315-.721.766-1.037 1.172v16.511l2.571.496-.18 2.662H24.36zm136.28 0l.09-2.662 2.437-.496V14.751l-2.842-.27v-2.707l7.127-1.038.542 1.534v1.038c1.714-1.805 3.79-2.887 6.45-2.887 3.88 0 6.767 2.345 6.767 6.992V32.84l2.572.496-.136 2.662h-8.435V18.766c0-2.48-.903-3.88-3.158-3.88-.767 0-1.308.136-1.895.362-.36.315-.722.766-1.037 1.172v16.511l2.57.496-.18 2.662h-10.871zm-99.65-.496c-.992.406-2.752.857-5.052.857-3.023 0-5.82-1.354-5.82-5.775V14.751l-2.887-.45.136-3.159 3.248-.135 1.398-4.827 4.15-.18v5.188h4.466l-.315 3.157-4.106.451v15.88c0 1.308.722 2.165 2.076 2.165h2.436zm168.851.496l.09-2.617 2.301-.541V14.751l-2.707-.27v-2.707l7.399-1.038.496 1.76v.586c1.94-1.443 4.556-2.39 7.714-2.39l1.082.947-.766 6.857-4.06-.136-.406-3.654c-.948.136-1.85.406-2.617.948V32.93l2.571.541-.18 2.617h-10.917zm-106.237 0l.136-2.617 2.3-.541V14.751l-2.706-.27v-2.707l7.398-1.038.496 1.76v.586c1.94-1.443 4.556-2.39 7.714-2.39l1.083.947-.857 6.857-4.06-.136-.406-3.654c-.948.136-1.85.406-2.617.948V32.93l2.572.541-.18 2.617h-10.873zm-60.81 0l.136-2.617 2.3-.541V14.751l-2.706-.27v-2.707l7.398-1.038.496 1.76v.586c1.94-1.443 4.557-2.39 7.67-2.39l1.082.947-.767 6.857-4.06-.136-.406-3.654c-.947.136-1.85.406-2.616.948V32.93l2.571.541-.18 2.617H62.795zm23.368-11.052c0 4.33 1.895 7.668 5.64 7.668 1.939 0 3.473-.406 5.277-1.263l1.038 2.391c-1.85 1.489-4.557 2.617-7.94 2.617-6.586 0-10.375-5.684-10.375-12.992 0-6.226 2.751-13.037 10.285-13.037 6.586 0 9.067 6.09 9.067 12.856l-.631 1.624zm-.09-2.888l7.579-.36c-.136-3.023-.767-7.805-3.745-7.805-.721 0-1.218.136-2.12.587-1.218 2.075-1.714 5.82-1.714 7.578zM191 24.992c0 4.33 1.895 7.668 5.64 7.668 1.94 0 3.473-.406 5.277-1.263l1.038 2.391c-1.85 1.489-4.556 2.617-7.94 2.617-6.586 0-10.375-5.684-10.375-12.992 0-6.226 2.752-13.037 10.285-13.037 6.586 0 9.067 6.09 9.067 12.856l-.631 1.624zm-.09-2.888l7.579-.36c-.135-3.023-.767-7.805-3.744-7.805-.722 0-1.218.136-2.12.587-1.219 2.075-1.715 5.82-1.715 7.578zm-43.938 2.888c0 4.33 1.895 7.668 5.639 7.668 1.94 0 3.473-.406 5.278-1.263l1.037 2.391c-1.85 1.489-4.556 2.617-7.94 2.617-6.585 0-10.375-5.684-10.375-12.992 0-6.226 2.752-13.037 10.286-13.037 6.586 0 9.067 6.09 9.067 12.856l-.632 1.624zm-.09-2.888l7.578-.36c-.135-3.023-.766-7.805-3.744-7.805-.722 0-1.218.136-2.12.587-1.218 2.075-1.76 5.82-1.714 7.578zm74.162 13.94l-.631-2.166c-1.67 1.58-3.293 2.527-5.82 2.527-3.879 0-7.353-1.94-7.353-7.308V14.12l-2.842-.27v-2.392l8.21-.947.632 2.165v15.699c0 2.752 1.128 4.195 3.338 4.195.632 0 1.444-.09 2.166-.36a8.504 8.504 0 001.128-1.4V14.12l-2.933-.27v-2.392l8.3-.947.632 2.165v20.21l2.572.496-.316 2.662zm-99.47-13.218c0 4.286-.09 13.624-9.292 13.624-1.58 0-3.023-.361-4.06-.948v9.744l2.57.497-.18 2.571H99.741l.135-2.571 2.436-.497V14.481l-2.842-.361v-2.617l7.353-1.037.632 2.165v.857c.721-.902 2.48-3.067 6.225-3.067 5.639 0 7.894 4.781 7.894 12.405zm-10.104 9.97c1.172 0 2.165-.226 3.112-.677.226-.677 1.128-2.3 1.128-8.21 0-6.135-.586-9.564-3.97-9.564-.812 0-1.488.09-2.255.361-.406.451-.812.948-1.173 1.489v15.924c.812.451 1.85.677 3.158.677z\"/></svg>";

  var forbesLogo = "<svg height=\"49\" viewBox=\"0 0 144 49\" width=\"144\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M87.34 10.196c5.684 0 9.924 4.962 9.924 11.82C97.264 30.585 92.031 36 83.28 36c-3.248 0-6.406-.631-9.383-1.263.27-3.338.36-24.36 0-28.33-.18-2.076-.722-2.978-2.256-3.159l-1.083-.18v-.993L81.565 0a254.24 254.24 0 00-.27 11.73c1.894-.903 3.789-1.534 6.044-1.534zm-3.88 24c3.609 0 6.135-5.143 6.135-11.82 0-5.233-2.075-9.383-5.684-9.383-.903 0-1.624 0-2.617.36 0 8.482.09 18.317.27 20.662.452.09 1.264.18 1.896.18zm-54.317-23.73l-1.714.542c-1.534-5.053-3.97-7.85-8.391-7.85h-5.684c-.271 3.158-.361 8.481-.361 13.985l3.88-.09c2.526-.09 3.608-1.985 4.24-4.782h1.444V24h-1.444c-.632-2.798-1.714-4.783-4.24-4.873l-3.88-.09c0 4.24.18 7.76.36 9.925.271 3.158 1.083 4.42 3.339 4.782l1.985.18v1.444H0v-1.444l1.534-.18c2.256-.361 3.068-1.624 3.338-4.782.451-5.143.451-15.88 0-21.835-.27-3.158-1.082-4.421-3.338-4.782L0 2.166V.721h28.963zm9.203-.541c8.21 0 12.361 5.684 12.361 12.993C50.707 30.136 46.106 36 37.895 36s-12.36-5.684-12.36-12.992c0-7.218 4.6-13.083 12.811-13.083zm-.36 1.624c-3.61 0-4.692 4.872-4.692 11.369 0 6.315 1.624 11.458 4.962 11.458 3.61 0 4.692-4.962 4.692-11.458 0-6.316-1.624-11.369-4.963-11.369zm61.353 11.64c0-6.858 4.241-13.174 12.722-13.174 6.858 0 10.286 5.143 10.286 11.82h-15.429c-.18 6.045 2.978 10.466 8.843 10.466 2.616 0 3.97-.631 5.503-1.804l.722.902C120.272 33.745 116.663 36 111.971 36c-7.398 0-12.632-5.323-12.632-12.812zm7.67-3.159l7.669-.18c0-3.429-.451-8.301-3.248-8.301s-4.331 4.602-4.421 8.481zm35.098-2.436l-1.263.361c-1.354-4.33-3.339-6.226-6.316-6.226-1.985 0-3.429 1.534-3.429 3.7s1.534 3.248 6.226 5.052c4.33 1.625 6.045 3.61 6.045 7.128 0 5.233-3.97 8.391-10.557 8.391-3.157 0-6.586-.721-8.661-1.533l-.27-7.219 1.262-.36c1.805 5.052 4.15 6.947 7.218 6.947 2.617 0 4.15-1.895 4.15-3.88s-1.082-3.158-5.323-4.692c-3.88-1.443-6.767-3.067-6.767-7.398 0-4.24 3.79-7.94 10.016-7.94 2.887 0 5.594.541 7.398 1.353zm-72.633-.18c-3.338-2.256-6.947-1.173-7.669 0-.27 4.06-.18 10.195.09 13.263.18 2.075.812 2.978 2.346 3.158l1.985.18v1.354H50.888v-1.354l1.082-.18c1.534-.18 2.166-1.083 2.346-3.158.271-3.338.361-10.376 0-14.346-.18-2.075-.812-2.977-2.346-3.158l-1.082-.09v-.993l11.007-2.165-.09 5.774c2.527-5.864 7.58-6.676 10.376-5.052z\"/></svg>";

  var incLogo = "<svg height=\"49\" viewBox=\"0 0 105 49\" width=\"105\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M24.608 0v8.296h-4.455c-.359 6.095-.051 12.855-.154 19.205h4.61v7.836H.025v-7.682H4.48c.358-6.147.052-12.957.154-19.359H.025C.129 5.582-.178 2.458.18 0zm64.376 34.876c-1.469.546-5.793 1.326-9.526 1.075-4.965-.332-9.765-2.571-12.138-5.377l-1.69-2.612v7.375H46.886v-7.682h3.38c.277-1.562.154-3.515.154-5.378 0-1.901.14-3.635-.615-4.762-1.253-1.875-4.55-1.701-6.145-.615-.157.107-.311.187-.461.307-.077.062-.091.264-.154.308-.059.041-.26-.052-.307 0-.374.406-1.097 1.805-1.23 2.611-.366 2.233.273 5.09 0 7.529h3.688v7.682H25.837v-7.682h3.38c.357-3.587.053-7.834.154-11.677h-3.534c.103-2.51-.204-5.428.154-7.682h15.057c.223.664.136 3.156.153 4.917.425.102.547-.394.769-.615.152-.152.3-.318.46-.46.64-.571 1.378-1.301 2.305-1.845 2.236-1.31 5.047-1.994 9.065-1.69 3.135.238 5.757 1.606 7.221 3.38.095.116.059.209.154.308.339.354 1.1 2.193 1.229 2.919.46 2.586.136 7.796.166 12.253.691.062 1.985.076 2.907.038-1.196-2.586-1.277-7.278-.154-10.14.319-.813.708-1.683 1.23-2.458.167-.25.427-.364.614-.615.2-.269.312-.606.46-.768.925-1.007 2.407-2.014 3.842-2.766 2.918-1.53 7.09-2.632 11.983-2.304 7.05.472 12.202 4.441 12.753 11.216-3.32.52-6.947.735-10.294 1.229-.262-2.401-.687-4.879-2.612-5.685-1.287-.539-3.158-.407-4.456.46-1.234.826-1.834 2.634-1.997 4.303-.343 3.51.006 7.849 2.305 9.065 2.087 1.104 5.575.333 6.452-1.69.228-.525.298-1.12.461-1.998h10.294c.023 1.598-.596 2.933-1.229 4.149-.574 1.103-1.127 2.184-2.15 3.072s-2.527 1.759-3.995 2.305zm10.6-8.143c-.004 0 .042-.154.154-.154a4.575 4.575 0 014.61 4.456 4.344 4.344 0 01-.461 1.997c-.576 1.171-2.126 2.458-3.995 2.458-2.392 0-4.333-1.932-4.456-4.148-.092-1.669 1.017-3.592 2.459-4.302.5-.246.87-.245 1.69-.307z\" fill-rule=\"evenodd\"/></svg>";

  var uiBootstrapBindHtmlModule = 'ui.bootstrap.bindHtml';

  var articles = [{
    link: 'https://www.inc.com/andrew-medal/top-4-ways-companies-can-recruit-better-technical-talent.html',
    title: 'Top 4 Ways Companies Can Recruit Better Technical Talent',
    source: 'Inc',
    logo: incLogo,
    description: "Finding the right technical talent can make or break your company's success. Revamp your hiring approach with these creative, tech-driven solutions."
  }, {
    link: 'https://www.forbes.com/sites/julianmitchell/2017/09/26/codewars-founder-nathan-doctors-new-startup-makes-it-easy-to-recruit-top-developers/',
    title: "Codewars Co-Founder Nathan Doctor's New Venture Makes It Easy To Identify Top Developers",
    source: 'Forbes',
    logo: forbesLogo,
    description: 'I spoke with Qualified CEO and Co-Founder Nathan Doctor about the vision behind his company, redefining how tech companies hire top talent, and his plans to rewrite the code of an expanding industry.'
  }, {
    link: 'https://www.entrepreneur.com/article/307573',
    title: '4 Innovative Moves Entrepreneurs Can Make To Hire More Qualified Tech Experts',
    source: 'Entrepreneur',
    logo: entrepreneurLogo,
    description: 'As the economy grows, so does the number of companies at the leading edge of innovation. Tech leaders need to start harnessing, yes, tech, to hire.'
  }];

  var articleCarouselComponentModule = angular.module('Q.components.article-carousel', [timerHelperModule, uiBootstrapBindHtmlModule]).component('articleCarousel', {
    controller: 'ArticleCarouselCtrl',
    template: articleCarouselTemplate
  }).controller('ArticleCarouselCtrl', ['$element', 'timerHelper', function ArticleCarouselCtrl($element, timerHelper) {
    var ctrl = this;

    ctrl.active = null;
    ctrl.articles = articles;
    ctrl.activeIndex = -1;
    var timer = void 0;

    var start = function start() {
      if (timer) timer.start();
    };
    var stop = function stop() {
      if (timer) timer.stop();
    };

    ctrl.addArticle = function (article) {
      articles.push(article);
    };

    ctrl.$postLink = function () {
      timer = timerHelper.runEvery(ctrl.next, 5000);
      timerHelper.longTimeout(function () {
        return ctrl.ready = true;
      }, 5000);
    };
    ctrl.$onDestroy = function () {
      stop();
    };

    var _prevIndex = function _prevIndex() {
      return (ctrl.activeIndex + articles.length - 1) % articles.length;
    };
    var _nextIndex = function _nextIndex() {
      return (ctrl.activeIndex + 1) % articles.length;
    };

    ctrl.next = function () {
      ctrl.jump(_nextIndex(), { pause: false, reverse: false });
      start();
    };

    ctrl.prev = function () {
      ctrl.jump(_prevIndex(), { pause: false, reverse: true });
      start();
    };

    ctrl.jump = function (index) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$pause = _ref.pause,
          pause = _ref$pause === undefined ? true : _ref$pause,
          _ref$reverse = _ref.reverse,
          reverse = _ref$reverse === undefined ? null : _ref$reverse;

      if (index !== ctrl.activeIndex) {
        var numArticles = articles.length;
        ctrl.prevIndex = ctrl.activeIndex;
        ctrl.activeIndex = index % numArticles;
        if (reverse === null) {
          reverse = ctrl.activeIndex < ctrl.prevIndex;
        }
        ctrl.active = articles[ctrl.activeIndex];
        ctrl.reverse = reverse;
      }
      if (pause) {
        ctrl.ready = true;
        stop();
      }
    };
  }]);

  var stickyHeaderComponentModule = angular.module('Q.components.sticky-header', [scrollMonitorServiceModule]).directive('stickyHeader', ['scrollMonitorService', '$timeout', '$window', function (scrollMonitorService, $timeout, $window) {
    return {
      restrict: 'A',
      link: function link(scope, $elem, attr) {
        if (attr.stickyHeaderNonMobile !== undefined && angular.element($window).offsetWidth() < 768) {
          return;
        }
        $timeout(function () {
          // create clone of the element to act as a placeholder when we scroll off-screen
          var elem = $elem[0];
          var $placeholder = $elem.clone();
          var placeholder = $placeholder[0];
          $placeholder.addClass('sticky-header-placeholder-inactive');
          $elem.addClass('sticky-header');
          $elem.after($placeholder);

          var viewport = attr.stickyHeader || $elem.scrollableParent();

          var lastTop = null;
          var lastLeft = null;
          var lastActive = false;

          var isTable = elem.nodeName === 'THEAD' || elem.nodeName === 'TR';

          var scrollWatcher = scrollMonitorService.addListener(viewport, function (event, data) {
            var nonScrollEvent = event && event.type !== 'scroll';
            var elTop = data.elementTop;
            if (lastActive) {
              // the element top won't be useful if we were already active
              if (nonScrollEvent) {
                // if we've had a DOM change, lastTop may no longer be correct
                elTop = $placeholder.offsetTop() - $placeholder.scrollableParent().offsetTop();
              } else {
                // otherwise, if just scrolling, we can safely use the last known top
                elTop = lastTop;
              }
            }
            var elLeft = lastActive ? lastLeft : $elem.offsetLeft();
            var active = data.viewportScrollTop >= elTop;
            var shouldUpdate = lastActive !== active;

            // toggle classes if we're changing state
            if (shouldUpdate) {
              $elem.toggleClass('sticky-header-active', active);
              $placeholder.toggleClass('sticky-header-placeholder-inactive', !active);
              $placeholder.toggleClass('sticky-header-placeholder-active', active);

              $elem.css('top', active ? data.viewportTop + 'px' : null);
              $elem.css('left', active ? elLeft + 'px' : null);
              $elem.css('margin-top', active ? '0' : null);
            }
            if (shouldUpdate || active) {
              if (attr.stickyHeaderSetWidth !== 'false') {
                $elem.css('width', active ? placeholder.offsetWidth + 'px' : null);
              }
              if (attr.stickyHeaderSetHeight !== 'false') {
                $elem.css('height', active ? placeholder.offsetHeight + 'px' : null);
              }
            }

            // update table cells everytime if active, or if changing states
            if (isTable && (shouldUpdate || active)) {
              var origCells = elem.querySelectorAll('td,th');
              var phCells = placeholder.querySelectorAll('td,th');
              angular.forEach(phCells, function (cell, idx) {
                var width = active ? cell.offsetWidth + 'px' : null;
                var height = active ? cell.offsetHeight + 'px' : null;
                angular.element(origCells[idx]).css('min-width', width);
                angular.element(origCells[idx]).css('min-height', height);
              });
            }

            lastActive = active;
            lastTop = elTop;
            lastLeft = elLeft;
          }, $elem);

          scope.$on('$destroy', function () {
            return scrollWatcher.destroy();
          });
        }, 250);
      }
    };
  }]);

  var consentCookiePopupTemplate = "<div class=\"help-block\"> <p> This website stores data such as cookies to enable important site functionality, including analytics and personalization. </p> <p><a href=\"/kb/legal/privacy-policy\">Read our privacy policy here.</a></p> </div> <div class=\"buttons\"> <button class=\"btn-primary btn-sm\" ng-click=\"consent()\">Accept</button> </div> ";

  var CONSENT_COOKIE = 'qualified-cookie-consent';

  var cookieWarningServiceModule = angular.module('Q.services.cookie-warning-service', ['ngAnimate']).directive('consentCookiePopup', ['$animate', function ($animate) {
    return {
      restrict: 'E',
      template: consentCookiePopupTemplate,
      link: function link(scope, elem) {
        scope.consent = function () {
          setCookie(CONSENT_COOKIE, 1, Infinity);
          $animate.leave(elem);
          scope.$destroy();
        };
      }
    };
  }]).run(['$compile', '$rootScope', '$animate', '$document', function ($compile, $rootScope, $animate, $document) {
    if (!hasCookie(CONSENT_COOKIE)) {
      var el = angular.element('<consent-cookie-popup></consent-cookie-popup>');
      $compile(el)($rootScope.$new(true));
      $animate.enter(el, $document.find('body'));
    }
  }]);

  var featureCarouselDirectiveModule = angular.module('Q.components.feature-carousel', [timerHelperModule]).directive('featureCarousel', ['timerHelper', '$window', function (timerHelper, $window) {
    return {
      restrict: 'A',
      link: function link(scope, el, attr) {
        el.addClass('carousel-mode-enabled');
        var list = el.find('ul');
        var listItems = list.querySelectorAll('li');
        var totalItems = listItems.length;
        var headerSelector = angular.element('<div class="feature-carousel-header-selector"></div>');
        var headerItems = void 0;
        var autoFlipTimer = void 0;

        var stopFlipTimer = function stopFlipTimer() {
          timerHelper.runEvery.cancel(autoFlipTimer);
        };

        var select = function select(idx) {
          var stopFlipping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

          var active = list.getStyle('display') === 'flex';
          if (active) {
            listItems.removeClass('selected');
            headerItems.removeClass('selected');
            listItems.eq(idx).addClass('selected');
            headerItems.eq(idx).addClass('selected');
            listItems.css({ transform: 'translateX(-' + idx + '00%)' });
            headerSelector.css({
              left: 100 * idx / totalItems + '%',
              width: 100 / totalItems + '%'
            });
          } else {
            listItems.css({ transform: null });
          }
          if (stopFlipping || !active) {
            stopFlipTimer();
          }
        };

        // generate header
        var header = angular.element('<div class="feature-carousel-header">');
        angular.forEach(listItems, function (listItem, idx) {
          var headerItem = angular.element(listItem).querySelector('h3').clone();
          headerItem.on('click', function () {
            return select(idx, true);
          });
          header.append(headerItem);
        });

        header.append(headerSelector);

        headerItems = header.querySelectorAll('h3');
        el.prepend(header);

        // set up selections
        var last = 0;
        select(last);
        var checkCounter = 0;
        autoFlipTimer = timerHelper.runEvery(function () {
          // if we have on-scroll-add-class, then wait until the element is visible before
          // animating, otherwise always animate
          if (attr.onScrollAddClass === undefined || el.hasClass('is-visible')) {
            checkCounter++;
            if (checkCounter === 12) {
              // 12 seconds
              last = (last + 1) % totalItems;
              select(last);
              checkCounter = 0;
            }
          } else {
            checkCounter = 0;
          }
        }, 1000);

        // if you click on an item, stop flipping
        listItems.on('click', stopFlipTimer);

        angular.element($window).on('resize', function () {
          return select(last);
        });
      }
    };
  }]);

  var embeddedQualifiedTestTemplate = "<section class=\"section-basic section-embedded-editor\" ng-repeat=\"embed in $ctrl.embeds track by embed.embedId\"> <div> <h1 class=\"{{embed.icon}}\" ng-bind=\"embed.label || 'Challenge #'+($index+1)\"></h1> <div class=\"embed-description\" ng-if=\"embed.description\" markdown=\"embed.description\"></div> <div class=\"options\"> <div class=\"options-header\"> <a ng-click=\"showOptions = !showOptions\" class=\"options-toggle\" ng-class=\"{expanded:showOptions}\"> {{showOptions?'Hide':'Show'}} Embed Configuration </a> <a ng-if=\"!$ctrl.disableAdd\" ng-click=\"$ctrl.destroy($index)\" class=\"options-remove\"> <span class=\"icon-trashcan\"></span> Remove Editor </a> </div> <embedded-qualified-options embed=\"embed\" manager-options=\"$ctrl.manager.options\" ng-if=\"showOptions\" on-submit=\"update()\"></embedded-qualified-options> </div> <iframe qualified-embed></iframe> <div class=\"embedded-qualified-controls\"> <div class=\"buttons btn-group\"> <button class=\"btn-default btn-sm embed-start\" ng-click=\"embed.editor.start()\" ng-disabled=\"!embed.loadData || embed.started || embed.error || embed.restricted\" tooltip=\"Starts the challenge if not already started.\" tooltip-shortcut-hint=\"editor.start()\"> Start </button> <button class=\"btn-default btn-sm embed-runTests\" ng-click=\"embed.editor.runTests()\" ng-disabled=\"!embed.started || embed.readOnly\" tooltip=\"Triggers running the tests in the editor, if enabled.\" tooltip-shortcut-hint=\"editor.runTests()\"> Run Tests </button> <button class=\"btn-default btn-sm embed-attempt\" ng-click=\"embed.editor.attempt()\" ng-disabled=\"!embed.started || embed.readOnly\" tooltip=\"Triggers running the submission tests in the editor, if enabled.\" tooltip-shortcut-hint=\"editor.attempt()\"> Submit Solution </button> <button class=\"btn-default btn-sm embed-reset\" ng-click=\"embed.editor.reset()\" ng-disabled=\"!embed.started || embed.readOnly\" tooltip=\"Resets the solution code to the original setup.\" tooltip-shortcut-hint=\"editor.reset()\"> Reset </button> <button class=\"btn-default btn-sm embed-reload\" ng-click=\"embed.editor.reload()\" tooltip=\"Reloads the iframe. If localStorageId is set, the solution will be retained.\" tooltip-shortcut-hint=\"editor.reload()\"> Reload </button> </div> <div class=\"embed-contents\"> <div class=\"challenge-details\"> <h5><span>Challenge Details</span> <code>onLoaded</code></h5> <pre class=\"hljs\"><code ng-bind-html=\"embed.loadData\"></code></pre> </div> <div class=\"files\"> <h5><span>Files</span> <code>onChange</code></h5> <pre class=\"hljs\"><code ng-bind-html=\"embed.files\"></code></pre> </div> <div class=\"results\"> <h5><span>Run Results</span> <code>onRun</code></h5> <pre class=\"hljs\"><code ng-bind-html=\"embed.results\"></code></pre> </div> </div> </div> </div> </section> <section class=\"section-basic\" ng-if=\"!$ctrl.disableAdd\"> <div> <div class=\"options\"> <div class=\"add-new-embed\" ng-hide=\"$ctrl.newEmbed\"> <a class=\"btn-primary btn-sm\" ng-click=\"$ctrl.showAdd()\"> <span class=\"icon-plus\"></span> Add a New Editor </a> </div> <embedded-qualified-options ng-if=\"$ctrl.newEmbed\" embed=\"$ctrl.newEmbed\" manager-options=\"$ctrl.manager.options\" on-submit=\"$ctrl.add()\" add-mode=\"true\"></embedded-qualified-options> </div> </div> </section> ";

  var embeddedQualifiedOptionsTemplate = "<div class=\"form-group\"> <label for=\"embed[{{$ctrl.embed.id}}].id\">Challenge ID</label> <div class=\"demo-selector\"> <div class=\"form-control-select btn-default\" ng-if=\"$ctrl.demos.length\"> <select id=\"embed[{{$ctrl.embed.id}}].demoId\" ng-options=\"c as c.title for c in $ctrl.demos\" ng-change=\"$ctrl.updateDemoId()\" ng-model=\"$ctrl.demo\"> <option value=\"\">Custom ID:</option> </select> </div> <input id=\"embed[{{$ctrl.embed.id}}].id\" ng-show=\"!$ctrl.demo\" type=\"text\" ng-model=\"$ctrl.embed.id\" class=\"form-control\"> </div> <p class=\"help-block\" ng-show=\"!$ctrl.demo\"> Note: You can only embed challenges with embed enabled. Embed can be enabled on the challenge from its detail view within the hire application. </p> </div> <div class=\"form-group\" tooltip=\"Set the language used to solve the challenge\"> <label for=\"embed[{{$ctrl.embed.id}}].opts.language\">Language</label> <input id=\"embed[{{$ctrl.embed.id}}].opts.language\" ng-if=\"!$ctrl.embed.languages\" type=\"text\" ng-model=\"$ctrl.embed.opts.language\" class=\"form-control\"> <div class=\"form-control-select btn-default\" ng-if=\"$ctrl.embed.languages\"> <select id=\"embed[{{$ctrl.embed.id}}].opts.language\" ng-options=\"lang for lang in $ctrl.embed.languages\" ng-model=\"$ctrl.embed.opts.language\"></select> </div> </div> <div class=\"form-group\" tooltip=\"Use the edit mode to prevent saving or modifying the solution\"> <label for=\"embed[{{$ctrl.embed.id}}].opts.mode\"> <span ng-show=\"$ctrl.managerOptions.mode\">Override</span> Edit Mode </label> <div class=\"form-control-select btn-default\"> <select id=\"embed[{{$ctrl.embed.id}}].opts.mode\" ng-options=\"type.v as type.l for type in $ctrl.modes\" ng-model=\"$ctrl.embed.opts.mode\"> <option value=\"\">Normal full-editing</option> </select> </div> </div> <div class=\"form-group\" tooltip=\"Set the theme for the embedded editor\"> <label for=\"embed[{{$ctrl.embed.id}}].opts.theme\"> <span ng-show=\"$ctrl.managerOptions.mode\">Override</span> Theme </label> <div class=\"form-control-select btn-default\"> <select id=\"embed[{{$ctrl.embed.id}}].opts.theme\" ng-options=\"type.v as type.l for type in $ctrl.themes\" ng-model=\"$ctrl.embed.opts.theme\"> <option value=\"\"> Use the light theme, but let the candidate override </option> </select> </div> </div> <div class=\"form-group\" tooltip=\"Use this option to remove tabs from the embedded editor\"> <label for=\"embed[{{$ctrl.embed.id}}].opts.hideTabs\">Hide Tabs</label> <input id=\"embed[{{$ctrl.embed.id}}].opts.hideTabs\" ng-readonly=\"$ctrl.embed.tabs.length\" type=\"text\" ng-model=\"$ctrl.embed.opts.hideTabs\" class=\"form-control\"> <p class=\"help-block\" ng-show=\"$ctrl.embed.tabs.length\"> Click to hide or show tabs: <span ng-repeat=\"tab in $ctrl.embed.tabs\"> <code ng-bind=\"tab\" ng-click=\"$ctrl.embed.toggleTab(tab)\"></code>{{$last?'':','}} </span> </p> </div> <div class=\"form-group\" tooltip=\"Use this option to change the internal actions on the editor\"> <label for=\"embed[{{$ctrl.embed.id}}].opts.hideActions\">Hide Actions</label> <div class=\"form-control-select btn-default\"> <select id=\"embed[{{$ctrl.embed.id}}].opts.hideActions\" ng-options=\"type.v as type.l for type in $ctrl.actions\" ng-model=\"$ctrl.embed.opts.hideActions\"> <option value=\"\">Show all enabled action buttons in the editor</option> </select> </div> </div> <div class=\"form-group\"> <label for=\"embed[{{$ctrl.embed.id}}].opts.localStorageId\">LocalStorage ID</label> <input id=\"embed[{{$ctrl.embed.id}}].opts.localStorageId\" type=\"text\" ng-model=\"$ctrl.embed.opts.localStorageId\" class=\"form-control\"> </div> <div class=\"form-group options-initial-layout\" tooltip=\"This options lets you customize the layout of the visible tabs\"> <label>Initial Layout</label> <div> <div ng-repeat=\"ts in $ctrl.tabsets\"> <label for=\"embed[{{$ctrl.embed.id}}].opts.initialLayout.{{ts}}\">{{ts}}</label> <input id=\"embed[{{$ctrl.embed.id}}].opts.initialLayout.{{ts}}\" class=\"form-control\" ng-model=\"$ctrl.initialLayout[ts]\" ng-change=\"$ctrl.updateLayout(ts)\"> </div> </div> </div> <div class=\"options-submit-button\"> <button class=\"btn-primary btn-sm\" ng-click=\"$ctrl.onSubmit()\"> <span class=\"icon-{{$ctrl.addMode?'plus':'reload'}}\"></span> {{$ctrl.addMode ? 'Add Editor' : 'Update Editor'}} </button> </div> ";

  /**
   * Adds an item to an array if it doesn't already exist.
   * @param {Array} array
   * @param {*} item
   */
  function addUnique(array, item) {
    if (!array.includes(item)) {
      array.push(item);
    }
  }

  /**
   * Removes an item from an array if that item is found.
   * @param {Array} array
   * @param {*} item
   * @returns {boolean} True if the item is found.
   */
  function remove(array, item) {
    var i = array.indexOf(item);
    var found = i >= 0;
    if (found) array.splice(i, 1);
    return found;
  }

  /**
   * Removes any items in an array based on a matcher function. If the matcher function returns true, the item is
   * removed from the array.
   * @param {Array} array
   * @param {Function} matcher - Receives the item, index, and original array. If it returns `true`, the
   *   item is removed from the array.
   */
  function removeMatching(array, matcher) {
    for (var i = array.length - 1; i >= 0; i--) {
      if (matcher(array[i], i, array)) {
        array.splice(i, 1);
      }
    }
  }

  /**
   * Safely returns a new array without any falsy items in it.
   * @param {*} array
   * @returns {Array} New array without any falsy items in it.
   */
  function compactFalsy(array) {
    return empty$1(array) ? [] : array.filter(identity);
  }

  /**
   * Removes any duplicates from an array, returning a new array.
   * @param {Array} array
   * @param {Function?} finder - Optional function for identifier
   * @returns {Array} New array without duplicates
   */
  function unique(array) {
    var finder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity;

    var found = {};
    array.forEach(function (v) {
      var k = finder(v);
      if (!(k in found)) {
        found[k] = v;
      }
    });

    return Object.values(found);
  }

  /**
   * Returns true if the provided object is not array-like or has a length of 0
   * @param {*} array
   * @returns {boolean}
   */
  function empty$1(array) {
    return !array || array.length === 0;
  }

  // highlight

  /* eslint-disable camelcase */
  /* globals hljs:true */

  /**
   * highlight.js Solidity syntax highlighting definition
   *
   * @see https://github.com/pospi/highlightjs-solidity
   *
   * @package: highlightjs-solidity
   * @author:  Sam Pospischil <sam@changegiving.com>
   * @since:   2016-07-01
   */

  hljs.registerLanguage('solidity', function hljsDefineSolidity(hljs) {
    var SOL_KEYWORDS = {
      keyword: 'var bool string ' + 'int uint int8 uint8 int16 uint16 int24 uint24 int32 uint32 ' + 'int40 uint40 int48 uint48 int56 uint56 int64 uint64 ' + 'int72 uint72 int80 uint80 int88 uint88 int96 uint96 ' + 'int104 uint104 int112 uint112 int120 uint120 int128 uint128 ' + 'int104 uint104 int112 uint112 int120 uint120 int128 uint128 ' + 'int136 uint136 int144 uint144 int152 uint152 int160 uint160 ' + 'int168 uint168 int176 uint176 int184 uint184 int192 uint192 ' + 'int200 uint200 int208 uint208 int216 uint216 int224 uint224 ' + 'int232 uint232 int240 uint240 int248 uint248 int256 uint256 ' + 'byte bytes bytes1 bytes2 bytes3 bytes4 bytes5 bytes6 bytes7 bytes8 ' + 'bytes9 bytes10 bytes11 bytes12 bytes13 bytes14 bytes15 bytes16 ' + 'bytes17 bytes18 bytes19 bytes20 bytes21 bytes22 bytes23 bytes24 ' + 'bytes25 bytes26 bytes27 bytes28 bytes29 bytes30 bytes31 bytes32 ' + 'enum struct mapping address ' + 'new delete ' + 'if else for while continue break return throw ' + 'function modifier event ' + 'constant anonymous indexed ' + 'storage memory ' + 'external public internal private returns ' + 'import using ' + 'contract library ' + 'assembly',
      literal: 'true false ' + 'wei szabo finney ether ' + 'second seconds minute minutes hour hours day days week weeks year years',
      built_in: 'self ' + // :NOTE: not a real keyword, but a convention used in storage manipulation libraries
      'this super selfdestruct ' + 'now ' + 'msg ' + 'block ' + 'tx ' + 'sha3 sha256 ripemd160 erecover addmod mulmod ' +
      // :NOTE: not really toplevel, but advantageous to have highlighted as if reserved to
      //        avoid newcomers making mistakes due to accidental name collisions.
      'send call callcode delegatecall'
    };

    var SOL_NUMBER = {
      cN: 'number',
      v: [{ b: '\\b(0[bB][01]+)' }, { b: '\\b(0[oO][0-7]+)' }, { b: hljs.CNR }],
      r: 0
    };

    var SOL_FUNC_PARAMS = {
      cN: 'params',
      b: /\(/,
      e: /\)/,
      eB: true,
      eE: true,
      k: SOL_KEYWORDS,
      c: [hljs.CLCM, hljs.CBCM, hljs.ASM, hljs.QSM, SOL_NUMBER]
    };

    var SOL_RESERVED_MEMBERS = {
      b: /\.\s*/, // match any property access up to start of prop
      e: /[^A-Za-z0-9$_.]/,
      eB: true,
      eE: true,
      k: {
        built_in: 'gas value send call callcode delegatecall balance length push'
      },
      r: 2
    };

    function makeBuiltinProps(obj, props) {
      return {
        b: obj + '\\.\\s*',
        e: /[^A-Za-z0-9$_.]/,
        eB: false,
        eE: true,
        k: {
          built_in: obj + ' ' + props
        },
        c: [SOL_RESERVED_MEMBERS],
        r: 10
      };
    }

    return {
      aliases: ['sol'],
      l: SOL_KEYWORDS,
      c: [
      // basic literal definitions
      hljs.ASM, hljs.QSM, hljs.CLCM, hljs.CBCM, SOL_NUMBER, {
        // functions
        cN: 'function',
        bK: 'function modifier event',
        e: /[{;]/,
        eE: true,
        c: [hljs.inherit(hljs.TM, {
          b: /[A-Za-z$_][0-9A-Za-z$_]*/,
          k: SOL_KEYWORDS
        }), SOL_FUNC_PARAMS],
        i: /[\[%]/
      },
      // built-in members
      makeBuiltinProps('msg', 'data sender sig'), makeBuiltinProps('block', 'blockhash coinbase difficulty gaslimit number timestamp '), makeBuiltinProps('tx', 'gasprice origin'), SOL_RESERVED_MEMBERS, {
        // contracts & libraries
        cN: 'class',
        bK: 'contract library',
        e: /[{]/,
        eE: true,
        i: /[:"\[\]]/,
        c: [{ bK: 'is' }, hljs.UTM, SOL_FUNC_PARAMS]
      }, {
        // imports
        bK: 'import',
        e: '[;$]',
        k: 'import * from as',
        c: [hljs.ASM, hljs.QSM]
      }],
      i: /#/
    };
  });

  // highlight

  /* eslint-disable camelcase */

  // the extension stuff lives here otherwise we cause circular dependencies :-\
  var EXT_MATCHER = /\.(\w+)$/;

  function getExtension(filename) {
    return EXT_MATCHER.test(filename) ? filename.match(EXT_MATCHER)[1].toLowerCase() : '';
  }

  var frameworks = {
    'clojure.test': 'Clojure clojure.test',
    'cw-2': 'Qualified Testing Framework',
    busted: 'Busted',
    criterion: 'Criterion',
    cw: 'Qualified Testing Framework',
    eunit: 'eunit',
    ex_unit: 'ExUnit',
    fuchu: 'Fuchu',
    ginkgo: 'Ginkgo',
    gtest: 'Google Test',
    hspec: 'hspec Testing Framework',
    igloo: 'Igloo BDD',
    jest: 'Jest',
    junit5: 'JUnit 5',
    junit: 'JUnit',
    karma_bdd: 'Karma + Mocha BDD',
    karma_tdd: 'Karma + Mocha TDD',
    kotlintest: 'KotlinTest',
    mocha_bdd: 'Mocha BDD',
    mocha_tdd: 'Mocha TDD',
    mocha: 'Mocha',
    nunit: 'NUnit',
    ounit: 'OUnit',
    pester: 'Pester',
    phpunit: 'PHPUnit',
    rspec: 'RSpec',
    rust: 'Rust',
    scalatest: 'ScalaTest',
    spek: 'Spek',
    spock: 'Spock',
    test: 'Dart Test',
    testthat: 'testthat',
    truffle_with_mocha: 'Truffle + Mocha BDD',
    unitkit: 'UnitKit',
    unittest: 'Python unittest',
    xctest: 'XCTest'
  };

  var COMMENT_C_LIKE = ['//', '/*', '*/'];
  var COMMENT_SHELL_LIKE = ['#'];
  var COMMENT_RUBY_LIKE = ['#', '\n=begin', '\n=end'];
  var COMMENT_HTML = ['', '<!--', '-->'];

  /**
   * List of languages, with the name or id as the key for each language.
   *
   * Languages can have the following properties:
   *
   * - n: Name (if the name does not make for a good key [C#, F#])
   * - x: extension or list of extensions, defaults to lowercase id if not provided
   * - m: codemirror type or mimetype, defaults to lowercase id if not provided, set to false to exclude
   * - c: set to false if not a Challenge language,
   * - f: framework or frameworks
   * - p: true if a primary language
   * - h: highlight language, if not the id
   * - cm: comments mode (see constants above)
   * - ac: enable autocomplete
   * - filenames: Special filenames that map back onto this mode (e.x., files without extensions)
   * - l: Language Id override for Language Server if necessary.
   * - ls: Language Servers.
   *
   * Note: this is all compacted like this to make it take up less space in the final form
   *
   * Given the most basic form, such as Java:{}, The resulting object will look like:
   *
   * {
   *   id: 'java',
   *   name: 'Java',
   *   ext: ['java'],
   *   codemirror: 'java'
   *   challenge: true,
   *   highlight: 'java',
   *   primary: false,
   *   cm: ['//', '/*', '*\/'],
   * }
   *
   * The language will be reinserted into the hash based on it's lowercase name, id, and all extensions,
   * on a first-come, first-serve basis.
   *
   * @type {{[NameOrId]: {n: string, x: string[], m:string}}}
   */
  var languages = {
    C: {
      x: ['c', 'h'],
      m: 'text/x-csrc',
      f: ['criterion']
    },
    Clojure: {
      x: ['clj', 'cljs'],
      f: ['clojure.test'],
      C: [';']
    },
    CoffeeScript: {
      x: 'coffee',
      f: ['cw-2'],
      cm: ['#', '###', '###']
    },
    cpp: {
      n: 'C++',
      x: ['cc', 'cpp', 'hpp'],
      m: 'text/x-c++src',
      f: ['gtest', 'igloo'],
      p: true
    },
    CSharp: {
      n: 'C#',
      x: 'cs',
      m: 'text/x-csharp',
      f: ['nunit'],
      p: true,
      ls: ['omnisharp-roslyn']
    },
    css: {
      n: 'CSS3',
      m: 'text/css',
      c: false,
      ac: true,
      ls: ['css-language-server']
    },
    Dart: {
      x: 'dart',
      f: ['test']
    },
    Elixir: {
      x: ['ex', 'exs'],
      f: ['ex_unit'],
      m: 'ruby',
      cm: COMMENT_RUBY_LIKE
    },
    Erb: {
      x: 'erb',
      m: 'application/x-erb',
      c: false
    },
    Erlang: {
      x: 'erl',
      f: ['eunit'],
      m: 'text/x-erlang',
      cm: ['%']
    },
    FSharp: {
      n: 'F#',
      x: 'fs',
      m: 'text/x-fsharp',
      f: ['nunit', 'fuchu'],
      cm: ['//', '(*', '*)']
    },
    Go: {
      m: 'text/x-go',
      f: ['ginkgo']
    },
    Groovy: {
      x: ['groovy'],
      f: ['junit5', 'junit', 'spock'],
      m: 'text/x-groovy'
    },
    Haskell: {
      x: ['hs', 'lhs'],
      f: ['hspec'],
      cm: ['--']
    },
    HTML: {
      x: ['htm', 'html'],
      m: 'text/html',
      c: false,
      cm: COMMENT_HTML,
      ac: true,
      ls: ['html-language-server']
    },
    Java: {
      m: 'text/x-java',
      f: ['junit5', 'junit'],
      p: true,
      ls: ['jdt-language-server']
    },
    JavaScript: {
      x: ['js', 'json'],
      f: ['jest', 'mocha_bdd', 'mocha_tdd', 'karma_bdd', 'karma_tdd', 'cw-2'],
      m: 'text/jsx',
      p: true,
      ls: ['typescript-language-server', 'vue-language-server']
    },
    JSP: {
      x: 'jsp',
      m: 'application/x-jsp',
      ac: true,
      c: false
    },
    JSX: {
      m: 'text/jsx',
      c: false,
      ac: true,
      h: 'javascript',
      l: 'javascriptreact',
      ls: ['typescript-language-server']
    },
    Kotlin: {
      x: ['kt', 'kts'],
      f: ['junit5', 'junit', 'spek', 'kotlintest'],
      m: 'text/x-kotlin'
    },
    Less: {
      m: 'text/x-less',
      n: 'LessCSS',
      ac: true,
      c: false,
      ls: ['css-language-server']
    },
    Lua: {
      x: ['lua'],
      f: ['busted'],
      m: 'text/x-lua'
    },
    Markdown: {
      x: ['md', 'mark', 'markdown'],
      m: 'better-markdown',
      c: false,
      cm: COMMENT_HTML
    },
    ObjC: {
      n: 'Objective-C',
      x: ['m', 'mm'],
      m: 'text/x-objectivec',
      f: ['unitkit', 'cw']
    },
    OCaml: {
      m: 'text/x-ocaml',
      x: 'ml',
      f: ['ounit'],
      cm: ['', '(*', '*)']
    },
    PHP: {
      x: ['php', 'php3'],
      f: ['phpunit'],
      m: 'text/x-php',
      p: true
    },
    PowerShell: {
      x: ['ps1', 'psm1'],
      f: ['pester'],
      m: 'application/x-powershell',
      cm: COMMENT_SHELL_LIKE
    },
    Python: {
      x: 'py',
      f: ['unittest', 'cw-2'],
      p: true,
      cm: COMMENT_SHELL_LIKE,
      ls: ['pyright-langserver']
    },
    R: {
      x: 'r',
      f: ['testthat'],
      m: 'text/x-rsrc',
      cm: COMMENT_SHELL_LIKE
    },
    Ruby: {
      x: 'rb',
      f: ['rspec', 'cw-2'],
      p: true,
      cm: COMMENT_RUBY_LIKE,
      filenames: ['Gemfile'],
      ls: ['solargraph']
    },
    Rust: {
      x: 'rs',
      f: ['rust'],
      m: 'text/x-rustsrc'
    },
    Sass: {
      m: 'text/x-sass',
      n: 'Sass (SASS flavor)',
      ac: true,
      c: false,
      ls: ['css-language-server']
    },
    Scss: {
      m: 'text/x-scss',
      n: 'Sass (SCSS Flavor)',
      ac: true,
      c: false,
      ls: ['css-language-server']
    },
    Scala: {
      x: 'scala',
      f: ['junit', 'scalatest'],
      m: 'text/x-scala'
    },
    Shell: {
      m: 'text/x-sh',
      f: ['rspec'],
      fl: ['ruby'],
      x: 'sh',
      h: 'bash',
      cm: COMMENT_SHELL_LIKE
    },
    SQL: {
      f: ['rspec'],
      fl: ['ruby'],
      // had to pick one, chose x-pgsql for now
      m: 'text/x-pgsql',
      cm: ['--', '/*', '*/'],
      ac: true,
      p: true
    },
    Solidity: {
      x: 'sol',
      // Need to duplicate because `language.frameworkLanguage` uses the framework's index.
      fl: ['javascript', 'javascript'],
      f: ['mocha', 'truffle_with_mocha']
    },
    SVG: {
      m: 'text/xml',
      c: false,
      cm: COMMENT_HTML
    },
    Swift: {
      f: ['xctest']
    },
    Text: {
      x: ['txt'],
      m: 'text/plain',
      c: false,
      filenames: ['Dockerfile']
    },
    TSX: {
      m: 'text/typescript-jsx',
      c: false,
      h: 'typescript',
      l: 'typscriptreact',
      ls: ['typescript-language-server']
    },
    TypeScript: {
      x: 'ts',
      f: ['jest', 'mocha_bdd', 'mocha_tdd', 'karma_bdd', 'karma_tdd'],
      m: 'text/typescript',
      p: true,
      ls: ['typescript-language-server']
    },
    Vue: {
      x: 'vue',
      c: false,
      ac: true,
      m: 'text/x-vue',
      ls: ['vue-language-server']
    },
    XML: {
      x: ['xslt'],
      m: 'text/xml',
      c: false,
      cm: COMMENT_HTML
    },
    Yaml: {
      x: ['yml', 'yaml'],
      m: 'text/x-yaml',
      c: false,
      cm: COMMENT_SHELL_LIKE
    }
  };
  var fileMap = {};

  var all = [];
  var known = [];
  var allExt = [];
  var allNames = [];

  angular.forEach(languages, function (lang, id) {
    function add(key) {
      if (!languages[key]) languages[key] = lang;
    }

    var idlc = id.toLowerCase();
    lang.id = idlc;
    lang.name = lang.namePlain = lang.n || id;
    lang.ext = lang.x || idlc;
    lang.codemirror = lang.mime = lang.m === undefined ? idlc : lang.m;
    lang.challenge = lang.c !== false;
    lang.highlight = lang.h || idlc;
    if (lang.f) {
      lang.frameworks = lang.f;
      // enables frameworks to use a different language
      lang.frameworkLanguages = lang.fl || lang.f.map(function () {
        return idlc;
      });
    }
    lang.primary = !!lang.p;
    lang.cm = lang.cm || COMMENT_C_LIKE;
    lang.languageId = lang.l || lang.id;
    lang.languageServerIds = lang.ls || [];

    add(idlc);
    add(lang.name);
    add(lang.name.toLowerCase());

    if (!angular.isArray(lang.ext)) lang.ext = [lang.ext];
    allExt.push.apply(allExt, toConsumableArray(lang.ext));
    if (lang.filenames) {
      lang.filenames.forEach(add);
      allNames.push.apply(allNames, toConsumableArray(lang.filenames));
    }
    angular.forEach(lang.ext, add);

    known.push(lang);
    if (lang.challenge) {
      all.push(lang);
    }
  });

  // Potential sorting by primary / secondary, but then we need to deal with
  // visually separating the results
  function langCompare(a, b) {
    if (a === b) return 0;
    if (!a) return 1;
    if (!b) return -1;
    if (a.primary && !b.primary) return -1;
    if (b.primary && !a.primary) return 1;
    return compareIgnoreCase(a.name || a, b.name || b);
  }

  // attempts to find a valid language based on several variations of the input
  function getLang(l) {
    return l && (languages[l] || // exact string match (l = 'js')
    languages[l.id] || // id match (l = {id:'js'})
    languages[l.name] || // name match (l = {name:'js'})
    languages[fileMap[l]] || // fileMapped by user
    languages[fileMap['*.' + getExtension(l)]]) // file extension mapped by user
    ;
  }

  languages.primaryCompare = function (a, b) {
    return langCompare(getLang(a), getLang(b));
  };

  languages.compare = function (a, b) {
    if (a.id) {
      return compareIgnoreCase(a.name, b.name);
    } else if (a.name) {
      return compareIgnoreCase(languages[a.name].name, languages[b.name].name);
    } else {
      return compareIgnoreCase(a, b);
    }
  };

  languages.frameworkLanguage = function (lang, framework) {
    var l = getLang(lang);
    if (!l) {
      return lang && lang.id || lang;
    }
    var fwidx = l.frameworks.indexOf(framework);
    if (fwidx < 0) fwidx = 0;
    return l.frameworkLanguages[fwidx] || l.id;
  };

  languages.stripComments = function (l, code) {
    code = code || '';
    var lang = getLang(l);
    var cm = lang && lang.cm || [];
    if (cm[0]) {
      // single line comments
      code = code.replace(new RegExp(escapeRegex(cm[0]) + '.*$', 'gm'), '');
    }
    if (cm[1]) {
      // multi line comments
      code = code.replace(new RegExp(escapeRegex(cm[1]) + '[\\s\\S]+?' + escapeRegex(cm[2]), 'g'), '');
    }
    // remove whitespace
    return code.trim();
  };

  languages.getLang = getLang;
  languages.toName = function (l) {
    return languages[l] ? languages[l].name : l;
  };

  all.sort(languages.compare);
  languages.all = all;
  known.sort(languages.compare);
  languages.known = known;
  languages.primary = all.slice().sort(languages.primaryCompare);
  languages.frameworks = frameworks;
  var VALID_EXT_REGEX = void 0;
  languages.validExt = function (name) {
    if (!VALID_EXT_REGEX) {
      VALID_EXT_REGEX = new RegExp('(^' + allNames.join('|') + ')|(.(' + allExt.join('|') + '))$');
    }
    return VALID_EXT_REGEX.test(name);
  };
  languages.langFromFilename = function (filename) {
    var ext = getExtension(filename);
    var lang = ext && getLang(ext);
    if (!lang && filename) {
      // check to match full-name files
      filename = filename.replace(/^(.*\/)/g, '');
      lang = allNames.includes(filename) && getLang(filename);
    }
    return lang;
  };

  window.$languages = languages;

  var PLAIN_TEXT = ['text', 'plain', 'plaintext', 'none', 'null'];

  var codeHighlightComponentModule = angular.module('Q.components.code-highlight', []).directive('codeHighlight', ['$window', '$sanitize', 'highlightCode', '$injector', function ($window, $sanitize, highlightCode, $injector) {
    // no hard dependencies
    var Challenge = null;
    if ($injector.has('Challenge')) {
      Challenge = $injector.get('Challenge');
    }

    return {
      restrict: 'A',
      replace: true,
      scope: {
        language: '=',
        framework: '=',
        codeHighlight: '=',
        lineNumberStart: '=?'
      },
      link: function link(scope, element, attrs) {
        element.addClass('markdown');

        var shouldWrap = element[0].nodeName !== 'CODE';

        render(scope.codeHighlight || element.text() || '');
        if (attrs.codeHighlight) {
          scope.$watch('codeHighlight', render);
        }

        function render(code) {
          var lang = scope.language;
          if (scope.framework) {
            lang = languages.frameworkLanguage(lang, scope.framework);
          }
          var highlightedCode = $sanitize(highlightCode(code, lang, scope.lineNumberStart));
          highlightedCode = replaceIncludeSolution(highlightedCode);
          if (shouldWrap) {
            highlightedCode = '<pre><code>' + highlightedCode + '</code></pre>';
          }
          element.html(highlightedCode);
        }

        var loaded = false;

        function replaceIncludeSolution(highlightedCode) {
          if (Challenge) {
            var needsReload = false;
            highlightedCode = highlightedCode.replace(Challenge.INCLUDE_SOLUTIONS_REGEX_GLOBAL, function (match, leading, id) {
              var c = Challenge.get(id);
              if (c) {
                return leading + '<span class="carry-forward-notification">Dynamically pulls previous solution from <a href="challenges/' + id + '" target="_blank">' + c.title + '</a></span>';
              } else {
                needsReload = true;
                return match;
              }
            });

            if (needsReload && !loaded) {
              Challenge.findAll().then(function () {
                loaded = true;
                render(scope.codeHighlight || element.text() || '');
              });
            }
          }
          return highlightedCode;
        }
      }
    };
  }]).factory('highlightCode', ['$window', '$log', function ($window, $log) {
    var reported = {};
    var fn = function highlightCode(code, lang) {
      var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      if ($window.codeHighlightLinenums) {
        if (lang) {
          if (PLAIN_TEXT.includes(lang.toLowerCase())) {
            lang = '';
          } else {
            lang = lang.replace(/^[^:]+/, function (l) {
              return languages[l] && languages[l].highlight || '';
            });
          }
        }
        try {
          code = $window.codeHighlightLinenums(code, {
            lang: lang,
            hljs: $window.hljs,
            start: start
          });
        } catch (err) {
          // make sure we don't render HTML if the language didn't load
          code = escapeHTML(code);
          if (!reported[lang]) {
            reported[lang] = true;
            $log.warn(err);
          }
        }
      }

      return code;
    };
    fn.withCircular = function (code, lang, start) {
      return fn(code, lang, start).replace(/\[Circular\]/g, '<span class="hljs-circular">[Circular]</span>');
    };
    return fn;
  }]);

  var zoomableImageTemplate = "<span class=\"zoomable-image-controls\" ng-if=\"$ctrl.enabled\"> <button class=\"btn-default btn-sm icon-{{ $ctrl.expanded ? 'contract' : 'expand' }}\" ng-click=\"$ctrl.expandOrContract($event)\" tooltip=\"{{ $ctrl.expanded ? 'Scale image back down' : 'Make this image as large as possible'}}\"></button> <button class=\"btn-default btn-sm icon-minus\" ng-click=\"$ctrl.zoomOut($event)\" ng-disabled=\"$ctrl.zoomOutDisabled\" tooltip=\"Zoom Out\"></button> <button class=\"btn-default btn-sm\" ng-class=\"{ active: $ctrl.is100 }\" ng-click=\"$ctrl.zoom100($event)\" tooltip=\"Zoom 1:1 pixels\"> 1:1 </button> <button class=\"btn-default btn-sm icon-plus\" ng-click=\"$ctrl.zoomIn($event)\" ng-disabled=\"$ctrl.zoomInDisabled\" tooltip=\"Zoom In\"></button> </span> <div class=\"zoomable-image-scrollbox\" ng-transclude ng-dblclick=\"$ctrl.autoZoom($event)\" tooltip=\"{{ $ctrl.enabled ? 'You can zoom into this image using the controls, or double-clicking on it' : '' }}\" tooltip-position=\"top\" scroll-on-drag=\"$ctrl.enabled && $ctrl.zoomed\"></div> ";

  var domHelperModule = angular.module('Q.helpers.dom-helper', []).factory('domHelper', ['$q', function ($q) {
    function whenImageLoaded(img) {
      var $img = angular.element(img);
      var _img = $img[0];
      if (_img && (!_img.complete || _img.naturalWidth === 0)) {
        // Image is not complete, set up listeners
        return $q(function (resolve, reject) {
          $img.on('load', function () {
            resolve(img);
          }).on('error', function () {
            reject(img);
          });
        });
      } else {
        return $q.resolve(img);
      }
    }

    return {
      whenImageLoaded: whenImageLoaded
    };
  }]);

  var scrollOnDragDirectiveModule = angular.module('Q.components.scroll-on-drag', [])

  // Note: this directive is not designed to work on window/body, it only works on dom nodes
  .directive('scrollOnDrag', ['$document', function ($document) {
    return {
      restrict: 'A',
      link: function link(scope, el, attr) {
        var startXPos = void 0;
        var startYPos = void 0;
        var scrollXPos = void 0;
        var scrollYPos = void 0;
        var curDown = false;
        var enabled = false;

        function stopDrag() {
          // safe-to-call method to stop dragging whenever we want
          el.removeClass('scroll-on-drag-active');
          curDown = false;
          $document.off('mouseup', stopDrag);
          $document.off('mousemove', mouseMoveListener);
        }

        function mouseDownListener(e) {
          if (enabled) {
            stopEvent(e);
            el.addClass('scroll-on-drag-active');
            curDown = true;
            // store initial values
            startXPos = e.pageX;
            startYPos = e.pageY;
            scrollXPos = el[0].scrollLeft;
            scrollYPos = el[0].scrollTop;

            // start listening to document-level movement, so we can track outside the element
            $document.on('mouseup', stopDrag);
            $document.on('mousemove', mouseMoveListener);
          }
        }

        function mouseMoveListener(e) {
          if (enabled && curDown === true) {
            stopEvent(e);
            el[0].scrollLeft = scrollXPos + startXPos - e.pageX;
            el[0].scrollTop = scrollYPos + startYPos - e.pageY;
          }
        }

        checkEnable();

        // if we only need a link function, use this
        scope.$watch(attr.scrollOnDrag, checkEnable);

        function checkEnable() {
          if (attr.scrollOnDrag && scope.$eval(attr.scrollOnDrag) === false) {
            disable();
          } else {
            enable();
          }
        }

        function enable() {
          if (!enabled) {
            stopDrag();
            el.on('mousedown', mouseDownListener);
            el.addClass('scroll-on-drag-enabled');
            enabled = true;
          }
        }

        function disable() {
          if (enabled) {
            stopDrag();
            el.off('mousedown', mouseDownListener);
            el.removeClass('scroll-on-drag-enabled');
            enabled = false;
          }
        }
      }
    };
  }]);

  var zoomableImageComponentModule = angular.module('Q.components.zoomable-image', [windowEventHelperModule, domHelperModule, scrollOnDragDirectiveModule]).component('zoomableImage', {
    bindings: {
      zoomDisabled: '<'
    },
    controller: 'ZoomableImageCtrl',
    template: zoomableImageTemplate,
    transclude: true
  }).controller('ZoomableImageCtrl', ['$scope', '$element', '$window', '$document', '$timeout', 'domHelper', function ZoomableImageCtrl($scope, $element, $window, $document, $timeout, domHelper) {
    var ctrl = this;

    var SCROLLBOX_CLASS = '.zoomable-image-scrollbox';
    var CONTROLS_CLASS = '.zoomable-image-controls';

    var zoomLevel = -2;

    ctrl.$onInit = function () {
      _initializeImage();
      $timeout(function () {
        // timeout ensures the DOM has finished rendering
        domHelper.whenImageLoaded($element.find('image')).then(_initializeImage);
      });

      ctrl.$onChanges = function (changes) {
        if (changes.zoomDisabled) {
          _initializeImage();
        }
      };
    };

    ctrl.expandOrContract = stopEvent(function () {
      ctrl.expanded = !ctrl.expanded;
      if (ctrl.expanded) {
        _expand();
      } else {
        _contract();
      }
    });

    ctrl.zoomOut = stopEvent(function () {
      _adjustZoomLevel(-1);
    });

    ctrl.zoom100 = stopEvent(function () {
      _adjustZoomLevel(0);
    });

    ctrl.zoomIn = stopEvent(function () {
      _adjustZoomLevel(1);
    });

    ctrl.autoZoom = stopEvent(function () {
      if (ctrl.enabled) {
        _adjustZoomLevel(zoomLevel > 1 ? -10 : 1);
      }
    });

    var lastImageUrl = void 0;
    var lastWidth = void 0;
    var listeningToEvents = false;

    function _reset() {
      ctrl.expanded = ctrl.enabled = false;
      ctrl.zoomInDisabled = ctrl.zoomOutDisabled = true;
      $element.removeClass('enabled zoomed expanded');
      // revert everything to default CSS
      $element.css('height', null);
      $element.querySelector(SCROLLBOX_CLASS).css({
        left: null,
        right: null
      });
      $element.querySelector(CONTROLS_CLASS).css({
        left: null
      });
      $element.find('img').css({
        width: null,
        height: null,
        'max-width': null
      });
    }

    function _initializeImage() {
      var $img = $element.find('img');
      var img = $img[0];

      if (!img || ctrl.zoomDisabled) {
        lastImageUrl = null;
        _reset();
        return;
      }
      if (ctrl.enabled && img.src === lastImageUrl && $element.offsetWidth() === lastWidth) {
        if (ctrl.expanded) {
          _expand();
        } else {
          _contract();
        }
        return;
      }

      _reset();

      lastWidth = $element.offsetWidth();
      lastImageUrl = img.src;

      if (!listeningToEvents) {
        listeningToEvents = true;
        $scope.$on(WINDOW_EVT_RESIZE, _initializeImage);
        $scope.$on(UI_LAYOUT_EVT_RESIZE, _initializeImage);
        $scope.$watch(function () {
          return $element[0].offsetWidth + img.src;
        }, _initializeImage);
      }

      if (img.naturalWidth > $element.offsetWidth() * 0.9) {
        // if the image is greater than 90% of the available width, enable the tool
        ctrl.enabled = true;
        $element.addClass('enabled');
        _contract();
      }
    }

    function _expand() {
      var elOffset = $element.offset();
      var maxBoundary = _maxBoundary();
      var $img = $element.find('img');
      var img = $img[0];
      if (img && img.naturalHeight < maxBoundary.height) {
        // don't bother expanding above the image's natural height
        maxBoundary.height = img.naturalHeight + 2;
      }

      // now allow the scrollbox to expand up to our max boundary
      $element.addClass('expanded');
      $element.css('height', maxBoundary.height + 'px');
      var left = maxBoundary.left - elOffset.left;
      $element.querySelector(SCROLLBOX_CLASS).css({
        left: left + 'px',
        right: elOffset.right - maxBoundary.right + 'px'
      });
      $element.querySelector(CONTROLS_CLASS).css({
        left: left + 'px'
      });

      // enable the zoom buttons by using _setZoomLevel, zoom to 1:1 by default
      _adjustZoomLevel(0, maxBoundary.width, maxBoundary.height);
      var scrollbox = $element.querySelector(SCROLLBOX_CLASS)[0];
      if (scrollbox && img) {
        $timeout(function () {
          // scroll to center
          scrollbox.scrollLeft = (img.naturalWidth - maxBoundary.width) / 2;
          scrollbox.scrollTop = (img.naturalHeight - maxBoundary.height) / 2;
        }, 200);
      }
    }

    function _contract() {
      $element.removeClass('expanded');
      var $img = $element.find('img');
      var img = $img[0];
      $element.css('height', null);
      var width = $element.offsetWidth();
      var height = $element.offsetHeight();
      if (img) {
        var ratio = img.naturalHeight / img.naturalWidth;
        height = Math.min(img.naturalHeight, width * ratio);
        // default to height of the image
        $element.css('height', height + 'px');
      }
      // revert sizing mostly to CSS
      $element.querySelector(SCROLLBOX_CLASS).css({
        left: null,
        right: null
      });
      $element.querySelector(CONTROLS_CLASS).css({
        left: null
      });
      // enable the zoom buttons by using _setZoomLevel
      _adjustZoomLevel(null, width, height);
    }

    // currently, zoom levels are defined as follows:
    // -2: fits container
    // -1: 50% between container and 1:1
    // 0: 1x
    // 1: 1.5x
    // 2: 2x
    function _adjustZoomLevel(zlAdjustment, scrollboxWidth, scrollboxHeight) {
      if (zlAdjustment === null) {
        zoomLevel = -2;
      } else if (zlAdjustment === 0) {
        zoomLevel = 0;
      } else {
        zoomLevel = Math.min(2, Math.max(-2, zoomLevel + zlAdjustment));
      }

      var $img = $element.find('img');
      var img = $img[0];
      if (!img) return;
      var scrollbox = $element.querySelector(SCROLLBOX_CLASS);
      if (!scrollboxWidth || !scrollboxHeight) {
        scrollboxWidth = scrollbox.offsetWidth();
        scrollboxHeight = scrollbox.offsetHeight();
      }
      var widthRatio = (scrollboxWidth - 2) / img.naturalWidth;
      var heightRatio = (scrollboxHeight - 2) / img.naturalHeight;
      var baseScale = Math.min(widthRatio, heightRatio);

      if (baseScale >= 1 && zoomLevel <= 0) {
        // if we're already 1:1, don't bother shrinking it down
        zoomLevel = 0;
        ctrl.zoomOutDisabled = true;
      } else {
        if (zoomLevel === -1 && baseScale > 0.6) {
          // skip zoomLevel -1 if we're pretty close images
          zoomLevel = zlAdjustment < 0 ? -2 : 0;
        }
        ctrl.zoomOutDisabled = zoomLevel <= -2;
      }
      ctrl.zoomInDisabled = zoomLevel >= 2;
      ctrl.is100 = zoomLevel === 0;
      ctrl.zoomed = !ctrl.zoomOutDisabled;
      $element.toggleClass('zoomed', ctrl.zoomed);

      var scale = baseScale;
      switch (zoomLevel) {
        case -1:
          scale = baseScale / 2 + 0.5; // 50% of fit and 1:1
          break;
        case 0:
          scale = 1;
          break;
        case 1:
          scale = 1.25;
          break;
        case 2:
          scale = 1.5;
          break;
      }
      var height = img.naturalHeight * scale;
      $img.css({
        width: img.naturalWidth * scale + 'px',
        height: height + 'px',
        'max-width': 'none'
      });
    }

    function _maxBoundary() {
      // base boundary
      var scrollParent = $element.scrollableParent();
      var left = scrollParent.offsetLeft();
      var top = scrollParent.offsetTop();
      var width = scrollParent.offsetWidth();
      if (scrollParent[0].clientWidth < width) {
        // accounts for the scrollbar automatically
        width = scrollParent[0].clientWidth;
      }
      var height = scrollParent.offsetHeight();

      var $win = angular.element($window);
      var $sidebar = $document.querySelector('.sidebar');
      var $navbar = $document.querySelector('.navbar-fixed-top');
      var visibleWidth = $win.offsetWidth() - ($sidebar.isVisible() ? $sidebar.offsetWidth() : 0);
      var visibleHeight = $win.offsetHeight() - ($navbar.isVisible() ? $navbar.offsetHeight() : 0);

      // adjust to visible boundary (excluding sidebar and navbar)
      width = Math.min(visibleWidth || width, width);
      height = Math.min(visibleHeight || height, height);

      // reduce maxBoundary size by 10px on all used sides
      left += 10;
      top += 10;
      width -= 20;
      height -= 20;
      return {
        left: left,
        top: top,
        width: width,
        height: height,
        right: left + width,
        bottom: top + height
      };
    }
  }]);

  var KNOWN_HTML_ELEMENTS = new Set('a,abbr,acronym,address,area,article,aside,b,bdi,bdo,big,blockquote,br,caption,center,cite,code,col,colgroup,dd,del,dfn,dir,div,dl,dt,em,figcaption,figure,font,footer,h1,h2,h3,h4,h5,h6,header,hgroup,hr,i,img,ins,kbd,label,li,map,mark,menu,nav,ol,p,pre,q,rp,rt,ruby,s,samp,section,small,span,strike,strong,sub,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,wbr'.split(','));
  var COMMENT_NODE = '!--';

  var HTML_MATCHER = /<\/?([^\s>]+)[^>]*>/gi;

  var markdownComponentModule = angular.module('Q.components.markdown', [codeHighlightComponentModule, zoomableImageComponentModule])

  // The start of this code was copied from angular-marked

  .provider('marked', function () {
    var self = this;

    self.defaults = {
      gfm: true,
      tables: true,
      breaks: true,
      smartLists: true
    };

    self.setOptions = function (opts) {
      angular.extend(self.defaults, opts);
    };

    self.$get = ['$window', 'highlightCode', function ($window, highlightCode) {
      var m = $window.marked;

      if (!self.defaults.highlight) {
        self.defaults.highlight = highlightCode;
      }

      self.setOptions = m.setOptions;
      m.setOptions(self.defaults);

      if ($window.markedExtensions) {
        m.process = $window.markedExtensions.process;
      }

      return m;
    }];
  })

  /**
   * @docType shared
   * @category directive
   * @name markdown
   * @example
   *   <div markdown>#A Sample Header
   *---
   *##Wooohooo a subheader
   *> "Always code as if the guy who ends up maintaining your code will be a violent psychopath who knows where you live."
   *
   ** List Item A
   ** List Item B
   ** List Item C
   *     </div>
   * @description
   * Transcludes some HTML and also re-uses it in a sample code block
   * It will be good to keep all the HTML examples of the components in this directive so they can all be changed from one central location
   * @returns Directive Definition Object {object}
   */
  .directive('markdown', ['marked', '$sanitize', '$timeout', '$compile', function (marked, $sanitize, $timeout, $compile) {
    return {
      restrict: 'A',
      scope: {
        opts: '<',
        markdown: '<',
        language: '<',
        sanitize: '@',
        linkTarget: '@',
        linkRel: '@',
        afterRender: '&',
        expandable: '<',
        expanded: '<?',
        expandableInline: '<',
        maxLines: '<',
        multiLanguage: '<'
      },
      link: function link(scope, el, attrs) {
        var node = el[0];
        var lastVal = void 0;

        el.addClass('markdown');
        if (scope.expandable) {
          scope.expanded = !!scope.expanded;
          el.addClass('expandable ' + (scope.expanded ? 'expanded' : 'collapsed'));
          if (scope.expandableInline) {
            el.addClass('expandable-inline');
          }
        }
        var lastExpandedState = scope.expanded;
        var expandingPromise = void 0;
        var $expandLink = void 0;
        var expandListener = void 0;
        var toggleExpandable = function toggleExpandable(val) {
          var exp = scope.expanded = val === undefined ? !scope.expanded : val;

          if (exp === lastExpandedState) return;
          lastExpandedState = exp;

          if (expandingPromise) $timeout.cancel(expandingPromise);

          el.removeClass('expanding-init collapsing-init expanding collapsed expanded collapsed');
          el.addClass(exp ? 'expanding-init' : 'collapsing-init');
          expandingPromise = $timeout(function () {
            el.removeClass(exp ? 'expanding-init' : 'collapsing-init');
            el.addClass(exp ? 'expanding' : 'collapsing');
            expandingPromise = $timeout(function () {
              el.removeClass(exp ? 'expanding' : 'collapsing');
              el.addClass(exp ? 'expanded' : 'collapsed');

              if ($expandLink) {
                $expandLink.text(scope.expanded ? 'Less' : 'More');
              }
            }, 210);
          });
        };

        if (scope.expandable && attrs.expanded) {
          scope.$watch('expanded', toggleExpandable);
        }

        _render(scope.markdown || el.text() || '');
        if (attrs.markdown !== undefined) {
          scope.$watch('markdown', _render);
        }

        scope.$watch('language', function () {
          return _render();
        });

        function _shouldExpand(val) {
          return scope.expandable && (!scope.maxLines && val.length > 200 || el.children().length > (scope.maxLines || 2) || el[0].querySelector('img,h1,h2,h3,ul,ol,table,pre'));
        }

        function _render(val) {
          if (val || val === '') {
            lastVal = val;
          } else {
            val = lastVal || '';
          }

          var opts = scope.opts || {};
          var result = _process(val, scope.language, opts);
          var html = result.html();
          if (scope.sanitize !== 'false') {
            html = _sanitizeHTML(html);
          }
          el.html(html);

          if (scope.linkTarget !== 'false' || scope.linkRel !== 'false') {
            var anchors = el.find('a');
            if (scope.linkTarget !== 'false') {
              anchors.attr('target', scope.linkTarget || '_blank');
            }
            if (scope.linkRel !== 'false') {
              anchors.attr('rel', scope.linkRel || 'noopener');
            }
          }

          if (scope.multiLanguage) {
            _replaceLanguageBlocks(node, scope.language);
          }

          _compileZoomableImages(node, scope);

          // if we have more than 200 characters, more than two nodes, or images, make it expandable
          if (_shouldExpand(val)) {
            el.addClass('expandable');
            el.toggleClass('has-max-lines', !!scope.maxLines);
            if (scope.maxLines) {
              var children = el.children().removeClass('always-show');
              for (var i = 0; i < scope.maxLines; i++) {
                children.eq(i).addClass('always-show');
              }
            }
            if (!scope.expandableInline) {
              $expandLink = angular.element('<a href class="expand-link">More</a>');
              $expandLink.on('click', function (event) {
                stopEvent(event);
                toggleExpandable();
                scope.$apply();
              });
              var $p = angular.element('<p class="expand-link-wrapper">');
              $p.append($expandLink);
              el.append($p);
              $p.parent().children().eq(-2).addClass('last-markdown-node');
            } else if (!expandListener) {
              expandListener = function expandListener(event) {
                if (event.target && event.target.nodeName === 'A') return;
                stopEvent(event);
                toggleExpandable();
                scope.$apply();
              };
              el.on('click touch', expandListener);
            }
            toggleExpandable(scope.expanded);
          } else {
            $expandLink = null;
            el.removeClass('expandable');
            toggleExpandable(false);
            if (expandListener) {
              el.off('click touch', expandListener);
            }
          }

          scope.afterRender();
        }
      }
    };

    //// private functions

    /**
     * processes the markdown using the marked-extensions library, which will handle a number of details
     * such as handling @@doc tokens, if/if-not blocks, hidden non-relevant language code, and %doc blocks.
     * @param markdown
     * @param defaultLang
     * @param opts
     * @private
     */
    function _process(markdown, defaultLang, opts) {
      markdown = '' + markdown;
      if (marked.process) {
        var options = {
          marked: opts || {},
          lineNumbers: false, // we provide our own implementation instead
          language: defaultLang,
          filterLanguages: false,
          findLanguage: function findLanguage(language) {
            return languages[language] ? languages[language].id : null;
          },
          languageWrapper: function languageWrapper(code, language) {
            return '<div class="language-tabset"><div class="language-tab language-' + language + '">' + code + '</div></div>';
          }
          // NOTE: this isn't really doing anything until we add in support for loading scripts dynamically
          // via the scriptjs package. the extensions library also supports mermaid/CodeMirror.runMode - which also
          // need the scriptjs package loaded and referenced as an option before they can be used.
          // onLoaded: result => $timeout(() => result.afterRender(), 100)
        };
        var result = marked.process(marked, markdown, options);
        // make sure we include some whitespace around brs
        result.renderer.br = function () {
          return '<br>\n';
        };
        return result;
      }

      // if markedExtensions are not loaded on the page, then just render using basic markdown without
      // any additional logic.
      return {
        html: function html() {
          return marked(markdown, opts);
        }
      };
    }

    /**
     * @name ReplaceLanguageBlocks
     * @docType shared
     * @category function
     * @description
     * Replaces sequential code blocks with wrapped blocks for hiding/showing languages
     * @param node {object}
     * @param lang {string}
     * @private
     */
    function _replaceLanguageBlocks(node, lang) {
      if (!lang) return;
      // walk the tree looking for sequential pre/code blocks,
      // then convert them into a set of tabs
      var tabsToGroup = node.querySelectorAll('.language-tabset + .language-tabset');

      angular.forEach(tabsToGroup, function (tab) {
        tab.previousElementSibling.appendChild(tab.firstChild);
        tab.parentNode.removeChild(tab);
      });

      // now, in every group that has multiple tabs, remove the non-current languages
      var tabsets = node.querySelectorAll('.language-tabset');
      angular.forEach(tabsets, function (tabset) {
        if (tabset.children.length > 1) {
          angular.forEach(tabset.querySelectorAll('.language-tab'), function (tab) {
            var $tab = angular.element(tab);
            if (!$tab.hasClass('language-' + lang)) {
              tab.parentNode.removeChild(tab);
            }
          });
        }
      });
    }

    function _compileZoomableImages(node, scope) {
      if (scope.expandableInline) {
        // don't enable zoomable images for inline markdown
        return;
      }
      angular.forEach(node.querySelectorAll('img'), function (img) {
        // wrap standalone images to make them zoomable if necessary
        if (_nonTextSibling(img.previousSibling) && _nonTextSibling(img.nextSibling)) {
          $compile(angular.element(img).wrap('<zoomable-image zoom-disabled="expandable && !expanded">').parent())(scope.$new());
        }
      });
    }

    // Only returns true if the sibling is empty or a hard line break
    function _nonTextSibling(sibling) {
      return !sibling || (sibling.nodeName || '').toUpperCase() === 'BR';
    }

    function _sanitizeHTML(html) {
      // escape unknown HTML
      var escapedHTML = html.replace(HTML_MATCHER, function (match, nodeName) {
        // check for comments or known HTML elements
        if (nodeName.startsWith(COMMENT_NODE) || KNOWN_HTML_ELEMENTS.has(nodeName)) {
          return match;
        } else {
          return escapeHTML(match);
        }
      });
      // sanitize remaining HTML
      return $sanitize(escapedHTML);
    }
  }]);

  var uiRouterStateModule = 'ui.router.state';

  var stateHelperModule = angular.module('Q.helpers.state-helper', [uiRouterStateModule])

  /**
   * Provides some simple helpers for dealing with uiRouter $state issues
   */
  .factory('stateHelper', ['$state', '$q', '$rootScope', '$injector', '$timeout', function ($state, $q, $rootScope, $injector, $timeout) {
    var stateHelper = {
      /**
       * Redirects immediately during a resolve, by rejecting the current resolve.
       * This style redirect only works if you don't care about the current state name or parameters.
       *
       * @example
       *
       * resolve: {
       *     foo(stateHelper) {
       *         if(test) {
       *             return stateHelper.redirectInResolve('someState', { param: true });
       *         } // else like normal
       *     }
       * }
       *
       * @param state State to redirect to (required)
       * @param params {*?} Parameters for the state (optional)
       * @param options {*?} Options for $state.go (optional)
       * @returns {Promise}
       */
      redirectInResolve: function redirectInResolve(state, params, options) {
        return $q.reject({ redirectTo: { state: state, params: params, options: options } });
      },


      /**
       * Redirects after a state change. Only redirects if the state change is successful.
       * This uses scope events to detect a successful state change, and redirects at that time.
       * If there's a state change error, the redirect is canceled.
       *
       * @param state State to redirect to (required)
       * @param params {*?} Parameters for the state (optional)
       * @param options {*?} Options for $state.go (optional)
       */
      redirectAfterResolve: function redirectAfterResolve(state, params, options) {
        $rootScope.stateHelperRedirecting = true;
        var unWatchSuccess = void 0;
        var unWatchError = void 0;
        unWatchSuccess = $rootScope.$on('$stateChangeSuccess', function () {
          unWatchError();
          unWatchSuccess();
          $timeout(function () {
            $rootScope.stateHelperRedirecting = false;
            $state.go(state || '.', params, options);
          });
        });
        unWatchError = $rootScope.$on('$stateChangeError', function () {
          unWatchError();
          unWatchSuccess();
          $rootScope.stateHelperRedirecting = false;
        });
      },


      /**
       * Enables automatic redirecting to the default filter or user's preference if no filter is
       * defined.
       *
       * @param stateName
       * @param stateFilters
       * @returns {*|Promise}
       */
      defaultFilters: function defaultFilters(stateName, stateFilters) {
        var filterId = stateName + 'StateFilter';
        var redirectParams = false;
        if (!$state.activeParams[filterId]) {
          // switch to users or systems default route

          // set to default in case we can't use the user's
          redirectParams = defineProperty({}, filterId, stateFilters.default.id);

          var accountService = getAccountService($injector);
          var defaultViews = {};
          if (accountService) {
            defaultViews = accountService.prefs().defaultviews || {};
          }
          if (defaultViews[stateName]) {
            var params = defaultViews[stateName];
            // only redirect if it's a valid state filter, to prevent immediate 404s
            if (stateFilters.find(function (filter) {
              return filter.id === params[filterId];
            })) {
              // assume we can handle all the other params without completely breaking
              redirectParams = params;
            }
          }
        }

        if (redirectParams) {
          // using active state prevents us from breaking deeper redirects
          var updatedState = $state.activeState || stateName;
          // merge the default params with any active params
          var updatedParams = angular.extend({}, $state.activeParams, redirectParams);
          return stateHelper.redirectInResolve(updatedState, updatedParams);
        }
      }
    };

    return stateHelper;
  }]);

  var paginationHelperModule = angular.module('Q.helpers.pagination-helper', [uiRouterStateModule, stateHelperModule]).factory('paginationHelper', ['$state', 'stateHelper', function ($state, stateHelper) {
    var clamp = function clamp(min, n, max) {
      return Math.max(min, Math.min(max, n));
    };
    var protect = function protect(n) {
      return isNaN(n) ? 0 : n;
    };

    return {
      /**
       * Calculate pagination data for a set of items
       * @param total {number} Total number of items
       * @param perPage {number} Number of items per page
       * @param page {number} Current page, defaults to 1
       * @param currentIndex {number} Current item index, will override opts.page
       * @param minPerPage {number} minimum allowed page size, defaults to 1
       * @param maxPerPage {number} max allowed page size, defaults to Infinity
       * @param buffer {number} Allowed overage to disable pagination (defaults to 1 if perPage is > 2)
       * @returns {*} A collection of properties that can be used to render information about the current page
       */
      calc: function calc() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            total = _ref.total,
            perPage = _ref.perPage,
            page = _ref.page,
            currentIndex = _ref.currentIndex,
            _ref$minPerPage = _ref.minPerPage,
            minPerPage = _ref$minPerPage === undefined ? 1 : _ref$minPerPage,
            _ref$maxPerPage = _ref.maxPerPage,
            maxPerPage = _ref$maxPerPage === undefined ? Infinity : _ref$maxPerPage,
            _ref$buffer = _ref.buffer,
            buffer = _ref$buffer === undefined ? 1 : _ref$buffer;

        perPage = +perPage;
        var currentPerPage = clamp(minPerPage, perPage || minPerPage, maxPerPage);

        if (buffer === 1 && currentPerPage < 3) buffer = 0;

        if (total <= currentPerPage + buffer) {
          // override perPage since we only have «buffer» items on the next page
          currentPerPage = total;
        }

        var pages = Math.ceil(protect(total / currentPerPage));

        currentIndex = Math.floor(currentIndex);

        if (isNaN(currentIndex) || currentIndex < 0 || currentIndex >= total) {
          currentIndex = false;
          page = clamp(1, Math.floor(page) || 1, pages);
        } else {
          page = Math.floor(protect(currentIndex / currentPerPage)) + 1;
        }

        var first = (page - 1) * currentPerPage;

        return {
          total: total,
          perPage: perPage,
          currentPerPage: currentPerPage,
          minPerPage: minPerPage,
          maxPerPage: maxPerPage,
          page: page,
          pages: pages,
          first: first,
          last: Math.min(total, first + currentPerPage) - 1,
          hasPrev: page > 1,
          hasNext: page < pages,
          currentIndex: currentIndex
        };
      },


      /**
       * Updates an autolist's pagination, and, if provided, sets the uiRouter param for the correct
       * page.
       *
       * Designed to be used within a promise chain for the item being paged to.
       *
       * @usage
       * Model.get(id)
       *     .then(paginationHelper.updateList(modelList, 'modelPage'));
       *
       * @param list List to update
       * @param param Optional uiRouter state param to update
       * @returns {Function} to be added to the promise chain
       */
      updateList: function updateList(list, param) {
        return function (item) {
          if (item && (angular.isString(item) || item.id)) {
            var page = list.setPageFor(item);
            if (param && page !== +$state.params[param] && $state.current && !$state.current.abstract) {
              stateHelper.redirectAfterResolve('.', defineProperty({}, param, page));
            }
          }
          return item;
        };
      }
    };
  }]);

  /* eslint-disable angular/no-private-call */

  var autolistHelperModule = angular.module('Q.helpers.autolist', [paginationHelperModule])

  /**
   * This service is used to create lists that will automatically update when items
   * are added or removed during push state events.
   *
   * It also can be used to return a list that is filled asynchronously, or a list that needs to be
   * manually re-updated.
   *
   * The list can also track a filter or sort, and automatically reapply the filter and sort to the
   * source list when updating.
   *
   * Autolists also provide a consistent promise interface even to synchronous lookup functions, via
   * list.promise.
   *
   */

  .factory('autolist', ['$rootScope', '$q', '$timeout', 'paginationHelper', function ($rootScope, $q, $timeout, paginationHelper) {
    var uniqueLists = {};

    var SOCKET_DEBOUNCE = 'socketDebounceTimeout';
    var WATCHER_DEBOUNCE = 'watcherDebounceTimeout';

    return {
      create: create
    };

    //// Public Functions

    /**
     * Creates a new autolist based on the provided lookup function
     *
     * @param lookupFunction {Function} function that generates the initial list
     * @param Model {Object?} Model that this list will contain (helps narrow down event listeners)
     * @param options {Object?}
     * @param options.autolistId {String?} If provided, will only update if this list is the current version of the unique ID
     * @param options.modifyResult {Function<result,autolist>?} function called after list is processed
     * @returns {Array}
     */
    function create(lookupFunction, Model) {
      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          autolistId = _ref.autolistId,
          _modifyResult = _ref.modifyResult;

      var list = [];

      angular.forEach({
        $$cache: {
          lookupFunction: lookupFunction,
          Model: Model,
          autolistId: autolistId
        },
        canUpdate: canUpdate,
        update: update,
        autoSort: autoSort,
        autoFilter: autoFilter,
        paginate: paginate,
        setPageFor: setPageFor,
        modifyResult: modifyResult,
        processUpdate: processUpdate,
        listen: listen,
        stopListening: stopListening,
        destroy: destroy,
        originalList: [],
        filteredList: null,
        sortedList: null,
        pg: {},
        hasLoaded: false,
        isEventUpdate: false,
        isWatchUpdate: false
      }, function (value, prop) {
        Object.defineProperty(list, prop, { value: value, writable: true });
      });

      if (autolistId) {
        uniqueLists[autolistId] = list;
      }

      if (_modifyResult) {
        list.modifyResult(_modifyResult);
      }

      list.update();

      return list;
    }

    //// Public Functions on an autolist

    /**
     * Returns false if this model should not be updated
     * @returns {boolean}
     */
    function canUpdate() {
      var list = this;
      return !list.$destroyed && (!list.$$cache.autolistId || uniqueLists[list.$$cache.autolistId] === list);
    }

    /**
     * Updates the list by reprocessing the original lookupFunction,
     * and reapplying any filters or sorts on the result.
     *
     * A promise for the async (or even synchronous) lookup can be accessed via
     * list.promise
     *
     * @param options {object} Options for processing the list this time only
     * @param options.sticky {bool} Override the sticky state for this update
     * @param options.changes {object} Change info for this update
     * @param options.event {object} Event info for this update
     * @returns {Array} self
     */
    function update() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var list = this;

      if (!list.canUpdate()) return list;
      list.updatingError = false;

      function markLoaded() {
        list.hasLoaded = true;
        list.updatingError = false;
        list.dirty = false;
        $timeout(function () {
          return list.finishedLoading = true;
        }, 1);
      }

      if (options.changes && Object.keys(options.changes).length && !options.changes.all && list.originalList.length) {
        // don't reload if we're only handling local sort or pagination changes
        markLoaded();
        _processResult(list, list.originalList, options);
        list.promise = $q.when(list);
      } else {
        var result = list.$$cache.lookupFunction(options);
        if (result.then) {
          list.updating = true;
          list.promise = result.then(function (data) {
            list.updating = false;
            markLoaded();
            return _processResult(list, data, options);
          }, function (err) {
            markLoaded();
            list.updatingError = err || true;
            return $q.reject(err);
          });
        } else {
          markLoaded();
          _processResult(list, result, options);
          list.promise = $q.when(list);
        }
      }

      return list;
    }

    /**
     * Creates an auto sorting function on this list.  This sort will be reapplied
     * if the list contents get updated.
     *
     * @param fn {function|bool} sort function, true for default sort, or false to disable the sort
     * @returns {Array} self
     */
    function autoSort(fn) {
      var list = this;
      list.$$cache.sort = fn;
      _processResult(list, undefined, { changes: { sort: true } });
      return list;
    }

    /**
     * Creates an auto filtering function on this list.  This filter will be reapplied
     * if the list contents get updated.
     *
     * @param fn {function} filter function
     * @param sticky {bool} If provided, don't remove items from the list when updating
     * @returns {Array} self
     */
    function autoFilter(fn) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          sticky = _ref2.sticky;

      var list = this;
      list.$$cache.filter = fn;
      _processResult(list);
      // we set sticky _after_ the first time the list is filtered, otherwise the list is
      // never filtered!
      list.$$cache.sticky = sticky;
      return list;
    }

    /**
     * Configures automatic pagination
     * @param opts {object|function} The options to pass into paginate
     * @returns {Array} self
     */
    function paginate(opts) {
      var list = this;
      list.$$cache.pagination = opts;
      _processResult(list, undefined, { changes: { pagination: true } });
      return list;
    }

    /**
     * Switches to the page for the provided item or id
     * @param itemOrId
     * @returns {number} page we switched to (for updating routes, etc)
     */
    function setPageFor(itemOrId) {
      var list = this;
      _processResult(list, undefined, {
        paginationCurrentItem: itemOrId,
        changes: { pagination: true }
      });
      return list.pg.page;
    }

    /**
     * If provided, allows modification of the final list after updates, filtering, sorting, and pagination
     * @param fn {function<Array,autolist>}
     */
    function modifyResult(fn) {
      var list = this;
      list.$$cache.modifyResult = fn;
      if (list.hasLoaded) {
        _processResult(list);
      }
      return this;
    }

    /**
     * Runs a function on the list during every update.  This function is called before the filter
     * or sort are applied.
     *
     * The function is provided with two arguments: the new data, and the autolist in it's current state.
     *
     * If the function returns an array, that array is assumed to replace the new data.
     * If the function returns false, the update is halted.
     * All other results from the function are discarded.
     *
     * This function could be used to load missing relationships, or perform per-item modifications.
     *
     * @param fn Function to run after every update
     * @returns {Array} self
     */
    function processUpdate(fn) {
      this.$$cache.processUpdate = fn;
      return _processResult(this);
    }

    /**
     * Creates a listener on the provided scope (recommended) or $rootScope if one is not provided.
     * This listener will listen to create and destroy events for the provided model, as well as the optional
     * watcher function.
     *
     * Watcher events are assumed to be important, and are updated immediately. They are debounced to .5s by
     * default, ensuring relatively quick updates while ignoring multiple sequential event triggers.
     *
     * Socket and model events are delayed and debounced to 15s by default. This helps cut down on refresh noise.
     * Socket events can also be disabled completely using `updated: false`, which will only mark the list as
     * `dirty`, and not cause an update. In this case, calling `list.update()` will reload the list immediately
     * and clear the dirty flag.
     *
     * If no local scope is provided, it is up to the endpoint to call stopListening or the returned
     * deregistration function on this list, or there *will* be a memory leak and performance issues.
     *
     * @param {$rootScope.Scope} scope Local scope to attach to
     * @param {boolean?} update If false, don't update the list, just mark it as dirty
     * @param {number?} socketDebounce Adjust the debounce rate for socket updates. Defaults to 15,000ms (15 seconds).
     * @param {number?} socketInitialDelay Always delay socket updates by this amount. Defaults to 100ms.
     * @param {number?} watcherDebounce Adjust the debounce rate for watcher updates. Defaults to 500ms.
     * @param {number?} watcherInitialDelay Always delay watched updates by this amount. Defaults to 0ms, which still groups multiple events per digest.
     * @param {Function?} watcher Additional watcher function (updates on change except the first)
     * @param {boolean?} deepWatch If using the additional watcher, is this a deep watch?  Defaults to false.
     * @param {string?} sortKey If provided, helps determine if we only need to sort (and paginate) the results without reloading (during watch)
     * @param {string?} pageKey If provided, helps determine if we only need to paginate the results without reloading (during watch)
     * @param {Function|boolean?} sticky If provided, only update items within the list (using Model.find()) when we can.
     * @returns {Function} deregistration function
     */
    function listen() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$scope = _ref3.scope,
          scope = _ref3$scope === undefined ? $rootScope : _ref3$scope,
          _ref3$update = _ref3.update,
          update = _ref3$update === undefined ? true : _ref3$update,
          _ref3$socketDebounce = _ref3.socketDebounce,
          socketDebounce = _ref3$socketDebounce === undefined ? 15000 : _ref3$socketDebounce,
          _ref3$socketInitialDe = _ref3.socketInitialDelay,
          socketInitialDelay = _ref3$socketInitialDe === undefined ? 100 : _ref3$socketInitialDe,
          _ref3$watcherDebounce = _ref3.watcherDebounce,
          watcherDebounce = _ref3$watcherDebounce === undefined ? 500 : _ref3$watcherDebounce,
          _ref3$watcherInitialD = _ref3.watcherInitialDelay,
          watcherInitialDelay = _ref3$watcherInitialD === undefined ? 0 : _ref3$watcherInitialD,
          _ref3$watcher = _ref3.watcher,
          watcher = _ref3$watcher === undefined ? null : _ref3$watcher,
          _ref3$deepWatch = _ref3.deepWatch,
          deepWatch = _ref3$deepWatch === undefined ? false : _ref3$deepWatch,
          _ref3$sortKey = _ref3.sortKey,
          sortKey = _ref3$sortKey === undefined ? null : _ref3$sortKey,
          _ref3$pageKey = _ref3.pageKey,
          pageKey = _ref3$pageKey === undefined ? null : _ref3$pageKey,
          _ref3$sticky = _ref3.sticky,
          sticky = _ref3$sticky === undefined ? null : _ref3$sticky;

      var list = this;
      list.stopListening();

      var $$cache = list.$$cache;
      $$cache.listeners = [];

      var changes = {};
      var event = {};
      var ids = [];

      function _handleUpdate() {
        // reset any updates that came in before the update started.
        delete $$cache.hasDebouncedUpdates;

        // if we're in sticky mode, and every id we've caught is in our visible list,
        // then don't reload the list
        if (sticky && ids.length && ids.every(function (id) {
          return list.some(function (item) {
            return item.id === id;
          });
        })) {
          list.forEach(function (item, index) {
            if (ids.includes(item.id)) {
              $$cache.Model.find(item.id, { bypassCache: true }).then(function (newItem) {
                list[index] = newItem;
              });
            }
          });

          // prevent reloading the whole list if we can simply refresh individual items
          changes.all = false;
        }
        list.update({ changes: changes, event: event });
        ids = [];
        changes = {};
        event = {};
      }

      // sets up a debounced update, which will automatically update after the timeout if there's a change
      // while waiting. Never updates faster than `debounce` milliseconds
      function _startDebounce(key, debounce) {
        $$cache[key] = $timeout(function () {
          delete $$cache[key];
          if ($$cache.hasDebouncedUpdates) {
            delete $$cache.hasDebouncedUpdates;
            _debouncedUpdate(key, 0, debounce);
          }
        }, debounce);
      }

      // If there's a delay in progress, marks that we have more changes and returns
      // otherwise starts an update immediately, then sets up a delay
      function _debouncedUpdate(key, initialDelay, debounce) {
        if ($$cache[key]) {
          $$cache.hasDebouncedUpdates = true;
          return;
        }
        list.dirty = true;

        // update after initialDelay to capture multiple rapid events
        $timeout(_handleUpdate, initialDelay);

        _startDebounce(key, debounce);
      }

      // listens to changes on sockets and model events, triggering debounced updates whenever one happens
      function modelChangedListener($event, data, type) {
        list.isEventUpdate = true;
        changes.all = true;
        event.data = data;
        event.type = type;
        if (data && data.id) {
          addUnique(ids, data.id);
        }
        list.dirty = true;
        if (update) {
          _debouncedUpdate(SOCKET_DEBOUNCE, socketInitialDelay, socketDebounce);
        }
      }

      if (update) {
        // Prevent updating immediately if we're performing updates.
        // This way the first update cannot happen until after the first socketDebounce.
        _startDebounce(SOCKET_DEBOUNCE, socketDebounce);
      }

      // configure all socket and model events
      var events = ['socket:model.changed', 'model.changed'];
      if ($$cache.Model) {
        events = events.map(function (n) {
          return n + ':' + $$cache.Model.name;
        });
      }
      events.forEach(function (event) {
        $$cache.listeners.push(scope.$on(event, modelChangedListener));
      });

      // configure watcher listener
      if (watcher) {
        var watchListener = scope.$watch(watcher, function (newVal, oldVal) {
          if (newVal && !angular.equals(newVal, oldVal)) {
            if (list.$$cache.clearTypeFlagTimer) {
              $timeout.cancel(list.$$cache.clearTypeFlagTimer);
            }
            list.isWatchUpdate = true;
            Object.keys(newVal).forEach(function (k) {
              if (newVal[k] !== oldVal[k]) {
                if (k.match(pageKey)) {
                  changes.pagination = true;
                } else if (k.match(sortKey)) {
                  changes.sort = true;
                } else {
                  changes.all = true;
                }
              }
            });

            _debouncedUpdate(WATCHER_DEBOUNCE, watcherInitialDelay, watcherDebounce);
          }
        }, deepWatch);
        $$cache.listeners.push(watchListener);
      }

      return list.stopListening.bind(list);
    }

    /**
     * Deregisters the listener on this list.
     */
    function stopListening() {
      var $$cache = this.$$cache;
      if ($$cache.listeners) {
        $$cache.listeners.forEach(function (l) {
          return l();
        });
        $$cache.listeners = null;
      }
      [WATCHER_DEBOUNCE, SOCKET_DEBOUNCE].forEach(function (k) {
        if ($$cache[k]) {
          $timeout.cancel($$cache[k]);
          delete $$cache[k];
        }
      });
    }

    /**
     * Destroys the auto list, stops listening, prevents further handling, etc.
     */
    function destroy() {
      var list = this;
      list.$destroyed = true;
      list.stopListening();
      list.length = 0;
      if (list.$$cache.autolistId && uniqueLists[list.$$cache.autolistId] === list) {
        delete uniqueLists[list.$$cache.autolistId];
      }
      Object.keys(list.$$cache).forEach(function (k) {
        delete list.$$cache[k];
      });
      ['originalList', 'filteredList', 'sortedList', 'pg'].forEach(function (k) {
        list[k] = undefined;
      });
      ['update', 'autoSort', 'autoFilter', 'paginate', 'setPageFor', 'processUpdate', 'listen', 'stopListening', 'destroy'].forEach(function (k) {
        list[k] = angular.noop;
      });
    }

    //// Private Functions

    /**
     * Handles processing a result, by running the auto filter and auto sort over it
     *
     * @param list autolist
     * @param result optional new list data
     * @param options {Object} pass in extra options to override the autolist's settings
     * @returns {Array} original autolist, now updated
     * @private
     */
    function _processResult(list) {
      var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : list.originalList;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (!list.canUpdate()) return;

      var $$cache = angular.extend({}, list.$$cache, options);

      var changes = options.changes;
      if (!changes || !(changes.sort || changes.pagination)) changes = { all: true };
      changes.newResult = result !== list.originalList;

      if (changes.all || !result.length || !list.filteredList) {
        result = _processAndFilter(list, result, $$cache);
      } else {
        result = list.filteredList;
      }

      if (changes.all || changes.sort || !list.sortedList) {
        // sort the list (only happens if there is a cached sort function)
        result = _processSort(list, result, $$cache);
      } else {
        result = list.sortedList;
      }

      // pagination is last, we always process it
      result = _processPagination(list, result, $$cache);

      if (changes.newResult && $$cache.modifyResult) {
        result = $$cache.modifyResult(result, list, changes) || result;
      }

      // overwrite the original array contents with the new contents
      list.length = 0;
      list.push.apply(list, toConsumableArray(result));

      if (list.isEventUpdate || list.isWatchUpdate) {
        if (list.$$cache.clearTypeFlagTimer) {
          $timeout.cancel(list.$$cache.clearTypeFlagTimer);
        }
        list.$$cache.clearTypeFlagTimer = $timeout(function () {
          if (!$$cache.hasDebouncedUpdates) {
            list.isEventUpdate = false;
            list.isWatchUpdate = false;
          }
          delete list.$$cache.clearTypeFlagTimer;
        }, 2500);
      }

      if (angular.isFunction(list.onUpdate)) {
        list.onUpdate(list);
      }

      return list;
    }

    /**
     * Handles post-load processing and filtering of the results
     * @param list
     * @param result
     * @param $$cache
     * @returns {*}
     * @private
     */
    function _processAndFilter(list, result, $$cache) {
      // enable post-update processing
      if ($$cache.processUpdate) {
        var processUpdateResult = $$cache.processUpdate(result, list);
        // bail on false
        if (processUpdateResult === false) return list;

        // store original result no matter what
        list.originalList = result;

        // work on returned data
        if (Array.isArray(processUpdateResult)) {
          result = processUpdateResult;
        }
      } else {
        list.originalList = result;
      }

      // enable filtering
      if ($$cache.filter) {
        result = result.filter(function (item) {
          var match = $$cache.filter(item);
          if (!match && $$cache.sticky && !list.isWatchUpdate) {
            match = list.filter(function (i) {
              return i === item || item.id && i.id === item.id;
            }).length > 0;
          }
          return match;
        });
        list.filteredList = result;
      }

      return result;
    }

    /**
     * Handles post-filter sorting of the results
     * @param list
     * @param result
     * @param $$cache
     * @returns {*}
     * @private
     */
    function _processSort(list, result, $$cache) {
      var fn = $$cache.sort;
      if (fn) {
        if (fn === true) {
          result.sort();
        } else {
          if (fn.length !== 2) {
            fn = fn();
          }
          result.sort(fn);
        }
      }
      list.sortedList = result;

      return result;
    }

    /**
     * Handles post-sort pagination of the results
     * @param list
     * @param result
     * @param $$cache
     * @returns {*}
     * @private
     */
    function _processPagination(list, result, $$cache) {
      if ($$cache.pagination) {
        var opts = angular.isFunction($$cache.pagination) ? $$cache.pagination() : $$cache.pagination;
        if (opts.client === false) {
          // use the server details if this is a server query, except we don't support the buffer option
          list.pg = paginationHelper.calc(angular.extend({}, opts, { buffer: 0 }));
        } else {
          var currentIndex = -1;
          if (opts.currentItem || $$cache.paginationCurrentItem) {
            var currentItem = opts.currentItem || $$cache.paginationCurrentItem;
            currentIndex = result.findIndex(function (item) {
              return item === currentItem || item.id === currentItem;
            });
          }
          list.pg = paginationHelper.calc(angular.extend({ total: result.length, currentIndex: currentIndex }, opts));
          result = result.slice(list.pg.first, list.pg.last + 1);
        }
      } else {
        list.pg = {};
      }
      return result;
    }
  }]);

  var jsDataModule = 'js-data';

  var jsDataConfigModule = angular.module('Q.config.js-data', [jsDataModule]).run(['DS', 'DSHttpAdapter', '$log', function (DS, DSHttpAdapter, $log) {
    // make sure we always re-query the local store on cached remote calls, in case the result as changed
    DS.defaults.useFilter = true;
    DSHttpAdapter.defaults.basePath = appConfig.apiRoot;
    DSHttpAdapter.defaults.log = $log.debug;
    DSHttpAdapter.defaults.error = $log.error;
  }]);

  /* eslint-disable angular/no-private-call */

  var ACTIVE_STATIC_PROMISES = {};

  function _createCommonStaticMethods(DS, DSUtils, DSHttpAdapter, $q, $injector, autolist) {
    var _commonStaticMethods = {
      /**
       * Generates a complete URL for an endpoint on a JS-Data model
       * @param {string|Object?} id - The string ID or object with an ID of a model. If not included, then the URL would be on the collection
       * @param {string?} segment - The segment we want to check. Can be excluded if just looking for the base model URL
       * @param {*} options - Additional properties to pass to the DSHttpAdapter
       * @param {Object<String>} params - Additional (string-only) parameters to encode in the URL
       * @returns {string} The absolute URL
       */
      getEndpointUrl: function getEndpointUrl() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            id = _ref.id,
            _ref$segment = _ref.segment,
            segment = _ref$segment === undefined ? null : _ref$segment,
            _ref$options = _ref.options,
            options = _ref$options === undefined ? {} : _ref$options,
            _ref$params = _ref.params,
            params = _ref$params === undefined ? {} : _ref$params;

        var Model = this;
        id = DSUtils.resolveId(Model, id);

        var url = DSUtils.makePath(options.basePath || DSHttpAdapter.defaults.basePath, DSHttpAdapter.getEndpoint(Model, id, options), id || segment, id && segment);

        if (Object.keys(params).length) {
          url += '?' + Object.keys(params).map(function (k) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
          }).join('&');
        }

        return url;
      },
      saveOrCreate: function saveOrCreate(instance, changes, options) {
        var _this = this;

        if (!instance) return $q.reject();
        var promise = void 0;
        var isNew = !instance.id;
        var newObj = void 0;
        var getInstanceChanges = function getInstanceChanges(changes) {
          var instanceChanges = angular.copy(changes);
          if (_this.meta.excludeSaveOrCreateProps) {
            _this.meta.excludeSaveOrCreateProps.forEach(function (prop) {
              delete instanceChanges[prop];
            });
          }
          return instanceChanges;
        };
        if (isNew) {
          // for new items, the entire instance is our changes
          changes = angular.extend({}, instance, changes || {});
          promise = this.create(getInstanceChanges(changes), options).then(function (o) {
            return newObj = o;
          });
        } else {
          var _angular;

          // include any client-side changes in the model
          changes = (_angular = angular).extend.apply(_angular, [{}].concat(toConsumableArray(Object.values(this.changes(instance))), [changes || {}]));
          var instanceChanges = getInstanceChanges(changes);
          var original = this.get(instance.id);
          var includeChange = this.meta.includeSaveOrCreateChange || function () {
            return true;
          };
          var hasChanges = original && Object.keys(instanceChanges).some(function (k) {
            return includeChange(k, instanceChanges[k]) && !angular.equals(original[k], instanceChanges[k]);
          });
          if (hasChanges || changes.tag && changes.event) {
            instanceChanges.$type = instance.$type;
            promise = this.update(instance.id, instanceChanges, options);
          } else {
            promise = $q.resolve(original);
          }
        }

        if (this.meta.afterSaveOrCreate) {
          promise = promise.then(this.meta.afterSaveOrCreate(instance, changes, options)).catch(function (err) {
            if (isNew && newObj) {
              // send off a destroy if we fail on after-save events
              _this.destroy(newObj);
            }
            return $q.reject(err);
          });
        }

        return promise;
      },


      //// old-style Find method

      /**
       * Enables making a server call to find the item at least once, even if it's already in the store
       *
       * @param {string} id - ID of item to get
       * @param {*} options - Options passed to get or find
       * @returns {Promise} Promise to be resolved if the item is found, or rejected if there was an error
       *    communicating with the server
       */
      findOnce: function findOnce(id, options) {
        var wasFound = this.markFoundOnce(id);

        // if we haven't already looked up the item, force a reload
        options = options || {};
        options.bypassCache = !wasFound;

        return this.find(id, options);
      },

      /**
       * Marks that this item has been looked up directly at least once. This means using find()
       * rather than findAll() or coming in as a nested item.
       * @param {string} id - ID of item
       * @returns {boolean} True if was found previously
       */
      markFoundOnce: function markFoundOnce(id) {
        var foundOnce = this.meta.foundOnce = this.meta.foundOnce || {};
        var wasFound = foundOnce[id];
        foundOnce[id] = true;
        return wasFound;
      },

      //// fetch methods

      /**
       * Fetches an item from either the backing store, or looks to the server if
       * not already present. Options will be passed to both the `get` and `find`
       * methods, but note that if this is requested with server-side parameters
       * yet already exists in the backing store, the parameters will be ignored.
       *
       * @param {string} id - ID of item to get
       * @param {*} options - Options passed to get or find
       * @returns {Promise} Promise to be resolved if the item is found, or rejected if there was an error
       *    communicating with the server
       */
      fetch: function fetch(id, options) {
        var self = this;
        var bypassCache = !!(options && options.bypassCache);
        var model = bypassCache ? null : self.get(id, options);
        if (model) {
          if (options && options.rels) {
            return self.loadMissingRelations(model, options.rels);
          } else {
            return $q.when(model);
          }
        } else {
          return self.find(id, options);
        }
      },

      /**
       * Fetches an array of items from either the backing store, or loads from the server if the
       * requested search params return nothing.
       * @param {*} params - Parameters to search on
       * @param {*?} options - Any additional properties to pass along to the `findAll` method
       * @returns {Promise} Found models
       */
      fetchAll: function fetchAll(params, options) {
        var self = this;
        var bypassCache = !!(options && options.bypassCache);
        var models = bypassCache ? [] : self.filter(params, options);
        // not optimal, because the filter might return the empty set correctly, but anyway...
        if (models.length) {
          return $q.when(models);
        } else {
          return self.findAll(params, options);
        }
      },

      /**
       * Fetches all models with the matching IDs. All IDs that are not already in the store are
       * grouped together into a single query to load missing items.
       *
       * @param {Array<string>} ids - IDs to load
       * @param {*?} options - Any additional properties to pass along to the `findAll` method
       * @param {boolean} options.bypassCache - If true, don't look in the local store
       * @returns {Promise} Result including all matching items.
       */
      fetchAllIds: function fetchAllIds(ids) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var self = this;
        var bypassCache = !!options.bypassCache;
        var searchIds = bypassCache ? ids : [];
        var found = [];
        if (!bypassCache) {
          ids.forEach(function (id) {
            var item = self.get(id, options);
            if (item) {
              found.push(item);
            } else {
              searchIds.push(id);
            }
          });
        }
        return $q.when().then(function () {
          if (searchIds.length) {
            var opts = {
              where: {
                id: { in: searchIds }
              },
              per: searchIds.length
            };
            angular.merge(opts, options);
            return self.findAll(opts);
          } else {
            return [];
          }
        }).then(function (newItems) {
          return found.concat(newItems);
        });
      },

      createWithFetch: function createWithFetch(attrs, options) {
        var k = 'createWithFetch:' + JSON.stringify(attrs);

        if (!ACTIVE_STATIC_PROMISES[k]) {
          options = angular.copy(options) || {};
          options.params = options.params || {};
          options.params.fetch = true;
          ACTIVE_STATIC_PROMISES[k] = this.create(attrs, options).finally(function () {
            delete ACTIVE_STATIC_PROMISES[k];
          });
        }

        return ACTIVE_STATIC_PROMISES[k];
      },

      /**
       * A specialized function designed to aid in finding items where only one or zero are
       * expected, and if zero are returned, then the item is created with the given attributes.
       *
       * @param params {object} Query parameters
       * @param attrs {object?} Attributes for the newly created item if the ID does not exist (params
       *    will be used if attrs is not provided)
       * @param options {object?} Options to be passed to fetchAll AND create
       * @returns {*} Promise A promise that will resolve with a single instance, OR reject if anything
       *    prevents a single instance from being created
       */
      fetchOrCreateWhere: function fetchOrCreateWhere(params) {
        var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        var k = 'fetchOrCreateWhere:' + JSON.stringify(params);

        if (!ACTIVE_STATIC_PROMISES[k]) {
          var self = this;

          var create = function create() {
            var method = options.createInstance ? 'createInstance' : 'create';
            return self[method](attrs || params || {}, options);
          };

          ACTIVE_STATIC_PROMISES[k] = self.fetchAll(params, options).then(function (models) {
            var resp = models.find(function (m) {
              return Object.keys(params).every(function (k) {
                return k === 'where' ? true : m[k] === params[k];
              });
            });
            return resp || $q.reject({ status: 404 });
          }).catch(function (response) {
            return response.status === 404 ? create() : $q.reject(response);
          }).finally(function () {
            delete ACTIVE_STATIC_PROMISES[k];
          });
        }

        return ACTIVE_STATIC_PROMISES[k];
      },

      /**
       * A method that asynchronously loads any unknown items by creating a query that
       * excludes any known IDs.
       *
       * By default this method will only go to the server once, afterwards it returns `getAll`
       * wrapped in a promise. You can bypass this behavior by using the `bypassCache`
       *
       * Note: the results of this method will always contains _all_ the items in the system, even if
       * only some came from the server, which makes it a safe alternative to `fetchAll` or
       * `findAll`.
       *
       * @param {*} options Options to pass to findAll
       * @returns {Promise}
       */
      findMissing: function findMissing(options) {
        var self = this;
        if (self.meta.$$didFindMissing && !(options && options.bypassCache)) {
          return $q.when(self.getAll());
        } else {
          var where = {
            id: {
              notIn: self.getAll().map(function (item) {
                return item.id;
              })
            }
          };
          if (options.where) {
            angular.merge(where, options.where);
          }
          return self.findAll({ where: where }, options).then(function () {
            self.meta.$$didFindMissing = true;
            return self.getAll();
          });
        }
      },

      //// Relationships

      /**
       * Loads any missing default includes if they are not already defined on the instance.
       *
       * @param instance
       * @param rels Names of relations to load (see DI.loadRelations)
       * @returns {*} Promise
       */
      loadMissingRelations: function loadMissingRelations(instance, rels) {
        var self = this;
        var _rels = [];
        angular.forEach(rels, function (rel) {
          angular.forEach(self.relationList, function (fieldDef) {
            if (fieldDef.relation === rel && _rels.indexOf(rel) === -1) {
              var localField = fieldDef.localField;
              // force loading if the field is missing OR an empty array on hasMany
              if (localField && (!instance[localField] || fieldDef.type === 'hasMany' && !instance[localField].length)) {
                _rels.push(rel);
              }
            }
          });
        });
        return _rels.length ? self.loadRelations(instance, _rels) : $q.when(instance);
      },

      //// Meta Data

      /**
       * Asynchronously returns the meta data for this Model
       * @param {boolean} force If true, force reloading
       * @returns {*} Promise
       */
      getMetaData: function getMetaData() {
        var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var self = this;

        if (self._metaDataPromise) return self._metaDataPromise;

        if (!force && self.metaData && self.metaData._loaded) {
          return $q.when(self.metaData);
        } else {
          if (!self.metaData) {
            self.metaData = {
              enums: {},
              flags: {},
              includes: []
            };
          }
          var returnMeta = function returnMeta() {
            self.metaData._loaded = true;
            delete self._metaDataPromise;
            return $q.when(self.metaData);
          };
          // reuse DS to handle the meta-data load
          self._metaDataPromise = self.find('meta', {
            cacheResponse: false,
            ignoreLoadingBar: true
          }).then(returnMeta, returnMeta);

          return self._metaDataPromise;
        }
      },

      /**
       * Loads an enum array or enum value
       * @param {string} name Name of the enum (can include nested enums using `.`, as in `office.seating`)
       * @param {string} key (Optional) Looks up the mapped value of the enum based on the key
       * @param {boolean} async If true, the response will be a promise that resolves once metadata has been loaded
       * @returns {Promise|Array|string} Promise for async, array of enum objects if key is not provided, and a string if the key is provided.
       * This will always return a value, even if the metadata has not been loaded or we cannot find a matching enum or key
       */
      getEnum: function getEnum(name, key) {
        var _this2 = this;

        var async = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        if (async) {
          return this.getMetaData().then(function () {
            return _this2.getEnum(name, key);
          });
        } else {
          var enumData = this.metaData && this.metaData.enums && pluck(name, this.metaData.enums);
          var keyExists = key !== null && key !== undefined;

          if (!enumData) {
            // enable looking up the metadata so it's available on a later $digest cycle
            this.getMetaData();
            return keyExists ? '' : [];
          }

          if (keyExists) {
            if (!enumData.keyMap) {
              enumData.keyMap = enumData.reduce(function (map, item) {
                map[item.value] = item.text;
                return map;
              }, {});
            }
            return enumData.keyMap[key] || '';
          } else {
            return enumData;
          }
        }
      }
    };

    //--------------------------------------------------------------------
    //
    // Autolist functions
    //
    //--------------------------------------------------------------------

    ['getAll', 'filter', 'fetchAll'].forEach(function (fnName) {
      _commonStaticMethods['auto' + pascalCase(fnName)] = function (params, options) {
        var Model = this;
        return autolist.create(function () {
          return Model[fnName](params, options);
        }, Model, options);
      };
    });

    // Auto find missing doesn't take any arguments
    _commonStaticMethods.autoFindMissing = function (options) {
      var Model = this;
      return autolist.create(function () {
        return Model.findMissing(options);
      }, Model, options);
    };

    // autoFindAll is treated special, so it can be used for server-side-only lists
    // It includes internal support for dynamic params and server-side pagination
    // (All other methods are assumed to be used for client-side handling)
    _commonStaticMethods.autoFindAll = function (params) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var Model = this;
      var list = autolist.create(function autoFindAllAutoListMethod() {
        // get the query parameters (may be dynamic)
        var findAllParams = angular.isFunction(params) ? params() : params;
        // do not modify the original options
        var findAllOptions = angular.copy(options);

        // the following block is for tracking the full response data on the returned Array
        var responseDataCacheKey = JSON.stringify(findAllParams) || 'null';
        findAllOptions.responseDataCacheKey = responseDataCacheKey;
        var cacheResponse = findAllOptions.cacheResponse !== undefined ? findAllOptions.cacheResponse : Model.cacheResponse;
        var afterFn = cacheResponse === false ? 'afterFindAll' : 'afterInject';
        var originalAfterFn = findAllOptions[afterFn] || Model[afterFn];
        findAllOptions[afterFn] = function autoFindAllAfterFn(options, data) {
          var InjectedModel = options;
          while (InjectedModel && !InjectedModel.hasOwnProperty('$dsModel')) {
            // When injecting a nested data model, JS-Data decides to use the overridden `after*` method,
            // (meaning this one) rather than the one on the injected model
            // So we need to look for the correct model for the injected resource by walking the prototype
            // chain
            InjectedModel = Object.getPrototypeOf(InjectedModel);
          }

          if (InjectedModel.name !== Model.name) {
            // this is a different model than the one the method was called on, use the default after*
            // function for that model
            if (InjectedModel[afterFn]) {
              InjectedModel[afterFn](InjectedModel, data);
            }
          } else {
            // this is the top-level model, so we can use the original method instead
            if (originalAfterFn) {
              originalAfterFn(options, data);
            }
            if (Array.isArray(data) && Model.$responseData) {
              // store the response data on the final output array from the find all operation
              // we do it this way because the result of Model.findAll can be returned to *different*
              // requests to findAll! Even if they come from different sources, if the params match,
              // JS-Data will only make a single request at a time.
              data.$responseData = Model.$responseData[responseDataCacheKey];
              delete Model.$responseData[responseDataCacheKey];
            }
          }
          return data;
        };

        if (findAllOptions.bypassCache !== false && findAllOptions.cacheResponse !== true) {
          findAllOptions.bypassCache = true;
        }

        return Model.findAll(findAllParams, findAllOptions).then(function (resp) {
          // catch pagination errors if we have no data
          if (resp.length === 0 && findAllParams && findAllParams.page > 1) {
            return Model.findAll(angular.extend({}, findAllParams, { page: 1 }), findAllOptions);
          }
          // store the response data back on the autolist for pagination
          list.responseData = resp.$responseData;
          return resp;
        });
      }, Model, options);

      // configure default server-side pagination
      list.paginate(function autoFindAllPagination() {
        var data = { client: false };
        if (list.responseData && list.responseData.params && list.responseData.params.per) {
          data.total = list.responseData.totalCount;
          data.perPage = list.responseData.params.per;
          data.page = list.responseData.currentPage;
        }
        return data;
      });

      return list;
    };

    /**
     * A variation of autoFindAll and findAll that recursively loads every matching item across multiple pages
     * Use the 3rd parameter to `then` to receive progress notifications
     *
     * @param params {Object}
     * @param params.per {number} By default this is 100, but can be adjusted based on needs
     * @param options
     * @returns {Promise}
     */
    _commonStaticMethods.retrieveAll = function () {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var deferred = $q.defer();
      params.per = params.per || 100;
      params.page = 1;

      var cfpLoadingBar = $injector.has('cfpLoadingBar') && $injector.get('cfpLoadingBar');

      var showProgress = !options.ignoreLoadingBar && cfpLoadingBar;
      if (showProgress) cfpLoadingBar.start();
      options.ignoreLoadingBar = true;

      var result = [];
      var autolist = this.autoFindAll(params, options);
      var _processNext = function _processNext() {
        autolist.update().promise.then(function (list) {
          result.push.apply(result, toConsumableArray(list));
          if (list.pg.hasNext) {
            var retrieved = result.length;
            var total = list.pg.total;
            var progress = retrieved / total;
            deferred.notify({ progress: progress, retrieved: retrieved, total: total });
            if (showProgress) cfpLoadingBar.set(progress);

            params.page += 1;
            _processNext();
          } else {
            if (showProgress) cfpLoadingBar.complete();
            autolist.destroy();
            deferred.resolve(result);
          }
        }, deferred.reject);
      };
      _processNext();

      return deferred.promise;
    };

    // Attach static methods to DS defaults for simple inheritance
    angular.forEach(_commonStaticMethods, function (fn, key) {
      defineValue(DS.defaults, key, fn);
    });
  }

  function _createSaveEmbedded($q) {
    /**
     * Creates a method that can be used after a normal save to automatically save an embedded
     * array of children on a parent model.
     *
     * @param options {Object|Array<{Model,fieldName,foreignKey,changes,orderable}>}
     * @param options.Model {Resource|Array<Array>} JS-Data resource of the children.
     *        If this is an array, each item is passed as an argument to saveEmbedded
     * @param options.fieldName {String?} Name of the field for the children on the parent object
     * @param options.foreignKey {String?} Name of the reference field to point to the parent's ID on the child
     * @param options.changes {*?} Optional set of changes on the parent model, to prevent unnecessary calls out
     * @param options.orderable {boolean?}
     * @param options.exclude {Function?} if provided, used to exclude changes on the embedded
     * @param options.diff {Function?} if provided, use instead of object-utils.diff for determining changes
     * @param options.uniqueChildField {String?} If provided, use to prevent uniqueness constraint errors
     * @param options.copyFields {Array<String>?} If provided, copy these values from changes to any modified child
     * @param options.requestOptions {*?} Params to send along with the request
     * @returns {Function} Function to call with the parent model, usually used in a `.then` after a save or update. Parent instance is returned.
     */
    return function saveEmbedded(options) {
      if (Array.isArray(options)) {
        return function (parent) {
          return $q.all(options.map(function (options) {
            return saveEmbedded(options)(parent);
          })).then(function () {
            return parent;
          });
        };
      }
      var Model = options.Model,
          fieldName = options.fieldName,
          _options$foreignKey = options.foreignKey,
          foreignKey = _options$foreignKey === undefined ? null : _options$foreignKey,
          _options$changes = options.changes,
          changes = _options$changes === undefined ? null : _options$changes,
          _options$requestOptio = options.requestOptions,
          requestOptions = _options$requestOptio === undefined ? {} : _options$requestOptio,
          _options$orderable = options.orderable,
          orderable = _options$orderable === undefined ? true : _options$orderable,
          _options$exclude = options.exclude,
          exclude = _options$exclude === undefined ? angular.noop : _options$exclude,
          _options$uniqueChildF = options.uniqueChildField,
          uniqueChildField = _options$uniqueChildF === undefined ? null : _options$uniqueChildF,
          _options$copyFields = options.copyFields,
          copyFields = _options$copyFields === undefined ? ['tag'] : _options$copyFields,
          _options$diff = options.diff,
          diff$$1 = _options$diff === undefined ? diff : _options$diff;

      var baseFields = function baseFields() {
        var fields = {};
        if (changes) {
          copyFields.forEach(function (f) {
            fields[f] = changes[f];
          });
        }
        return fields;
      };
      return function (parent) {
        var updates = changes && changes[fieldName];
        if (!updates && (changes || !parent[fieldName])) {
          // don't bother if we have no changes to report
          return $q.resolve(parent);
        }

        var _addForeignKeyParam = function _addForeignKeyParam(options) {
          if (foreignKey) {
            if (options) {
              options[foreignKey] = parent.id;
            } else {
              options = angular.copy(requestOptions);
              options.params = options.params || {};
              options.params[foreignKey] = parent.id;
            }
          }
          return options || requestOptions;
        };

        // handle deletions first (for unique constraints)
        var delPromises = $q.when();
        if (updates && parent[fieldName] && parent[fieldName].length) {
          if (uniqueChildField) {
            // Delete the IDs of any updated items that would cause uniqueness constraint issues (they'll
            // be deleted and recreated instead).
            // This happens, for example, if two files have swapped paths.
            updates.forEach(function (newChild) {
              var oldChild = parent[fieldName].find(function (oldChild) {
                return oldChild.id !== newChild.id && oldChild[uniqueChildField] === newChild[uniqueChildField];
              });
              if (oldChild) {
                delete newChild.id;
                var updateToOldChild = updates.find(function (nc) {
                  return nc.id === oldChild.id;
                });
                if (updateToOldChild) {
                  // If only one child was renamed, it's possible to get into a scenario where the
                  // updates happen out-of-order, causing a uniqueness constraint, so we go ahead
                  // and treat that file as deleted-and-recreated as well.
                  delete updateToOldChild.id;
                }
              }
            });
          }
          delPromises = $q.all(parent[fieldName].filter(function (oldChild) {
            return oldChild.id && !oldChild.softDeletedAt && updates.every(function (newChild) {
              return oldChild.id !== newChild.id;
            });
          }).map(function (oldChild) {
            return Model.destroy(oldChild, _addForeignKeyParam());
          }));
        }

        return delPromises.then(function () {
          // Save or create any changed or new child models
          var promises = void 0;
          promises = (updates || parent[fieldName]).map(function (child, i) {
            // Ensure files with softDeletedAt are included
            if (exclude(child) && !child.softDeletedAt) {
              // return the internally stored file if we don't save changes here
              return Model.get(child.id);
            }
            if (orderable) {
              child.position = i + 1;
            }
            var createModel = function createModel() {
              var params = _addForeignKeyParam(baseFields());
              angular.extend(params, child);
              delete params.id;
              return Model.create(params, requestOptions);
            };
            if (child.id) {
              var childOrig = Model.get(child.id);
              var updatePromise = void 0;
              if (childOrig) {
                var childCopy = Object.assign({}, child);
                // strip any special $ prefixed values out of the object to do a proper diff
                Object.keys(childCopy).filter(function (k) {
                  return k[0] === '$';
                }).forEach(function (key) {
                  delete childCopy[key];
                });

                var diffData = diff$$1(childOrig, childCopy);

                if (diffData.$empty) {
                  // no need to update child, just return the local reference
                  return childOrig;
                } else {
                  // always include type
                  diffData.$type = childOrig.$type;
                  angular.extend(diffData, _addForeignKeyParam(baseFields()));
                  updatePromise = Model.update(childOrig, diffData, requestOptions);
                }
              } else {
                // no local copy?
                var params = angular.extend(_addForeignKeyParam(baseFields()), child);
                updatePromise = Model.update(child.id, params, requestOptions);
              }
              return updatePromise.catch(function (resp) {
                // on 404 errors, just create a new file instead
                return resp.status === 404 ? createModel() : $q.reject(resp);
              });
            } else {
              // save a new one
              return createModel();
            }
          });

          // Wait for any and all changes
          return $q.all(promises);
        }).then(function (children) {
          // Clean up any old children on the parent model missed above
          if (parent[fieldName] && parent[fieldName].length) {
            return $q.all(parent[fieldName].filter(function (oldChild) {
              return !oldChild.softDeletedAt && children.every(function (newChild) {
                return newChild.id !== oldChild.id;
              });
            }).map(function (oldChild) {
              return oldChild.id && Model.destroy(oldChild, _addForeignKeyParam()).catch(function (resp) {
                // ignore 404 errors on deleted embedded saves
                return resp.status === 404 ? true : $q.reject(resp);
              });
            })).then(function () {
              return children;
            });
          }
          return children;
        }).then(function (children) {
          if (parent[fieldName]) {
            var _parent$fieldName;

            // replace the array of children with the updated models
            parent[fieldName].length = 0;
            (_parent$fieldName = parent[fieldName]).push.apply(_parent$fieldName, toConsumableArray(children));
            return parent;
          }
        });
      };
    };
  }

  /* eslint-disable angular/no-private-call */

  var modelHelperModule = angular.module('Q.models.model-helper', [jsDataModule, jsDataConfigModule, autolistHelperModule])

  /**
   * This library is used to make more advanced models by including some extra methods, and also
   * wrapping default methods for js-data.
   *
   * The main improvements are:
   *
   * - Typed Resources
   *   A resource may define .meta.types, which will enable type-specific functionality for that
   *   model.
   *
   * - fetch and fetchAll
   *   These methods are added to the model, and will provide asynchronous access to instances whether they
   *   are already in the backing store or not.
   *
   * - loadMissingRelations
   *   Will only load relations that are missing on the instance.
   *
   */
  .factory('ModelHelper', ['autolist', 'DS', '$q', 'DSUtils', '$rootScope', 'DSHttpAdapter', '$timeout', '$log', '$injector', function (autolist, DS, $q, DSUtils, $rootScope, DSHttpAdapter, $timeout, $log, $injector) {
    //--------------------------------------------------------------------
    //
    //  COMMON STATIC METHODS: Methods added to the Model object itself
    //
    //--------------------------------------------------------------------

    var _commonStaticProperties = {
      first: function first() {
        return this.getAll()[0];
      },
      last: function last() {
        var a = this.getAll();
        return a[a.length - 1];
      }
    };

    // attach static properties to DS defaults for inheritance
    angular.forEach(_commonStaticProperties, function (fn, key) {
      Object.defineProperty(DS.defaults, key, { get: fn });
    });

    _createCommonStaticMethods(DS, DSUtils, DSHttpAdapter, $q, $injector, autolist);

    //--------------------------------------------------------------------
    //
    // MODEL EVENTS
    //
    //--------------------------------------------------------------------

    function _addModelChangedEvents(config, Model) {
      Model.$broadcast = function (type, attrs) {
        var action = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : type;

        var instance = DS.get(Model.name, attrs.id);

        var props = {
          id: attrs.id,
          config: config,
          instance: instance,
          attrs: attrs,
          resourceName: Model.name,
          action: action
        };

        $rootScope.$broadcast('model.changed:' + Model.name + ':' + attrs.id, props, type);
        $rootScope.$broadcast('model.changed:' + Model.name, props, type);
        $rootScope.$broadcast('model.changed', props, type);
      };
      angular.forEach({ create: 'created', update: 'updated', destroy: 'destroyed' }, function (type, action) {
        Model.on('DS.after' + pascalCase(action), function (resource, attrs) {
          $timeout(function () {
            Model.$broadcast(type, attrs, action);
          }, 100);
        });
      });
    }

    //--------------------------------------------------------------------
    //
    // ACTION ENDPOINTS
    //
    //--------------------------------------------------------------------

    /**
     * Enables new static methods that call to specific endpoints, with the ability to
     * automatically inject the resulting object.
     *
     * Configuration comes from config.meta.actionEndpoints, a hash of method names to options. If the options
     * value is true or an empty object, the defaults apply.  All options are passed to the HTTP adapter, as well,
     * allowing you to override endpoints and other settings in a general manner.
     *
     * The created methods have the form of
     *
     * .[methodName]( id|resource, options )
     *
     * Options is mixed on top of the action, allowing you to override some configuration on a per-call basis.
     *
     * @param config
     * @param config.segment: the end segment, defaults to the method name
     * @param config.endpoint: override the model's default endpoint
     * @param config.method: HTTP method, defaults to POST,
     * @param config.responseHandler: if provided, overrides the built-in response handler (which deserializes
     *              and attempts to inject the result if it has an ID).
     *              Set to angular.identity to get direct access to the HTTP response.
     * @param config.cacheResponse: prevent the default handler from attempting to inject the response.
     * @param config.serialize: unless falsey, serialize the data object (if present) using the model's serialize method
     */
    function _addActionEndpoints(config) {
      config.staticMethods = config.staticMethods || {};

      angular.forEach(config.meta.actionEndpoints, function (action, name) {
        if (!angular.isObject(action)) {
          if (action === true) action = {};
          if (angular.isFunction(action)) action = { responseHandler: action };
        }

        action = angular.extend({
          segment: snakeCase(name),
          method: 'POST',
          responseHandler: false,
          onSuccess: null,
          cacheResponse: true,
          serialize: true
        }, action);

        config.staticMethods[name] = function (id, options) {
          var Model = this;

          if (!id) {
            var msg = 'Called to actionEndpoint ' + Model.name + '.' + name + ' without an id or instance: "' + id + '"';
            $log.warn(msg);
            return $q.reject(msg);
          }

          var instance = id;
          id = DSUtils.resolveId(Model, id);
          if (!instance.id) {
            instance = Model.get(id) || { id: id };
          }

          options = angular.extend({}, action, options || {});

          options.url = Model.getEndpointUrl({
            id: id,
            segment: action.segment,
            options: options
          });

          if (instance.$type) {
            // add in type param for typed models
            var what = options.method === 'GET' ? 'params' : 'data';
            options[what] = options[what] || {};
            options[what].$type = options[what].$type || instance.$type;
          }

          if (options.data && options.serialize) {
            // serialize the data model by default
            options.data = Model.serialize(Model.name, options.data || {});
          }

          function broadcast() {
            Model.$broadcast('update', instance);
            // currently only used by tracker service
            $rootScope.$broadcast('model.actionEndpoint.success', {
              options: options,
              model: Model,
              instance: instance,
              name: name
            });
          }

          var responseHandler = void 0;
          // if a response handler was provided, wrap it so that we can pass in other useful information
          if (options.responseHandler) {
            responseHandler = function responseHandler(res) {
              broadcast();
              return options.responseHandler(res, Model, instance, options);
            };
          } else {
            responseHandler = function responseHandler(res) {
              broadcast();
              var data = options.deserialize ? options.deserialize(Model.name, res) : Model.deserialize(Model.name, res);
              if (data && data.id && options.cacheResponse) {
                return Model.inject(data);
              } else if (data && data.id) {
                return Model.createInstance(data);
              } else {
                return data;
              }
            };
          }

          return DSHttpAdapter.HTTP(options).then(responseHandler).then(function (val) {
            if (options.onSuccess) options.onSuccess(val);
            return val;
          });
        };

        config.staticMethods[name + 'WithAlert'] = function () {
          var returnedPromise = this[name].apply(this, arguments);
          var appAlert = $injector.has('appAlert') && $injector.get('appAlert');
          if (appAlert) {
            returnedPromise = returnedPromise.catch(appAlert.modelError);
          }
          return returnedPromise;
        };
      });
    }

    //--------------------------------------------------------------------
    //
    // SERIALIZATION & DESERIALIZATION
    //
    //--------------------------------------------------------------------

    /**
     * Looks at all top-level Array properties. If the first child contains a numerical `position` property,
     * then we sort the array based on `position`
     * @param data
     */
    function sortOrderables(data) {
      if (Array.isArray(data)) {
        data.forEach(sortOrderables);
      } else {
        angular.forEach(data, function (prop) {
          if (Array.isArray(prop) && prop[0] && angular.isNumber(prop[0].position)) {
            prop.sort(function (a, b) {
              return a.position - b.position;
            });
            // recurse
            prop.forEach(sortOrderables);
          } else if (angular.isObject(prop)) {
            // recurse
            sortOrderables(prop);
          }
        });
      }
    }

    /**
     * Extracts data and attempts to replace dates
     * @param resource
     * @param resp
     * @returns {*} parsed and extracted data
     */
    function deserialize(resource, resp) {
      var body = resp && resp.data ? resp.data : resp;
      if (!body) return body;
      if (angular.isString(resource)) {
        resource = DS.definitions[resource];
      }

      var result = parseDates(body.data || body);
      sortOrderables(result);

      if (Array.isArray(result) && resp.config.responseDataCacheKey) {
        var responseDataCacheKey = resp.config.responseDataCacheKey;
        resource.$responseData = resource.$responseData || {};
        resource.$responseData[responseDataCacheKey] = angular.copy(body);
        resource.$responseData[responseDataCacheKey].params = angular.copy(resp.config.params);
      }

      var meta = body.meta;
      if (meta && !Array.isArray(result)) {
        if (resource.metaData) {
          angular.merge(resource.metaData, meta);
        } else {
          resource.metaData = meta;
        }
      }

      return result;
    }

    // handles the actual parsing of UI prefs
    function _parseUiPrefs(instance) {
      var uiPrefs = instance.uiPrefs;
      if (uiPrefs) {
        angular.forEach(uiPrefs, function (v, k) {
          try {
            uiPrefs[k] = JSON.parse(v);
          } catch (e) {
            delete uiPrefs[k];
          }
        });
      }
    }

    /**
     * Adds JSON parsing for uiPrefs field
     * @param resource
     * @param data
     * @returns {*}
     */
    function deserializeWithUiPrefs(resource, data) {
      var parsedData = deserialize(resource, data);
      if (angular.isArray(parsedData)) {
        parsedData.forEach(_parseUiPrefs);
      } else {
        _parseUiPrefs(parsedData);
      }
      return parsedData;
    }

    /**
     * Cleans an item of undesired properties before serialization
     * @param resource
     * @param data
     * @returns {*}
     */
    function cleanItemForSave(resource, data) {
      if (angular.isString(resource)) {
        resource = DS.definitions[resource];
      }
      var saved = void 0,
          notSaved = void 0,
          newData = void 0;
      data = angular.copy(data, {});
      if (resource.meta && resource.meta.saveIncludes) {
        saved = resource.meta.saveIncludes;
        newData = {};
        angular.forEach(data, function (val, id) {
          if (saved.indexOf(id) !== -1) {
            newData[id] = val;
          }
        });
        data = newData;
      } else if (resource.meta && resource.meta.saveExcludes) {
        notSaved = resource.meta.saveExcludes;
        newData = {};
        angular.forEach(data, function (val, id) {
          // do not include fields that are prefixed with _ or that are explicitly excluded
          if (id[0] !== '_' && notSaved.indexOf(id) === -1) {
            newData[id] = val;
          }
        });
        data = newData;
      }
      // recursively clean relationships
      angular.forEach(resource.relationList, function (rel) {
        var local = rel.localField;
        if (local && data[local]) {
          if (rel.type === 'hasMany') {
            var acc = [];
            angular.forEach(data[local], function (val, i) {
              acc[i] = cleanItemForSave(rel.relation, val);
            });
            data[local] = acc;
          } else {
            data[local] = cleanItemForSave(rel.relation, data[local]);
          }
        }
      });
      return data;
    }

    /**
     * Cleans item and encapsulates it. Angular or JSON.stringify handles dates for us.
     * @param resource
     * @param data
     * @returns {{data: *}} cleaned data
     */
    function serialize(resource, data) {
      return { data: cleanItemForSave(resource, data) };
    }

    /**
     * Adds JSON stringification for uiPrefs
     * @param resource
     * @param data
     * @returns {{data: *}}
     */
    function serializeWithUiPrefs(resource, data) {
      var out = serialize(resource, data);
      if (out.data.uiPrefs) {
        angular.forEach(out.data.uiPrefs, function (v, k) {
          return out.data.uiPrefs[k] = JSON.stringify(v);
        });
      }
      return out;
    }

    function afterInject(resource, data) {
      if (angular.isArray(data)) {
        data.forEach(function (d) {
          return afterInject(resource, d);
        });
      } else if (angular.isObject(data)) {
        angular.forEach(resource.relationList, function (rel) {
          var local = rel.localField;
          var $type = rel.$type || data.$type;
          var linked = typeof rel.link === 'boolean' ? rel.link : !!resource.linkRelations;
          if (!linked && local && $type === data.$type && data[local]) {
            // inject any references
            data[local] = DS.inject(rel.relation, data[local]);
          }
        });

        if (resource.meta.cleanInjected) {
          resource.meta.cleanInjected(data);
        }

        if (resource.meta.hasDigest && !data.digest) {
          // insert dummy digest if this model usually has one
          data.digest = {};
        }
      }
    }

    function _addDefaultValues(config) {
      var defaults = config.meta.defaults;
      ['afterInject', 'afterCreateInstance'].forEach(function (method) {
        var oldMethod = config[method];
        config[method] = function setDefaultsAfter(resource, items) {
          if (!Array.isArray(items)) items = [items];
          items.forEach(function (item) {
            angular.forEach(defaults, function (val, k) {
              if (item[k] === undefined) {
                item[k] = angular.copy(val);
              }
            });
          });
          if (oldMethod) {
            oldMethod(resource, items);
          }
        };
      });
    }

    //--------------------------------------------------------------------
    //
    // DEFAULT CONFIGURATION: Default properties for model configs
    //
    //--------------------------------------------------------------------

    var _defaultConfig = {
      deserialize: deserialize,

      serialize: serialize,

      afterInject: afterInject
    };

    //--------------------------------------------------------------------
    //
    // PRIMARY METHODS
    //
    //--------------------------------------------------------------------

    /**
     * Defines a resource using the ModelHelper improvements.
     * @param config
     * @returns {*}
     */
    function defineResource(config) {
      var Model = void 0;

      config = angular.extend({ meta: {}, methods: {} }, _defaultConfig, config);

      // Add a specialized method in for retrieving the value of enumerated properties
      config.methods.getEnum = function (name, property) {
        var key = pluck(property || name, this);
        if (key) {
          return Model.getEnum(name, key);
        } else {
          return '';
        }
      };

      if (config.cleanAfterDestroy) {
        var _config$cleanAfterDes = config.cleanAfterDestroy,
            parent = _config$cleanAfterDes.parent,
            collection = _config$cleanAfterDes.collection;

        config.afterEject = config.afterDestroy = cleanDestroyed(parent, collection);
        delete config.cleanAfterDestroy;
      }

      if (config.meta.actionEndpoints) {
        _addActionEndpoints(config);
      }

      if (config.meta.defaults) {
        _addDefaultValues(config);
      }

      /**
       * Returns a cloned instance of this model.
       *
       * First, this flattens the prototype chain, to ensure we're getting a deep copy of all the properties.
       * This is specifically used for solution-review-dialog, which uses a prototype chain to make shallow
       * changes for playback. Then angular.copy is used to create a deep copy of the model.
       *
       * Finally, we use Model.createInstance to create a new instance of the flattened, cloned data.
       *
       * Just using `Model.createInstance(this)` would only create a shallow copy, and would also
       * lose properties set higher up the prototype chain.
       *
       * @returns {*} Deep, flattened clone of this model.
       */
      config.methods.$clone = function () {
        var dataFlattened = flattenPrototypeChain(this, Model);
        var dataCopy = angular.copy(dataFlattened);
        return Model.createInstance(dataCopy);
      };

      if (config.meta.types) {
        Model = _defineTypedResource(config);
      } else {
        Model = DS.defineResource(config);
      }

      Model.$dsModel = config.name;

      _addModelChangedEvents(config, Model);

      if (config.staticMethods) {
        angular.extend(Model, config.staticMethods);
      }

      // Monkey Patch to prevent errors when checking hasChanges on new models
      Model.hasChanges = function (model) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        if (model && !model.id) return true;
        return DS.hasChanges.apply(DS, [config.name, model].concat(args));
      };

      $rootScope.$on('app.logout', function () {
        delete Model.meta.$$didFindMissing;
      });

      return Model;
    }

    /**
     * Fix for js-data items no longer being cleaned up after removal.
     * This looks for any parents that might be referencing the given
     * resource item, and updates their collection
     * @param parent
     * @param collection
     */
    function cleanDestroyed(parent, collection) {
      return function (resource, data) {
        if (angular.isArray(data)) {
          data.forEach(cleanDestroyed);
        } else {
          DS.definitions[parent].getAll().forEach(function (p) {
            if (p[collection]) {
              var idx = p[collection].findIndex(function (ci) {
                return ci.id === data.id;
              });
              if (idx > -1) {
                p[collection].splice(idx, 1);
              }
            }
          });
        }
        return $q.when(data);
      };
    }

    /**
     * Defines a typed resource, that includes type-specific functionality.
     *
     * @param config
     * @returns {*}
     */
    function _defineTypedResource(config) {
      // auto type items
      function asType(instance) {
        if (instance && instance.$type && instance.$asType) {
          instance.$asType();
        }
      }

      ['afterInject', 'afterCreateInstance'].forEach(function (method) {
        var oldMethod = config[method];
        config[method] = function typedResourceAfter(options, instance) {
          if (Array.isArray(instance)) {
            instance.forEach(asType);
          } else {
            asType(instance);
          }
          if (oldMethod) {
            oldMethod(options, instance);
          }
        };
      });

      config.methods = config.methods || {};

      // provide the ability to "import" sub-typed methods into the instance
      config.methods.$asType = function () {
        if (!this.hasOwnProperty('$$typed') && this.$type) {
          defineValue(this, '$$typed', true);
          var self = this;
          angular.forEach(config.meta.types[this.$type], function (value, key) {
            if (key === 'afterTyped') return;
            if (key === 'computed') {
              Object.defineProperties(self, value);
            } else {
              defineValue(self, key, value);
            }
          });
          if (config.meta.types[this.$type].afterTyped) {
            config.meta.types[this.$type].afterTyped(this);
          }
        }

        return this;
      };

      return DS.defineResource(config);
    }

    function _createDefineQuickList(autolist) {
      // special case to load in a list for quick lookups
      return function defineQuickList(Model, findAllProps) {
        var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
            sort = _ref.sort;

        lazyProperty(Model, 'quickList', function () {
          var loaded = false;
          var lookup = {};
          var updateList = function updateList(list) {
            // mixin any existing items
            Model.getAll().forEach(function (instance) {
              var idx = list.findIndex(function (v) {
                return v.id === instance.id;
              });
              if (idx > -1) {
                list[idx] = instance;
              } else {
                list.push(instance);
              }
            });
            lookup = {};
            list.forEach(function (item) {
              lookup[item.id] = item;
            });
            return list;
          };
          var quickList = autolist.create(function (options) {
            if (loaded) {
              var list = quickList.slice();
              // remove any destroyed items
              var event = options.event;
              if (event && event.type === 'destroyed' && event.data) {
                removeMatching(list, function (v) {
                  return v.id === event.data.id;
                });
              }
              return updateList(list);
            } else {
              // asynchronously load the list
              return Model.retrieveAll(angular.extend({
                quickList: true,
                orderBy: 'id ASC',
                per: 1000
              }, findAllProps), { cacheResponse: false, bypassCache: true }).then(function (list) {
                loaded = true;
                return updateList(list);
              });
            }
          }, Model);
          if (sort) {
            quickList.autoSort(sort);
          }
          quickList.listen();
          quickList.get = function (id) {
            return lookup[id];
          };
          return quickList;
        });
      };
    }

    return {
      defineResource: defineResource,
      deserialize: deserialize,
      deserializeWithUiPrefs: deserializeWithUiPrefs,
      serialize: serialize,
      serializeWithUiPrefs: serializeWithUiPrefs,
      afterInject: afterInject,
      saveEmbedded: _createSaveEmbedded($q),
      defineQuickList: _createDefineQuickList(autolist)
    };
  }]);

  var challengeItemModelModule = angular.module('Q.models.challenge-item', [modelHelperModule]).factory('ChallengeItem', ['DS', 'ModelHelper', '$q', '$injector', function (DS, ModelHelper, $q, $injector) {
    return ModelHelper.defineResource({
      name: 'ChallengeItem',
      endpoint: 'challenge_items',

      cleanAfterDestroy: {
        parent: 'Assessment',
        collection: 'challengeItems'
      },

      methods: {
        getChallenge: function getChallenge() {
          var promise = void 0;

          if (this.challenge) {
            promise = $q.when(this.challenge);
          } else if (this.challengeId && isLoggedIn($injector)) {
            promise = DS.definitions.Challenge.fetch(this.challengeId, {
              params: { includes: ['sourced_from'] }
            });
          } else {
            promise = $q.when(null);
          }
          return promise.then(function (c) {
            return c && c.loadSourcedFrom();
          }).catch(function () {
            return null;
          });
        },
        availableLanguages: function availableLanguages() {
          var _this = this;

          // get a list of all available challenge languages that aren't filtered out
          return this.challenge.getLanguages().filter(function (lang) {
            return !_this.disabledLanguages.includes(lang.id);
          });
        }
      },

      staticMethods: {
        /**
         * Loads all missing challenges in a given array of challengeItems
         *
         * @param {Array} challengeItems
         * @returns {Promise} promise upon completion with the challengeItems
         */
        loadMissingChallenges: function loadMissingChallenges(challengeItems) {
          // don't look up challenges on reports
          if (appConfig.appId === 'reports') {
            return $q.resolve(challengeItems);
          }

          var challengeIds = [];
          var missingIdsMap = {};
          var Challenge = DS.definitions.Challenge;
          challengeItems.forEach(function (ci) {
            if (!ci.challenge && ci.challengeId) {
              var c = Challenge.get(ci.challengeId);
              if (!c) {
                if (!missingIdsMap[ci.challengeId]) {
                  challengeIds.push(ci.challengeId);
                  missingIdsMap[ci.challengeId] = [ci];
                } else {
                  missingIdsMap[ci.challengeId].push(ci);
                }
              } else {
                // grab sourced from in the same load if we need it
                if (!c.sourcedFrom && c.sourcedFromId) {
                  challengeIds.push(c.sourcedFromId);
                }
              }
            }
          });

          var promise = void 0;

          if (challengeIds.length) {
            promise = DS.definitions.Challenge.findAll({
              where: { id: { in: challengeIds } },
              includes: ['sourced_from']
            }).then(function (challenges) {
              challenges.forEach(function (c) {
                missingIdsMap[c.id].forEach(function (ci) {
                  return ci.challenge = c;
                });
              });
              return challengeItems;
            });
          } else {
            promise = $q.resolve(challengeItems);
          }

          return promise
          // load missing copied from (for stats)
          .then(function (cis) {
            return Challenge.loadSourcedFrom(cis.map(function (ci) {
              return ci.challenge;
            }).filter(angular.identity));
          }).then(function () {
            return challengeItems;
          });
        }
      },

      relations: {
        hasOne: {
          Challenge: {
            localField: 'challenge',
            localKey: 'challengeId'
          }
        }
      },

      meta: {
        saveExcludes: ['challenge']
      }
    });
  }]);

  var _BASE_TYPES, _DEFAULT_OPTS;

  var TEXT_QUESTION = 'QuizTextQuestion';
  var WEIGHTED_CHOICE_QUESTION = 'QuizWeightedChoiceQuestion';

  var BASE_TYPES = (_BASE_TYPES = {}, defineProperty(_BASE_TYPES, TEXT_QUESTION, 'text'), defineProperty(_BASE_TYPES, WEIGHTED_CHOICE_QUESTION, 'multiple-choice'), _BASE_TYPES);

  // used to configure default options before injection
  var DEFAULT_OPTS = (_DEFAULT_OPTS = {}, defineProperty(_DEFAULT_OPTS, TEXT_QUESTION, {
    subtype: 'short',
    language: 'text',
    lengthValidation: {
      enabled: false,
      expectedLength: 0
    }
  }), defineProperty(_DEFAULT_OPTS, WEIGHTED_CHOICE_QUESTION, {
    shuffle: false,
    automax: true,
    autosum: true
  }), _DEFAULT_OPTS);

  var TEXT_SUBTYPES_ORDERED = [{ id: 'short', label: 'Short Answer' }, { id: 'lplain', label: 'Long Answer (Plain Text)' }, { id: 'long', label: 'Long Answer (Markdown-Enabled)' }, { id: 'essayplain', label: 'Essay (Plain Text)' }, { id: 'essay', label: 'Essay (Markdown-Enabled)' }, { id: 'scode', label: 'Code (Short)' }, { id: 'lcode', label: 'Code (Multiline)' }];

  var TEXT_SUBTYPES = {};
  TEXT_SUBTYPES_ORDERED.forEach(function (t) {
    TEXT_SUBTYPES[t.id] = t.label;
  });

  var MC_SUBTYPES = {
    mcma: 'Multiple Choice (Multiple Answer)',
    mcsa: 'Multiple Choice (Single Answer)'
  };

  var INPUT_TYPE_MAP = {
    short: 'text',
    lplain: 'text',
    long: 'markdown',
    essayplain: 'text',
    essay: 'markdown',
    scode: 'code',
    lcode: 'code',
    mcma: 'checkbox',
    mcsa: 'radio'
  };

  var MATCHER_LABELS = {
    includes: 'Includes Text',
    includesIncorrect: 'Should Include Text',
    notincludes: 'Excludes Text',
    notincludesIncorrect: 'Should Exclude Text',
    exact: 'Equals Exactly',
    exactIncorrect: 'Should Equal',
    notexact: 'Does Not Equal',
    notexactIncorrect: 'Should Not Equal',
    regex: 'Matches Pattern',
    regexIncorrect: 'Should Match Pattern',
    notregex: 'Does Not Match Pattern',
    notregexIncorrect: 'Should Not Match Pattern'
  };

  function cleanUpQuizQuestion(instance) {
    if (instance.$type === 'QuizMultipleChoiceQuestion' && instance.choices && angular.isString(instance.choices[0])) {
      // convert to new weighted format
      // if this question is saved, it'll get replaced at that time, otherwise we'll just pretend it's been updated locally
      instance.$type = WEIGHTED_CHOICE_QUESTION;
      instance.choices = instance.choices.map(function (c) {
        return {
          label: c,
          value: 0 // TODO: determine default non-answer value?
        };
      });
      instance.maxSum = 0;
      if (instance.answers) {
        instance.answers.forEach(function (a) {
          return instance.choices[+a].value = 1;
        });
        instance.maxSum = instance.answers.length;
        delete instance.answers;
      }
    }

    // handle case swaps in options, because the API doesn't
    var opts = instance.options = instance.options || {};
    Object.keys(opts).forEach(function (k) {
      if (/_/.test(k)) {
        opts[camelCase(k)] = opts[k];
        delete opts[k];
      }
    });

    angular.forEach(DEFAULT_OPTS[instance.$type] || {}, function (v, k) {
      if (opts[k] === undefined) {
        opts[k] = angular.copy(v);
      }
    });

    if (instance.$type === WEIGHTED_CHOICE_QUESTION) {
      instance.weightedScoring = instance.weightedScoring || false;
    }

    return instance;
  }

  var quizQuestionModelModule = angular.module('Q.models.quiz-question', [modelHelperModule]).factory('QuizQuestion', ['ModelHelper', '$filter', '$injector', function (ModelHelper, $filter, $injector) {
    var QuizQuestion = ModelHelper.defineResource({
      name: 'QuizQuestion',
      endpoint: 'quiz_questions',

      cleanAfterDestroy: {
        parent: 'Challenge',
        collection: 'questions'
      },

      // Convert API-style answers into something we can work on locally
      beforeInject: function QuizQuestion$beforeInject(resource, instances) {
        if (!Array.isArray(instances)) {
          instances = [instances];
        }
        instances.forEach(cleanUpQuizQuestion);
      },
      // Convert local formatted answers into API-style
      serialize: function serialize(resource, data) {
        // TODO: always include the $type!
        QuizQuestion.syncChoices(data);
        return ModelHelper.serialize(resource, data);
      },


      methods: {
        baseType: function baseType() {
          return BASE_TYPES[this.$type];
        },
        isText: function isText() {
          return this.$type === TEXT_QUESTION;
        },
        isMultipleChoice: function isMultipleChoice() {
          return this.$type === WEIGHTED_CHOICE_QUESTION;
        },
        baseTypeLabel: function baseTypeLabel() {
          if (this.isText()) {
            return 'Free Text Question';
          } else if (this.isMultipleChoice()) {
            return 'Multiple Choice Question';
          }
          return 'Question';
        },
        answerType: function answerType() {
          if (this.isText()) {
            return this.options.subtype || 'short';
          } else if (this.isMultipleChoice()) {
            return this.maxSelections === 1 ? 'mcsa' : 'mcma';
          }
        },
        answerTypeLabel: function answerTypeLabel() {
          if (this.isCode()) {
            return this.languageLabel() + TEXT_SUBTYPES[this.answerType()];
          } else if (this.isText()) {
            return TEXT_SUBTYPES[this.answerType()];
          } else if (this.isMultipleChoice()) {
            return MC_SUBTYPES[this.answerType()];
          }
        },
        hasLanguage: function hasLanguage() {
          var lang = this.options.language;
          return !!lang && lang !== 'text' && !!languages[lang];
        },
        editorLanguage: function editorLanguage() {
          if (this.isCode()) {
            return this.options.language || 'text';
          } else {
            return this.isMultiline() ? 'markdown' : 'text';
          }
        },
        languageLabel: function languageLabel() {
          var lang = this.options.language || '';
          if (lang) {
            lang = languages.toName(lang) + ' ';
          }
          return lang;
        },
        inputType: function inputType() {
          return INPUT_TYPE_MAP[this.answerType()] || 'text';
        },
        isAnswerType: function isAnswerType() {
          for (var _len = arguments.length, types = Array(_len), _key = 0; _key < _len; _key++) {
            types[_key] = arguments[_key];
          }

          return types.includes(this.answerType());
        },
        isPlain: function isPlain() {
          return this.isAnswerType('short', 'lplain', 'essayplain');
        },
        isMarkdown: function isMarkdown() {
          return this.isAnswerType('long', 'essay');
        },
        isMultiline: function isMultiline() {
          return this.isEssay() || this.isAnswerType('long', 'lcode');
        },
        isEssay: function isEssay() {
          return this.isAnswerType('essay', 'essayplain');
        },
        isCode: function isCode() {
          return this.isAnswerType('scode', 'lcode');
        },
        isMultipleAnswer: function isMultipleAnswer() {
          return this.answerType() === 'mcma';
        },
        isAnswer: function isAnswer(index, solution) {
          if (solution && solution.values) {
            return solution.values.indexOf(index) > -1;
          } else {
            return this.choices[index].value > 0;
          }
        },
        isCorrect: function isCorrect(index, solution) {
          if (!solution) return false;
          return solution.score >= 100 || this.isAnswer(index) === this.isAnswer(index, solution);
        },
        maxAnswers: function maxAnswers() {
          var question = this;
          if (question.isMultipleChoice()) {
            return question.choices.filter(function (a) {
              return a.value > 0;
            }).length;
          } else if (question.isText()) {
            return (question.matchers || []).length;
          }
        },
        maxCorrectSum: function maxCorrectSum() {
          return this.choices.map(function (c) {
            return c.value;
          }).filter(function (v) {
            return v > 0;
          }).sort(function (a, b) {
            return b - a;
          }).slice(0, this.maxSelections || 1).reduce(function (a, b) {
            return a + b;
          }, 0);
        },
        maxWeight: function maxWeight() {
          return this.choices.map(function (c) {
            return c.value;
          }).filter(function (v) {
            return v > 0;
          }).sort(function (a, b) {
            return b - a;
          })[0] || 0;
        },
        shouldDisable: function shouldDisable(solutionAnswers, $index) {
          solutionAnswers = solutionAnswers || {};
          var remaining = Math.max(0, this.updateMaxSelections() - (solutionAnswers.values || []).length);
          var selected = (solutionAnswers.$mcmaValues || [])[$index];
          return !remaining && !selected;
        },
        updateMaxSelections: function updateMaxSelections(force) {
          var question = this;
          if (!question.isMultipleChoice()) return question.maxSelections;

          if (force || !question.maxSelections) {
            var totalAnswers = (question.choices || []).length;
            if (question.options.automax === 'all') {
              question.maxSelections = totalAnswers;
            } else if (question.options.automax) {
              question.maxSelections = question.maxAnswers();
            }
            // ensure we don't an invalid selection
            question.maxSelections = Math.max(1, Math.min(question.maxSelections, totalAnswers));
          }

          return question.maxSelections;
        },
        remainingSelectionsMessage: function remainingSelectionsMessage(solutionAnswers) {
          solutionAnswers = solutionAnswers || {};
          var maxSelections = this.updateMaxSelections();
          var remaining = Math.max(0, maxSelections - (solutionAnswers.values || []).length);
          var msg = 'Max allowed answers selected';
          if (maxSelections === this.choices.length) {
            msg = 'Choose all correct answers below';
          } else if (remaining === maxSelections) {
            msg = 'Choose up to <strong>' + remaining + '</strong> answers below';
          } else if (remaining > 0) {
            msg = 'Choose up to <strong>' + remaining + '</strong> more answer' + (remaining === 1 ? '' : 's');
          }
          return msg;
        },
        updateMaxSum: function updateMaxSum(force) {
          var question = this;
          if (question.isMultipleChoice() && (force || !question.maxSum)) {
            if (question.options.autosum === 'highest') {
              question.maxSum = question.maxWeight();
            } else if (question.options.autosum) {
              question.maxSum = question.maxCorrectSum();
            }
            // ensure we don't an invalid selection
            question.maxSum = Math.max(0, question.maxSum || 0);
          }
          return question.maxSum;
        },
        optionsSummary: function optionsSummary(challenge, answer) {
          var numFilter = $injector.has('fuzzyNumberFilter') ? $filter('fuzzyNumber') : $filter('number');
          var summary = [];
          var self = this;
          var weight = angular.isNumber(+self.weight) ? +self.weight : 1;
          var score = '';
          if (weight === 0) {
            score = 'Not scored';
          } else {
            if (answer) {
              if (answer.values.length) {
                // Calculate length score if not present

                if (self.options.lengthValidation && self.options.lengthValidation.enabled) {
                  var answerText = answer.values[0] || '';
                  answer.lengthScore = self.calculateLengthScore(answerText);
                }
                var lengthScore = answer.lengthScore || 0; // Already between 0-1
                var accuracyScore = (answer.accuracyScore || 0) / 100; // Convert from percentage to 0-1

                // Calculate final score based on whether length validation is enabled
                var finalScore = void 0;
                if (self.options.lengthValidation && self.options.lengthValidation.enabled) {
                  finalScore = (accuracyScore + lengthScore) / 2; // Average of both scores
                } else {
                  finalScore = accuracyScore;
                }

                if (self.options.lengthValidation && self.options.lengthValidation.enabled) {
                  score = numFilter(finalScore * weight) + ' out of ' + numFilter(weight) + ' point' + (weight === 1 ? '' : 's') + ' (Matchers: ' + numFilter(accuracyScore * 100) + '%, Length: ' + numFilter(lengthScore * 100) + '%)';
                } else {
                  score = numFilter(finalScore * weight) + ' out of ' + numFilter(weight) + ' point' + (weight === 1 ? '' : 's');
                }
              } else {
                score = 'Not Answered';
              }
            } else {
              score = numFilter(weight) + ' point' + (weight === 1 ? '' : 's');
            }

            if (answer && challenge.isQuestionTimed() && answer.timeTakenSec) {
              score += ' (answered in ' + answer.timeTakenSec + 's)';
            }
          }

          summary.push(score);

          if (!challenge.isBonusTimed() && self.maxAnswers() > 1 && weight !== 0) {
            if (self.allOrNothing) {
              summary.push('no partial credit');
            } else {
              summary.push('with partial credit');
            }
          }

          if (self.isMultipleChoice()) {
            var sel = self.updateMaxSelections();
            var weighted = self.weightedScoring ? ' weighted' : '';
            if (sel === 1) {
              summary.push('single' + weighted + ' answer');
            } else {
              summary.push('select up to ' + sel + weighted + ' answers');
            }
          }

          if (self.options.lengthValidation && self.options.lengthValidation.enabled) {
            var actualLength = answer && answer.values.length > 0 ? answer.values[0].length : 0;
            summary.push('length: ' + actualLength + '/' + self.options.lengthValidation.expectedLength);
          }

          if (challenge.isQuestionTimed()) {
            var limit$$1 = self._timeLimitSec(challenge);
            if (limit$$1) {
              summary.push(limit$$1 + 's time limit');
              if (challenge.isBonusTimed()) {
                summary.push('bonus countdown at ' + self._timeLimitStartSec(challenge) + 's');
              }
            }
          }

          if (!answer && self.isText()) {
            summary.push((self.defaultValue ? 'with' : 'no') + ' default answer');
          }

          return summary.join(', ');
        },
        _timeLimitSec: function _timeLimitSec(challenge) {
          return this.timeLimitSec || challenge.questionTimeLimitSec;
        },
        _timeLimitStartSec: function _timeLimitStartSec(challenge) {
          return angular.isNumber(this.timeLimitStartSec) ? this.timeLimitStartSec : challenge.questionTimeLimitStartSec || 0;
        },
        matcherTest: function matcherTest() {
          if (!this.$matcherTest) {
            defineValue(this, '$matcherTest', {
              open: false,
              text: '',
              notes: {}
            });
          }
          return this.$matcherTest;
        },
        calculateLengthScore: function calculateLengthScore(answer) {
          if (!this.options.lengthValidation || !this.options.lengthValidation.enabled) {
            return 1;
          }

          var expectedLength = this.options.lengthValidation.expectedLength;

          if (expectedLength <= 0) {
            return 1;
          }

          // Handle both string input and answer object with values array
          var answerText = '';
          if (typeof answer === 'string') {
            answerText = answer;
          } else if (answer && answer.values && answer.values.length > 0) {
            answerText = answer.values[0];
          }

          var actualLength = answerText.length;

          return Math.min(1, actualLength / expectedLength);
        },
        getFinalScore: function getFinalScore(answer, ruleScore) {
          if (!this.options.lengthValidation || !this.options.lengthValidation.enabled) {
            return ruleScore;
          }

          var lengthScore = this.calculateLengthScore(answer);
          return (lengthScore + ruleScore) / 2;
        }
      },

      staticMethods: {
        getMatcherLabel: function getMatcherLabel(item, result) {
          var k = (item.negate ? 'not' : '') + (item.type || 'regex') + (result && !result.correct ? 'Incorrect' : '');
          return MATCHER_LABELS[k];
        },
        syncChoices: function syncChoices(question) {
          if (question.choices && question.maxSelections > question.choices.length) {
            // revert to the default
            question.maxSelections = null;
          }
        }
      },

      relations: {},

      meta: {}
    });

    return QuizQuestion;
  }]);

  function getFileLanguage(file) {
    if (!file || !file.path) return '';
    var lang = languages.langFromFilename(file.path);
    return lang ? lang.id : getExtension(file.path);
  }

  function splitPath(path) {
    path = path || '';
    // clean up and split path
    var pathParts = path.replace(/^\/+|\/+$/g, '').split('/');
    var filename = pathParts.pop();
    return { pathParts: pathParts, filename: filename };
  }

  /**
   * Converts a layout string to layout properties
   * @see layoutString
   * @param {string} layout
   * @returns {{tabindex: number, active: boolean, tabset: string}}
   */
  var layoutProps = function layoutProps(layout) {
    var _ref = layout && layout.match(/^(\w+):(\d+)(?::(\d))?/) || [],
        _ref2 = slicedToArray(_ref, 4),
        tabset = _ref2[1],
        tabindex = _ref2[2],
        active = _ref2[3];

    return { tabset: tabset, tabindex: +tabindex, active: !!+active };
  };

  /**
   * Configures a file with initial layout data
   * @param {CodeFile} file - File to configure
   * @param {boolean} always - If true, always override the file's layout data
   * @param {boolean} lockedLayout - If true, set the file's layout data if missing
   * @param {string?} initialLayout - Layout data, usually provided by file.initialLayout. {@see layoutString} for more details
   */
  var configureInitiallyOpenFile = function configureInitiallyOpenFile(_ref4) {
    var file = _ref4.file,
        always = _ref4.always,
        lockedLayout = _ref4.lockedLayout,
        _ref4$initialLayout = _ref4.initialLayout,
        initialLayout = _ref4$initialLayout === undefined ? file.initialLayout : _ref4$initialLayout;

    var _layoutProps = layoutProps(file.hidden ? '' : initialLayout),
        tabset = _layoutProps.tabset,
        tabindex = _layoutProps.tabindex,
        active = _layoutProps.active;
    // save default tabset if available


    file.lastTabset = tabset || file.lastTabset || file.defaultTabset;
    file.defaultTabset = tabset;
    file.defaultTabindex = tabindex;
    file.defaultActive = active;
    if (always || lockedLayout && !file.tabset && tabset) {
      file.tabset = tabset;
      file.tabindex = tabindex;
      file.active = active;
    }
  };

  var SOLUTION_FILE_CHANGE_KEYS = ['path', 'contents', 'cursor'];
  var SOLUTION_FILE_COPY_KEYS = ['id', 'challengeFileId', 'access', 'deletable', 'directory', 'includeOnSubmit', 'includeOnTest', 'testGroups', 'initialLayout', 'field', 'isClassicCode'].concat(SOLUTION_FILE_CHANGE_KEYS);

  function addOptionProperties(modelConfig, props) {
    props.forEach(function (prop) {
      var optionKeySafe = prop.toLowerCase();
      modelConfig.computed[prop] = {
        get: function get$$1() {
          return (this.options || {})[optionKeySafe];
        },
        set: function set$$1(val) {
          this.options = this.options || {};
          this.options[optionKeySafe] = val;
        },

        enumerable: false
      };
    });
  }

  function addHiddenProperties(modelConfig, props) {
    props.forEach(function (prop) {
      modelConfig.computed[prop] = {
        get: function get$$1() {
          return (this.$hidden || {})[prop];
        },
        set: function set$$1(val) {
          if (!this.$hidden) {
            defineValue(this, '$hidden', {});
          }
          this.$hidden[prop] = val;
        },

        enumerable: false
      };
    });
  }

  var codeFileModelModule = angular.module('Q.models.code-file', [modelHelperModule]).factory('CodeFile', ['ModelHelper', function (ModelHelper) {
    // shared functions for CodeFiles
    function define(modelConfig) {
      // property getters & setters
      addOptionProperties(modelConfig, ['collapsed', 'tabset', 'tabindex', 'active', 'closeable']);
      addHiddenProperties(modelConfig, ['$deleted', 'defaultTabset', 'defaultTabindex', 'defaultActive', 'lastTabset', 'ignored', 'parentAccess', 'tabClasses', '$readOnly', 'selections', '$interact', '$hideFromInteract']);

      var computed = modelConfig.computed;

      if (!computed.readOnly) {
        computed.readOnly = {
          get: function get$$1() {
            return this.$deleted;
          }
        };
      }
      computed.$markdown = {
        get: function get$$1() {
          return (/\.(md|mark(down)?)$/.test(this.path)
          );
        }
      };
      computed.$markdownReadOnly = {
        get: function get$$1() {
          return this.$markdown && this.$type === 'AdvancedCodeSolutionFile' && this.$access && this.$access !== 'readwrite' && !this.$interact;
        }
      };
      computed.$access = {
        get: function get$$1() {
          var access = this.$interactMode ? 'readwrite' : this.access;
          if (access !== 'hidden') {
            var parentAccess = this.parentAccess;
            var parentHiding = parentAccess === 'restricted' || parentAccess === 'hidden';
            if (parentHiding) {
              // allows the parent access level to override this access level
              access = 'hidden';
            } else if (parentAccess === 'readonly' && access === 'readwrite' && this.directory) {
              access = 'readonly';
            }
          }
          return access;
        },
        set: function set$$1(val) {
          // set the requested value, even though we may end up with something different based
          // on parent rules
          this.access = val;
        }
      };
      computed.$deletable = {
        get: function get$$1() {
          var deletable = this.deletable || false;
          if (deletable) {
            var parentAccess = this.parentAccess;
            if (parentAccess && parentAccess !== 'readwrite') {
              deletable = false;
            }
          }
          return deletable;
        },
        set: function set$$1(val) {
          // set the requested value, even though we may end up with something different based
          // on parent rules
          this.deletable = val;
        }
      };
      computed.language = {
        get: function get$$1() {
          return getFileLanguage(this);
        }
      };

      modelConfig.afterCreateInstance = function (resource, files) {
        if (!Array.isArray(files)) files = [files];
        files.forEach(function (file) {
          file.$type = modelConfig.name;
        });
      };

      return ModelHelper.defineResource(modelConfig);
    }

    return {
      define: define,
      configureAccessLevels: function configureAccessLevels(files) {
        var parentRules = {};
        files.slice()
        // sorting ensures we'll go through them in the right order
        .sort(function (a, b) {
          return compareIgnoreCase(a.path, b.path);
        }).forEach(function (f) {
          f.parentAccess = null;
          // try to set the parent access if there is any
          var parentPath$$1 = splitPath(f.path).pathParts;
          while (parentPath$$1.length) {
            var parentAccess = parentRules[parentPath$$1.join('/')];
            if (parentAccess) {
              f.parentAccess = parentAccess;
              break;
            }
            parentPath$$1.pop();
          }
          // store the new $access (based on parent access)
          parentRules[f.path] = f.$access;
        });
      }
    };
  }]).factory('AdvancedCodeChallengeFile', ['CodeFile', function (CodeFile) {
    var modelConfig = {
      name: 'AdvancedCodeChallengeFile',
      endpoint: 'advanced_code_challenge_files',

      cleanAfterDestroy: {
        parent: 'Challenge',
        collection: 'files'
      },

      meta: {
        defaults: {
          access: 'readwrite',
          accessLocked: false,
          codeSimilarity: false,
          contents: '',
          deletable: true,
          directory: false,
          includeOnSubmit: true,
          includeOnTest: true,
          initialLayout: null,
          options: {},
          path: '',
          testGroups: []
        }
      },

      computed: {
        candidateCanOpen: {
          get: function get$$1() {
            return this.$access === 'readwrite' || this.$access === 'readonly';
          }
        }
      },
      methods: {}
    };

    addHiddenProperties(modelConfig, ['hasReference', 'wasDeletable']);

    return CodeFile.define(modelConfig);
  }]).factory('AdvancedCodeChallengeReferenceFile', ['CodeFile', function (CodeFile) {
    var modelConfig = {
      name: 'AdvancedCodeChallengeReferenceFile',
      endpoint: 'advanced_code_challenge_reference_files',

      cleanAfterDestroy: {
        parent: 'Challenge',
        collection: 'referenceFiles'
      },

      meta: {
        defaults: {
          contents: '',
          directory: false,
          options: {},
          path: '',
          testGroups: []
        }
      },

      computed: {},
      methods: {
        reference: true
      }
    };

    addHiddenProperties(modelConfig, ['hasReference', 'notAllowed']);

    return CodeFile.define(modelConfig);
  }]).factory('AdvancedCodeSolutionFile', ['DS', 'CodeFile', function (DS, CodeFile) {
    var modelConfig = {
      name: 'AdvancedCodeSolutionFile',
      endpoint: 'advanced_code_solution_files',

      cleanAfterDestroy: {
        parent: 'Solution',
        collection: 'files'
      },

      computed: {
        interactId: {
          get: function get$$1() {
            if (this.field) {
              return this.field + '.' + getExtension(this.path);
            } else {
              return this.path;
            }
          }
        },
        hidden: {
          get: function get$$1() {
            return !this.$reviewMode && this.$access === 'hidden';
          }
        },
        disabled: {
          get: function get$$1() {
            return !this.$reviewMode && (this.$access === 'restricted' || this.$access === 'hidden');
          }
        },
        alwaysReadOnly: {
          get: function get$$1() {
            return this.$reviewMode || this.$deleted || this.$access !== 'readwrite';
          }
        },
        readOnly: {
          get: function get$$1() {
            return this.alwaysReadOnly || this.$readOnly;
          }
        },
        alwaysLocked: {
          get: function get$$1() {
            return this.disabled || this.alwaysReadOnly || this.lockedLayout || !this.$deletable;
          }
        },
        locked: {
          get: function get$$1() {
            return this.disabled || this.readOnly || this.lockedLayout || !this.$deletable;
          }
        },
        directoryLocked: {
          get: function get$$1() {
            return this.directory && (this.disabled || this.readOnly);
          }
        }
      },

      methods: {
        expirable: true,
        readWriteCopy: function readWriteCopy() {
          var file = this;
          var props = {
            options: {},
            // override read/write
            $hideFromInteract: file.$hideFromInteract || file.disabled,
            $interactMode: true
          };
          SOLUTION_FILE_COPY_KEYS.forEach(function (k) {
            props[k] = file[k];
          });
          var fileCopy = DS.createInstance('AdvancedCodeSolutionFile', props);
          if (this.isClassicCode) {
            // have to write back to parent model
            Object.defineProperty(fileCopy, 'contents', {
              get: function get$$1() {
                return file.contents;
              },
              set: function set$$1(val) {
                file.contents = val;
              }
            });
          }
          return fileCopy;
        },
        readOnlyCopy: function readOnlyCopy() {
          var _this = this;

          var props = {
            options: {},
            $reviewMode: true
          };
          SOLUTION_FILE_COPY_KEYS.forEach(function (k) {
            props[k] = _this[k];
          });
          return DS.createInstance('AdvancedCodeSolutionFile', props);
        },
        changesIgnored: function changesIgnored() {
          return this.restricted || this.includeOnSubmit && this.hasChallengeFile;
        },
        ignoredWarningTooltip: function ignoredWarningTooltip() {
          return 'You may edit this file for your own tests, but <strong>' + (this.changesIgnored() ? 'changes to this file are' : 'this file is') + ' not included when assessing your code.</strong><br>(Your edits will still be saved, and can be viewed by anyone reviewing your code.)';
        }
      },

      staticMethods: {
        /**
         * Returns a filtered and sorted list of files to initially show
         * @param {Array<CodeFile>} files - Files to filter and sort
         * @returns {Array<CodeFile>} - Filtered and sorted list
         */
        initialLayout: function initialLayout(files) {
          return files.filter(function (f) {
            return !f.directory && f.initialLayout && f.$access !== 'hidden' && f.$access !== 'restricted';
          }).sort(function (a, b) {
            // ensure readwrite files are opened before readonly
            return a.$access === b.$access ? compareIgnoreCase(a.path, b.path) : a.$access === 'readwrite' ? -1 : 1;
          });
        },


        /**
         * Configures the initial layout for each file
         * @param {Array<CodeFile>} files - Array of files
         * @param {boolean} always - If true, always set the layout, even if the file has a different one stored
         * @param {boolean} lockedLayout - If true, set the layout if missing from the file
         * @param {multiFileChallengeService} mfcs - Used to provide a default layout if we're missing all layouts
         * @returns {Array<CodeFile>}
         */
        configureInitialLayout: function configureInitialLayout(files) {
          var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              always = _ref5.always,
              lockedLayout = _ref5.lockedLayout,
              mfcs = _ref5.mfcs;

          var initialLayoutFiles = this.initialLayout(files);
          if (initialLayoutFiles.length === 0 && mfcs) {
            initialLayoutFiles = [mfcs.ideSettingsFile];
          }
          initialLayoutFiles.forEach(function (file) {
            configureInitiallyOpenFile({
              file: file,
              always: always,
              lockedLayout: lockedLayout
            });
          });
          return initialLayoutFiles;
        }
      },

      meta: {
        defaults: {
          access: 'readwrite',
          contents: '',
          deletable: true,
          directory: false,
          includeOnSubmit: true,
          includeOnTest: true,
          options: {},
          path: '',
          testGroups: []
        }
      }
    };

    addHiddenProperties(modelConfig, ['canReset', 'unchanged', 'ignored', 'restricted', 'hasChallengeFile', 'lockedLayout', '$interactMode']);

    return CodeFile.define(modelConfig);
  }]);

  function unwrapExports (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var nunit = createCommonjsModule(function (module, exports) {

      Object.defineProperty(exports, "__esModule", { value: true });
      exports.toFiles = void 0;
      var toFiles = function toFiles(_ref) {
          var solution = _ref.solution,
              tests = _ref.tests,
              preloaded = _ref.preloaded;

          var files = [{ path: "src/Solution.cs", contents: solution, source: "solution" }, { path: "tests/Fixture.cs", contents: tests, source: "tests" }];
          if (preloaded) {
              files.push({
                  path: "src/Preloaded.cs",
                  contents: preloaded,
                  source: "preloaded"
              });
          }
          return files;
      };
      exports.toFiles = toFiles;
      
  });

  unwrapExports(nunit);
  var nunit_1 = nunit.toFiles;

  var facade = createCommonjsModule(function (module, exports) {

      Object.defineProperty(exports, "__esModule", { value: true });
      exports.toFiles = void 0;

      var toFiles = function toFiles(ccc) {
          switch (ccc.testFramework) {
              case "nunit":
                  return (0, nunit.toFiles)(ccc);
              default:
                  throw new Error('Unknown test framework: ' + ccc.testFramework);
          }
      };
      exports.toFiles = toFiles;
      
  });

  unwrapExports(facade);
  var facade_1 = facade.toFiles;

  var csharp = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", { value: true });
    exports.nunit = exports.toFiles = void 0;

    Object.defineProperty(exports, "toFiles", { enumerable: true, get: function get() {
        return facade.toFiles;
      } });

    Object.defineProperty(exports, "nunit", { enumerable: true, get: function get() {
        return nunit.toFiles;
      } });
    
  });

  unwrapExports(csharp);
  var csharp_1 = csharp.nunit;
  var csharp_2 = csharp.toFiles;

  var test = createCommonjsModule(function (module, exports) {

      Object.defineProperty(exports, "__esModule", { value: true });
      exports.toFiles = void 0;
      var toFiles = function toFiles(_ref) {
          var solution = _ref.solution,
              tests = _ref.tests,
              preloaded = _ref.preloaded;

          var files = [{ path: "lib/solution.dart", contents: solution, source: "solution" }, { path: "test/solution_test.dart", contents: tests, source: "tests" }];
          if (preloaded) {
              files.push({
                  path: "lib/preloaded.dart",
                  contents: preloaded,
                  source: "preloaded"
              });
          }
          return files;
      };
      exports.toFiles = toFiles;
      
  });

  unwrapExports(test);
  var test_1 = test.toFiles;

  var facade$2 = createCommonjsModule(function (module, exports) {

      Object.defineProperty(exports, "__esModule", { value: true });
      exports.toFiles = void 0;

      var toFiles = function toFiles(ccc) {
          switch (ccc.testFramework) {
              case "test":
                  return (0, test.toFiles)(ccc);
              default:
                  throw new Error('Unknown test framework: ' + ccc.testFramework);
          }
      };
      exports.toFiles = toFiles;
      
  });

  unwrapExports(facade$2);
  var facade_1$1 = facade$2.toFiles;

  var dart = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", { value: true });
    exports.test = exports.toFiles = void 0;

    Object.defineProperty(exports, "toFiles", { enumerable: true, get: function get() {
        return facade$2.toFiles;
      } });

    Object.defineProperty(exports, "test", { enumerable: true, get: function get() {
        return test.toFiles;
      } });
    
  });

  unwrapExports(dart);
  var dart_1 = dart.test;
  var dart_2 = dart.toFiles;

  var utils = createCommonjsModule(function (module, exports) {

      Object.defineProperty(exports, "__esModule", { value: true });
      exports.getClassName = void 0;
      var getClassName = function getClassName(code, defaultClass) {
          // Check public class first because this must match the source file name and
          // a file can contain non-public classes
          var patterns = [/\bpublic\s+(?:(?:abstract|final|static)\s+)?class\s+([A-Za-z][A-Za-z\d_]*)/m, /\bpublic\s+record\s+([A-Za-z][A-Za-z\d_]*)/m, /\bpublic\s+?interface\s+([A-Za-z][A-Za-z\d_]*)/m, /\b(?:(?:abstract|final|static)\s+)?class\s+([A-Za-z][A-Za-z\d_]*)/m, /\brecord\s+([A-Za-z][A-Za-z\d_]*)/m, /\binterface\s+([A-Za-z][A-Za-z\d_]*)/m];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
              for (var _iterator = patterns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var pattern = _step.value;

                  var match = code.match(pattern);
                  if (match !== null) return getPrefix(code) + match[1];
              }
          } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
          } finally {
              try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                  }
              } finally {
                  if (_didIteratorError) {
                      throw _iteratorError;
                  }
              }
          }

          if (defaultClass) return defaultClass;
          throw new Error("Failed to detect class name:\n" + code);
      };
      exports.getClassName = getClassName;
      var getPrefix = function getPrefix(code) {
          var m = code.match(/^\s*package\s+(\S+);/m);
          return m === null ? "" : m[1] + ".";
      };
      
  });

  unwrapExports(utils);
  var utils_1 = utils.getClassName;

  var junit = createCommonjsModule(function (module, exports) {

      Object.defineProperty(exports, "__esModule", { value: true });
      exports.toFiles = void 0;

      var getPath = function getPath(code, defaultClass) {
          return (0, utils.getClassName)(code, defaultClass).replace(/\./g, "/");
      };
      var toFiles = function toFiles(_ref) {
          var solution = _ref.solution,
              tests = _ref.tests,
              preloaded = _ref.preloaded;

          var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              fallback = _ref2.fallback;

          var testsPath = getPath(tests, fallback ? "Tests" : "");
          var solutionPath = getPath(solution, fallback ? "Solution" : "");
          if (testsPath == solutionPath) {
              throw new Error("File Name Conflict: tests and solution");
          }
          var files = [{
              path: 'src/test/java/' + testsPath + '.java',
              contents: tests,
              source: "tests"
          }, {
              path: 'src/main/java/' + solutionPath + '.java',
              contents: solution,
              source: "solution"
          }];
          if (preloaded) {
              var preloadedPath = getPath(preloaded, fallback ? "Preloaded" : "");
              if (testsPath == preloadedPath) {
                  throw new Error("File Name Conflict: tests and preloaded");
              }
              if (solutionPath == preloadedPath) {
                  throw new Error("File Name Conflict: solution and preloaded");
              }
              files.push({
                  path: 'src/main/java/' + preloadedPath + '.java',
                  contents: preloaded,
                  source: "preloaded"
              });
          }
          return files;
      };
      exports.toFiles = toFiles;
      
  });

  unwrapExports(junit);
  var junit_1 = junit.toFiles;

  var facade$4 = createCommonjsModule(function (module, exports) {

      Object.defineProperty(exports, "__esModule", { value: true });
      exports.toFiles = void 0;

      var toFiles = function toFiles(ccc, opts) {
          switch (ccc.testFramework) {
              case "junit":
              case "junit4":
              case "junit5":
              case "jqwik":
                  return (0, junit.toFiles)(ccc, opts);
              default:
                  throw new Error('Unknown test framework: ' + ccc.testFramework);
          }
      };
      exports.toFiles = toFiles;
      
  });

  unwrapExports(facade$4);
  var facade_1$2 = facade$4.toFiles;

  var java = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", { value: true });
    exports.junit = exports.getClassName = exports.toFiles = void 0;

    Object.defineProperty(exports, "toFiles", { enumerable: true, get: function get() {
        return facade$4.toFiles;
      } });

    Object.defineProperty(exports, "getClassName", { enumerable: true, get: function get() {
        return utils.getClassName;
      } });

    Object.defineProperty(exports, "junit", { enumerable: true, get: function get() {
        return junit.toFiles;
      } });
    
  });

  unwrapExports(java);
  var java_1 = java.junit;
  var java_2 = java.getClassName;
  var java_3 = java.toFiles;

  var mocha = createCommonjsModule(function (module, exports) {

      Object.defineProperty(exports, "__esModule", { value: true });
      exports.toFiles = void 0;
      // Note that CR actually concatenates these into a single file.
      var toFiles = function toFiles(_ref) {
          var solution = _ref.solution,
              tests = _ref.tests,
              preloaded = _ref.preloaded;

          var files = [{
              path: "solution.js",
              contents: solution,
              source: "solution"
          }, {
              path: "test.js",
              contents: tests,
              source: "tests"
          }];
          if (preloaded) {
              files.push({
                  path: "preloaded.js",
                  contents: preloaded,
                  source: "preloaded"
              });
          }
          return files;
      };
      exports.toFiles = toFiles;
      
  });

  unwrapExports(mocha);
  var mocha_1 = mocha.toFiles;

  var jest = createCommonjsModule(function (module, exports) {

      Object.defineProperty(exports, "__esModule", { value: true });
      exports.toFiles = void 0;
      var toFiles = function toFiles(_ref) {
          var solution = _ref.solution,
              tests = _ref.tests,
              preloaded = _ref.preloaded;

          var files = [{ path: "src/solution.js", contents: solution, source: "solution" }, { path: "src/solution.test.js", contents: tests, source: "tests" }];
          if (preloaded) {
              files.push({
                  path: "src/preloaded.js",
                  contents: preloaded,
                  source: "preloaded"
              });
          }
          return files;
      };
      exports.toFiles = toFiles;
      
  });

  unwrapExports(jest);
  var jest_1 = jest.toFiles;

  var facade$6 = createCommonjsModule(function (module, exports) {

      Object.defineProperty(exports, "__esModule", { value: true });
      exports.toFiles = void 0;

      var toFiles = function toFiles(ccc) {
          switch (ccc.testFramework) {
              case "mocha":
              case "mocha_bdd":
              case "mocha_tdd":
                  return (0, mocha.toFiles)(ccc);
              case "jest":
                  return (0, jest.toFiles)(ccc);
              default:
                  throw new Error('Unknown test framework: ' + ccc.testFramework);
          }
      };
      exports.toFiles = toFiles;
      
  });

  unwrapExports(facade$6);
  var facade_1$3 = facade$6.toFiles;

  var javascript = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", { value: true });
    exports.jest = exports.mocha = exports.toFiles = void 0;

    Object.defineProperty(exports, "toFiles", { enumerable: true, get: function get() {
        return facade$6.toFiles;
      } });

    Object.defineProperty(exports, "mocha", { enumerable: true, get: function get() {
        return mocha.toFiles;
      } });

    Object.defineProperty(exports, "jest", { enumerable: true, get: function get() {
        return jest.toFiles;
      } });
    
  });

  unwrapExports(javascript);
  var javascript_1 = javascript.jest;
  var javascript_2 = javascript.mocha;
  var javascript_3 = javascript.toFiles;

  var unittest = createCommonjsModule(function (module, exports) {

      Object.defineProperty(exports, "__esModule", { value: true });
      exports.toFiles = void 0;
      // Python 3.7+
      var toFiles = function toFiles(_ref) {
          var solution = _ref.solution,
              tests = _ref.tests,
              preloaded = _ref.preloaded;

          var files = [{ path: "solution.py", contents: solution, source: "solution" }, { path: "tests/test_solution.py", contents: tests, source: "tests" }];
          if (preloaded) {
              files.push({
                  path: "preloaded.py",
                  contents: preloaded,
                  source: "preloaded"
              });
          }
          return files;
      };
      exports.toFiles = toFiles;
      
  });

  unwrapExports(unittest);
  var unittest_1 = unittest.toFiles;

  var facade$8 = createCommonjsModule(function (module, exports) {

      Object.defineProperty(exports, "__esModule", { value: true });
      exports.toFiles = void 0;

      var toFiles = function toFiles(ccc) {
          if (ccc.testFramework === "unittest") {
              return (0, unittest.toFiles)(ccc);
          }
          throw new Error('Unknown test framework: ' + ccc.testFramework);
      };
      exports.toFiles = toFiles;
      
  });

  unwrapExports(facade$8);
  var facade_1$4 = facade$8.toFiles;

  var python = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", { value: true });
    exports.unittest = exports.toFiles = void 0;

    Object.defineProperty(exports, "toFiles", { enumerable: true, get: function get() {
        return facade$8.toFiles;
      } });

    Object.defineProperty(exports, "unittest", { enumerable: true, get: function get() {
        return unittest.toFiles;
      } });
    
  });

  unwrapExports(python);
  var python_1 = python.unittest;
  var python_2 = python.toFiles;

  var rspec = createCommonjsModule(function (module, exports) {

      Object.defineProperty(exports, "__esModule", { value: true });
      exports.toFiles = void 0;
      // Note that this is for Ruby 3.x.
      // Ruby 2.x has a different mapping, and concatenates the preloaded with test helper.
      // This might work for Ruby 2.x as well because neither of them `require`s explicitly.
      var toFiles = function toFiles(_ref) {
          var solution = _ref.solution,
              tests = _ref.tests,
              preloaded = _ref.preloaded;

          var files = [{ path: "lib/solution.rb", contents: solution, source: "solution" }, { path: "spec/solution_spec.rb", contents: tests, source: "tests" }];
          var specHelper = ["require 'solution'"];
          if (preloaded) {
              files.push({
                  path: "lib/preloaded.rb",
                  contents: preloaded,
                  source: "preloaded"
              });
              specHelper.unshift("require 'preloaded'");
          }
          files.push({
              path: "spec/spec_helper.rb",
              contents: specHelper.join("\n"),
              source: "generated"
          });
          return files;
      };
      exports.toFiles = toFiles;
      
  });

  unwrapExports(rspec);
  var rspec_1 = rspec.toFiles;

  var facade$10 = createCommonjsModule(function (module, exports) {

      Object.defineProperty(exports, "__esModule", { value: true });
      exports.toFiles = void 0;

      var toFiles = function toFiles(ccc) {
          if (ccc.testFramework === "rspec") {
              return (0, rspec.toFiles)(ccc);
          }
          throw new Error('Unknown test framework: ' + ccc.testFramework);
      };
      exports.toFiles = toFiles;
      
  });

  unwrapExports(facade$10);
  var facade_1$5 = facade$10.toFiles;

  var ruby = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", { value: true });
    exports.rspec = exports.toFiles = void 0;

    Object.defineProperty(exports, "toFiles", { enumerable: true, get: function get() {
        return facade$10.toFiles;
      } });

    Object.defineProperty(exports, "rspec", { enumerable: true, get: function get() {
        return rspec.toFiles;
      } });
    
  });

  unwrapExports(ruby);
  var ruby_1 = ruby.rspec;
  var ruby_2 = ruby.toFiles;

  var mocha$2 = createCommonjsModule(function (module, exports) {

      Object.defineProperty(exports, "__esModule", { value: true });
      exports.toFiles = void 0;
      var toFiles = function toFiles(_ref) {
          var solution = _ref.solution,
              tests = _ref.tests,
              preloaded = _ref.preloaded;

          var files = [{
              path: "solution.ts",
              contents: solution,
              source: "solution"
          }, {
              path: "test.ts",
              contents: tests,
              source: "tests"
          }];
          if (preloaded) {
              files.push({
                  path: "preloaded.ts",
                  contents: preloaded,
                  source: "preloaded"
              });
          }
          return files;
      };
      exports.toFiles = toFiles;
      
  });

  unwrapExports(mocha$2);
  var mocha_1$1 = mocha$2.toFiles;

  var jest$2 = createCommonjsModule(function (module, exports) {

      Object.defineProperty(exports, "__esModule", { value: true });
      exports.toFiles = void 0;
      var toFiles = function toFiles(_ref) {
          var solution = _ref.solution,
              tests = _ref.tests,
              preloaded = _ref.preloaded,
              preset = _ref.preset;

          var ext = preset === "react" ? "tsx" : "ts";
          var files = [{ path: "src/solution." + ext, contents: solution, source: "solution" }, { path: "src/solution.test." + ext, contents: tests, source: "tests" }];
          if (preloaded) {
              files.push({
                  path: "src/preloaded." + ext,
                  contents: preloaded,
                  source: "preloaded"
              });
          }
          return files;
      };
      exports.toFiles = toFiles;
      
  });

  unwrapExports(jest$2);
  var jest_1$1 = jest$2.toFiles;

  var facade$12 = createCommonjsModule(function (module, exports) {

      Object.defineProperty(exports, "__esModule", { value: true });
      exports.toFiles = void 0;

      var toFiles = function toFiles(ccc) {
          switch (ccc.testFramework) {
              case "mocha":
              case "mocha_bdd":
              case "mocha_tdd":
                  return (0, mocha$2.toFiles)(ccc);
              case "jest":
                  return (0, jest$2.toFiles)(ccc);
              default:
                  throw new Error('Unknown test framework: ' + ccc.testFramework);
          }
      };
      exports.toFiles = toFiles;
      
  });

  unwrapExports(facade$12);
  var facade_1$6 = facade$12.toFiles;

  var typescript = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", { value: true });
    exports.mocha = exports.jest = exports.toFiles = void 0;

    Object.defineProperty(exports, "toFiles", { enumerable: true, get: function get() {
        return facade$12.toFiles;
      } });

    Object.defineProperty(exports, "jest", { enumerable: true, get: function get() {
        return jest$2.toFiles;
      } });

    Object.defineProperty(exports, "mocha", { enumerable: true, get: function get() {
        return mocha$2.toFiles;
      } });
    
  });

  unwrapExports(typescript);
  var typescript_1 = typescript.mocha;
  var typescript_2 = typescript.jest;
  var typescript_3 = typescript.toFiles;

  var facade$14 = createCommonjsModule(function (module, exports) {

      Object.defineProperty(exports, "__esModule", { value: true });
      exports.toFiles = void 0;

      var mappers = {
          csharp: csharp.toFiles,
          dart: dart.toFiles,
          java: java.toFiles,
          javascript: javascript.toFiles,
          python: python.toFiles,
          ruby: ruby.toFiles,
          typescript: typescript.toFiles
      };
      var toFiles = function toFiles(ccc) {
          var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          var language = ccc.language;
          if (!mappers.hasOwnProperty(language)) {
              throw new Error("Unknown language: " + language);
          }
          return mappers[language](ccc, opts);
      };
      exports.toFiles = toFiles;
      
  });

  unwrapExports(facade$14);
  var facade_1$7 = facade$14.toFiles;

  var cjs = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", { value: true });
    exports.toFiles = void 0;

    Object.defineProperty(exports, "toFiles", { enumerable: true, get: function get() {
        return facade$14.toFiles;
      } });
    
  });

  unwrapExports(cjs);
  var cjs_1 = cjs.toFiles;

  var _WORKSPACE_STATUS_LAB;

  var WORKSPACE_STATUS = {
    DISABLED: 'disabled',
    NEW: 'new',
    CONNECTING: 'connecting',
    CONNECTION_DELAY: 'connection-delay',
    CONNECTED: 'connected',
    CONNECTION_ERROR: 'connection-error',
    CONNECTION_RETRYING: 'connection-retrying',
    CONNECTION_FAILED: 'connection-failed',
    DESTROYING: 'destroying'
  };

  var WORKSPACE_STATUS_LABELS = (_WORKSPACE_STATUS_LAB = {}, defineProperty(_WORKSPACE_STATUS_LAB, WORKSPACE_STATUS.DISABLED, 'SmartIDE Disabled'), defineProperty(_WORKSPACE_STATUS_LAB, WORKSPACE_STATUS.NEW, 'Starting SmartIDE'), defineProperty(_WORKSPACE_STATUS_LAB, WORKSPACE_STATUS.CONNECTING, 'Connecting to SmartIDE'), defineProperty(_WORKSPACE_STATUS_LAB, WORKSPACE_STATUS.CONNECTION_DELAY, 'Connecting to SmartIDE is taking longer than expected'), defineProperty(_WORKSPACE_STATUS_LAB, WORKSPACE_STATUS.CONNECTED, 'SmartIDE connected and available for code completion and inspection'), defineProperty(_WORKSPACE_STATUS_LAB, WORKSPACE_STATUS.CONNECTION_ERROR, 'Unable to connect to SmartIDE service'), defineProperty(_WORKSPACE_STATUS_LAB, WORKSPACE_STATUS.CONNECTION_RETRYING, 'SmartIDE service was interrupted, trying to reconnect'), defineProperty(_WORKSPACE_STATUS_LAB, WORKSPACE_STATUS.CONNECTION_FAILED, 'SmartIDE service cannot connect. Please restart the service.'), defineProperty(_WORKSPACE_STATUS_LAB, WORKSPACE_STATUS.DESTROYING, 'Shutting down the SmartIDE service'), _WORKSPACE_STATUS_LAB);

  /**
   * Simple mapping of classic code challenge fields to files
   * @param {string} field - Field to map
   * @param {string} language - Language being used
   * @param {string?} testFramework - Framework being used (for `testCases` and `exampleTestCases` only)
   * @returns {string} Language Server filename for a given
   */
  function mapClassicCodeFieldToPath(field, language, testFramework) {
    if (/testcases/i.test(field)) {
      language = languages.frameworkLanguage(language, testFramework);
    }
    var lang = languages.getLang(language) || languages.Text;
    return field + '.' + lang.ext[0];
  }

  var classFilePathMap = {
    code: 'solution',
    testCases: 'tests',
    setup: 'solution',
    preloaded: 'preloaded',
    exampleTestCases: 'tests',
    solution: 'solution'
  };

  /**
   * Sets the paths on classic code files. If we can map them using the ccc-files method, we use that. Otherwise,
   * we revert to a simple "field.ext" format.
   *
   * @param {Array<CodeFile>} files - Array of files to be updated
   * @param {string} language - current language
   * @param {string} testFramework - current test framework
   * @param {string?} languageVersion - optional language version
   * @param {string?} preset - optional runner preset
   * @param {Object?} $log - optional AngularJS $log service for debugging
   *
   * @returns {Array<{file:*, oldPath:string}>} Array of renamed files
   */
  function setClassicFilePaths(_ref) {
    var files = _ref.files,
        language = _ref.language,
        testFramework = _ref.testFramework,
        languageVersion = _ref.languageVersion,
        preset = _ref.preset,
        $log = _ref.$log;

    // arguments passed into the ccc-files#toFiles method
    var toFilesArgs = {
      language: language,
      languageVersion: languageVersion,
      testFramework: testFramework,
      preset: preset
    };
    // makes it easier to trace the files back to the field
    var fieldToFile = {};
    files.forEach(function (file) {
      file._oldPath = file.path;
      // reset the path
      file.path = null;
      var mappedField = classFilePathMap[file.field];
      if (mappedField) {
        toFilesArgs[mappedField] = file.contents;
        fieldToFile[mappedField] = file;
      }
    });

    if (language && testFramework) {
      try {
        var mappedFiles = cjs_1(toFilesArgs);
        mappedFiles.forEach(function (mf) {
          // if we get mapped files back, store the path back on the file
          if (fieldToFile[mf.source]) {
            fieldToFile[mf.source].path = mf.path;
          }
        });
      } catch (e) {
        // Some errors are expected (e.g., unsupported language/framework combos), but log for debugging
        if ($log && $log.debug) {
          $log.debug('[SmartIDE] File path mapping failed, using fallback paths:', {
            language: language,
            testFramework: testFramework,
            languageVersion: languageVersion,
            preset: preset,
            error: e.message || String(e)
          });
        }
      }
    }

    var renamedFiles = [];

    files.forEach(function (file) {
      if (!file.path) {
        // if a file didn't get a path mapped, we just revert to the simple classic file path
        file.path = mapClassicCodeFieldToPath(file.field, language, testFramework);
      }

      if (file._oldPath !== file.path) {
        // track any files that got renamed
        renamedFiles.push({
          file: file,
          oldPath: file._oldPath
        });
      }
      delete file._oldPath;
    });

    return renamedFiles;
  }

  var CONNECTING_WAIT_ERROR = 120000; // only wait 120s for a server to connect
  var CONNECTING_WAIT_DELAY = 30000; // at 30s note there's a delay

  var DEFAULT_PROXY_READY_TIMEOUT_MS = 120000;
  var AUTOCOMPLETE_DURATION_CAP_MS = CONNECTING_WAIT_ERROR;
  // Max time to wait for prewarm to complete before returning the proxy.
  // Slow LSes (OmniSharp ~3-5s, JDT ~4s) need time to parse the project.
  // If prewarm exceeds this, the proxy is returned anyway — the LS will
  // still be loading but the user won't be blocked indefinitely.
  var PREWARM_AWAIT_TIMEOUT_MS = 8000;

  // Retry policy for the `language_server` create call. A single 500 from that
  // endpoint used to end SmartIDE for the whole session (QUAL-2118), so we retry —
  // but the assessment timer keeps running while we back off, which is exactly the
  // harm that was reported, so the total added delay is tightly capped.
  var PROXY_CREATE_MAX_RETRIES = 3;
  var PROXY_CREATE_RETRY_BASE_MS = 1000;
  var PROXY_CREATE_RETRY_BUDGET_MS = 10000;

  // Deadline for one request to the ephemeron API. `fetch` has no timeout of its
  // own, and `DEFAULT_PROXY_READY_TIMEOUT_MS` is only checked between polls, so
  // without this a single unanswered request runs past every budget we have —
  // a candidate lost 85s to exactly one of them (QUAL-2250).
  var EPHEMERON_REQUEST_TIMEOUT_MS = 10000;
  // Pace between polls of the pod-ready endpoint.
  var PROXY_POLL_INTERVAL_MS = 1000;
  // Consecutive poll failures ridden out before giving up. The create call was
  // answered seconds earlier, so a single blip says nothing about the pod; a run
  // of them says the proxy is unreachable.
  var PROXY_POLL_MAX_NETWORK_FAILURES = 3;

  // Sentry performance helpers for LSP observability
  var sentryBreadcrumb = function sentryBreadcrumb(message, data, level) {
    if (window.Sentry) {
      window.Sentry.addBreadcrumb({
        category: 'smartide.lsp',
        message: message,
        data: data,
        level: level || 'info'
      });
    }
  };

  var sentryConfigureScope = function sentryConfigureScope(cb) {
    if (window.Sentry && window.Sentry.configureScope) {
      try {
        window.Sentry.configureScope(cb);
      } catch (e) {
        // ignore
      }
    }
  };

  var sentrySetSmartIdeContext = function sentrySetSmartIdeContext(context) {
    sentryConfigureScope(function (scope) {
      if (!scope || !context) return;

      // Tags: indexed + good for filtering/aggregation.
      if (context.smartIdeSessionId) scope.setTag('smartide.session_id', context.smartIdeSessionId);
      if (context.proxyId) scope.setTag('smartide.proxy_id', context.proxyId);
      if (context.proxyHost) scope.setTag('smartide.proxy_host', context.proxyHost);
      if (context.preset) scope.setTag('smartide.preset', context.preset);
      if (context.serverId) scope.setTag('smartide.server_id', context.serverId);
      if (context.challengeId) scope.setTag('challenge_id', context.challengeId);
      if (context.solutionId) scope.setTag('solution_id', context.solutionId);

      // Extras: helpful but not always indexed.
      scope.setExtra('smartide', Object.assign({}, context));
    });
  };

  var sentryClearSmartIdeContext = function sentryClearSmartIdeContext() {
    sentryConfigureScope(function (scope) {
      if (!scope) return;
      scope.setTag('smartide.session_id', null);
      scope.setTag('smartide.proxy_id', null);
      scope.setTag('smartide.proxy_host', null);
      scope.setTag('smartide.preset', null);
      scope.setTag('smartide.server_id', null);
      scope.setTag('challenge_id', null);
      scope.setTag('solution_id', null);
      scope.setExtra('smartide', null);
    });
  };

  var generateSmartIdeSessionId = function generateSmartIdeSessionId() {
    return [Date.now().toString(36), Math.random().toString(36).slice(2, 10)].join('-');
  };

  // --- SmartIDE: time to first autocomplete (typing -> first hint shown) ---
  // We instrument CodeMirror at runtime to avoid depending on CodeMirrorWorkspace internals.
  // 1) When the user first types in an editor, we record a timestamp on the CodeMirror instance.
  // 2) When CodeMirror shows the first completion popup (showHint), we record the duration.
  //
  // NOTE: This is intentionally a breadcrumb-style metric (via sentryMeasure) because the app
  // already ships Sentry and we want a low-friction, low-risk implementation.

  var isLikelyUserTypingChange = function isLikelyUserTypingChange(changeObj) {
    // CodeMirror change origins we want to treat as "user started typing".
    // We intentionally exclude setValue and other programmatic updates.
    if (!changeObj || !changeObj.origin) return false;
    var origin = changeObj.origin;
    if (origin === 'setValue') return false;
    return origin === '+input' || origin === 'paste';
  };

  var TYPING_BLOCK_IDLE_MS = 1200;

  var attachSmartIdeFirstTypingTracker = function attachSmartIdeFirstTypingTracker(codemirror, context, $interval, $timeout) {
    if (!codemirror || codemirror.__smartIdeFirstTypingTrackerAttached) return;

    // Keep the context lean; this gets attached to the CodeMirror instance.
    codemirror.__smartIdeFirstTypingTrackerAttached = true;
    codemirror.__smartIdeAutocompleteContext = context || {};
    codemirror.__smartIdeFirstUserTypingAt = null;
    codemirror.__smartIdeFirstAutocompleteRecorded = false;
    codemirror.__smartIdeFirstAutocompleteTimeoutRecorded = false;
    codemirror.__smartIdeCurrentTypingBlockStartedAt = null;
    codemirror.__smartIdeLastTypingAt = null;
    codemirror.__smartIdeTypingVelocityWindowStartedAt = null;
    codemirror.__smartIdeTypingVelocityWindowCount = 0;
    codemirror.__smartIdeActivePollInterval = null;
    codemirror.__smartIdeActivePollTimeout = null;

    codemirror.on('change', function (_cm, changeObj) {
      if (!isLikelyUserTypingChange(changeObj)) return;

      var nowAt = Date.now();
      var ctx = codemirror.__smartIdeAutocompleteContext || {};
      var workspaceState = ctx.workspaceState;

      if (!codemirror.__smartIdeFirstUserTypingAt) {
        codemirror.__smartIdeFirstUserTypingAt = nowAt;

        if (workspaceState && !workspaceState.firstTypingRecorded && workspaceState.startTime) {
          workspaceState.firstTypingRecorded = true;
          trackPerformance('smartide.time_to_first_typing', {
            duration_ms: nowAt - workspaceState.startTime,
            preset: ctx.preset,
            language: ctx.language,
            session_id: ctx.smartIdeSessionId,
            challenge_id: ctx.challengeId,
            solution_id: ctx.solutionId,
            assessment_id: ctx.assessmentId
          });
        }

        sentryBreadcrumb('SmartIDE first user typing detected', {
          filePath: context && context.filePath,
          language: context && context.language,
          languageVersion: context && context.languageVersion,
          preset: context && context.preset,
          challengeId: context && context.challengeId,
          solutionId: context && context.solutionId
        });
      }

      if (!codemirror.__smartIdeCurrentTypingBlockStartedAt || !codemirror.__smartIdeLastTypingAt || nowAt - codemirror.__smartIdeLastTypingAt > TYPING_BLOCK_IDLE_MS) {
        codemirror.__smartIdeCurrentTypingBlockStartedAt = nowAt;
      }
      codemirror.__smartIdeLastTypingAt = nowAt;

      if (!codemirror.__smartIdeTypingVelocityWindowStartedAt) {
        codemirror.__smartIdeTypingVelocityWindowStartedAt = nowAt;
      }
      codemirror.__smartIdeTypingVelocityWindowCount += 1;

      var typingVelocityElapsedMs = nowAt - codemirror.__smartIdeTypingVelocityWindowStartedAt;
      if (typingVelocityElapsedMs >= 1000) {
        trackPerformance('smartide.key_typing_velocity', {
          value: codemirror.__smartIdeTypingVelocityWindowCount * 1000 / typingVelocityElapsedMs,
          preset: ctx.preset,
          language: ctx.language,
          session_id: ctx.smartIdeSessionId,
          challenge_id: ctx.challengeId,
          solution_id: ctx.solutionId,
          assessment_id: ctx.assessmentId
        });
        codemirror.__smartIdeTypingVelocityWindowStartedAt = nowAt;
        codemirror.__smartIdeTypingVelocityWindowCount = 0;
      }
    });

    codemirror.on('blur', function () {
      codemirror.__smartIdeCurrentTypingBlockStartedAt = null;
      codemirror.__smartIdeLastTypingAt = null;
    });

    // Per-instance keyup listener — polls cm.state.completionActive to detect when LSP
    // completions appear. We cannot patch window.CodeMirror.showHint because
    // CodeMirrorWorkspace uses its own bundled CodeMirror reference (not window.CodeMirror),
    // so the global showHint patch never intercepts LSP-driven completions.
    codemirror.on('keyup', function (cm) {
      if (!cm.__smartIdeCurrentTypingBlockStartedAt) return;

      // Cancel any existing poll+timeout from the previous keyup before starting new ones.
      // Without this, every keyup accumulates a new interval — if the user types N characters
      // before completions appear, N intervals all fire simultaneously and emit N duplicate
      // metrics, many with inflated durations anchored to the start of the typing block.
      if (cm.__smartIdeActivePollInterval) {
        $interval.cancel(cm.__smartIdeActivePollInterval);
        cm.__smartIdeActivePollInterval = null;
      }
      if (cm.__smartIdeActivePollTimeout) {
        $timeout.cancel(cm.__smartIdeActivePollTimeout);
        cm.__smartIdeActivePollTimeout = null;
      }

      var typingBlockStartedAt = cm.__smartIdeCurrentTypingBlockStartedAt;
      // Capture the time of this specific keyup so that autocomplete.general measures
      // "time from last keystroke to completion popup", not "time from block start".
      var keyupAt = Date.now();

      cm.__smartIdeActivePollInterval = $interval(function () {
        try {
          if (!(cm.state && cm.state.completionActive)) return;

          // Completions are now visible — stop polling and record metrics.
          $interval.cancel(cm.__smartIdeActivePollInterval);
          cm.__smartIdeActivePollInterval = null;

          var ctx = cm.__smartIdeAutocompleteContext || {};
          var autocompleteDurationMs = Date.now() - keyupAt;
          var cappedAutocompleteDurationMs = Math.min(autocompleteDurationMs, AUTOCOMPLETE_DURATION_CAP_MS);

          var tabVisible = document.visibilityState !== 'hidden';

          if (!cm.__smartIdeFirstAutocompleteRecorded) {
            // Record first autocomplete separately — don't pollute the
            // general metric with the slow first-completion time.
            cm.__smartIdeFirstAutocompleteRecorded = true;

            if (typingBlockStartedAt) {
              var firstAutocompleteDurationMs = Math.min(Date.now() - typingBlockStartedAt, AUTOCOMPLETE_DURATION_CAP_MS);
              trackPerformance('smartide.time_to_first_autocomplete', {
                duration_ms: firstAutocompleteDurationMs,
                preset: ctx.preset,
                language: ctx.language,
                tab_visible: tabVisible,
                session_id: ctx.smartIdeSessionId,
                status: 'ok',
                reason: 'completion_detected',
                challenge_id: ctx.challengeId,
                solution_id: ctx.solutionId,
                assessment_id: ctx.assessmentId
              });
            }
          } else {
            // Only track general autocomplete after the first one, so the
            // metric reflects steady-state LS performance, not cold start.
            trackPerformance('smartide.autocomplete.general', {
              duration_ms: cappedAutocompleteDurationMs,
              preset: ctx.preset,
              language: ctx.language,
              tab_visible: tabVisible,
              session_id: ctx.smartIdeSessionId,
              challenge_id: ctx.challengeId,
              solution_id: ctx.solutionId,
              assessment_id: ctx.assessmentId
            });
          }

          cm.__smartIdeCurrentTypingBlockStartedAt = null;
        } catch (e) {
          // Never let observability code impact editor functionality.
          $interval.cancel(cm.__smartIdeActivePollInterval);
          cm.__smartIdeActivePollInterval = null;
        }
      }, 20);

      // Safety valve — stop polling after 15 seconds (completions should appear quickly).
      cm.__smartIdeActivePollTimeout = $timeout(function () {
        if (cm.__smartIdeActivePollInterval) {
          $interval.cancel(cm.__smartIdeActivePollInterval);
          cm.__smartIdeActivePollInterval = null;
        }
        cm.__smartIdeActivePollTimeout = null;

        if (!cm.__smartIdeCurrentTypingBlockStartedAt) return;
        if (cm.__smartIdeCurrentTypingBlockStartedAt !== typingBlockStartedAt) {
          return;
        }
        if (cm.state && cm.state.completionActive) return;

        var timeoutCtx = cm.__smartIdeAutocompleteContext || {};
        trackPerformance('smartide.autocomplete.timeout', {
          preset: timeoutCtx.preset,
          language: timeoutCtx.language,
          session_id: timeoutCtx.smartIdeSessionId,
          status: 'timeout',
          reason: 'no_completion_active',
          challenge_id: timeoutCtx.challengeId,
          solution_id: timeoutCtx.solutionId,
          assessment_id: timeoutCtx.assessmentId
        });

        if (cm.__smartIdeFirstAutocompleteRecorded || cm.__smartIdeFirstAutocompleteTimeoutRecorded) {
          return;
        }

        cm.__smartIdeFirstAutocompleteTimeoutRecorded = true;
        var timeoutDurationMs = Math.min(Date.now() - typingBlockStartedAt, AUTOCOMPLETE_DURATION_CAP_MS);

        trackPerformance('smartide.first_autocomplete_timeout', {
          duration_ms: timeoutDurationMs,
          preset: timeoutCtx.preset,
          language: timeoutCtx.language,
          session_id: timeoutCtx.smartIdeSessionId,
          status: 'timeout',
          reason: 'no_completion_active',
          challenge_id: timeoutCtx.challengeId,
          solution_id: timeoutCtx.solutionId,
          assessment_id: timeoutCtx.assessmentId
        });
      }, 15000);
    });
  };

  // Sends a performance metric to the Rails backend, which fans it out to:
  //   - StatsD  → Datadog dashboard widgets (avg, p95, count, breakdown by preset/language)
  //   - Structured log → Datadog Log Management with full context (userId, challengeId, etc.)
  //
  // Fire-and-forget: errors are swallowed so broken telemetry never affects the editor.
  // High-cardinality IDs (challengeId, solutionId, assessmentId) are included in the
  // POST body but the Rails controller routes them to logs only — never to StatsD tags.
  function trackPerformance(event, data) {
    try {
      if (!window.fetch) return;
      window.fetch(appConfig.apiRoot + 'lsp_telemetry', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        keepalive: true,
        body: JSON.stringify(Object.assign({ event: event }, data || {}))
      }).catch(function () {});
    } catch (e) {
      // Never let telemetry break the editor.
    }
  }

  function sentryMeasure(name, durationMs, data) {
    if (window.Sentry) {
      window.Sentry.addBreadcrumb({
        category: 'smartide.performance',
        message: name,
        data: Object.assign({}, data || {}, { durationMs: durationMs }),
        level: durationMs > 10000 ? 'warning' : 'info'
      });
      // Also capture as a Sentry event if it's abnormally slow
      if (durationMs > 30000) {
        window.Sentry.captureMessage('[SmartIDE] Slow LSP operation: ' + name + ' (' + durationMs + 'ms)', {
          level: 'warning',
          extra: Object.assign({}, data || {}, { durationMs: durationMs })
        });
      }
    }
  }

  // we can get away with async/await here because this service doesn't interact with AngularJS
  // Normally we'd have to convert this to an AngularJS component, and also convert it to use Promises.
  // This class is not currently exported on purpose (we don't want it used outside this factory)
  // DO NOT USE ASYNC/AWAIT WITH ANGULARJS

  var now = function now() {
    return Math.floor(Date.now() / 1000);
  };
  // eslint-disable-next-line angular/timeout-service
  var delay = function delay(ms) {
    return new Promise(function (resolve) {
      return setTimeout(resolve, ms);
    });
  };

  /**
   * Whether a failed `create()` call is worth trying again.
   *
   * Only server-side faults and network blips can succeed on a retry. A 4xx will
   * fail identically, and a `SmartIDEProxyWaitTimeout` has already burned
   * `DEFAULT_PROXY_READY_TIMEOUT_MS` of the candidate's time.
   *
   * @param {Error?} err - Error thrown by `create()`
   * @returns {boolean} True if the call should be retried
   */
  function isRetryableProxyCreateError(err) {
    if (!err) return false;
    if (isNetworkLevelError(err)) return true;
    if (err.name !== 'SmartIDEProxyCreateError') return false;
    var status = err.details && err.details.statusCode;
    return typeof status === 'number' && status >= 500;
  }

  /**
   * Whether a request failed without ever coming back with an answer.
   *
   * `TypeError` is how `fetch` reports a request that never reached the server;
   * `AbortError` is our own `EPHEMERON_REQUEST_TIMEOUT_MS` firing. Neither tells
   * us anything about the state of what we asked about, so both are worth asking
   * again. Anything else is a real answer, to act on rather than retry.
   *
   * @param {Error?} err - Error thrown by the request
   * @returns {boolean} True if the request is worth retrying
   */
  function isNetworkLevelError(err) {
    if (!err) return false;
    return err.name === 'TypeError' || err.name === 'AbortError';
  }

  /**
   * `fetch` with a deadline.
   *
   * A bare `fetch` has no timeout: a request that opens a connection and then
   * goes unanswered hangs for as long as the OS keeps retransmitting.
   *
   * @param {string} url - Request URL
   * @param {Object} options - `fetch` options
   * @param {number?} timeoutMs - Abort the request after this long
   * @param {Function?} fetchFn - Injectable for tests
   * @returns {Promise} Resolves with the Response, rejects with `AbortError` on timeout
   */
  var fetchWithTimeout = function () {
    var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, options) {
      var timeoutMs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EPHEMERON_REQUEST_TIMEOUT_MS;
      var fetchFn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : fetch;
      var controller, timer;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              controller = new AbortController();
              // eslint-disable-next-line angular/timeout-service

              timer = setTimeout(function () {
                return controller.abort();
              }, timeoutMs);
              _context.prev = 2;
              _context.next = 5;
              return fetchFn(url, Object.assign({}, options, { signal: controller.signal }));

            case 5:
              return _context.abrupt('return', _context.sent);

            case 6:
              _context.prev = 6;

              clearTimeout(timer);
              return _context.finish(6);

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[2,, 6, 9]]);
    }));

    return function fetchWithTimeout(_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();

  /**
   * Exponential backoff with +/-25% jitter, so a degraded proxy pool isn't
   * stampeded by every candidate retrying in lockstep.
   *
   * @param {number} attempt - Zero-based attempt index
   * @param {Function?} random - Source of randomness, injectable for tests
   * @returns {number} Delay in milliseconds
   */
  function proxyCreateRetryDelay(attempt) {
    var random = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Math.random;

    var base = PROXY_CREATE_RETRY_BASE_MS * Math.pow(2, attempt);
    return Math.round(base * (0.75 + random() * 0.5));
  }

  /**
   * Runs `create` until it succeeds, the error is not retryable, or the retry
   * budget is spent. Rethrows the last error when it gives up.
   *
   * @param {Function} create - Returns a Promise for the created proxy
   * @param {Object?} options - Overrides, all injectable for tests
   * @param {number?} options.maxRetries - Retries after the initial attempt
   * @param {number?} options.budgetMs - Ceiling on total time spent sleeping
   * @param {Function?} options.sleep - Delay function
   * @param {Function?} options.random - Source of randomness for jitter
   * @param {Function?} options.onRetry - Called as (err, attemptNumber, waitMs)
   * @returns {Promise} Resolves with whatever `create` resolved with
   */
  var retryProxyCreate = function () {
    var _ref3 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(create) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _options$maxRetries, maxRetries, _options$budgetMs, budgetMs, _options$sleep, sleep, _options$random, random, _options$onRetry, onRetry, spentMs, attempt, waitMs;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _options$maxRetries = options.maxRetries, maxRetries = _options$maxRetries === undefined ? PROXY_CREATE_MAX_RETRIES : _options$maxRetries, _options$budgetMs = options.budgetMs, budgetMs = _options$budgetMs === undefined ? PROXY_CREATE_RETRY_BUDGET_MS : _options$budgetMs, _options$sleep = options.sleep, sleep = _options$sleep === undefined ? delay : _options$sleep, _options$random = options.random, random = _options$random === undefined ? Math.random : _options$random, _options$onRetry = options.onRetry, onRetry = _options$onRetry === undefined ? noop : _options$onRetry;
              spentMs = 0;
              attempt = 0;

            case 3:
              _context2.prev = 3;
              _context2.next = 6;
              return create(attempt);

            case 6:
              return _context2.abrupt('return', _context2.sent);

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2['catch'](3);
              waitMs = proxyCreateRetryDelay(attempt, random);

              if (!(attempt >= maxRetries || spentMs + waitMs > budgetMs || !isRetryableProxyCreateError(_context2.t0))) {
                _context2.next = 14;
                break;
              }

              throw _context2.t0;

            case 14:
              onRetry(_context2.t0, attempt + 1, waitMs);
              spentMs += waitMs;
              _context2.next = 18;
              return sleep(waitMs);

            case 18:
              attempt++;
              _context2.next = 3;
              break;

            case 21:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[3, 9]]);
    }));

    return function retryProxyCreate(_x7) {
      return _ref3.apply(this, arguments);
    };
  }();

  /**
   * Rebinds the editors a candidate has open onto a freshly respawned proxy.
   *
   * The replacement pod is a new pod with an image-default workspace: its files
   * only ever come from `writeFiles` (prewarm just opens one document over a
   * throwaway socket). So the challenge files have to be written again before the
   * editors reattach, or cross-file resolution -- imports, sibling modules,
   * `$ref/` files -- is silently dead on the new proxy.
   *
   * @param {Object} options - Injected so this stays testable outside AngularJS
   * @param {Object} options.svc - The workspace service
   * @param {Array} options.editors - `{file, codemirror}` pairs to reattach
   * @param {Array?} options.files - Current challenge files to seed the pod with
   * @param {Function} options.all - `Promise.all` equivalent (`$q.all` in the app)
   * @returns {Promise} Resolves once the editors are reattached
   */
  function reattachEditors(_ref4) {
    var svc = _ref4.svc,
        editors = _ref4.editors,
        files = _ref4.files,
        all = _ref4.all;

    // Close first: the documents still hold a handle to the dead connection.
    return all(editors.map(function (e) {
      return svc.closeFile(e.file);
    })).then(function () {
      return Array.isArray(files) && files.length ? svc.initializeFiles(files) : null;
    }).then(function () {
      return all(editors.map(function (e) {
        return svc.openEditor(e.file, e.codemirror);
      }));
    });
  }

  /**
   * Builds a `report(label, err, data)` that sends each distinct failure to
   * Sentry once instead of once per occurrence.
   *
   * A dead LSP proxy fails every subsequent file operation, and the workspace
   * catch handlers hang off `updateFile`/`saveOpenFile`, which fire per edit and
   * per autosave. Reporting unconditionally meant one Sentry event per keystroke
   * for the rest of the session: `[SmartIDE] Workspace operation failed:` billed
   * 1.67M events in the twelve days after it shipped, with single sessions
   * responsible for 28k, and it was 89% of the org's entire error quota.
   *
   * The tally is per-reporter and in-memory, so a workspace that is torn down and
   * rebuilt re-reports its first failure -- that is deliberate, since a failure
   * that survives a rebuild is worth seeing again. If the repeat volume itself
   * becomes the interesting signal, have the dispose path log the counts.
   *
   * @param {Object} log - Angular's `$log` (`$log.error` forwards to Sentry)
   * @returns {Function} `report(label, err, data)`
   */
  function createFailureReporter(log) {
    var seen = new Map();

    return function report(label, err, data) {
      // Keyed by label too, so the cleanup path is not silenced by an identical
      // message already reported from the workspace path.
      var key = label + ':' + (err.message || String(err));
      var count = (seen.get(key) || 0) + 1;
      seen.set(key, count);
      if (count > 1) return false;

      log.error(label, data, err);
      return true;
    };
  }

  // Pods pre-created from the assessment lobby (keyed by preset name).
  // Consumed on first use; one pod per preset, fire-and-forget errors fall back to normal flow.
  var _preWarmedProxies = new Map();
  var urlPath = function urlPath(url, path) {
    return url + (url.endsWith('/') ? '' : '/') + path;
  };

  var parseUidFromTokenSub = function parseUidFromTokenSub(sub) {
    if (!sub || typeof sub !== 'string') return '';
    var idx = sub.indexOf('.');
    if (idx <= 0) return '';
    return sub.slice(0, idx);
  };

  var LanguageServerController = function () {
    function LanguageServerController(_ref5) {
      var url = _ref5.url,
          authorize = _ref5.authorize,
          runConfig = _ref5.runConfig,
          $log = _ref5.$log,
          context = _ref5.context,
          initialFilesGetter = _ref5.initialFilesGetter;
      classCallCheck(this, LanguageServerController);

      this.token = '';
      this.exp = 0;
      this.url = url;
      this.authorize = authorize;
      this.$log = $log;
      this.context = context || {};
      this.startupAttemptSent = false;
      this.startupResultSent = false;
      this.respawned = false;
      this.initialFilesGetter = initialFilesGetter || null;
      this.name = [runConfig.language, runConfig.languageVersion, runConfig.preset || 'default'].join('/');
      // Create a promise that resolves with Proxy service's info.
      this.proxy = this.createProxy();
    }

    /**
     * Ensure proxy is created, and resolve with WebSocket URL for the Language Server.
     */


    createClass(LanguageServerController, [{
      key: 'start',
      value: function () {
        var _ref6 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(name) {
          var proxy;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!this.proxy) this.proxy = this.createProxy();

                  _context3.next = 3;
                  return this.proxy;

                case 3:
                  proxy = _context3.sent;
                  return _context3.abrupt('return', proxy.proxyUrl + '?name=' + name);

                case 5:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function start(_x8) {
          return _ref6.apply(this, arguments);
        }

        return start;
      }()
    }, {
      key: 'createProxy',
      value: function () {
        var _ref7 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
          var _this = this;

          var proxyStartTime, _cached, proxy, id, host, tls, createStartTime, json, waitStartTime, waitResult, totalDuration, _proxy, prewarmStartTime, podReason, createReason;

          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  proxyStartTime = Date.now();

                  this.emitStartupAttempt();
                  sentryBreadcrumb('Creating LSP proxy', { preset: this.name });

                  _cached = _preWarmedProxies.get(this.name);

                  if (!_cached) {
                    _context4.next = 23;
                    break;
                  }

                  _preWarmedProxies.delete(this.name);
                  _context4.prev = 6;
                  _context4.next = 9;
                  return _cached;

                case 9:
                  proxy = _context4.sent;

                  if (!proxy) {
                    _context4.next = 18;
                    break;
                  }

                  sentryMeasure('lsp.proxy.total', Date.now() - proxyStartTime, {
                    preset: this.name,
                    proxyId: proxy.id
                  });
                  sentrySetSmartIdeContext(Object.assign({}, this.context || {}, {
                    proxyId: proxy.id,
                    preset: this.name
                  }));
                  sentryBreadcrumb('Using pre-warmed LSP proxy', {
                    preset: this.name,
                    proxyId: proxy.id
                  });
                  this.emitStartupResult('connected', { reason: 'pre_warmed' });
                  // Resolve this.proxy now so prewarm() can access proxy.id without circular deadlock,
                  // then fire prewarm v3 with the real challenge file content.
                  this.proxy = Promise.resolve(proxy);
                  Promise.race([this.prewarm(), delay(PREWARM_AWAIT_TIMEOUT_MS)]).catch(function () {});
                  return _context4.abrupt('return', proxy);

                case 18:
                  _context4.next = 23;
                  break;

                case 20:
                  _context4.prev = 20;
                  _context4.t0 = _context4['catch'](6);

                  sentryBreadcrumb('Pre-warmed proxy failed, creating new', { preset: this.name }, 'warning');

                case 23:
                  id = null;
                  host = null;
                  tls = false;
                  _context4.prev = 26;
                  createStartTime = Date.now();
                  _context4.next = 30;
                  return retryProxyCreate(function () {
                    return _this.create(_this.name);
                  }, {
                    onRetry: function onRetry(retryErr, attempt, waitMs) {
                      sentryBreadcrumb('Retrying LSP proxy creation', {
                        preset: _this.name,
                        attempt: attempt,
                        waitMs: waitMs,
                        statusCode: retryErr.details && retryErr.details.statusCode,
                        errorName: retryErr.name
                      }, 'warning');
                    }
                  });

                case 30:
                  json = _context4.sent;

                  sentryMeasure('lsp.ephemeron.create', Date.now() - createStartTime, {
                    preset: this.name,
                    proxyId: json.id
                  });

                  id = json.id;
                  waitStartTime = Date.now();
                  _context4.next = 36;
                  return this.wait(id);

                case 36:
                  waitResult = _context4.sent;

                  host = waitResult.host;
                  tls = waitResult.tls;
                  sentryMeasure('lsp.ephemeron.wait', Date.now() - waitStartTime, {
                    preset: this.name,
                    proxyId: id
                  });

                  totalDuration = Date.now() - proxyStartTime;

                  sentryMeasure('lsp.proxy.total', totalDuration, {
                    preset: this.name,
                    proxyId: id,
                    host: host
                  });
                  sentryBreadcrumb('LSP proxy created', {
                    preset: this.name,
                    proxyId: id,
                    host: host,
                    durationMs: totalDuration
                  });

                  // Make proxy metadata available on all subsequent Sentry events for this workspace.
                  sentrySetSmartIdeContext(Object.assign({}, this.context || {}, {
                    proxyId: id,
                    proxyHost: host,
                    preset: this.name
                  }));

                  _proxy = {
                    id: id,
                    proxyUrl: 'ws' + (tls ? 's' : '') + '://' + host,
                    filesUrl: 'http' + (tls ? 's' : '') + '://' + host + '/files',
                    // ping before it expires to extend its lifetime
                    // eslint-disable-next-line angular/interval-service
                    timer: setInterval(this.createPinger(id), 60 * 4 * 1000)
                  };

                  // Prewarm the language server before the client connects. We await it
                  // (with a timeout) so the LS has finished parsing the real file by the
                  // time the user starts typing. Without this, slow LSes like OmniSharp
                  // would still be loading when the first completion fires.

                  prewarmStartTime = Date.now();
                  _context4.prev = 46;
                  _context4.next = 49;
                  return Promise.race([this.prewarm(), delay(PREWARM_AWAIT_TIMEOUT_MS)]);

                case 49:
                  _context4.next = 54;
                  break;

                case 51:
                  _context4.prev = 51;
                  _context4.t1 = _context4['catch'](46);

                  // Prewarm failure is non-critical — the LS will still work,
                  // just with a slower first autocomplete.
                  sentryBreadcrumb('SmartIDE early prewarm failed', {
                    preset: this.name,
                    errorName: _context4.t1 && _context4.t1.name,
                    errorMessage: _context4.t1 && _context4.t1.message
                  }, 'warning');

                case 54:
                  sentryMeasure('lsp.prewarm.await', Date.now() - prewarmStartTime, {
                    preset: this.name,
                    proxyId: id
                  });

                  return _context4.abrupt('return', _proxy);

                case 58:
                  _context4.prev = 58;
                  _context4.t2 = _context4['catch'](26);

                  sentryBreadcrumb('LSP proxy creation failed', {
                    preset: this.name,
                    proxyId: id,
                    errorName: _context4.t2 && _context4.t2.name,
                    errorMessage: _context4.t2 && _context4.t2.message,
                    durationMs: Date.now() - proxyStartTime
                  }, 'error');
                  if (_context4.t2 && _context4.t2.name === 'SmartIDEPodStartupError') {
                    podReason = _context4.t2.details && _context4.t2.details.reason;

                    this.emitStartupResult('pod_startup_error', { reason: podReason });
                    trackPerformance('smartide.lsp.startup_error', {
                      preset: this.name,
                      language: this.context && this.context.language,
                      session_id: this.context && this.context.smartIdeSessionId,
                      status: 'error',
                      reason: podReason,
                      challenge_id: this.context && this.context.challengeId,
                      solution_id: this.context && this.context.solutionId,
                      assessment_id: this.context && this.context.assessmentId
                    });
                  } else if (_context4.t2 && _context4.t2.name === 'SmartIDEProxyWaitTimeout') {
                    this.emitStartupResult('timeout', {
                      reason: 'lsp_pod_ready_wait_timeout'
                    });
                    trackPerformance('smartide.proxy_wait_timeout', {
                      preset: this.name,
                      language: this.context && this.context.language,
                      session_id: this.context && this.context.smartIdeSessionId,
                      status: 'timeout',
                      reason: 'lsp_pod_ready_wait_timeout',
                      challenge_id: this.context && this.context.challengeId,
                      solution_id: this.context && this.context.solutionId,
                      assessment_id: this.context && this.context.assessmentId
                    });
                  } else if (_context4.t2 && _context4.t2.name === 'SmartIDEProxyCreateError') {
                    createReason = _context4.t2.details && _context4.t2.details.reason;

                    this.emitStartupResult('connection_failed', {
                      reason: 'proxy_create_error'
                    });
                    trackPerformance('smartide.lsp.startup_error', {
                      preset: this.name,
                      language: this.context && this.context.language,
                      session_id: this.context && this.context.smartIdeSessionId,
                      status: 'error',
                      reason: createReason,
                      challenge_id: this.context && this.context.challengeId,
                      solution_id: this.context && this.context.solutionId,
                      assessment_id: this.context && this.context.assessmentId
                    });
                  } else {
                    this.emitStartupResult('connection_failed', {
                      reason: 'proxy_creation_failed'
                    });
                  }
                  throw _context4.t2;

                case 63:
                  _context4.prev = 63;
                  return _context4.finish(63);

                case 65:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, this, [[6, 20], [26, 58, 63, 65], [46, 51]]);
        }));

        function createProxy() {
          return _ref7.apply(this, arguments);
        }

        return createProxy;
      }()

      /**
       * Replaces a proxy that died mid-session with a fresh one.
       *
       * One-shot on purpose: if the replacement also dies, something is wrong on the
       * server side and looping would just spend the candidate's remaining time.
       *
       * @returns {Promise<Object|null>} The new proxy, or null if already respawned
       */

    }, {
      key: 'respawn',
      value: function () {
        var _ref8 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (!this.respawned) {
                    _context5.next = 2;
                    break;
                  }

                  return _context5.abrupt('return', null);

                case 2:
                  this.respawned = true;

                  _context5.prev = 3;
                  _context5.next = 6;
                  return this.destroyProxy();

                case 6:
                  _context5.next = 11;
                  break;

                case 8:
                  _context5.prev = 8;
                  _context5.t0 = _context5['catch'](3);

                  // The old proxy is already gone — that is why we're here.
                  sentryBreadcrumb('Discarding unreachable LSP proxy', { preset: this.name, errorName: _context5.t0 && _context5.t0.name }, 'warning');

                case 11:
                  this.proxy = null;

                  sentryBreadcrumb('Respawning LSP proxy', { preset: this.name }, 'warning');
                  // Let the respawn report its own outcome rather than inheriting the
                  // already-sent result of the original startup.
                  this.startupResultSent = false;
                  this.proxy = this.createProxy();
                  return _context5.abrupt('return', this.proxy);

                case 16:
                case 'end':
                  return _context5.stop();
              }
            }
          }, _callee5, this, [[3, 8]]);
        }));

        function respawn() {
          return _ref8.apply(this, arguments);
        }

        return respawn;
      }()
    }, {
      key: 'destroyProxy',
      value: function () {
        var _ref9 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
          var proxy, id;
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if (this.proxy) {
                    _context6.next = 2;
                    break;
                  }

                  return _context6.abrupt('return');

                case 2:
                  _context6.next = 4;
                  return this.proxy;

                case 4:
                  proxy = _context6.sent;

                  clearInterval(proxy.timer);
                  id = proxy.id;
                  _context6.next = 9;
                  return this.auth();

                case 9:
                  _context6.next = 11;
                  return fetch(urlPath(this.url, id), {
                    method: 'DELETE',
                    headers: {
                      'Content-Type': 'application/json',
                      Authorization: 'Bearer ' + this.token
                    }
                  });

                case 11:
                  this.proxy = null;

                case 12:
                case 'end':
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));

        function destroyProxy() {
          return _ref9.apply(this, arguments);
        }

        return destroyProxy;
      }()
    }, {
      key: 'wait',
      value: function () {
        var _ref10 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id, timeoutMs) {
          var json, pollCount, networkFailures, startTime, timeout, err, pollStartTime, response, errorJson, _err;

          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  // Poll until ready
                  json = void 0;
                  pollCount = 0;
                  networkFailures = 0;
                  startTime = Date.now();
                  timeout = typeof timeoutMs === 'number' ? timeoutMs : DEFAULT_PROXY_READY_TIMEOUT_MS;

                case 5:
                  if (json && json.host) {
                    _context7.next = 54;
                    break;
                  }

                  if (!(Date.now() - startTime > timeout)) {
                    _context7.next = 12;
                    break;
                  }

                  err = new Error('[SmartIDE] Timed out waiting for LSP pod to become ready');

                  err.name = 'SmartIDEProxyWaitTimeout';
                  err.details = {
                    proxyId: id,
                    preset: this.name,
                    timeoutMs: timeout,
                    pollCount: pollCount
                  };
                  if (this.$log && this.$log.error) {
                    this.$log.error('[SmartIDE] LSP pod ready wait timed out', Object.assign({}, this.context || {}, err.details), err);
                  }
                  throw err;

                case 12:
                  _context7.next = 14;
                  return this.auth();

                case 14:
                  pollStartTime = Date.now();
                  response = void 0;
                  _context7.prev = 16;
                  _context7.next = 19;
                  return fetchWithTimeout(urlPath(this.url, id), {
                    method: 'GET',
                    headers: {
                      'Content-Type': 'application/json',
                      Authorization: 'Bearer ' + this.token
                    }
                  });

                case 19:
                  response = _context7.sent;
                  _context7.next = 33;
                  break;

                case 22:
                  _context7.prev = 22;
                  _context7.t0 = _context7['catch'](16);

                  if (isNetworkLevelError(_context7.t0)) {
                    _context7.next = 26;
                    break;
                  }

                  throw _context7.t0;

                case 26:
                  networkFailures++;

                  if (!(networkFailures > PROXY_POLL_MAX_NETWORK_FAILURES)) {
                    _context7.next = 29;
                    break;
                  }

                  throw _context7.t0;

                case 29:

                  sentryBreadcrumb('LSP pod poll failed, retrying', {
                    proxyId: id,
                    preset: this.name,
                    consecutiveFailures: networkFailures,
                    errorName: _context7.t0 && _context7.t0.name
                  }, 'warning');
                  // Pace from the start of the failed poll, not from now: a request that
                  // burned the full deadline has already left the pod alone long enough.
                  _context7.next = 32;
                  return delay(Math.max(0, PROXY_POLL_INTERVAL_MS - (Date.now() - pollStartTime)));

                case 32:
                  return _context7.abrupt('continue', 5);

                case 33:
                  // A poll that answered clears the streak — the budget is consecutive.
                  networkFailures = 0;

                  if (response.ok) {
                    _context7.next = 42;
                    break;
                  }

                  _context7.next = 37;
                  return response.json().catch(function () {
                    return {};
                  });

                case 37:
                  errorJson = _context7.sent;
                  _err = new Error('[SmartIDE] LSP pod failed to start');

                  _err.name = 'SmartIDEPodStartupError';
                  _err.details = {
                    proxyId: id,
                    preset: this.name,
                    statusCode: response.status,
                    reason: errorJson.reason || 'unknown',
                    message: errorJson.message || ''
                  };
                  throw _err;

                case 42:
                  _context7.next = 44;
                  return response.json();

                case 44:
                  json = _context7.sent;

                  pollCount++;

                  if (!json.host) {
                    _context7.next = 49;
                    break;
                  }

                  sentryBreadcrumb('LSP pod ready', {
                    proxyId: id,
                    pollCount: pollCount,
                    pollDurationMs: Date.now() - pollStartTime
                  });
                  return _context7.abrupt('break', 54);

                case 49:
                  if (pollCount % 5 === 0) {
                    sentryBreadcrumb('LSP pod still waiting', { proxyId: id, pollCount: pollCount }, 'warning');
                  }
                  _context7.next = 52;
                  return delay(PROXY_POLL_INTERVAL_MS);

                case 52:
                  _context7.next = 5;
                  break;

                case 54:
                  return _context7.abrupt('return', json);

                case 55:
                case 'end':
                  return _context7.stop();
              }
            }
          }, _callee7, this, [[16, 22]]);
        }));

        function wait(_x9, _x10) {
          return _ref10.apply(this, arguments);
        }

        return wait;
      }()
    }, {
      key: 'create',
      value: function () {
        var _ref11 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(preset) {
          var custom, context, body, response, errorJson, err;
          return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.next = 2;
                  return this.auth();

                case 2:
                  custom = {};
                  context = this.context || {};

                  if (context.candidateId) custom.candidateId = String(context.candidateId);
                  if (context.teamMemberId) custom.teamMemberId = String(context.teamMemberId);
                  if (context.assessmentId) custom.assessmentId = String(context.assessmentId);
                  if (context.challengeId) custom.challengeId = String(context.challengeId);
                  if (context.solutionId) custom.solutionId = String(context.solutionId);

                  body = {
                    preset: preset,
                    lifetimeMinutes: 5
                  };

                  if (Object.keys(custom).length) {
                    body.custom = custom;
                  }

                  // Deadlined for the same reason the poll is: an unanswered POST here hangs
                  // the whole creation before the poll's protection can apply, and
                  // `retryProxyCreate`'s budget only caps the sleeping between attempts.
                  _context8.next = 13;
                  return fetchWithTimeout(this.url, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      Authorization: 'Bearer ' + this.token
                    },
                    body: JSON.stringify(body)
                  });

                case 13:
                  response = _context8.sent;

                  if (response.ok) {
                    _context8.next = 22;
                    break;
                  }

                  _context8.next = 17;
                  return response.json().catch(function () {
                    return {};
                  });

                case 17:
                  errorJson = _context8.sent;
                  err = new Error('[SmartIDE] Failed to create LSP proxy');

                  err.name = 'SmartIDEProxyCreateError';
                  err.details = {
                    preset: preset,
                    statusCode: response.status,
                    reason: errorJson.reason || 'unknown',
                    message: errorJson.message || ''
                  };
                  throw err;

                case 22:
                  _context8.next = 24;
                  return response.json();

                case 24:
                  return _context8.abrupt('return', _context8.sent);

                case 25:
                case 'end':
                  return _context8.stop();
              }
            }
          }, _callee8, this);
        }));

        function create(_x11) {
          return _ref11.apply(this, arguments);
        }

        return create;
      }()
    }, {
      key: 'auth',
      value: function () {
        var _ref12 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
          var authStartTime, payload, uid;
          return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  if (!(now() + 30 >= this.exp)) {
                    _context9.next = 10;
                    break;
                  }

                  authStartTime = Date.now();
                  _context9.next = 4;
                  return this.authorize();

                case 4:
                  this.token = _context9.sent;
                  payload = JSON.parse(atob(this.token.split('.')[1]));

                  this.exp = payload.exp;
                  uid = parseUidFromTokenSub(payload.sub);

                  if (uid) {
                    if (appConfig.candidateApp) {
                      if (!this.context.candidateId) this.context.candidateId = uid;
                    } else {
                      if (!this.context.teamMemberId) this.context.teamMemberId = uid;
                    }
                  }
                  sentryMeasure('lsp.auth', Date.now() - authStartTime, {
                    preset: this.name
                  });

                case 10:
                case 'end':
                  return _context9.stop();
              }
            }
          }, _callee9, this);
        }));

        function auth() {
          return _ref12.apply(this, arguments);
        }

        return auth;
      }()
    }, {
      key: 'createPinger',
      value: function createPinger(id) {
        var _this2 = this;

        var url = urlPath(this.url, id);
        return asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
          return regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.next = 2;
                  return _this2.auth();

                case 2:
                  _context10.next = 4;
                  return fetch(url, {
                    method: 'PATCH',
                    headers: {
                      'Content-Type': 'application/json',
                      Authorization: 'Bearer ' + _this2.token
                    },
                    // Update the expiration time to 5 minutes from now.
                    body: JSON.stringify({ lifetimeMinutes: 5 })
                  });

                case 4:
                case 'end':
                  return _context10.stop();
              }
            }
          }, _callee10, _this2);
        }));
      }
    }, {
      key: 'writeFiles',
      value: function () {
        var _ref14 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(files) {
          var operations;
          return regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  operations = files.map(function (file) {
                    return {
                      op: 'write',
                      path: file.path,
                      contents: file.contents
                    };
                  });
                  return _context11.abrupt('return', this.changeRemoteFiles(operations));

                case 2:
                case 'end':
                  return _context11.stop();
              }
            }
          }, _callee11, this);
        }));

        function writeFiles(_x12) {
          return _ref14.apply(this, arguments);
        }

        return writeFiles;
      }()
    }, {
      key: 'writeFile',
      value: function () {
        var _ref15 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(file) {
          return regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  return _context12.abrupt('return', this.changeRemoteFiles([{ op: 'write', path: file.path, contents: file.contents }]));

                case 1:
                case 'end':
                  return _context12.stop();
              }
            }
          }, _callee12, this);
        }));

        function writeFile(_x13) {
          return _ref15.apply(this, arguments);
        }

        return writeFile;
      }()
    }, {
      key: 'removeFile',
      value: function () {
        var _ref16 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(path) {
          return regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  return _context13.abrupt('return', this.changeRemoteFiles([{ op: 'remove', path: path }]));

                case 1:
                case 'end':
                  return _context13.stop();
              }
            }
          }, _callee13, this);
        }));

        function removeFile(_x14) {
          return _ref16.apply(this, arguments);
        }

        return removeFile;
      }()
    }, {
      key: 'renameFile',
      value: function () {
        var _ref17 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(from, to) {
          return regeneratorRuntime.wrap(function _callee14$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  return _context14.abrupt('return', this.changeRemoteFiles([{ op: 'rename', from: from, to: to }]));

                case 1:
                case 'end':
                  return _context14.stop();
              }
            }
          }, _callee14, this);
        }));

        function renameFile(_x15, _x16) {
          return _ref17.apply(this, arguments);
        }

        return renameFile;
      }()
    }, {
      key: 'changeRemoteFiles',
      value: function () {
        var _ref18 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(operations) {
          var proxy, res, json, errorDetails, error;
          return regeneratorRuntime.wrap(function _callee15$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  if (this.proxy) {
                    _context15.next = 2;
                    break;
                  }

                  return _context15.abrupt('return');

                case 2:
                  _context15.next = 4;
                  return this.proxy;

                case 4:
                  proxy = _context15.sent;
                  _context15.next = 7;
                  return fetch(proxy.filesUrl, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ operations: operations })
                  });

                case 7:
                  res = _context15.sent;
                  _context15.next = 10;
                  return res.json();

                case 10:
                  json = _context15.sent;

                  if (res.ok) {
                    _context15.next = 18;
                    break;
                  }

                  // Handle file operation errors
                  errorDetails = {
                    status: res.status,
                    statusText: res.statusText,
                    operations: operations.map(function (op) {
                      return {
                        op: op.op,
                        path: op.path || op.from
                      };
                    }),
                    errors: json.errors || [],
                    languageServer: this.name
                  };
                  error = new Error('[SmartIDE] File operation failed: ' + res.statusText);

                  error.name = 'SmartIDEFileOperationError';
                  error.details = errorDetails;

                  // Log error details - will be sent to Sentry via $log.error
                  if (this.$log && this.$log.error) {
                    this.$log.error('[SmartIDE] File operation error:', errorDetails, error);
                  }

                  throw error;

                case 18:
                  return _context15.abrupt('return', json.changes);

                case 19:
                case 'end':
                  return _context15.stop();
              }
            }
          }, _callee15, this);
        }));

        function changeRemoteFiles(_x17) {
          return _ref18.apply(this, arguments);
        }

        return changeRemoteFiles;
      }()
    }, {
      key: 'prewarm',
      value: function () {
        var _ref19 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
          var proxy, primaryFile, initFiles, lang, sourceExts, exts, isSourceFile, prewarmVersion, reqBody, res, body;
          return regeneratorRuntime.wrap(function _callee16$(_context16) {
            while (1) {
              switch (_context16.prev = _context16.next) {
                case 0:
                  if (this.proxy) {
                    _context16.next = 2;
                    break;
                  }

                  return _context16.abrupt('return');

                case 2:
                  _context16.next = 4;
                  return this.proxy;

                case 4:
                  proxy = _context16.sent;

                  if (!(!proxy || !proxy.id)) {
                    _context16.next = 7;
                    break;
                  }

                  return _context16.abrupt('return');

                case 7:
                  _context16.next = 9;
                  return this.auth();

                case 9:

                  // Resolve the primary solution file for prewarm v3.
                  // Pick a source file the LS can actually analyze — skip markdown, text,
                  // config, and other files the language server won't benefit from parsing.
                  primaryFile = null;

                  if (this.initialFilesGetter) {
                    try {
                      initFiles = this.initialFilesGetter();

                      if (Array.isArray(initFiles)) {
                        lang = this.name.split('/')[0];
                        sourceExts = {
                          javascript: ['.js', '.jsx', '.mjs'],
                          typescript: ['.ts', '.tsx'],
                          python: ['.py'],
                          csharp: ['.cs'],
                          ruby: ['.rb'],
                          java: ['.java']
                        };
                        exts = sourceExts[lang] || [];

                        isSourceFile = function isSourceFile(f) {
                          if (!f || !f.path || !f.contents) return false;
                          if (f.directory || f.hidden || f.reference) return false;
                          if (!exts.length) return true;
                          var p = f.path.toLowerCase();
                          return exts.some(function (ext) {
                            return p.endsWith(ext);
                          });
                        };

                        // Prefer solution file over fixture/test file.


                        primaryFile = initFiles.find(function (f) {
                          return isSourceFile(f) && !/test|spec|fixture/i.test(f.path);
                        }) || initFiles.find(function (f) {
                          return isSourceFile(f);
                        });
                      }
                    } catch (e) {
                      // non-critical — fall back to v2 prewarm
                    }
                  }

                  prewarmVersion = primaryFile ? 'v3' : 'v2';


                  sentryBreadcrumb('SmartIDE prewarm request start', {
                    proxyId: proxy.id,
                    preset: this.name,
                    prewarm_version: prewarmVersion
                  });

                  reqBody = { name: this.name };

                  if (primaryFile) {
                    reqBody.fileUri = 'source://' + primaryFile.path;
                    // Cap at 50 KB to avoid blowing up the request.
                    reqBody.fileContent = (primaryFile.contents || '').substring(0, 50000);
                    // Derive languageId from the preset name (e.g. "typescript/5.7/default" → "typescript").
                    reqBody.fileLanguageId = this.name.split('/')[0];
                  }

                  _context16.next = 17;
                  return fetch(urlPath(this.url, proxy.id + '/prewarm'), {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      Authorization: 'Bearer ' + this.token
                    },
                    body: JSON.stringify(reqBody)
                  });

                case 17:
                  res = _context16.sent;
                  body = null;
                  _context16.prev = 19;
                  _context16.next = 22;
                  return res.json();

                case 22:
                  body = _context16.sent;
                  _context16.next = 27;
                  break;

                case 25:
                  _context16.prev = 25;
                  _context16.t0 = _context16['catch'](19);

                case 27:

                  sentryBreadcrumb('SmartIDE prewarm request complete', {
                    proxyId: proxy.id,
                    statusCode: res.status,
                    warmed: body && body.warmed,
                    reason: body && body.reason,
                    prewarm_version: prewarmVersion
                  }, res.ok ? 'info' : 'warning');

                case 28:
                case 'end':
                  return _context16.stop();
              }
            }
          }, _callee16, this, [[19, 25]]);
        }));

        function prewarm() {
          return _ref19.apply(this, arguments);
        }

        return prewarm;
      }()
    }, {
      key: 'emitStartupAttempt',
      value: function emitStartupAttempt() {
        if (this.startupAttemptSent) return;
        this.startupAttemptSent = true;
        trackPerformance('smartide.lsp.startup_attempt', {
          preset: this.name,
          language: this.context && this.context.language,
          session_id: this.context && this.context.smartIdeSessionId,
          challenge_id: this.context && this.context.challengeId,
          solution_id: this.context && this.context.solutionId,
          assessment_id: this.context && this.context.assessmentId
        });
      }
    }, {
      key: 'emitStartupResult',
      value: function emitStartupResult(status, extra) {
        if (this.startupResultSent) return;
        this.startupResultSent = true;
        trackPerformance('smartide.lsp.startup_result', Object.assign({
          preset: this.name,
          language: this.context && this.context.language,
          session_id: this.context && this.context.smartIdeSessionId,
          status: status,
          challenge_id: this.context && this.context.challengeId,
          solution_id: this.context && this.context.solutionId,
          assessment_id: this.context && this.context.assessmentId
        }, extra || {}));
      }
    }]);
    return LanguageServerController;
  }();

  var codemirrorWorkspaceServiceModule = angular.module('Q.services.codemirror-workspace-service', [markdownComponentModule, tryFunctionHelperModule])

  /**
   * A service to help simplify the process of enabling codemirror editors with LSP
   */
  .factory('codemirrorWorkspaceService', ['$window', '$http', '$log', 'configService', '$q', 'marked', 'tryFunction', '$interval', '$timeout', function ($window, $http, $log, configService, $q, marked, tryFunction, $interval, $timeout) {
    return {
      /**
       * Pre-creates an LSP pod for a preset so it's warmed by the time the candidate opens the challenge.
       * Called from the assessment lobby when the candidate clicks Start/Resume.
       * Fire-and-forget — errors fall back to normal pod creation.
       *
       * @param {string} preset - e.g. 'javascript/18.x/default'
       * @param {string} teamId - Used to obtain a service_auth token
       */
      preWarmProxy: function preWarmProxy(_ref20) {
        var preset = _ref20.preset,
            teamId = _ref20.teamId,
            initialFiles = _ref20.initialFiles;

        if (_preWarmedProxies.has(preset)) return;
        var parts = preset.split('/');
        var authorize = function authorize() {
          return $http.post(appConfig.baseApiRoot + 'service_auth', {
            service: 'language_server',
            teamId: teamId
          }).then(function (resp) {
            return resp.data.token;
          });
        };
        var controller = new LanguageServerController({
          url: configService.config.languageServerUrl,
          authorize: authorize,
          runConfig: {
            language: parts[0],
            languageVersion: parts[1],
            preset: parts[2] || 'default',
            languageServers: []
          },
          $log: $log,
          context: {},
          initialFilesGetter: initialFiles && initialFiles.length ? function () {
            return initialFiles;
          } : null
        });
        _preWarmedProxies.set(preset, controller.proxy);
      },


      /**
       * Creates either a functional workspace, or a dummy model with the same method signatures
       *
       * @param {boolean} enabled - If true, returns a workspace. Otherwise returns a dummy object.
       * @param {Solution?} solution - If provided, will be used to determine language server
       * @param {Challenge?} challenge - If provided, will be used to determine language server
       * @param {Function?} initialFilesGetter - If provided, configures the unopened files automatically.
       */
      createIfEnabled: function createIfEnabled(_ref21) {
        var enabled = _ref21.enabled,
            solution = _ref21.solution,
            challenge = _ref21.challenge,
            initialFilesGetter = _ref21.initialFilesGetter;

        var svc = void 0;
        if (enabled) {
          try {
            svc = this.create({ solution: solution, challenge: challenge, initialFilesGetter: initialFilesGetter });
          } catch (err) {
            // $log.error automatically sends to Sentry
            $log.error('[SmartIDE] Failed to create workspace', {
              error: err.message || String(err),
              challengeId: challenge && challenge.id,
              language: challenge && challenge.runConfig && challenge.runConfig.language,
              languageVersion: challenge && challenge.runConfig && challenge.runConfig.languageVersion,
              hasLanguageServers: !!(challenge && challenge.runConfig && challenge.runConfig.languageServers && challenge.runConfig.languageServers.length),
              solutionId: solution && solution.id
            }, err);
          }
        }
        return svc || eventEmitter({
          enabled: false,
          status: WORKSPACE_STATUS.DISABLED,
          initializeFiles: $q.resolve,
          addFile: $q.resolve,
          updateFile: $q.resolve,
          deleteFile: $q.resolve,
          renameFile: $q.resolve,
          hideAllPopups: noop,
          enablePopups: noop,
          openEditor: noop,
          saveOpenFile: $q.resolve,
          saveAllFiles: $q.resolve,
          closeFile: $q.resolve,
          destroy: noop
        });
      },

      /**
       * Creates a workspace manager. Requires either challenge or solution & solution.challenge.
       *
       * @param {Solution?} solution - If provided, will be used to determine language server
       * @param {Challenge?} challenge - If provided, will be used to determine language server
       * @param {Function?} initialFilesGetter - If provided, configures the unopened files automatically.
       */
      // eslint-disable-next-line no-unused-vars
      create: function create() {
        var _this3 = this;

        var _ref22 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            solution = _ref22.solution,
            _ref22$challenge = _ref22.challenge,
            challenge = _ref22$challenge === undefined ? solution && solution.challenge : _ref22$challenge,
            _ref22$initialFilesGe = _ref22.initialFilesGetter,
            initialFilesGetter = _ref22$initialFilesGe === undefined ? noop : _ref22$initialFilesGe;

        if (!$window.CodeMirrorWorkspace) {
          throw new Error('Unable to find CodeMirrorWorkspace');
        }
        if (!challenge) {
          throw new Error('Missing required challenge');
        }

        var runConfig = challenge.runConfig;
        var supportedServers = new Set(runConfig.languageServers || []);
        var _disconnectedAt = null;
        var smartIdeSessionId = generateSmartIdeSessionId();
        if (supportedServers.size === 0) {
          // REVIEW This should probably be checked in `createIfEnabled` instead.
          throw new Error('No Language Server is available');
        }
        // Shared state for this workspace — passed by reference to every openEditor call
        // so all editors report startup metrics against the same workspace start time.
        var workspaceState = {
          startTime: Date.now(),
          lspStartupRecorded: false,
          firstTypingRecorded: false
        };

        // REVIEW Creating `LanguageServerController` starts Proxy service based on `runConfig`.
        var controller = new LanguageServerController({
          url: configService.config.languageServerUrl,
          runConfig: runConfig,
          $log: $log,
          initialFilesGetter: initialFilesGetter,
          context: {
            smartIdeSessionId: smartIdeSessionId,
            assessmentId: solution && solution.assessmentId || solution && solution.assessment && solution.assessment.id,
            challengeId: challenge && challenge.id,
            solutionId: solution && solution.id,
            candidateId: appConfig.candidateApp && solution && solution.candidateId,
            teamMemberId: !appConfig.candidateApp && solution && solution.teamMemberId,
            language: runConfig && runConfig.language,
            languageVersion: runConfig && runConfig.languageVersion,
            preset: runConfig && runConfig.preset
          },
          authorize: function authorize() {
            return $http.post(appConfig.baseApiRoot + 'service_auth', {
              service: 'language_server',
              teamId: challenge.teamId
            }).then(function (resp) {
              return resp.data.token;
            });
          }
        });

        var getLanguageInfo = function getLanguageInfo(uri) {
          var lang = languages.langFromFilename(uri);
          if (!lang || !(lang.languageServerIds || []).length) return null;

          return {
            languageId: lang.languageId,
            languageServerIds: lang.languageServerIds
          };
        };

        // This error happens when we dispose (destroy) the workspace while a request is in-progress.
        // We can always ignore these errors.
        var isDisposeError = function isDisposeError(err) {
          return (/pending response rejected/i.test(err) || /request cancelled/i.test(err)
          );
        };
        // Both handlers below run per file operation, so an unrecoverable
        // proxy reports through them on every keystroke. Dedupe per distinct
        // failure for the life of this workspace.
        var reportFailure = createFailureReporter($log);

        var catchAndIgnoreDisposeErrors = function catchAndIgnoreDisposeErrors(err) {
          if (!isDisposeError(err)) {
            // Reported once per distinct error - $log.error sends to Sentry
            reportFailure('[SmartIDE] Workspace operation failed:', err, {
              error: err.message || String(err),
              language: runConfig.language,
              languageVersion: runConfig.languageVersion,
              challengeId: challenge.id,
              solutionId: solution && solution.id
            });
            return $q.reject(err);
          }
        };

        var catchLog = function catchLog(err) {
          if (!isDisposeError(err)) {
            // Reported once per distinct error - $log.error sends to Sentry
            reportFailure('[SmartIDE] Cleanup operation failed:', err, {
              error: err.message || String(err),
              language: runConfig.language,
              challengeId: challenge.id
            });
          }
          return err;
        };

        // Wrap workspace creation to catch any errors from CodeMirrorWorkspace
        var workspace = void 0;
        try {
          // Set base context immediately so any early errors get tagged.
          sentrySetSmartIdeContext({
            smartIdeSessionId: smartIdeSessionId,
            challengeId: challenge && challenge.id,
            solutionId: solution && solution.id,
            language: runConfig && runConfig.language,
            languageVersion: runConfig && runConfig.languageVersion,
            preset: runConfig && runConfig.preset
          });

          workspace = new $window.CodeMirrorWorkspace({
            // Using relative URI.
            // Proxy remaps to appropriate file path.
            rootUri: 'source://',
            getLanguageAssociation: function getLanguageAssociation(uri) {
              var info = getLanguageInfo(uri);
              if (!info) return null;

              var languageServerIds = info.languageServerIds.filter(function (id) {
                return supportedServers.has(id);
              });
              if (languageServerIds.length === 0) return null;
              return {
                languageId: info.languageId,
                languageServerIds: languageServerIds
              };
            },
            getConnectionString: function () {
              var _ref23 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(id) {
                var connStartTime, url;
                return regeneratorRuntime.wrap(function _callee17$(_context17) {
                  while (1) {
                    switch (_context17.prev = _context17.next) {
                      case 0:
                        if (id) {
                          _context17.next = 2;
                          break;
                        }

                        return _context17.abrupt('return', '');

                      case 2:
                        connStartTime = Date.now();

                        sentryBreadcrumb('LSP getConnectionString', {
                          serverId: id,
                          language: runConfig.language
                        });

                        // Keep server id on the Sentry scope for any connection-related errors.
                        sentrySetSmartIdeContext({
                          smartIdeSessionId: smartIdeSessionId,
                          serverId: id,
                          challengeId: challenge && challenge.id,
                          solutionId: solution && solution.id,
                          language: runConfig && runConfig.language,
                          languageVersion: runConfig && runConfig.languageVersion,
                          preset: runConfig && runConfig.preset
                        });
                        _context17.next = 7;
                        return controller.start(id);

                      case 7:
                        url = _context17.sent;

                        sentryMeasure('lsp.getConnectionString', Date.now() - connStartTime, { serverId: id, language: runConfig.language });
                        return _context17.abrupt('return', url);

                      case 10:
                      case 'end':
                        return _context17.stop();
                    }
                  }
                }, _callee17, _this3);
              }));

              function getConnectionString(_x19) {
                return _ref23.apply(this, arguments);
              }

              return getConnectionString;
            }(),
            onDisconnected: function onDisconnected(serverId) {
              _disconnectedAt = Date.now();
              var tabHidden = document.visibilityState === 'hidden';
              sentryBreadcrumb('LSP server disconnected', {
                serverId: serverId,
                language: runConfig.language,
                languageVersion: runConfig.languageVersion,
                challengeId: challenge.id,
                tabHidden: tabHidden,
                cause: tabHidden ? 'browser_tab_background' : 'unknown'
              }, 'warning');
              $log.warn('[SmartIDE] LSP server disconnected, attempting to reconnect...', {
                serverId: serverId,
                language: runConfig.language,
                languageVersion: runConfig.languageVersion,
                challengeId: challenge.id,
                solutionId: solution && solution.id,
                tabHidden: tabHidden,
                cause: tabHidden ? 'browser_tab_background' : 'unknown'
              });
              setStatus(WORKSPACE_STATUS.CONNECTION_RETRYING);
            },
            onReconnected: function onReconnected(serverId) {
              var downtime = _disconnectedAt ? Date.now() - _disconnectedAt : 0;
              sentryMeasure('lsp.reconnection.downtime', downtime, {
                serverId: serverId,
                language: runConfig.language,
                challengeId: challenge.id
              });
              sentryBreadcrumb('LSP server reconnected', {
                serverId: serverId,
                language: runConfig.language,
                downtimeMs: downtime
              });
              _disconnectedAt = null;
              $log.info('[SmartIDE] LSP server reconnected successfully', {
                serverId: serverId,
                language: runConfig.language
              });
              setStatus();
              // Reconnected to the server and finished re-initialization.
              // Sync the files if necessary.
              // It's possible that the files are out of sync now if files were changed while the connection was down.
              // This function should return `Promise<void>` that resolves after `workspace.notifyFilesChanged(changes)`.
              // The event handlers related to the connection is reattached to the editors after this.
              return Promise.resolve();
            },
            onConnectionFailed: function onConnectionFailed(serverId) {
              var downtime = _disconnectedAt ? Date.now() - _disconnectedAt : 0;
              var tabHidden = document.visibilityState === 'hidden';
              var cause = tabHidden ? 'browser_tab_background' : 'server_or_network_error';
              sentryBreadcrumb('LSP connection failed permanently', {
                serverId: serverId,
                language: runConfig.language,
                languageVersion: runConfig.languageVersion,
                preset: runConfig.preset,
                challengeId: challenge.id,
                downtimeMs: downtime,
                tabHidden: tabHidden,
                cause: cause
              }, tabHidden ? 'warning' : 'error');
              _disconnectedAt = null;
              if (tabHidden) {
                // Tab was in background - browser throttled WebSocket pings.
                // Not a real error, log as warning to avoid Sentry noise.
                $log.warn('[SmartIDE] LSP connection lost (tab was in background)', {
                  serverId: serverId,
                  language: runConfig.language,
                  languageVersion: runConfig.languageVersion,
                  preset: runConfig.preset,
                  challengeId: challenge.id,
                  solutionId: solution && solution.id,
                  downtimeMs: downtime,
                  cause: cause
                });
              } else {
                // Real failure - $log.error automatically sends to Sentry
                $log.error('[SmartIDE] LSP server connection failed permanently', {
                  serverId: serverId,
                  language: runConfig.language,
                  languageVersion: runConfig.languageVersion,
                  preset: runConfig.preset,
                  challengeId: challenge.id,
                  solutionId: solution && solution.id,
                  downtimeMs: downtime,
                  cause: cause
                });
              }
              // Failed all the reconnection attempts — the proxy is gone.
              // Respawn it once so the candidate isn't left with a dead IDE
              // for the rest of a timed assessment.
              respawnProxy(cause);
            },
            renderMarkdown: marked,
            configs: {
              'pyright-langserver': {
                settings: {
                  python: {
                    analysis: {
                      autoSearchPaths: true,
                      useLibraryCodeForTypes: true,
                      diagnosticMode: 'openFiles'
                    }
                  }
                }
              },
              'typescript-language-server': {
                settings: {
                  diagnostics: {
                    ignoredCodes: [
                    // Ignore confusing "File is a CommonJS module; it may be converted to an ES6 module."
                    80001]
                  }
                }
              },
              'vue-language-server': {
                initOptions: {
                  typescript: {
                    // Need to pass absolute path to `tsserverlibrary` :(
                    serverPath: '/workspace/vue/node_modules/typescript/lib/tsserverlibrary.js',
                    localizedPath: null
                  },
                  languageFeatures: {
                    hover: true,
                    signatureHelp: true,
                    diagnostics: true,
                    references: true,
                    implementation: true,
                    definition: true,
                    typeDefinition: true,
                    documentHighlight: true,
                    documentLink: true,
                    completion: {
                      defaultTagNameCase: 'both',
                      defaultAttrNameCase: 'kebabCase',
                      getDocumentNameCasesRequest: false,
                      getDocumentSelectionRequest: false
                    }
                  }
                }
              }
            }
          });
        } catch (err) {
          $log.error('[SmartIDE] Failed to initialize CodeMirrorWorkspace', {
            error: err.message || String(err),
            language: runConfig.language,
            languageVersion: runConfig.languageVersion,
            challengeId: challenge.id
          }, err);
          throw err;
        }

        // Monkey-patch workspace methods to capture LSP errors that might be swallowed
        var originalOpenTextDocument = workspace.openTextDocument;
        workspace.openTextDocument = function (path, codemirror) {
          return originalOpenTextDocument.call(workspace, path, codemirror).catch(function (err) {
            // This catch will capture errors from the LSP that openTextDocument might swallow
            if (!isDisposeError(err)) {
              $log.error('[SmartIDE] LSP error in openTextDocument', {
                path: path,
                error: err.message || String(err),
                language: runConfig.language
              }, err);
            }
            throw err;
          });
        };

        /**
         * Returns a simplified file object with a mapped path (mapped for reference files).
         * The method returns false in the following circumstances
         * - the file is not present
         * - it is a directory
         * - it is missing the path
         * - it is hidden, and we have a solution
         * - it is a reference file, and we have a solution
         * @param file
         * @returns {boolean|{path: string, contents: string}}
         * @private
         */
        var _mappedFile = function _mappedFile(file) {
          if (!file || file.directory || !file.path || solution && file.hidden || solution && file.reference) {
            return false;
          }
          var path = file.path;
          if (file.reference) {
            path = '$ref/' + path;
          }
          return { contents: file.contents, path: path };
        };

        var connectingEditors = {};
        // path -> {file, codemirror}, so a respawned proxy can reattach the
        // editors the candidate actually has open.
        var openEditors = {};
        var openEditorList = function openEditorList() {
          return Object.keys(openEditors).map(function (p) {
            return openEditors[p];
          });
        };

        var svc = {
          enabled: true,
          status: WORKSPACE_STATUS.NEW,

          initializeFiles: tryFunction(function (files) {
            var mapped = files.map(_mappedFile).filter(identity);
            return $q.resolve(controller.writeFiles(mapped)).catch(catchAndIgnoreDisposeErrors).then(function (changes) {
              return changes && workspace.notifyFilesChanged(changes);
            });
          }),
          addFile: tryFunction(function (file) {
            var mappedFile = _mappedFile(file);
            if (!mappedFile) return $q.resolve();

            return $q.resolve(controller.writeFile(mappedFile)).catch(catchAndIgnoreDisposeErrors).then(function (changes) {
              return changes && workspace.notifyFilesChanged(changes);
            });
          }),
          updateFile: tryFunction(function (file) {
            var mappedFile = _mappedFile(file);
            if (!mappedFile) return $q.resolve();

            return $q.resolve(controller.writeFile(mappedFile)).catch(catchAndIgnoreDisposeErrors).then(function (changes) {
              return changes && workspace.notifyFilesChanged(changes);
            });
          }),
          deleteFile: tryFunction(function (file) {
            var mappedFile = _mappedFile(file);
            if (!mappedFile) return $q.resolve();

            return $q.resolve(controller.removeFile(mappedFile.path)).catch(catchAndIgnoreDisposeErrors).then(function (changes) {
              return changes && workspace.notifyFilesChanged(changes);
            });
          }),
          renameFile: tryFunction(function (file, oldPath) {
            var mappedFile = _mappedFile(file);
            if (!mappedFile) return $q.resolve();

            return $q.resolve(controller.renameFile(oldPath, mappedFile.path)).catch(catchAndIgnoreDisposeErrors).then(function (changes) {
              return changes && workspace.notifyFilesChanged(changes);
            });
          }),
          hideAllPopups: tryFunction(function () {
            workspace.hideAllPopups();
          }),
          enablePopups: tryFunction(function (popupsEnabled) {
            workspace.enablePopups(popupsEnabled);
          }),

          /**
           * Opens a file in an editor within the workspace
           */
          openEditor: tryFunction(function (file, codemirror) {
            var mappedFile = _mappedFile(file);
            if (!mappedFile) return;
            var path = mappedFile.path;

            openEditors[path] = { file: file, codemirror: codemirror };
            connectingEditors[path] = Date.now();
            var openStartTime = Date.now();
            sentryBreadcrumb('LSP openEditor start', {
              path: path,
              language: runConfig.language
            });

            setStatus();

            return $q.resolve(workspace.openTextDocument(path, codemirror)).then(function () {
              var openDuration = Date.now() - openStartTime;
              sentryMeasure('lsp.openEditor', openDuration, {
                path: path,
                language: runConfig.language,
                challengeId: challenge.id
              });
              sentryBreadcrumb('LSP openEditor complete', {
                path: path,
                durationMs: openDuration
              });

              if (!workspaceState.lspStartupRecorded && workspaceState.startTime) {
                workspaceState.lspStartupRecorded = true;
                controller.emitStartupResult('ok', {
                  duration_ms: Date.now() - workspaceState.startTime,
                  reason: 'open_text_document_ready'
                });
                trackPerformance('smartide.lsp.startup', {
                  duration_ms: Date.now() - workspaceState.startTime,
                  preset: runConfig.preset,
                  language: runConfig.language,
                  session_id: smartIdeSessionId,
                  status: 'ok',
                  challenge_id: challenge.id,
                  solution_id: solution && solution.id,
                  assessment_id: solution && solution.assessmentId || solution && solution.assessment && solution.assessment.id
                });
              }

              // Attach typing tracker now that the editor is opened within the workspace.
              // This enables the global showHint wrapper to record time-to-first-autocomplete.
              attachSmartIdeFirstTypingTracker(codemirror, {
                filePath: path,
                language: runConfig.language,
                languageVersion: runConfig.languageVersion,
                preset: runConfig.preset,
                challengeId: challenge.id,
                solutionId: solution && solution.id,
                assessmentId: solution && solution.assessmentId || solution && solution.assessment && solution.assessment.id,
                workspaceState: workspaceState
              }, $interval, $timeout);

              delete connectingEditors[path];
              setStatus();
            }).catch(function (err) {
              delete connectingEditors[path]; // should we keep it here?
              if (isDisposeError(err)) return;

              // $log.error automatically sends to Sentry with context
              $log.error('[SmartIDE] Failed to open editor', {
                filePath: path,
                language: runConfig.language,
                languageVersion: runConfig.languageVersion,
                errorMessage: err.message || String(err),
                challengeId: challenge.id,
                solutionId: solution && solution.id
              }, err);

              controller.emitStartupResult('connection_failed', {
                reason: 'open_text_document_failed'
              });

              // A failed proxy takes every open editor down with it. Don't
              // let those knock-on failures downgrade the terminal status
              // the candidate was just alerted about.
              if (svc.status !== WORKSPACE_STATUS.CONNECTION_FAILED) {
                setStatus(WORKSPACE_STATUS.CONNECTION_ERROR);
              }
              return $q.reject(err);
            });
          }),

          /**
           * Saves changes to an open file back to the workspace,
           * which can be used even while the file isn't open
           */
          saveOpenFile: tryFunction(function (file) {
            var mappedFile = _mappedFile(file);
            if (!mappedFile) return $q.resolve();

            return $q.resolve(workspace.saveTextDocument(mappedFile.path)).catch(catchAndIgnoreDisposeErrors);
          }),

          /**
           * saves all open files
           */
          saveAllFiles: function saveAllFiles() {
            // `saveOpenFile` expects a file, not a path -- passing a path
            // makes `_mappedFile` return false and the save a no-op.
            return $q.all(openEditorList().map(function (e) {
              return svc.saveOpenFile(e.file);
            }));
          },

          /**
           * Closes an open file (*does not save the file*
           */
          closeFile: tryFunction(function (file) {
            var mappedFile = _mappedFile(file);
            if (!mappedFile) return $q.resolve();
            var path = mappedFile.path;

            delete openEditors[path];

            return $q.resolve(workspace.closeTextDocument(path)).catch(catchLog).then(function () {
              delete connectingEditors[path];
              setStatus();
            });
          }),
          destroy: tryFunction(function () {
            // destroy all listeners
            svc.off(true);
            setStatus(WORKSPACE_STATUS.DESTROYING);
            var destroyed = controller.destroyProxy().catch(catchLog);
            // The closes now actually run (they used to be handed a path,
            // which `_mappedFile` rejected), so they have to finish before
            // dispose or every `closeTextDocument` races the teardown.
            return $q.all(openEditorList().map(function (e) {
              return svc.closeFile(e.file);
            })).then(function () {
              return workspace.dispose();
            }).catch(catchLog).then(function () {
              return destroyed;
            }).then(function () {
              setStatus(WORKSPACE_STATUS.DISABLED);
              sentryClearSmartIdeContext();
            });
          })
        };

        eventEmitter(svc);

        function setStatus(status) {
          if (!status) {
            // if there are no editors, we're connected
            status = WORKSPACE_STATUS.CONNECTED;

            var _now = Date.now();
            Object.keys(connectingEditors).forEach(function (k) {
              var delay = _now - connectingEditors[k];
              if (delay > CONNECTING_WAIT_ERROR) {
                // if it has taken too long, show an error
                status = WORKSPACE_STATUS.CONNECTION_ERROR;
              } else if (status === WORKSPACE_STATUS.CONNECTED) {
                if (delay > CONNECTING_WAIT_DELAY) {
                  // if it is taking a while for any of them, show a warning color
                  status = WORKSPACE_STATUS.CONNECTION_DELAY;
                } else {
                  // otherwise just show that we're connecting
                  status = WORKSPACE_STATUS.CONNECTING;
                }
              }
            });
          }
          var oldStatus = svc.status;
          svc.status = status;
          if (oldStatus !== status) {
            svc.emit(status);
          }
        }

        /**
         * Replaces a dead proxy, re-seeds its workspace files, and reattaches
         * the open editors to it. `controller.respawn()` is one-shot, so a
         * second failure lands the workspace in CONNECTION_FAILED for good.
         *
         * @param {string} cause - Why the connection failed, for telemetry
         * @returns {Promise} Resolves once the workspace has settled
         */
        function respawnProxy(cause) {
          var failed = function failed() {
            controller.emitStartupResult('connection_failed', {
              reason: cause
            });
            setStatus(WORKSPACE_STATUS.CONNECTION_FAILED);
          };

          var editors = openEditorList();

          setStatus(WORKSPACE_STATUS.CONNECTION_RETRYING);
          return $q.resolve(controller.respawn()).then(function (proxy) {
            if (!proxy) return failed();
            return reattachEditors({
              svc: svc,
              editors: editors,
              files: initialFilesGetter && initialFilesGetter(),
              all: function all(promises) {
                return $q.all(promises);
              }
            }).then(function () {
              return setStatus();
            });
          }).catch(failed);
        }

        controller.proxy.then(function () {
          if (initialFilesGetter) {
            svc.initializeFiles(initialFilesGetter());
          }
        }).catch(function () {
          // A pod that never came up is a dead proxy like any other, so it
          // recovers through the same one path: `respawnProxy` re-seeds the
          // replacement's files, reattaches the editors, moves the status
          // and reports the outcome. Rebuilding from `start()` instead
          // would hand the candidate a pod with none of the challenge
          // files on it, which reads as a working IDE giving wrong answers.
          // One shot, then CONNECTION_FAILED and its actionable alert.
          respawnProxy('proxy_creation_failed');
        });

        return svc;
      }
    };
  }]);

  var _TYPE_KEYS, _TYPE_NAMES, _TYPE_TOOLTIPS;

  var GLOBAL_COLLECTION = 'commons';
  var TEAM_COLLECTION = 'team';

  var INCLUDE_SOLUTIONS_REGEX = /(\s*(?:\/\/|#|--|;;|%%)\s*)@include-solution-from ([0-9a-fA-F]{24})[^\n]*/;
  var INCLUDE_SOLUTIONS_REGEX_GLOBAL = new RegExp(INCLUDE_SOLUTIONS_REGEX, 'g');

  var CODE_CHALLENGE_TYPE = 'CodeChallenge';
  var ADVANCED_CODE_CHALLENGE_TYPE = 'AdvancedCodeChallenge';
  var QUIZ_CHALLENGE_TYPE = 'QuizChallenge';
  var TYPE_KEYS = (_TYPE_KEYS = {}, defineProperty(_TYPE_KEYS, CODE_CHALLENGE_TYPE, 'code'), defineProperty(_TYPE_KEYS, ADVANCED_CODE_CHALLENGE_TYPE, 'advanced-code'), defineProperty(_TYPE_KEYS, QUIZ_CHALLENGE_TYPE, 'quiz'), _TYPE_KEYS);
  var TYPE_NAMES = (_TYPE_NAMES = {}, defineProperty(_TYPE_NAMES, CODE_CHALLENGE_TYPE, 'Code'), defineProperty(_TYPE_NAMES, ADVANCED_CODE_CHALLENGE_TYPE, 'Project Code'), defineProperty(_TYPE_NAMES, QUIZ_CHALLENGE_TYPE, 'Q&A'), _TYPE_NAMES);
  var TYPE_TOOLTIPS = (_TYPE_TOOLTIPS = {}, defineProperty(_TYPE_TOOLTIPS, CODE_CHALLENGE_TYPE, 'A simplified coding based challenge, designed around a single editor for the solution'), defineProperty(_TYPE_TOOLTIPS, ADVANCED_CODE_CHALLENGE_TYPE, 'An advanced coding based challenge, with multiple file support and additional features'), defineProperty(_TYPE_TOOLTIPS, QUIZ_CHALLENGE_TYPE, 'A quiz-like challenge with questions and answers, not necessarily code-related'), _TYPE_TOOLTIPS);

  var UPDATE_VERSION = {
    MAJOR: 'major',
    MINOR: 'minor',
    PATCH: 'patch'
  };

  var LIBRARY_ACCESS = ['limited', 'standard', 'extended'];

  var CHALLENGE_INITIAL_LAYOUT_DEFAULT = {
    instructions: 'topRight:1:1',
    webpreview: 'topRight:2',
    candidatenotes: 'topRight:3',
    help: 'topRight:4'
  };

  var DEFAULT_ESTIMATED_TIME = 5;

  var challengeModelModule = angular.module('Q.models.challenge', [modelHelperModule, challengeItemModelModule, quizQuestionModelModule, codeFileModelModule]).run(['$rootScope', function ($rootScope) {
    var unlisten = $rootScope.$on('app.login', function (event) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          account = _ref.account;

      if (account && account.user && account.user.team) {
        if (account.user.team.hasFeature('advancedCodeChallenges')) {
          // if you have access to project challenges, we rename classic challenges
          TYPE_NAMES[CODE_CHALLENGE_TYPE] = 'Classic Code';
        }
        unlisten();
      }
    });
  }]).factory('Challenge', ['DS', 'ModelHelper', '$q', '$rootScope', '$injector', '$log', 'AdvancedCodeChallengeFile', 'AdvancedCodeChallengeReferenceFile', function (DS, ModelHelper, $q, $rootScope, $injector, $log, AdvancedCodeChallengeFile, AdvancedCodeChallengeReferenceFile) {
    var difficultiesList = [{
      id: 1,
      label: 'Basic',
      filter: { '<=': 1 } // includes any value lower than 0 for filtering
    }, {
      id: 2,
      label: 'Intermediate',
      filter: 2
    }, {
      id: 3,
      label: 'Advanced',
      filter: { '>=': 3 } // Include Advanced and up for filtering
    }, {
      id: 4,
      label: 'Advanced (Brutal)',
      filter: { '>=': 3 }, // Include Advanced and up for filtering
      hidden: true // hide for filters, meters, etc
    }];

    var difficulties = {};
    difficultiesList.forEach(function (_ref2) {
      var id = _ref2.id,
          label = _ref2.label;

      difficulties[id] = label;
    });

    var stateNameMappings = {
      draft: 'Draft',
      published: 'Published',
      archived: 'Archived'
    };

    var contentTypeMappings = {
      normal: 'Ready To Use',
      template: 'Template',
      tutorial: 'Tutorials'
    };

    var _afterInject = function _afterInject(instance) {
      delete instance.$languages;
      delete instance.$smartIdeAvailable;
      if (instance.$type === ADVANCED_CODE_CHALLENGE_TYPE && !instance.initialLayout) {
        instance.initialLayout = angular.copy(CHALLENGE_INITIAL_LAYOUT_DEFAULT);
      }
    };

    /**
     * Returns the correct team to be looking at for feature checks
     * If the current user has a team (i.e., is a TeamMember), then we use that. Otherwise we use the team
     * associated with this instance (if available)
     * @param {Challenge} instance
     * @returns {Team|null}
     */
    var getFeatureTeam = function getFeatureTeam(instance) {
      return getTeam($injector) || instance.team;
    };

    var shouldFind = function shouldFind() {
      var user = getUser($injector);
      return user && user.$type !== 'Candidate';
    };

    var Challenge = ModelHelper.defineResource({
      name: 'Challenge',
      endpoint: 'challenges',
      afterInject: function afterInject(resource, instance) {
        ModelHelper.afterInject(resource, instance);
        // after we inject or update a solution, we should always remove any cached revisions,
        // because they will never be updated
        if (Array.isArray(instance)) {
          instance.forEach(_afterInject);
        } else {
          _afterInject(instance);
        }
      },

      relations: {
        hasMany: {
          QuizQuestion: {
            $type: 'QuizChallenge',
            localField: 'questions',
            link: false
          },
          AdvancedCodeChallengeFile: {
            $type: 'AdvancedCodeChallenge',
            localField: 'files',
            link: false
          },
          AdvancedCodeChallengeReferenceFile: {
            $type: 'AdvancedCodeChallenge',
            localField: 'referenceFiles',
            link: false
          }
        },
        hasOne: {
          ChallengeItem: {
            foreignKey: 'challengeId',
            foreignField: 'challenge'
          },
          Challenge: [{
            localField: 'sourcedFrom',
            localKey: 'sourcedFromId'
          }, {
            localField: 'copiedFrom',
            localKey: 'copiedFromId'
          }]
        },
        belongsTo: {
          Team: {
            localField: 'team',
            localKey: 'teamId'
          },
          TeamMember: [{
            localField: 'createdBy',
            localKey: 'createdById'
          }]
        }
      },
      computed: {
        selectTitle: /* @ngInject */['title', 'demoData', function selectTitle(title, demoData) {
          return title + (demoData ? ' (DEMO)' : '');
        }],
        icon: {
          get: function get$$1() {
            if (!this.galleryImage) {
              if (this.isClassicCode() && this.languages.length === 1 && languages[this.languages[0].name]) {
                return 'lang-' + languages[this.languages[0].name].id;
              } else if (this.isAdvancedCode() && this.runConfig && languages[this.runConfig.language]) {
                return 'lang-' + languages[this.runConfig.language].id;
              } else if (this.isQuiz()) {
                return 'quiz';
              }
            }
          }
        },
        // Returns topics which may be filtered due to similar signal subjects being shown
        signalTopics: {
          get: function get$$1() {
            var topics = this.topics;
            var subjects = compactFalsy((this.getSubjects() || []).map(function (s) {
              return s.label;
            }));
            if (empty$1(topics) || empty$1(subjects)) return topics;

            // filter out any topics which are redundant with subjects
            return topics.filter(function (topic) {
              return !subjects.find(function (s) {
                return s.includes(topic);
              });
            });
          }
        }
      },
      methods: {
        _runConfig: function _runConfig() {
          return this.runConfig || {};
        },
        isGlobal: function isGlobal() {
          return this.collection === GLOBAL_COLLECTION;
        },
        isLinked: function isLinked() {
          return !this.isGlobal() && this.linkedStatus;
        },
        isTeam: function isTeam() {
          return this.collection === TEAM_COLLECTION;
        },
        difficultyName: function difficultyName() {
          return difficulties[this.difficulty];
        },
        stateName: function stateName() {
          return this.isGlobal() ? contentTypeMappings[this.contentType] : stateNameMappings[this.state];
        },
        typeKey: function typeKey() {
          return TYPE_KEYS[this.$type] || TYPE_KEYS[CODE_CHALLENGE_TYPE];
        },
        typeName: function typeName() {
          return TYPE_NAMES[this.$type] || TYPE_NAMES[CODE_CHALLENGE_TYPE];
        },
        typeTooltip: function typeTooltip() {
          return TYPE_TOOLTIPS[this.$type] || TYPE_TOOLTIPS[CODE_CHALLENGE_TYPE];
        },
        typeState: function typeState() {
          return lcFirst(this.$type || CODE_CHALLENGE_TYPE);
        },
        typeSuffix: function typeSuffix() {
          return this.isQuestionTimed() ? ' with question time limits' : '';
        },
        isCode: function isCode() {
          return this.isClassicCode() || this.isAdvancedCode();
        },
        isClassicCode: function isClassicCode() {
          return this.$type === CODE_CHALLENGE_TYPE;
        },
        isAdvancedCode: function isAdvancedCode() {
          return this.$type === ADVANCED_CODE_CHALLENGE_TYPE;
        },
        isQuiz: function isQuiz() {
          return this.$type === QUIZ_CHALLENGE_TYPE;
        },
        webPreviews: function webPreviews() {
          return this._runConfig().webPreviews;
        },
        versionsArray: function versionsArray() {
          return [this.majorVersion, this.minorVersion, this.patchVersion];
        },
        hasVersion: function hasVersion() {
          var versions = this.versionsArray();
          return versions.filter(angular.isNumber).length === versions.length && versions.some(function (v) {
            return v > 0;
          });
        },
        fullVersion: function fullVersion() {
          return this.versionsArray().join('.');
        },
        scoringSummary: function scoringSummary() {
          if (this.isQuiz()) {
            var questions = this.questions || [];
            var points = questions.reduce(function (s, q) {
              return s + (angular.isNumber(+q.weight) ? q.weight : 1);
            }, 0);
            var summary = questions.length + ' question' + (questions.length === 1 ? '' : 's');
            if (points === 0) {
              summary += ' (none scored)';
            } else {
              summary += ' worth ' + points + ' point' + (points === 1 ? '' : 's');
            }
            return summary;
          }
          return '';
        },
        canEdit: function canEdit() {
          return this.isTeam() && !this.protected && $rootScope.permitted({ privilege: 'manageChallenges' });
        },
        canPublish: function canPublish() {
          return this.canEdit() && Challenge.canPublish(this);
        },
        trackProperties: function trackProperties() {
          return {
            title: this.title,
            id: this.id,
            teamId: this.teamId,
            state: this.state,
            summary: this.summary,
            copiedById: this.copiedById,
            createdById: this.createdById,
            difficulty: this.difficulty
          };
        },
        loadSourcedFrom: function loadSourcedFrom() {
          var _this = this;

          return Challenge.loadSourcedFrom([this]).then(function () {
            return _this;
          });
        },
        globalChallenge: function globalChallenge() {
          if (!this.isGlobal() && this.sourcedFrom) {
            var cf = this.sourcedFrom;
            if (cf.contentType === 'normal' && cf.isGlobal()) {
              return cf;
            }
          }
          return null;
        },
        hasStats: function hasStats(type, language) {
          var stats = this.stats(type, language);
          var globalStats = this.globalStats(type, language);
          // ignore if only one result
          return !!(stats && stats.count > 1) || !!(globalStats && globalStats.count > 1);
        },
        stats: function stats(type, language) {
          var name = type + 'Stats';
          var challengeLanguage = language && this.language && this.language(language);
          return challengeLanguage && challengeLanguage[name] || this[name];
        },
        globalStats: function globalStats(type, language) {
          var gc = this.globalChallenge();
          return gc && gc.stats(type, language);
        },
        hasPremiumAccess: function hasPremiumAccess() {
          return this.libraryAccess && this.libraryAccess !== 'limited';
        },
        hasChallengeTimeLimit: function hasChallengeTimeLimit(val) {
          if (val === undefined) {
            // we're specifically only tracking null here so you can safely edit the number
            return this.timeLimitMin !== null;
          } else {
            this.timeLimitMin = val ? 60 : null;
            // scored notes are only locked by a time limit, so don't leave the flag set without one
            if (!val) this.candidateNotesScored = false;
          }
        },

        // Placeholder for the candidate Your Notes tab: author text, else the default
        candidateNotesPlaceholder: function candidateNotesPlaceholder() {
          var noun = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'solution';

          var custom = (this.candidateNotesTemplate || '').trim();
          return custom || 'Add notes about your ' + noun + ' to help explain your process.\n\nThis is markdown-enabled, so feel free to include code snippets, lists, etc.';
        },

        // For quizzes, rely on timeLimitType, otherwise use timeLimitMin
        isUntimed: function isUntimed() {
          return this.timeLimitType ? this.timeLimitType === 'none' : !this.isTimed();
        },

        // For quizzes, rely on timeLimitType, otherwise use timeLimitMin
        isTimed: function isTimed() {
          return this.timeLimitType ? this.timeLimitType === 'challenge' : this.timeLimitMin > 0;
        },
        isQuestionTimed: function isQuestionTimed() {
          return (/^per_question/.test(this.timeLimitType)
          );
        },
        isBonusTimed: function isBonusTimed() {
          return this.timeLimitType === 'per_question_bonus';
        },
        totalTimeLimitMin: function totalTimeLimitMin() {
          var _this2 = this;

          if (this.isQuestionTimed()) {
            var timeLimitSec = (this.questions || []).map(function (q) {
              return q._timeLimitSec(_this2);
            }).reduce(function (sum, sec) {
              return sum + sec;
            }, 0);
            return Math.round(timeLimitSec / 60) || Infinity;
          } else {
            return this.isTimed() ? this.timeLimitMin : Infinity;
          }
        },
        timeLimitTypeLabel: function timeLimitTypeLabel() {
          return Challenge.getEnum('timeLimitType', this.timeLimitType || 'none');
        },
        expectedTime: function expectedTime() {
          var timeLimit = this.totalTimeLimitMin();
          var estimatedTime = this.estimatedTime;
          var time = DEFAULT_ESTIMATED_TIME;
          if (estimatedTime) {
            time = Math.min(estimatedTime, timeLimit);
          } else if (timeLimit < Infinity) {
            time = timeLimit;
          }
          return time;
        },
        hasLimitedSubmissionAttempts: function hasLimitedSubmissionAttempts(val) {
          if (val === undefined) {
            // we're specifically only tracking null here so you can safely edit the number
            return this.limitSubmissionAttempts !== null;
          } else {
            this.limitSubmissionAttempts = val ? 3 : null;
          }
        },

        // matches assessment-template function for template consistency
        upgradeRequired: function upgradeRequired() {
          return this.requiresUpgrade;
        },
        requiresUpgradeLabel: function requiresUpgradeLabel() {
          var team = getTeam($injector);
          if (this.isAdvancedCode() && (!team || !team.hasFeature('advancedCodeChallenges'))) {
            return 'Project Code Challenges';
          }
          return ucFirst(this.libraryAccess) + ' Library';
        },
        premiumFeature: function premiumFeature() {
          var team = getTeam($injector);
          if (this.isAdvancedCode() && (!team || !team.hasFeature('advancedCodeChallenges'))) {
            return 'projectCodeChallenges';
          }
          return this.libraryAccess + 'ChallengeLibrary';
        },
        getLanguages: function getLanguages(assessmentResult) {
          if (!this.$languages) {
            this.$languages = this._getLanguages(assessmentResult).filter(angular.identity);
          }
          return this.$languages;
        },
        getSubjects: function getSubjects() {
          return this.signalMappings ? this.signalMappings.subjects : this.digest && this.digest.subjects || [];
        },
        externalIdeEnabled: function externalIdeEnabled() {
          var team = getFeatureTeam(this);
          return team && team.hasFeature('externalIde') && this.isAdvancedCode() && (this.enableExternalIde === 'enabled' || this.enableExternalIde === 'default' && team.defaultEnableExternalIde);
        },
        codeOfConductConfig: function codeOfConductConfig() {
          return {
            enabled: !!this.cocEnabled,
            aiUsageAllowed: this.cocAiUsageAllowed === true,
            externalIdeAllowed: this.cocExternalIdeAllowed === true,
            requireAcknowledgement: this.cocRequireAcknowledgement !== false
          };
        },
        codeOfConductRuleMessage: function codeOfConductRuleMessage(type, allowed) {
          var messages = {
            aiUsage: {
              true: 'You may use external AI tools/assistance to help solve this challenge. We encourage you to leverage AI with your own thinking to create the best work possible.',
              false: 'You may not use AI tools/assistance while solving this challenge. We want to see your own work, not AI-generated work. Using AI will result in a failed assessment.'
            },
            externalIde: {
              true: '',
              false: 'You must perform your work within this browser. Using an external IDE/tool to develop your work will result in a failed assessment.'
            }
          };
          return messages[type] && messages[type][allowed ? 'true' : 'false'];
        },
        codeOfConductRuleAcknowledgementLabel: function codeOfConductRuleAcknowledgementLabel(type, allowed) {
          var labels = {
            aiUsage: {
              true: 'I understand that I am allowed to use AI',
              false: 'I agree to not use AI'
            },
            externalIde: {
              true: '',
              false: 'I agree to work only in this browser'
            }
          };
          return labels[type] && labels[type][allowed ? 'true' : 'false'];
        },
        codeOfConductRules: function codeOfConductRules() {
          var _this3 = this;

          var config = this.codeOfConductConfig();
          var rules = [{
            id: 'aiUsage',
            allowed: config.aiUsageAllowed
          }];
          // External IDE policy is only relevant when AI usage is disallowed.
          if (!config.aiUsageAllowed) {
            rules.push({
              id: 'externalIde',
              allowed: config.externalIdeAllowed
            });
          }
          return rules.map(function (rule) {
            rule.message = _this3.codeOfConductRuleMessage(rule.id, rule.allowed);
            rule.acknowledgementLabel = _this3.codeOfConductRuleAcknowledgementLabel(rule.id, rule.allowed);
            return rule;
          }).filter(function (rule) {
            return rule.message !== null && rule.message !== undefined && String(rule.message).trim().length > 0;
          });
        },

        /**
         * Determines if SmartIDE is available on this challenge at all.
         *
         * @param {*} opts - Optional values
         * @param {boolean?} opts.overrideChallenge - If true, ignore the challenge's internal value
         * @param {boolean?} opts.enabledCheck - Private, true if we're checking strictly for currently enabled
         * @returns {boolean|string} - `true` if enabled for all languages, `'partial'` if enabled on some languages, `false` otherwise
         */
        smartIdeAvailable: function smartIdeAvailable() {
          var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          if (!this.$smartIdeAvailable) {
            this.$smartIdeAvailable = {};
          }
          var enabledCheck = opts.enabledCheck,
              overrideChallenge = opts.overrideChallenge;

          var language = enabledCheck ? this._runConfig().language : '';
          var key = language + '|' + overrideChallenge;

          if (!this.$smartIdeAvailable[key]) {
            var user = getUser($injector);
            var team = getFeatureTeam(this);
            var hasLanguageServers = false;
            if (enabledCheck || this.isAdvancedCode()) {
              hasLanguageServers = (this._runConfig().languageServers || this.languageServers || []).length > 0;
            } else if (this.isClassicCode()) {
              var langs = this.languages.length;
              var smartIdeLangs = this.languages.filter(function (l) {
                return l.languageServers && l.languageServers.length > 0;
              }).length;
              if (smartIdeLangs === langs) {
                hasLanguageServers = true;
              } else if (smartIdeLangs > 0) {
                hasLanguageServers = 'partial';
              }
            }

            if (!user || !team || !hasLanguageServers) {
              this.$smartIdeAvailable[key] = false;
            } else {
              var featureEnabled = team.hasFeature('smartIde');

              var enabledOnChallenge = this.enableSmartIde === 'enabled';
              var enabledByDefault = this.enableSmartIde === 'default' && team.defaultEnableSmartIde;
              var enabledByOverride = overrideChallenge && team.defaultEnableSmartIde;

              this.$smartIdeAvailable[key] = featureEnabled && (enabledOnChallenge || enabledByDefault || enabledByOverride) && hasLanguageServers;
            }
          }
          return this.$smartIdeAvailable[key];
        },

        /**
         * Determines if smartIDE is currently enabled on this challenge
         * @param {boolean} overrideChallenge - If true, ignore the challenge's internal value
         * @returns {boolean} - `true` if enabled, `false` otherwise
         */
        smartIdeEnabled: function smartIdeEnabled(overrideChallenge) {
          return !!this.smartIdeAvailable({
            enabledCheck: true,
            overrideChallenge: overrideChallenge
          });
        },

        /**
         * Creates a function to determine if a path is ignored
         * @returns {Function<String>} Function that takes a string and compares it against the ignored
         * paths. Returns `true` if ignored, false otherwise;
         */
        createIgnoreCheckFunction: function createIgnoreCheckFunction() {
          var paths = (this._runConfig().submissionIgnorePaths || []).filter(angular.identity);
          if (paths.length) {
            var pathRegexes = paths.map(function (r) {
              return new RegExp(r);
            });
            return function (path) {
              return pathRegexes.some(function (r) {
                return r.test(path);
              });
            };
          } else {
            return function () {
              return false;
            };
          }
        },
        lockedLayout: function lockedLayout() {
          return this.isClassicCode() || this.initialLayout && this.initialLayout.locked;
        },
        responsiveMode: function responsiveMode() {
          return this.initialLayout && this.initialLayout.responsive;
        },
        canCloseTabs: function canCloseTabs() {
          return !this.lockedLayout();
        }
      },
      staticMethods: {
        GLOBAL_COLLECTION: GLOBAL_COLLECTION,
        TEAM_COLLECTION: TEAM_COLLECTION,
        UPDATE_VERSION: UPDATE_VERSION,
        collections: [{ id: TEAM_COLLECTION, label: 'Team Library', shortLabel: 'Team' }, {
          id: GLOBAL_COLLECTION,
          label: 'Qualified Library',
          shortLabel: 'Qualified'
        }],

        loadSourcedFrom: function loadSourcedFrom(challenges) {
          var ids = [];

          challenges.forEach(function (c) {
            if (!c.$sourcedFromLoaded && !c.sourcedFrom && c.sourcedFromId) {
              ids.push(c.sourcedFromId);
              // only try once per challenge
              c.$sourcedFromLoaded = true;
            }
          });
          return ids.length && shouldFind() ? Challenge.findAll({ where: { id: { in: ids } } }).then(function () {
            return challenges;
          }) : $q.resolve(challenges);
        },
        getTypesList: function getTypesList() {
          var suffix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

          var list = [{
            id: CODE_CHALLENGE_TYPE,
            label: TYPE_NAMES[CODE_CHALLENGE_TYPE] + suffix,
            c: TYPE_KEYS[CODE_CHALLENGE_TYPE]
          }, {
            id: QUIZ_CHALLENGE_TYPE,
            label: TYPE_NAMES[QUIZ_CHALLENGE_TYPE] + suffix,
            c: TYPE_KEYS[QUIZ_CHALLENGE_TYPE]
          }];
          if ($rootScope.permitted && $rootScope.permitted({ feature: 'advancedCodeChallenges' })) {
            list.splice(0, 0, {
              id: ADVANCED_CODE_CHALLENGE_TYPE,
              label: TYPE_NAMES[ADVANCED_CODE_CHALLENGE_TYPE] + suffix,
              c: TYPE_KEYS[ADVANCED_CODE_CHALLENGE_TYPE]
            });
          }
          return list;
        },


        difficulties: difficulties,
        difficultiesList: difficultiesList,
        difficultiesVisibleList: difficultiesList.filter(function (v) {
          return !v.hidden;
        }),

        LIBRARY_ACCESS: LIBRARY_ACCESS,
        premiumAccess: function premiumAccess(accessLevel) {
          var accessIndex = LIBRARY_ACCESS.indexOf(accessLevel);
          if (accessIndex < 0) accessIndex = 0;
          return LIBRARY_ACCESS.slice(accessIndex + 1);
        },
        showAccessTags: function showAccessTags() {
          return $rootScope.permitted && $rootScope.permitted({ staffContent: true });
        },


        INCLUDE_SOLUTIONS_REGEX: INCLUDE_SOLUTIONS_REGEX,
        INCLUDE_SOLUTIONS_REGEX_GLOBAL: INCLUDE_SOLUTIONS_REGEX_GLOBAL,

        isCarriedForward: function isCarriedForward(challenge, assessment) {
          return assessment.challengeItems.some(function (ci) {
            return Challenge.getCarriedForwardIds(ci.challenge || {}).some(function (cid) {
              return challenge.id === cid;
            });
          });
        },
        hasBeenCarriedForward: function hasBeenCarriedForward(challenge, assessmentResult) {
          return assessmentResult.validSolutions().some(function (sol) {
            return sol.challengeId !== challenge.id && sol.challenge && Challenge.getCarriedForwardIds(sol.challenge).some(function (cid) {
              return cid === challenge.id;
            });
          });
        },
        getCarriedForwardIds: function getCarriedForwardIds(challenge) {
          var ids = [];
          (challenge.languages || []).forEach(function (lang) {
            var matches = (lang.setup || '').match(INCLUDE_SOLUTIONS_REGEX_GLOBAL);
            if (matches) {
              matches.forEach(function (m) {
                var id = m.match(INCLUDE_SOLUTIONS_REGEX)[2];
                if (ids.indexOf(id) === -1) {
                  ids.push(id);
                }
              });
            }
          });
          return ids;
        },
        loadCarriedForward: function loadCarriedForward(challenge) {
          var ids = Challenge.getCarriedForwardIds(challenge).filter(function (cid) {
            return !!Challenge.get(cid);
          });
          if (ids.length && shouldFind()) {
            return Challenge.find({ where: { id: { in: ids } } }).then(function () {
              return true;
            }, function () {
              return false;
            });
          } else {
            return $q.resolve(true);
          }
        },
        replaceCarriedForward: function replaceCarriedForward(language, code) {
          return (code || '').replace(INCLUDE_SOLUTIONS_REGEX_GLOBAL, function (match, prefix, id) {
            var c = Challenge.get(id);
            if (!c) {
              return prefix + '(Unable to find reference challenge for previous solution)';
            }

            var lang = c.language(language);
            if (lang && lang.solution) {
              return prefix + ' (Using reference solution from ' + c.title + ')\n' + lang.solution;
            } else {
              return prefix + ' (Reference solution not available for ' + c.title + ')';
            }
          });
        },
        canPublish: function canPublish(challengeData) {
          var hasContent = true;
          var type = challengeData.$type;
          if (type === QUIZ_CHALLENGE_TYPE) {
            hasContent = challengeData.questions && challengeData.questions.length && challengeData.questions.every(function (q) {
              return q && q.prompt;
            });
          } else if (type === CODE_CHALLENGE_TYPE) {
            hasContent = challengeData.languages && challengeData.languages.length && challengeData.languages.every(function (l) {
              return l && l.solution && l.testCases;
            });
          } else if (type === ADVANCED_CODE_CHALLENGE_TYPE) {
            hasContent = challengeData.files && challengeData.files.length;
          }
          return hasContent && challengeData.title && challengeData.instructions;
        },
        getRunFiles: function getRunFiles(challenge) {
          var filesContainer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : challenge;
          var submission = arguments[2];
          var reference = arguments[3];

          var includeKey = submission ? 'includeOnSubmit' : 'includeOnTest';
          var baseFiles = filesContainer.files.filter(function (f) {
            return !f.directory && f[includeKey];
          });
          var ignored = challenge.createIgnoreCheckFunction();
          if (reference) {
            var refFiles = Array.isArray(reference) ? reference : filesContainer.referenceFiles;
            // add or override valid reference files
            refFiles.filter(function (f) {
              return !f.directory && (!submission || !ignored(f.path));
            }).forEach(function (rf) {
              var setupFileIndex = baseFiles.findIndex(function (f) {
                return f.path === rf.path;
              });
              if (setupFileIndex > -1) {
                if (baseFiles[setupFileIndex].$access === 'readwrite') {
                  baseFiles[setupFileIndex] = rf;
                }
              } else {
                baseFiles.push(rf);
              }
            });
          }
          return baseFiles.map(function (f) {
            return {
              path: f.path,
              contents: f.contents,
              get encrypted() {
                return f.encrypted;
              },
              get reference() {
                return f.reference;
              },
              get $access() {
                return f.$access || f.access;
              }
            };
          });
        }
      },
      meta: {
        hasDigest: true,
        types: {
          CodeChallenge: {
            afterTyped: function afterTyped(instance) {
              // ensure languages is not missing
              instance.languages = instance.languages || [];

              // configure current language (if already configured, reconfigure it)
              instance.setCurrentLanguage(instance.$currentLanguage);

              // Mock files & referenceFiles arrays to simulate an AdvancedCodeChallenge
              var createFile = function createFile(field) {
                var reference = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                // const testCases = /testcases/i.test(field);
                var FileModel = reference ? AdvancedCodeChallengeReferenceFile : AdvancedCodeChallengeFile;
                var file = FileModel.createInstance({
                  id: 'challenge$' + field.toLowerCase(),
                  field: field,
                  deletable: false,
                  access: 'readwrite',
                  isClassicCode: true,
                  $hideFromInteract: true
                });
                Object.defineProperties(file, {
                  contents: {
                    get: function get$$1() {
                      return instance.$currentLanguage[field];
                    },
                    set: function set$$1(val) {
                      instance.$currentLanguage[field] = val;
                    }
                  }
                });
                return file;
              };

              var createFiles = function createFiles(key, fields, reference) {
                lazyProperty(instance, key, function () {
                  var files = fields.map(function (f) {
                    return createFile(f, reference);
                  });

                  files.updatePaths = function () {
                    return setClassicFilePaths({
                      files: files,
                      language: instance.$currentLanguage.name,
                      testFramework: instance.$currentLanguage.testFramework,
                      languageVersion: instance.$currentLanguage.languageVersion,
                      $log: $log
                    });
                  };
                  defineValue(instance, '_updatePaths', files.updatePaths);

                  files.updatePaths();
                  // TODO: do we ever need to track renamed files here?
                  instance.on('afterInject', files.updatePaths);

                  return files;
                });
              };

              createFiles('files', ['setup', 'preloaded', 'exampleTestCases']);
              createFiles('referenceFiles', ['solution', 'testCases'], true);
            },

            /**
             * Stores the current working language on the challenge to make it easier to worth with a
             * classic code challenge in multi-file components.
             *
             * @param {Object|string?} nameOrLanguage - Name of a language, or a language object to set
             */
            setCurrentLanguage: function setCurrentLanguage(nameOrLanguage) {
              var challenge = this;
              var langName = isObject(nameOrLanguage) && nameOrLanguage.name || nameOrLanguage;
              // always look up the actual language object
              var lang = challenge.language(langName) || {};
              defineValue(challenge, '$currentLanguage', lang);
              defineValue(challenge, 'runConfig', {
                language: lang.name,
                languageVersion: lang.languageVersion,
                testFramework: lang.testFramework,
                preset: null,
                webPreviews: false,
                services: challenge.enabledServices,
                languageServers: lang.languageServers
              });
              if (challenge._updatePaths) {
                challenge._updatePaths();
              }
            },
            language: function language(name) {
              return name ? this.languages.find(function (language) {
                return language.name === name;
              }) : undefined;
            },
            _getLanguages: function _getLanguages(assessmentResult) {
              var langs = this.languages.map(function (l) {
                return languages.getLang(l.name);
              });
              if (assessmentResult) {
                var ci = assessmentResult.getChallengeItem(this);
                langs = langs.filter(function (lang) {
                  return !ci.disabledLanguages.includes(lang.id);
                });
              }
              return langs;
            }
          },
          AdvancedCodeChallenge: {
            getRunFiles: function getRunFiles(submission, reference, updates) {
              var filesContainer = this;
              if (updates) {
                filesContainer = {
                  files: updates.files || this.files,
                  referenceFiles: updates.referenceFiles || this.referenceFiles
                };
              }
              return Challenge.getRunFiles(this, filesContainer, submission, reference);
            },
            _getLanguages: function _getLanguages() {
              var lang = this._runConfig().language || this.languages && this.languages[0] && this.languages[0].name;
              if (lang) {
                return [languages[lang]];
              } else {
                return [];
              }
            }
          },
          QuizChallenge: {
            _getLanguages: function _getLanguages() {
              var allLangs = this.questions.map(function (q) {
                return q.language;
              }).map(languages.getLang).filter(angular.identity);
              return unique(allLangs, function (l) {
                return l.id;
              });
            }
          }
        },
        defaults: {
          initialLayout: CHALLENGE_INITIAL_LAYOUT_DEFAULT
        },
        actionEndpoints: {
          import: { track: true },
          duplicate: { segment: 'import' },
          unpublish: { method: 'PUT', track: true },
          archive: { method: 'PUT', track: true },
          unarchive: { method: 'PUT', track: true },
          duplicateToShared: { method: 'PUT', track: true },
          export: { method: 'POST', track: true, cacheResponse: false }
        },
        track: {
          create: true,
          update: true
        },
        includeOnPull: ['digest'],
        excludeSaveOrCreateProps: ['questions', 'files', 'referenceFiles'],
        afterSaveOrCreate: function afterSaveOrCreate(instance, changes) {
          var fields = [];
          if (instance.$type === 'AdvancedCodeChallenge') {
            fields = [{
              Model: DS.definitions.AdvancedCodeChallengeFile,
              fieldName: 'files',
              foreignKey: 'challengeId',
              changes: changes,
              orderable: false,
              uniqueChildField: 'path'
            }, {
              Model: DS.definitions.AdvancedCodeChallengeReferenceFile,
              fieldName: 'referenceFiles',
              foreignKey: 'challengeId',
              changes: changes,
              orderable: false,
              uniqueChildField: 'path'
            }];
          }
          if (instance.$type === 'QuizChallenge') {
            fields = {
              Model: DS.definitions.QuizQuestion,
              fieldName: 'questions',
              foreignKey: 'challengeId',
              changes: changes
            };
          }
          return ModelHelper.saveEmbedded(fields);
        }
      }
    });

    return Challenge;
  }]);

  var demoChallenges = [];

  var EMBED_THEMES = [{
    v: 'light',
    l: 'Force Light Theme ("light")'
  }, {
    v: 'dark',
    l: 'Force Dark Theme ("dark")'
  }];
  var EMBED_MODES = [{
    v: 'restricted',
    l: 'Restricted (can edit, but nothing saves) ("restricted")'
  }, {
    v: 'readonly',
    l: 'Read-Only ("readonly")'
  }];
  var EMBED_ACTIONS = [{
    v: true,
    l: 'Hide all actions in the editor, use external actions or shortcut keys to run. (true)'
  }, {
    v: 'attempt',
    l: 'Hide the SUBMIT action in the editor, only enable run tests. ("attempt")'
  }, {
    v: 'runTests',
    l: 'Hide the RUN TESTS action in the editor, only enable submit. ("runTests")'
  }];

  var embeddedQualifiedTestComponentModule = angular.module('Q.components.embedded-qualified-test', [markdownComponentModule]).component('embeddedQualifiedTest', {
    bindings: {
      hideAuth: '<',
      noDefaults: '<',
      demoChallenges: '<',
      disableAdd: '<',
      challengeIds: '<?',
      managerOptions: '<?',
      embeds: '=?'
    },
    controller: 'EmbeddedQualifiedTestCtrl',
    template: embeddedQualifiedTestTemplate
  }).controller('EmbeddedQualifiedTestCtrl', ['$scope', '$window', '$http', function EmbeddedQualifiedTestCtrl($scope, $window, $http) {
    var ctrl = this;

    var embedClientKey = '6CmpVAhdeGKw/Fmz7noB+qP8o+Xvb9b8';

    function syntaxHighlight(json) {
      json = JSON.stringify(json, null, 2);
      json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
        var cls = 'hljs-literal';
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = 'hljs-title';
          } else {
            cls = 'hljs-string';
          }
        } else if (/true|false|null/.test(match)) {
          cls = 'hljs-keyword';
        }
        return '<span class="' + cls + '">' + match + '</span>';
      });
    }

    var embedId = 0;
    var makeEmbed = function makeEmbed(props) {
      var e = {};
      angular.merge(e, {
        embedId: ++embedId,
        tabs: [],
        toggleTab: function toggleTab(tab) {
          var tabs = (this.opts.hideTabs || '').split(',').filter(function (a) {
            return a;
          });
          if (tabs.includes(tab)) {
            remove(tabs, tab);
          } else {
            tabs.push(tab);
          }
          this.opts.hideTabs = tabs.join(',');
        },

        loadData: '<span class="hljs-comment">// Info about the loaded challenge shown here</span>',
        files: '<span class="hljs-comment">// File contents will be shown here once loaded</span>',
        results: '<span class="hljs-comment">// Run results will be shown after running code</span>',
        opts: {
          onLoaded: function onLoaded(_ref) {
            var data = _ref.data;

            e.error = data.error;
            e.loaded = !data.error;
            if (!e.example) {
              e.label = data.title;
              if (data.summary) {
                e.description = data.summary;
              }
            }
            e.languages = data.languages;
            if (data.solutionLanguage) {
              e.opts.language = data.solutionLanguage;
            } else if (data.languages && data.languages.length === 1) {
              e.opts.language = data.languages[0];
            }
            e.tabs = data.availableTabs;
            e.started = data.started;
            e.loadData = syntaxHighlight(data);
            e.isAdvanced = data.type === ADVANCED_CODE_CHALLENGE_TYPE;
            e.isCode = e.isAdvanced || data.type === CODE_CHALLENGE_TYPE;
            e.icon = 'icon-' + TYPE_KEYS[data.type];
            $scope.$applyAsync();
          },
          onChange: function onChange(_ref2) {
            var data = _ref2.data;

            e.files = syntaxHighlight(data);
            $scope.$applyAsync();
          },
          onRun: function onRun(_ref3) {
            var data = _ref3.data;

            e.results = syntaxHighlight(data);
            $scope.$applyAsync();
          },

          initialLayout: {
            topLeft: [],
            topRight: [],
            bottomLeft: [],
            bottomRight: []
          }
        }
      }, props);
      return e;
    };

    ctrl.$onInit = function () {
      var embeds = [];
      if (Array.isArray(ctrl.challengeIds)) {
        embeds = ctrl.challengeIds.map(function (id) {
          return makeEmbed({ id: id });
        });
      } else if (!ctrl.noDefaults) {
        embeds = [makeEmbed({
          id: '58e6576a7e68c90014a0279e',
          label: 'Classic Code',
          example: true,
          description: 'This example shows a classic code challenge, using mostly the default configuration. Click on _Show Embed Configuration_ to see how changing the default configuration changes the embed.',
          opts: {
            language: 'javascript'
          }
        }), makeEmbed({
          id: '5d3f62af4d8eb0000e063d4d',
          label: 'Web Preview',
          example: true,
          description: 'Shows using a project challenge with embedded web preview, no code running, and dark mode.',
          opts: {
            theme: 'dark',
            hideTabs: 'instructions,runnerframe,idesettings,__tests__/Checkbox.test.jsx,public/index.html',
            initialLayout: {
              topLeft: [],
              topRight: [],
              bottomLeft: [],
              bottomRight: ['webpreviewconsole']
            }
          }
        })];
      }
      ctrl.embeds = embeds;

      var options = ctrl.managerOptions || {};
      options.baseURL = $window.location.origin;

      // Since there have been regressions due to using the old version, try
      // using both embed init APIs for the time being so we're sure it works.
      if ($window.QualifiedEmbed.QualifiedEmbedManager) {
        // new API
        ctrl.manager = $window.QualifiedEmbed.QualifiedEmbedManager.init({
          options: _extends({}, options, { embedClientKey: embedClientKey })
        });
      } else {
        // old API
        ctrl.manager = $window.QualifiedEmbed.init({
          options: _extends({}, options, { embedClientKey: embedClientKey })
        });
      }

      ctrl.initEmbed = function (node, challengeId, options) {
        return ctrl.manager.createEditor({
          node: node,
          challengeId: challengeId,
          options: _extends({}, options, { embedClientKey: embedClientKey })
        });
      };

      ctrl.destroy = function (index) {
        ctrl.embeds.splice(index, 1);
      };

      ctrl.showAdd = function () {
        ctrl.newEmbed = makeEmbed({});
      };
      ctrl.add = function () {
        if (ctrl.embeds.find(function (e) {
          return e.id === ctrl.newEmbed.id;
        })) {
          $window.alert('Already showing that challenge, please choose a different one');
        } else {
          ctrl.embeds.push(ctrl.newEmbed);
          ctrl.newEmbed = null;
        }
      };

      if (ctrl.demoChallenges || ctrl.noDefaults) {
        demoChallenges = ctrl.demoChallenges || [];
      } else {
        $http.get(appConfig.apiRoot + 'challenges/embed_demos').then(function (result) {
          if (result && result.data) {
            demoChallenges = result.data.data;
          }
        });
      }
    };
  }]).component('embeddedQualifiedOptions', {
    restrict: 'E',
    bindings: {
      embed: '<',
      expanded: '<?',
      onSubmit: '&',
      addMode: '<?',
      managerOptions: '<'
    },
    template: embeddedQualifiedOptionsTemplate,
    controller: /* @ngInject*/function controller() {
      var ctrl = this;
      Object.defineProperty(ctrl, 'demos', {
        get: function get$$1() {
          return demoChallenges;
        }
      });

      ctrl.themes = EMBED_THEMES;
      ctrl.modes = EMBED_MODES;
      ctrl.actions = EMBED_ACTIONS;

      var previousId = void 0;
      ctrl.updateDemoId = function () {
        if (ctrl.demo) {
          ctrl.embed.id = previousId = ctrl.demo.id;
          if (ctrl.demo.languages) {
            ctrl.embed.languages = ctrl.demo.languages;
          }
          ctrl.embed.label = ctrl.demo.title;
        } else if (previousId === ctrl.embed.id) {
          ctrl.embed.id = '';
          if (ctrl.editor && ctrl.editor.challengeData) {
            ctrl.embed.languages = ctrl.editor.challengeData.languages;
          } else {
            ctrl.embed.languages = [];
          }
        }
      };

      ctrl.tabsets = ['topLeft', 'topRight', 'bottomLeft', 'bottomRight'];
      ctrl.updateLayout = function (ts) {
        ctrl.embed.opts.initialLayout[ts] = ctrl.initialLayout[ts].split(',').filter(identity);
      };

      ctrl.$onInit = function () {
        var demo = ctrl.demos.find(function (d) {
          return d.id === ctrl.embed.id;
        });
        if (demo) {
          ctrl.demo = demo;
          ctrl.previousId = ctrl.embed.id;
        }
        ctrl.initialLayout = {};
        ctrl.tabsets.forEach(function (ts) {
          ctrl.initialLayout[ts] = ctrl.embed.opts.initialLayout[ts].join(',');
        });
      };
    }
  }).directive('qualifiedEmbed', function () {
    return {
      restrict: 'A',
      require: '^embeddedQualifiedTest',
      link: function link(scope, elem, attrs, embeddedQualifiedTestCtrl) {
        var embed = scope.embed;
        var editor = scope.editor = embeddedQualifiedTestCtrl.initEmbed(elem[0], embed.id, embed.opts);
        embed.editor = editor;

        function updateInternalProps() {
          embed.readOnly = editor.options.mode === 'readonly';
          embed.restricted = embed.readOnly || editor.options.mode === 'restricted';
        }

        updateInternalProps();

        scope.update = function () {
          editor.update({ challengeId: embed.id, options: embed.opts });
          updateInternalProps();
        };

        scope.$on('$destroy', function () {
          if (editor) {
            editor.destroy();
          }
        });
      }
    };
  });

  var embeddedCalendlyTemplate = "<div class=\"calendly-loading\">One second, checking the calendar…</div> <div class=\"calendly-widget\"></div> ";

  // Enables us to lazily load external JS scripts
  // Very minimalist, simply designed to support modern browsers and very basic, JS-only loading
  var asyncLoaderServiceModule = angular.module('Q.services.async-loader-service', []).factory('asyncLoaderService', ['$document', '$q', function ($document, $q) {
    var loaded = {};

    return {
      load: load
    };

    /**
     * Asynchronously loads a remote script., and returns a promise for when that script
     * is loaded (or fails to load).
     *
     * @param url URL of remote script (raw)
     * @param attributes
     * @returns {Promise}
     */
    function load(url) {
      var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!loaded[url]) {
        loaded[url] = _create(url, attributes);
      }
      return loaded[url];
    }

    function _create(url, attributes) {
      return $q(function (resolve, reject) {
        var $node = angular.element('<script>');
        var node = $node[0];
        $node.attr(angular.extend({
          type: 'text/javascript',
          charset: 'utf-8',
          async: true
        }, attributes));

        node.addEventListener('load', function () {
          return resolve();
        }, false);
        node.addEventListener('error', function () {
          return reject('Unable to load ' + url);
        }, false);

        node.src = url;
        $document.find('body').append($node);
      });
    }
  }]);

  var CALENDLY_WIDGET = 'https://assets.calendly.com/assets/external/widget.js';
  var CALENDLY_BASE = 'https://calendly.com/';

  var embeddedCalendlyComponentModule = angular.module('Q.components.embedded-calendly', [asyncLoaderServiceModule]).component('embeddedCalendly', {
    bindings: {
      calendlyLink: '@',
      calendlyPrefill: '<',
      calendlyUtm: '<',
      calendlyEvent: '@'
    },
    controller: 'EmbeddedCalendlyCtrl',
    template: embeddedCalendlyTemplate
  }).controller('EmbeddedCalendlyCtrl', ['$element', '$window', '$log', 'asyncLoaderService', 'trackerService', function EmbeddedCalendlyCtrl($element, $window, $log, asyncLoaderService, trackerService) {
    var ctrl = this;

    ctrl.$onInit = function () {
      trackerService.trackEvent(ctrl.calendlyEvent + ' Started');

      var loading = $element.querySelector('.calendly-loading');
      var widgetNode = $element.querySelector('.calendly-widget')[0];
      asyncLoaderService.load(CALENDLY_WIDGET).then(function () {
        if (!$window.Calendly) throw new Error('Unable to locate Calendly object');
        loading.remove();
        $window.Calendly.initInlineWidget({
          url: CALENDLY_BASE + ctrl.calendlyLink,
          parentElement: widgetNode,
          prefill: ctrl.calendlyPrefill,
          utm: ctrl.calendlyUtm
        });
      }).catch(function (err) {
        trackerService.trackEvent(ctrl.calendlyEvent + ' Error');
        $log.error('Unable to load Calendly', err);
        $window.location = CALENDLY_BASE + ctrl.calendlyLink;
      });
    };

    var calendlyEventListener = function calendlyEventListener(event) {
      // Note: we can listen to other events, too:
      // calendly.profile_page_viewed: Profile page was viewed
      // calendly.event_type_viewed: Event type page was viewed
      // calendly.date_and_time_selected: Invitee selected date and time
      // calendly.event_scheduled: Invitee successfully booked a meeting
      if (event.data.event === 'calendly.event_type_viewed') {
        trackerService.trackEvent(ctrl.calendlyEvent + ' Meeting Type Selected');
      }
      if (event.data.event === 'calendly.date_and_time_selected') {
        trackerService.trackEvent(ctrl.calendlyEvent + ' Time Selected');
      }
      if (event.data.event === 'calendly.event_scheduled') {
        trackerService.trackEvent(ctrl.calendlyEvent + ' Success');
      }
    };

    $window.addEventListener('message', calendlyEventListener);
    ctrl.$onDestroy = function () {
      $window.removeEventListener('message', calendlyEventListener);
    };
  }]);

  var embeddedTypeFormTemplate = "<div class=\"embedded-type-form-container\"></div> <div class=\"alert alert-danger\" ng-if=\"$ctrl.error\"> <strong>Error</strong>: {{$ctrl.error}} </div> ";

  window.tf = function () {
    var e = { 6664: function _(e, t, n) {
        var o = this && this.__assign || function () {
          return (o = Object.assign || function (e) {
            for (var t, n = 1, o = arguments.length; n < o; n++) {
              for (var r in t = arguments[n]) {
                Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
              }
            }return e;
          }).apply(this, arguments);
        },
            r = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
          void 0 === o && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function get() {
              return t[n];
            } });
        } : function (e, t, n, o) {
          void 0 === o && (o = n), e[o] = t[n];
        }),
            i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
          Object.defineProperty(e, "default", { enumerable: !0, value: t });
        } : function (e, t) {
          e.default = t;
        }),
            a = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;var t = {};if (null != e) for (var n in e) {
            "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
          }return i(t, e), t;
        };Object.defineProperty(t, "__esModule", { value: !0 });var u = n(6654),
            c = a(n(1920));function s(e) {
          void 0 === e && (e = !1), u.initializePopovers(e), u.initializePopups(e), u.initializeSidetabs(e), u.initializeSliders(e), u.initializeWidgets(e);
        }var d = function d() {
          return s(!1);
        };e.exports = o(o({}, c), { load: d, reload: function reload() {
            return s(!0);
          } }), document.addEventListener("DOMContentLoaded", d, !1), "interactive" !== document.readyState && "complete" !== document.readyState || d();
      }, 8027: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.FORM_BASE_URL = t.POPUP_SIZE = t.SLIDER_WIDTH = t.SLIDER_POSITION = t.SIDETAB_ATTRIBUTE = t.WIDGET_ATTRIBUTE = t.SLIDER_ATTRIBUTE = t.POPUP_ATTRIBUTE = t.POPOVER_ATTRIBUTE = void 0, t.POPOVER_ATTRIBUTE = "data-tf-popover", t.POPUP_ATTRIBUTE = "data-tf-popup", t.SLIDER_ATTRIBUTE = "data-tf-slider", t.WIDGET_ATTRIBUTE = "data-tf-widget", t.SIDETAB_ATTRIBUTE = "data-tf-sidetab", t.SLIDER_POSITION = "right", t.SLIDER_WIDTH = 800, t.POPUP_SIZE = 100, t.FORM_BASE_URL = "https://form.typeform.com";
      }, 7528: function _(e, t, n) {
        var o = this && this.__assign || function () {
          return (o = Object.assign || function (e) {
            for (var t, n = 1, o = arguments.length; n < o; n++) {
              for (var r in t = arguments[n]) {
                Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
              }
            }return e;
          }).apply(this, arguments);
        };Object.defineProperty(t, "__esModule", { value: !0 }), t.createPopover = void 0;var r = n(6797),
            i = n(1320),
            a = function a(e, t) {
          var n = e.parentNode;n && (n.removeChild(e), n.appendChild(t));
        },
            u = function u(e, t) {
          void 0 === e && (e = "div"), void 0 === t && (t = "tf-v1-popover-button-icon");var n = document.createElement(e);return n.className = t + " tf-v1-close-icon", n.innerHTML = "&times;", n.dataset.testid = t, n;
        },
            c = { buttonColor: "#3a7685" };t.createPopover = function (e, t) {
          void 0 === t && (t = {});var n,
              s,
              d,
              l = o(o({}, c), t),
              f = r.createIframe(e, "popover", l),
              p = f.iframe,
              v = f.embedId,
              m = f.refresh,
              h = function (e, t) {
            var n = document.createElement("div");return n.className = "tf-v1-popover", n.dataset.testid = "tf-v1-popover", r.setElementSize(n, { width: e, height: t });
          }(l.width, l.height),
              b = function () {
            var e = document.createElement("div");return e.className = "tf-v1-popover-wrapper", e.dataset.testid = "tf-v1-popover-wrapper", e;
          }(),
              y = function (e, t) {
            var n = r.getTextColor(t),
                o = document.createElement("div");o.className = "tf-v1-popover-button-icon";var i = '<svg class="default" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path d="M21 0H0V9L10.5743 24V16.5H21C22.6567 16.5 24 15.1567 24 13.5V3C24 1.34325 22.6567 0 21 0ZM7.5\n    9.75C6.672 9.75 6 9.07875 6 8.25C6 7.42125 6.672 6.75 7.5 6.75C8.328 6.75 9 7.42125 9 8.25C9 9.07875 8.328 9.75\n    7.5 9.75ZM12.75 9.75C11.922 9.75 11.25 9.07875 11.25 8.25C11.25 7.42125 11.922 6.75 12.75 6.75C13.578 6.75 14.25\n    7.42125 14.25 8.25C14.25 9.07875 13.578 9.75 12.75 9.75ZM18 9.75C17.172 9.75 16.5 9.07875 16.5 8.25C16.5 7.42125\n    17.172 6.75 18 6.75C18.828 6.75 19.5 7.42125 19.5 8.25C19.5 9.07875 18.828 9.75 18 9.75Z" fill="' + n + '"></path>\n  </svg>',
                a = null == e ? void 0 : e.startsWith("http");return o.innerHTML = a ? "<img alt='popover trigger icon button' src='" + e + "'/>" : null != e ? e : i, o.dataset.testid = "default-icon", o;
          }(l.customIcon, l.buttonColor || c.buttonColor),
              g = function () {
            var e = document.createElement("div");e.className = "tf-v1-spinner";var t = document.createElement("div");return t.className = "tf-v1-popover-button-icon", t.dataset.testid = "spinner-icon", t.append(e), t;
          }(),
              O = u(),
              _ = u("a", "tf-v1-popover-close"),
              w = function (e) {
            var t = r.getTextColor(e),
                n = document.createElement("button");return n.className = "tf-v1-popover-button", n.dataset.testid = "tf-v1-popover-button", n.style.backgroundColor = e, n.style.color = t, n;
          }(l.buttonColor || c.buttonColor);(l.container || document.body).append(h), b.append(p), h.append(w), h.append(_), w.append(y);var P = function P() {
            s && s.parentNode && (s.classList.add("closing"), setTimeout(function () {
              r.unmountElement(s);
            }, 250));
          };l.tooltip && l.tooltip.length > 0 && (s = function (e, t) {
            var n = document.createElement("span");n.className = "tf-v1-popover-tooltip-close", n.dataset.testid = "tf-v1-popover-tooltip-close", n.innerHTML = "&times;", n.onclick = t;var o = document.createElement("div");o.className = "tf-v1-popover-tooltip-text", o.innerHTML = e;var r = document.createElement("div");return r.className = "tf-v1-popover-tooltip", r.dataset.testid = "tf-v1-popover-tooltip", r.appendChild(o), r.appendChild(n), r;
          }(l.tooltip, P), h.append(s)), l.notificationDays && (l.enableSandbox || i.canBuildNotificationDot(e)) && (d = i.buildNotificationDot(), w.append(d)), p.onload = function () {
            h.classList.add("open"), b.style.opacity = "1", _.style.opacity = "1", a(g, O), r.addCustomKeyboardListener(T);
          };var E = function E() {
            r.isOpen(b) || (P(), d && (d.classList.add("closing"), l.notificationDays && !l.enableSandbox && i.saveNotificationDotHideUntilTime(e, l.notificationDays), setTimeout(function () {
              r.unmountElement(d);
            }, 250)), setTimeout(function () {
              r.isInPage(b) ? (b.style.opacity = "0", _.style.opacity = "0", b.style.display = "flex", setTimeout(function () {
                h.classList.add("open"), b.style.opacity = "1", _.style.opacity = "1";
              }), a(y, O)) : (h.append(b), a(y, g), b.style.opacity = "0", _.style.opacity = "0");
            }));
          },
              T = function T() {
            var e;r.isOpen(h) && (null === (e = t.onClose) || void 0 === e || e.call(t), setTimeout(function () {
              l.keepSession ? b.style.display = "none" : r.unmountElement(b), h.classList.remove("open"), a(O, y);
            }, 250));
          };r.setAutoClose(v, l.autoClose, T);var j = function j() {
            r.isOpen(b) ? T() : E();
          };return w.onclick = j, _.onclick = T, l.open && !r.isOpen(b) && (n = r.handleCustomOpen(E, l.open, l.openValue)), { open: E, close: T, toggle: j, refresh: m, unmount: function unmount() {
              r.unmountElement(h), l.open && (null == n ? void 0 : n.remove) && n.remove();
            } };
        };
      }, 1797: function _(e, t, n) {
        var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
          void 0 === o && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function get() {
              return t[n];
            } });
        } : function (e, t, n, o) {
          void 0 === o && (o = n), e[o] = t[n];
        }),
            r = this && this.__exportStar || function (e, t) {
          for (var n in e) {
            "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
          }
        };Object.defineProperty(t, "__esModule", { value: !0 }), r(n(7528), t), r(n(6100), t);
      }, 1320: function _(e, t) {
        var n = this && this.__assign || function () {
          return (n = Object.assign || function (e) {
            for (var t, n = 1, o = arguments.length; n < o; n++) {
              for (var r in t = arguments[n]) {
                Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
              }
            }return e;
          }).apply(this, arguments);
        };Object.defineProperty(t, "__esModule", { value: !0 }), t.buildNotificationDot = t.canBuildNotificationDot = t.saveNotificationDotHideUntilTime = void 0;var o = "tfNotificationData",
            r = function r() {
          var e = localStorage.getItem(o);return e ? JSON.parse(e) : {};
        },
            i = function i(e) {
          e && localStorage.setItem(o, JSON.stringify(e));
        };t.saveNotificationDotHideUntilTime = function (e, t) {
          var o,
              a = new Date();a.setDate(a.getDate() + t), i(n(n({}, r()), ((o = {})[e] = { hideUntilTime: a.getTime() }, o)));
        }, t.canBuildNotificationDot = function (e) {
          var t = function (e) {
            var t;return (null === (t = r()[e]) || void 0 === t ? void 0 : t.hideUntilTime) || 0;
          }(e);return new Date().getTime() > t && (t && function (e) {
            var t = r();delete t[e], i(t);
          }(e), !0);
        }, t.buildNotificationDot = function () {
          var e = document.createElement("span");return e.className = "tf-v1-popover-unread-dot", e.dataset.testid = "tf-v1-popover-unread-dot", e;
        };
      }, 6100: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 });
      }, 9630: function _(e, t, n) {
        var o = this && this.__rest || function (e, t) {
          var n = {};for (var o in e) {
            Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
          }if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var r = 0;for (o = Object.getOwnPropertySymbols(e); r < o.length; r++) {
              t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
            }
          }return n;
        };Object.defineProperty(t, "__esModule", { value: !0 }), t.createPopup = void 0;var r = n(6797),
            i = n(8027),
            a = n(6797);t.createPopup = function (e, t) {
          if (void 0 === t && (t = {}), !r.hasDom()) return { open: function open() {}, close: function close() {}, toggle: function toggle() {}, refresh: function refresh() {}, unmount: function unmount() {} };var n,
              u = t.width,
              c = t.height,
              s = t.size,
              d = void 0 === s ? i.POPUP_SIZE : s,
              l = t.onClose,
              f = o(t, ["width", "height", "size", "onClose"]),
              p = r.createIframe(e, "popup", f),
              v = p.iframe,
              m = p.embedId,
              h = p.refresh,
              b = document.body.style.overflow,
              y = function () {
            var e = document.createElement("div");return e.className = "tf-v1-popup", e.dataset.testid = "tf-v1-popup", e.style.opacity = "0", e;
          }(),
              g = function () {
            var e = document.createElement("div");return e.className = "tf-v1-spinner", e;
          }(),
              O = function (e, t, n) {
            var o = document.createElement("div");return o.className = "tf-v1-iframe-wrapper", o.style.opacity = "0", r.isDefined(e) && r.isDefined(t) ? r.setElementSize(o, { width: e, height: t }) : (o.style.width = "calc(" + n + "% - 80px)", o.style.height = "calc(" + n + "% - 80px)", o);
          }(u, c, d);O.append(v), y.append(g), y.append(O);var _ = f.container || document.body;v.onload = function () {
            O.style.opacity = "1", setTimeout(function () {
              g.style.display = "none";
            }, 250), r.addCustomKeyboardListener(P);
          };var w = function w() {
            a.isOpen(y) || (a.isInPage(y) ? y.style.display = "flex" : (g.style.display = "block", _.append(y)), document.body.style.overflow = "hidden", setTimeout(function () {
              y.style.opacity = "1";
            }));
          },
              P = function P() {
            a.isOpen(y) && (null == l || l(), y.style.opacity = "0", document.body.style.overflow = b, setTimeout(function () {
              f.keepSession ? y.style.display = "none" : E();
            }, 250));
          };O.append(function (e) {
            var t = document.createElement("a");return t.className = "tf-v1-close tf-v1-close-icon", t.innerHTML = "&times;", t.onclick = e, t;
          }(P)), r.setAutoClose(m, f.autoClose, P), f.open && !a.isOpen(y) && (n = r.handleCustomOpen(w, f.open, f.openValue));var E = function E() {
            r.unmountElement(y), f.open && (null == n ? void 0 : n.remove) && n.remove();
          };return { open: w, close: P, toggle: function toggle() {
              a.isOpen(y) ? P() : w();
            }, refresh: h, unmount: E };
        };
      }, 5970: function _(e, t, n) {
        var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
          void 0 === o && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function get() {
              return t[n];
            } });
        } : function (e, t, n, o) {
          void 0 === o && (o = n), e[o] = t[n];
        }),
            r = this && this.__exportStar || function (e, t) {
          for (var n in e) {
            "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
          }
        };Object.defineProperty(t, "__esModule", { value: !0 }), r(n(9630), t), r(n(7394), t);
      }, 7394: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 });
      }, 382: function _(e, t, n) {
        var o = this && this.__assign || function () {
          return (o = Object.assign || function (e) {
            for (var t, n = 1, o = arguments.length; n < o; n++) {
              for (var r in t = arguments[n]) {
                Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
              }
            }return e;
          }).apply(this, arguments);
        };Object.defineProperty(t, "__esModule", { value: !0 }), t.createSidetab = void 0;var r = n(6797),
            i = { buttonColor: "#3a7685", buttonText: "Launch me" },
            a = function a(e, t) {
          void 0 === e && (e = "div"), void 0 === t && (t = "tf-v1-sidetab-button-icon");var n = document.createElement(e);return n.className = t + " tf-v1-close-icon", n.innerHTML = "&times;", n.dataset.testid = t, n;
        },
            u = function u(e, t) {
          var n = e.parentNode;n && (n.removeChild(e), n.appendChild(t));
        };t.createSidetab = function (e, t) {
          void 0 === t && (t = {});var n,
              c = o(o({}, i), t),
              s = r.createIframe(e, "side-tab", c),
              d = s.iframe,
              l = s.embedId,
              f = s.refresh,
              p = function (e, t) {
            var n = document.createElement("div");return n.className = "tf-v1-sidetab", n.dataset.testid = "tf-v1-sidetab", r.setElementSize(n, { width: e, height: t });
          }(c.width, c.height),
              v = function () {
            var e = document.createElement("div");return e.className = "tf-v1-sidetab-wrapper", e.dataset.testid = "tf-v1-sidetab-wrapper", e;
          }(),
              m = function () {
            var e = document.createElement("div");e.className = "tf-v1-spinner";var t = document.createElement("div");return t.className = "tf-v1-sidetab-button-icon", t.dataset.testid = "spinner-icon", t.append(e), t;
          }(),
              h = function (e) {
            var t = r.getTextColor(e),
                n = document.createElement("button");return n.className = "tf-v1-sidetab-button", n.style.backgroundColor = e, n.style.color = t, n;
          }(c.buttonColor || i.buttonColor),
              b = function (e) {
            var t = document.createElement("span");return t.className = "tf-v1-sidetab-button-text", t.innerHTML = e, t;
          }(c.buttonText || i.buttonText),
              y = function (e, t) {
            var n = r.getTextColor(t),
                o = document.createElement("div");o.className = "tf-v1-sidetab-button-icon";var i = '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path d="M21 0H0V9L10.5743 24V16.5H21C22.6567 16.5 24 15.1567 24 13.5V3C24 1.34325 22.6567 0 21 0ZM7.5 9.75C6.672 9.75 6 9.07875 6 8.25C6 7.42125 6.672 6.75 7.5 6.75C8.328 6.75 9 7.42125 9 8.25C9 9.07875 8.328 9.75 7.5 9.75ZM12.75 9.75C11.922 9.75 11.25 9.07875 11.25 8.25C11.25 7.42125 11.922 6.75 12.75 6.75C13.578 6.75 14.25 7.42125 14.25 8.25C14.25 9.07875 13.578 9.75 12.75 9.75ZM18 9.75C17.172 9.75 16.5 9.07875 16.5 8.25C16.5 7.42125 17.172 6.75 18 6.75C18.828 6.75 19.5 7.42125 19.5 8.25C19.5 9.07875 18.828 9.75 18 9.75Z" fill="' + n + '"></path>\n  </svg>',
                a = null == e ? void 0 : e.startsWith("http");return o.innerHTML = a ? "<img alt='popover trigger icon button' src='" + e + "'/>" : null != e ? e : i, o.dataset.testid = "default-icon", o;
          }(c.customIcon, c.buttonColor || i.buttonColor),
              g = a(),
              O = a("a", "tf-v1-sidetab-close");(c.container || document.body).append(p), v.append(d), p.append(h), p.append(O), h.append(y), h.append(b), setTimeout(function () {
            p.classList.add("ready");
          }, 250), d.onload = function () {
            p.classList.add("open"), u(m, g), r.addCustomKeyboardListener(w);
          };var _ = function _() {
            r.isOpen(v) || (r.isInPage(v) ? (v.style.display = "flex", p.classList.add("open"), u(y, g)) : (p.append(v), u(y, m)));
          },
              w = function w() {
            var e;r.isOpen(v) && (null === (e = c.onClose) || void 0 === e || e.call(c), p.classList.remove("open"), setTimeout(function () {
              c.keepSession ? v.style.display = "none" : r.unmountElement(v), u(g, y);
            }, 250));
          };r.setAutoClose(l, c.autoClose, w);var P = function P() {
            r.isOpen(v) ? w() : _();
          };return h.onclick = P, O.onclick = w, c.open && !r.isOpen(v) && (n = r.handleCustomOpen(_, c.open, c.openValue)), { open: _, close: w, toggle: P, refresh: f, unmount: function unmount() {
              r.unmountElement(p), c.open && (null == n ? void 0 : n.remove) && n.remove();
            } };
        };
      }, 1434: function _(e, t, n) {
        var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
          void 0 === o && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function get() {
              return t[n];
            } });
        } : function (e, t, n, o) {
          void 0 === o && (o = n), e[o] = t[n];
        }),
            r = this && this.__exportStar || function (e, t) {
          for (var n in e) {
            "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
          }
        };Object.defineProperty(t, "__esModule", { value: !0 }), r(n(382), t), r(n(7668), t);
      }, 7668: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 });
      }, 2603: function _(e, t, n) {
        var o = this && this.__rest || function (e, t) {
          var n = {};for (var o in e) {
            Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
          }if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var r = 0;for (o = Object.getOwnPropertySymbols(e); r < o.length; r++) {
              t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
            }
          }return n;
        };Object.defineProperty(t, "__esModule", { value: !0 }), t.createSlider = void 0;var r = n(6797),
            i = n(8027);t.createSlider = function (e, t) {
          if (void 0 === t && (t = {}), !r.hasDom()) return { open: function open() {}, close: function close() {}, toggle: function toggle() {}, refresh: function refresh() {}, unmount: function unmount() {} };var n,
              a = t.position,
              u = void 0 === a ? i.SLIDER_POSITION : a,
              c = t.width,
              s = void 0 === c ? i.SLIDER_WIDTH : c,
              d = t.onClose,
              l = o(t, ["position", "width", "onClose"]),
              f = r.createIframe(e, "slider", l),
              p = f.iframe,
              v = f.embedId,
              m = f.refresh,
              h = document.body.style.overflow,
              b = function (e) {
            var t = document.createElement("div");return t.className = "tf-v1-slider " + e, t.dataset.testid = "tf-v1-slider", t.style.opacity = "0", t;
          }(u),
              y = function () {
            var e = document.createElement("div");return e.className = "tf-v1-spinner", e;
          }(),
              g = function (e, t) {
            var n = document.createElement("div");return n.className = "tf-v1-iframe-wrapper", n.style[e] = "-100%", r.setElementSize(n, { width: t });
          }(u, s);g.append(p), b.append(y), b.append(g);var O = l.container || document.body;p.onload = function () {
            g.style[u] = "0", setTimeout(function () {
              y.style.display = "none";
            }, 500), r.addCustomKeyboardListener(w);
          };var _ = function _() {
            r.isOpen(b) || (r.isInPage(b) ? (b.style.display = "flex", setTimeout(function () {
              g.style[u] = "0";
            })) : (O.append(b), y.style.display = "block"), document.body.style.overflow = "hidden", setTimeout(function () {
              b.style.opacity = "1";
            }));
          },
              w = function w() {
            r.isOpen(b) && (null == d || d(), b.style.opacity = "0", g.style[u] = "-100%", document.body.style.overflow = h, setTimeout(function () {
              l.keepSession ? b.style.display = "none" : P();
            }, 500));
          };r.setAutoClose(v, l.autoClose, w), g.append(function (e) {
            var t = document.createElement("a");return t.className = "tf-v1-close tf-v1-close-icon", t.innerHTML = "&times;", t.onclick = e, t;
          }(w)), l.open && !r.isOpen(b) && (n = r.handleCustomOpen(_, l.open, l.openValue));var P = function P() {
            r.unmountElement(b), l.open && (null == n ? void 0 : n.remove) && n.remove();
          };return { open: _, close: w, toggle: function toggle() {
              r.isOpen(b) ? w() : _();
            }, refresh: m, unmount: P };
        };
      }, 4071: function _(e, t, n) {
        var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
          void 0 === o && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function get() {
              return t[n];
            } });
        } : function (e, t, n, o) {
          void 0 === o && (o = n), e[o] = t[n];
        }),
            r = this && this.__exportStar || function (e, t) {
          for (var n in e) {
            "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
          }
        };Object.defineProperty(t, "__esModule", { value: !0 }), r(n(2603), t), r(n(3162), t);
      }, 3162: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 });
      }, 718: function _(e, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.createWidget = void 0;var o = n(6797),
            r = n(8554),
            i = n(2313);t.createWidget = function (e, t) {
          if (!o.hasDom()) return { refresh: function refresh() {}, unmount: function unmount() {} };var n = t;t.inlineOnMobile || !t.forceTouch && !o.isFullscreen() || (n.enableFullscreen = !0, n.forceTouch = !0);var a = o.createIframe(e, "widget", n),
              u = a.embedId,
              c = a.iframe,
              s = a.refresh,
              d = i.buildWidget(c, t.width, t.height);if (n.autoResize) {
            var l = "string" == typeof n.autoResize ? n.autoResize.split(",").map(function (e) {
              return parseInt(e);
            }) : [],
                f = l[0],
                p = l[1];window.addEventListener("message", r.getFormHeightChangedHandler(u, function (e) {
              var n = Math.max(e.height + 20, f || 0);p && (n = Math.min(n, p)), t.container.style.height = n + "px";
            }));
          }var v,
              m = function m() {
            return t.container.append(d);
          };if (t.container.innerHTML = "", t.lazy ? o.lazyInitialize(t.container, m) : m(), n.enableFullscreen) {
            var h = t.container;window.addEventListener("message", r.getWelcomeScreenHiddenHandler(u, h));var b = ((v = document.createElement("a")).className = "tf-v1-widget-close tf-v1-close-icon", v.innerHTML = "&times;", v);b.onclick = function () {
              var e;if (null === (e = t.onClose) || void 0 === e || e.call(t), h.classList.remove("tf-v1-widget-fullscreen"), t.keepSession) {
                var n = document.createElement("div");n.className = "tf-v1-widget-iframe-overlay", n.onclick = function () {
                  h.classList.add("tf-v1-widget-fullscreen"), o.unmountElement(n);
                }, d.append(n);
              } else t.container.innerHTML = "", m(), h.append(b);
            }, h.append(b);
          }return { refresh: s, unmount: function unmount() {
              return o.unmountElement(d);
            } };
        };
      }, 1419: function _(e, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.buildWidget = void 0;var o = n(6797);t.buildWidget = function (e, t, n) {
          var r = document.createElement("div");return r.className = "tf-v1-widget", r.dataset.testid = "tf-v1-widget", r.append(e), o.setElementSize(r, { width: t, height: n });
        };
      }, 2313: function _(e, t, n) {
        var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
          void 0 === o && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function get() {
              return t[n];
            } });
        } : function (e, t, n, o) {
          void 0 === o && (o = n), e[o] = t[n];
        }),
            r = this && this.__exportStar || function (e, t) {
          for (var n in e) {
            "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
          }
        };Object.defineProperty(t, "__esModule", { value: !0 }), r(n(1419), t);
      }, 9321: function _(e, t, n) {
        var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
          void 0 === o && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function get() {
              return t[n];
            } });
        } : function (e, t, n, o) {
          void 0 === o && (o = n), e[o] = t[n];
        }),
            r = this && this.__exportStar || function (e, t) {
          for (var n in e) {
            "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
          }
        };Object.defineProperty(t, "__esModule", { value: !0 }), r(n(718), t), r(n(4058), t);
      }, 4058: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 });
      }, 1920: function _(e, t, n) {
        var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
          void 0 === o && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function get() {
              return t[n];
            } });
        } : function (e, t, n, o) {
          void 0 === o && (o = n), e[o] = t[n];
        }),
            r = this && this.__exportStar || function (e, t) {
          for (var n in e) {
            "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
          }
        };Object.defineProperty(t, "__esModule", { value: !0 }), r(n(1797), t), r(n(5970), t), r(n(4071), t), r(n(9321), t), r(n(1434), t);
      }, 5455: function _(e, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.buildOptionsFromAttributes = void 0;var o = n(6797);t.buildOptionsFromAttributes = function (e) {
          return o.loadOptionsFromAttributes(e, { source: "string", medium: "string", mediumVersion: "string", open: "string", openValue: "integer", hideFooter: "boolean", hideHeaders: "boolean", opacity: "integer", disableTracking: "boolean", onReady: "function", onSubmit: "function", onQuestionChanged: "function", onHeightChanged: "function", autoResize: "stringOrBoolean", onClose: "function", onEndingButtonClick: "function", transitiveSearchParams: "array", hidden: "record", chat: "boolean", buttonColor: "string", customIcon: "string", width: "integer", height: "integer", size: "integer", buttonText: "string", position: "string", enableSandbox: "boolean", tooltip: "string", notificationDays: "integer", autoClose: "integerOrBoolean", shareGaInstance: "stringOrBoolean", forceTouch: "boolean", enableFullscreen: "boolean", inlineOnMobile: "boolean", disableAutoFocus: "boolean", tracking: "record", redirectTarget: "string", iframeProps: "record", lazy: "boolean", keepSession: "boolean" });
        };
      }, 6654: function _(e, t, n) {
        var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
          void 0 === o && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function get() {
              return t[n];
            } });
        } : function (e, t, n, o) {
          void 0 === o && (o = n), e[o] = t[n];
        }),
            r = this && this.__exportStar || function (e, t) {
          for (var n in e) {
            "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
          }
        };Object.defineProperty(t, "__esModule", { value: !0 }), r(n(8806), t), r(n(8933), t), r(n(7833), t), r(n(5361), t), r(n(2103), t);
      }, 8806: function _(e, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.initializePopovers = void 0;var o = n(1797),
            r = n(8027),
            i = n(7308);t.initializePopovers = function (e) {
          void 0 === e && (e = !1), i.initialize(r.POPOVER_ATTRIBUTE, "popover.css", e, function (e, t, n) {
            var r = o.createPopover(e, t).toggle;n.onclick = r;
          });
        };
      }, 8933: function _(e, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.initializePopups = void 0;var o = n(5970),
            r = n(8027),
            i = n(7308);t.initializePopups = function (e) {
          void 0 === e && (e = !1), i.initialize(r.POPUP_ATTRIBUTE, "popup.css", e, function (e, t, n) {
            var r = o.createPopup(e, t).toggle;n.onclick = r;
          });
        };
      }, 2103: function _(e, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.initializeSidetabs = void 0;var o = n(1434),
            r = n(8027),
            i = n(7308);t.initializeSidetabs = function (e) {
          void 0 === e && (e = !1), i.initialize(r.SIDETAB_ATTRIBUTE, "sidetab.css", e, function (e, t) {
            o.createSidetab(e, t);
          });
        };
      }, 7833: function _(e, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.initializeSliders = void 0;var o = n(4071),
            r = n(8027),
            i = n(7308);t.initializeSliders = function (e) {
          void 0 === e && (e = !1), i.initialize(r.SLIDER_ATTRIBUTE, "slider.css", e, function (e, t, n) {
            var r = o.createSlider(e, t).toggle;n.onclick = r;
          });
        };
      }, 5361: function _(e, t, n) {
        var o = this && this.__assign || function () {
          return (o = Object.assign || function (e) {
            for (var t, n = 1, o = arguments.length; n < o; n++) {
              for (var r in t = arguments[n]) {
                Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
              }
            }return e;
          }).apply(this, arguments);
        };Object.defineProperty(t, "__esModule", { value: !0 }), t.initializeWidgets = void 0;var r = n(9321),
            i = n(8027),
            a = n(7308);t.initializeWidgets = function (e) {
          void 0 === e && (e = !1), a.initialize(i.WIDGET_ATTRIBUTE, "widget.css", e, function (e, t, n) {
            r.createWidget(e, o(o({}, t), { container: n }));
          });
        };
      }, 7308: function _(e, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.initialize = void 0;var o = n(6797),
            r = n(5455);t.initialize = function (e, t, n, i) {
          void 0 === n && (n = !1);var a = document.querySelectorAll("[" + e + "]");a.length > 0 && o.includeCss(t), Array.from(a).forEach(function (t, o) {
            if (n || "true" !== t.dataset.tfLoaded) {
              var a = t.getAttribute(e);if (!a) throw new Error("Invalid " + e + "=" + a + " for embed #" + o);i(a, r.buildOptionsFromAttributes(t), t), t.dataset.tfLoaded = "true";
            }
          });
        };
      }, 3626: function _(e, t, n) {
        var o = this && this.__assign || function () {
          return (o = Object.assign || function (e) {
            for (var t, n = 1, o = arguments.length; n < o; n++) {
              for (var r in t = arguments[n]) {
                Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
              }
            }return e;
          }).apply(this, arguments);
        };Object.defineProperty(t, "__esModule", { value: !0 }), t.buildIframeSrc = void 0;var r = n(8027),
            i = n(4527),
            a = n(2346),
            u = n(2698),
            c = { widget: "embed-widget", popup: "popup-blank", slider: "popup-drawer", popover: "popup-popover", "side-tab": "popup-side-panel" };t.buildIframeSrc = function (e) {
          var t = e.formId,
              n = e.type,
              s = e.embedId,
              d = e.options,
              l = function (e, t, n) {
            var r = n.transitiveSearchParams,
                i = n.source,
                a = n.medium,
                s = n.mediumVersion,
                d = n.hideFooter,
                l = n.hideHeaders,
                f = n.opacity,
                p = n.disableTracking,
                v = n.enableSandbox,
                m = n.disableAutoFocus,
                h = n.shareGaInstance,
                b = n.forceTouch,
                y = n.enableFullscreen,
                g = n.tracking,
                O = n.redirectTarget,
                _ = u.getTransitiveSearchParams(r);return o(o(o({}, { "typeform-embed-id": t, "typeform-embed": c[e], "typeform-source": i, "typeform-medium": a, "typeform-medium-version": s, "embed-hide-footer": d ? "true" : void 0, "embed-hide-headers": l ? "true" : void 0, "embed-opacity": f, "disable-tracking": p || v ? "true" : void 0, "disable-auto-focus": m ? "true" : void 0, "__dangerous-disable-submissions": v ? "true" : void 0, "share-ga-instance": h ? "true" : void 0, "force-touch": b ? "true" : void 0, "add-placeholder-ws": "widget" === e && y ? "true" : void 0, "typeform-embed-redirect-target": O }), _), g);
          }(n, s, function (e) {
            return o(o({}, { source: null === (t = null === window || void 0 === window ? void 0 : window.location) || void 0 === t ? void 0 : t.hostname.replace(/^www\./, ""), medium: "embed-sdk", mediumVersion: "next" }), i.removeUndefinedKeys(e));var t;
          }(d)),
              f = function (e, t) {
            void 0 === t && (t = !1);var n = t ? "c" : "to";return new URL(e.startsWith("http://") || e.startsWith("https://") ? e : r.FORM_BASE_URL + "/" + n + "/" + e);
          }(t, d.chat);if (Object.entries(l).filter(function (e) {
            var t = e[1];return a.isDefined(t);
          }).forEach(function (e) {
            var t = e[0],
                n = e[1];f.searchParams.set(t, n);
          }), d.hidden) {
            var p = new URL(r.FORM_BASE_URL);Object.entries(d.hidden).filter(function (e) {
              var t = e[1];return a.isDefined(t);
            }).forEach(function (e) {
              var t = e[0],
                  n = e[1];p.searchParams.set(t, n);
            });var v = p.searchParams.toString();v && (f.hash = v);
          }return f.href;
        };
      }, 8972: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.handleCustomOpen = void 0;var n = { remove: function remove() {} };t.handleCustomOpen = function (e, t, o) {
          switch (t) {case "load":
              return e(), n;case "exit":
              return o ? function (e, t) {
                var n = 0,
                    o = function o(r) {
                  r.clientY < e && r.clientY < n ? (document.removeEventListener("mousemove", o, !0), t()) : n = r.clientY;
                };return document.addEventListener("mousemove", o, !0), { remove: function remove() {
                    return document.removeEventListener("mousemove", o, !0);
                  } };
              }(o, e) : n;case "time":
              return setTimeout(function () {
                e();
              }, o), n;case "scroll":
              return o ? function (e, t) {
                function n() {
                  var o = window.pageYOffset || document.documentElement.scrollTop,
                      r = document.documentElement.clientTop || 0,
                      i = document.documentElement.scrollHeight,
                      a = o - r,
                      u = a / i * 100,
                      c = a + window.innerHeight >= i;(u >= e || c) && (t(), document.removeEventListener("scroll", n));
                }return document.addEventListener("scroll", n), { remove: function remove() {
                    return document.removeEventListener("scroll", n);
                  } };
              }(o, e) : n;default:
              return n;}
        };
      }, 1553: function _(e, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.createIframe = void 0;var o = n(3626),
            r = n(6797),
            i = n(8866),
            a = n(8554),
            u = n(2256),
            c = n(7144),
            s = n(5511);t.createIframe = function (e, t, n) {
          var d = i.generateEmbedId(),
              l = n.iframeProps,
              f = void 0 === l ? {} : l,
              p = n.onReady,
              v = n.onQuestionChanged,
              m = n.onHeightChanged,
              h = n.onSubmit,
              b = n.onEndingButtonClick,
              y = n.shareGaInstance,
              g = o.buildIframeSrc({ formId: e, embedId: d, type: t, options: n }),
              O = document.createElement("iframe");return O.src = g, O.dataset.testid = "iframe", O.style.border = "0px", O.allow = "microphone; camera", Object.keys(f).forEach(function (e) {
            O.setAttribute(e, f[e]);
          }), O.addEventListener("load", u.triggerIframeRedraw, { once: !0 }), window.addEventListener("message", a.getFormReadyHandler(d, p)), window.addEventListener("message", a.getFormQuestionChangedHandler(d, v)), window.addEventListener("message", a.getFormHeightChangedHandler(d, m)), window.addEventListener("message", a.getFormSubmitHandler(d, h)), window.addEventListener("message", a.getFormThemeHandler(d)), window.addEventListener("message", a.getThankYouScreenButtonClickHandler(d, b)), "widget" !== t && window.addEventListener("message", c.dispatchCustomKeyEventFromIframe), y && window.addEventListener("message", a.getFormReadyHandler(d, function () {
            r.setupGaInstance(O, d, y);
          })), { iframe: O, embedId: d, refresh: function refresh() {
              return s.refreshIframe(O);
            } };
        };
      }, 8866: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.generateEmbedId = void 0, t.generateEmbedId = function () {
          var e = Math.random();return String(e).split(".")[1];
        };
      }, 8554: function _(e, t) {
        var n = this && this.__rest || function (e, t) {
          var n = {};for (var o in e) {
            Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
          }if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var r = 0;for (o = Object.getOwnPropertySymbols(e); r < o.length; r++) {
              t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
            }
          }return n;
        };function o(e, t, o) {
          return function (r) {
            var i = r.data,
                a = i.type,
                u = i.embedId,
                c = n(i, ["type", "embedId"]);a === e && u === t && (null == o || o(c));
          };
        }Object.defineProperty(t, "__esModule", { value: !0 }), t.getThankYouScreenButtonClickHandler = t.getFormThemeHandler = t.getWelcomeScreenHiddenHandler = t.getFormSubmitHandler = t.getFormHeightChangedHandler = t.getFormQuestionChangedHandler = t.getFormReadyHandler = void 0, t.getFormReadyHandler = function (e, t) {
          return o("form-ready", e, t);
        }, t.getFormQuestionChangedHandler = function (e, t) {
          return o("form-screen-changed", e, t);
        }, t.getFormHeightChangedHandler = function (e, t) {
          return o("form-height-changed", e, t);
        }, t.getFormSubmitHandler = function (e, t) {
          return o("form-submit", e, t);
        }, t.getWelcomeScreenHiddenHandler = function (e, t) {
          return o("welcome-screen-hidden", e, function () {
            t.classList.add("tf-v1-widget-fullscreen");
          });
        }, t.getFormThemeHandler = function (e) {
          return o("form-theme", e, function (e) {
            var t;if (null == e ? void 0 : e.theme) {
              var n = document.querySelector(".tf-v1-close-icon");n && (n.style.color = null === (t = e.theme) || void 0 === t ? void 0 : t.color);
            }
          });
        }, t.getThankYouScreenButtonClickHandler = function (e, t) {
          return o("thank-you-screen-button-click", e, t);
        };
      }, 339: function _(e, t, n) {
        var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
          void 0 === o && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function get() {
              return t[n];
            } });
        } : function (e, t, n, o) {
          void 0 === o && (o = n), e[o] = t[n];
        }),
            r = this && this.__exportStar || function (e, t) {
          for (var n in e) {
            "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
          }
        };Object.defineProperty(t, "__esModule", { value: !0 }), r(n(1553), t), r(n(7144), t);
      }, 5511: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.refreshIframe = void 0, t.refreshIframe = function (e) {
          if (e) {
            var t = e.src;if (t.includes("&refresh")) {
              var n = t.split("&refresh#");e.src = n.join("#");
            } else (n = t.split("#"))[0] = n[0] + "&refresh", e.src = n.join("#");
          }
        };
      }, 7144: function _(e, t) {
        var n = this && this.__awaiter || function (e, t, n, o) {
          return new (n || (n = Promise))(function (r, i) {
            function a(e) {
              try {
                c(o.next(e));
              } catch (e) {
                i(e);
              }
            }function u(e) {
              try {
                c(o.throw(e));
              } catch (e) {
                i(e);
              }
            }function c(e) {
              var t;e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
                e(t);
              })).then(a, u);
            }c((o = o.apply(e, t || [])).next());
          });
        },
            o = this && this.__generator || function (e, t) {
          var n,
              o,
              r,
              i,
              a = { label: 0, sent: function sent() {
              if (1 & r[0]) throw r[1];return r[1];
            }, trys: [], ops: [] };return i = { next: u(0), throw: u(1), return: u(2) }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
            return this;
          }), i;function u(i) {
            return function (u) {
              return function (i) {
                if (n) throw new TypeError("Generator is already executing.");for (; a;) {
                  try {
                    if (n = 1, o && (r = 2 & i[0] ? o.return : i[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, i[1])).done) return r;switch (o = 0, r && (i = [2 & i[0], r.value]), i[0]) {case 0:case 1:
                        r = i;break;case 4:
                        return a.label++, { value: i[1], done: !1 };case 5:
                        a.label++, o = i[1], i = [0];continue;case 7:
                        i = a.ops.pop(), a.trys.pop();continue;default:
                        if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                          a = 0;continue;
                        }if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                          a.label = i[1];break;
                        }if (6 === i[0] && a.label < r[1]) {
                          a.label = r[1], r = i;break;
                        }if (r && a.label < r[2]) {
                          a.label = r[2], a.ops.push(i);break;
                        }r[2] && a.ops.pop(), a.trys.pop();continue;}i = t.call(e, a);
                  } catch (e) {
                    i = [6, e], o = 0;
                  } finally {
                    n = r = 0;
                  }
                }if (5 & i[0]) throw i[1];return { value: i[0] ? i[1] : void 0, done: !0 };
              }([i, u]);
            };
          }
        };Object.defineProperty(t, "__esModule", { value: !0 }), t.dispatchCustomKeyEventFromIframe = t.removeCustomKeyboardListener = t.addCustomKeyboardListener = void 0;var r = "Escape",
            i = function i(e, _i) {
          return n(void 0, void 0, void 0, function () {
            return o(this, function (n) {
              return e.code === r && "function" == typeof _i && (_i(), t.removeCustomKeyboardListener()), [2];
            });
          });
        };t.addCustomKeyboardListener = function (e) {
          return window.document.addEventListener("keydown", function (t) {
            return i(t, e);
          });
        }, t.removeCustomKeyboardListener = function () {
          return window.document.removeEventListener("keydown", i);
        }, t.dispatchCustomKeyEventFromIframe = function (e) {
          "form-close" === e.data.type && window.document.dispatchEvent(new KeyboardEvent("keydown", { code: r }));
        };
      }, 2256: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.triggerIframeRedraw = void 0, t.triggerIframeRedraw = function () {
          this.style.transform = "translateZ(0)";
        };
      }, 8939: function _(e, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.getTextColor = void 0;var o = n(2938);t.getTextColor = function (e) {
          if (!e) return "#FFFFFF";var t = e.startsWith("#") ? o.hexRgb(e) : function (e) {
            var t = { red: 0, green: 0, blue: 0 },
                n = e.match(/\d+/g);return n && (t.red = parseInt(n[0], 10), t.green = parseInt(n[0], 10), t.blue = parseInt(n[0], 10)), t;
          }(e),
              n = t.red,
              r = t.green,
              i = t.blue;return Math.round((299 * n + 587 * r + 114 * i) / 1e3) > 125 ? "#000000" : "#FFFFFF";
        };
      }, 2698: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.getTransitiveSearchParams = void 0, t.getTransitiveSearchParams = function (e) {
          var t = new URL(window.location.href),
              n = {};return e && e.length > 0 && e.forEach(function (e) {
            t.searchParams.has(e) && (n[e] = t.searchParams.get(e));
          }), n;
        };
      }, 8252: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.hasDom = void 0, t.hasDom = function () {
          return "undefined" != typeof document && "undefined" != typeof window;
        };
      }, 2938: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.hexRgb = void 0;var n = new RegExp("[^#a-f\\d]", "gi"),
            o = new RegExp("^#?[a-f\\d]{3}[a-f\\d]?$|^#?[a-f\\d]{6}([a-f\\d]{2})?$", "i");t.hexRgb = function (e) {
          if ("string" != typeof e || n.test(e) || !o.test(e)) throw new TypeError("Expected a valid hex string");8 === (e = e.replace(/^#/, "")).length && (e = e.slice(0, 6)), 4 === e.length && (e = e.slice(0, 3)), 3 === e.length && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]);var t = Number.parseInt(e, 16);return { red: t >> 16, green: t >> 8 & 255, blue: 255 & t };
        };
      }, 9071: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.includeCss = void 0, t.includeCss = function (e) {
          var t = function (e) {
            return "https://embed.typeform.com/next/css/" + e;
          }(e);if (!document.querySelector('link[href="' + t + '"]')) {
            var n = document.createElement("link");n.rel = "stylesheet", n.href = t, document.head.append(n);
          }
        };
      }, 6797: function _(e, t, n) {
        var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
          void 0 === o && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function get() {
              return t[n];
            } });
        } : function (e, t, n, o) {
          void 0 === o && (o = n), e[o] = t[n];
        }),
            r = this && this.__exportStar || function (e, t) {
          for (var n in e) {
            "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
          }
        };Object.defineProperty(t, "__esModule", { value: !0 }), r(n(3626), t), r(n(339), t), r(n(8252), t), r(n(9071), t), r(n(2346), t), r(n(7377), t), r(n(6563), t), r(n(4527), t), r(n(9533), t), r(n(1451), t), r(n(8972), t), r(n(4748), t), r(n(4392), t), r(n(8939), t), r(n(9917), t), r(n(1987), t);
      }, 2346: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.isDefined = void 0, t.isDefined = function (e) {
          return null != e;
        };
      }, 1987: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.isVisible = t.isInPage = t.isOpen = void 0, t.isOpen = function (e) {
          return t.isInPage(e) && t.isVisible(e);
        }, t.isInPage = function (e) {
          return !!e.parentNode;
        }, t.isVisible = function (e) {
          return "none" !== e.style.display;
        };
      }, 9917: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.lazyInitialize = void 0, t.lazyInitialize = function (e, t) {
          var n = new IntersectionObserver(function (e) {
            e.forEach(function (e) {
              e.isIntersecting && (t(), n.unobserve(e.target));
            });
          });n.observe(e);
        };
      }, 7377: function _(e, t) {
        var n = this && this.__assign || function () {
          return (n = Object.assign || function (e) {
            for (var t, n = 1, o = arguments.length; n < o; n++) {
              for (var r in t = arguments[n]) {
                Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
              }
            }return e;
          }).apply(this, arguments);
        };Object.defineProperty(t, "__esModule", { value: !0 }), t.loadOptionsFromAttributes = t.transformAttributeValue = t.camelCaseToKebabCase = void 0, t.camelCaseToKebabCase = function (e) {
          return e.split("").map(function (e, t) {
            return e.toUpperCase() === e ? (0 !== t ? "-" : "") + e.toLowerCase() : e;
          }).join("");
        };var o = function o(e) {
          return e || void 0;
        },
            r = function r(e) {
          return "" === e || "yes" === e || "true" === e;
        },
            i = function i(e) {
          var t = e ? parseInt(e, 10) : NaN;return isNaN(t) ? void 0 : t;
        },
            a = "%ESCAPED_COMMA%";t.transformAttributeValue = function (e, t) {
          var u, c;switch (t) {case "string":
              return o(e);case "boolean":
              return r(e);case "integer":
              return i(e);case "function":
              return function (e) {
                var t = e && e in window ? window[e] : void 0;return "function" == typeof t ? t : void 0;
              }(e);case "array":
              return function (e) {
                if (e) return e.replace(/\s/g, "").replace(/\\,/g, a).split(",").filter(function (e) {
                  return !!e;
                }).map(function (e) {
                  return e.replace(a, ",");
                });
              }(e);case "record":
              return function (e) {
                if (e) return e.replace(/\\,/g, a).split(",").filter(function (e) {
                  return !!e;
                }).map(function (e) {
                  return e.replace(a, ",");
                }).reduce(function (e, t) {
                  var o,
                      r = t.match(/^([^=]+)=(.*)$/);if (r) {
                    var i = r[1],
                        a = r[2];return n(n({}, e), ((o = {})[i.trim()] = a, o));
                  }return e;
                }, {});
              }(e);case "integerOrBoolean":
              return null !== (u = i(e)) && void 0 !== u ? u : r(e);case "stringOrBoolean":
              return null !== (c = o(e)) && void 0 !== c ? c : r(e);default:
              throw new Error("Invalid attribute transformation " + t);}
        }, t.loadOptionsFromAttributes = function (e, o) {
          return Object.keys(o).reduce(function (r, i) {
            var a;return n(n({}, r), ((a = {})[i] = t.transformAttributeValue(e.getAttribute("data-tf-" + t.camelCaseToKebabCase(i)), o[i]), a));
          }, {});
        };
      }, 6563: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.isFullscreen = t.isMobile = t.isBigScreen = void 0, t.isBigScreen = function () {
          return window.screen.width >= 1024 && window.screen.height >= 768;
        }, t.isMobile = function () {
          return (/mobile|tablet|android/i.test(navigator.userAgent.toLowerCase())
          );
        }, t.isFullscreen = function () {
          return t.isMobile() && !t.isBigScreen();
        };
      }, 4527: function _(e, t, n) {
        var o = this && this.__assign || function () {
          return (o = Object.assign || function (e) {
            for (var t, n = 1, o = arguments.length; n < o; n++) {
              for (var r in t = arguments[n]) {
                Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
              }
            }return e;
          }).apply(this, arguments);
        };Object.defineProperty(t, "__esModule", { value: !0 }), t.removeUndefinedKeys = void 0;var r = n(2346);t.removeUndefinedKeys = function (e) {
          return Object.entries(e).filter(function (e) {
            var t = e[1];return r.isDefined(t);
          }).reduce(function (e, t) {
            var n,
                r = t[0],
                i = t[1];return o(o({}, e), ((n = {})[r] = i, n));
          }, {});
        };
      }, 4748: function _(e, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.setAutoClose = void 0;var o = n(8554);t.setAutoClose = function (e, t, n) {
          if (t && n) {
            var r = "number" == typeof t ? t : 0;window.addEventListener("message", o.getFormSubmitHandler(e, function () {
              return setTimeout(n, r);
            }));
          }
        };
      }, 9533: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.setElementSize = void 0, t.setElementSize = function (e, t) {
          var n = t.width,
              o = t.height;return n && (e.style.width = n + "px"), o && (e.style.height = o + "px"), e;
        };
      }, 4392: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.setupGaInstance = t.sendGaIdMessage = void 0, t.sendGaIdMessage = function (e, t, n) {
          var o = { embedId: e, gaClientId: t };setTimeout(function () {
            n && n.contentWindow && n.contentWindow.postMessage({ type: "ga-client-id", data: o }, "*");
          }, 0);
        };var n = function n(e) {
          console.error(e);
        };t.setupGaInstance = function (e, o, r) {
          try {
            var i = window[window.GoogleAnalyticsObject],
                a = "string" == typeof r ? r : void 0,
                u = function (e, t) {
              return t ? e.find(function (e) {
                return e.get("trackingId") === t;
              }) : e[0];
            }(i.getAll(), a);u ? t.sendGaIdMessage(o, u.get("clientId"), e) : n("Whoops! You enabled the shareGaInstance feature in your typeform embed but the tracker with ID " + a + " was not found. Make sure to include Google Analytics Javascript code before the Typeform Embed Javascript code in your page and use correct tracker ID. ");
          } catch (e) {
            n("Whoops! You enabled the shareGaInstance feature in your typeform embed but the Google Analytics object has not been found. Make sure to include Google Analytics Javascript code before the Typeform Embed Javascript code in your page. "), n(e);
          }
        };
      }, 1451: function _(e, t) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.unmountElement = void 0, t.unmountElement = function (e) {
          var t;null === (t = e.parentNode) || void 0 === t || t.removeChild(e);
        };
      } },
        t = {};return function n(o) {
      if (t[o]) return t[o].exports;var r = t[o] = { exports: {} };return e[o].call(r.exports, r, r.exports, n), r.exports;
    }(6664);
  }();

  var embeddedTypeFormComponentModule = angular.module('Q.components.embedded-type-form', [landingTrackerServiceModule, tryFunctionHelperModule]).component('embeddedTypeForm', {
    bindings: {
      formId: '@',
      hiddenFields: '<',
      trackingParams: '<',
      hideFooter: '<',
      hideHeaders: '<',
      minHeight: '<',
      onReady: '&',
      onSubmit: '&',
      onQuestionChanged: '&',
      typeFormEvent: '@'
    },
    controller: 'EmbeddedTypeFormCtrl',
    template: embeddedTypeFormTemplate
  }).controller('EmbeddedTypeFormCtrl', ['$element', '$scope', '$window', 'trackerService', 'tryFunction', function EmbeddedTypeFormCtrl($element, $scope, $window, trackerService, tryFunction) {
    var ctrl = this;

    var track = tryFunction(function (action) {
      if (ctrl.typeFormEvent) {
        trackerService.trackEvent(ctrl.typeFormEvent + ' ' + action);
      }
    });

    ctrl.$onInit = function () {
      if (!$window.tf || !$window.tf.createWidget) {
        track('TypeForm Library not found');
        ctrl.error = 'form library not found';
        return;
      }
      track('Started');
      try {
        var $container = $element.querySelector('.embedded-type-form-container');
        if (ctrl.minHeight) {
          $container.css({ 'min-height': ctrl.minHeight + 'px' });
        }
        $window.tf.createWidget(ctrl.formId, {
          container: $container[0],
          hidden: ctrl.hiddenFields || {},
          tracking: ctrl.trackingParams || {},
          hideFooter: !!ctrl.hideFooter,
          hideHeaders: !!ctrl.hideHeaders,
          opacity: 0,
          onReady: function onReady() {
            $scope.$applyAsync(function () {
              track('Ready');
              ctrl.onReady();
            });
          },
          onSubmit: function onSubmit(event) {
            $scope.$applyAsync(function () {
              track('Submitted');
              ctrl.onSubmit({ event: event });
            });
          },
          onQuestionChanged: function onQuestionChanged(event) {
            $scope.$applyAsync(function () {
              ctrl.onQuestionChanged({ event: event });
            });
          },

          autoResize: (ctrl.minHeight || 200) + ',1200',
          inlineOnMobile: true
        });
      } catch (err) {
        track('Error with TypeForm: ' + err);
        ctrl.error = err;
      }
    };
  }]);

  angular.module('Q.landing', [ngAnimateModule, exceptionHandlerServiceModule, configModule, landingTrackerServiceModule, landingTrackClickComponentModule,

  // app components
  frameworkDemosComponentModule, onScrollAddClassComponentModule, previewVideoComponentModule, salesLeadFormComponentModule, sectionAutoLinkComponentModule, subscriptionsComponentModule, articleCarouselComponentModule, scrollToComponentModule, btnCtaDirectiveModule, stickyHeaderComponentModule, cookieWarningServiceModule, featureCarouselDirectiveModule, embeddedQualifiedTestComponentModule, embeddedCalendlyComponentModule, embeddedTypeFormComponentModule]).controller('MainCtrl', ['$rootScope', function ($rootScope) {
    // make sales lead data available for other forms
    var sld = $rootScope.salesLeadData = salesLeadData();
    if (sld.firstName || sld.lastName) {
      sld.name = sld.firstName + ' ' + sld.lastName;
    }
  }]).config(['$locationProvider', function ($locationProvider) {
    // Required to prevent $location from breaking anchor links (grrr)
    // One of the keys here is rewriteLinks: false - without it, $location prevents any standard
    // link from working as expected
    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false,
      rewriteLinks: false
    });
  }]);

}());
